webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ba4f54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ba4f54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {},

  methods: {}
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(191);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],

    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },


  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(195);
/* unused harmony reexport Aside */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Callout_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch__ = __webpack_require__(195);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_0__Callout__["a" /* default */],
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch__["a" /* default */]
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(615);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(616);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__(623);



var config = __webpack_require__(201);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
  },
  data: function data() {
    return {
      isDownloading: false,
      enableDownloadButton: config.downloadButton.enable,
      i2oc: this.$http.defaults.baseURL
    };
  },

  methods: {
    downloadData: function downloadData() {
      var _this = this;
      this.isDownloading = true;
      this.$http.get('/api/users/download_data').then(function (response) {
        if (response.status == 200) {
          _this.$http.get('/api/containers/default_database_schema/download/' + response.data, { responseType: 'blob' }).then(function (responseDownload) {
            var link = document.createElement('a');
            link.href = URL.createObjectURL(responseDownload.data);
            link.download = response.data;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
          _this.isDownloading = false;
        } else {
          alert('Unable to download user data. Please try again or contact administrator is problem continious');
          _this.isDownloading = false;
        }
      }).catch(function (err) {
        alert('Something went wrong');
      });
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__spinner_vue__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "header-dropdown",
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_0__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      resetModal: false,
      password: {
        new: "",
        confirm: ""
      },
      hasErrors: {
        new: false,
        confirm: false
      },
      errorMessage: {
        new: "",
        confirm: "",
        message: ""
      },
      itemsCount: 42
    };
  },
  methods: {
    logout: function logout() {
      var _this = this;
      _this.loading = true;
      this.$http.post("/api/users/logout").then(function (response) {
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
      localStorage.clear();
      _this.$store.commit("SET_AUTH_USER", null);
      _this.$router.push("/");
    },
    reset_password: function reset_password() {
      this.errorMessage.message = "";
      this.password.new = "";
      this.password.confirm = "";
      this.reset_all();
      this.resetModal = true;
    },
    reset_all: function reset_all() {
      this.hasErrors.new = false;
      this.hasErrors.confirm = false;
      this.errorMessage.new = "";
      this.errorMessage.confirm = "";
    },
    Submit: function Submit() {
      this.errorMessage.message = "";
      this.reset_all();
      var submit = 0;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      if (this.password.new.length == 0) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "Password Required";
      } else if (pass.test(this.password.new) == false) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
      }
      if (this.password.confirm.length == 0) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Confirm Password Required";
      } else if (this.password.confirm != this.password.new) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Password and Confirm Password doesnot match";
      }
      if (submit == 0) {
        this.handleSubmit();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      var pass = {};
      _this.loading = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      pass.newPassword = this.password.new;
      this.$http.post("/api/users/reset-password", pass).then(function (response) {
        _this.reset_password();
        _this.reset_all();
        _this.loading = false;
        _this.errorMessage.message = " Password Changed Successfully !!";
      }).catch(function (error) {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {"baseUrl":"https://i2oc.com","downloadButton":{"enable":false,"postgresUrl":null,"i2ocApplicationUrl":null},"companyTaxLogic":{"MUMNSB81":"IN","MUMSIA83":"US"}}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarFooter__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarForm__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarHeader__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarMinimizer__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDivider__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(654);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sidebar",
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_1__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_2__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_3__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_4__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDivider__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
    SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
  },
  data: function data() {
    return {
      roles_data: [],
      dashboard: false,
      company_reg: false,
      shop_details: false,
      users: false,
      roles: false,
      sales: false,
      sale_return: false,
      customer: false,
      sale_invoice: false,
      sale_receipt: false,
      sale_receipt_history: false,
      salereturn_receipt_history: false,
      purchase: false,
      purchase_return: false,
      supplier: false,
      purchase_payment: false,
      purchase_payment_history: false,
      purchasereturn_pending_list: false,
      shop_inventory: false,
      stock_transfer: false,
      product: false,
      category_sub_category: false,
      brand: false,
      tax: false,
      hsn: false,
      cust_pp: true,
      supp_pp: true,
      variant: false,
      unit: false,
      is_admin: false,
      company_tab: false,
      security_tab: false,
      sales_tab: false,
      purchase_tab: false,
      setup_tab: false,
      tax_tab: false,
      reports_tab: false,
      super_user: 3,
      shop_user: 3
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    hsnLabel: function hsnLabel() {
      return this.companyTaxType === 'US' ? 'US Code' : 'HSN';
    },
    hsnRateLabel: function hsnRateLabel() {
      return this.companyTaxType === 'US' ? 'US Code Rate' : 'HSN Rate';
    }
  },
  created: function created() {
    for (var j = 0; j < 29; j++) {
      this.roles_data.push({ page_name: j + 1, view: false, rights: false });
    }
    this.getRoles();
  },

  methods: {
    getRoles: function getRoles() {
      this.loading = true;
      var _this = this;
      var roles = null;
      this.loading = true;
      this.$http.get("/api/userroles/userroles").then(function (response) {
        _this.$http.get("/api/userroles/usertype").then(function (response1) {
          _this.$http.get("/api/userroles/shopusertype").then(function (response2) {
            _this.$store.commit("set_super_user", response1.data);
            _this.super_user = _this.$store.getters.get_super_user;
            _this.$store.commit("set_shop_user", response2.data);
            _this.shop_user = _this.$store.getters.get_shop_user;
            if (!response.data.data) {
              roles = null;
            } else {
              roles = response.data.data;
              for (var i = 0; i < roles.length; i++) {
                for (var k = 0; k < roles[i].length; k++) {
                  if (roles[i][k].page_name == _this.roles_data[k].page_name) {
                    if (_this.roles_data[k].view == true && roles[i][k].view == true) {
                      _this.roles_data[k].view = true;
                    } else if (_this.roles_data[k].view == false && roles[i][k].view == false) {
                      _this.roles_data[k].view = false;
                    } else {
                      _this.roles_data[k].view = true;
                    }

                    if (_this.roles_data[k].rights == true && roles[i][k].rights == true) {
                      _this.roles_data[k].rights = true;
                    } else if (_this.roles_data[k].rights == false && roles[i][k].rights == false) {
                      _this.roles_data[k].rights = false;
                    } else {
                      _this.roles_data[k].rights = true;
                    }
                  }
                }
              }
              if (_this.roles_data[0].page_name === 1) {
                _this.$store.commit("set_dashbd_view", _this.roles_data[0].view);
                _this.$store.commit("set_dashbd_rights", _this.roles_data[0].rights);
              }

              if (_this.roles_data[1].page_name === 2) {
                _this.$store.commit("set_reg_view", _this.roles_data[1].view);
                _this.$store.commit("set_reg_rights", _this.roles_data[1].rights);
              }

              if (_this.roles_data[2].page_name === 3) {
                _this.$store.commit("set_shop_view", _this.roles_data[2].view);
                _this.$store.commit("set_shop_rights", _this.roles_data[2].rights);
              }

              if (_this.roles_data[3].page_name === 4) {
                _this.$store.commit("set_u_view", _this.roles_data[3].view);
                _this.$store.commit("set_u_rights", _this.roles_data[3].rights);
              }
              if (_this.roles_data[4].page_name === 5) {
                _this.$store.commit("set_r_view", _this.roles_data[4].view);
                _this.$store.commit("set_r_rights", _this.roles_data[4].rights);
              }
              if (_this.roles_data[7].page_name === 8) {
                _this.$store.commit("set_cust_view", _this.roles_data[7].view);
                _this.$store.commit("set_cust_rights", _this.roles_data[7].rights);
              }
              if (_this.roles_data[13].page_name === 14) {
                _this.$store.commit("set_sup_view", _this.roles_data[13].view);
                _this.$store.commit("set_sup_rights", _this.roles_data[13].rights);
              }
              if (_this.roles_data[16].page_name === 17) {
                _this.$store.commit("set_invt_view", _this.roles_data[16].view);
                _this.$store.commit("set_invt_rights", _this.roles_data[16].rights);
              }
              if (_this.roles_data[17].page_name === 18) {
                _this.$store.commit("set_stcktran_view", _this.roles_data[17].view);
                _this.$store.commit("set_stcktran_rights", _this.roles_data[17].rights);
              }
              if (_this.roles_data[18].page_name === 19) {
                _this.$store.commit("set_prod_view", _this.roles_data[18].view);
                _this.$store.commit("set_prod_rights", _this.roles_data[18].rights);
              }
              if (_this.roles_data[19].page_name === 20) {
                _this.$store.commit("set_cat_view", _this.roles_data[19].view);
                _this.$store.commit("set_cat_rights", _this.roles_data[19].rights);
              }
              if (_this.roles_data[20].page_name === 21) {
                _this.$store.commit("set_brand_view", _this.roles_data[20].view);
                _this.$store.commit("set_brand_rights", _this.roles_data[20].rights);
              }
              if (_this.roles_data[21].page_name === 22) {
                _this.$store.commit("set_tax_view", _this.roles_data[21].view);
                _this.$store.commit("set_tax_rights", _this.roles_data[21].rights);
              }

              if (_this.roles_data[22].page_name === 23) {
                _this.$store.commit("set_hsn_view", _this.roles_data[22].view);
                _this.$store.commit("set_hsn_rights", _this.roles_data[22].rights);
              }
              if (_this.roles_data[23].page_name === 24) {
                _this.$store.commit("set_var_view", _this.roles_data[23].view);
                _this.$store.commit("set_var_rights", _this.roles_data[23].rights);
              }
              if (_this.roles_data[24].page_name === 25) {
                _this.$store.commit("set_unit_view", _this.roles_data[24].view);
                _this.$store.commit("set_unit_rights", _this.roles_data[24].rights);
              }

              if (_this.roles_data[11].page_name === 12) {
                _this.$store.commit("set_pur_view", _this.roles_data[11].view);
                _this.$store.commit("set_pur_rights", _this.roles_data[11].rights);
              }
              if (_this.roles_data[12].page_name === 13) {
                _this.$store.commit("set_purrt_view", _this.roles_data[12].view);
                _this.$store.commit("set_purrt_rights", _this.roles_data[12].rights);
              }
              if (_this.roles_data[5].page_name === 6) {
                _this.$store.commit("set_sale_view", _this.roles_data[5].view);
                _this.$store.commit("set_sale_rights", _this.roles_data[5].rights);
              }
              if (_this.roles_data[6].page_name === 7) {
                _this.$store.commit("set_salert_view", _this.roles_data[6].view);
                _this.$store.commit("set_salert_rights", _this.roles_data[6].rights);
              }
              if (_this.roles_data[10].page_name === 11) {
                _this.$store.commit("set_salerechis_view", _this.roles_data[10].view);
                _this.$store.commit("set_salerechis_rights", _this.roles_data[10].rights);
              }
              if (_this.roles_data[9].page_name === 10) {
                _this.$store.commit("set_salerec_view", _this.roles_data[9].view);
                _this.$store.commit("set_salerec_rights", _this.roles_data[9].rights);
              }
              if (_this.roles_data[8].page_name === 9) {
                _this.$store.commit("set_saleinvoice_view", _this.roles_data[8].view);
                _this.$store.commit("set_saleinvoice_rights", _this.roles_data[8].rights);
              }
              if (_this.roles_data[14].page_name === 15) {
                _this.$store.commit("set_purpay_view", _this.roles_data[14].view);
                _this.$store.commit("set_purpay_rights", _this.roles_data[14].rights);
              }
              if (_this.roles_data[15].page_name === 16) {
                _this.$store.commit("set_purpayhis_view", _this.roles_data[15].view);
                _this.$store.commit("set_purpayhis_rights", _this.roles_data[15].rights);
              }
              if (_this.roles_data[25].page_name === 26) {
                _this.$store.commit("set_salereturnpay_view", _this.roles_data[25].view);
                _this.$store.commit("set_salereturnpay_rights", _this.roles_data[25].rights);
              }
              if (_this.roles_data[26].page_name === 27) {
                _this.$store.commit("set_purchasereturnpay_view", _this.roles_data[26].view);
                _this.$store.commit("set_puchasereturnpay_rights", _this.roles_data[26].rights);
              }
              _this.check();
              _this.loading = false;
            }
          }).catch(function (error) {
            console.log(error);
            _this.loading = false;
            _this.$store.commit("set_shop_user", "3");
          });
        }).catch(function (error) {
          _this.loading = false;
          _this.$store.commit("set_super_user", "3");
        });
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
    handleClick1: function handleClick1(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
    check: function check() {
      var roles = this.roles_data;

      if (roles != null) {
        if (roles.length > 0) {
          for (var i = 0; i < roles.length; i++) {
            if (roles[i].page_name == 1) {
              this.dashboard = roles[i].view;
            } else if (roles[i].page_name == 2) {
              this.company_reg = roles[i].view;
            } else if (roles[i].page_name == 3) {
              this.shop_details = roles[i].view;
            } else if (roles[i].page_name == 4) {
              this.users = roles[i].view;
            } else if (roles[i].page_name == 5) {
              this.roles = roles[i].view;
            } else if (roles[i].page_name == 6) {
              this.sales = roles[i].view;
            } else if (roles[i].page_name == 7) {
              this.sale_return = roles[i].view;
            } else if (roles[i].page_name == 8) {
              this.customer = roles[i].view;
            } else if (roles[i].page_name == 9) {
              this.sale_invoice = roles[i].view;
            } else if (roles[i].page_name == 10) {
              this.sale_receipt = roles[i].rights;
            } else if (roles[i].page_name == 11) {
              this.sale_receipt_history = roles[i].view;
            } else if (roles[i].page_name == 12) {
              this.purchase = roles[i].view;
            } else if (roles[i].page_name == 13) {
              this.purchase_return = roles[i].view;
            } else if (roles[i].page_name == 14) {
              this.supplier = roles[i].view;
            } else if (roles[i].page_name == 15) {
              this.purchase_payment = roles[i].rights;
            } else if (roles[i].page_name == 16) {
              this.purchase_payment_history = roles[i].view;
            } else if (roles[i].page_name == 17) {
              this.shop_inventory = roles[i].view;
            } else if (roles[i].page_name == 18) {
              this.stock_transfer = roles[i].view;
            } else if (roles[i].page_name == 19) {
              this.product = roles[i].view;
            } else if (roles[i].page_name == 20) {
              this.category_sub_category = roles[i].view;
            } else if (roles[i].page_name == 21) {
              this.brand = roles[i].view;
            } else if (roles[i].page_name == 22) {
              this.tax = roles[i].view;
            } else if (roles[i].page_name == 23) {
              this.hsn = roles[i].view;
            } else if (roles[i].page_name == 24) {
              this.variant = roles[i].view;
            } else if (roles[i].page_name == 25) {
              this.unit = roles[i].view;
            } else if (roles[i].page_name == 26) {
              this.salereturn_receipt_history = roles[i].view;
            } else if (roles[i].page_name == 27) {
              this.purchasereturn_pending_list = roles[i].view;
            } else if (roles[i].page_name == 28) {
              this.is_admin = roles[i].view;
            } else if (roles[i].page_name == 29) {
              this.is_admin = roles[i].view;
            }
          }

          if (this.super_user == 1 || this.shop_user == 2) {
            if (this.company_reg == false && this.shop_details == false) {
              this.company_tab = false;
            } else {
              this.company_tab = true;
            }
          } else {
            this.company_tab = false;
          }

          if (this.super_user == 1 || this.shop_user == 2) {
            if (this.users == false && this.roles == false) {
              this.security_tab = false;
            } else {
              this.security_tab = true;
            }
          } else {
            this.security_tab = false;
          }

          if (this.sales == false && this.sale_return == false && this.customer == false && this.sale_invoice == false && this.sale_receipt == false && this.sale_receipt_history == false && this.salereturn_receipt_history == false) {
            this.sales_tab = false;
          } else {
            this.sales_tab = true;
          }

          if (this.purchase == false && this.purchase_return == false && this.supplier == false && this.purchase_payment == false && this.purchase_payment_history == false && this.purchasereturn_pending_list == false) {
            this.purchase_tab = false;
          } else {
            this.purchase_tab = true;
          }

          if (this.product == false && this.category_sub_category == false && this.brand == false && this.tax == false && this.hsn == false && this.variant == false && this.unit == false) {
            this.setup_tab = false;
          } else {
            this.setup_tab = true;
          }

          if (this.tax == false && this.hsn == false) {
            this.tax_tab = false;
          } else {
            this.tax_tab = true;
          }
        }
      }
    }
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67792580_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(650);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67792580_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(653);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(220);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	created: function created() {
		this.run();
	},

	methods: {
		run: function run() {
			var _this = this;
			_this.$router.push('/');
		}
	}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ResetPassword",
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      logo: null,
      bg_img: null,
      loading: false,
      resetotp: "",
      resetpassword: "",
      resettoken: "",
      resetpasswordconf: "",
      email: "",
      status_color: null,
      hasErrors: {
        new: false,
        confirm: false,
        otp: false,
        message: false
      },
      errorMessage: {
        new: "",
        confirm: "",
        message: "",
        otp: ""
      }
    };
  },
  created: function created() {
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    this.test();
  },


  methods: {
    test: function test() {
      if (this.$route.query.access_token == undefined) {
        this.$router.push("/");
      } else {
        this.resettoken = this.$route.query.access_token;
        this.email = this.$route.query.email;
      }
    },
    reset_all: function reset_all() {
      this.hasErrors.new = false;
      this.hasErrors.confirm = false;
      this.hasErrors.otp = false;
      this.errorMessage.new = "";
      this.errorMessage.confirm = "";
      this.errorMessage.otp = "";
      this.status_color = null;
    },
    Submit: function Submit() {
      this.errorMessage.message = "";
      this.reset_all();
      var submit = 0;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      if (this.resetpassword.length == 0) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "Password Required";
      } else if (pass.test(this.resetpassword) == false) {
        submit = 1;
        this.hasErrors.new = true;
        this.errorMessage.new = "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
      }
      if (this.resetpasswordconf.length == 0) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Confirm Password Required";
      } else if (this.resetpassword != this.resetpasswordconf) {
        submit = 1;
        this.hasErrors.confirm = true;
        this.errorMessage.confirm = "Password and Confirm Password does not match";
      }
      if (this.resetotp == "") {
        submit = 1;
        this.hasErrors.otp = true;
        this.errorMessage.otp = "Token Id Required";
      }
      if (submit == 0) {
        this.handleSubmit();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.loading = true;
      var data = { newPassword: this.resetpassword };
      this.$http.post("/api/users/reset-password?access_token=" + this.resettoken, data).then(function (response) {
        _this.loading = false;
        _this.errorMessage.message = "Password Reset Successfully";
        _this.status_color = "col-md-12 alert alert-success";
        _this.hasErrors.message = true;
      }).catch(function (error) {
        _this.loading = false;
        _this.errorMessage.message = "Something Went Wrong :(";
        _this.status_color = "col-md-12 alert alert-danger";
        _this.hasErrors.message = true;
      });
    },
    Login: function Login() {
      this.$router.push("/");
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    userStore: function userStore(state) {
      return state.userStore;
    }
  })),
  data: function data() {
    return {
      logo: null,
      bg_img: null,
      remember: 0,
      loading: false,
      status_color: 'alert alert-success',
      warningModal: false,
      warningModal1: false,
      resetemail: '',
      resetpassword: '',
      resettoken: '',
      resetpasswordconf: '',
      checkwarningmodel1: '',
      verfiy_color: 'alert alert-success',
      loginData: {
        both: '',
        companyname: '',
        password: ''
      },
      hasErrors: {
        both: false,
        companyname: false,
        password: false,
        message: false
      },
      errorMessage: {
        verifyemail: null,
        both: null,
        companyname: null,
        password: null,
        message: null,
        statusemail: null
      }
    };
  },
  created: function created() {
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    var is_remember = this.getCookie('is_remember');
    var company_id = this.getCookie('company_id');
    var username = this.getCookie('username');

    if (is_remember == 'true') {
      this.remember = true;
      this.loginData.both = username;
      this.loginData.companyname = company_id;
    }

    this.test();
  },


  methods: {
    getCookie: function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    test: function test() {
      if (this.$route.query.id != undefined) {
        this.verfiyemai();
      } else {
        this.$router.push('/');
      }
    },
    verfiyemai: function verfiyemai() {
      var _this = this;
      var submit = 0;
      if (this.$route.query.id != undefined) {
        if (this.$route.query.id.length <= 50) {
          this.$router.push('/');
          submit = 1;
        }
        if (submit == 0) {
          this.$http.get('/api/users/confirm?uid=' + this.$route.query.id + '').then(function (response) {
            _this.verfiy_color = "alert alert-success";
            _this.errorMessage.verifyemail = "Account Activated Successfully";
            setTimeout(function () {
              _this.verfiy_color = "alert alert-success";
              _this.errorMessage.verifyemail = null;
              _this.$router.push('/');
            }, 10000);
          }).catch(function (error) {
            _this.verfiy_color = "alert alert-danger";
            _this.errorMessage.verifyemail = "Token Has Been Expired";
            setTimeout(function () {
              _this.verfiy_color = "alert alert-success";
              _this.errorMessage.verifyemail = null;
              _this.$router.push('/');
            }, 10000);
          });
        }
      }
    },
    resetmodel: function resetmodel() {
      if (this.checkwarningmodel1 != '') {
        if (this.checkwarningmodel1 != 'open1') {
          this.warningModal1 = true;
        }
      } else {
        this.warningModal = true;
      }
    },
    reseturl: function reseturl() {
      var _this = this;
      var data = {
        email: this.resetemail
      };
      this.$http.post('/request-password-reset', data).then(function (response) {
        if (response.status == 200) {
          _this.warningModal = false;

          _this.errorMessage.verifyemail = "Please Check Your Email for Password Reset";
          _this.status_color = 'alert alert-success';
          setTimeout(function () {
            _this.verfiy_color = "alert alert-success";
            _this.errorMessage.verifyemail = null;
          }, 10000);
        } else {
          _this.errorMessage.statusemail = "Please Try Again Or Email Id does Not exists";
          _this.status_color = 'alert alert-danger';
        }
      }).catch(function (error) {
        _this.errorMessage.statusemail = error.response.data.code;
        _this.status_color = 'alert alert-danger';
      });
    },
    loginPost1: function loginPost1() {
      var _this = this;
      if (this.resetpassword === this.resetpasswordconf && this.resettoken != '') {
        var data = { newPassword: this.resetpassword,
          confirmation: this.resetpasswordconf };

        this.$http.post('/api/users/reset-password?access_token=' + this.resettoken, data).then(function (response) {
          _this.errorMessage.statusemail = "Password Reset Successfully";
          _this.status_color = 'alert alert-success';
          _this.checkwarningmodel1 = '';
        }).catch(function (error) {
          _this.errorMessage.statusemail = "Something Went Wrong :(";
          _this.status_color = 'alert alert-danger';
        });
      } else if (this.resetpassword !== this.resetpasswordconf) {
        _this.errorMessage.statusemail = "Password Does Not Match";
        _this.status_color = 'alert alert-danger';
      } else {
        _this.errorMessage.statusemail = "Please Provide Token Id ";
        _this.status_color = 'alert alert-danger';
      }
    },
    loginPost: function loginPost() {
      var _this = this;
      var vm = this.hasErrors;
      var _vm = this.errorMessage;
      if (this.loginData.both === '' || this.loginData.both === null) {
        vm.both = true;
        _vm.both = "Required Phone/Email/Username";
      } else if (this.loginData.companyname === '' || this.loginData.companyname === null) {
        vm.companyname = true;
        _vm.companyname = "Required companydomain";
      } else if (this.loginData.password === '' || this.loginData.password === null) {
        vm.password = true;
        _vm.password = "Required Password";
      } else {
        this.loading = true;
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var number = /^[0-9]{9,14}$/;
        if (re.test(this.loginData.both) === true) {
          var log = {
            companyname: this.loginData.companyname.toUpperCase(),
            email: this.loginData.both.toLowerCase(),
            password: this.loginData.password
          };
        } else if (number.test(this.loginData.both) === true) {
          var log = {
            companyname: this.loginData.companyname,
            phone: this.loginData.both,
            password: this.loginData.password
          };
        } else {
          var log = {
            companyname: this.loginData.companyname,
            username: this.loginData.both,
            password: this.loginData.password
          };
        }

        if (this.remember) {
          document.cookie = 'is_remember=true';
          document.cookie = 'company_id=' + this.loginData.companyname;
          document.cookie = 'username=' + this.loginData.both;
        } else {
          document.cookie = 'is_remember=false';
          document.cookie = 'company_id=';
          document.cookie = 'username=';
        }

        this.$http.post('/api/users/login', log).then(function (response) {
          if (response.status === 200) {
            _this.$store.dispatch('setUserObject', response.data.data1.id);
            localStorage.setItem('authUser', response.data.data1.id);
            localStorage.setItem('authUseremail', response.data.data1.email);
            var companyId = (log.companyname || '').toUpperCase();
            localStorage.setItem('companyId', companyId);
            if (log.email === 'i2oc@minsyst.com') {
              _this.$store.commit('set_is_admin', true);
            } else {
              _this.$store.commit('set_is_admin', false);
            }


            localStorage.setItem('authUserstatus', response.data.data1.status);
            _this.$router.push('/authuser');
          } else {
            _this.loading = false;
          }
        }).catch(function (error) {
          console.log(error);
          _this.loading = false;
          vm.message = true;
          _vm.message = error.response.data.error.message;
        });
      }
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      logo: null,
      bg_img: null,
      planModal: false,
      selplan: "0",
      plan_dt: null,
      plan_dt_save: {},
      termModal: false,
      privacyModal: false,
      loading: false,
      cityopt: [],
      city: null,
      registerData: {
        username: "",
        companyname: "",
        email: "",
        phone: "",
        password: "",
        confirmpassword: "",
        agree: false,
        plan: "Free",
        selplan: 0
      },
      hasErrors: {
        message: false,
        username: false,
        companyname: false,
        email: false,
        phone: false,
        password: false,
        agree: false,
        plan: false
      },
      messagepassword: "",
      errorMessage: {
        message: null,
        username: null,
        companyname: null,
        email: null,
        phone: null,
        password: null,
        agree: null,
        plan: null
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.plan()]).then(function (ret_val) {
      _this2.plan_dt = _this2.plan_dt_save;
      _this2.city1();
    });
  },

  methods: {
    plan_select: function plan_select() {
      this.planModal = false;

      this.registerData.plan = this.plan_dt[parseInt(this.selplan)]['plan_label'];
      this.registerData.selplan = this.selplan;
    },
    plan: function plan() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.plan_dt_save = {};
                _this3.$http.get("/api/plans").then(function (response) {
                  for (var i = 0; i < response.data.length; i++) {
                    _this.plan_dt_save[response.data[i]["plan_type"]] = response.data[i];
                    if (i === response.data.length - 1) {
                      if (_this.$route.query.type !== undefined && _this.$route.query.type !== null) {
                        _this.registerData.plan = _this.plan_dt_save[parseInt(_this.$route.query.type)]['plan_label'];
                        _this.registerData.selplan = _this.plan_dt_save[parseInt(_this.$route.query.type)]['plan_type'];
                        _this.selplan = _this.$route.query.type.toString();
                      }
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                    }
                  }
                }).catch(function (error) {
                  console.log(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    showplan: function showplan() {
      this.planModal = true;
    },
    city1: function city1() {
      this.cityopt = [];
      this.city = null;
      var _this = this;

      this.$http.get("/api/dbconnects").then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    registerPost: function registerPost() {
      var submit_true = 0;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var _this = this;
      var vm = this.hasErrors;
      var _vm = this.errorMessage;
      var pass = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;

      _this.hasErrors.phone = false;
      _this.hasErrors.companyname = false;
      _this.hasErrors.username = false;
      _this.hasErrors.email = false;
      _this.hasErrors.agree = false;

      if (this.registerData.password === this.registerData.confirmpassword) {
        vm.password = false;
        if (this.city === null) {
          alert("please Select DataCenter Location");
          submit_true = 1;
        }

        var regex = /^[a-zA-Z0-9\s]{3,100}$/;
        var uregex = /^[a-zA-Z\s]{3,100}$/;
        var prex = /^[0-9]{10,15}$/;
        var eregex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

        if (this.registerData.password != this.registerData.confirmpassword || this.registerData.password == "") {
          _this.hasErrors.password = true;
          _this.errorMessage.password = "Password & ConfirmPassword Does Not Match";
          submit_true = 1;
        }

        if (prex.test(this.registerData.phone) == false) {
          _this.hasErrors.phone = true;
          _this.errorMessage.phone = "Phone is required in correct Format", submit_true = 1;
        }

        if (regex.test(this.registerData.companyname) == false) {
          _this.hasErrors.companyname = true;
          _this.errorMessage.companyname = "CompanyName is required in correct Format", submit_true = 1;
        }

        if (regex.test(this.registerData.username) == false) {
          _this.hasErrors.username = true;
          _this.errorMessage.username = "UserName is required in correct Format", submit_true = 1;
        }

        this.registerData.email = this.registerData.email.toLowerCase();
        if (eregex.test(this.registerData.email) == false) {
          _this.hasErrors.email = true;
          _this.errorMessage.email = "Email is required in correct Format", submit_true = 1;
        }

        if (pass.test(this.registerData.password) == false) {
          vm.password = true;
          _this.messagepassword = "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
          submit_true = 1;
        }

        if (this.registerData.agree == false) {
          vm.agree = true;
          _this.errorMessage.agree = "Required";
          submit_true = 1;
        }

        if (submit_true == 0) {
          var res = {
            phone: this.registerData.phone,
            companyname: this.registerData.companyname,
            username: this.registerData.username,
            email: this.registerData.email,
            password: this.registerData.password,
            txt_pass: this.registerData.password,
            regcity_code: this.city.shortname,
            plan_type: this.registerData.selplan
          };

          this.loading = true;
          this.$http.post("/api/users", res).then(function (response) {
            if (response.status === 200) {
              _this.loading = false;
              _this.hasErrors.message = true;
              _this.$router.push("/afterregister");

              _this.registerData.username = "";
              _this.registerData.companyname = "";
              _this.registerData.email = "";
              _this.registerData.phone = "";
              _this.registerData.password = "";
              _this.registerData.confirmpassword = "";
              _this.registerData.agree = false;
              _this.registerData.plan = "";
              _this.registerData.selplan = 0;
              _this.city = null;
              document.getElementById("username").required = false;
              document.getElementById("companyname").required = false;
              document.getElementById("email").required = false;
              document.getElementById("phone").required = false;
              document.getElementById("password").required = false;
              document.getElementById("confirmpassword").required = false;
            } else {}
          }).catch(function (error) {
            _this.loading = false;

            var errors = error.response;
            console.log(errors);
            if (errors.statusText === "Unprocessable Entity") {
              if (errors.data) {
                if (error.response.data.error.details.messages.username) {
                  vm.username = true;
                  _vm.username = error.response.data.error.details.messages.username[0];
                }
                if (error.response.data.error.details.messages.companyname) {
                  vm.companyname = true;
                  _vm.companyname = error.response.data.error.details.messages.companyname[0];
                }
                if (error.response.data.error.details.messages.email) {
                  vm.email = true;
                  _vm.email = error.response.data.error.details.messages.email[0];
                }
                if (error.response.data.error.details.messages.phone) {
                  vm.phone = true;
                  _vm.phone = error.response.data.error.details.messages.phone[0];
                }
                if (error.response.data.error.details.messages.password) {
                  vm.password = true;
                  _vm.password = error.response.data.error.details.messages.password[0];
                }
              }
            } else if (errors.statusText === "unknown") {
              if (errors.status === 455) {
                alert("Email is already registeredwith us. You have deactivated your account. Kindly contact to Administrator to Activate your account again.");
              }
            }
          });
        }
      } else {
        vm.password = true;
        _this.messagepassword = "Password & ConfirmPassword Does Not Match";
      }
    }
  }
});

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__spinner_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_0__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableItems: [{
        avatar: { url: 'img/avatars/1.jpg', status: 'success' }

      }],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        }
      },
      termModal: false,
      logo: null,
      bg_img: null,
      privacyModal: false,
      loading: false,
      cityopt: [],
      city: null,
      registerData: {
        username: '',
        companyname: '',
        email: '',
        phone: '',
        password: '',
        confirmpassword: '',
        agree: false

      },
      hasErrors: {
        message: false,
        username: false,
        companyname: false,
        email: false,
        phone: false,
        password: false,
        agree: false

      },
      messagepassword: '',
      errorMessage: {
        message: null,
        username: null,
        companyname: null,
        email: null,
        phone: null,
        password: null,
        agree: null
      },
      img: 'static/img/logo2.png',
      img2: 'static/img/regsuccess.png',
      myStyle: {
        backgroundColor: "#FFFFFF"
      }

    };
  },
  created: function created() {
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    this.city1();
  },

  methods: {
    city1: function city1() {
      this.cityopt = [];
      this.city = null;
      var _this = this;

      this.$http.get('/api/dbconnects').then(function (response) {

        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log('error.response');
      });
    }
  }

});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_CardLine1ChartExample__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_CardLine2ChartExample__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_CardLine3ChartExample__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_CardBarChartExample__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_MainChartExample__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard_MainChart2Example__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dashboard_SocialBoxChartExample__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard_CalloutChartExample__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components___ = __webpack_require__(191);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    currencyIconClass: function currencyIconClass() {
      return this.companyTaxType === 'US' ? 'fa fa-dollar' : 'fa fa-rupee';
    },

    dashbd_view: function dashbd_view() {
      if (this.$store.getters.get_dashbd_view === true) {
        this.shopuser();
        this.get_profit();
        this.get_saleRevenue();
        this.prchse_expenses();
        this.purchase_payment();
        this.top_SoldProduct();
        this.show_currentMonth();
        this.top_crntMnthSoldPrdct();
        this.recent_order();
        var now = new Date();
        this.year = now.getFullYear();
        return true;
      } else {
        return false;
      }
    },
    dashbd_rights: function dashbd_rights() {
      return this.$store.getters.get_dashbd_rights;
    }
  },
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_9__components___["b" /* Callout */],
    CardLine1ChartExample: __WEBPACK_IMPORTED_MODULE_1__dashboard_CardLine1ChartExample__["a" /* default */],
    CardLine2ChartExample: __WEBPACK_IMPORTED_MODULE_2__dashboard_CardLine2ChartExample__["a" /* default */],
    CardLine3ChartExample: __WEBPACK_IMPORTED_MODULE_3__dashboard_CardLine3ChartExample__["a" /* default */],
    CardBarChartExample: __WEBPACK_IMPORTED_MODULE_4__dashboard_CardBarChartExample__["a" /* default */],
    MainChartExample: __WEBPACK_IMPORTED_MODULE_5__dashboard_MainChartExample__["a" /* default */],
    MainChart2Example: __WEBPACK_IMPORTED_MODULE_6__dashboard_MainChart2Example__["a" /* default */],
    SocialBoxChartExample: __WEBPACK_IMPORTED_MODULE_7__dashboard_SocialBoxChartExample__["a" /* default */],
    CalloutChartExample: __WEBPACK_IMPORTED_MODULE_8__dashboard_CalloutChartExample__["a" /* default */]
  },
  data: function data() {
    return {
      hide: false,
      year: null,
      selected: 'Month',
      profit: 0,
      purchase_expenses: 0,
      total_sale_revenue: 0,
      purchasepayment: 0,
      mnth: '',
      rows1: [],
      rows2: [],
      rows3: [],
      columns: [{
        label: 'Order ID',
        field: 'oid'
      }, {
        label: 'Customer Name',
        field: 'name'
      }, {
        label: 'Date',
        field: 'age',
        type: 'number'
      }, {
        label: 'Status',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left'
      }, {
        label: 'Order Total',
        field: 'score'
      }],
      columns1: [{
        label: 'Pro. Id',
        field: 'product_id',
        width: '15% !important'
      }, {
        label: 'Pro. Name',
        field: 'product_name',
        width: '50% !important'
      }, {
        label: 'Pro. Variant',
        field: 'variant_id',
        width: '30% !important'
      }, {
        label: 'Qty',
        field: 'sum',
        width: '15% !important'
      }],
      columns2: [{
        label: 'Pro. Id',
        field: 'product_id',
        width: '15% !important'
      }, {
        label: 'Pro. Name',
        field: 'product_name',
        width: '50% !important'
      }, {
        label: 'Pro. Variant',
        field: 'variant_id',
        width: '30% !important'
      }, {
        label: 'Qty',
        field: 'sum',
        width: '15% !important'
      }],
      columns3: [{
        label: 'Custmer Name',
        field: 'cust_cmp_name',
        width: '50% !important'
      }, {
        label: 'Date',
        field: 'lastupdated_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width: '30% !important'
      }, {
        label: 'Order Total',
        field: 'total_amt_pay',
        width: '20% !important'
      }]
    };
  },
  created: function created() {},

  methods: {
    download_data: function download_data() {
      var _this = this;
      var access_token = localStorage.getItem('authUser');
      this.$http.get('/api/users/download_data').then(function (response) {
        var url1 = _this.baseURL2 + '/api/containers/default_database_schema/download/' + response.data + '?access_token=' + access_token;
        _this.$http({
          url: url1,
          method: 'GET',
          responseType: 'blob'
        }).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res.data]));
          var link = document.createElement('a');
          link.setAttribute('download', 'file.sql');
          link.href = url1;
          document.body.appendChild(link);
          link.click();
        });
      }).catch(function (error) {});
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    yearReport: function yearReport() {
      var _this = this;
      this.$http.get('/api/companies/yearReport').then(function (response) {}).catch(function (error) {});
    },
    get_profit: function get_profit() {
      var _this = this;
      this.$http.get('/api/companies/getProfit').then(function (response) {
        if (response.data == 'NaN') {
          _this.profit = 0;
        } else {
          _this.profit = response.data;
        }
      }).catch(function (error) {});
    },
    get_saleRevenue: function get_saleRevenue() {
      var _this = this;
      this.$http.get('/api/companies/getTotalSaleRevenue').then(function (response) {
        if (response.data[0]['sum'] == null || response.data[0]['sum'] == NaN) {
          _this.total_sale_revenue = 0;
        } else {
          _this.total_sale_revenue = response.data[0]['sum'];
        }
      }).catch(function (error) {});
    },
    prchse_expenses: function prchse_expenses() {
      var _this = this;
      this.$http.get('/api/companies/purchaseExpenses').then(function (response) {

        if (response.data[0]['sum'] == null || response.data[0]['sum'] == NaN) {
          _this.purchase_expenses = 0;
        } else {
          _this.purchase_expenses = response.data[0]['sum'];
        }
      }).catch(function (error) {});
    },
    purchase_payment: function purchase_payment() {
      var _this = this;
      this.$http.get('/api/companies/purchasePayment').then(function (response) {
        if (response.data[0]['sum'] == null || response.data[0]['sum'] == NaN) {
          _this.purchasepayment = 0;
        } else {
          _this.purchasepayment = response.data[0]['sum'];
        }
      }).catch(function (error) {});
    },
    top_SoldProduct: function top_SoldProduct() {
      var _this = this;
      this.$http.get('/api/companies/topSoldProduct').then(function (response) {
        _this.rows1 = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    show_currentMonth: function show_currentMonth() {
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var now = new Date();
      this.mnth = months[now.getMonth()].toUpperCase();
    },
    top_crntMnthSoldPrdct: function top_crntMnthSoldPrdct() {
      var _this = this;
      this.$http.get('/api/companies/topCurntMnthSoldProduct').then(function (response) {
        _this.rows2 = response.data;
      }).catch(function (error) {});
    },
    recent_order: function recent_order() {
      var _this = this;
      this.$http.get('/api/companies/recentOrder').then(function (response) {
        _this.rows3 = response.data;
      }).catch(function (error) {});
    },
    variant: function variant(value) {
      var $variant = void 0;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    flag: function flag(value) {
      return 'flag-icon flag-icon-' + value;
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(39);



var brandPrimary = '#20a8d8';
var datasets = [{
  label: 'My First dataset',
  backgroundColor: brandPrimary,
  borderColor: 'rgba(255,255,255,.55)',
  data: [65, 59, 84, 84, 51, 55, 40]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent'
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent'
          }
        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, datasets[0].data) - 5,
            max: Math.max.apply(Math, datasets[0].data) + 5
          }
        }]
      },
      elements: {
        line: {
          borderWidth: 1
        },
        point: {
          radius: 4,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
});

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(39);



var brandInfo = '#63c2de';
var datasets = [{
  label: 'My First dataset',
  backgroundColor: brandInfo,
  borderColor: 'rgba(255,255,255,.55)',
  data: [1, 18, 9, 17, 34, 22, 11]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent'
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent'
          }

        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, datasets[0].data) - 5,
            max: Math.max.apply(Math, datasets[0].data) + 5
          }
        }]
      },
      elements: {
        line: {
          tension: 0.00001,
          borderWidth: 1
        },
        point: {
          radius: 4,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(39);



var datasets = [{
  label: 'My First dataset',
  backgroundColor: 'rgba(255,255,255,.2)',
  borderColor: 'rgba(255,255,255,.55)',
  data: [78, 81, 80, 45, 34, 12, 40]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false
        }],
        yAxes: [{
          display: false
        }]
      },
      elements: {
        line: {
          borderWidth: 2
        },
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(39);



var datasets = [{
  label: 'My First dataset',
  backgroundColor: 'rgba(255,255,255,.3)',
  borderColor: 'transparent',
  data: [78, 81, 80, 45, 34, 12, 40, 75, 34, 89, 32, 68, 54, 72, 18, 98]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false,
          categoryPercentage: 1,
          barPercentage: 0.5
        }],
        yAxes: [{
          display: false
        }]
      }
    });
  }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(39);




var brandSuccess = '#4dbd74';
var brandInfo = '#63c2de';
var brandDanger = '#f86c6b';

function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["b" /* Line */],
  props: ['height'],
  data: function data() {
    return {};
  },


  methods: {
    temp_fun: function temp_fun() {
      var _this = this;
      var temp = [];
      this.$http.get('/api/companies/monthReport').then(function (response) {
        temp = response.data;

        _this.chart(temp);
      }).catch(function (error) {
        console.log("error in chart");
      });
    },
    chart: function chart(temp) {
      var date = new Date(),
          y = date.getFullYear(),
          m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      var year1 = firstDay.getFullYear();
      var month1 = firstDay.getMonth();
      var day1 = firstDay.getDate();
      var year2 = lastDay.getFullYear();
      var month2 = lastDay.getMonth() + 1;
      var day2 = lastDay.getDate();
      var nextday;
      var elements = day2;
      var data1 = [];
      var label = [];
      var dates = [];
      var nxtdt = 1;
      var valuearr = [];
      var datearr = [];
      var sumarr = [];
      var ch = 0;
      var val = 0;
      var largest = 0;
      var step = 0;
      for (var i = 1; i <= day2; i++) {
        label.push(i);
        if (i == 1) {
          dates.push(firstDay);
        } else {
          var nxtdt = nxtdt + 1;
          var nextday = new Date(year1, month1, nxtdt);
          dates.push(nextday);
        }
      }

      if (temp.length == 0) {
        largest = 1000;
        step = largest / 5;
        for (var j = 0; j < dates.length; j++) {
          data1.push(0);
        }
      } else {
        var getMaxOfArray = function getMaxOfArray(sumarr) {
          return Math.max.apply(null, sumarr);
        };

        for (var l = 0; l < temp.length; l++) {
          valuearr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(temp[l]);
          datearr.push(new Date(valuearr[0]));
          sumarr.push(valuearr[1]);
        }

        largest = getMaxOfArray(sumarr);
        step = largest / 5;
        for (var n = 0; n < dates.length; n++) {
          var tmpdy1 = new Date(dates[n]).getDate();
          for (var j = 0; j < datearr.length; j++) {
            var tmpdy2 = new Date(datearr[j]).getDate();
            if (tmpdy1 == tmpdy2) {
              ch = 1;
              val = sumarr[j];
              break;
            } else {
              ch = 0;
            }
          }
          if (ch == 1) {
            data1.push(val);
          }
          if (ch == 0) {
            data1.push(0);
          }
        }
      }

      this.renderChart({
        labels: label,
        datasets: [{
          label: 'Quantity',
          backgroundColor: convertHex(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: data1
        }]
      }, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 0,
              stepSize: largest / 5,
              suggestedMax: largest
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 2,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      });
    }
  },

  mounted: function mounted() {
    this.temp_fun();
  }
});

/***/ }),
/* 367 */,
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(39);




var brandSuccess = '#4dbd74';
var brandInfo = '#63c2de';
var brandDanger = '#f86c6b';

function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["b" /* Line */],
  props: ['height'],
  data: function data() {
    return {};
  },


  methods: {
    temp_fun: function temp_fun() {
      var _this = this;
      var temp = [];
      this.$http.get('/api/companies/yearReport').then(function (response) {
        temp = response.data;
        _this.chart(temp);
      }).catch(function (error) {
        console.log("error in chart");
      });
    },
    chart: function chart(temp) {
      var date = new Date(),
          y = date.getFullYear(),
          m = date.getMonth();
      var firstDay = new Date(y, m, 1);
      var lastDay = new Date(y, m + 1, 0);
      var year1 = firstDay.getFullYear();
      var month1 = firstDay.getMonth();
      var day1 = firstDay.getDate();
      var year2 = lastDay.getFullYear();
      var month2 = lastDay.getMonth() + 1;
      var day2 = lastDay.getDate();
      var nextday;
      var elements = day2;
      var data1 = [];
      var label = [];
      var dates = [];
      var nxtdt = 1;
      var valuearr = [];
      var datearr = [];
      var sumarr = [];
      var ch = 0;
      var val = 0;
      var largest = 0;
      var step = 0;
      var months = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

      if (temp.length == 0) {
        largest = 1000;
        step = largest / 5;
        for (var j = 0; j < months.length; j++) {
          data1.push(0);
        }
      } else {
        var getMaxOfArray = function getMaxOfArray(sumarr) {
          return Math.max.apply(null, sumarr);
        };

        for (var l = 0; l < temp.length; l++) {
          valuearr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(temp[l]);
          datearr.push(valuearr[1]);
          sumarr.push(valuearr[2]);
        }
        for (var n = 0; n < months.length; n++) {
          var tmpdy1 = months[n];
          for (var j = 0; j < datearr.length; j++) {
            var tmpdy2 = datearr[j];
            if (tmpdy1 == tmpdy2) {
              ch = 1;
              val = sumarr[j];
              break;
            } else {
              ch = 0;
            }
          }
          if (ch == 1) {
            data1.push(val);
          }
          if (ch == 0) {
            data1.push(0);
          }
        }

        var largest = getMaxOfArray(sumarr);
      }
      this.renderChart({
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],

        datasets: [{
          label: 'Quantity',
          backgroundColor: convertHex(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: data1
        }]
      }, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 0,
              stepSize: largest / 5,
              suggestedMax: largest
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 2,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      });
    }
  },

  mounted: function mounted() {
    this.temp_fun();
  }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(39);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['data', 'height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        backgroundColor: 'rgba(255,255,255,.1)',
        borderColor: 'rgba(255,255,255,.55)',
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.data
      }]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false
        }],
        yAxes: [{
          display: false
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    });
  }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(39);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['data', 'height', 'width', 'variant'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      datasets: [{
        backgroundColor: 'transparent',
        borderColor: this.variant ? this.variant : '#c2cfd6',
        data: this.data
      }]
    }, {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        xAxes: [{
          display: false
        }],
        yAxes: [{
          display: false
        }]
      },
      elements: {
        line: {
          borderWidth: 2
        },
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      },
      legend: {
        display: false
      }
    });
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    currencyIconClass: function currencyIconClass() {
      return this.companyTaxType === 'US' ? 'fa fa-dollar' : 'fa fa-rupee';
    },

    dashbd_view: function dashbd_view() {
      if (this.$store.getters.get_is_admin === true) {
        this.shopuser();

        this.get_totaluser();

        return true;
      } else {
        return false;
      }
    },
    dashbd_rights: function dashbd_rights() {
      return this.$store.getters.get_dashbd_rights;
    }
  },
  components: {},
  data: function data() {
    return {
      hide: false,

      total_user: 0,
      active_user: 0,
      inactive_user: 0
    };
  },

  created: function created() {},


  methods: {
    bcardclick: function bcardclick() {
      this.$router.push("/user_management/user_status");
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    get_totaluser: function get_totaluser() {
      var _this = this;
      this.$http.get('/api/users/getTotalUser').then(function (response) {
        if (response.data !== null) {
          _this.total_user = response.data['total_user'];
          _this.active_user = response.data['active_user'];
          _this.inactive_user = response.data['inactive_user'];
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_editor__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Registration',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_4_vue2_editor__["VueEditor"]
  },
  data: function data() {
    return {
      pg_view: false,
      pg_rights: false,
      hide: false,
      access_token: null,
      content: '<h1>Company Profile</h1>',
      selectedCategory: null,
      con: null,
      loading: false,
      submit_true: 0,
      comptype1: [],
      largeModal: false,
      city: null,
      stateo1: null,
      messagesucc: '',
      messagesucc1: false,
      countryname: '',
      statename: '',
      cmp_type: '',
      cityname: '',
      allowableLogoTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp'],
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp', 'application/pdf'],
      maximumSize: 500000,
      cityopt: [],
      conopt: [],
      stateopt: [],
      yearopt: [],
      sel_year: null,
      company: {
        reg_year: '',
        name: '',
        add: '',
        add2: '',
        city: '',
        country: '',
        pincode: '',
        companyphone: '',
        email: '',
        gst: '',
        pan: '',
        cin: '',
        tan: '',
        profile: '',
        bankname: '',
        bankaccount: '',
        ifsc: '',
        branch: '',
        micr: '',
        code: '',
        bankholdername: ''
      },
      hasErrors: {
        messageemail: false,
        companyname: false,
        companyadd1: false,
        companyadd2: false,
        companycity: false,
        companycon: false,
        companypin: false,
        compphone: false,
        companymail: false,
        companygst: false,
        companypan: false,
        companycin: false,
        companytan: false,
        bankholdername: false,
        companyprofile: false,
        bankname: false,
        bankifsc: false,
        bankbrnch: false,
        bankmicr: false,
        bankswft: false,
        bankac: false,
        cmptype: false,
        conty: false,
        stateopt1: false,
        ctyopt: false,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      },
      view: {
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null,
        image1_href: null,
        image2_href: null,
        image3_href: null,
        image4_href: null,
        image5_href: null
      }
    };
  },

  computed: {
    super_user: function super_user() {
      return this.$store.getters.get_super_user;
    },

    shop_user: function shop_user() {
      return this.$store.getters.get_shop_user;
    },

    reg_view: function reg_view() {
      if (this.$store.getters.get_reg_view === true) {
        this.shopuser();

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.contr(), this.typecmp(), this.editcmp(), this.bankdtl(), this.cmpdetail()]).then(function (ret_val) {});
        return true;
      } else {
        return false;
      }
    },
    reg_rights: function reg_rights() {
      return this.$store.getters.get_reg_rights;
    }
  },

  created: function created() {
    if (localStorage.authUser != null) {
      this.access_token = '?access_token=' + localStorage.authUser;
    }
    var today = new Date();
    var year = today.getFullYear();
    for (var i = 1985; i <= year; i++) {
      var year_dic = { 'year': i.toString() };
      this.yearopt.push(year_dic);
    }
  },


  methods: {
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    editcmp: function editcmp() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this, api, rdata;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this2;
                api = '';
                rdata = null;

                if ('company_id' in _this2.$route.params) {
                  api = '/api/companies?filter[where][company_id]=' + _this2.$route.params['company_id'];
                } else {
                  api = '/api/companies/findOne';
                }
                _this2.$http.get(api).then(function (response) {
                  if ('company_id' in _this.$route.params) {
                    rdata = response.data[0];
                  } else {
                    rdata = response.data;
                  }
                  if (rdata !== null) {
                    _this.company.name = rdata.company_name;
                    _this.cmp_type = rdata.company_type;
                    _this.company.add = rdata.address1;
                    _this.countryname = rdata.country_code;
                    _this.statename = rdata.state_code;
                    _this.cityname = rdata.city;
                    if (_this.countryname == null) {
                      _this.countryname = '101';
                    }
                    if (_this.statename == null) {
                      _this.statename = '22';
                    }
                    if (_this.cityname == null) {
                      _this.cityname = '2707';
                    }
                    _this.edcontr();
                    _this.edstate1();
                    _this.edcity1();
                    _this.edtypecmp();
                    _this.company.pincode = rdata.pincode;
                    _this.company.companyphone = rdata.com_phone;
                    _this.company.email = rdata.cmp_email;
                    _this.company.cin = rdata.cmp_cin;
                    _this.company.gst = rdata.cmp_gst;
                    _this.company.pan = rdata.cmp_pan;
                    _this.company.tan = rdata.cmp_tan;
                  }
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                }).catch(function (error) {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    bankdtl: function bankdtl() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, api, rdata;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this3;
                api = '';
                rdata = null;

                if ('company_id' in _this3.$route.params) {
                  api = '/api/companybanks?filter[where][company_id]=' + _this3.$route.params['company_id'];
                } else {
                  api = '/api/companybanks/findOne';
                }
                _this3.$http.get(api).then(function (response) {
                  if ('company_id' in _this.$route.params) {
                    rdata = response.data[0];
                  } else {
                    rdata = response.data;
                  }
                  if (rdata !== null) {
                    _this.company.bankname = rdata.bank_name;
                    _this.company.bankaccount = rdata.acc_number;
                    _this.company.ifsc = rdata.ifsc_code;
                    _this.company.branch = rdata.branch;
                    _this.company.micr = rdata.micr_code;
                    _this.company.code = rdata.swift_code;
                    _this.company.bankholdername = rdata.bank_holder_name;
                  }
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                }).catch(function (error) {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    cmpdetail: function cmpdetail() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this, rdata, api;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this = _this4;
                rdata = null;
                api = '';

                if ('company_id' in _this4.$route.params) {
                  api = '/api/companydetails?filter[where][company_id]=' + _this4.$route.params['company_id'];
                } else {
                  api = '/api/companydetails/findOne';
                }

                _this4.$http.get(api).then(function (response) {

                  if ('company_id' in _this.$route.params) {
                    rdata = response.data[0];
                  } else {
                    rdata = response.data;
                  }

                  if (rdata !== null) {
                    _this.view.image1 = rdata.cmp_logo;
                    _this.view.image2 = rdata.cmp_cic_certificate;
                    _this.view.image3 = rdata.cmp_gst_cert;
                    _this.view.image4 = rdata.cmp_pan_cert;
                    _this.view.image5 = rdata.cmp_tan_cert;
                    _this.view.image1_href = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + rdata.cmp_logo + _this.access_token;
                    _this.view.image2_href = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + rdata.cmp_cic_certificate + _this.access_token;
                    _this.view.image3_href = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + rdata.cmp_gst_cert + _this.access_token;
                    _this.view.image4_href = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + rdata.cmp_pan_cert + _this.access_token;
                    _this.view.image5_href = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + rdata.cmp_tan_cert + _this.access_token;
                    _this.company.profile = rdata.cmp_profile;
                    _this.company.reg_year = rdata.reg_year;
                    if (_this.company.reg_year !== null && _this.company.reg_year !== undefined && _this.company.reg_year !== '') {
                      _this.sel_year = { 'year': _this.company.reg_year };
                    }
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                  } else {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                }).catch(function (error) {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    typecmp: function typecmp() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this = _this5;

                _this5.$http.get('/api/companytypes').then(function (response) {
                  _this.comptype1 = response.data;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                }).catch(function (error) {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    contr: function contr() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this = _this6;

                _this6.$http.get('/api/countries').then(function (response) {
                  _this.conopt = response.data;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                }).catch(function (error) {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    state1: function state1(conopt) {
      this.stateopt = [];
      this.cityopt = [];
      this.state = null;
      this.city = null;
      var _this = this;
      var id = conopt.id;
      this.$http.get('/api/states?filter[where][country_id]=' + id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {});
    },
    city1: function city1(stateopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      var id = stateopt.id;
      this.$http.get('/api/cities?filter[where][state_id]=' + id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {});
    },
    edcontr: function edcontr() {
      var _this = this;
      if (this.countryname != null) {
        this.$http.get('/api/countries/' + _this.countryname).then(function (response) {
          _this.con = response.data;
        }).catch(function (error) {});
        this.$http.get('/api/states?&filter[where][country_id]=' + _this.countryname).then(function (response) {
          _this.stateopt = response.data;
        }).catch(function (error) {});
      }
    },
    edstate1: function edstate1() {
      var _this = this;
      if (this.statename != null) {
        this.$http.get('/api/states/' + _this.statename).then(function (response) {
          _this.stateo1 = response.data;
        }).catch(function (error) {});
        this.$http.get('/api/cities?filter[where][state_id]=' + _this.statename).then(function (response) {
          _this.cityopt = response.data;
        }).catch(function (error) {});
      }
    },
    edcity1: function edcity1() {
      var _this = this;
      if (this.cityname != null) {
        this.$http.get('/api/cities/' + this.cityname).then(function (response) {
          _this.city = response.data;
        }).catch(function (error) {});
      }
    },
    edtypecmp: function edtypecmp() {
      var _this = this;
      var id = this.cmp_type;
      if (this.cmp_type != null) {
        this.$http.get('/api/companytypes/' + id).then(function (response) {
          _this.selectedCategory = response.data;
        }).catch(function (error) {});
      }
    },
    image1: function image1(callback) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      if (this.view.image1 != null) {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.view.image1);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.view.image1;
        }
      } else {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    image2: function image2(callback) {
      var _this = this;
      var image2 = document.querySelector('#image2');
      if (this.view.image2 != null) {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.view.image2);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.view.image2;
        }
      } else {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    image3: function image3(callback) {
      var _this = this;
      var image3 = document.querySelector('#image3');
      if (this.view.image3 != null) {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.view.image3);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.view.image3;
        }
      } else {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    image4: function image4(callback) {
      var _this = this;
      var image4 = document.querySelector('#image4');
      if (this.view.image4 != null) {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.view.image4);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.view.image4;
        }
      } else {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    image5: function image5(callback) {
      var _this = this;
      var image5 = document.querySelector('#image5');
      if (this.view.image5 != null) {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.view.image5);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.view.image5;
        }
      } else {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    resetError: function resetError() {

      this.messagesucc1 = false;
      this.hasErrors.cmptype = false;
      this.hasErrors.companyname = false;
      this.hasErrors.companyadd1 = false;
      this.hasErrors.companymail = false;
      this.hasErrors.companycity = false;
      this.hasErrors.companycon = false;
      this.hasErrors.companypin = false;
      this.hasErrors.compphone = false;
      this.hasErrors.companymail = false;
      this.hasErrors.companygst = false;
      this.hasErrors.companypan = false;
      this.hasErrors.companycin = false;
      this.hasErrors.companytan = false;
      this.hasErrors.companyprofile = false;
      this.hasErrors.conty = false;
      this.hasErrors.stateopt1 = false;
      this.hasErrors.ctyopt = false;
      this.hasErrors.image1 = null;
      this.hasErrors.image2 = null;
      this.hasErrors.image3 = null;
      this.hasErrors.image4 = null;
      this.hasErrors.image5 = null;
    },
    onComplete: function onComplete(chk, value) {
      var nregex = /^[a-zA-Z\s]{3,100}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var regexifsc = /^[A-Z|a-z]{4}[0][\d]{6}$/;
      var regexswift = / ^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
      var panregex = /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/;
      var mobregex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var accregex = /^[0-9]{16}$/;
      var brex = /^[a-zA-Z0-9\s]{3,100}[!@#$%^.,%&<>'":;/_|]{0,3}$/;

      var eregex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

      if (value == 'cmptype' || chk == 'check') {
        if (this.selectedCategory) {
          if (!this.selectedCategory.companycode) {
            this.hasErrors.cmptype = 'Required';
            this.submit_true = 1;
          } else {
            this.hasErrors.cmptype = '';
          }
        } else if (!this.selectedCategory) {
          this.hasErrors.cmptype = 'Required';
          this.submit_true = 1;
        } else {
          this.hasErrors.cmptype = '';
        }
      }

      if (value == 'con' || chk == 'check') {
        if (this.con) {
          if (!this.con.country_name) {
            this.hasErrors.conty = 'Required';
            this.hasErrors.stateopt1 = 'Required';
            this.hasErrors.ctyopt = 'Required';
            this.stateo1 = null;
            this.city = null;

            this.submit_true = 1;
          } else {
            this.hasErrors.conty = '';
            this.hasErrors.stateopt1 = '';
            this.hasErrors.ctyopt = '';
          }
        } else if (!this.con) {
          this.hasErrors.conty = 'Required';
          this.hasErrors.stateopt1 = 'Required';
          this.hasErrors.ctyopt = 'Required';
          this.stateo1 = null;
          this.city = null;
          this.submit_true = 1;
        } else {
          this.hasErrors.conty = '';
          this.hasErrors.stateopt1 = '';
          this.hasErrors.ctyopt = '';
        }
      }

      if (value == 'gst' || chk == 'check') {
        if (this.company.gst) {
          if (this.company.gst.length > 100) {
            this.hasErrors.companygst = 'Enter maximum 100 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.companygst = '';
          }
        }
      }

      if (value == 'state' || chk == 'check') {
        if (this.stateo1) {
          if (!this.stateo1.state_name) {
            this.hasErrors.stateopt1 = 'Required';
            this.hasErrors.ctyopt = 'Required';
            this.city = null;
            this.submit_true = 1;
          } else {
            this.hasErrors.stateopt1 = '';
            this.hasErrors.ctyopt = '';
          }
        } else if (!this.stateo1) {
          this.hasErrors.stateopt1 = 'Required';
          this.hasErrors.ctyopt = 'Required';
          this.city = null;
          this.submit_true = 1;
        } else {
          this.hasErrors.stateopt1 = '';
          this.hasErrors.ctyopt = '';
        }
      }
      if (value == 'city' || chk == 'check') {
        if (this.city) {
          if (!this.city.city_name) {
            this.hasErrors.ctyopt = 'Required';
            this.submit_true = 1;
          } else {
            this.hasErrors.ctyopt = '';
          }
        } else if (!this.city) {
          this.hasErrors.ctyopt = 'Required';
          this.submit_true = 1;
        } else {
          this.hasErrors.ctyopt = '';
        }
      }

      if (value == 'cmpname' || chk == 'check') {
        if (!this.company.name) {
          this.hasErrors.companyname = 'Required';
          this.submit_true = 1;
        } else if (this.company.name.length > 100) {
          this.hasErrors.companyname = 'Enter maximum 100 characters';
          this.submit_true = 1;
        } else if (this.company.name.length < 2) {
          this.hasErrors.companyname = 'Enter minimum 2 characters';
          this.submit_true = 1;
        } else {
          this.hasErrors.companyname = '';
        }
      }

      if (value == 'pncd' || chk == 'check') {

        if (pirex.test(this.company.pincode) == false) {

          if (!this.company.pincode) {
            this.hasErrors.companypin = 'Required';
            this.submit_true = 1;
          } else {
            this.hasErrors.companypin = 'Enter valid pincode';
            this.submit_true = 1;
          }
        } else {
          this.hasErrors.companypin = '';
        }
      }

      if (value == 'address' || chk == 'check') {
        if (this.company.add) {
          if (this.company.add.length > 100) {
            this.hasErrors.companyadd1 = 'Enter maximum 100 characters';
            this.submit_true = 1;
          } else if (this.company.add.length < 2 && this.company.add.length > 0) {
            this.hasErrors.companyadd1 = 'Enter minimum 2 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.companyadd1 = '';
          }
        } else {
          this.hasErrors.companyadd1 = '';
        }
      }

      if (value == 'companyphone' || chk == 'check') {
        if (!this.company.companyphone) {
          this.hasErrors.compphone = 'Required';
          this.submit_true = 1;
        } else if (mobregex.test(this.company.companyphone) == false) {
          this.hasErrors.compphone = 'Invalid Phone number';
          this.submit_true = 1;
        } else {
          this.hasErrors.compphone = '';
        }
      }
      if (value == 'email' || chk == 'check') {
        if (eregex.test(this.company.email) == false) {
          if (!this.company.email) {
            this.hasErrors.companymail = 'Required';
          } else {
            this.hasErrors.companymail = 'Enter valid email';
          }
          this.submit_true = 1;
        } else if (this.company.email.length > 70) {
          this.hasErrors.companymail = 'Maximum 70 characters';
        } else {
          this.hasErrors.companymail = '';
        }
      }

      if (value == 'pan' || chk == 'check') {
        if (panregex.test(this.company.pan) == false) {
          if (!this.company.pan) {
            this.hasErrors.companypan = 'Required';
          } else {
            this.hasErrors.companypan = 'Enter valid pan number';
          }
          this.submit_true = 1;
        } else {
          this.hasErrors.companypan = '';
        }
      }

      if (value == 'logo' || chk == 'check') {
        if ('files' in image1) {
          if (image1.files[0] !== undefined) {
            if (image1.files[0].size > this.maximumSize) {
              this.hasErrors.image1 = "Image Size Cannot Be Greater Than 500kb";
              this.submit_true = 1;
            } else {
              this.hasErrors.image1 = '';
            }
            if (this.allowableLogoTypes.indexOf(image1.files[0].type.toLowerCase()) === -1) {
              this.hasErrors.image1 = "Invalid File Type";
              this.submit_true = 1;
            } else {
              this.hasErrors.image1 = '';
            }
          }
        }
      }

      if (value == 'cin' || chk == 'check') {
        if (this.company.cin) {
          if (this.company.cin.length > 100) {
            this.hasErrors.companycin = 'Enter maximum 100 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.companycin = '';
          }
        }
      }
      if (value == 'cincert' || chk == 'check') {
        if ('files' in image2) {
          if (image2.files[0] != undefined) {
            if (image2.files[0].size > this.maximumSize) {
              this.hasErrors.image2 = "Image Size Cannot Be Greater Than 500kb";
              this.submit_true = 1;
            } else {
              this.hasErrors.image2 = '';
            }
            if (this.allowableTypes.indexOf(image2.files[0].type.toLowerCase()) === -1) {
              this.hasErrors.image2 = "Invalid File Type";
              this.submit_true = 1;
            } else {
              this.hasErrors.image2 = '';
            }
          }
        }
      }

      if (value == 'gstcert' || chk == 'check') {
        if ('files' in image3) {
          if (image3.files[0] != undefined) {
            if (image3.files[0].size > this.maximumSize) {
              this.hasErrors.image3 = "Image Size Cannot Be Greater Than 500kb";
              this.submit_true = 1;
            } else {
              this.hasErrors.image3 = '';
            }
            if (this.allowableTypes.indexOf(image3.files[0].type.toLowerCase()) === -1) {
              this.hasErrors.image3 = "Invalid File Type";
              this.submit_true = 1;
            } else {
              this.hasErrors.image3 = '';
            }
          }
        }
      }

      if (value == 'pancert' || chk == 'check') {
        if ('files' in image4) {
          if (image4.files[0] != undefined) {
            if (image4.files[0].size > this.maximumSize) {
              this.hasErrors.image4 = "Image Size Cannot Be Greater Than 500kb";
              this.submit_true = 1;
            } else {
              this.hasErrors.image4 = '';
            }
            if (this.allowableTypes.indexOf(image4.files[0].type.toLowerCase()) === -1) {
              this.hasErrors.image4 = "Invalid File Type";
              this.submit_true = 1;
            } else {
              this.hasErrors.image4 = '';
            }
          }
        }
      }
      if (value == 'tan' || chk == 'check') {
        if (this.company.tan) {
          if (this.company.tan.length > 12) {
            this.hasErrors.companytan = 'Enter valid TAN number';
            this.submit_true = 1;
          } else {
            this.hasErrors.companytan = '';
          }
        }
      }
      if (value == 'tancert' || chk == 'check') {
        if ('files' in image5) {
          if (image5.files[0] != undefined) {
            if (image5.files[0].size > this.maximumSize) {
              this.hasErrors.image5 = "Image Size Cannot Be Greater Than 500kb";
              this.submit_true = 1;
            } else {
              this.hasErrors.image5 = '';
            }
            if (this.allowableTypes.indexOf(image5.files[0].type.toLowerCase()) === -1) {
              this.hasErrors.image5 = "Invalid File Type";
              this.submit_true = 1;
            } else {
              this.hasErrors.image5 = '';
            }
          }
        }
      }
      if (value == 'profile' || chk == 'check') {
        if (this.company.profile) {
          if (this.company.profile.length > 1000) {
            this.hasErrors.companyprofile = 'Profile cannot be greater than 1000 Character';
            this.submit_true = 1;
          } else {
            this.hasErrors.companyprofile = '';
          }
        } else {
          this.hasErrors.companyprofile = '';
        }
      }
      if (value == 'bankname' || chk == 'check') {
        if (this.company.bankname) {
          if (this.company.bankname.length > 20) {
            this.hasErrors.banknm = 'Enter maximum 20 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.banknm = '';
          }
        }
      }

      if (value == 'bankhldname' || chk == 'check') {
        if (this.company.bankholdername) {
          if (this.company.bankholdername.length > 70) {
            this.hasErrors.bankholdername = 'Enter maximum 70 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.bankholdername = '';
          }
        }
      }

      if (value == 'bankacc' || chk == 'check') {
        if (this.company.bankaccount) {
          if (this.company.bankaccount.length > 30) {
            this.hasErrors.bankac = 'Enter maximum 30 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.bankac = '';
          }
        }
      }
      if (value == 'ifsc' || chk == 'check') {
        if (this.company.ifsc) {
          if (this.company.ifsc.length > 20) {
            this.hasErrors.bankifsc = 'Enter maximum 20 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.bankifsc = '';
          }
        }
      }

      if (value == 'micr' || chk == 'check') {
        if (this.company.micr) {
          if (this.company.micr.length > 20) {
            this.hasErrors.bankmicr = 'Enter maximum 20 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.bankmicr = '';
          }
        }
      }
      if (value == 'branch' || chk == 'check') {
        if (this.company.branch) {
          if (this.company.branch.length > 20) {
            this.hasErrors.bankbrnch = 'Enter maximum 20 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.bankbrnch = '';
          }
        }
      }

      if (value == 'swiftcode' || chk == 'check') {
        if (this.company.code) {
          if (this.company.code.length > 20) {
            this.hasErrors.bankswft = 'Enter maximum 20 characters';
            this.submit_true = 1;
          } else {
            this.hasErrors.bankswft = '';
          }
        }
      }
    },
    finalSave: function finalSave() {
      var _this7 = this;

      this.messagesucc1 = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.submit_true = 0;
      this.onComplete('check', 'false');
      var _this = this;
      if (this.submit_true == 0) {
        this.loading = true;
        var data = {};
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          if (_this7.sel_year !== null) {
            if ('year' in _this7.sel_year) {
              _this7.company.reg_year = _this7.sel_year['year'];
            } else {
              _this7.company.reg_year = null;
            }
          }

          data.gst = _this7.company.gst;
          data.cic = _this7.company.cic;
          data.pan = _this7.company.pan;
          data.profile = _this7.company.profile;
          data.banknm = _this7.company.banknm;
          data.account = _this7.company.ac;
          data.ifsc = _this7.company.ifsc;
          data.branch = _this7.company.branch;
          data.micr = _this7.company.micr;
          data.code = _this7.company.code;
          data.company_name = _this7.company.name;
          data.company_type = _this7.selectedCategory.id;
          data.address1 = _this7.company.add;
          data.address2 = _this7.company.add2;
          data.city = _this7.city.id;
          data.country_code = _this7.con.id;
          data.state_code = _this7.stateo1.id;
          data.pincode = _this7.company.pincode;
          data.com_phone = _this7.company.companyphone;
          data.cmp_email = _this7.company.email;
          data.cmp_gst = _this7.company.gst;
          data.cmp_pan = _this7.company.pan;
          data.cmp_cin = _this7.company.cin;
          data.cmp_tan = _this7.company.tan;
          data.banknm = _this7.company.bankname;
          data.account = _this7.company.bankaccount;
          if (_this7.company.reg_year !== null && _this7.company.reg_year !== undefined) {
            data.reg_year = _this7.company.reg_year;
          } else {
            data.reg_year = '';
          }
          data.bank_holder_name = _this7.company.bankholdername;
          data.cmp_logo = user[0];
          data.cmp_cic_certificate = user[1];
          data.cmp_gst_cert = user[2];
          data.cmp_pan_cert = user[3];
          data.cmp_tan_cert = user[4];
          var api = '';
          if ('company_id' in _this7.$route.params) {
            api = '/api/companies/upsertWithWhere?filter[where][company_id]=' + _this7.$route.params['company_id'];
          } else {
            api = '/api/companies/upsertWithWhere';
          }
          _this7.$http.post(api, data).then(function (response) {
            _this.loading = false;
            _this.messagesucc1 = true;
            _this.messagesucc = " Successfully Updated";
            setTimeout(function () {
              _this.messagesucc = '';
            }, 2000);
            _this.contr();
            _this.typecmp();
            _this.editcmp();
            _this.bankdtl();
            _this.cmpdetail();
          }).catch(function (error) {
            _this.messagesucc1 = true;
            _this.messagesucc = "Something went Wrong";
            _this.loading = false;
            setTimeout(function () {
              _this.messagesucc = '';
            }, 2000);
          });
        });
      }
    },


    setLoading: function setLoading(value) {
      this.loadingWizard = value;
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(36);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shop',
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */] },
  computed: {
    shop_view: function shop_view() {
      var _this = this;
      if (this.$store.getters.get_shop_view === true) {
        this.shopuser();
        this.contr1();
        this.getTotals('comp');

        return true;
      } else {
        return false;
      }
    },
    shop_rights: function shop_rights() {
      return this.$store.getters.get_shop_rights;
    }
  },

  data: function data() {
    return {
      center: { lat: 19.283442, lng: 72.870092 },
      tfrst_time: false,

      show_save_btn: false,
      largeModal: false,
      plan_modal: false,
      loading: false,
      cityopt: [],
      stateopt: [],
      conopt: [],
      useropt: [],
      citysrchopt: [],
      adminuser: null,
      oldadmin: null,
      con: null,
      state: null,
      city: null,
      updateedit: 0,
      shoptype: [],
      editid: null,
      shopid: null,
      shpusername: null,
      buttosstat: 0,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      shop: {
        name: '',
        phone: '',
        address1: '',
        address2: '',
        pincode: '',
        gst: '',
        sale_price_editable: false
      },
      search: {
        name: '',
        city: null,
        address2: '',
        pincode: ''
      },
      columns: [{
        label: 'Shop Name',
        field: 'est_shop_name',
        width: '40%'
      }, {
        label: 'Shop Type',
        field: 'est_type',
        width: '20%'
      }, {
        label: 'Shop Phone',
        field: 'est_shop_phone',
        width: '10%'
      }, {
        label: 'Pincode',
        field: 'pincode',
        width: '10%'
      }, {
        label: 'City',
        field: 'cities.city_name',
        width: '10%'
      }, {
        label: 'Action',
        field: 'action',
        width: '10%'
      }],
      rows: [],
      hasErrors: {
        message: false,
        shopnm: false,
        shopad1: false,
        shopad2: false,
        shoppin: false,
        shop_gst: false,
        shopph: false,
        shopcntry: false,
        shopstate: false,
        shopcity: false,
        cmptype: false,
        shopadmin: false,
        shopnmexist: false
      },
      errorMessage: {
        message: ''
      },
      warningModal: false,
      markers: [{ position: null }],
      place: null
    };
  },
  created: function created() {
    this.allusers();
    this.contr1ed('101');
    this.state1ed('22');
    this.city1ed('2707');
  },


  mounted: function mounted() {
    if (navigator.geolocation) {
      var self = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        self.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        self.markers.push({
          position: {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        });
      });
    }
  },

  methods: {
    chkShopExist: function chkShopExist() {
      var _this = this;

      if (this.shop.name != '') {
        this.$http.get('/api/shopestablishments/chk_shop_exist?filter[where][est_shop_name]=' + this.shop.name).then(function (response) {
          if (response.data.length > 0) {
            _this.shop.name = '';
            _this.hasErrors.shopnmexist = true;
            _this.$refs['txtshopname'].focus();
          }
        }).catch(function (error) {
          _this.hasErrors.shopnmexist = false;
        });
      } else {
        _this.hasErrors.shopnmexist = false;
      }
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.username + ' - ' + item.phone;
    },
    allusers: function allusers() {
      var _this = this;
      this.$http.get('/api/users/allusers').then(function (response) {
        _this.useropt = response.data;
      }).catch(function (error) {});
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems: function loadItems() {
      this.loading = true;
      var self = this;
      var new1 = [];
      var data = [];
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var shopname = this.search.name;
      shopname = shopname.split(' ').join('_');
      if (this.search.name != '') {
        data = data + "&filter[where][est_shop_name][ilike]=%" + shopname + "%";
      }
      if (this.search.city != null) {
        if (this.search.city.id != undefined) {
          var cmptyp = this.search.city.id;
          data = data + "&filter[where][city][ilike]=%" + cmptyp + "%";
        }
      }
      if (this.search.pincode != '') {
        data = data + "&filter[where][pincode][ilike]=%" + this.search.pincode + "%";
      }
      this.$http.get('/api/shopestablishments?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        self.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) self.rows = response.data;
        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
      });
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    fillshopgst: function fillshopgst() {
      var _this = this;
      this.$http.get('/api/companies/findOne').then(function (response) {
        _this.shop.gst = response.data.cmp_gst;
      });
    },
    openwarning: function openwarning() {
      this.warningModal = true;
      this.buttosstat = 0;
    },
    addshopnew: function addshopnew() {
      var _this = this;
      this.loading = true;
      this.$http.get('/api/shopestablishments/chk_plan_count').then(function (response) {
        _this.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _this.plan_modal = true;
          } else {
            _this.plan_modal = false;
            var shopoptions = _this.$refs.shptype.children;
            if (shopoptions.length) {
              _this.shoptype = shopoptions[1].value;
            }

            for (var i = 0; i < _this.useropt.length; i++) {
              if (_this.useropt[i].role === '1') {
                _this.adminuser = _this.useropt[i];
              }
            }
            _this.hasErrors.cmptype = '';
            _this.hasErrors.shopnm = '';
            _this.hasErrors.shopad1 = '';
            _this.hasErrors.shopad2 = '';
            _this.hasErrors.shoppin = '';
            _this.hasErrors.shop_gst = '';
            _this.hasErrors.shopph = '';
            _this.hasErrors.shopcntry = '';
            _this.hasErrors.shopadmin = '';
            _this.hasErrors.shopstate = '';
            _this.hasErrors.shopcity = '';
            _this.hasErrors.message = '';
            _this.hasErrors.shopnmexist = '';
            _this.errorMessage.message = '';
            _this.shop.name = '';
            _this.shop.address1 = '';
            _this.shop.address2 = '';
            _this.shop.pincode = '';
            _this.shop.gst = '';
            _this.shop.phone = '';
            _this.updateedit = 0;
            _this.editid = null;
            _this.shopid = null;
            _this.shpusername = null;
            _this.show_save_btn = true;
            _this.largeModal = true;
            _this.contr1ed('101');
            _this.state1ed('22');
            _this.city1ed('2707');

            _this.fillshopgst();
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getMarkerPosition: function getMarkerPosition(marker) {
      this.center = { lat: marker.lat(), lng: marker.lng() };
    },
    contr1: function contr1() {
      var _this = this;
      this.$http.get('/api/countries').then(function (response) {
        _this.conopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    state1: function state1(conopt) {
      this.stateopt = [];
      this.cityopt = [];
      this.state = null;
      this.city = null;
      var _this = this;
      var id = conopt.id;
      this.$http.get('/api/states?filter[where][country_id]=' + id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1: function city1(stateopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      var id = stateopt.id;
      this.$http.get('/api/cities?filter[where][state_id]=' + id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    searchcity: function searchcity(name) {
      var _this = this;
      if (name.length > 2) {
        this.$http.get('/api/cities?filter[where][city_name][ilike]=%' + name + '%').then(function (response) {
          _this.citysrchopt = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    shopadmined: function shopadmined(option) {
      var _this = this;
      var shop = {
        est_shop_id: option
      };
      this.$http.post('/api/shopusers/getShopAdmin', shop).then(function (response) {
        _this.adminuser = response.data;
        _this.oldadmin = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    contr1ed: function contr1ed(option) {
      var _this = this;
      this.$http.get('/api/countries/' + option).then(function (response) {
        _this.con = response.data;
      }).catch(function (error) {
        console.log(error);
      });
      this.$http.get('/api/states?&filter[where][country_id]=' + option).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    state1ed: function state1ed(conopt) {
      var _this = this;
      this.$http.get('/api/states/' + conopt).then(function (response) {
        _this.state = response.data;
      }).catch(function (error) {
        console.log(error);
      });
      this.$http.get('/api/cities?filter[where][state_id]=' + conopt).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1ed: function city1ed(stateopt) {
      var _this = this;
      this.$http.get('/api/cities/' + stateopt).then(function (response) {
        _this.city = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    editpro: function editpro(row) {
      var stateedit = {};
      var cityedit = {};
      this.hasErrors.cmptype = '';
      this.hasErrors.shopnm = '';
      this.hasErrors.shopad1 = '';
      this.hasErrors.shopad2 = '';
      this.hasErrors.shoppin = '';
      this.hasErrors.shop_gst = '';
      this.hasErrors.shopph = '';
      this.hasErrors.shopcntry = '';
      this.hasErrors.shopadmin = '';
      this.hasErrors.shopstate = '';
      this.hasErrors.shopcity = '';
      this.hasErrors.message = '';
      this.hasErrors.shopnmexist = false;
      this.shop.name = row.est_shop_name;
      this.hasErrors.message = false;
      this.errorMessage.message = '';
      this.shop.address1 = row.address1;
      this.shop.address2 = row.address2;
      this.shop.pincode = row.pincode;
      this.shop.gst = row.shop_gst;
      this.shop.phone = row.est_shop_phone;
      this.shop.sale_price_editable = row.saleprice;
      this.updateedit = 1;
      this.editid = row.id;
      this.shopid = row.est_shop_id;
      this.shpusername = row.user_name;
      this.shoptype = row.est_type;

      this.shopadmined(row.est_shop_id);
      if (row.country_code != null) {
        this.contr1ed(row.country_code);
      }
      if (row.state_code != null) {
        this.state1ed(row.state_code);
      }
      if (row.city != null) {
        this.city1ed(row.city);
      }
      this.show_save_btn = true;
      this.largeModal = true;
    },
    viewshop: function viewshop(row) {
      this.shop.name = row.est_shop_name;
      this.shop.address1 = row.address1;
      this.shop.address2 = row.address2;
      this.shop.pincode = row.pincode;
      this.shop.gst = row.shop_gst;
      this.shop.phone = row.est_shop_phone;
      this.shoptype = row.est_type;
      if (row.country_code != null) {
        this.contr1ed(row.country_code);
      }
      if (row.state_code != null) {
        this.state1ed(row.state_code);
      }
      if (row.city != null) {
        this.city1ed(row.city);
      }
      this.show_save_btn = false;
      this.largeModal = true;
    },
    Successsub: function Successsub() {
      this.loading = true;
      var _this = this;
      _this.hasErrors.cmptype = false;
      _this.hasErrors.shopnm = false;
      _this.hasErrors.shopad1 = false;
      _this.hasErrors.shopad2 = false;
      _this.hasErrors.shoppin = false;
      _this.hasErrors.shop_gst = false;
      _this.hasErrors.shopph = false;
      _this.hasErrors.shopadmin = false;
      _this.hasErrors.shopcntry = false;
      _this.hasErrors.shopstate = false;
      _this.hasErrors.shopcity = false;
      _this.hasErrors.shopnmexist = false;
      var submit_true = 0;
      var regex = /^[a-zA-Z0-9\s,.'-/]{3,}$/;
      var prex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var eregex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
      if (this.shoptype.length == 0) {
        _this.hasErrors.cmptype = true;
        submit_true = 1;
      }
      if (regex.test(this.shop.name) == false) {
        _this.hasErrors.shopnm = true;
        submit_true = 1;
      }

      if (regex.test(this.shop.address1) == false) {
        _this.hasErrors.shopad1 = true;
        submit_true = 1;
      }
      if (this.adminuser == null) {
        _this.hasErrors.shopadmin = true;
        submit_true = 1;
      }
      if (this.con == null) {
        _this.hasErrors.shopcntry = true;
        submit_true = 1;
      }
      if (this.state == null) {
        _this.hasErrors.shopstate = true;
        submit_true = 1;
      }
      if (this.city == null) {
        _this.hasErrors.shopcity = true;
        submit_true = 1;
      }
      if (pirex.test(this.shop.pincode) == false) {
        _this.hasErrors.shoppin = true;
        submit_true = 1;
      }
      if (regex.test(this.shop.gst) == false && this.shop.gst != '') {
        _this.hasErrors.shop_gst = true;
        submit_true = 1;
      }
      if (prex.test(this.shop.phone) == false) {
        _this.hasErrors.shopph = true;
        submit_true = 1;
      }

      if (submit_true == 0) {
        var useradmin = null;
        var shp_username = null;
        var shp_userphone = null;
        if (this.adminuser !== null) {
          useradmin = this.adminuser.email;
          shp_username = this.adminuser.username;
          shp_userphone = this.adminuser.phone;
        }

        var shop = {
          est_type: this.shoptype,
          est_shop_name: this.shop.name,
          est_shop_phone: this.shop.phone,
          address1: this.shop.address1,
          address2: this.shop.address2,
          pincode: this.shop.pincode,
          country_code: this.con.id,
          state_code: this.state.id,
          city: this.city.id,
          shop_gst: this.shop.gst,
          saleprice: this.shop.sale_price_editable,
          est_latitude: this.center.lat,
          est_longititude: this.center.lng,
          shopid: this.shopid,
          user_admin: useradmin,
          shpusername: shp_username,
          shpuserphone: shp_userphone,
          oldadmin: this.oldadmin
        };

        if (this.updateedit == 0) {
          this.$http.post('/api/shopestablishments', shop).then(function (response) {
            _this.loading = false;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.hasErrors.message = true;
            _this.errorMessage.message = 'Shop Added Successfully';
            _this.getTotals();
            setTimeout(function () {
              _this.errorMessage.message = '';
            }, 2000);
            _this.reset();
            _this.largeModal = false;
          }).catch(function (error) {
            _this.loading = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = 'Something went wrong!, try later';
            console.log(error);
            setTimeout(function () {
              _this.errorMessage.message = '';
            }, 2000);
          });
        }
        if (this.updateedit == 1) {
          this.$http.post('/api/shopestablishments/update?where[id]=' + this.editid, shop).then(function (response) {
            _this.loading = false;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.hasErrors.message = true;
            _this.errorMessage.message = 'Shop Updated Successfully';
            setTimeout(function () {
              _this.errorMessage.message = '';
            }, 2000);
            _this.reset();
            _this.getTotals();
            _this.largeModal = false;
          }).catch(function (error) {
            _this.loading = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = "Something went wrong, try later";
            setTimeout(function () {
              _this.errorMessage.message = '';
            }, 2000);
          });
        }
      } else {
        _this.loading = false;
      }
    },
    serachprev: function serachprev() {
      this.serverParams.page = 1;
      this.$refs['my-table'].reset();
      this.loadItems();
    },
    setDescription: function setDescription(description) {
      this.description = description;
    },
    setPlace: function setPlace(place) {
      this.position = [];
      this.buttosstat = 0;
      this.place = place;
      this.center = { lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng() };
    },
    usePlace: function usePlace(place) {
      this.buttosstat = 1;
      this.markers = [];
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          }
        });
        this.place = null;
      } else {
        this.markers = [{ position: { lat: this.center.lat, lng: this.center.lng } }];
      }
    },
    revertbck: function revertbck() {
      this.largeModal = true;
      this.warningModal = false;
    },
    reset: function reset() {
      var _this = this;
      _this.shop.name = '';
      _this.con = null, _this.state = null;
      _this.city = null;
      _this.shoptype = null;
      _this.shop.address1 = '';
      _this.shop.address2 = '';
      _this.shop.pincode = '';
      _this.shop.gst = '';
      _this.shop.phone = '';
    },
    getTotals: function getTotals(val) {
      if (val === 'comp') {
        if (this.tfrst_time === false) {
          this.tfrst_time = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
    deleteshoplist: function deleteshoplist(shoplistid) {
      var _this = this;
      var id = shoplistid.id;
      this.$http.delete('/api/shopestablishments/' + id).then(function (response) {
        _this.getTotals();
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuedt',
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      hide: false,
      roletype: false,
      viewroles: false,
      editmodal: false,
      loading: false,
      role_name_view: '',
      checkview: [],
      checkrights: [],
      checkview_view: [],
      checkrights_view: [],
      checkview_edit: [],
      checkrights_edit: [],
      selectallview_edit: false,
      selectallrights_edit: false,
      selectallview_add: false,
      selectallrights_add: false,
      message: '',
      role_name: '',
      role_name1: '',
      haserror: {
        role_name: false,
        role_name1: ''
      },
      columns: [{
        label: 'Page Name',
        field: 'pagename',
        width: '25% !important'
      }, {
        label: 'View Only',
        field: 'view',
        width: '15% !important'
      }, {
        label: 'Add/Update',
        field: 'rights',
        width: '15% !important'
      }],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      new_roles: [],
      columns1: [{
        label: 'Role Type',
        field: 'role_name',
        width: '55% !important'
      }, {
        label: 'Created At',
        field: 'lastupdated_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'DD MMMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width: '35% !important'
      }, {
        label: 'Action',
        field: 'action',
        tdClass: 'text-center',
        thClass: 'text-center',
        width: '10% !important'
      }],
      rows1: []
    };
  },

  computed: {
    r_view: function r_view() {
      if (this.$store.getters.get_r_view === true) {
        this.getRoles();
        this.getPageNames();
        this.shopuser();
        return true;
      } else {
        return false;
      }
    },

    r_rights: function r_rights() {
      return this.$store.getters.get_r_rights;
    }
  },

  methods: {
    chkExist: function chkExist() {
      var _this = this;
      this.role_name = this.role_name.trim();
      if (this.role_name != '') {
        this.$http.get('/api/roletbs/chk_exist?filter[where][role_name]=' + this.role_name).then(function (response) {
          if (response.data.length > 0) {
            _this.role_name = '';
            _this.haserror.role_name = 'Role name already exist';
            _this.$refs['txtrolename'].focus();
          } else {
            _this.haserror.role_name = false;
          }
        }).catch(function (error) {
          _this.haserror.role_name = false;
        });
      } else {
        _this.haserror.role_name = false;
      }
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems: function loadItems() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.$http.get('/api/roletbs?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        if (response.data != undefined) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          _this.rows1 = response.data;
          _this.loading = false;
        }
      }).catch(function (error) {});
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    viewpermission: function viewpermission(row) {
      var data = {};
      this.checkview_view = [];
      this.checkrights_view = [];
      this.rows = [];
      this.role_name_view = '';
      data.role_id = row.role_id;
      var _this = this;
      this.$http.post('/api/permissiontbs/permission', data).then(function (response) {
        _this.viewroles = true;
        _this.rows = response.data.data;
        _this.role_name_view = response.data.data[0]['role_name'];
        if (response.data.data.length > 0) {
          for (var i = 0; i < response.data.data.length; i++) {
            _this.checkview_view[i] = response.data.data[i]['view'];
            _this.checkrights_view[i] = response.data.data[i]['rights'];
          }
        }
      }).catch(function (error) {});
    },
    editpermission: function editpermission(row) {
      var data = {};
      this.checkview_edit = [];
      this.checkrights_edit = [];
      this.rows = [];
      this.role_name1 = '';
      data.role_id = row.role_id;
      var _this = this;
      this.$http.post('/api/permissiontbs/permission', data).then(function (response) {
        _this.editmodal = true;
        _this.rows = response.data.data;
        _this.role_name1 = response.data.data[0]['role_name'];
        if (response.data.data.length > 0) {
          for (var i = 0; i < response.data.data.length; i++) {
            _this.checkview_edit[i] = response.data.data[i]['view'];
            _this.checkrights_edit[i] = response.data.data[i]['rights'];
          }
        }
      }).catch(function (error) {});
    },
    deletepermission: function deletepermission(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http.delete('/api/roletbs/' + row.role_id).then(function (response) {
          _this.loading = false;
          _this.getRoles();
        }).catch(function (error) {
          if (error.response.status === 444) {
            _this.loading = false;
            _this.message = 'Cannot delete role "' + row.role_name + '" it has been assigned to user';
            setTimeout(function () {
              _this.message = false;
            }, 6000);
          } else {
            console.log('error.response');
          }
        });
      }
    },
    addRoles: function addRoles() {
      this.roletype = true;
      this.haserror.role_name = '';
      this.role_name = '';
      this.checkview = [];
      this.checkrights = [];
      this.rows = [];
      this.rows = this.new_roles;
      this.selectallview_add = false;
      this.selectallrights_add = false;
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i]['view'] = false;
          this.rows[i]['rights'] = false;
        }
      }
    },
    getRoles: function getRoles() {
      this.loadItems();
    },
    getPageNames: function getPageNames() {
      var _this = this;
      this.$http.get('/api/permissionpgs').then(function (response) {
        if (response.data.length > 0) {
          for (var i = 0; i < response.data.length; i++) {
            response.data[i]['view'] = false;
            response.data[i]['rights'] = false;
          }
        }
        _this.new_roles = response.data;
        _this.rows = _this.new_roles;
      }).catch(function (error) {});
    },
    checkedview: function checkedview(index) {

      if (this.checkview[index] === true) {
        this.rows[index]['view'] = true;
      } else {
        if (this.rows[index]['rights'] === false) {
          this.rows[index]['view'] = false;
          this.checkview[index] = false;
        } else {
          this.rows[index]['view'] = true;
          this.checkview[index] = true;
        }
      }
    },
    checkedrights: function checkedrights(index) {
      this.rows[index]['rights'] = this.checkrights[index];
      if (this.checkrights[index] === true) {
        this.checkview[index] = true;
        this.rows[index]['view'] = true;
      }
    },
    checkedview_edit: function checkedview_edit(index) {
      if (this.checkview_edit[index] === true) {
        this.rows[index]['view'] = true;
      } else {
        if (this.rows[index]['rights'] === false) {
          this.rows[index]['view'] = false;
          this.checkview_edit[index] = false;
        } else {
          this.rows[index]['view'] = true;
          this.checkview_edit[index] = true;
        }
      }
    },
    checkedrights_edit: function checkedrights_edit(index) {
      this.rows[index]['rights'] = this.checkrights_edit[index];
      if (this.checkrights_edit[index] === true) {
        this.checkview_edit[index] = true;
        this.rows[index]['view'] = true;
      }
    },
    close_addroles: function close_addroles() {
      this.roletype = false;
    },
    create_roles: function create_roles() {
      var _this = this;
      var data = {};
      var submit = 0;
      data.role_name = this.role_name;
      data.permission = this.rows;
      _this.haserror.role_name = '';
      if (data.role_name == '') {
        submit = 1;
        _this.haserror.role_name = "Required";
      } else if (data.role_name.length < 2) {
        submit = 1;
        _this.haserror.role_name = "Minimum 2 characters required";
      } else if (data.role_name.length > 30) {
        submit = 1;
        _this.haserror.role_name = "Cannot be greater than 30 characters";
      }
      if (submit == 0) {
        this.loading = true;
        this.$http.post('/api/roletbs', data).then(function (response) {
          _this.loading = false;
          _this.role_name = '';
          _this.roletype = false;
          _this.getRoles();
        }).catch(function (error) {});
      }
    },
    update_roles: function update_roles() {
      var _this = this;
      var data = {};
      var submit = 0;
      data.permission = this.rows;
      data.role_name = this.role_name1;
      _this.haserror.role_name1 = '';

      if (data.role_name1 == '') {
        submit = 1;
        _this.haserror.role_name1 = "Required";
      } else if (data.role_name.length < 2) {
        submit = 1;
        _this.haserror.role_name1 = "Minimum 2 characters required";
      } else if (data.role_name.length > 30) {
        submit = 1;
        _this.haserror.role_name1 = "Cannot be greater than 30 characters";
      }

      if (submit == 0) {
        this.loading = true;
        this.$http.post('/api/roletbs/update_roles', data).then(function (response) {
          _this.loading = false;
          _this.role_name1 = '';
          _this.editmodal = false;
          _this.getRoles();
        }).catch(function (error) {});
      }
    },
    selectallview: function selectallview(act) {
      if (act === 'add') {
        if (this.selectallview_add === true) {
          for (var i = 0; i < this.rows.length; i++) {
            this.rows[i]['view'] = true;
            this.checkview[i] = true;
          }
        } else {
          for (var i = 0; i < this.rows.length; i++) {
            if (this.rows[i]['rights'] === true) {
              this.rows[i]['view'] = true;
              this.checkview[i] = true;
            } else {
              this.rows[i]['view'] = false;
              this.checkview[i] = false;
            }
          }
        }
      } else {
        if (this.selectallview_edit === true) {
          for (var i = 0; i < this.rows.length; i++) {
            this.rows[i]['view'] = true;
            this.checkview_edit[i] = true;
          }
        } else {
          for (var i = 0; i < this.rows.length; i++) {
            if (this.rows[i]['rights'] === true) {
              this.rows[i]['view'] = true;
              this.checkview_edit[i] = true;
            } else {
              this.rows[i]['view'] = false;
              this.checkview_edit[i] = false;
            }
          }
        }
      }
    },
    selectallrights: function selectallrights(act) {
      if (act === 'add') {
        if (this.selectallrights_add === true) {
          this.selectallview_add = true;
          for (var i = 0; i < this.rows.length; i++) {
            this.checkrights[i] = true;
            this.rows[i]['rights'] = this.selectallrights_add;

            this.checkview[i] = true;
            this.rows[i]['view'] = true;
          }
        } else {
          for (var i = 0; i < this.rows.length; i++) {
            this.checkrights[i] = false;
            this.rows[i]['rights'] = false;
          }
        }
      } else {
        if (this.selectallrights_edit === true) {
          this.selectallview_edit = true;
          for (var i = 0; i < this.rows.length; i++) {
            this.checkrights_edit[i] = true;
            this.rows[i]['rights'] = this.selectallrights_edit;

            this.checkview_edit[i] = true;
            this.rows[i]['view'] = true;
          }
        } else {
          for (var i = 0; i < this.rows.length; i++) {
            this.checkrights_edit[i] = false;
            this.rows[i]['rights'] = false;
          }
        }
      }
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_vue__ = __webpack_require__(3);







var _methods;


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "user",
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_6__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      active_deactive: true,
      plan_modal: false,
      rfrst_time: false,
      shpfrst_time: false,
      estfrst_time: false,
      isSuperAdmin: false,
      deact_modal: false,
      columnsadj: [{
        label: "Shop Name",
        field: "est_shop_name",
        width: "30%"
      }, {
        label: "Address",
        field: "address1",
        width: "60%"
      }],
      rowsadj: [],
      column1: [{
        label: "Role",
        field: "role_name",
        width: "90%"
      }],
      totalRecords: 0,
      totalRecordsShop: 0,
      totalRecordsRoles: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      serverParamsShop: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      serverParamsRole: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      rows1: [],
      tempshpList: null,
      shopList: [],
      beforeShops: [],
      deletedshops: [],

      roleList: null,
      isAdmin: false,
      submit_true: 0,
      options1: [{ text: "Admin User", value: "2" }, { text: "Normal User", value: "3" }],
      options2: [{ text: "Normal User", value: "3" }],
      options3: [{ text: "Please select", value: "" }],
      items: [],
      lastSelectItem: {},
      checkbox: 1,
      shopids: null,
      largeModal: false,
      largeModal1: false,
      loading: false,
      usertype: "",
      updateedit: 0,
      temprow: null,
      shopidopt: [],
      allUser: [],
      shoplist1: [],
      rolelist1: [],

      user: {
        name: "",
        address: "",
        pincode: "",
        email: "",
        email1: "",
        pass: "",
        conf: "",
        phone: "",
        names: "",
        editid: null
      },
      columns: [{
        label: "User Name",
        field: "user_name",
        width: "20%"
      }, {
        label: "User Email",
        field: "user_email",
        width: "30%"
      }, {
        label: "Contact No.",
        field: "phonenumber",
        width: "30%"
      }, {
        label: "Status",
        field: "status",
        width: "10%"
      }, {
        label: "Action",
        field: "action",
        width: "10%"
      }],
      rows: [],
      shopid: null,
      shopidopt1: [],
      hasErrors: {
        err_message: "",
        message: "",
        password: "",
        usernm: "",
        useradd: "",
        userpin: "",
        usereml: "",
        userph: ""
      },
      errorMessage: {
        err_message: null,
        message: null,
        usertypeerr: null,
        usershop: null,
        userrole: null
      }
    };
  },


  computed: {
    u_view: function u_view() {
      if (this.$store.getters.get_u_view === true) {
        this.shopest("comp");
        this.shopuser("comp");
        this.role("comp");
        return true;
      } else {
        return false;
      }
    },
    u_rights: function u_rights() {
      return this.$store.getters.get_u_rights;
    }
  },

  methods: (_methods = {
    handleOk: function handleOk(event) {
      event.preventDefault();

      this.deactivate_acc();
    },
    deactivate_acc: function deactivate_acc() {
      var _this = this;
      this.loading = true;
      var res = {
        status: false,
        locked: false
      };
      this.$http.post("/api/users/update", res).then(function (response) {
        if (response.status === 200) {
          alert("your account has been deactivated");
          _this.loading = false;
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      }).catch(function (error) {
        _this.loading = false;
        localStorage.clear();
        _this.$store.commit("SET_AUTH_USER", null);
        _this.$router.push("/");
      });
    },
    account_status: function account_status() {
      if (this.active_deactive === false) {
        this.active_deactive = true;
        this.deact_modal = true;
      }
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.shopuser();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.shopuser();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.shopuser();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.shopuser();
    },
    updateParamsShop: function updateParamsShop(newProps) {
      this.serverParamsShop = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.serverParamsShop, newProps);
    },
    onPageChangeShop: function onPageChangeShop(params) {
      this.updateParamsShop({ page: params.currentPage });
    },
    onPerPageChangeShop: function onPerPageChangeShop(params) {
      this.updateParamsShop({ perPage: params.currentPerPage, page: 1 });
    },
    onSortChangeShop: function onSortChangeShop(params) {
      this.updateParamsShop({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
    },
    onColumnFilterShop: function onColumnFilterShop(params) {
      this.updateParamsShop(params);
    },
    updateParamsRole: function updateParamsRole(newProps) {
      this.serverParamsRole = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()({}, this.serverParamsRole, newProps);
    },
    onPageChangeRole: function onPageChangeRole(params) {
      this.updateParamsRole({ page: params.currentPage });
      this.role();
    },
    onPerPageChangeRole: function onPerPageChangeRole(params) {
      this.updateParamsRole({ perPage: params.currentPerPage, page: 1 });
      this.role();
    },
    onSortChangeRole: function onSortChangeRole(params) {
      this.updateParamsRole({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.role();
    },
    onColumnFilterRole: function onColumnFilterRole(params) {
      this.updateParamsRole(params);
    },
    checkEmail: function checkEmail(email) {
      var _this = this;
      return this.$http.get("/api/users/" + email + "/exists").then(function (response) {
        return response.data.exists;
      }).catch(function (error) {
        return null;
      });
    },
    chkphone: function chkphone(phone) {
      var _this = this;
      return this.$http.get("/api/users/phone_exist/" + phone).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return true;
      });
    },
    onComplete: function onComplete(chk, val) {
      var _this2 = this;

      var _this = this;
      this.submit_true = 0;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var mobregex = /^[0-9]{10,15}$/;
      var passcheck = /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;
      var eregex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)[a-z0-9]{2,3}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

      if (val == "uname" || chk == "check") {
        if (this.user.name.length < 3) {
          if (!this.user.name) {
            this.hasErrors.usernm = "Required";
          } else {
            this.hasErrors.usernm = "Enter Minimum 3 Characters";
          }
          this.submit_true = 1;
        } else if (this.user.name.length > 100) {
          this.hasErrors.usernm = "Enter Minimum 3 Characters";
          this.submit_true = 1;
        } else {
          this.hasErrors.usernm = "";
        }
      }

      if (val == "utype" || chk == "check") {
        if (!this.usertype) {
          this.errorMessage.usertypeerr = "Required";
          this.submit_true = 1;
        } else {
          this.errorMessage.usertypeerr = "";
        }
      }

      if (val == "psw" || chk == "check") {
        if (passcheck.test(this.user.pass) == false) {
          if (!this.user.pass) {
            this.hasErrors.password = "Required";
          } else {
            this.hasErrors.password = "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
          }
          this.submit_true = 1;
        } else {
          this.hasErrors.password = "";
        }
      }

      if (val == "eml" || chk == "check") {
        if (eregex.test(this.user.email) == false) {
          if (!this.user.email) {
            this.hasErrors.usereml = "Required";
          } else {
            this.hasErrors.usereml = "Enter valid email";
          }
          this.submit_true = 1;
        } else if (this.user.email.length > 70) {
          this.hasErrors.usereml = "Maximum 70 characters";
        } else {
          this.hasErrors.usereml = "";
        }
      }

      if (val == "phn" || chk == "check") {
        if (!this.user.phone) {
          this.hasErrors.userph = "Required";
          this.submit_true = 1;
        } else if (mobregex.test(this.user.phone) == false) {
          this.hasErrors.userph = "Invalid Contact number";
          this.submit_true = 1;
        } else {
          if (this.updateedit == 0) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.chkphone(this.user.phone)]).then(function (user) {
              if (user[0] == true) {
                _this2.hasErrors.userph = "This Number Alerady Exist";
                _this2.submit_true = 1;
              } else {
                _this2.hasErrors.userph = "";
              }
            });
          } else {
            if (this.user.phone !== this.temprow.phonenumber) {
              __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.chkphone(this.user.phone)]).then(function (user) {
                if (user[0] == true) {
                  _this2.hasErrors.userph = "This Number Alerady Exist";
                  _this2.submit_true = 1;
                } else {
                  _this2.hasErrors.userph = "";
                }
              });
            }
          }
        }
      }

      if (val == "cnfpsw" || chk == "check") {
        if (this.user.conf == "") {
          this.hasErrors.confpassword = "Required";
          this.submit_true = 1;
        } else if (this.user.pass != this.user.conf) {
          this.hasErrors.confpassword = "Password & ConfirmPassword Does Not Match";
          this.submit_true = 1;
        } else {
          this.hasErrors.confpassword = "";
        }
      }

      if (chk == "check") {
        if (this.shopList.length == 0) {
          this.errorMessage.usershop = "Please Provide Shop";
          this.submit_true = 1;
        } else {
          this.errorMessage.usershop = "";
        }

        if (this.roleList === null || this.roleList == "") {
          this.errorMessage.userrole = "Please Provide Role";
          this.submit_true = 1;
        } else {
          this.errorMessage.userrole = "";
        }
      }
    },
    selectedShops: function selectedShops(shop) {
      this.deletedshops = [];
      var a = [];
      var b = [];
      var c = [];
      for (var i = 0; i < this.rowsadj.length; i++) {
        a.push(this.rowsadj[i].est_shop_id);
      }

      var len = shop.selectedRows.length;
      var _this = this;
      this.shopList = [];
      for (var i = 0; i < len; i++) {
        var temp = shop.selectedRows[i];
        _this.shopList.push(temp.est_shop_id);
        b.push(temp.est_shop_id);
      }

      for (var i = 0; i < a.length; i++) {
        var ind = b.indexOf(a[i]);
        if (ind == -1) {
          c.push(a[i]);
        }
      }

      this.deletedshops = c;
    },
    selectedRoles: function selectedRoles(role) {
      for (var i = 0; i < this.rows1.length; i++) {
        this.$set(this.rows1[i], "vgtSelected", false);
        if (this.rows1[i].role_id == role.row.role_id) {
          this.$set(this.rows1[i], "vgtSelected", true);
        }
      }

      this.roleList = role.row.role_id;
    },
    reset: function reset() {
      this.items = [];
    },
    selectFromParentComponent: function selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
    },
    addusers: function addusers() {
      var _this = this;
      this.loading = true;
      this.$http.get("/api/users/chk_plan_count").then(function (response) {
        _this.loading = false;
        if ("message" in response.data) {
          if (response.data.message === false) {
            var x = document.getElementsByClassName("vgt-checkbox-col");
            for (var i = 0; i < x.length; i++) {
              x[i].style.width = "0.1%";
            }
            _this.hasErrors.usernm = "";
            _this.hasErrors.useradd = "";
            _this.hasErrors.userpin = "";
            _this.hasErrors.usereml = "";
            _this.hasErrors.userph = "";
            _this.hasErrors.password = "";
            _this.hasErrors.confpassword = "";
            _this.errorMessage.usershop = "";
            _this.errorMessage.usertypeerr = "";
            _this.errorMessage.userrole = "";
            _this.user.name = "";
            _this.user.email = "";
            _this.user.phone = "";
            _this.user.pass = "";
            _this.user.conf = "";
            _this.updateedit = 0;
            _this.checkbox = 1;
            _this.shopid = null;
            _this.address = "";
            _this.shopList = null;
            _this.roleList = null;
            _this.deletedshops = [];
            _this.updateedit = 0;
            _this.editid = null;
            _this.hasErrors.message = false;
            _this.errorMessage.message = null;
            _this.usertype = "3";
            _this.temprow = null;
            for (var k = 0; k < _this.rowsadj.length; k++) {
              _this.$set(_this.rowsadj[k], "vgtSelected", false);
            }
            for (var k = 0; k < _this.rows1.length; k++) {
              _this.$set(_this.rows1[k], "vgtSelected", false);
            }
            _this.plan_modal = false;
            _this.largeModal = true;
          } else {
            _this.plan_modal = true;
          }
        } else {
          console.log("something went wrong");
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    shopest: function shopest(val) {
      if (val === "comp") {
        if (this.estfrst_time === false) {
          this.estfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopestablishments/find_user_shop").then(function (response) {
        _this.tempshpList = response.data;
        _this.rowsadj = response.data;
        _this.shopidopt1 = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    role: function role(val) {
      if (val === "comp") {
        if (this.rfrst_time === false) {
          this.rfrst_time = true;
        } else {
          return false;
        }
      }
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParamsRole.page;
      filteParam.perPage = this.serverParamsRole.perPage;
      filteParam.sort = this.serverParamsRole.sort;
      this.$http.get("/api/roletbs?params=" + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        if (response.data != undefined) {
          _this.totalRecordsRoles = response.data[0].totalRecords;
          response.data.shift();
          _this.rows1 = response.data;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    shopuser: function shopuser(val) {
      var _this = this;
      this.allUser = [];

      var filteParam = {};

      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }

      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = [];
      var supname = this.user.names;
      supname = supname.split(" ").join("_");
      if (this.user.names != "") {
        data = data + "&filter[where][user_name][ilike]=%" + supname + "%";
      }
      if (this.user.email1 != "") {
        data = data + "&filter[where][user_email][ilike]=%" + this.user.email1 + "%";
      }
      if (this.shopids != null) {
        data = data + "&filter[where][est_shop_id]=" + this.shopids.est_shop_id;
      }
      this.loading = true;
      this.$http.get("/api/shopusers/getShopUser?params=" + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.allUser = response.data;
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) {
          _this.rows.length = 0;
          _this.rows = response.data;
        }

        _this.loading = false;
      }).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    editpro: function editpro(row) {
      this.temprow = row;
      this.roleList = null;
      for (var k = 0; k < this.rowsadj.length; k++) {
        this.$set(this.rowsadj[k], "vgtSelected", false);
      }
      for (var k = 0; k < this.rows1.length; k++) {
        this.$set(this.rows1[k], "vgtSelected", false);
      }

      var x = document.getElementsByClassName("vgt-checkbox-col");
      for (var i = 0; i < x.length; i++) {
        x[i].style.width = "0.1%";
      }
      if (row.est_user_type == "1") {
        this.isSuperAdmin = true;
      } else {
        this.isSuperAdmin = false;
      }
      this.user.name = row.user_name;
      this.user.email = row.user_email;
      this.user.phone = row.phonenumber;
      this.usertype = 3;
      this.user.pass = row.password;
      this.user.conf = row.password;
      this.checkbox = row.status;
      this.updateedit = 1;
      this.editid = row.user_email;
      this.hasErrors.message = false;
      this.errorMessage.message = null;
      var _this = this;
      _this.hasErrors.usernm = "";
      _this.hasErrors.useradd = "";
      _this.hasErrors.userpin = "";
      _this.hasErrors.usereml = "";
      _this.hasErrors.userph = "";
      _this.hasErrors.password = "";
      _this.hasErrors.confpassword = "";
      _this.errorMessage.usershop = "";
      _this.errorMessage.usertypeerr = "";
      _this.errorMessage.userrole = "";
      var temp = row.user_email;

      var temparr = [];
      var temprole = [];

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.setUserShop(row.user_email), this.setUserRole(row.user_email)]).then(function (ret_val) {
        _this.largeModal = true;
      });
    },
    setUserShop: function setUserShop(email) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get("/api/shopusers?filter[where][est_user_id]=" + email).then(function (response) {
                  _this.beforeShops.length = 0;

                  for (var i = 0; i < response.data.length; i++) {
                    _this.shopList.push(response.data[i].est_shop_id);
                    _this.beforeShops.push(response.data[i].est_shop_id);
                  }

                  for (var k = 0; k < _this.rowsadj.length; k++) {
                    for (var j = 0; j < response.data.length; j++) {
                      if (_this.rowsadj[k].est_shop_id == response.data[j].est_shop_id) {
                        _this.$set(_this.rowsadj[k], "vgtSelected", true);
                      }
                    }
                  }

                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true);
                }).catch(function (err) {
                  console.log(err);
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    setUserRole: function setUserRole(email) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this4;

                _this4.$http.get("/api/userroles?filter[where][est_user_id]=" + email).then(function (response) {
                  _this.roleList = response.data[0].role_id;
                  for (var k = 0; k < _this.rows1.length; k++) {
                    if (_this.rows1[k].role_id == response.data[0].role_id) {
                      _this.$set(_this.rows1[k], "vgtSelected", true);
                      break;
                    }
                  }
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true);
                }).catch(function (err) {
                  console.log(err);
                  return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    Submit: function Submit() {
      var _this5 = this;

      var _this = this;
      var ch = 156;
      this.onComplete("check", "false");
      if (this.submit_true == 0) {
        this.loading = true;
        var user = {
          checkbox: this.checkbox,
          usertype: this.usertype,
          username: this.user.name,
          email: this.user.email,
          password: this.user.pass,
          phone: this.user.phone,
          est_shop_id: this.shopList,
          roleList: this.roleList,
          update: this.updateedit,
          deletedshops: this.deletedshops,
          isAdmin: this.isAdmin,
          isSuperAdmin: this.isSuperAdmin,
          beforeShops: this.beforeShops
        };
        if (this.updateedit === 0) {
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.checkEmail(_this.user.email)]).then(function (user1) {
            if (user1[0] == true) {
              _this5.loading = false;
              _this5.hasErrors.usereml = "Email Already Exist";
            } else if (user1[0] == 0) {
              _this5.$http.post("/api/users/insertuser", user).then(function (response) {
                _this.loading = false;
                _this.reset();
                _this.hasErrors.message = true;
                _this.errorMessage.message = "User Added Successfully";
                _this.shopuser();
                _this.largeModal = false;
                setTimeout(function () {
                  _this.hasErrors.message = false;
                  _this.errorMessage.message = null;
                }, 6000);
              }).catch(function (error) {
                _this.loading = false;
                _this.hasErrors.message = true;
                setTimeout(function () {
                  _this.hasErrors.message = false;
                  _this.errorMessage.message = null;
                }, 6000);
              });
            } else {}
          });
        } else {
          this.$http.post("/api/users/insertuser", user).then(function (response) {
            if (response.data.status == 444) {
              var data1 = "User is admin in ";
              var shp = response.data.data;
              var data = [];
              for (var i = 0; i < _this.rowsadj.length; i++) {
                data.push({
                  Name: _this.rowsadj[i].est_shop_name,
                  Value: _this.rowsadj[i].est_shop_id
                });
              }
              for (var i = 0; i < shp.length; i++) {
                var valObj = data.filter(function (elem) {
                  if (elem.Value == shp[i]) {
                    data1 = data1 + " " + elem.Name + ",";
                  }
                });
              }
              _this.loading = false;
              _this.hasErrors.err_message = true;
              _this.errorMessage.err_message = data1;
              setTimeout(function () {
                _this.hasErrors.err_message = false;
                _this.errorMessage.err_message = null;
              }, 15000);
            } else {
              _this.loading = false;
              _this.reset();
              _this.hasErrors.message = true;
              _this.updateedit = 0;
              _this.errorMessage.message = "User Updated Successfully";
              _this.shopuser();
              _this.largeModal = false;
              setTimeout(function () {
                _this.hasErrors.message = false;
                _this.errorMessage.message = null;
              }, 6000);
            }
          }).catch(function (error) {
            _this.loading = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = error.response.data.error.message;
            setTimeout(function () {
              _this.hasErrors.message = false;
              _this.errorMessage.message = null;
            }, 6000);
          });
        }
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "reset", function reset() {
    var _this = this;
    for (var k = 0; k < _this.rowsadj.length; k++) {
      _this.$set(_this.rowsadj[k], "vgtSelected", false);
    }
    for (var k = 0; k < _this.rows1.length; k++) {
      _this.$set(_this.rows1[k], "vgtSelected", false);
    }
    _this.hasErrors.usernm = "";
    _this.hasErrors.useradd = "";
    _this.hasErrors.userpin = "";
    _this.hasErrors.usereml = "";
    _this.hasErrors.userph = "";
    _this.hasErrors.password = "";
    _this.errorMessage.usershop = null;
    _this.errorMessage.usertypeerr = null;
    _this.usertype = "";
    _this.user.name = "";
    _this.shopid = null;
    _this.user.address = "";
    _this.user.pincode = "";
    _this.user.email = "";
    _this.user.pass = "";
    _this.user.phone = "";
    _this.user.conf = "";
    _this.roleList = null;
    _this.shopList = [];
    _this.temprow = null;
    _this.beforeShops = [];
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "deleteshoplist", function deleteshoplist(shopid) {
    var _this = this;
    var id = shopid.id;
    this.$http.delete("/api/shopusers/" + id).then(function (response) {
      _this.shopuser();
    }).catch(function (error) {
      console.log(error);
    });
  }), _methods)
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard_dist_vue_form_wizard_min_css__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "help2",
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"]
  },
  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    download_manual: function download_manual() {
      var _this = this;
      var access_token = localStorage.getItem("authUser");
      this.loading = true;
      var url1 = _this.baseURL2 + "/api/containers/common/download/I2OC_User_Manual.pdf?access_token=" + access_token;
      _this.$http({
        url: url1,
        method: "GET",
        responseType: "blob"
      }).then(function (res) {
        _this.loading = false;
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.setAttribute("download", "I2OC_User_Manual.pdf");
        link.href = url1;
        document.body.appendChild(link);
        link.click();
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_0__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      columnsadj: [{
        label: 'Sales ID',
        field: 'sale_id',
        width: '10% !important'
      }, {
        label: 'Product Name',
        field: 'productname',
        width: '30% !important'
      }, {
        label: 'Variant',
        field: 'variant',
        width: '15% !important'
      }, {
        label: 'Qty',
        field: 'qty',
        width: '5% !important'
      }, {
        label: 'Amount Per Unit',
        field: 'amount',
        width: '20% !important'
      }, {
        label: 'Date',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DD',
        dateOutputFormat: 'MMM Do YY',
        width: '20% !important'
      }],
      disabled: 0,
      amt_rec: '',
      chequeno_validate: '',
      chequedate_validate: '',
      rowsadj: [],
      current_index: null,
      is_cs_gst: true,
      is_i_gst: true,
      Adjustment: false,
      loading: false,
      variantindex: null,
      smallmodal: false,
      plan_modal: false,
      shopplan_modal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,

      bal: 0,
      totalamtreceived: '',
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      selected_pytype: 'full',
      lst_paymenttype: [{ value: 'full', text: 'Full' }, { value: 'partial', text: 'Partial' }, { value: 'no', text: 'No' }],
      selected_pymode: 'cash',
      selectedcustomer: null,
      company_gst: '',
      supplier_gst: '',
      variantdata: null,
      batchmd: '',
      serialmd: '',
      percentagemd: '',
      amtmd: '',
      salepricemd: 0,
      inclusive: false,
      indexval: null,
      largeModal: false,
      suppliername: [],
      prod_lst: [],
      barcodelist: [],
      barcode: '',
      shopname: [],
      selectshop: null,
      rows: [],

      haserror: {
        amt: '',
        dis: '',
        cust: '',
        message: '',
        message1: '',
        inclusive: '',
        saleprice: '',
        shop: ''
      },
      detail: {
        totprddis: '',
        addition: '',
        tot: '',
        cgst: '',
        sgst: '',
        igst: '',
        taxamt: '',
        totalamtpay: ''
      }
    };
  },


  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },

    sup_rights: function sup_rights() {
      return this.$store.getters.get_sup_rights;
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totaligst: function totaligst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.igst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.salestax = all;
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == '') {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        this.totalamtreceived = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    for (var i = 0; i < 3; i++) {
      this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: '', err_saleprice: '', is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', showvariant: false, novariant: false, productExist: '' });
    }
    this.searchshops();
    this.searchsupplier();

    this.shopuser();
  },


  methods: {
    addSupplier: function addSupplier() {
      var _thiss = this;
      this.loading = true;
      this.$http.get('/api/suppliers/chk_plan_count').then(function (response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true;
          } else {
            _thiss.plan_modal = false;
            var params = {};
            var _this = _thiss;
            _thiss.$http.get('/api/countries').then(function (countries) {
              params["conopt"] = countries.data;
              var __this = _this;
              _this.$http.get('/api/companytypes').then(function (response) {
                params["contyp"] = response.data;
                __this.$addsuppliermodal.showSupplier(params);
                var ___this = __this;
                var timer = setInterval(function () {
                  var modal_return = ___this.$store.getters.get_supmodal;
                  if (modal_return !== null) {
                    ___this.suppliername.push(modal_return);
                    ___this.selectedcustomer = modal_return;
                    clearInterval(timer);
                  }
                }, 1000);
              }).catch(function (err) {
                console.log(err);
              });
            }).catch(function (error) {
              console.log(error);
            });
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    addProduct: function addProduct(row, index) {
      var _thiss = this;
      this.loading = true;
      this.$http.get('/api/companyproducts/chk_plan_count').then(function (response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true;
          } else {
            _thiss.plan_modal = false;
            if (_thiss.selectedcustomer == null || _thiss.selectedcustomer.supplier_id === undefined) {
              _thiss.haserror.cust = "Please Select Supplier";
            } else {
              _thiss.haserror.cust = "";
              var _this = _thiss;
              _thiss.$http.get('/api/companyproducts/loadData').then(function (response) {
                if (response.data.data) {
                  _this.$addproductmodal.show(response.data.data);
                  var __this = _this;
                  var timer = setInterval(function () {
                    var modal_return = __this.$store.getters.get_productmodal;
                    if (modal_return !== null) {
                      row.productnamex.push(modal_return);
                      row.selectproductrow = modal_return;
                      __this.openvariant(row, index);
                      clearInterval(timer);
                    }
                  }, 1000);
                }
              }).catch(function (error) {
                if (error.response.status === 401) {
                  localStorage.clear();
                  _this.$store.commit('SET_AUTH_USER', null);
                  _this.$router.push('/');
                }
                if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
                  localStorage.clear();
                  _this.$store.commit('SET_AUTH_USER', null);
                  _this.$router.push('/');
                }
              });
            }
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    addShop: function addShop() {
      var _thiss = this;
      _thiss.loading = true;
      _thiss.$http.get('/api/shopestablishments/chk_plan_count').then(function (response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true;
          } else {
            var params = {};
            _thiss.$http.get('/api/countries').then(function (countries) {
              params['countries'] = countries.data;
              var __this = _thiss;
              _this.$http.get('/api/users/allusers').then(function (alluser) {
                params['alluser'] = alluser.data;
                __this.$addshopmodal.showShop(params);
                var ___this = __this;
                var timer = setInterval(function () {
                  var modal_return = ___this.$store.getters.get_shopmodal;
                  if (modal_return !== null) {
                    ___this.searchshops(modal_return);
                    clearInterval(timer);
                  }
                }, 1000);
              }).catch(function (error) {
                console.log("error - " + error);
              });
            }).catch(function (error) {
              console.log("error - " + error);
            });
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalparamtreceived = '';
          return;
        } else {
          this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === 'full') {
        this.fullpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    checkVariant: function checkVariant(index) {
      if (this.variantdata == null) {
        this.rows[index].adjustment_list = [];
        this.rows[index].adjusted = [];

        this.rows[index].selectedproductid = null;
        this.rows[index].unit = '';
        this.rows[index].selectproductrow = null;
        this.rows[index].price = '';
        this.rows[index].qty = '';
        this.rows[index].amt = '';
        this.rows[index].cgst = 0;
        this.rows[index].sgst = 0;
        this.rows[index].igst = '';
        this.rows[index].batchmd1 = '';
        this.rows[index].serialmd1 = '';
        this.rows[index].is_adjustment = false;
        this.rows[index].amttotal = 0;
        this.rows[index].percentagemd1 = '';
        this.rows[index].amtmd1 = '';
        this.rows[index].variantrow = 'n/a';
        this.rows[index].unitvalue = '';
        this.rows[index].novariant = false;
        this.rows[index].showvariant = false;
        this.rows[index].inclusive1 = false;
        this.rows[index].err_qty = '';
        this.rows[index].err_price = '';
        this.rows[index].err_sgst = '';
        this.rows[index].err_cgst = '';
        this.rows[index].err_igst = '';
        this.rows[index].productExist = '';
      }
    },
    checkShop: function checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Supplier";
        this.barcode = '';
      } else {
        this.haserror.cust = '';
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = '';
      } else {
        this.haserror.shop = '';
      }
    },
    searchBarcode: function searchBarcode() {
      var _this = this;

      var option = [];
      var index = 0;
      var addRow = 0;
      var barcode = this.barcode;

      this.checkShop();

      this.barcode = '';
      if (barcode) {

        this.$http.get('/api/purchasereturns/joinproduct2?barcode=' + barcode).then(function (response) {

          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {

            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });
          if (response.data[0] != null) {

            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: '', err_saleprice: '', is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', showvariant: false, novariant: false, productExist: '' });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];
            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log('error');
        });
      } else {}
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.sup_cmp_name + ' - ' + item.sup_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    onSelectAdjustment: function onSelectAdjustment(index, row) {
      this.current_index = null;
      this.current_index = index;
      this.haserror.message1 = '';
      this.disabled = 0;
      this.Adjustment = true;
      this.rowsadj = [];

      for (var i = 0; i < row.adjustment_list.length; i++) {
        if (row.adjusted.length > 0) {
          var vgtSelected = false;
          for (var j = 0; j < row.adjusted.length; j++) {
            if (row.adjusted[j] == row.adjustment_list[i].saleadjustment_id) {
              var vgtSelected = true;
            }
          }
          this.rowsadj.push({ sale_id: row.adjustment_list[i].saleadjustment_id, productname: row.adjustment_list[i].product_id, variant: row.adjustment_list[i].variant_id, qty: row.adjustment_list[i].adjusted_qty, amount: row.adjustment_list[i].sale_amount, createdAt: row.adjustment_list[i].lastupdated_datetime, vgtSelected: vgtSelected });
        } else {
          this.rowsadj.push({ sale_id: row.adjustment_list[i].saleadjustment_id, productname: row.adjustment_list[i].product_id, variant: row.adjustment_list[i].variant_id, qty: row.adjustment_list[i].adjusted_qty, amount: row.adjustment_list[i].sale_amount, createdAt: row.adjustment_list[i].lastupdated_datetime, vgtSelected: false });
        }
      }
      this.checking_adjustment();
    },
    save_adjustment: function save_adjustment() {
      this.rows[this.current_index].adjusted = [];
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i]['vgtSelected'] == true) {
          this.rows[this.current_index].adjusted.push(this.rowsadj[i]['sale_id']);
        }
      }
      this.Adjustment = false;
    },
    selectAll: function selectAll(selected, selectedRows) {
      if (selected.selectedRows.length === 0) {
        var vgtSelected = false;
      } else {
        var vgtSelected = true;
      }

      for (var i = 0; i < this.rowsadj.length; i++) {
        this.rowsadj[i]['vgtSelected'] = vgtSelected;
      }
      this.checking_adjustment();
    },
    toggleSelectRow: function toggleSelectRow(params) {
      this.rowsadj[params.row.originalIndex]['vgtSelected'] = params.row.vgtSelected;
      this.checking_adjustment();
    },
    checking_adjustment: function checking_adjustment() {
      var row_qty = this.rows[this.current_index]['qty'];
      var adj_qty = 0;
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i].vgtSelected) {
          adj_qty += parseFloat(this.rowsadj[i].qty);
        }
      }
      if (adj_qty > row_qty) {
        this.disabled = 1;
        this.haserror.message1 = 'Adjustment Quantity Cannot Be Greater Than Purchase Quantity';
      } else {
        this.disabled = 0;
        this.haserror.message1 = '';
      }
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    onSelectShp: function onSelectShp(option) {
      this.selectshop = option;

      this.haserror.shop = '';
      this.company_data();
      if (this.selectedcustomer !== null && this.selectedcustomer !== undefined) this.onSelectSup(this.selectedcustomer);
      if (option.id != undefined) {
        if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
          this.haserror.shop = "Please Select Shop";
        }
      } else {
        this.haserror.shop = "Please Select Shop";
      }
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.sale_adjustment(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    onSelectSup: function onSelectSup(option) {
      this.is_cs_gst = true;
      this.is_i_gst = true;

      if (option.sup_cmp_gst !== undefined) {
        this.haserror.cust = '';
        this.supplier_gst = option.sup_cmp_gst;
      }
      if (this.company_gst && this.supplier_gst) {

        var company_gst = this.company_gst.substring(0, 2);
        var supplier_gst = this.supplier_gst.substring(0, 2);
        if (company_gst === supplier_gst) {

          this.is_cs_gst = true;
          this.is_i_gst = false;
        } else {

          this.is_cs_gst = false;
          this.is_i_gst = true;
        }
      } else if (this.supplier_gst === null || this.supplier_gst === '') {

        this.is_cs_gst = false;
        this.is_i_gst = false;
      } else {

        this.is_cs_gst = true;
        this.is_i_gst = true;
      }

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.show_tax(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    onSelectvariant: function onSelectvariant(option) {
      if (option.variant_value === 'No Variant') {
        this.rows[this.variantindex]['variantrow'] = 'n/a';
      } else {
        this.rows[this.variantindex]['variantrow'] = option.variant_value;
      }
      this.smallmodal = false;

      var row = this.rows[this.variantindex].selectproductrow;
      this.sale_adjustment(row, this.variantindex);
      this.onSelect(row, this.variantindex);
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(row, index) {
      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id;

      if (vrnt_id != null) {
        this.rows[this.variantindex].novariant = true;
        this.rows[this.variantindex].showvariant = false;
        this.smallmodal = true;

        this.$http.get('/api/variantvalues?filter[where][variant_id]=' + vrnt_id).then(function (response) {
          _this.variantvalue = response.data;
          _this.variantvalue.unshift({ company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant" });
        }).catch(function (error) {});
      } else {
        this.rows[this.variantindex].novariant = true;
        this.rows[this.variantindex].showvariant = false;
        var option = { company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant" };
        this.onSelectvariant(option);
        this.smallmodal = false;
      }
    },
    sale_adjustment: function sale_adjustment(option, index) {
      var _this = this;
      this.$http.get('/api/salesadjustments?filter[where][est_shop_id]=' + _this.selectshop.est_shop_id + '&filter[where][product_id]=' + option.product_id + '&filter[where][variant_id]=' + _this.rows[index]['variantrow']).then(function (response) {
        if (response.data.length > 0) {
          _this.rows[index]['adjustment_list'] = response.data;
          _this.rows[index]['is_adjustment'] = true;
        } else {
          _this.rows[index]['adjustment_list'] = [];
          _this.rows[index]['is_adjustment'] = false;
          _this.rows[index]['adjusted'] = [];
        }
      }).catch(function (error) {});
      this.onSelect(option, index);
    },
    show_tax: function show_tax(option, index) {
      var _this = this;
      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + option.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.supplier_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var supplier_gst = _this.supplier_gst.substring(0, 2);

          if (company_gst === supplier_gst) {
            _this.rows[index]['cgst'] = response.data.tax_cgst;
            _this.rows[index]['sgst'] = response.data.tax_sgst;
            _this.rows[index]['igst'] = 0.00;
          } else {
            _this.rows[index]['cgst'] = 0.00;
            _this.rows[index]['sgst'] = 0.00;
            _this.rows[index]['igst'] = response.data.tax_igst;
          }
          _this.price(index);
        } else if (_this.supplier_gst === null || _this.supplier_gst === '') {
          _this.rows[index]['cgst'] = 0.00;
          _this.rows[index]['sgst'] = 0.00;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        } else {
          _this.rows[index]['cgst'] = response.data.tax_cgst;
          _this.rows[index]['sgst'] = response.data.tax_sgst;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        }
      });
    },
    onSelect: function onSelect(option, index) {
      var _this = this;
      _this.rows[index]['inclusive1'] = false;
      _this.current_index = null;
      if (option != null) {
        if (option.alt_product_id !== undefined) {
          _this.show_tax(option, index);

          _this.rows[index]['qty'] = 1;
          _this.rows[index]['unit'] = option.unit_name;
          _this.rows[index]['unitvalue'] = option.unit_id;

          _this.rows[index]['adjustment_list'] = [];
          _this.rows[index]['adjusted'] = [];
          _this.rows[index]['price'] = '';
        } else {
          _this.rows[index]['selectedproductid'] = '';
          _this.rows[index]['unit'] = '';
          _this.rows[index]['unitvalue'] = '';
          _this.rows[index]['selectproductrow'] = null;
          _this.rows[index]['price'] = '';
          _this.rows[index]['qty'] = '';
          _this.rows[index]['amt'] = '';
          _this.rows[index]['cgst'] = 0;
          _this.rows[index]['sgst'] = 0;
          _this.rows[index]['igst'] = '';
          _this.rows[index]['amttotal'] = 0;
          _this.rows[index]['batchmd1'] = '';
          _this.rows[index]['serialmd1'] = '';
          _this.rows[index]['percentagemd1'] = '';
          _this.rows[index]['amtmd1'] = '';
          _this.rows[index]['variantrow'] = 'n/a';
          _this.rows[index]['inclusive1'] = false;
          _this.rows[index]['salepricemd1'] = 0;
          _this.rows[index]['adjustment_list'] = [];
          _this.rows[index]['adjusted'] = [];
          _this.rows[index].showvariant = false;
          _this.rows[index].novariant = false;
        }
      } else {
        _this.rows[index]['selectedproductid'] = '';
        _this.rows[index]['unit'] = '';
        _this.rows[index]['unitvalue'] = '';
        _this.rows[index]['selectproductrow'] = null;
        _this.rows[index]['price'] = '';
        _this.rows[index]['qty'] = '';
        _this.rows[index]['amt'] = '';
        _this.rows[index]['cgst'] = 0;
        _this.rows[index]['sgst'] = 0;
        _this.rows[index]['igst'] = '';
        _this.rows[index]['amttotal'] = 0;
        _this.rows[index]['batchmd1'] = '';
        _this.rows[index]['serialmd1'] = '';
        _this.rows[index]['percentagemd1'] = '';
        _this.rows[index]['amtmd1'] = '';
        _this.rows[index]['variantrow'] = 'n/a';
        _this.rows[index]['inclusive1'] = false;
        _this.rows[index]['salepricemd1'] = 0;
        _this.rows[index]['adjustment_list'] = [];
        _this.rows[index]['adjusted'] = [];
      }
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.batchmd = '';
      this.serialmd = '';
      this.percentagemd = '';
      this.amtmd = '';
      this.salepricemd = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
      this.salepricemd = this.rows[test].salepricemd1;
    },
    addRow1: function addRow1() {
      this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: '', err_saleprice: '', is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', showvariant: false, novariant: false, productExist: '' });
    },


    removeElement: function removeElement(index) {
      this.rows.splice(index, 1);
      if (this.selected_pytype === 'partial') {
        this.bal = 0.0000;
        this.totalparamtreceived = '';
      }
    },

    searchshops: function searchshops(shop_id) {
      var _this = this;
      this.$http.get('/api/shopusers/getShop').then(function (response) {
        _this.shopname = response.data;
        if (shop_id !== undefined) {
          var select_shp = _this.shopname.filter(function (each) {
            return each.est_shop_id === shop_id;
          });
          _this.selectshop = select_shp[0];
          _this.company_data();
        } else {
          var len = response.data.length - 1;
          _this.selectshop = response.data[len];
          _this.company_data();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    searchprd3: function searchprd3(searchText, index, row) {
      this.haserror.cust = '';
      this.haserror.shop = '';
      var status = 1;
      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Supplier";
      }
      if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }

      if (status == 1) {
        var _this = this;
        if (searchText) {
          this.$http.get('/api/purchasereturns/joinproduct2?data=' + searchText).then(function (response) {
            row.productnamex = response.data;
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    searchsupplier: function searchsupplier() {
      var _this = this;
      this.$http.get('/api/suppliers').then(function (response) {
        _this.suppliername = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
      this.haserror.amt = '';
      this.haserror.dis = '';
      if (this.percentagemd != '' && this.amtmd != '') {
        this.haserror.amt = "Please Select Any One";
      } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Valid Amount";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]['batchmd1'] = this.batchmd;
        this.rows[val]['serialmd1'] = this.serialmd;
        this.rows[val]['percentagemd1'] = this.percentagemd;
        this.rows[val]['amtmd1'] = this.amtmd;
        this.rows[val]['inclusive1'] = this.inclusive;
        this.rows[val]['salepricemd1'] = this.salepricemd;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition !== '') {
        this.detail.addition = '';
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if (parseFloat(this.detail.totalamtpay) < 0) {
        this.detail.addition = '';
        alert("Invalid Entry");
      }
      if (this.selected_pytype === 'partial') {
        if (this.totalparamtreceived !== '') {
          this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
        }
      }
    },
    price: function price(index) {

      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      if (igstexp.test(this.rows[index]['igst']) == false && this.rows[index]['igst'] != '') {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['igst']) < 0) {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else {
        this.rows[index]['err_igst'] = '';
      }

      if (tax.test(this.rows[index]['cgst']) == false && this.rows[index]['cgst'] != 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['cgst']) < 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else {
        this.rows[index]['err_cgst'] = '';
      }

      if (tax.test(this.rows[index]['sgst']) == false && this.rows[index]['sgst'] != 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['sgst']) < 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else {
        this.rows[index]['err_sgst'] = '';
      }

      if (this.rows[index]['price'] == '') {
        this.rows[index]['err_price'] = 'Required';
      } else if (parseFloat(this.rows[index]['price']) <= 0.00) {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else if (price.test(this.rows[index]['price']) == false && this.rows[index]['price'] != '') {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else {
        this.rows[index]['err_price'] = '';
        this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4);
      }

      if (this.rows[index]['qty'] == '') {
        this.rows[index]['err_qty'] = 'Required';
      } else if (parseFloat(this.rows[index]['qty']) <= 0.00) {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (price.test(this.rows[index]['qty']) == false && this.rows[index]['qty'] != '') {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else {
        this.rows[index]['err_qty'] = '';
      }

      if (this.rows[index]['igst'] != '' && this.companyTaxType !== 'US') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['sgst'] = 0;
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else if (this.rows[index]['igst'] != '' && this.companyTaxType === 'US') {
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else {
        this.rows[index]['igst'] = '';
        var igst_value = 0;
      }

      if (this.rows[index]['qty'] != '' && this.rows[index]['price'] != '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] == '') {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] != '' && this.rows[index]['price'] == '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] != '') {
        var qty = 0;
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      }

      if (this.rows[index]['percentagemd1'] != '') {
        total = total - total * this.rows[index]['percentagemd1'] / 100;
      }
      if (this.rows[index]['amtmd1'] != '') {
        total = total - parseFloat(this.rows[index]['amtmd1']);
      }

      if (total != undefined) {
        if (this.rows[index]['inclusive1'] == false) {
          this.rows[index]['amt'] = total.toFixed(4);

          var amttotal;
          if (this.companyTaxType === 'US') {
            amttotal = total + igst_value * total / 100;
          } else {
            amttotal = total + this.rows[index]['sgst'] * total / 100 + this.rows[index]['cgst'] * total / 100 + igst_value * total / 100;
          }
          amttotal = amttotal.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
        } else if (this.rows[index]['inclusive1'] == true) {
          amttotal = total.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
          var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]['amt'] = bfttotal.toFixed(4);
        }
      }

      if (this.selected_pytype === 'partial') {
        this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
      } else if (this.selected_pytype === 'full') {
        this.totalamtreceived = parseFloat(this.totalamtpay).toFixed(4);
      }
    },
    updateSalesTax: function updateSalesTax(index) {
      var salesTax = parseFloat(this.rows[index]['sales_tax']) || 0;

      var taxMode = this.companyTaxType || 'IN';

      if (taxMode === 'IN') {
        this.price(index);
        return;
      }

      var company_gst = this.company_gst ? this.company_gst.substring(0, 2) : '';
      var supplier_gst = this.supplier_gst ? this.supplier_gst.substring(0, 2) : '';

      if (this.companyTaxType === 'US') {
        var splitTax = salesTax / 2;
        this.rows[index]['cgst'] = splitTax;
        this.rows[index]['sgst'] = splitTax;
        this.rows[index]['igst'] = salesTax;
      } else if (company_gst && supplier_gst && company_gst === supplier_gst) {
          var splitTax = salesTax / 2;
          this.rows[index]['cgst'] = splitTax;
          this.rows[index]['sgst'] = splitTax;
          this.rows[index]['igst'] = 0;
        } else if (company_gst && supplier_gst && company_gst !== supplier_gst) {
            this.rows[index]['cgst'] = 0;
            this.rows[index]['sgst'] = 0;
            this.rows[index]['igst'] = salesTax;
          } else {
              var splitTax = salesTax / 2;
              this.rows[index]['cgst'] = splitTax;
              this.rows[index]['sgst'] = splitTax;
              this.rows[index]['igst'] = 0;
            }

      this.price(index);
    },
    finalsubmit: function finalsubmit() {
      this.haserror.message = '';
      this.haserror.cust = '';
      this.haserror.shop = '';
      var submit = 0;
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      for (var i = this.rows.length - 1; i >= 0; i--) {

        if (this.rows[i].selectproductrow != null) {

          if (this.rows[i].price == '') {
            submit = 1;
            this.rows[i].err_price = 'Required';
          } else if (parseFloat(this.rows[i].price) <= 0) {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          } else if (price.test(this.rows[i].price) == false && this.rows[i].price != '') {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          }

          if (this.rows[i].salepricemd1 == '') {
            submit = 1;
            this.rows[i].err_saleprice = 'Required';
          } else if (parseFloat(this.rows[i].salepricemd1) <= 0) {
            submit = 1;
            this.rows[i].err_saleprice = 'Invalid Price';
          } else if (price.test(this.rows[i].salepricemd1) == false && this.rows[i].salepricemd1 != '') {
            submit = 1;
            this.rows[i].err_saleprice = 'Invalid Price';
          } else if (parseFloat(this.rows[i].salepricemd1) < parseFloat(this.rows[i].price)) {
            submit = 1;
            this.rows[i].err_saleprice = 'Should be greater or equal to purchase price';
          }

          if (this.rows[i].qty == '') {
            submit = 1;
            this.rows[i].err_qty = 'Required';
          } else if (parseFloat(this.rows[i].qty) <= 0.00) {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          } else if (price.test(this.rows[i].qty) == false && this.rows[i].qty != '') {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          }

          if (igstexp.test(this.rows[i]['igst']) == false && this.rows[i]['igst'] != '') {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['igst']) < 0) {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['cgst']) == false && this.rows[i]['cgst'] != 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['cgst']) < 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['sgst']) == false && this.rows[i]['sgst'] != 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['sgst']) < 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          }
        }
      }

      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
        if (this.selectshop == null || this.selectshop.est_shop_id == null) {
          this.haserror.shop = "Please Select Shop";
        }
        if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null) {
          this.haserror.cust = "Please Select Supplier";
        }
      } else {
        for (var i = this.rows.length - 1; i >= 0; i--) {
          if (this.rows[i].selectproductrow == null) {
            this.rows.splice(i, 1);
          }
        }
        if (this.rows.length == 0) {
          alert("Nothing to Save");
        } else {
          var _this = this;
          if (this.detail.totalamtpay === '') {
            alert("Nothing To Save");
          } else if (parseFloat(this.detail.totalamtpay) < 0) {
            submit = 1;
            alert("Invalid Entry");
          } else {
            if (submit == 0) {
              this.amt_rec = '';
              this.chequeno_validate = '';
              this.chequedate_validate = '';

              if (this.selected_pytype === 'partial') {
                var chk_partail = false;

                if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
                  this.totalparamtreceived = '';
                  this.amt_rec = 'Required';
                  this.bal = 0;
                  chk_partail = true;
                }
                if (parseInt(this.bal) < 0) {
                  this.totalparamtreceived = '';
                  this.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)';
                  this.bal = 0;
                  chk_partail = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                  this.chequeno_validate = 'Required';
                  chk_partail = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                  this.chequedate_validate = 'Required';
                  chk_partail = true;
                }

                if (chk_partail == true) {
                  return;
                }

                this.detail.totalamtpendingpay = this.bal;
              } else if (this.selected_pytype === 'full') {
                this.detail.totalamtpendingpay = 0;
                var chk_full = false;
                if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                  this.chequeno_validate = 'Required';
                  chk_full = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                  this.chequedate_validate = 'Required';
                  chk_full = true;
                }
                if (chk_full == true) {
                  return;
                }
              } else {
                this.detail.totalamtpendingpay = this.detail.totalamtpay;
              }

              if (this.cheque_date != '') {
                var daynum = /^[0-9]{1}$/;
                var date = new Date(this.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = '0' + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = '0' + day;
                } else {
                  var day = day;
                }
                var dateval = year + '-' + month + '-' + day;
              } else {
                var dateval = null;
              }

              this.loading = true;
              var data = {};
              data.suppliersid = this.selectedcustomer.supplier_id;
              data.shopid = this.selectshop.est_shop_id;
              data.pur_items = this.rows;
              data.total_discount = this.detail.totprddis;
              data.additional = this.detail.addition;
              data.amt_before_tax = this.detail.tot;
              data.cgst = this.detail.cgst;
              data.sgst = this.detail.sgst;
              data.igst = this.detail.igst;
              data.taxamt = this.detail.taxamt;
              data.totalamtpay = this.detail.totalamtpay;
              data.totalamtpendingpay = this.detail.totalamtpendingpay;
              data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
              data.pay.paytype = this.selected_pytype;
              data.pay.paymode = this.selected_pymode;
              data.pay.chqno = this.cheque_no;
              data.pay.chqdt = dateval;
              data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay);
              this.$http.post('/api/purchases/postdata', data).then(function (response) {
                _this.loading = false;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = 'Purchase Added Successfully';
                setTimeout(function () {
                  _this.haserror.message = '';
                }, 2000);
                _this.reset();
              }).catch(function (error) {
                _this.loading = false;
                console.log(error.response);
              });
            }
          }
        }
      }
    },
    reset: function reset() {
      this.selectedcustomer = null;
      this.detail.totprddis = '';
      this.detail.addition = '';
      this.detail.tot = '';
      this.detail.cgst = '';
      this.detail.sgst = '';
      this.detail.igst = '';
      this.detail.taxamt = '';
      this.detail.totalamtpay = '';
      this.detail.totalamtpendingpay = '';

      this.bal = 0;
      this.cheque_no = '';
      this.cheque_date = '';
      this.selected_pymode = 'cash';
      this.selected_pytype = 'full';
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }

      for (var i = 0; i < 2; i++) {
        this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: '', err_saleprice: '', is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', showvariant: false, novariant: false, productExist: '' });
      }
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      columnsadj: [{
        label: "Sales ID",
        field: "sale_id",
        width: "10% !important"
      }, {
        label: "Product Name",
        field: "productname",
        width: "30% !important"
      }, {
        label: "Variant",
        field: "variant",
        width: "15% !important"
      }, {
        label: "Qty",
        field: "qty",
        width: "5% !important"
      }, {
        label: "Amount Per Unit",
        field: "amount",
        width: "20% !important"
      }, {
        label: "Date",
        field: "createdAt",
        type: "date",
        dateInputFormat: "YYYY-MM-DD",
        dateOutputFormat: "MMM Do YY",
        width: "20% !important"
      }],
      disabled: 0,

      selectsupname: null,
      all_unit: null,
      amt_rec: "",
      chequeno_validate: "",
      chequedate_validate: "",
      rowsadj: [],
      purchase_id: null,
      old_shop_id: null,
      shop_id: null,
      supp_id: null,
      remove_rows: [],
      current_index: null,
      is_cs_gst: true,
      is_i_gst: true,
      Adjustment: false,
      loading: false,
      variantindex: null,
      smallmodal1: false,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      totalamtreceived: "",
      totalparamtreceived: "",
      totalamtpreviouspaid: 0.0,
      total_amt_to_pay: 0.0,
      cheque_no: "",
      cheque_date: "",
      variantvalue: [],
      sup_select: "",
      shp_select: "",
      selectedcustomer: null,
      company_gst: "",
      supplier_gst: "",
      variantdata: null,
      shopdata: null,
      batchmd: "",
      serialmd: "",
      percentagemd: "",
      amtmd: "",
      salepricemd: 0,
      inclusive: false,
      indexval: null,
      largeModal: false,
      suppliername: [],
      selected_pytype: "full",
      lst_paymenttype: [{ value: "full", text: "Full" }, { value: "partial", text: "Partial" }, { value: "no", text: "No" }],
      selected_pymode: "cash",
      barcodelist: [],
      barcode: "",
      shopname: [],
      selectshop: null,
      selectshopname: null,
      prod_lst: [],

      rows: [],
      haserror: {
        amt: "",
        dis: "",
        cust: "",
        message: "",
        message1: "",
        inclusive: "",
        saleprice: "",
        shop: ""
      },
      detail: {
        totprddis: "",
        addition: "",
        tot: "",
        cgst: "",
        sgst: "",
        igst: "",
        taxamt: "",
        totalamtpay: "",
        totalamtpendingpay: ""
      }
    };
  },


  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);

      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.sgst) + Number(row.cgst));
      }, 0);
      all = all.toFixed(4);
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == "") {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    var _this2 = this;

    for (var i = 0; i < 2; i++) {
      var prodlst = [];
      prodlst = this.prod_lst;
      this.rows.push({
        productnamex: [],
        selectedproductid: "",
        unit: "",
        unitvalue: "",
        selectproductrow: null,
        price: "",
        qty: "",
        amt: "",
        sales_tax: "",
        cgst: 0,
        sgst: 0,
        igst: "",
        amttotal: 0,
        batchmd1: "",
        serialmd1: "",
        percentagemd1: "",
        amtmd1: "",
        variantrow: "n/a",
        inclusive1: false,
        salepricemd1: 0,
        is_adjustment: false,
        adjustment_list: [],
        adjusted: [],
        err_qty: "",
        err_price: "",
        err_salestax: "",
        err_sgst: "",
        err_cgst: "",
        err_igst: "",
        showvariant: false,
        novariant: false,
        productExist: "",
        item_seqno: ""
      });
    }
    this.shopuser();
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.searchsupplier(), this.searchshops(), this.listproduct(), this.getUnit()]).then(function (ret_val) {
      _this2.loadPurchaseData();
    });
  },


  methods: {
    getUnit: function getUnit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get("/api/Unittypes/getUnit").then(function (response) {
                  _this.all_unit = response.data.data;
                  if (_this.all_unit !== null) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== "") {
        if (regexp.test(this.totalamtreceived) === false) {
          alert("Please Enter Valid Amount");
          this.totalamtreceived = "";
          return;
        } else {
          this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(4);
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== "") {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert("Please Enter Valid Amount");
          this.totalparamtreceived = "";
          return;
        } else {
          var paid = parseFloat(this.totalparamtreceived) + parseFloat(this.totalamtpreviouspaid);
          this.bal = (parseFloat(this.detail.totalamtpay) - paid).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === "full") {
        this.fullpay = true;
        this.total_amt_to_pay = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === "partial") {
        this.parpay = true;
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== "no") {
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
          this.cheque_no = "";
          this.cheque_date = "";
        }
      } else {
        this.chqpay = false;
        this.cheque_no = "";
        this.cheque_date = "";
      }
    },
    searchshops: function searchshops() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this4;
                _context2.next = 3;
                return _this4.$http.get("/api/shopusers/getShop");

              case 3:
                response = _context2.sent;

                _this.shopname = response.data;

                if (!(_this.shopname.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    searchsupplier: function searchsupplier() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this = _this5;
                _context3.next = 3;
                return _this5.$http.get("/api/suppliers");

              case 3:
                response = _context3.sent;

                _this.suppliername = response.data;

                if (!(_this.suppliername.length > 0)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    loadPurchaseData: function loadPurchaseData() {
      this.rows.length = 0;
      this.purchase_id = this.$route.params.purchaseId;
      this.shop_id = this.$route.params.shopId;
      this.old_shop_id = this.$route.params.shopId;
      var __this = this;
      this.$http.get("/api/purchases/loadData?filter[where][purchase_id]=" + __this.purchase_id + "&filter[where][est_shop_id]=" + __this.shop_id).then(function (res) {
        if (res.status == 200) {
          __this.totalparamtreceived = "";

          __this.detail.totalamtpendingpay = res.data.pur_dtl.amt_pending_pay;
          __this.detail.addition = parseFloat(res.data.pur_dtl.additional_discount).toFixed(4);
          var select_sup = __this.suppliername.filter(function (each) {
            return each.supplier_id === res.data.pur_dtl.supplier_id;
          });
          __this.selectedcustomer = select_sup[0];
          __this.selectsupname = __this.nameAndnumber(select_sup[0]);

          var select_shop = __this.shopname.filter(function (each) {
            return each.est_shop_id === res.data.pur_dtl.est_shop_id;
          });
          __this.selectshop = select_shop[0];
          __this.company_data();

          __this.selectshopname = __this.selectshop.est_shop_name;

          __this.totalamtpreviouspaid = parseFloat(res.data.pay_dtl).toFixed(4);

          if (parseFloat(res.data.pur_dtl.total_amt_pay) === parseFloat(res.data.pur_dtl.amt_pending_pay)) {
            __this.selected_pytype = "no";
            __this.parpay = false;
            __this.fullpay = false;
          } else if (parseFloat(res.data.pur_dtl.amt_pending_pay) === 0.0) {
            __this.selected_pytype = "full";
            __this.parpay = false;
            __this.fullpay = true;
            __this.totalamtreceived = parseFloat(res.data.pay_dtl.amount).toFixed(4);
          } else {
            __this.selected_pytype = "partial";
            __this.parpay = true;
            __this.fullpay = false;


            __this.bal = parseFloat(res.data.pur_dtl.amt_pending_pay).toFixed(2);
          }

          for (var i = 0; i < res.data.item_data.length; i++) {
            var pur_disc_amt = "";
            if (parseFloat(res.data.item_data[i].pur_disc_amt) !== 0) {
              pur_disc_amt = parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(4);
            }

            var pur_disc_pct = "";
            if (parseFloat(res.data.item_data[i].pur_disc_pct) !== 0) {
              pur_disc_pct = parseFloat(res.data.item_data[i].pur_disc_pct);
            }

            var novariant_val = true;
            var showvariant_val = false;
            var variant_val = "";
            if (res.data.item_data[i].variant_id != null && res.data.item_data[i].variant_id != "") {
              novariant_val = false;
              showvariant_val = true;
              variant_val = res.data.item_data[i].variant_id;
            }

            var prod_dt = __this.prod_lst.filter(function (each) {
              return each.product_id === res.data.item_data[i].product_id;
            });

            var igst = 0.0;
            var sgst = 0.0;
            var cgst = 0.0;
            if (parseFloat(res.data.item_data[i].sgst_amt) === 0 && parseFloat(res.data.item_data[i].cgst_amt) === 0 && parseFloat(res.data.item_data[i].igst_amt) === 0) {
              igst = 0.0;
              sgst = 0.0;
              cgst = 0.0;
            } else if (parseFloat(res.data.item_data[i].cgst_amt) !== 0 && parseFloat(res.data.item_data[i].sgst_amt) !== 0) {
              cgst = res.data.item_data[i].cgst_amt;
              sgst = res.data.item_data[i].sgst_amt;
            } else {
              igst = res.data.item_data[i].igst_amt;
            }

            var unit_value = "";
            if (res.data.item_data[i].unit_id in __this.all_unit) {
              unit_value = __this.all_unit[res.data.item_data[i].unit_id];
            }

            var new_row = {
              productnamex: prod_dt,
              selectedproductid: "",
              price: parseFloat(res.data.item_data[i].product_unit_cost).toFixed(4),
              unit: unit_value,
              unitvalue: res.data.item_data[i].unit_id,
              selectproductrow: prod_dt[0],
              qty: res.data.item_data[i].purchase_qty,
              old_qty: res.data.item_data[i].purchase_qty,
              amt: res.data.item_data[i].sub_total,
              cgst: cgst,
              sgst: sgst,
              igst: igst,
              amttotal: res.data.item_data[i].amt_to_pay,
              batchmd1: res.data.item_data[i].batch,
              serialmd1: res.data.item_data[i].serialno,
              percentagemd1: pur_disc_pct,
              amtmd1: pur_disc_amt,
              variantrow: variant_val,
              inclusive1: res.data.item_data[i].tax_inclusive,
              salepricemd1: 0,
              is_adjustment: false,
              adjustment_list: [],
              adjusted: [],
              err_qty: "",
              err_price: "",
              err_sgst: "",
              err_cgst: "",
              err_igst: "",
              showvariant: showvariant_val,
              novariant: novariant_val,
              productExist: "",
              item_seqno: res.data.item_data[i].item_seq_no
            };

            __this.rows.push(new_row);
          }
          __this.onSelectSup(__this.selectedcustomer);
        } else {
          console.log("Didnt got response");
        }
      }).catch(function (error) {});
    },
    listproduct: function listproduct() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this = _this6;
                _context4.next = 3;
                return _this6.$http.get("/api/companyproducts");

              case 3:
                response = _context4.sent;

                _this.prod_lst = response.data;

                if (!(_this.prod_lst.length > 0)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    checkVariant: function checkVariant(index) {
      if (this.variantdata == null) {
        this.rows[index].adjustment_list = [];
        this.rows[index].adjusted = [];

        this.rows[index].selectedproductid = null;
        this.rows[index].unit = "";
        this.rows[index].selectproductrow = null;
        this.rows[index].price = "";
        this.rows[index].qty = "";
        this.rows[index].amt = "";
        this.rows[index].cgst = 0;
        this.rows[index].sgst = 0;
        this.rows[index].igst = "";
        this.rows[index].batchmd1 = "";
        this.rows[index].serialmd1 = "";
        this.rows[index].is_adjustment = false;
        this.rows[index].amttotal = 0;
        this.rows[index].percentagemd1 = "";
        this.rows[index].amtmd1 = "";
        this.rows[index].variantrow = "n/a";
        this.rows[index].unitvalue = "";
        this.rows[index].novariant = false;
        this.rows[index].showvariant = false;
        this.rows[index].inclusive1 = false;
        this.rows[index].err_qty = "";
        this.rows[index].err_price = "";
        this.rows[index].err_sgst = "";
        this.rows[index].err_cgst = "";
        this.rows[index].err_igst = "";
        this.rows[index].productExist = "";
        this.rows[index].item_seqno = "";
      }
    },
    checkShop: function checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Supplier";
        this.barcode = "";
      } else {
        this.haserror.cust = "";
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = "";
      } else {
        this.haserror.shop = "";
      }
    },
    searchBarcode: function searchBarcode() {
      var _this = this;

      var option = [];
      var index = 0;
      var addRow = 0;
      var barcode = this.barcode;

      this.checkShop();

      this.barcode = "";
      if (barcode) {
        this.$http.get("/api/purchasereturns/joinproduct2?barcode=" + barcode).then(function (response) {
          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {
            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });
          if (response.data[0] != null) {
            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({
                productnamex: [],
                selectedproductid: "",
                unit: "",
                unitvalue: "",
                selectproductrow: null,
                price: "",
                qty: "",
                amt: "",
                cgst: 0,
                sgst: 0,
                igst: "",
                amttotal: 0,
                batchmd1: "",
                serialmd1: "",
                percentagemd1: "",
                amtmd1: "",
                variantrow: "n/a",
                inclusive1: false,
                salepricemd1: 0,
                is_adjustment: false,
                adjustment_list: [],
                adjusted: [],
                err_qty: "",
                err_price: "",
                err_sgst: "",
                err_cgst: "",
                err_igst: "",
                showvariant: false,
                novariant: false,
                productExist: "",
                item_seqno: ""
              });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];

            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {}
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.sup_cmp_name + " - " + item.sup_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
      }).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    onSelectAdjustment: function onSelectAdjustment(index, row) {
      this.current_index = null;
      this.current_index = index;
      this.haserror.message1 = "";
      this.disabled = 0;
      this.Adjustment = true;
      this.rowsadj = [];

      for (var i = 0; i < row.adjustment_list.length; i++) {
        if (row.adjusted.length > 0) {
          var vgtSelected = false;
          for (var j = 0; j < row.adjusted.length; j++) {
            if (row.adjusted[j] == row.adjustment_list[i].saleadjustment_id) {
              var vgtSelected = true;
            }
          }
          this.rowsadj.push({
            sale_id: row.adjustment_list[i].saleadjustment_id,
            productname: row.adjustment_list[i].product_id,
            variant: row.adjustment_list[i].variant_id,
            qty: row.adjustment_list[i].sale_qty,
            amount: row.adjustment_list[i].sale_amount,
            createdAt: row.adjustment_list[i].lastupdated_datetime,
            vgtSelected: vgtSelected
          });
        } else {
          this.rowsadj.push({
            sale_id: row.adjustment_list[i].saleadjustment_id,
            productname: row.adjustment_list[i].product_id,
            variant: row.adjustment_list[i].variant_id,
            qty: row.adjustment_list[i].sale_qty,
            amount: row.adjustment_list[i].sale_amount,
            createdAt: row.adjustment_list[i].lastupdated_datetime,
            vgtSelected: false
          });
        }
      }
      this.checking_adjustment();
    },
    save_adjustment: function save_adjustment() {
      this.rows[this.current_index].adjusted = [];
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i]["vgtSelected"] == true) {
          this.rows[this.current_index].adjusted.push(this.rowsadj[i]["sale_id"]);
        }
      }
      this.Adjustment = false;
    },
    selectAll: function selectAll(selected, selectedRows) {
      if (selected.selectedRows.length === 0) {
        var vgtSelected = false;
      } else {
        var vgtSelected = true;
      }

      for (var i = 0; i < this.rowsadj.length; i++) {
        this.rowsadj[i]["vgtSelected"] = vgtSelected;
      }
      this.checking_adjustment();
    },
    toggleSelectRow: function toggleSelectRow(params) {
      this.rowsadj[params.row.originalIndex]["vgtSelected"] = params.row.vgtSelected;
      this.checking_adjustment();
    },
    checking_adjustment: function checking_adjustment() {
      var row_qty = this.rows[this.current_index]["qty"];
      var adj_qty = 0;
      for (var i = 0; i < this.rowsadj.length; i++) {
        if (this.rowsadj[i].vgtSelected) {
          adj_qty += parseFloat(this.rowsadj[i].qty);
        }
      }
      if (adj_qty > row_qty) {
        this.disabled = 1;
        this.haserror.message1 = "Adjustment Quantity Cannot Be Greater Than Purchase Quantity";
      } else {
        this.disabled = 0;
        this.haserror.message1 = "";
      }
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    onSelectShp: function onSelectShp(option) {
      this.haserror.shop = "";
      if (option.id != undefined) {
        if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
          this.haserror.shop = "Please Select Shop";
        }
      } else {
        this.haserror.shop = "Please Select Shop";
      }
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.sale_adjustment(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    onSelectSup: function onSelectSup(option) {
      this.is_cs_gst = true;
      this.is_i_gst = true;

      if (option.sup_cmp_gst != undefined) {
        this.haserror.cust = "";
        this.supplier_gst = option.sup_cmp_gst;
      }

      if (this.company_gst && this.supplier_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var supplier_gst = this.supplier_gst.substring(0, 2);
        if (company_gst === supplier_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
        }
      } else if (this.supplier_gst === null || this.supplier_gst === "") {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      } else {
        this.is_cs_gst = true;
        this.is_i_gst = true;
      }

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.variantindex = i;
            this.show_tax(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    onSelectvariant: function onSelectvariant(option) {
      if (option.variant_value === "No Variant") {
        this.rows[this.variantindex]["variantrow"] = "n/a";
      } else {
        this.rows[this.variantindex]["variantrow"] = option.variant_value;
      }
      this.smallmodal = false;


      var row = this.rows[this.variantindex].selectproductrow;
      this.sale_adjustment(row, this.variantindex);
      this.onSelect(row, this.variantindex);
    },
    updateshop: function updateshop() {
      this.loading = true;
      var _this = this;
      this.$http.post("/api/purchases/updateShop?filter[where][purchase_id]=" + this.purchase_id + "&filter[where][old_shop_id]=" + this.old_shop_id + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id).then(function (response) {
        if (response.status == 200) {
          if (response.data.data == "Successful") {
            _this.$route.params.shopId = _this.selectshop.est_shop_id;
            setTimeout(function () {
              _this.loadPurchaseData();
              _this.smallmodal1 = false;
              _this.loading = false;
            }, 1000);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.haserror.message = "Purchase Updated Successfully";
            setTimeout(function () {
              _this.haserror.message = "";
            }, 3000);
          }
        }
      }).catch(function (error) {});
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ("product_id" in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(row, index) {
      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id;

      if (vrnt_id != null) {
        this.rows[this.variantindex].novariant = false;
        this.rows[this.variantindex].showvariant = true;
        this.smallmodal = true;

        this.$http.get("/api/variantvalues?filter[where][variant_id]=" + vrnt_id).then(function (response) {
          _this.variantvalue = response.data;
          _this.variantvalue.unshift({
            company_id: "I2OCGLB",
            id: 0,
            regcity_code: "I2O",
            variant_id: "0",
            variant_value: "No Variant"
          });
        }).catch(function (error) {});
      } else {
        this.rows[this.variantindex].novariant = true;
        this.rows[this.variantindex].showvariant = false;
        var option = {
          company_id: "I2OCGLB",
          id: 0,
          regcity_code: "I2O",
          variant_id: "0",
          variant_value: "No Variant"
        };
        this.onSelectvariant(option);
        this.smallmodal = false;
      }
    },
    sale_adjustment: function sale_adjustment(option, index) {
      var _this = this;
      this.$http.get("/api/salesadjustments?filter[where][est_shop_id]=" + _this.selectshop.est_shop_id + "&filter[where][product_id]=" + option.product_id + "&filter[where][variant_id]=" + _this.rows[index]["variantrow"]).then(function (response) {
        if (response.data.length > 0) {
          _this.rows[index]["adjustment_list"] = response.data;
          _this.rows[index]["is_adjustment"] = true;
        } else {
          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["is_adjustment"] = false;
          _this.rows[index]["adjusted"] = [];
        }
      }).catch(function (error) {});
      this.onSelect(option, index);
    },
    show_tax: function show_tax(option, index) {
      var _this = this;
      this.$http.get("/api/taxrates/findOne?filter[where][tax_id]=" + option.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.supplier_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var supplier_gst = _this.supplier_gst.substring(0, 2);

          if (company_gst === supplier_gst) {
            _this.rows[index]["cgst"] = response.data.tax_cgst;
            _this.rows[index]["sgst"] = response.data.tax_sgst;
            _this.rows[index]["igst"] = 0.0;
          } else {
            _this.rows[index]["cgst"] = 0.0;
            _this.rows[index]["sgst"] = 0.0;
            _this.rows[index]["igst"] = response.data.tax_igst;
          }
          _this.price(index);
        } else if (_this.supplier_gst === null || _this.supplier_gst === "") {
          _this.rows[index]["cgst"] = 0.0;
          _this.rows[index]["sgst"] = 0.0;
          _this.rows[index]["igst"] = 0.0;
          _this.price(index);
        } else {
          if (_this.rows[index]["cgst"] === 0.0 && _this.rows[index]["sgst"] === 0.0 && _this.rows[index]["igst"] === 0.0) {
            _this.rows[index]["cgst"] = 0.0;
            _this.rows[index]["sgst"] = 0.0;
            _this.rows[index]["igst"] = 0.0;
          } else if (_this.rows[index]["cgst"] === 0.0 && _this.rows[index]["sgst"] === 0.0 && _this.rows[index]["igst"] !== 0.0) {
            _this.rows[index]["cgst"] = 0.0;
            _this.rows[index]["sgst"] = 0.0;
            _this.rows[index]["igst"] = response.data.tax_igst;
          } else {
            _this.rows[index]["cgst"] = response.data.tax_cgst;
            _this.rows[index]["sgst"] = response.data.tax_sgst;
            _this.rows[index]["igst"] = 0.0;
          }
          _this.price(index);
        }
      });
    },
    onSelect: function onSelect(option, index) {
      var _this = this;
      _this.rows[index]["inclusive1"] = false;
      _this.current_index = null;
      if (option != null) {
        if (option.alt_product_id != undefined) {
          _this.show_tax(option, index);

          _this.rows[index]["unit"] = option.unit_name;
          _this.rows[index]["unitvalue"] = option.unit_id;
          _this.rows[index]["selectedproductid"] = option.variant_id;
          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["adjusted"] = [];
        } else {
          _this.rows[index]["selectedproductid"] = "";
          _this.rows[index]["unit"] = "";
          _this.rows[index]["unitvalue"] = "";
          _this.rows[index]["selectproductrow"] = null;
          _this.rows[index]["price"] = "";
          _this.rows[index]["qty"] = "";
          _this.rows[index]["amt"] = "";
          _this.rows[index]["cgst"] = 0;
          _this.rows[index]["sgst"] = 0;
          _this.rows[index]["igst"] = "";
          _this.rows[index]["amttotal"] = 0;
          _this.rows[index]["batchmd1"] = "";
          _this.rows[index]["serialmd1"] = "";
          _this.rows[index]["percentagemd1"] = "";
          _this.rows[index]["amtmd1"] = "";
          _this.rows[index]["variantrow"] = "n/a";
          _this.rows[index]["inclusive1"] = false;
          _this.rows[index]["salepricemd1"] = 0;
          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["adjusted"] = [];
          _this.rows[index]["item_seqno"] = "";
          _this.rows[index].showvariant = false;
          _this.rows[index].novariant = false;
        }
      } else {
        _this.rows[index]["selectedproductid"] = "";
        _this.rows[index]["unit"] = "";
        _this.rows[index]["unitvalue"] = "";
        _this.rows[index]["selectproductrow"] = null;
        _this.rows[index]["price"] = "";
        _this.rows[index]["qty"] = "";
        _this.rows[index]["amt"] = "";
        _this.rows[index]["cgst"] = 0;
        _this.rows[index]["sgst"] = 0;
        _this.rows[index]["igst"] = "";
        _this.rows[index]["amttotal"] = 0;
        _this.rows[index]["batchmd1"] = "";
        _this.rows[index]["serialmd1"] = "";
        _this.rows[index]["percentagemd1"] = "";
        _this.rows[index]["amtmd1"] = "";
        _this.rows[index]["variantrow"] = "n/a";
        _this.rows[index]["inclusive1"] = false;
        _this.rows[index]["salepricemd1"] = 0;
        _this.rows[index]["adjustment_list"] = [];
        _this.rows[index]["adjusted"] = [];
      }
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.batchmd = "";
      this.serialmd = "";
      this.percentagemd = "";
      this.amtmd = "";
      this.salepricemd = "";
      if (this.rows[test]["percentagemd1"] != "") {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != "") {
        this.amtmd = this.rows[test].amtmd1;
      }
      if (this.rows[test]["batchmd1"] != "") {
        this.batchmd = this.rows[test].batchmd1;
      }
      if (this.rows[test]["serialmd1"] != "") {
        this.serialmd = this.rows[test].serialmd1;
      }

      this.inclusive = this.rows[test].inclusive1;
      this.salepricemd = this.rows[test].salepricemd1;
    },
    updateSalesTax: function updateSalesTax(index) {
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      if (tax.test(this.rows[index]["sales_tax"]) == false && this.rows[index]["sales_tax"] != "") {
        this.rows[index]["sales_tax"] = "";
        this.rows[index]["err_salestax"] = "Invalid";
      } else if (parseFloat(this.rows[index]["sales_tax"]) < 0) {
        this.rows[index]["sales_tax"] = "";
        this.rows[index]["err_salestax"] = "Invalid";
      } else {
        this.rows[index]["err_salestax"] = "";

        var taxMode = this.companyTaxType || 'IN';

        if (taxMode === 'IN') {
          var salesTax = parseFloat(this.rows[index]["sales_tax"]) || 0;
          this.rows[index]["igst"] = salesTax;
          this.rows[index]["sgst"] = 0;
          this.rows[index]["cgst"] = 0;
        } else {
          if (this.rows[index]["sales_tax"] != "") {
            var salesTax = parseFloat(this.rows[index]["sales_tax"]);
            this.rows[index]["sgst"] = salesTax / 2;
            this.rows[index]["cgst"] = salesTax / 2;
            this.rows[index]["igst"] = salesTax;
          } else {
            this.rows[index]["sgst"] = 0;
            this.rows[index]["cgst"] = 0;
            this.rows[index]["igst"] = 0;
          }
        }
      }
      this.price(index);
    },
    addRow1: function addRow1() {
      this.rows.push({
        productnamex: [],
        selectedproductid: "",
        unit: "",
        unitvalue: "",
        selectproductrow: null,
        price: "",
        qty: "",
        amt: "",
        sales_tax: "",
        cgst: 0,
        sgst: 0,
        igst: "",
        amttotal: 0,
        batchmd1: "",
        serialmd1: "",
        percentagemd1: "",
        amtmd1: "",
        variantrow: "n/a",
        inclusive1: false,
        salepricemd1: 0,
        is_adjustment: false,
        adjustment_list: [],
        adjusted: [],
        err_qty: "",
        err_price: "",
        err_salestax: "",
        err_sgst: "",
        err_cgst: "",
        err_igst: "",
        showvariant: false,
        novariant: false,
        productExist: "",
        item_seqno: ""
      });
      this.selected_pytype = "partial";
      this.selected_pymode = "cash";
      this.parpay = true;
    },


    removeElement: function removeElement(index) {
      var _this = this;
      if (this.rows[index].item_seqno != "") {
        this.$http.get("/api/estshopinventories?filter[where][est_shop_id]=" + this.shop_id + "&filter[where][product_id]=" + this.rows[index].selectproductrow.product_id + "&filter[where][variant_id]=" + this.rows[index].variantrow + "&filter[fields][quantity]=true").then(function (response) {
          if (parseFloat(response.data[1].quantity) >= parseFloat(_this.rows[index]["old_qty"])) {
            _this.remove_rows.push(_this.rows[index]);
            _this.rows.splice(index, 1);
            _this.manage_pre_paid();
          } else {
            alert("Item detail - " + _this.rows[index].selectproductrow.product_name + " " + _this.rows[index].variantrow + " cannot be removed from purchase record as its been adjusted in Sale Adjustment");
          }
        });
      } else {
        this.rows.splice(index, 1);
        this.manage_pre_paid();
      }
    },

    manage_pre_paid: function manage_pre_paid() {

      if (parseFloat(this.totalamtpreviouspaid) > parseFloat(this.totalamtpay)) {
        this.paychange("full");
        this.modechange("cash");

        this.totalparamtreceived = "";

        this.totalamtreceived = "";
        this.totamtrecdis = true;
      } else if (parseFloat(this.totalamtpreviouspaid) == parseFloat(this.totalamtpay)) {
        this.paychange("full");
        this.modechange("cash");

        this.totalparamtreceived = "";
        this.totalamtreceived = "";
        this.totamtrecdis = true;
      } else {
        this.paychange("partial");
        this.modechange("cash");
        this.totalparamtreceived = "";

        this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid)).toFixed(4);
        this.totamtrecdis = false;
      }
    },
    searchprd3: function searchprd3(searchText, index, row) {
      this.haserror.cust = "";
      this.haserror.shop = "";
      var status = 1;
      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Supplier";
      }
      if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }

      if (status == 1) {
        var _this = this;
        if (searchText) {
          this.$http.get("/api/purchasereturns/joinproduct2?data=" + searchText).then(function (response) {
            row.productnamex = response.data;
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
      this.haserror.amt = "";
      this.haserror.dis = "";
      if (this.percentagemd != "" && this.amtmd != "") {
        this.haserror.amt = "Please Select Any One";
      } else if (this.percentagemd != "" && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != "" && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Valid Amount";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]["amt"])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]["batchmd1"] = this.batchmd;
        this.rows[val]["serialmd1"] = this.serialmd;
        this.rows[val]["percentagemd1"] = this.percentagemd;
        this.rows[val]["amtmd1"] = this.amtmd;
        this.rows[val]["inclusive1"] = this.inclusive;
        this.rows[val]["salepricemd1"] = this.salepricemd;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition !== "") {
        this.detail.addition = "";
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if (parseFloat(this.detail.totalamtpay) < 0) {
        this.detail.addition = "";
        alert("Invalid Entry");
      }
    },
    price: function price(index) {
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;

      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      if (igstexp.test(this.rows[index]["igst"]) == false && this.rows[index]["igst"] != "") {
        this.rows[index]["igst"] = "";
        this.rows[index]["err_igst"] = "Invalid";
      } else if (parseFloat(this.rows[index]["igst"]) < 0) {
        this.rows[index]["igst"] = "";
        this.rows[index]["err_igst"] = "Invalid";
      } else {
        this.rows[index]["err_igst"] = "";
      }

      if (tax.test(this.rows[index]["cgst"]) == false && this.rows[index]["cgst"] != 0) {
        this.rows[index]["cgst"] = 0;
        this.rows[index]["err_cgst"] = "Invalid";
      } else if (parseFloat(this.rows[index]["cgst"]) < 0) {
        this.rows[index]["cgst"] = 0;
        this.rows[index]["err_cgst"] = "Invalid";
      } else {
        this.rows[index]["err_cgst"] = "";
      }

      if (tax.test(this.rows[index]["sgst"]) == false && this.rows[index]["sgst"] != 0) {
        this.rows[index]["sgst"] = 0;
        this.rows[index]["err_sgst"] = "Invalid";
      } else if (parseFloat(this.rows[index]["sgst"]) < 0) {
        this.rows[index]["sgst"] = 0;
        this.rows[index]["err_sgst"] = "Invalid";
      } else {
        this.rows[index]["err_sgst"] = "";
      }

      if (this.rows[index]["price"] == "") {
        this.rows[index]["err_price"] = "Required";
      } else if (parseFloat(this.rows[index]["price"]) <= 0.0) {
        this.rows[index]["err_price"] = "Invalid Price";
      } else if (price.test(this.rows[index]["price"]) == false && this.rows[index]["price"] != "") {
        this.rows[index]["err_price"] = "Invalid Price";
      } else {
        this.rows[index]["err_price"] = "";
        this.rows[index]["price"] = parseFloat(this.rows[index]["price"]).toFixed(4);
      }

      if (this.rows[index]["qty"] == "") {
        this.rows[index]["err_qty"] = "Required";
      } else if (parseFloat(this.rows[index]["qty"]) <= 0.0) {
        this.rows[index]["err_qty"] = "Invalid Quantity";
      } else if (price.test(this.rows[index]["qty"]) == false && this.rows[index]["qty"] != "") {
        this.rows[index]["err_qty"] = "Invalid Quantity";
      } else {
        this.rows[index]["err_qty"] = "";
      }

      if (this.rows[index]["igst"] != "" && this.companyTaxType !== 'US') {
        this.rows[index]["cgst"] = 0;
        this.rows[index]["sgst"] = 0;
        var igst_value = parseFloat(this.rows[index]["igst"]);
      } else if (this.rows[index]["igst"] != "" && this.companyTaxType === 'US') {
        var igst_value = parseFloat(this.rows[index]["igst"]);
      } else {
        this.rows[index]["igst"] = "";
        var igst_value = 0;
      }

      if (this.rows[index]["qty"] != "" && this.rows[index]["price"] != "") {
        var qty = parseFloat(this.rows[index]["qty"]);
        var price = parseFloat(this.rows[index]["price"]);
        var total = qty * price;
      } else if (this.rows[index]["qty"] == "" && this.rows[index]["price"] == "") {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]["qty"] != "" && this.rows[index]["price"] == "") {
        var qty = parseFloat(this.rows[index]["qty"]);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]["qty"] == "" && this.rows[index]["price"] != "") {
        var qty = 0;
        var price = parseFloat(this.rows[index]["price"]);
        var total = qty * price;
      }

      if (this.rows[index]["percentagemd1"] != "") {
        total = total - total * this.rows[index]["percentagemd1"] / 100;
      }
      if (this.rows[index]["amtmd1"] != "") {
        total = total - parseFloat(this.rows[index]["amtmd1"]);
      }

      if (total != undefined) {
        if (this.rows[index]["inclusive1"] == false) {
          this.rows[index]["amt"] = total.toFixed(4);
          var amttotal = total + this.rows[index]["sgst"] * total / 100 + this.rows[index]["cgst"] * total / 100 + igst_value * total / 100;
          amttotal = amttotal.toFixed(4);
          this.rows[index]["amttotal"] = amttotal;
        } else if (this.rows[index]["inclusive1"] == true) {
          amttotal = total.toFixed(4);
          this.rows[index]["amttotal"] = amttotal;
          var total_percentage = parseFloat(this.rows[index]["sgst"]) + parseFloat(this.rows[index]["cgst"]) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]["amt"] = bfttotal.toFixed(4);
        }
      }
      this.manage_pre_paid();
    },
    finalsubmit: function finalsubmit() {
      this.haserror.message = "";
      this.haserror.cust = "";
      this.haserror.shop = "";
      var submit = 0;
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow != null) {
          if (this.rows[i].price == "") {
            submit = 1;
            this.rows[i].err_price = "Required";
          } else if (parseFloat(this.rows[i].price) <= 0) {
            submit = 1;
            this.rows[i].err_price = "Invalid Price";
          } else if (price.test(this.rows[i].price) == false && this.rows[i].price != "") {
            submit = 1;
            this.rows[i].err_price = "Invalid Price";
          }

          if (this.rows[i].qty == "") {
            submit = 1;
            this.rows[i].err_qty = "Required";
          } else if (parseFloat(this.rows[i].qty) <= 0.0) {
            submit = 1;
            this.rows[i].err_qty = "Invalid Quantity";
          } else if (price.test(this.rows[i].qty) == false && this.rows[i].qty != "") {
            submit = 1;
            this.rows[i].err_qty = "Invalid Quantity";
          }

          if (igstexp.test(this.rows[i]["igst"]) == false && this.rows[i]["igst"] != "") {
            this.rows[i]["igst"] = "";
            this.rows[i]["err_igst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["igst"]) < 0) {
            this.rows[i]["igst"] = "";
            this.rows[i]["err_igst"] = "Invalid";
            submit = 1;
          }

          if (tax.test(this.rows[i]["cgst"]) == false && this.rows[i]["cgst"] != 0) {
            this.rows[i]["cgst"] = 0;
            this.rows[i]["err_cgst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["cgst"]) < 0) {
            this.rows[i]["cgst"] = 0;
            this.rows[i]["err_cgst"] = "Invalid";
            submit = 1;
          }

          if (tax.test(this.rows[i]["sgst"]) == false && this.rows[i]["sgst"] != 0) {
            this.rows[i]["sgst"] = 0;
            this.rows[i]["err_sgst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["sgst"]) < 0) {
            this.rows[i]["sgst"] = 0;
            this.rows[i]["err_sgst"] = "Invalid";
            submit = 1;
          }
        }
      }

      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
        if (this.selectshop == null || this.selectshop.est_shop_id == null) {
          this.haserror.shop = "Please Select Shop";
        }
        if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null) {
          this.haserror.cust = "Please Select Supplier";
        }
      } else {
        for (var i = this.rows.length - 1; i >= 0; i--) {
          if (this.rows[i].selectproductrow == null) {
            this.rows.splice(i, 1);
          }
        }
        if (this.rows.length == 0) {
          alert("Nothing to Save");
        } else {
          var _this = this;
          if (this.detail.totalamtpay == "") {
            submit = 1;
            alert("Nothing To Save");
          } else if (parseFloat(this.detail.totalamtpay) < 0) {
            submit = 1;
            alert("Invalid Entry");
          } else {
            if (submit == 0) {
              this.amt_rec = "";
              this.chequeno_validate = "";
              this.chequedate_validate = "";

              var amount_pay = 0.0;
              if (this.selected_pytype === "full") {
                var chk_full = false;
                if (parseFloat(this.chng) < 0.0) {
                  this.amt_rec = "Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)";
                  this.totalamtreceived = "";
                  this.chng = 0;
                  chk_full = true;
                }
                if (this.selected_pymode == "cheque" && this.cheque_no == "") {
                  this.chequeno_validate = "Required";
                  chk_full = true;
                }
                if (this.selected_pymode == "cheque" && this.cheque_date == "") {
                  this.chequedate_validate = "Required";
                  chk_full = true;
                }
                if (chk_full == true) {
                  return;
                } else {
                  amount_pay = this.total_amt_to_pay;
                  this.detail.totalamtpendingpay = 0;
                }
              } else if (this.selected_pytype === "partial") {
                var chk_partail = false;
                if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == "") {
                  this.totalparamtreceived = "";
                  this.amt_rec = "Required";
                  this.bal = 0;
                  chk_partail = true;
                }
                if (parseInt(this.bal) < 0) {
                  this.totalparamtreceived = "";
                  this.amt_rec = "Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)";
                  this.bal = 0;
                  chk_partail = true;
                }
                if (this.selected_pymode == "cheque" && this.cheque_no == "") {
                  this.chequeno_validate = "Required";
                  chk_partail = true;
                }
                if (this.selected_pymode == "cheque" && this.cheque_date == "") {
                  this.chequedate_validate = "Required";
                  chk_partail = true;
                }

                if (chk_partail == true) {
                  return;
                } else {
                  this.detail.totalamtpendingpay = this.bal;
                  amount_pay = this.totalparamtreceived;
                }
              } else {
                this.detail.totalamtpendingpay = this.detail.totalamtpay - this.totalamtpreviouspaid;
                amount_pay = 0;
              }

              if (this.cheque_date != "") {
                var daynum = /^[0-9]{1}$/;
                var date = new Date(this.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = "0" + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = "0" + day;
                } else {
                  var day = day;
                }
                var dateval = year + "-" + month + "-" + day;
              } else {
                var dateval = null;
              }

              this.loading = true;
              var data = {};
              data.purchase_id = this.purchase_id;
              data.suppliersid = this.selectedcustomer.supplier_id;
              data.shopid = this.selectshop.est_shop_id;
              data.pur_items = this.rows;
              data.remove_pur_items = this.remove_rows;
              data.total_discount = this.detail.totprddis;
              data.additional = this.detail.addition;
              data.amt_before_tax = this.detail.tot;
              data.cgst = this.is_cs_gst === true ? this.detail.cgst : "0";
              data.sgst = this.is_cs_gst === true ? this.detail.sgst : "0";
              data.igst = this.is_cs_gst === false ? this.detail.igst : "0";
              data.taxamt = this.detail.taxamt;
              data.totalamtpay = this.detail.totalamtpay;
              data.totalamtpendingpay = this.detail.totalamtpendingpay;
              data.pay = {
                paytype: "",
                paymode: "",
                chqno: "",
                chqdt: "",
                amt: 0
              };
              data.pay.paytype = this.selected_pytype;
              data.pay.paymode = this.selected_pymode;
              data.pay.chqno = this.cheque_no;
              data.pay.chqdt = dateval;

              data.pay.amt = amount_pay;


              this.$http.post("/api/purchases/editdata", data).then(function (response) {
                _this.loading = false;
                setTimeout(function () {
                  _this.chng = "";
                  _this.bal = "";
                  _this.cheque_no = "";
                  _this.cheque_date = "";
                  _this.loadPurchaseData();
                  _this.loading = false;
                }, 1000);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = "Purchase Updated Successfully";
                setTimeout(function () {
                  _this.haserror.message = "";
                }, 2000);
              }).catch(function (error) {
                _this.loading = false;
                console.log(error);
              });
            }
          }
        }
      }
    },
    reset: function reset() {
      this.selectedcustomer = null;
      this.selectshop = null;
      this.detail.totprddis = "";
      this.detail.addition = "";
      this.detail.tot = "";
      this.detail.cgst = "";
      this.detail.sgst = "";
      this.detail.igst = "";
      this.detail.taxamt = "";
      this.detail.totalamtpay = "";
      this.detail.totalamtpendingpay = "";
      this.chng = "";
      this.bal = "";
      this.cheque_no = "";
      this.cheque_date = "";
      this.selected_pymode = "cash";
      this.selected_pytype = "full";
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }

      for (var i = 0; i < 2; i++) {
        this.rows.push({
          productnamex: [],
          selectedproductid: "",
          unit: "",
          unitvalue: "",
          selectproductrow: null,
          price: "",
          qty: "",
          amt: "",
          cgst: 0,
          sgst: 0,
          igst: "",
          amttotal: 0,
          batchmd1: "",
          serialmd1: "",
          percentagemd1: "",
          amtmd1: "",
          variantrow: "n/a",
          inclusive1: false,
          salepricemd1: 0,
          is_adjustment: false,
          adjustment_list: [],
          adjusted: [],
          err_qty: "",
          err_price: "",
          err_sgst: "",
          err_cgst: "",
          err_igst: "",
          showvariant: false,
          novariant: false,
          productExist: "",
          item_seqno: ""
        });
      }
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Llistpurches",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      pfrst_time: false,
      shpfrst_time: false,
      productunit: "",
      productqty: "",
      rows: [],
      rows1: [],
      rows2: [],
      todate: "",
      fromdate: "",
      temprow: null,
      warningModal: false,
      warningModal1: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "purchase_id",
          type: "asc"
        },
        page: 1,
        perPage: 5
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      serverParams2: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      totalRecords1: 0,
      totalRecords2: 0,
      columns1: [{
        label: "Product Name",
        field: "product_name",
        width: "25% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "15% !important"
      }, {
        label: "Qty",
        field: "purchase_qty",
        width: "10% !important"
      }, {
        label: "Price",
        field: "product_unit_cost",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Sub Total",
        field: "sub_total",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Tax",
        field: "tax_inclusive",
        width: "8% !important"
      }, {
        label: "GST%",
        field: "gst_total",
        width: "15% !important"
      }, {
        label: "Amount",
        field: "amt_to_pay",
        width: "15% !important",
        formatFn: this.formatFn
      }, {
        label: "Barcode",
        field: "item_barcode",
        width: "32% !important"
      }],

      columns2: [{
        label: "Product Name",
        field: "product_name",
        width: "25% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "15% !important"
      }, {
        label: "Qty",
        field: "purchase_qty",
        width: "10% !important"
      }, {
        label: "Price",
        field: "product_unit_cost",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Sub Total",
        field: "sub_total",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Tax",
        field: "tax_inclusive",
        width: "8% !important"
      }, {
        label: "GST%",
        field: "gst_total",
        width: "15% !important"
      }, {
        label: "Amount",
        field: "amt_to_pay",
        width: "15% !important",
        formatFn: this.formatFn
      }, {
        label: "Return Qty",
        field: "return_qty",
        width: "15% !important"
      }, {
        label: "Barcode",
        field: "item_barcode",
        width: "32% !important"
      }]

    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    columns: function columns() {
      return [{ label: "Purchase Id", field: "purchase_id", width: "10% !important", thClass: "text-center" }, { label: "Supplier", field: "sup_cmp_name", width: "15% !important", thClass: "text-center" }, { label: "Shop", field: "est_shop_name", width: "15% !important", thClass: "text-center" }, { label: this.companyTaxType === 'US' ? "Tax Amount" : "GST Amount", field: "gst_total", width: "15% !important", thClass: "text-center" }, { label: "Total Amount", field: "total_amt_pay", width: "15% !important", formatFn: this.formatFn, thClass: "text-center" }, { label: "Date", field: "lastupdated_datetime", type: "date", dateInputFormat: "YYYY-MM-DDThh:mm:ss", dateOutputFormat: "Do MMM YYYY", tdClass: "text-left", thClass: "text-center", width: "15% !important" }, { label: "Action", field: "action", width: "10% !important", thClass: "text-center", tdClass: "text-center" }, { label: "Return", field: "return", width: "5% !important", tdClass: "text-center", thClass: "text-center" }];
    },

    pur_view: function pur_view() {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_pur_view === true) {
          this.purchase("comp");
          this.shopuser("comp");
          return true;
        } else {
          return false;
        }
      }
    },
    pur_rights: function pur_rights() {
      return this.$store.getters.get_pur_rights;
    },
    is_admin: function is_admin() {
      return this.$store.getters.get_is_admin;
    }
  },

  methods: {
    newDate: function newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var dt2 = day + "-" + month + "-" + year;

      return dt2;
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.editpro(this.temprow);
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.editpro(this.temprow);
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        },
        page: 1
      });
      this.editpro(this.temprow);
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.editpro(this.temprow);
    },
    updateParams2: function updateParams2(newProps) {
      this.serverParams2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams2, newProps);
    },
    onPageChange2: function onPageChange2(params) {
      this.updateParams2({ page: params.currentPage });
      this.editpro2(this.temprow);
    },
    onPerPageChange2: function onPerPageChange2(params) {
      this.updateParams2({ perPage: params.currentPerPage, page: 1 });
      this.editpro2(this.temprow);
    },
    onSortChange2: function onSortChange2(params) {
      this.updateParams2({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        },
        page: 1
      });
      this.editpro2(this.temprow);
    },
    onColumnFilter2: function onColumnFilter2(params) {
      this.updateParams2(params);
      this.editpro2(this.temprow);
    },
    returnitems: function returnitems() {
      var purchase_id = this.$refs["my-table2"].selectedRows[0]["purchase_id"];
      var est_shop_id = this.$refs["my-table2"].selectedRows[0]["est_shop_id"];

      if (this.$refs["my-table2"].selectedRows.length > 0) {
        if ("purchase_return_id" in this.$refs["my-table2"].selectedRows[0]) {
          var item_seqs = {};
          for (var i = 0; i < this.$refs["my-table2"].selectedRows.length; i++) {
            item_seqs[this.$refs["my-table2"].selectedRows[i].item_seq_no] = this.$refs["my-table2"].selectedRows[i].purchase_qty;
          }

          this.$router.push({
            name: "Edit Purchase Return",
            params: {
              purchaseId: purchase_id,
              shopId: est_shop_id,
              itemSeqs: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item_seqs),
              purchaseReturnId: this.$refs["my-table2"].selectedRows[0]["purchase_return_id"]
            }
          });
        } else {
          var item_seqs = [];
          for (var i = 0; i < this.$refs["my-table2"].selectedRows.length; i++) {
            item_seqs.push(this.$refs["my-table2"].selectedRows[i].item_seq_no);
          }

          this.$router.push({
            name: "Add Purchase return",
            params: {
              purchaseId: purchase_id,
              shopId: est_shop_id,
              itemSeqs: item_seqs
            }
          });
        }
      } else {
        return;
      }
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompnay: function onSelectCompnay(selected_company) {
      this.loadItems();
    },
    loadItems: function loadItems() {
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;

      if (this.todate && this.fromdate) {
        data = data + " &filter[where][lastupdated_datetime][between][0]= " + fromdate1 + "  &filter[where][lastupdated_datetime][between][1]= " + todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
      if (this.productunit) {
        data = data + "&filter[where][purchase_id]=" + unit;
      }
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }

      this.$http.get("/api/purchasedetails/getPurchase?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    purchase: function purchase(val) {
      if (val === "comp") {
        if (this.pfrst_time === false) {
          this.pfrst_time = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
    editpro: function editpro(row) {
      this.warningModal = true;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      var _this = this;
      var data = "";
      this.temprow = row;
      data = data + " &filter[where][purchase_id]= " + row.purchase_id;
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/purchasedetails/searchdb?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords1 = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) {
          _this.rows1 = response.data;
        }
      });
    },
    editpro2: function editpro2(row) {
      var filteParam = {};
      filteParam.page = this.serverParams2.page;
      filteParam.perPage = this.serverParams2.perPage;
      filteParam.sort = this.serverParams2.sort;
      var _this = this;
      var data = "";
      this.temprow = row;
      this.loading = true;
      this.$http.post("/api/salesadjustments/getPurchaseAdj?purchaseId=" + row.purchase_id + "&shp_id=" + row.est_shop_id).then(function (response) {
        if (response.data.data !== null) {
          _this.loading = false;
          alert("Purchase id - " + row.purchase_id + " belongs to Sale Adjustment, so cannot be return.");
        } else {
          data = data + " &filter[where][purchase_id]= " + row.purchase_id + "&filter[where][chk_return]=true";
          _this.$http.get("/api/purchasedetails/searchdb?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
            _this.loading = false;
            if (response.data === null) {
              alert("Items not exist in inventory to return");
            } else {
              if (response.data != undefined) {
                _this.warningModal1 = true;
                if ("pur_rt_dt" in response.data) {
                  _this.totalRecords2 = response.data.pur_dt.length;
                  var purchase_return_id = response.data.pur_rt_dt[0]["purchase_return_id"];
                  var obj_rtitemseq = {};
                  var pur_data = response.data.pur_dt;
                  var pur_rt_dt = response.data.pur_rt_dt;
                  for (var i = 0; i < pur_rt_dt.length; i++) {
                    obj_rtitemseq[parseInt(pur_rt_dt[i].item_seq)] = parseInt(pur_rt_dt[i].return_qty);
                  }


                  for (var j = 0; j < pur_data.length; j++) {
                    if (parseInt(pur_data[j].item_seq_no) in obj_rtitemseq) {
                      pur_data[j]["return_qty"] = obj_rtitemseq[pur_data[j].item_seq_no];
                      pur_data[j]["purchase_return_id"] = purchase_return_id;
                    } else {
                      pur_data[j]["return_qty"] = 0;
                      pur_data[j]["purchase_return_id"] = purchase_return_id;
                    }
                  }

                  _this.rows2 = pur_data;
                  for (var k = 0; k < _this.rows2.length; k++) {
                    if (parseInt(_this.rows2[k].item_seq_no) in obj_rtitemseq) {
                      _this.$set(_this.rows2[k], "vgtSelected", true);
                    }
                  }
                } else {
                  _this.rows2 = response.data;
                  _this.totalRecords2 = response.data.length;
                }
              }
            }
          });
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    },
    exportData: function exportData() {
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;

      if (this.todate && this.fromdate) {
        data = data + " &filter[where][lastupdated_datetime][between][0]= " + fromdate1 + "  &filter[where][lastupdated_datetime][between][1]= " + todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
      if (this.productunit) {
        data = data + "&filter[where][purchase_id]=" + unit;
      }
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (this.rows.length > 0) {

        this.$http.get("/api/purchasedetails/getPurchaseExport?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {

          var access_token = localStorage.getItem("authUser");

          var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

          _this.loading = false;
          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Data Found');
      }
    },
    searchpurchase: function searchpurchase() {
      this.updateParams({
        sort: {
          type: "",
          field: ""
        },
        page: 1
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    },
    removePurchase: function removePurchase(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http.delete("api/purchases/removePurchase?id=" + row.purchase_id + "&shp_id=" + row.est_shop_id).then(function (response) {
          _this.loading = false;
          if (response.status == 200) {
            if (response.data.res != "") {
              alert(response.data.res);
            }
            setTimeout(function () {
              _this.purchase();
            }, 2000);
          }
        }).catch(function (error) {});
      }
    },
    editPurchase: function editPurchase(row) {
      var _this = this;
      this.loading = true;
      this.$http.post("/api/salesadjustments/getPurchaseAdj?purchaseId=" + row.purchase_id + "&shp_id=" + row.est_shop_id).then(function (response) {
        _this.loading = false;
        if (response.data.data !== null) {
          alert("Purchase id - " + row.purchase_id + " belongs to Sale Adjustment, so cannot be edited");
        } else {
          _this.$router.push({
            name: "Edit Purchase",
            params: { purchaseId: row.purchase_id, shopId: row.est_shop_id }
          });
        }
      }).catch(function (error) {});
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Llistpurches",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      pfrst_time: false,
      shpfrst_time: false,
      productunit: "",
      productqty: "",
      rows: [],
      rows1: [],
      todate: null,
      fromdate: null,
      warningModal: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns1: [{
        label: "Product Name",
        field: "product_name",
        width: "25% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "15% !important"
      }, {
        label: "Return Qty",
        field: "return_qty",
        width: "10% !important"
      }, {
        label: "Price",
        field: "product_unit_cost",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Sub Total",
        field: "sub_total",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Tax",
        field: "tax_inclusive",
        width: "10% !important"
      }, {
        label: "GST%",
        field: "gst_total",
        width: "15% !important"
      }, {
        label: "Amount",
        field: "amt_before_tax",
        width: "15% !important",
        formatFn: this.formatFn
      }],

      columns: [{
        label: "Purchase Return Id",
        field: "purchase_return_id",
        width: "8% !important"
      }, {
        label: "Purchase Id",
        field: "purchase_id",
        width: "8% !important"
      }, {
        label: "Shop",
        field: "est_shop_name",
        width: "18% !important"
      }, {
        label: "Supplier",
        field: "sup_cmp_name",
        width: "14% !important"
      }, {
        label: this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[localStorage.getItem('companyId') || ''] === 'US' ? "Tax Amount" : "GST Amount",
        field: "gst_total",
        width: "14% !important"
      }, {
        label: "Total Amount",
        field: "total_amt_pay",
        width: "18% !important",
        formatFn: this.formatFn
      }, {
        label: "Date",
        field: "lastupdated_datetime",
        type: "date",
        dateInputFormat: "YYYY-MM-DDThh:mm:ss",
        dateOutputFormat: "Do MMM YYYY",
        width: "10% !important",
        tdClass: "text-left",
        thClass: "text-left"
      }, {
        label: "Action",
        field: "action",
        width: "10% !important"
      }]
    };
  },

  computed: {
    purrt_view: function purrt_view() {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_purrt_view === true) {
          this.purchase("comp");
          this.shopuser("comp");
          return true;
        } else {
          return false;
        }
      }
    },
    purrt_rights: function purrt_rights() {
      return this.$store.getters.get_purrt_rights;
    },
    is_admin: function is_admin() {
      return this.$store.getters.get_is_admin;
    }
  },

  methods: {
    newDate: function newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var dt2 = day + "-" + month + "-" + year;

      return dt2;
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.editpro(this.temprow);
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.editpro(this.temprow);
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        },
        page: 1
      });
      this.editpro(this.temprow);
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.editpro(this.temprow);
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompnay: function onSelectCompnay(selected_company) {
      this.loadItems();
    },
    loadItems: function loadItems() {
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var _this = this;
      var data = [];
      this.rows = [];
      var unit = this.productunit;
      var qty = this.productqty;
      this.loading = true;
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();

      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;

      if (this.todate && this.fromdate) {
        data = data + " &filter[where][lastupdated_datetime][between][0]=" + todate1 + "&filter[where][lastupdated_datetime][between][1]=" + fromdate1;
      } else {
        if (this.todate) {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate) {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit) {
        data = data + "&filter[where][purchase_return_id]=" + unit;
      }

      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }

      this.$http.get("/api/purchasertdetails/getPurchaseRtns?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    purchase: function purchase(val) {
      if (val === "comp") {
        if (this.pfrst_time === false) {
          this.pfrst_time = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
    editpro: function editpro(row) {
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      this.temprow = row;
      var _this = this;
      var data = [];
      var data = data + " &filter[where][purchase_return_id]=" + row.purchase_return_id;
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/purchasertdetails/searchdb?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords1 = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows1 = response.data;
      });
    },
    searchpurchase: function searchpurchase() {
      this.updateParams({
        sort: {
          type: "",
          field: ""
        },
        page: 1
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    },
    removePurchaseReturn: function removePurchaseReturn(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http.delete("api/purchasereturns/removePurchaseReturn?id=" + row.purchase_return_id + "&shp_id=" + row.est_shop_id).then(function (response) {
          if (response.status == 200) {
            setTimeout(function () {
              _this.purchase();
              _this.loading = false;
            }, 2000);
          }
        }).catch(function (error) {
          _this.loading = false;
        });
      }
    }
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      all_unit: null,
      dd_show: true,
      purchase_id: null,
      shop_id: null,
      item_seqnos: null,
      selectsupname: null,
      selectshopname: null,
      amt_rec: '',
      chequeno_validate: '',
      chequedate_validate: '',
      prod_lst: [],

      oldshp: null,
      is_cs_gst: true,
      is_i_gst: true,
      company_gst: '',
      supplier_gst: '',
      variantindex: null,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      totalamtreceived: '',
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      variantdata: null,
      loading: false,
      batchmd: '',
      serialmd: '',
      percentagemd: '',
      amtmd: '',
      inclusive: false,
      indexval: null,
      largeModal: false,
      customername: [],
      selected_pytype: 'full',
      lst_paymenttype: [{ value: 'full', text: 'Full' }, { value: 'partial', text: 'Partial' }, { value: 'no', text: 'No' }],
      selected_pymode: 'cash',
      selectedcustomer: null,
      shopname: [],
      selectshop: null,
      productname: [],
      selectproduct: {},
      rows: [],
      barcode: '',
      haserror: {
        amt: '',
        dis: '',
        cust: '',
        message: '',
        inclusive: '',
        shop: ''
      },
      detail: {
        totprddis: '',
        addition: '',
        tot: '',
        cgst: '',
        sgst: '',
        igst: '',
        taxamt: '',
        totalamtpay: '',
        totalamtpendingpay: ''
      }
    };
  },


  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totaligst: function totaligst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.igst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.sgst) + Number(row.cgst));
      }, 0);
      all = all.toFixed(4);
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == '') {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    var _this2 = this;

    for (var i = 0; i < 3; i++) {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', maxqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '', item_seqno: '' });
    }

    this.shopuser();
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.searchcustomer(), this.searchshops(), this.listproduct(), this.getUnit()]).then(function (ret_val) {
      _this2.loadPurchaseData();
    });
  },


  methods: {
    getUnit: function getUnit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get('/api/Unittypes/getUnit').then(function (response) {
                  _this.all_unit = response.data.data;
                  if (_this.all_unit !== null) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== '') {
        if (regexp.test(this.totalamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalamtreceived = '';
          return;
        } else {
          this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(4);
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalparamtreceived = '';
          return;
        } else {
          this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === 'full') {
        this.fullpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    loadPurchaseData: function loadPurchaseData() {
      if ('purchaseId' in this.$route.params) {
        this.dd_show = false;
        this.rows.length = 0;
        this.purchase_id = this.$route.params.purchaseId;
        this.shop_id = this.$route.params.shopId;
        this.item_seqnos = this.$route.params.itemSeqs;

        var __this = this;
        this.$http.get('/api/purchases/loadData?filter[where][purchase_id]=' + __this.purchase_id + '&filter[where][est_shop_id]=' + __this.shop_id).then(function (res) {

          if (res.status == 200) {
            var select_sup = __this.customername.filter(function (each) {
              return each.supplier_id === res.data.pur_dtl.supplier_id;
            });
            __this.selectedcustomer = select_sup[0];
            __this.selectsupname = __this.selectedcustomer.sup_cmp_name;

            var select_shop = __this.shopname.filter(function (each) {
              return each.est_shop_id === res.data.pur_dtl.est_shop_id;
            });
            __this.selectshop = select_shop[0];
            __this.selectshopname = __this.selectshop.est_shop_name;

            for (var i = 0; i < res.data.item_data.length; i++) {

              if (__this.item_seqnos.indexOf(res.data.item_data[i].item_seq_no) !== -1) {
                var pur_disc_amt = '';
                if (parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(3) != '0.000') {
                  pur_disc_amt = parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(4);
                }

                var pur_disc_pct = '';
                if (parseFloat(res.data.item_data[i].pur_disc_pct).toFixed(3) != '0.000') {
                  pur_disc_pct = parseFloat(res.data.item_data[i].pur_disc_pct);
                }

                var igst = '';
                if (parseFloat(res.data.item_data[i].igst_amt).toFixed(3) != '0.000') {
                  igst = parseFloat(res.data.item_data[i].igst_amt).toFixed(4);
                }

                var sgst = '';
                if (parseFloat(res.data.item_data[i].sgst_amt).toFixed(3) != '0.000') {
                  sgst = parseFloat(res.data.item_data[i].sgst_amt).toFixed(4);
                }

                var cgst = '';
                if (parseFloat(res.data.item_data[i].cgst_amt).toFixed(3) != '0.000') {
                  cgst = parseFloat(res.data.item_data[i].cgst_amt).toFixed(4);
                }

                var show = true;
                var show1 = false;
                var variant_val = '';
                if (res.data.item_data[i].variant_id != null && res.data.item_data[i].variant_id != '') {
                  show = false;
                  show1 = true;
                  variant_val = res.data.item_data[i].variant_id;
                }

                var prod_dt = __this.prod_lst.filter(function (each) {
                  return each.product_id === res.data.item_data[i].product_id;
                });

                var unit_value = '';
                if (res.data.item_data[i].unit_id in __this.all_unit) {
                  unit_value = __this.all_unit[res.data.item_data[i].unit_id];
                }
                __this.rows.push({ productnamex: prod_dt,
                  selectedproductid: '',
                  unit: unit_value,
                  unitvalue: res.data.item_data[i].unit_id,
                  selectproductrow: prod_dt[0],
                  price: res.data.item_data[i].product_unit_cost,
                  qty: res.data.item_data[i].max_qty,
                  amt: res.data.item_data[i].sub_total,
                  cgst: cgst, sgst: sgst, igst: igst,
                  amttotal: res.data.item_data[i].amt_to_pay,
                  batchmd1: res.data.item_data[i].batch, serialmd1: res.data.item_data[i].serialno,
                  percentagemd1: pur_disc_pct, amtmd1: pur_disc_amt,
                  variantrow: variant_val,
                  show: false,
                  show1: true,
                  avaqty: '',
                  maxqty: res.data.item_data[i].max_qty,
                  priceqty: '',
                  inclusive1: res.data.item_data[i].tax_inclusive,
                  err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '',
                  item_seqno: res.data.item_data[i].item_seq_no });
              }
            }
            __this.onSelectSup(__this.selectedcustomer);
          } else {
            console.log('Didnt got response');
          }
        }).catch(function (error) {});
      } else {
        return;
      }
    },
    checkShop: function checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Supplier";
        this.barcode = '';
      } else {
        this.haserror.cust = '';
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = '';
      } else {
        this.haserror.shop = '';
      }
    },
    searchBarcode: function searchBarcode() {
      var option = {};
      var index = 0;
      var addRow = 0;
      var barcode = this.barcode;
      if (this.selectshop != null) {
        var shopid = this.selectshop.est_shop_id;
      }
      this.barcode = '';
      var _this = this;
      var searchText = '';
      if (barcode) {
        this.$http.get('/api/purchasereturns/joinproduct?data=' + searchText + '&data2=' + shopid + '&barcode=' + barcode).then(function (response) {
          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {

            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });
          if (response.data[0]) {
            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: 0, is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '' });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];
            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log('error');
        });
      } else {}
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.sup_cmp_name + ' - ' + item.sup_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    savevatiantmodal: function savevatiantmodal(index) {},
    onSelectvariant: function onSelectvariant(option) {
      var _this = this;
      var valueArr = this.rows.map(function (item) {
        return item;
      });
      var temprow = this.rows[this.variantindex];
      var index = this.variantindex;
      var rowindex = -1;

      if (option.variant_id === 'No Variant') {
        this.rows[this.variantindex]['variantrow'] = 'n/a';
      } else {
        this.rows[this.variantindex]['variantrow'] = option.variant_id;
      }
      this.smallmodal = false;

      if (option.unit_id in this.all_unit) {
        this.rows[index]['unit'] = this.all_unit[option.unit_id];
      }

      this.rows[this.variantindex]['unitvalue'] = option.unit_id;
      this.rows[this.variantindex]['avaqty'] = option.quantity;
      if (option.quantity > 1) {
        this.rows[this.variantindex]['qty'] = 1;
      } else {
        this.rows[this.variantindex]['qty'] = 0;
      }
      this.rows[this.variantindex]['priceqty'] = option.last_purprice_aft;
    },
    show_tax: function show_tax(option, index) {
      var _this = this;
      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + option.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.supplier_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var supplier_gst = _this.supplier_gst.substring(0, 2);
          _this.rows[index]['inclusive1'] = false;
          if (company_gst === supplier_gst) {
            _this.rows[index]['cgst'] = response.data.tax_cgst;
            _this.rows[index]['sgst'] = response.data.tax_sgst;
            _this.rows[index]['igst'] = 0.00;
          } else {
            _this.rows[index]['cgst'] = 0.00;
            _this.rows[index]['sgst'] = 0.00;
            _this.rows[index]['igst'] = response.data.tax_igst;
          }
          _this.price(index);
        } else if (_this.supplier_gst === null || _this.supplier_gst === '') {
          _this.rows[index]['inclusive1'] = true;
          _this.rows[index]['cgst'] = 0.00;
          _this.rows[index]['sgst'] = 0.00;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        } else {
          _this.rows[index]['inclusive1'] = false;
          _this.rows[index]['cgst'] = response.data.tax_cgst;
          _this.rows[index]['sgst'] = response.data.tax_sgst;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        }
      });
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(option, index) {
      var _this = this;
      this.variantindex = index;
      if (option.selectproductrow == undefined) {
        this.rows[index].selectproductrow = option;
      }

      var prdctid = option.selectproductrow == undefined ? option.product_id : this.rows[index].selectproductrow.product_id;
      var shopid = option.selectproductrow == undefined ? option.est_shop_id : this.rows[index].selectproductrow.est_shop_id;

      var tempoption = option.selectproductrow == undefined ? option : option.selectproductrow;
      this.show_tax(tempoption, index);
      this.$http.get('/api/estshopinventories/getinventory?filter[where][product_id]=' + prdctid + '&filter[where][est_shop_id]=' + shopid).then(function (response) {
        _this.rows[index]['selectedproductid'] = response.data;

        if (response.data.length > 1) {
          _this.rows[index]['show'] = true;
          _this.rows[index]['show1'] = false;
          _this.rows[index]['selectedproductid'] = response.data;
          _this.variantvalue = response.data;
          for (var i = 0; i < _this.variantvalue.length; i++) {
            if (_this.variantvalue[i]['variant_id'] === 'n/a') {
              _this.variantvalue[i]['variant_id'] = 'No Variant';
            }
          }
          _this.smallmodal = true;
          if (response.data[0].unit_id in _this.all_unit) {
            _this.rows[index]['unit'] = _this.all_unit[response.data[0].unit_id];
          }
          _this.rows[index]['unitvalue'] = response.data[0].unit_id;
          _this.rows[index]['avaqty'] = response.data[0].quantity;
          if (response.data[0].quantity > 1) {
            _this.rows[index]['qty'] = 1;
          } else {
            _this.rows[index]['qty'] = 0;
          }
          _this.rows[index]['priceqty'] = response.data[0].last_purprice_aft;
          _this.rows[index]['variantrow'] = response.data[0].variant_id;
        } else {
          _this.variantvalue = response.data;
          if (response.data[0].variant_id === "n/a") {
            _this.rows[index]['variantrow'] = "n/a";

            if (response.data[0].unit_id in _this.all_unit) {
              _this.rows[index]['unit'] = _this.all_unit[response.data[0].unit_id];
            }
            _this.rows[index]['unitvalue'] = response.data[0].unit_id;

            _this.rows[index]['avaqty'] = response.data[0].quantity;

            if (response.data[0].quantity > 1) {
              _this.rows[index]['qty'] = 1;
            } else {
              _this.rows[index]['qty'] = 0;
            }

            _this.rows[index]['priceqty'] = response.data[0].last_purprice_aft;

            _this.rows[index]['show'] = false;
            _this.rows[index]['show1'] = true;
          } else {
            if (response.data[0].unit_id in _this.all_unit) {
              _this.rows[index]['unit'] = _this.all_unit[response.data[0].unit_id];
            }
            _this.rows[index]['unitvalue'] = response.data[0].unit_id;
            _this.rows[index]['avaqty'] = response.data[0].quantity;
            _this.rows[index]['priceqty'] = response.data[0].last_purprice_aft;
            if (response.data[0].quantity > 1) {
              _this.rows[index]['qty'] = 1;
            } else {
              _this.rows[index]['qty'] = 0;
            }
            _this.rows[index]['variantrow'] = response.data[0].variant_id;
            _this.rows[index]['show'] = false;
            _this.rows[index]['show1'] = true;
          }
        }
      }).catch(function (error) {});
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.batchmd = '';
      this.serialmd = '';
      this.percentagemd = '';
      this.amtmd = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
    },
    addRow1: function addRow1() {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '' });
    },
    updateSalesTax: function updateSalesTax(index) {
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      if (this.rows[index]['sales_tax'] != '') {
        if (tax.test(this.rows[index]['sales_tax']) == false) {
          this.rows[index]['sales_tax'] = '';
          this.rows[index]['err_salestax'] = 'Invalid';
        } else if (parseFloat(this.rows[index]['sales_tax']) < 0) {
          this.rows[index]['sales_tax'] = '';
          this.rows[index]['err_salestax'] = 'Invalid';
        } else {
          this.rows[index]['err_salestax'] = '';

          var taxMode = this.companyTaxType || 'IN';
          var salesTax = parseFloat(this.rows[index]['sales_tax']);

          if (taxMode === 'IN') {
            this.rows[index]['igst'] = salesTax;
            this.rows[index]['sgst'] = 0;
            this.rows[index]['cgst'] = 0;
          } else {
            this.rows[index]['sgst'] = salesTax / 2;
            this.rows[index]['cgst'] = salesTax / 2;
            this.rows[index]['igst'] = salesTax;
          }
        }
      } else {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_salestax'] = '';
      }
      this.price(index);
    },


    removeElement: function removeElement(index) {
      this.rows.splice(index, 1);
    },

    searchshops: function searchshops() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, len;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.$http.get('/api/shopusers/getShop');

              case 2:
                response = _context2.sent;

                _this4.shopname = response.data;
                len = response.data.length - 1;

                _this4.selectshop = response.data[len];

                if (!(_this4.shopname.length > 0)) {
                  _context2.next = 9;
                  break;
                }

                _this4.company_data();
                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    listproduct: function listproduct() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this = _this5;
                _context3.next = 3;
                return _this5.$http.get('/api/companyproducts');

              case 3:
                response = _context3.sent;

                _this.prod_lst = response.data;

                if (!(_this.prod_lst.length > 0)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    searchprd3: function searchprd3(searchText, index, row) {

      this.haserror.cust = '';
      this.haserror.shop = '';
      var status = 1;
      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Supplier";
      }
      if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }

      if (status == 1) {
        var shopid = this.selectshop.est_shop_id;
        var _this = this;
        var barcode = '';
        if (searchText) {
          this.$http.get('/api/purchasereturns/joinproduct?data=' + searchText + '&data2=' + shopid + '&barcode=' + barcode).then(function (response) {
            row.productnamex = response.data;
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    onSelectShp: function onSelectShp() {
      this.company_data();
      this.onSelectSup(this.selectedcustomer);

      if (this.oldshp != this.selectshop.est_shop_id) {
        this.oldshp = this.selectshop.est_shop_id;
        for (var i = this.rows.length - 1; i >= 0; i--) {
          this.rows.splice(i, 1);
        }
        for (var i = 0; i < 2; i++) {
          this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '' });
        }
      }
    },
    onSelectSup: function onSelectSup(option) {
      this.is_cs_gst = true;
      this.is_i_gst = true;

      if (option.sup_cmp_gst != undefined) {
        this.haserror.cust = '';
        this.supplier_gst = option.sup_cmp_gst;
      }

      if (this.company_gst && this.supplier_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var supplier_gst = this.supplier_gst.substring(0, 2);
        if (company_gst === supplier_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
        }
      } else if (this.supplier_gst === null || this.supplier_gst === '') {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      } else {
        this.is_cs_gst = true;
        this.is_i_gst = true;
      }

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {

            this.show_tax(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    searchcustomer: function searchcustomer() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this = _this6;
                _context4.next = 3;
                return _this6.$http.get('/api/suppliers');

              case 3:
                response = _context4.sent;

                _this.customername = response.data;

                if (!(_this.customername.length > 0)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
      this.haserror.amt = '';
      this.haserror.dis = '';

      if (this.percentagemd != '' && this.amtmd != '') {
        this.haserror.amt = "AnyOne Is Required";
      } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Valid Amount";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]['batchmd1'] = this.batchmd;
        this.rows[val]['serialmd1'] = this.serialmd;
        this.rows[val]['percentagemd1'] = this.percentagemd;
        this.rows[val]['amtmd1'] = this.amtmd;
        this.rows[val]['inclusive1'] = this.inclusive;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition != '') {
        this.detail.addition = '';
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if (parseFloat(this.detail.totalamtpay) <= 0) {
        this.detail.addition = '';
        alert("Addition Discount Cannot Be Greater Than Total Amount To Pay");
      }
    },
    price: function price(index) {
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var num1 = /^[0-9]{1,8}$/;

      if (parseFloat(this.rows[index]['qty']) <= 0.00) {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (price.test(this.rows[index]['qty']) == false && this.rows[index]['qty'] != '') {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (parseFloat(this.rows[index]['qty']) > parseFloat(this.rows[index]['avaqty'])) {
        this.rows[index]['qty'] = '';
        this.rows[index]['err_qty'] = 'Cannot Be Greater Than Available Quantity';
      } else {
        this.rows[index]['err_qty'] = '';
      }

      if (this.rows[index]['price'] == '') {
        this.rows[index]['err_price'] = 'Required';
      } else if (parseFloat(this.rows[index]['price']) <= 0.00) {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else if (price.test(this.rows[index]['price']) == false && this.rows[index]['price'] != '') {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else {
        this.rows[index]['err_price'] = '';
        this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4);
      }

      if (igstexp.test(this.rows[index]['igst']) == false && this.rows[index]['igst'] != '') {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['igst']) < 0) {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else {
        this.rows[index]['err_igst'] = '';
      }

      if (tax.test(this.rows[index]['cgst']) == false && this.rows[index]['cgst'] != 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['cgst']) < 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else {
        this.rows[index]['err_cgst'] = '';
      }

      if (tax.test(this.rows[index]['sgst']) == false && this.rows[index]['sgst'] != 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['sgst']) < 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else {
        this.rows[index]['err_sgst'] = '';
      }

      if (this.rows[index]['igst'] != '' && this.companyTaxType !== 'US') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['sgst'] = 0;
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else if (this.rows[index]['igst'] != '' && this.companyTaxType === 'US') {
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else {
        this.rows[index]['igst'] = '';
        var igst_value = 0;
      }

      if (this.rows[index]['qty'] != '' && this.rows[index]['price'] != '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] == '') {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] != '' && this.rows[index]['price'] == '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] != '') {
        var qty = 0;
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      }

      if (this.rows[index]['percentagemd1'] != '') {
        total = total - total * this.rows[index]['percentagemd1'] / 100;
      }
      if (this.rows[index]['amtmd1'] != '') {
        total = total - parseFloat(this.rows[index]['amtmd1']);
      }

      if (total != undefined) {
        if (this.rows[index]['inclusive1'] == false) {
          this.rows[index]['amt'] = total.toFixed(4);
          var amttotal = total + this.rows[index]['sgst'] * total / 100 + this.rows[index]['cgst'] * total / 100 + igst_value * total / 100;
          amttotal = amttotal.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
        } else if (this.rows[index]['inclusive1'] == true) {
          amttotal = total.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
          var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]['amt'] = bfttotal.toFixed(4);
        }
      }
    },
    finalsubmit: function finalsubmit() {
      this.haserror.message = '';
      this.haserror.cust = '';
      this.haserror.shop = '';
      var submit = 0;
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow != null) {

          if (this.rows[i].price == '') {
            submit = 1;
            this.rows[i].err_price = 'Required';
          } else if (parseFloat(this.rows[i].price) < 0) {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          } else if (price.test(this.rows[i].price) == false && this.rows[i].price != '') {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          }

          if (this.rows[i].qty == '') {
            submit = 1;
            this.rows[i].err_qty = 'Required';
          } else if (parseFloat(this.rows[i].qty) <= 0.00) {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          } else if (price.test(this.rows[i].qty) == false && this.rows[i].qty != '') {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          } else if (this.rows[i].maxqty !== '') {
            if (parseFloat(this.rows[i].qty) > parseFloat(this.rows[i].maxqty)) {
              submit = 1;
              this.rows[i].err_qty = 'Qty should be less than or equal to max qty';
            }
          }

          if (igstexp.test(this.rows[i]['igst']) == false && this.rows[i]['igst'] != '') {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['igst']) < 0) {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['cgst']) == false && this.rows[i]['cgst'] != 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['cgst']) < 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['sgst']) == false && this.rows[i]['sgst'] != 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['sgst']) < 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          }
        }
      }

      if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
        if (this.selectshop == null || this.selectshop.est_shop_id == null) {
          this.haserror.shop = "Please Select Shop";
        }
        if (this.selectedcustomer == null || this.selectedcustomer.supplier_id == null) {
          this.haserror.cust = "Please Select Supplier";
        }
      } else {
        for (var i = this.rows.length - 1; i >= 0; i--) {
          if (this.rows[i].selectproductrow == null) {
            this.rows.splice(i, 1);
          }
        }
        if (this.rows.length == 0) {
          alert("nothing to Save");
        } else {
          var _this = this;
          if (this.detail.totalamtpay == '') {
            alert("Nothing To Save");
          } else {
            if (submit == 0) {
              this.amt_rec = '';
              this.chequeno_validate = '';
              this.chequedate_validate = '';

              if (this.selected_pytype === 'partial') {
                var chk_partail = false;

                if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
                  this.totalparamtreceived = '';
                  this.amt_rec = 'Required';
                  this.bal = 0;
                  chk_partail = true;
                }
                if (parseInt(this.bal) < 0) {
                  this.totalparamtreceived = '';
                  this.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)';
                  this.bal = 0;
                  chk_partail = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                  this.chequeno_validate = 'Required';
                  chk_partail = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                  this.chequedate_validate = 'Required';
                  chk_partail = true;
                }

                if (chk_partail == true) {
                  return;
                }

                this.detail.totalamtpendingpay = this.bal;
              } else if (this.selected_pytype === 'full') {
                this.detail.totalamtpendingpay = 0;
                var chk_full = false;
                if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                  this.chequeno_validate = 'Required';
                  chk_full = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                  this.chequedate_validate = 'Required';
                  chk_full = true;
                }
                if (chk_full == true) {
                  return;
                }
              } else {
                this.detail.totalamtpendingpay = this.detail.totalamtpay;
              }

              if (this.cheque_date != '') {
                var daynum = /^[0-9]{1}$/;
                var date = new Date(this.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = '0' + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = '0' + day;
                } else {
                  var day = day;
                }
                var dateval = year + '-' + month + '-' + day;
              } else {
                var dateval = null;
              }
              this.loading = true;
              var data = {};
              data.suppliersid = this.selectedcustomer.supplier_id;
              data.shopid = this.selectshop.est_shop_id;
              data.pur_items = this.rows;
              data.total_discount = this.detail.totprddis;
              data.additional = this.detail.addition;
              data.amt_before_tax = this.detail.tot;
              data.cgst = this.detail.cgst;
              data.sgst = this.detail.sgst;
              data.igst = this.detail.igst;
              data.taxamt = this.detail.taxamt;
              data.totalamtpay = this.detail.totalamtpay;
              data.purchase_id = this.purchase_id;
              data.totalamtpendingpay = this.detail.totalamtpendingpay;
              data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
              data.pay.paytype = this.selected_pytype;
              data.pay.paymode = this.selected_pymode;
              data.pay.chqno = this.cheque_no;
              data.pay.chqdt = dateval;
              data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay);

              this.$http.post('/api/purchasereturns/rtdata', data).then(function (response) {
                _this.loading = false;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = 'Purchase Returned Successfully';
                setTimeout(function () {
                  _this.haserror.message = '';
                }, 2000);
                if ('purchaseId' in _this.$route.params) {
                  _this.$router.push({ name: 'Purchase Entry' });
                } else {
                  _this.reset();
                }
              }).catch(function (error) {
                _this.loading = false;
              });
            } else {
              return;
            }
          }
        }
      }
    },
    reset: function reset() {
      this.selectedcustomer = null;
      this.selectshop = null;
      this.detail.totprddis = '';
      this.detail.addition = '';
      this.detail.tot = '';
      this.detail.cgst = '';
      this.detail.sgst = '';
      this.detail.igst = '';
      this.detail.taxamt = '';
      this.detail.totalamtpay = '';
      this.detail.totalamtpendingpay = '';
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }
      for (var i = 0; i < 2; i++) {
        this.rows.push({ productnamex: [], selectedproductid: null, unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '' });
      }
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__);





var _methods;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_4__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      all_unit: null,
      dd_show: true,
      purchase_return_id: '',
      purchase_entry_id: null,
      shop_id: '',
      selectsupname: '',
      old_shop_id: null,
      oldshp: null,
      is_cs_gst: true,
      is_i_gst: true,
      remove_rows: [],
      company_gst: '',
      supplier_gst: '',
      variantindex: null,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      amt_rec: "",
      chequeno_validate: "",
      chequedate_validate: "",
      totalamtpreviouspaid: 0.0,
      totalamtreceived: '',
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      variantdata: null,
      loading: false,
      batchmd: '',
      serialmd: '',
      percentagemd: '',
      amtmd: '',
      inclusive: false,
      indexval: null,
      largeModal: false,
      smallmodal1: false,
      suppliername: [],
      selected_pytype: 'full',
      lst_paymenttype: [{ value: 'full', text: 'Full' }, { value: 'partial', text: 'Partial' }, { value: 'no', text: 'No' }],
      selected_pymode: 'cash',
      selectedsupplier: null,
      shopname: [],
      prod_lst: [],
      selectshop: null,
      selectshopname: null,
      productname: [],

      selectproduct: {},
      rows: [],
      barcode: '',
      haserror: {
        amt: '',
        dis: '',
        cust: '',
        message: '',
        inclusive: '',
        shop: ''
      },
      detail: {
        totprddis: '',
        addition: '',
        tot: '',
        cgst: '',
        sgst: '',
        igst: '',
        taxamt: '',
        totalamtpay: '',
        totalamtpendingpay: ''
      }
    };
  },


  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totaligst: function totaligst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.igst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.sgst) + Number(row.cgst));
      }, 0);
      all = all.toFixed(4);
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == '') {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    var _this2 = this;

    for (var i = 0; i < 2; i++) {
      this.rows.push({ productnamex: this.prod_lst, selectedproductid: null, unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', maxqty: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '', item_seqno: '' });
    }

    this.shopuser();


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.searchsupplier(), this.searchshops(), this.listproduct(), this.getUnit()]).then(function (ret_val) {
      _this2.loadPurchaseReturnData();
    });
  },


  methods: (_methods = {
    getUnit: function getUnit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get('/api/Unittypes/getUnit').then(function (response) {
                  _this.all_unit = response.data.data;
                  if (_this.all_unit !== null) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== '') {
        if (regexp.test(this.totalamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalamtreceived = '';
          return;
        } else {
          var paid = parseFloat(this.totalamtreceived) + parseFloat(this.totalamtpreviouspaid);
          this.chng = paid.toFixed(4) - parseFloat(this.detail.totalamtpay);
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalparamtreceived = '';
          return;
        } else {
          var paid = parseFloat(this.totalparamtreceived) + parseFloat(this.totalamtpreviouspaid);
          this.bal = (parseFloat(this.detail.totalamtpay) - paid).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === 'full') {
        this.fullpay = true;
        this.totalamtreceived = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    loadPurchaseReturnData: function loadPurchaseReturnData() {
      this.rows.length = 0;
      this.purchase_return_id = this.$route.params.purchaseReturnId;
      this.shop_id = this.$route.params.shopId;
      this.old_shop_id = this.$route.params.shopId;
      var _this = this;

      var api = '';

      if ('purchaseId' in this.$route.params) {
        this.dd_show = false;
        this.purchase_entry_id = this.$route.params.purchaseId;
        api = '/api/purchasereturns/loadData?filter[where][purchase_return_id]=' + this.purchase_return_id + '&filter[where][est_shop_id]=' + this.shop_id + '&filter[where][purchase_id]=' + this.purchase_entry_id + '&filter[where][item_seqs]=' + this.$route.params.itemSeqs;
      } else {
        api = '/api/purchasereturns/loadData?filter[where][purchase_return_id]=' + this.purchase_return_id + '&filter[where][est_shop_id]=' + this.shop_id;
      }

      this.$http.get(api).then(function (res) {
        if (res.status == 200) {
          _this.detail.totalamtpendingpay = res.data.purrt_dtl.total_amt_pendingpay;

          if (res.data.purrt_dtl.purchase_id !== null) {
            _this.purchase_entry_id = res.data.purrt_dtl.purchase_id;
            _this.dd_show = false;
          }
          var select_sup = _this.suppliername.filter(function (each) {
            return each.supplier_id === res.data.purrt_dtl.supplier_id;
          });
          _this.selectedsupplier = select_sup[0];
          var select_shop = _this.shopname.filter(function (each) {
            return each.est_shop_id === res.data.purrt_dtl.est_shop_id;
          });
          _this.selectshop = select_shop[0];
          _this.selectshopname = _this.selectshop.est_shop_name;
          if (_this.dd_show === false) {
            _this.selectsupname = _this.selectedsupplier.sup_cmp_name;
          }

          if (parseFloat(res.data.purrt_dtl.total_amt_pendingpay) === 0) {

            _this.selected_pytype = 'full';
            _this.selected_pymode = 'cash';
            _this.parpay = false;
            _this.fullpay = true;
            _this.totalamtpreviouspaid = parseFloat(res.data.purrt_dtl.total_amt_pay).toFixed(4);
          } else if (parseFloat(res.data.purrt_dtl.total_amt_pay) === parseFloat(res.data.purrt_dtl.total_amt_pendingpay)) {
            _this.selected_pytype = 'no';
            _this.parpay = false;
            _this.fullpay = false;
          } else {
            _this.selected_pytype = 'partial';
            _this.selected_pymode = 'cash';
            _this.parpay = true;
            _this.fullpay = false;
            _this.totalamtpreviouspaid = (parseFloat(res.data.purrt_dtl.total_amt_pay) - parseFloat(res.data.purrt_dtl.total_amt_pendingpay)).toFixed(4);
            _this.bal = parseFloat(res.data.purrt_dtl.total_amt_pendingpay).toFixed(4);
          }

          for (var i = 0; i < res.data.item_data.length; i++) {
            var pur_disc_amt = '';
            if (parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(3) != '0.000') {
              pur_disc_amt = parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(4);
            }

            var pur_disc_pct = '';
            if (parseFloat(res.data.item_data[i].pur_disc_pct).toFixed(3) != '0.000') {
              pur_disc_pct = parseFloat(res.data.item_data[i].pur_disc_pct);
            }

            var igst = '';
            if (parseFloat(res.data.item_data[i].igst_amt).toFixed(3) != '0.000') {
              igst = parseFloat(res.data.item_data[i].igst_amt).toFixed(4);
            }

            var sgst = '';
            if (parseFloat(res.data.item_data[i].sgst_amt).toFixed(3) != '0.000') {
              sgst = parseFloat(res.data.item_data[i].sgst_amt).toFixed(4);
            }

            var cgst = '';
            if (parseFloat(res.data.item_data[i].cgst_amt).toFixed(3) != '0.000') {
              cgst = parseFloat(res.data.item_data[i].cgst_amt).toFixed(4);
            }

            var show = true;
            var show1 = false;
            var variant_val = '';
            if (res.data.item_data[i].variant_id != null && res.data.item_data[i].variant_id != '') {
              show = false;
              show1 = true;
              variant_val = res.data.item_data[i].variant_id;
            }

            var prod_dt = _this.prod_lst.filter(function (each) {
              return each.product_id === res.data.item_data[i].product_id;
            });

            var rowqty = '0';
            var mxqty = '';
            var avqty = '';
            var pqty = '';
            var item_key = '';
            var set_return_qty = 0;
            if ('purchase_qty' in res.data.item_data[i]) {
              item_key = 'item_seq_no';
              if (parseFloat(res.data.stock_val[i].avaqty) < parseFloat(res.data.item_data[i].purchase_qty)) {
                rowqty = res.data.stock_val[i].avaqty;
              } else {
                rowqty = res.data.item_data[i].purchase_qty;
              }
            } else {
              item_key = 'item_seq';
              rowqty = res.data.item_data[i].return_qty;
            }


            if (res.data.puritem_qty !== null) {
              set_return_qty = parseFloat(res.data.item_data[i].return_qty) + parseFloat(res.data.stock_val[i].avaqty);
              if (set_return_qty < parseFloat(res.data.puritem_qty[res.data.item_data[i][item_key]]['p_qty'])) {
                mxqty = set_return_qty;
              } else {
                mxqty = res.data.puritem_qty[res.data.item_data[i][item_key]]['p_qty'];
              }

              pqty = res.data.puritem_qty[res.data.item_data[i][item_key]]['prod_unit_cost'];
            } else {
              avqty = res.data.stock_val[i].avaqty;
              pqty = res.data.stock_val[i].priceqty;
              mxqty = parseFloat(res.data.item_data[i].return_qty) + parseFloat(res.data.stock_val[i].avaqty);
            }

            var unit_value = '';
            if (res.data.item_data[i].unit_id in _this.all_unit) {
              unit_value = _this.all_unit[res.data.item_data[i].unit_id];
            }
            _this.rows.push({ productnamex: prod_dt,
              selectedproductid: null,
              unit: unit_value,
              unitvalue: res.data.item_data[i].unit_id,
              selectproductrow: prod_dt[0],
              price: res.data.item_data[i].product_unit_cost,
              qty: rowqty,
              old_qty: rowqty,
              maxqty: mxqty,
              amt: res.data.item_data[i].sub_total,
              cgst: cgst, sgst: sgst, igst: igst,
              sales_tax: (parseFloat(cgst || 0) + parseFloat(sgst || 0)).toString(),
              amttotal: res.data.item_data[i].amt_to_pay,
              batchmd1: res.data.item_data[i].batch, serialmd1: res.data.item_data[i].serialno,
              percentagemd1: pur_disc_pct, amtmd1: pur_disc_amt,
              variantrow: variant_val,
              show: false,
              show1: true,
              avaqty: avqty,
              priceqty: pqty,
              inclusive1: res.data.item_data[i].tax_inclusive,
              err_qty: '',
              err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '',
              item_seqno: res.data.item_data[i][item_key] });
          }
          _this.onSelectSup(_this.selectedsupplier);
        } else {
          console.log('Didnt got response');
        }
      }).catch(function (error) {});
    },
    checkShop: function checkShop() {
      if (!this.selectedsupplier) {
        this.haserror.cust = "Select Supplier";
        this.barcode = '';
      } else {
        this.haserror.cust = '';
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = '';
      } else {
        this.haserror.shop = '';
      }
    },
    searchBarcode: function searchBarcode() {
      var option = {};
      var index = 0;
      var addRow = 0;
      var barcode = this.barcode;
      if (this.selectshop != null) {
        var shopid = this.selectshop.est_shop_id;
      }
      this.barcode = '';
      var _this = this;
      var searchText = '';
      if (barcode) {
        this.$http.get('/api/purchasereturns/joinproduct?data=' + searchText + '&data2=' + shopid + '&barcode=' + barcode).then(function (response) {
          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {

            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });
          if (response.data[0]) {
            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: 0, is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '' });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];
            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log('error');
        });
      } else {}
    },
    listproduct: function listproduct() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this4;
                _context2.next = 3;
                return _this4.$http.get('/api/companyproducts');

              case 3:
                response = _context2.sent;

                _this.prod_lst = response.data;

                if (!(_this.prod_lst.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.sup_cmp_name + ' - ' + item.sup_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    onSelectvariant: function onSelectvariant(option) {
      var _this = this;
      var valueArr = this.rows.map(function (item) {
        return item;
      });
      var temprow = this.rows[this.variantindex];
      var index = this.variantindex;
      var rowindex = -1;

      if (option.variant_id === 'No Variant') {
        this.rows[this.variantindex]['variantrow'] = 'n/a';
      } else {
        this.rows[this.variantindex]['variantrow'] = option.variant_id;
      }
      this.smallmodal = false;

      if (option.unit_id in this.all_unit) {
        this.rows[index]['unit'] = this.all_unit[option.unit_id];
      }
      this.rows[index]['unitvalue'] = option.unit_id;

      this.rows[this.variantindex]['avaqty'] = option.quantity;
      if (option.quantity > 1) {
        this.rows[this.variantindex]['qty'] = 1;
      } else {
        this.rows[this.variantindex]['qty'] = 0;
      }
      this.rows[this.variantindex]['priceqty'] = option.last_purprice_aft;
    },
    show_tax: function show_tax(option, index) {
      var _this = this;
      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + option.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.supplier_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var supplier_gst = _this.supplier_gst.substring(0, 2);

          if (company_gst === supplier_gst) {
            _this.rows[index]['cgst'] = response.data.tax_cgst;
            _this.rows[index]['sgst'] = response.data.tax_sgst;
            _this.rows[index]['igst'] = 0.00;
          } else {
            _this.rows[index]['cgst'] = 0.00;
            _this.rows[index]['sgst'] = 0.00;
            _this.rows[index]['igst'] = response.data.tax_igst;
          }
          _this.price(index);
        } else if (_this.supplier_gst === null || _this.supplier_gst === '') {
          _this.rows[index]['cgst'] = 0.00;
          _this.rows[index]['sgst'] = 0.00;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        } else {
          _this.rows[index]['cgst'] = response.data.tax_cgst;
          _this.rows[index]['sgst'] = response.data.tax_sgst;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        }
      });
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(option, index) {
      var _this = this;
      this.variantindex = index;
      if (option.selectproductrow == undefined) {
        this.rows[index].selectproductrow = option;
      }

      var prdctid = option.selectproductrow == undefined ? option.product_id : this.rows[index].selectproductrow.product_id;
      var shopid = option.selectproductrow == undefined ? option.est_shop_id : this.rows[index].selectproductrow.est_shop_id;
      var tempoption = option.selectproductrow == undefined ? option : option.selectproductrow;
      this.show_tax(tempoption, index);
      this.$http.get('/api/estshopinventories/getinventory?filter[where][product_id]=' + prdctid + '&filter[where][est_shop_id]=' + shopid).then(function (response) {

        _this.rows[index]['selectedproductid'] = response.data;

        if (response.data.length > 1) {
          _this.smallmodal = true;
          _this.rows[index]['show'] = true;
          _this.rows[index]['show1'] = false;
          _this.rows[index]['selectedproductid'] = response.data;
          _this.variantvalue = response.data;
          for (var i = 0; i < _this.variantvalue.length; i++) {
            if (_this.variantvalue[i]['variant_id'] === 'n/a') {
              _this.variantvalue[i]['variant_id'] = 'No Variant';
            }
          }

          if (response.data[0].unit_id in _this.all_unit) {
            _this.rows[index]['unit'] = _this.all_unit[response.data[0].unit_id];
          }
          _this.rows[index]['unitvalue'] = response.data[0].unit_id;
          _this.rows[index]['avaqty'] = response.data[0].quantity;
          if (response.data[0].quantity > 1) {
            _this.rows[index]['qty'] = 1;
          } else {
            _this.rows[index]['qty'] = 0;
          }
          _this.rows[index]['priceqty'] = response.data[0].last_purprice_aft;
          _this.rows[index]['variantrow'] = response.data[0].variant_id;
        } else {
          _this.variantvalue = response.data;
          if (response.data[0].variant_id == "n/a") {
            _this.rows[index]['variantrow'] = "n/a";
            if (response.data[0].unit_id in _this.all_unit) {
              _this.rows[index]['unit'] = _this.all_unit[response.data[0].unit_id];
            }
            _this.rows[index]['unitvalue'] = response.data[0].unit_id;

            _this.rows[index]['avaqty'] = response.data[0].quantity;

            if (response.data[0].quantity > 1) {
              _this.rows[index]['qty'] = 1;
            } else {
              _this.rows[index]['qty'] = 0;
            }

            _this.rows[index]['priceqty'] = response.data[0].last_purprice_aft;

            _this.rows[index]['show'] = false;
            _this.rows[index]['show1'] = true;
          } else {
            if (response.data[0].unit_id in _this.all_unit) {
              _this.rows[index]['unit'] = _this.all_unit[response.data[0].unit_id];
            }
            _this.rows[index]['unitvalue'] = response.data[0].unit_id;

            _this.rows[index]['avaqty'] = response.data[0].quantity;
            _this.rows[index]['priceqty'] = response.data[0].last_purprice_aft;
            if (response.data[0].quantity > 1) {
              _this.rows[index]['qty'] = 1;
            } else {
              _this.rows[index]['qty'] = 0;
            }
            _this.rows[index]['variantrow'] = response.data[0].variant_id;
            _this.rows[index]['show'] = false;
            _this.rows[index]['show1'] = true;
          }
        }
      }).catch(function (error) {});
    },
    updateshop: function updateshop() {
      this.loading = true;
      var _this = this;
      this.$http.post('/api/purchasereturns/updateShop?filter[where][purchase_return_id]=' + this.purchase_return_id + '&filter[where][old_shop_id]=' + this.old_shop_id + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id).then(function (response) {

        if (response.status == 200) {
          if (response.data.data == 'Successful') {

            _this.$route.params.shopId = _this.selectshop.est_shop_id;
            setTimeout(function () {
              _this.loadPurchaseReturnData();_this.smallmodal1 = false;_this.loading = false;
            }, 1000);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.haserror.message = 'Purchase Return Updated Successfully';
            setTimeout(function () {
              _this.haserror.message = '';
            }, 3000);
          }
        }
      }).catch(function (error) {});
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.batchmd = '';
      this.serialmd = '';
      this.percentagemd = '';
      this.amtmd = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
    },
    addRow1: function addRow1() {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '', item_seqno: '' });
    },
    updateSalesTax: function updateSalesTax(index) {
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      if (this.rows[index]['sales_tax'] != '') {
        if (tax.test(this.rows[index]['sales_tax']) == false) {
          this.rows[index]['sales_tax'] = '';
          this.rows[index]['err_salestax'] = 'Invalid';
        } else if (parseFloat(this.rows[index]['sales_tax']) < 0) {
          this.rows[index]['sales_tax'] = '';
          this.rows[index]['err_salestax'] = 'Invalid';
        } else {
          this.rows[index]['err_salestax'] = '';

          var taxMode = this.companyTaxType || 'IN';
          var salesTax = parseFloat(this.rows[index]['sales_tax']);

          if (taxMode === 'IN') {
            this.rows[index]['igst'] = salesTax;
            this.rows[index]['sgst'] = 0;
            this.rows[index]['cgst'] = 0;
          } else {
            var splitTax = salesTax / 2;
            this.rows[index]['igst'] = salesTax;
            this.rows[index]['sgst'] = splitTax;
            this.rows[index]['cgst'] = splitTax;
          }
        }
      } else {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_salestax'] = '';
      }
      this.price(index);
    },


    removeElement: function removeElement(index) {
      if (this.rows[index].item_seqno != '') {
        this.remove_rows.push(this.rows[index]);
        this.rows.splice(index, 1);
      } else {
        this.rows.splice(index, 1);
        this.loading = false;
      }
    }

  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'updateSalesTax', function updateSalesTax(index) {
    var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
    if (this.rows[index]['sales_tax'] != '') {
      if (tax.test(this.rows[index]['sales_tax']) == false) {
        this.rows[index]['sales_tax'] = '';
        this.rows[index]['err_salestax'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['sales_tax']) < 0) {
        this.rows[index]['sales_tax'] = '';
        this.rows[index]['err_salestax'] = 'Invalid';
      } else {
        this.rows[index]['err_salestax'] = '';

        var taxMode = this.companyTaxType || 'IN';
        var salesTax = parseFloat(this.rows[index]['sales_tax']);

        if (taxMode === 'IN') {
          this.rows[index]['igst'] = salesTax;
          this.rows[index]['sgst'] = 0;
          this.rows[index]['cgst'] = 0;
        } else {
          var splitTax = salesTax / 2;
          this.rows[index]['igst'] = salesTax;
          this.rows[index]['sgst'] = splitTax;
          this.rows[index]['cgst'] = splitTax;
        }
      }
    } else {
      this.rows[index]['sgst'] = 0;
      this.rows[index]['cgst'] = 0;
      this.rows[index]['err_salestax'] = '';
    }
    this.price(index);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'manage_pre_paid', function manage_pre_paid() {
    if (parseFloat(this.totalamtpreviouspaid) > parseFloat(this.totalamtpay)) {
      this.paychange("full");
      this.modechange("cash");

      this.totalparamtreceived = "";

      this.totalamtreceived = "";
      this.totamtrecdis = true;
    } else if (parseFloat(this.totalamtpreviouspaid) == parseFloat(this.totalamtpay)) {
      this.paychange("full");
      this.modechange("cash");

      this.totalparamtreceived = "";
      this.totalamtreceived = "";
      this.totamtrecdis = true;
    } else {
      this.paychange("partial");
      this.modechange("cash");

      this.totalparamtreceived = "";
      this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid)).toFixed(4);
      this.totamtrecdis = false;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'searchshops', function searchshops() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _this, response, len;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this5;
              _context3.next = 3;
              return _this5.$http.get('/api/shopusers/getShop');

            case 3:
              response = _context3.sent;

              _this5.shopname = response.data;
              len = response.data.length - 1;

              _this5.selectshop = response.data[len];

              if (!(_this5.shopname.length > 0)) {
                _context3.next = 10;
                break;
              }

              _this5.company_data();
              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true));

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'searchprd3', function searchprd3(searchText, index, row) {
    this.haserror.cust = '';
    this.haserror.shop = '';
    var status = 1;
    if (this.selectedsupplier == null || this.selectedsupplier.supplier_id === undefined) {
      status = 0;
      this.haserror.cust = "Please Select Supplier";
    }
    if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
      status = 0;
      this.haserror.shop = "Please Select Shop";
    }

    if (status == 1) {
      var shopid = this.selectshop.est_shop_id;
      var _this = this;
      var barcode = '';
      if (searchText) {
        this.$http.get('/api/purchasereturns/joinproduct?data=' + searchText + '&data2=' + shopid + '&barcode=' + barcode).then(function (response) {
          row.productnamex = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'onSelectShp', function onSelectShp() {
    if (this.oldshp != this.selectshop.est_shop_id) {
      this.oldshp = this.selectshop.est_shop_id;
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }
      for (var i = 0; i < 2; i++) {
        this.rows.push({ productnamex: [], selectedproductid: null, unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '' });
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'onSelectSup', function onSelectSup(option) {
    this.is_cs_gst = true;
    this.is_i_gst = true;

    if (option.sup_cmp_gst != undefined) {
      this.haserror.cust = '';
      this.supplier_gst = option.sup_cmp_gst;
    }

    if (this.company_gst && this.supplier_gst) {
      var company_gst = this.company_gst.substring(0, 2);
      var supplier_gst = this.supplier_gst.substring(0, 2);
      if (company_gst === supplier_gst) {
        this.is_cs_gst = true;
        this.is_i_gst = false;
      } else {
        this.is_cs_gst = false;
        this.is_i_gst = true;
      }
    } else if (this.supplier_gst === null || this.supplier_gst === '') {
      this.is_cs_gst = false;
      this.is_i_gst = false;
    } else {
      this.is_cs_gst = true;
      this.is_i_gst = true;
    }

    if (this.rows.length > 0) {
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].selectproductrow != null) {
          this.show_tax(this.rows[i].selectproductrow, i);
        }
      }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'searchsupplier', function searchsupplier() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this, response;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this6;
              _context4.next = 3;
              return _this6.$http.get('/api/suppliers');

            case 3:
              response = _context4.sent;

              _this6.suppliername = response.data;

              if (!(_this6.suppliername.length > 0)) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true));

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this6);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'savemodal', function savemodal(val) {
    var num = /^([0-9]{1,2}|100)$/;
    var num1 = /^[0-9]{1,12}$/;
    var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
    this.haserror.amt = '';
    this.haserror.dis = '';

    if (this.percentagemd != '' && this.amtmd != '') {
      this.haserror.amt = "AnyOne Is Required";
    } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
      this.haserror.dis = "Please Provide Integer Between 1-100";
    } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
      this.haserror.amt = "Please Provide Valid Amount";
    } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
      this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
    } else {
      this.rows[val]['batchmd1'] = this.batchmd;
      this.rows[val]['serialmd1'] = this.serialmd;
      this.rows[val]['percentagemd1'] = this.percentagemd;
      this.rows[val]['amtmd1'] = this.amtmd;
      this.rows[val]['inclusive1'] = this.inclusive;
      this.largeModal = false;
      this.price(val);
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'discountadd', function discountadd() {
    var num = /^\d{1,12}(\.\d{1,6})?$/;
    if (num.test(this.detail.addition) == false && this.detail.addition != '') {
      this.detail.addition = '';
      alert("Please Provide Valid Integer For Additional Discount");
    }
    if (parseFloat(this.detail.totalamtpay) <= 0) {
      this.detail.addition = '';
      alert("Addition Discount Cannot Be Greater Than Total Amount To Pay");
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'price', function price(index) {
    var num = /^[0-9]{1,11}$/;
    var price = /^\d{1,12}(\.\d{1,6})?$/;
    var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
    var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
    var num1 = /^[0-9]{1,8}$/;
    var avaqty = parseFloat(this.rows[index]['avaqty']) + parseFloat(this.rows[index]['qty']);
    if (parseFloat(this.rows[index]['qty']) <= 0.00) {
      this.rows[index]['err_qty'] = 'Invalid Quantity';
    } else if (price.test(this.rows[index]['qty']) == false && this.rows[index]['qty'] != '') {
      this.rows[index]['err_qty'] = 'Invalid Quantity';
    } else if (parseFloat(this.rows[index]['qty']) > avaqty) {
      this.rows[index]['qty'] = '';
      this.rows[index]['err_qty'] = 'Cannot Be Greater Than Available Quantity';
    } else if (parseFloat(this.rows[index]['qty']) > parseFloat(this.rows[index]['maxqty'])) {
      this.rows[index]['err_qty'] = 'Qty should be less than or equal to max qty';
    } else {
      this.rows[index]['err_qty'] = '';
    }

    if (this.rows[index]['price'] == '') {
      this.rows[index]['err_price'] = 'Required';
    } else if (parseFloat(this.rows[index]['price']) < 0) {
      this.rows[index]['err_price'] = 'Invalid Price';
    } else if (price.test(this.rows[index]['price']) == false && this.rows[index]['price'] != '') {
      this.rows[index]['err_price'] = 'Invalid Price';
    } else {
      this.rows[index]['err_price'] = '';
      this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4);
    }

    if (igstexp.test(this.rows[index]['igst']) == false && this.rows[index]['igst'] != '') {
      this.rows[index]['igst'] = '';
      this.rows[index]['err_igst'] = 'Invalid';
    } else if (parseFloat(this.rows[index]['igst']) < 0) {
      this.rows[index]['igst'] = '';
      this.rows[index]['err_igst'] = 'Invalid';
    } else {
      this.rows[index]['err_igst'] = '';
    }

    if (tax.test(this.rows[index]['cgst']) == false && this.rows[index]['cgst'] != 0) {
      this.rows[index]['cgst'] = 0;
      this.rows[index]['err_cgst'] = 'Invalid';
    } else if (parseFloat(this.rows[index]['cgst']) < 0) {
      this.rows[index]['cgst'] = 0;
      this.rows[index]['err_cgst'] = 'Invalid';
    } else {
      this.rows[index]['err_cgst'] = '';
    }

    if (tax.test(this.rows[index]['sgst']) == false && this.rows[index]['sgst'] != 0) {
      this.rows[index]['sgst'] = 0;
      this.rows[index]['err_sgst'] = 'Invalid';
    } else if (parseFloat(this.rows[index]['sgst']) < 0) {
      this.rows[index]['sgst'] = 0;
      this.rows[index]['err_sgst'] = 'Invalid';
    } else {
      this.rows[index]['err_sgst'] = '';
    }

    if (this.rows[index]['igst'] != '' && this.companyTaxType !== 'US') {
      this.rows[index]['cgst'] = 0;
      this.rows[index]['sgst'] = 0;
      var igst_value = parseFloat(this.rows[index]['igst']);
    } else if (this.rows[index]['igst'] != '' && this.companyTaxType === 'US') {
      var igst_value = parseFloat(this.rows[index]['igst']);
    } else {
      this.rows[index]['igst'] = '';
      var igst_value = 0;
    }

    if (this.rows[index]['qty'] != '' && this.rows[index]['price'] != '') {
      var qty = parseFloat(this.rows[index]['qty']);
      var price = parseFloat(this.rows[index]['price']);
      var total = qty * price;
    } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] == '') {
      var qty = 0;
      var price = 0;
      var total = qty * price;
    } else if (this.rows[index]['qty'] != '' && this.rows[index]['price'] == '') {
      var qty = parseFloat(this.rows[index]['qty']);
      var price = 0;
      var total = qty * price;
    } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] != '') {
      var qty = 0;
      var price = parseFloat(this.rows[index]['price']);
      var total = qty * price;
    }

    if (this.rows[index]['percentagemd1'] != '') {
      total = total - total * this.rows[index]['percentagemd1'] / 100;
    }
    if (this.rows[index]['amtmd1'] != '') {
      total = total - parseFloat(this.rows[index]['amtmd1']);
    }

    if (total != undefined) {
      if (this.rows[index]['inclusive1'] == false) {
        this.rows[index]['amt'] = total.toFixed(4);;
        var amttotal = total + this.rows[index]['sgst'] * total / 100 + this.rows[index]['cgst'] * total / 100 + igst_value * total / 100;
        amttotal = amttotal.toFixed(4);
        this.rows[index]['amttotal'] = amttotal;
      } else if (this.rows[index]['inclusive1'] == true) {
        amttotal = total.toFixed(4);
        this.rows[index]['amttotal'] = amttotal;
        var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value;
        var bfttotal = total * (100 / (100 + total_percentage));
        this.rows[index]['amt'] = bfttotal.toFixed(4);
      }
    }
    this.manage_pre_paid();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'finalsubmit', function finalsubmit() {
    this.haserror.message = '';
    this.haserror.cust = '';
    this.haserror.shop = '';
    var submit = 0;
    var num = /^[0-9]{1,11}$/;
    var price = /^\d{1,12}(\.\d{1,6})?$/;
    var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
    var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

    for (var i = this.rows.length - 1; i >= 0; i--) {
      if (this.rows[i].selectproductrow != null) {

        if (this.rows[i].price == '') {
          submit = 1;
          this.rows[i].err_price = 'Required';
        } else if (parseFloat(this.rows[i].price) < 0) {
          submit = 1;
          this.rows[i].err_price = 'Invalid Price';
        } else if (price.test(this.rows[i].price) == false && this.rows[i].price != '') {
          submit = 1;
          this.rows[i].err_price = 'Invalid Price';
        }

        if (this.rows[i].qty == '') {
          submit = 1;
          this.rows[i].err_qty = 'Required';
        } else if (parseFloat(this.rows[i].qty) <= 0.00) {
          submit = 1;
          this.rows[i].err_qty = 'Invalid Quantity';
        } else if (num.test(this.rows[i].qty) == false && this.rows[i].qty != '') {
          submit = 1;
          this.rows[i].err_qty = 'Invalid Quantity';
        } else if (this.rows[i].maxqty !== '') {
          if (parseFloat(this.rows[i].qty) > parseFloat(this.rows[i].maxqty)) {
            submit = 1;
            this.rows[i].err_qty = 'Qty should be less than or equal to max qty';
          }
        }

        if (igstexp.test(this.rows[i]['igst']) == false && this.rows[i]['igst'] != '') {
          this.rows[i]['igst'] = '';
          this.rows[i]['err_igst'] = 'Invalid';
          submit = 1;
        } else if (parseFloat(this.rows[i]['igst']) < 0) {
          this.rows[i]['igst'] = '';
          this.rows[i]['err_igst'] = 'Invalid';
          submit = 1;
        }

        if (tax.test(this.rows[i]['cgst']) == false && this.rows[i]['cgst'] != 0) {
          this.rows[i]['cgst'] = 0;
          this.rows[i]['err_cgst'] = 'Invalid';
          submit = 1;
        } else if (parseFloat(this.rows[i]['cgst']) < 0) {
          this.rows[i]['cgst'] = 0;
          this.rows[i]['err_cgst'] = 'Invalid';
          submit = 1;
        }

        if (tax.test(this.rows[i]['sgst']) == false && this.rows[i]['sgst'] != 0) {
          this.rows[i]['sgst'] = 0;
          this.rows[i]['err_sgst'] = 'Invalid';
          submit = 1;
        } else if (parseFloat(this.rows[i]['sgst']) < 0) {
          this.rows[i]['sgst'] = 0;
          this.rows[i]['err_sgst'] = 'Invalid';
          submit = 1;
        }
      }
    }

    if (this.selectedsupplier == null || this.selectedsupplier.supplier_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
      if (this.selectshop == null || this.selectshop.est_shop_id == null) {
        this.haserror.shop = "Please Select Shop";
      }
      if (this.selectedsupplier == null || this.selectedsupplier.supplier_id == null) {
        this.haserror.cust = "Please Select Supplier";
      }
    } else {
      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow == null) {
          this.rows.splice(i, 1);
        }
      }
      if (this.rows.length == 0) {
        alert("nothing to Save");
      } else {
        var _this = this;
        if (this.detail.totalamtpay == '') {
          alert("Nothing To Save");
        } else {
          if (submit == 0) {
            this.amt_rec = "";
            this.chequeno_validate = "";
            this.chequedate_validate = "";

            var amount_pay = 0.0;
            if (this.selected_pytype === "full") {
              var chk_full = false;
              if (parseFloat(this.chng) < 0.0) {
                this.amt_rec = "Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)";
                this.totalamtreceived = "";
                this.chng = 0;
                chk_full = true;
              }
              if (this.selected_pymode == "cheque" && this.cheque_no == "") {
                this.chequeno_validate = "Required";
                chk_full = true;
              }
              if (this.selected_pymode == "cheque" && this.cheque_date == "") {
                this.chequedate_validate = "Required";
                chk_full = true;
              }
              if (chk_full == true) {
                return;
              } else {
                amount_pay = this.totalamtreceived;
                this.detail.totalamtpendingpay = 0;
              }
            } else if (this.selected_pytype === "partial") {
              var chk_partail = false;
              if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == "") {
                this.totalparamtreceived = "";
                this.amt_rec = "Required";
                this.bal = 0;
                chk_partail = true;
              }
              if (parseInt(this.bal) < 0) {
                this.totalparamtreceived = "";
                this.amt_rec = "Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)";
                this.bal = 0;
                chk_partail = true;
              }
              if (this.selected_pymode == "cheque" && this.cheque_no == "") {
                this.chequeno_validate = "Required";
                chk_partail = true;
              }
              if (this.selected_pymode == "cheque" && this.cheque_date == "") {
                this.chequedate_validate = "Required";
                chk_partail = true;
              }

              if (chk_partail == true) {
                return;
              } else {
                this.detail.totalamtpendingpay = this.bal;
                amount_pay = this.totalparamtreceived;
              }
            } else {
              this.detail.totalamtpendingpay = this.detail.totalamtpay - this.totalamtpreviouspaid;
              amount_pay = 0;
            }

            if (this.cheque_date != "") {
              var daynum = /^[0-9]{1}$/;
              var date = new Date(this.cheque_date);
              var year = date.getFullYear();
              var month = date.getMonth() + 1;
              var day = date.getDate();

              if (daynum.test(month) == true) {
                var month = "0" + month;
              } else {
                var month = month;
              }

              if (daynum.test(day) == true) {
                var day = "0" + day;
              } else {
                var day = day;
              }
              var dateval = year + "-" + month + "-" + day;
            } else {
              var dateval = null;
            }

            this.loading = true;
            var data = {};
            data.purchase_return_id = this.purchase_return_id;
            data.suppliersid = this.selectedsupplier.supplier_id;
            data.shopid = this.selectshop.est_shop_id;
            data.remove_pur_items = this.remove_rows;
            data.pur_items = this.rows;
            data.total_discount = this.detail.totprddis;
            data.additional = this.detail.addition;
            data.amt_before_tax = this.detail.tot;
            data.cgst = this.detail.cgst;
            data.sgst = this.detail.sgst;
            data.igst = this.detail.igst;
            data.taxamt = this.detail.taxamt;
            data.totalamtpay = this.detail.totalamtpay;
            data.purchase_id = this.purchase_entry_id;
            data.totalamtpendingpay = this.detail.totalamtpendingpay;
            data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
            data.pay.paytype = this.selected_pytype;
            data.pay.paymode = this.selected_pymode;
            data.pay.chqno = this.cheque_no;
            data.pay.chqdt = dateval;
            data.pay.amt = amount_pay;
            this.$http.post('/api/purchasereturns/editdata', data).then(function (response) {
              setTimeout(function () {
                _this.loadPurchaseReturnData();_this.loading = false;
              }, 3000);
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              _this.haserror.message = 'Purchase Return Updated Successfully';
              setTimeout(function () {
                _this.haserror.message = '';
              }, 2000);

              if ('purchaseId' in _this.$route.params) {
                _this.$router.push({ name: 'Purchase Entry' });
              } else {
                _this.reset();
              }
            }).catch(function (error) {
              _this.loading = false;
            });
          }
        }
      }
    }
  }), _methods),

  reset: function reset() {
    this.selectedsupplier = null;
    this.selectshop = null;
    this.detail.totprddis = '';
    this.detail.addition = '';
    this.detail.tot = '';
    this.detail.cgst = '';
    this.detail.sgst = '';
    this.detail.igst = '';
    this.detail.taxamt = '';
    this.detail.totalamtpay = '';
    this.detail.totalamtpendingpay = '';
    for (var i = this.rows.length - 1; i >= 0; i--) {
      this.rows.splice(i, 1);
    }
    for (var i = 0; i < 2; i++) {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', show: false, show1: false, avaqty: '', priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '', item_seqno: '' });
    }
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_editor__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'supplier',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_4_vue2_editor__["VueEditor"], Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      access_token: null,
      plan_modal: false,
      customToolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }]],
      comf_time: false,
      cfrst_time: false,
      supfrst_time: false,
      shpfrst_time: false,
      supplier_id: '',
      largeModal1: false,
      largeModal: false,
      editBtn: false,
      saveBtn: true,
      loading: false,
      suptype: null,
      city: null,
      state: null,
      con: null,
      cityopt: [],
      stateopt: [],
      maximumSize: 500000,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      conopt: [],
      contyp: [],
      srch_cmptyp: [],
      display: {
        name: null,
        cmptyp: null,
        email: null,
        add1: null
      },

      supplier: {
        add: '',
        name: '',
        add2: '',
        pin: '',
        phone: '',
        email: '',
        gst: '',
        pan: '',
        cin: '',
        tan: '',
        contact: '',
        contactno: '',
        contactemail: '',
        profile: '',
        image: '',
        bankname: '',
        banknumber: '',
        bankholder: '',
        bankifsc: '',
        bankbranch: '',
        bankmicr: '',
        bankswift: ''
      },

      search: {
        supname: '',
        cmptyp: null,
        email: ''
      },

      columns: [{
        label: 'Supplier Name',
        field: 'sup_cmp_name',
        width: '15% !important'
      }, {
        label: 'Company Type',
        field: 'companytypes.desc',
        width: '15% !important'
      }, {
        label: 'Contact No.',
        field: 'sup_cmp_phone',
        width: '10% !important'
      }, {
        label: 'Email',
        field: 'sup_cmp_email',
        width: '15% !important'
      }, {
        label: 'GST',
        field: 'sup_cmp_gst',
        width: '15% !important'
      }, {
        label: 'PAN',
        field: 'sup_cmp_pan',
        width: '15% !important'
      }, {
        label: 'Action',
        field: 'action',
        width: '15% !important'
      }],

      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      ed: {
        image1: '',
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image1_href: '',
        image2_href: '',
        image3_href: '',
        image4_href: '',
        image5_href: ''
      },
      hasErrors: {
        message: false,
        supnm: false,
        supad1: false,
        supad2: false,
        suppin: false,
        supph: false,
        supeml: false,
        supgst: false,
        suppan: false,
        supcin: false,
        suptan: false,
        supcont: false,
        supcontno: false,
        supconteml: false,
        supplierprf: false,
        image1: false,
        image2: false,
        image3: false,
        image4: false,
        image5: false,
        bankname: false,
        banknumber: false,
        bankholder: false,
        bankifsc: false,
        bankbranch: false,
        bankmicr: false,
        bankswift: false
      },
      errorMessage: {
        message: '',
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      }
    };
  },

  computed: {
    sup_view: function sup_view() {
      if (this.$store.getters.get_sup_view === true) {
        this.shopuser('comp');
        this.getSupplier('comp');
        this.contr('comp');
        this.companytype('comp');
        return true;
      } else {
        return false;
      }
    },

    sup_rights: function sup_rights() {
      return this.$store.getters.get_sup_rights;
    }
  },
  created: function created() {
    if (localStorage.authUser != null) {
      this.access_token = '?access_token=' + localStorage.authUser;
    }
  },


  methods: {
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {

      this.updateParams({ page: params.currentPage });
      this.getSupplier();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getSupplier();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getSupplier();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getSupplier();
    },
    addsupplier: function addsupplier() {
      var _this = this;
      this.loading = true;
      this.$http.get('/api/suppliers/chk_plan_count').then(function (response) {
        _this.loading = false;
        if ('message' in response.data) {
          if (response.data.message === false) {
            _this.plan_modal = false;
            _this.saveBtn = true;
            _this.editBtn = false;
            _this.contr1ed('101');
            _this.state1ed('22');
            _this.city1ed('2707');
            _this.largeModal = true;
            _this.reset_error();
            _this.reset();
          } else {
            _this.plan_modal = true;
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    viewsupplier: function viewsupplier(supplierid) {
      var _this = this;
      _this.display.name = null;
      _this.display.cmptyp = null;
      _this.display.email = null;
      _this.display.add1 = null;
      this.largeModal1 = true;
      _this.display.name = supplierid.sup_cmp_name;

      if (supplierid.sup_cmp_type != null) {

        this.$http.get('/api/companytypes/' + supplierid.sup_cmp_type).then(function (response) {

          _this.display.cmptyp = response.data.desc;
        }).catch(function (error) {
          console.log(error);
        });
      }

      _this.display.email = supplierid.sup_cmp_email;
      _this.display.add1 = supplierid.address1;
    },
    contr1ed: function contr1ed(option) {
      var _this = this;
      this.$http.get('/api/countries/' + option).then(function (response) {
        _this.con = response.data;
      }).catch(function (error) {
        console.log(error);
      });
      this.$http.get('/api/states?&filter[where][country_id]=' + option).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    state1ed: function state1ed(conopt) {
      var _this = this;
      this.$http.get('/api/states/' + conopt).then(function (response) {
        _this.state = response.data;
      }).catch(function (error) {
        console.log(error);
      });
      this.$http.get('/api/cities?filter[where][state_id]=' + conopt).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1ed: function city1ed(stateopt) {
      var _this = this;
      this.$http.get('/api/cities/' + stateopt).then(function (response) {
        _this.city = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    suptyp1ed: function suptyp1ed(suptypopt) {
      var _this = this;
      this.$http.get('/api/companytypes/' + suptypopt).then(function (response) {
        _this.suptype = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    editsupplier: function editsupplier(supplierid) {
      this.reset_error();
      this.reset();
      this.saveBtn = false;
      this.editBtn = true;
      this.largeModal = true;
      this.supplier.name = supplierid.sup_cmp_name;
      if (supplierid.sup_cmp_type != null) {
        this.suptyp1ed(supplierid.sup_cmp_type);
      }
      this.supplier.add = supplierid.address1;
      this.supplier.add2 = supplierid.address2;
      if (supplierid.country_code != null) {
        this.contr1ed(supplierid.country_code);
      }
      if (supplierid.state_code != null) {
        this.state1ed(supplierid.state_code);
      }
      if (supplierid.city != null) {
        this.city1ed(supplierid.city);
      }
      this.supplier.pin = supplierid.pincode;
      this.supplier.phone = supplierid.sup_cmp_phone;
      this.supplier.email = supplierid.sup_cmp_email;
      this.supplier.gst = supplierid.sup_cmp_gst;
      this.supplier.pan = supplierid.sup_cmp_pan;
      this.supplier.cin = supplierid.sup_cmp_cin;
      this.supplier.tan = supplierid.sup_cmp_tan;
      this.supplier.contact = supplierid.contact_person_name;
      this.supplier.contactno = supplierid.contact_no;
      this.supplier.contactemail = supplierid.contact_email;
      this.supplier.profile = supplierid.supplierdetails.sup_cmp_profile;
      this.supplier.bankname = supplierid.supplierbanks.bank_name;
      this.supplier.banknumber = supplierid.supplierbanks.acc_number;
      this.supplier.bankholder = supplierid.supplierbanks.bank_holder_name;
      this.supplier.bankifsc = supplierid.supplierbanks.ifsc_code;
      this.supplier.bankbranch = supplierid.supplierbanks.branch;
      this.supplier.bankmicr = supplierid.supplierbanks.micr_code;
      this.supplier.bankswift = supplierid.supplierbanks.swift_code;
      this.ed.image1 = supplierid.supplierdetails.sup_cmp_cic_cert;
      this.ed.image2 = supplierid.supplierdetails.sup_cmp_gst_cert;
      this.ed.image3 = supplierid.supplierdetails.sup_cmp_pan_cert;
      this.ed.image4 = supplierid.supplierdetails.sup_cmp_tan_cert;
      this.ed.image5 = supplierid.supplierdetails.sup_cmp_logo;
      this.ed.image1_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + supplierid.supplierdetails.sup_cmp_cic_cert + this.access_token;
      this.ed.image2_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + supplierid.supplierdetails.sup_cmp_gst_cert + this.access_token;
      this.ed.image3_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + supplierid.supplierdetails.sup_cmp_pan_cert + this.access_token;
      this.ed.image4_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + supplierid.supplierdetails.sup_cmp_tan_cert + this.access_token;
      this.ed.image5_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + supplierid.supplierdetails.sup_cmp_logo + this.access_token;
      this.supplier_id = supplierid.supplier_id;
    },
    getSupplier: function getSupplier(val) {
      if (val === 'comp') {
        if (this.supfrst_time === false) {
          this.supfrst_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      var data = [];
      this.rows = [];
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var supname = this.search.supname;
      var email = this.search.email;
      supname = supname.split(' ').join('_');
      email = email.split(' ').join('_');

      if (this.search.supname != '') {
        data = data + "&filter[where][sup_cmp_name][ilike]=%" + supname + "%";
      }
      if (this.search.cmptyp != null) {
        if (this.search.cmptyp.id != undefined) {
          var cmptyp = this.search.cmptyp.id;
          data = data + "&filter[where][sup_cmp_type]=" + cmptyp;
        }
      }
      if (this.search.email != '') {
        data = data + "&filter[where][sup_cmp_email][ilike]=%" + email + "%";
      }

      this.$http.get('/api/suppliers/supplier_search?params=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    deletesupplier: function deletesupplier(supplierid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        var id = supplierid.id;
        this.loading = true;
        this.$http.delete('/api/suppliers/' + id).then(function (response) {
          _this.getSupplier();
          _this.loading = false;
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    companytype: function companytype(val) {
      if (val === 'comp') {
        if (this.comf_time === false) {
          this.comf_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      this.$http.get('/api/companytypes').then(function (response) {
        _this.contyp = response.data;
        _this.srch_cmptyp = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    contr: function contr(val) {
      if (val === 'comp') {
        if (this.cfrst_time === false) {
          this.cfrst_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      this.$http.get('/api/countries').then(function (response) {
        _this.conopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    state1: function state1(conopt) {
      this.stateopt = [];
      this.cityopt = [];
      this.state = null;
      this.city = null;
      var _this = this;
      var id = conopt.id;
      this.$http.get('/api/states?filter[where][country_id]=' + id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1: function city1(stateopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      var id = stateopt.id;
      this.$http.get('/api/cities?filter[where][state_id]=' + id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    image1: function image1(callback) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      if (this.ed.image1 !== '' && this.ed.image1 !== null) {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image1);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image1;
        }
      } else {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return '';
        }
      }
    },
    image2: function image2(callback) {
      var _this = this;
      var image2 = document.querySelector('#image2');
      if (this.ed.image2 !== '' && this.ed.image2 !== null) {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image2);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image2;
        }
      } else {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    image3: function image3(callback) {
      var _this = this;
      var image3 = document.querySelector('#image3');
      if (this.ed.image3 !== '' && this.ed.image3 !== null) {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image3);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image3;
        }
      } else {
        if (image3.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    image4: function image4(callback) {
      var _this = this;
      var image4 = document.querySelector('#image4');
      if (this.ed.image4 !== '' && this.ed.image4 !== null) {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image4);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image4;
        }
      } else {
        if (image4.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    image5: function image5(callback) {
      var _this = this;
      var image5 = document.querySelector('#image5');
      if (this.ed.image5 !== '' && this.ed.image5 !== null) {
        if (image5.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image5);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image5;
        }
      } else {
        if (image5.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    reset_error: function reset_error() {
      var _this = this;
      _this.hasErrors.supnm = false;
      _this.hasErrors.supad1 = false;
      _this.hasErrors.supad2 = false;
      _this.hasErrors.suppin = false;
      _this.hasErrors.supph = false;
      _this.hasErrors.supeml = false;
      _this.hasErrors.supgst = false;
      _this.hasErrors.suppan = false;
      _this.hasErrors.supcin = false;
      _this.hasErrors.suptan = false;
      _this.hasErrors.supcont = false;
      _this.hasErrors.supcontno = false;
      _this.hasErrors.supconteml = false;
      _this.hasErrors.supplierprf = false;
      _this.hasErrors.image1 = false;
      _this.hasErrors.image2 = false;
      _this.hasErrors.image3 = false;
      _this.hasErrors.image4 = false;
      _this.hasErrors.image5 = false;
      _this.hasErrors.bankname = false;
      _this.hasErrors.banknumber = false;
      _this.hasErrors.bankholder = false;
      _this.hasErrors.bankifsc = false;
      _this.hasErrors.bankbranch = false;
      _this.hasErrors.bankmicr = false;
      _this.hasErrors.bankswift = false;
    },
    validation: function validation(boolean) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      var image2 = document.querySelector('#image2');
      var image3 = document.querySelector('#image3');
      var image4 = document.querySelector('#image4');
      var image5 = document.querySelector('#image5');

      this.reset_error();

      var submit_true = '0';
      var nrex = /^[a-zA-Z\s]{3,100}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var aregex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      var prex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var accregex = /^[0-9]{3,30}$/;
      var eregex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;

      if (aregex.test(this.supplier.name) == false) {
        _this.hasErrors.supnm = true;
        submit_true = '1';
      } else if (this.supplier.name.length > 100) {
        _this.hasErrors.supnm = true;
        submit_true = 1;
      }

      if (this.supplier.add != "") {
        if (aregex.test(this.supplier.add) == false) {
          _this.hasErrors.supad1 = true;
          submit_true = 1;
        } else if (this.supplier.add.length > 100) {
          _this.hasErrors.supad1 = true;
          submit_true = 1;
        }
      }

      if (this.supplier.add2 != "") {
        if (aregex.test(this.supplier.add2) == false) {
          _this.hasErrors.supad2 = true;
          submit_true = 1;
        } else if (this.supplier.add2.length > 100) {
          _this.hasErrors.supad2 = true;
          submit_true = 1;
        }
      }

      if (this.supplier.pin != "") {
        if (pirex.test(this.supplier.pin) == false) {
          _this.hasErrors.suppin = true;
          submit_true = 1;
        } else if (this.supplier.pin.length > 10) {
          _this.hasErrors.suppin = true;
          submit_true = 1;
        }
      }

      if (prex.test(this.supplier.phone) == false) {
        _this.hasErrors.supph = true;
        submit_true = 1;
      } else if (this.supplier.phone.length > 15) {
        _this.hasErrors.supph = true;
        submit_true = 1;
      }

      if (this.supplier.email != "") {
        if (eregex.test(this.supplier.email) == false) {
          _this.hasErrors.supeml = true;
          submit_true = 1;
        } else if (this.supplier.email.length > 70) {
          _this.hasErrors.supeml = true;
          submit_true = 1;
        }
      }

      if (this.supplier.gst != "") {
        if (regex.test(this.supplier.gst) == false) {
          _this.hasErrors.supgst = true;
          submit_true = 1;
        } else if (this.supplier.gst.length > 15) {
          _this.hasErrors.supgst = true;
          submit_true = 1;
        }
      }

      if (this.supplier.pan != "") {
        if (regex.test(this.supplier.pan) == false) {
          _this.hasErrors.suppan = true;
          submit_true = 1;
        } else if (this.supplier.pan.length > 10) {
          _this.hasErrors.suppan = true;
          submit_true = 1;
        }
      }

      if (this.supplier.cin != "") {
        if (regex.test(this.supplier.cin) == false) {
          _this.hasErrors.supcin = true;
          submit_true = 1;
        } else if (this.supplier.cin.length > 25) {
          _this.hasErrors.supcin = true;
          submit_true = 1;
        }
      }

      if (this.supplier.tan != "") {
        if (regex.test(this.supplier.tan) == false) {
          _this.hasErrors.suptan = true;
          submit_true = 1;
        } else if (this.supplier.tan.length > 12) {
          _this.hasErrors.suptan = true;
          submit_true = 1;
        }
      }

      if (this.supplier.profile != "") {
        if (this.supplier.profile.length > 255) {
          _this.hasErrors.supplierprf = true;
          submit_true = 1;
        }
      }

      if (this.supplier.contact !== "") {
        if (nrex.test(this.supplier.contact) == false) {
          _this.hasErrors.supcont = true;
          submit_true = 1;
        } else if (this.supplier.contact.length > 100) {
          _this.hasErrors.supcont = true;
          submit_true = 1;
        }
      }

      if (this.supplier.contactno !== "") {
        if (prex.test(this.supplier.contactno) == false) {
          _this.hasErrors.supcontno = true;
          submit_true = 1;
        } else if (this.supplier.contactno.length > 15) {
          _this.hasErrors.supcontno = true;
          submit_true = 1;
        }
      }

      if (this.supplier.contactemail !== "") {
        if (eregex.test(this.supplier.contactemail) == false) {
          _this.hasErrors.supconteml = true;
          submit_true = 1;
        } else if (this.supplier.contactemail.length > 70) {
          _this.hasErrors.supconteml = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankname != "") {
        if (regex.test(this.supplier.bankname) == false) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        } else if (this.supplier.bankname.length > 20) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        }
      }

      if (this.supplier.banknumber != "") {
        if (accregex.test(this.supplier.banknumber) == false) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        } else if (this.supplier.banknumber.length > 20) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankholder != "") {
        if (regex.test(this.supplier.bankholder) == false) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        } else if (this.supplier.bankholder.length > 50) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankifsc != "") {
        if (regex.test(this.supplier.bankifsc) == false) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        } else if (this.supplier.bankifsc.length > 20) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankbranch != "") {
        if (regex.test(this.supplier.bankbranch) == false) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        } else if (this.supplier.bankbranch.length > 20) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankmicr != "") {
        if (regex.test(this.supplier.bankmicr) == false) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        } else if (this.supplier.bankmicr.length > 20) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankswift != "") {
        if (regex.test(this.supplier.bankswift) == false) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        } else if (this.supplier.bankswift.length > 20) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        }
      }

      if (image1.files[0] != undefined) {
        if (image1.files[0].size > this.maximumSize) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image1.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image2.files[0] != undefined) {
        if (image2.files[0].size > this.maximumSize) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image2.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image3.files[0] != undefined) {
        if (image3.files[0].size > this.maximumSize) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image3.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image4.files[0] != undefined) {
        if (image4.files[0].size > this.maximumSize) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image4.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image5.files[0] != undefined) {
        if (image5.files[0].size > this.maximumSize) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image5.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Invalid Image Type";
          submit_true = 1;
        }
      }
      return submit_true;
    },
    Update: function Update() {
      var _this2 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation();
      var _this = this;

      if (submit_true == '0') {
        this.loading = true;
        var sup1 = {};

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          sup1.sup_cmp_name = _this2.supplier.name;

          if (_this2.suptype != null) {
            sup1.sup_cmp_type = _this2.suptype.id;
          } else {
            sup1.sup_cmp_type = null;
          }

          sup1.address1 = _this2.supplier.add;
          sup1.address2 = _this2.supplier.add2;
          sup1.pincode = _this2.supplier.pin;

          if (_this2.city != null) {
            sup1.city = _this2.city.id;
          } else {
            sup1.city = null;
          }

          if (_this2.state != null) {
            sup1.state_code = _this2.state.id;
          } else {
            sup1.state_code = null;
          }

          if (_this2.con != null) {
            sup1.country_code = _this2.con.id;
          } else {
            sup1.country_code = null;
          }

          sup1.sup_cmp_phone = _this2.supplier.phone;
          sup1.sup_cmp_email = _this2.supplier.email;
          sup1.sup_cmp_gst = _this2.supplier.gst;
          sup1.sup_cmp_pan = _this2.supplier.pan;
          sup1.sup_cmp_cin = _this2.supplier.cin;
          sup1.sup_cmp_tan = _this2.supplier.tan;
          sup1.contact_person_name = _this2.supplier.contact;
          sup1.contact_no = _this2.supplier.contactno;
          sup1.contact_email = _this2.supplier.contactemail;
          sup1.sup_cmp_cic_cert = user[0];
          sup1.sup_cmp_gst_cert = user[1];
          sup1.sup_cmp_pan_cert = user[2];
          sup1.sup_cmp_tan_cert = user[3];
          sup1.sup_cmp_logo = user[4];
          sup1.sup_cmp_profile = _this2.supplier.profile;
          sup1.bank_name = _this2.supplier.bankname;
          sup1.acc_number = _this2.supplier.banknumber;
          sup1.bank_holder_name = _this2.supplier.bankholder;
          sup1.ifsc_code = _this2.supplier.bankifsc;
          sup1.branch = _this2.supplier.bankbranch;
          sup1.micr_code = _this2.supplier.bankmicr;
          sup1.swift_code = _this2.supplier.bankswift;

          _this2.$http.post('/api/suppliers/update?where[supplier_id]=' + _this2.supplier_id, sup1).then(function (response) {
            _this.$http.post('/api/supplierbanks/update?where[supplier_id]=' + _this.supplier_id, sup1).then(function (response) {
              _this.$http.post('/api/supplierdetails/update?where[supplier_id]=' + _this.supplier_id, sup1).then(function (response) {
                _this.loading = false;
                _this.category = response.data;
                _this.hasErrors.message = true;
                _this.errorMessage.message = ' Supplier Updated Successfully';
                setTimeout(function () {
                  _this.errorMessage.message = '';
                }, 2000);
                _this.reset();
                _this.getSupplier();
                _this.largeModal = false;
              }).catch(function (error) {
                _this.loading = false;
              });
            }).catch(function (error) {
              _this.loading = false;
            });
          }).catch(function (error) {
            _this.loading = false;
          });
        });
      }
    },
    Submit: function Submit() {
      var _this3 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation();
      var _this = this;

      if (submit_true == '0') {
        this.loading = true;
        var sup = {};

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          sup.sup_cmp_name = _this3.supplier.name;

          if (_this3.suptype != null) {
            sup.sup_cmp_type = _this3.suptype.id;
          } else {
            sup.sup_cmp_type = null;
          }

          sup.address1 = _this3.supplier.add;
          sup.address2 = _this3.supplier.add2;
          sup.pincode = _this3.supplier.pin;

          if (_this3.city != null) {
            sup.city = _this3.city.id;
          } else {
            sup.city = null;
          }

          if (_this3.state != null) {
            sup.state_code = _this3.state.id;
          } else {
            sup.state_code = null;
          }

          if (_this3.con != null) {
            sup.country_code = _this3.con.id;
          } else {
            sup.country_code = null;
          }

          sup.sup_cmp_phone = _this3.supplier.phone;
          sup.sup_cmp_email = _this3.supplier.email;
          sup.sup_cmp_gst = _this3.supplier.gst;
          sup.sup_cmp_pan = _this3.supplier.pan;
          sup.sup_cmp_cin = _this3.supplier.cin;
          sup.sup_cmp_tan = _this3.supplier.tan;
          sup.contact_person_name = _this3.supplier.contact;
          sup.contact_no = _this3.supplier.contactno;
          sup.contact_email = _this3.supplier.contactemail;
          sup.sup_cmp_cic_cert = user[0];
          sup.sup_cmp_gst_cert = user[1];
          sup.sup_cmp_pan_cert = user[2];
          sup.sup_cmp_tan_cert = user[3];
          sup.sup_cmp_logo = user[4];
          sup.sup_cmp_profile = _this3.supplier.profile;
          sup.bank_name = _this3.supplier.bankname;
          sup.acc_number = _this3.supplier.banknumber;
          sup.bank_holder_name = _this3.supplier.bankholder;
          sup.ifsc_code = _this3.supplier.bankifsc;
          sup.branch = _this3.supplier.bankbranch;
          sup.micr_code = _this3.supplier.bankmicr;
          sup.swift_code = _this3.supplier.bankswift;

          _this3.$http.post('/api/suppliers', sup).then(function (response) {
            _this.loading = false;
            _this.category = response.data;
            _this.hasErrors.message = true;
            _this.errorMessage.message = ' Supplier Added';
            setTimeout(function () {
              _this.errorMessage.message = '';
            }, 2000);
            _this.reset();
            _this.getSupplier();
            _this.largeModal = false;
          }).catch(function (error) {
            _this.loading = false;
          });
        });
      }
    },
    reset: function reset() {
      var _this = this;
      _this.supplier.name = '';
      _this.suptype = null;
      _this.supplier.add = '';
      _this.supplier.add2 = '';
      _this.supplier.pin = '';
      _this.con = null;
      _this.state = null;
      _this.city = null;
      _this.supplier.phone = '';
      _this.supplier.email = '';
      _this.supplier.gst = '';
      _this.supplier.pan = '';
      _this.supplier.cin = '';
      _this.supplier.tan = '';
      _this.supplier.contact = '';
      _this.supplier.contactno = '';
      _this.supplier.contactemail = '';
      document.getElementById("image1").value = '';
      document.getElementById("image2").value = '';
      document.getElementById("image3").value = '';
      document.getElementById("image4").value = '';
      document.getElementById("image5").value = '';
      _this.supplier.profile = '';
      _this.supplier.bankname = '';
      _this.supplier.banknumber = '';
      _this.supplier.bankifsc = '';
      _this.supplier.bankbranch = '';
      _this.supplier.bankmicr = '';
      _this.supplier.bankswift = '';
      _this.ed.image1 = '';
      _this.ed.image2 = '';
      _this.ed.image3 = '';
      _this.ed.image4 = '';
      _this.ed.image5 = '';
      _this.ed.image1_href = '';
      _this.ed.image2_href = '';
      _this.ed.image3_href = '';
      _this.ed.image4_href = '';
      _this.ed.image5_href = '';
    }
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListPayments',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default.a, Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      is_cheque: false,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
      maximumSize: 1000000,
      largeModal1: false,
      largeModal: false,
      loading: false,
      supplier_name: [],
      selectsupplier: null,
      purchase_row: '',
      purchase_id1: '',
      from_DT: '',
      to_DT: '',
      payment_mode: 'cash',
      cheque_no: '',
      cheque_date: '',
      note: '',
      payment: {
        purchase_id: '',
        supplier_id: '',
        amount_topay: 0,
        amount_balance: 0
      },
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      haserror: {
        message: '',
        supplier: '',
        attachment: '',
        cheque_no: '',
        cheque_date: '',
        note: '',
        payment_mode: ''
      },
      payment_mode_list: [{ pay_value: 'cash', pay_text: 'Cash' }, { pay_value: 'cheque', pay_text: 'Cheque' }, { pay_value: 'online', pay_text: 'Online' }],
      columns: [{
        label: 'Purchase ID',
        field: 'purchase_id',
        width: '10% !important'
      }, {
        label: 'Shop',
        field: 'est_shop_name',
        width: '20% !important'
      }, {
        label: 'Supplier Name',
        field: 'sup_cmp_name',
        width: '20% !important'
      }, {
        label: 'Amount to Pay',
        field: 'total_amt_pay',
        width: '20% !important'
      }, {
        label: 'Amount Balance',
        field: 'amt_pending_pay',
        width: '20% !important'
      }, {
        label: 'Action',
        field: 'paymod',
        width: '10% !important'
      }],
      rows: [],
      rows1: []
    };
  },
  created: function created() {
    this.searchsupplier();
    this.shopuser();
    for (var i = 0; i < 1; i++) {
      this.rows1.push({ err_purchase_id: '', purchase_id: '', supplier_id: '', amount_topay: 0, amount: 0, amount_balance: 0 });
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.search_purchase();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.search_purchase();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.search_purchase();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.search_purchase();
    },
    onSelect: function onSelect() {
      if (this.payment_mode == 'cheque') {
        this.is_cheque = true;
      } else {
        this.is_cheque = false;
      }
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    attachment: function attachment(callback) {
      var _this = this;
      var attachment = document.querySelector('#attachment');
      if (attachment.files[0] != undefined) {
        var formData = new FormData();
        formData.append('image', attachment.files[0]);
        return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
          return response.data.result.files.image[0].name;
        }).catch(function (error) {
          return '';
        });
      } else {
        return '';
      }
    },
    searchsupplier: function searchsupplier() {
      this.haserror.supplier = '';
      var _this = this;
      this.$http.get('/api/suppliers').then(function (response) {
        _this.supplier_name = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRow1: function addRow1() {
      if (this.selectsupplier == null || this.selectsupplier.supplier_id == undefined) {
        var sup_id = this.selectsupplier.supplier_id;
      } else {
        var sup_id = this.selectsupplier.supplier_id;
      }
      this.rows1.push({ err_purchase_id: '', purchase_id: '', supplier_id: sup_id, amount_topay: 0, amount: 0, amount_balance: 0 });
    },


    removeElement: function removeElement(index) {
      this.rows1.splice(index, 1);
    },

    reset_error: function reset_error() {
      this.haserror.message = '';
      this.haserror.supplier = '';
      this.haserror.attachment = '';
      this.haserror.cheque_no = '';
      this.haserror.cheque_date = '';
      this.haserror.note = '';
    },
    validation: function validation(boolean) {
      var _this = this;
      var attachment = document.querySelector('#attachment');
      this.reset_error();
      var submit_true = 0;
      var cheque_reg = /^\d+$/;

      if (this.selectsupplier == null || this.selectsupplier.supplier_id == undefined) {
        this.haserror.supplier = 'Required';
        submit_true = 1;
      }

      if (this.cheque_no != "") {
        if (cheque_reg.test(this.cheque_no) == false) {
          this.haserror.cheque_no = 'Invalid Cheque Number';
          submit_true = 1;
        } else if (this.cheque_no.length > 20) {
          this.haserror.cheque_no = 'Cheque number cannot be greater than 20';
          submit_true = 1;
        }
      }

      if (this.note != "") {
        if (this.cheque_no.length > 500) {
          this.haserror.cheque_no = 'Note cannot be greater than 500 characters';
          submit_true = 1;
        }
      }

      if (this.payment_mode == '') {
        this.haserror.payment_mode = 'Required';
        submit_true = 1;
      }

      if (attachment.files[0] != undefined) {
        if (attachment.files[0].size > this.maximumSize) {
          this.haserror.attachment = "File Size Cannot Be Greater Than 1 mb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(attachment.files[0].type.toLowerCase()) === -1) {
          this.haserror.attachment = "File type should be jpeg, jpg, png, pdf";
          submit_true = 1;
        }
      }

      for (var i = this.rows1.length - 1; i >= 0; i--) {
        if (this.rows1[i].purchase_id == '') {
          submit_true = 1;
          this.rows1[i].err_purchase_id = 'Required';
        } else {
          this.rows1[i].err_purchase_id = '';
        }
      }

      return submit_true;
    },
    finalsubmit: function finalsubmit() {
      var _this2 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation();
      var _this = this;

      if (this.rows1.length == 0) {
        alert("nothing to Save");
      } else {
        if (submit_true == 0) {
          this.loading = true;

          var num = /^[0-9]{1}$/;

          if (this.cheque_date != '') {
            var date = new Date(this.cheque_date);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();

            if (num.test(month) == true) {
              var month = '0' + month;
            } else {
              var month = month;
            }

            if (num.test(day) == true) {
              var day = '0' + day;
            } else {
              var day = day;
            }

            var dateval = year + '-' + month + '-' + day;
          } else {
            var dateval = null;
          }

          var pay = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.attachment()]).then(function (file) {
            pay.supplier_id = _this2.selectsupplier.supplier_id;
            pay.payment_row = _this2.rows1;
            pay.attachment = file[0];
            pay.cheque_no = _this2.cheque_no;
            pay.cheque_date = dateval;
            pay.note = _this2.note;
            pay.payment_mode = _this2.payment_mode;
            _this2.$http.post('/api/inventorypayments/addpayment', pay).then(function (response) {
              _this.loading = false;
              _this.reset_form();
              _this.haserror.message = 'Payment Added Successfully';
              setTimeout(function () {
                _this.haserror.message = '';
              }, 2000);
            }).catch(function (error) {
              _this.loading = false;
            });
          });
        }
      }
    },
    SupSelected: function SupSelected() {
      this.rows = [];
      this.haserror.supplier = '';
      if (this.rows1.length > 0) {
        for (var i = 0; i < this.rows1.length; i++) {
          this.rows1[i]['purchase_id'] = '';
          this.rows1[i]['supplier_id'] = this.selectsupplier.supplier_id;
          this.rows1[i]['amount_topay'] = 0;
          this.rows1[i]['amount_balance'] = 0;
        }
      }
    },
    search_purchase: function search_purchase() {

      var _this = this;
      var data = [];
      var purchase_id = this.purchase_id1;
      var from_DT = this.from_DT;
      var to_DT = this.to_DT;
      var num = /^[0-9]{1}$/;
      var supplier_id = this.selectsupplier.supplier_id;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      if (this.from_DT) {
        var datefrom = new Date(this.from_DT);
        var year1 = datefrom.getFullYear();
        var month1 = datefrom.getMonth() + 1;
        var daycon = datefrom.getDate();
        if (num.test(month1) == true) {
          var month1 = '0' + month1;
        } else {
          var month1 = month1;
        }

        if (num.test(daycon) == true) {
          var day1 = '0' + daycon;
        } else {
          var day1 = daycon;
        }
        var fromdate1 = year1 + '-' + month1 + '-' + day1;
      } else {
        fromdate1 = '';
      }

      if (this.to_DT) {
        var dateto = new Date(this.to_DT);
        var year = dateto.getFullYear();
        var month = dateto.getMonth() + 1;
        var day = dateto.getDate();

        if (num.test(month) == true) {
          var month = '0' + month;
        } else {
          var month = month;
        }

        if (num.test(day) == true) {
          var day = '0' + day;
        } else {
          var day = day;
        }
        var todate1 = year + '-' + month + '-' + day;
      } else {
        todate1 = '';
      }

      data = data + "&filter[where][supplier_id]=" + this.selectsupplier.supplier_id;
      data = data + "&filter[where][purchase_id]=" + purchase_id;
      data = data + "&filter[where][from_DT]=" + fromdate1;
      data = data + "&filter[where][to_DT]=" + todate1;

      this.$http.get('/api/inventorypayments/purchase_search?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    purchase: function purchase(index) {

      this.rows1[index].err_purchase_id = '';

      if (this.selectsupplier == null || this.selectsupplier.supplier_id == undefined) {
        this.haserror.supplier = 'Select Supplier First';
        this.rows1[index]['purchase_id'] = '';
      } else {

        var match = 0;
        for (var i = 0; i < this.rows1.length; i++) {
          if (i != index) {
            if (this.rows1[i]['purchase_id'] === this.rows1[index]['purchase_id']) {
              match = 1;
            }
          }
        }

        if (match == 0) {
          this.haserror.supplier = '';
          var _this = this;
          var data = {};
          data.purchase_id = this.rows1[index]['purchase_id'];
          data.supplier_id = this.selectsupplier.supplier_id;
          this.$http.post('/api/inventorypayments/supplier_payment', data).then(function (response) {
            if (response.data !== null) {
              _this.rows1[index]['purchase_id'] = response.data.purchase_id;
              _this.rows1[index]['supplier_id'] = _this.selectsupplier.supplier_id;
              _this.rows1[index]['amount_topay'] = response.data.amt_pending_pay;
              _this.rows1[index]['amount'] = response.data.amt_pending_pay;
              _this.rows1[index]['amount_balance'] = 0;
            } else {
              _this.rows1[index]['purchase_id'] = '';
              _this.rows1[index]['supplier_id'] = '';
              _this.rows1[index]['amount_topay'] = 0;
              _this.rows1[index]['amount_balance'] = 0;
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          this.rows1[index].err_purchase_id = 'This purchase id already used';
          this.rows1[index]['purchase_id'] = '';
        }
      }
    },
    calculate: function calculate(index) {
      this.rows1[index].err_purchase_id = '';
      if (parseFloat(this.rows1[index]['amount_topay']) > parseFloat(this.rows1[index]['amount'])) {
        this.rows1[index]['amount_topay'] = this.rows1[index]['amount'];
        this.rows1[index].err_purchase_id = 'Amount cannot be greater than ' + this.rows1[index]['amount'];
      } else if (parseFloat(this.rows1[index]['amount_topay']) < 0) {
        this.rows1[index]['amount_topay'] = this.rows1[index]['amount'];
        this.rows1[index].err_purchase_id = 'Amount cannot be negative';
      } else {
        var amt_pay = /^[1-9]\d*(\.\d+)?$/;
        if (amt_pay.test(this.rows1[index]['amount_topay']) == false) {
          this.rows1[index].err_purchase_id = 'Enter valid amount';
          this.rows1[index]['amount_topay'] = 0;
          this.rows1[index]['amount_balance'] = this.rows1[index]['amount'];
        } else {
          if (this.rows1[index]['amount_topay'] == '') {
            this.rows1[index]['amount_topay'] = 0;
            this.rows1[index]['amount_balance'] = this.rows1[index]['amount'];
          }
          var bal_amt = parseFloat(this.rows1[index]['amount']) - parseFloat(this.rows1[index]['amount_topay']);
          this.rows1[index]['amount_balance'] = bal_amt.toFixed(6);
        }
      }
    },
    search_purchase_modal: function search_purchase_modal(index) {
      this.rows = [];
      this.from_DT = '';
      this.to_DT = '';
      this.purchase_id1 = '';
      if (this.selectsupplier == null || this.selectsupplier.supplier_id == undefined) {
        this.haserror.supplier = 'Select Supplier First';
      } else {
        this.purchase_row = index;
        this.largeModal = true;
      }
    },
    add_purchase_payment: function add_purchase_payment(row) {
      var purchase_row = this.purchase_row;
      this.rows1[purchase_row]['purchase_id'] = row.purchase_id;
      this.purchase(purchase_row);
      this.largeModal = false;
    },
    reset_form: function reset_form() {
      var _this = this;
      if (_this.rows1.length > 0) {
        for (var i = 0; i < _this.rows1.length; i++) {
          _this.rows1[i]['err_purchase_id'] = '', _this.rows1[i]['purchase_id'] = '', _this.rows1[i]['supplier_id'] = '', _this.rows1[i]['amount_topay'] = 0, _this.rows1[i]['amount'] = 0, _this.rows1[i]['amount_balance'] = 0;
        }
      }
      for (var j = this.rows1.length - 1; j >= 1; j--) {
        this.rows1.splice(j, 1);
      }
      _this.selectsupplier = null;
      _this.payment_mode = 'cash';
      _this.cheque_no = '';
      _this.cheque_date = '';
      _this.note = '';
    }
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ListSalePayment",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      loading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns: [{
        label: "Payment Id",
        field: "payment_id",
        width: "15% !important"
      }, {
        label: "Purchase Id",
        field: "purchase_id",
        width: "15% !important"
      }, {
        label: "Shop",
        field: "est_shop_name",
        width: "15% !important"
      }, {
        label: "Supplier",
        field: "sup_cmp_name",
        width: "20% !important"
      }, {
        label: "Payment Mode",
        field: "payment_mode",
        width: "10% !important"
      }, {
        label: "Amount",
        field: "amount",
        width: "10% !important"
      }, {
        label: "Cheque No",
        field: "cheque_no",
        width: "15% !important"
      }]
    };
  },

  computed: {
    is_admin: function is_admin() {
      if (this.$store.getters.get_is_admin) {
        return true;
      } else {
        this.PurPayment();
        this.shopuser();
        return this.$store.getters.get_is_admin;
      }
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.PurPayment();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.PurPayment();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.PurPayment();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.PurPayment();
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompnay: function onSelectCompnay(selectedcompany) {
      this.PurPayment();
    },
    PurPayment: function PurPayment() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = "";
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/inventorypayments/prchsPaymentHistory?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    exportData: function exportData() {
      var _this = this;
      if (this.rows.length > 0) {
        this.$http.get("/api/inventorypayments/getPurchaseHistoryExport").then(function (response) {
          var access_token = localStorage.getItem("authUser");

          var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
          }).catch(function (er) {
            console.log(er);
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Data Found');
      }
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ListSalePayment",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      loading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns: [{
        label: "Payment Id",
        field: "payment_id",
        width: "15% !important"
      }, {
        label: "Purchase Return Id",
        field: "purchase_return_id",
        width: "15% !important"
      }, {
        label: "Purchase Id",
        field: "purchase_id",
        width: "15% !important"
      }, {
        label: "Shop",
        field: "est_shop_name",
        width: "15% !important"
      }, {
        label: "Supplier",
        field: "sup_cmp_name",
        width: "20% !important"
      }, {
        label: "Payment Mode",
        field: "payment_mode",
        width: "10% !important"
      }, {
        label: "Amount",
        field: "amount",
        width: "10% !important"
      }, {
        label: "Cheque No",
        field: "cheque_no",
        width: "15% !important"
      }]
    };
  },

  computed: {
    is_admin: function is_admin() {
      if (this.$store.getters.get_is_admin) {
        return true;
      } else {
        this.PurPayment();
        this.shopuser();
        return this.$store.getters.get_is_admin;
      }
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.PurPayment();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.PurPayment();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.PurPayment();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.PurPayment();
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompnay: function onSelectCompnay(selectedcompany) {
      this.PurPayment();
    },
    PurPayment: function PurPayment() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = "";
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/inventorypurchasereturns/prchsrtsPaymentHistory?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    exportData: function exportData() {
      var _this = this;
      this.$http.get("/api/inventorypurchasereturn/getPurchaseHistoryExport").then(function (response) {
        var access_token = localStorage.getItem("authUser");

        var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

        _this.$http({
          url: url1,
          method: "GET",
          responseType: "blob"
        }).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res.data]));
          var link = document.createElement("a");
          link.setAttribute("download", response.data);
          link.href = url1;
          document.body.appendChild(link);
          link.click();
        }).catch(function (er) {
          console.log(er);
          _this.loading = false;
        });
      });
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      plan_modal: false,
      selectcompany: null,
      slfirst: false,
      shpfirst: false,
      todate: "",
      fromdate: "",
      productunit: "",
      productqty: "",
      rows1: [],
      rows2: [],
      rows: [],
      rows_adj: [],
      message: "",
      sales_adj_salesid: null,
      warningModal: false,
      warningModal1: false,
      saleadjModal: false,
      largeModal: false,
      loading: false,
      srchSales: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      totalRecords2: 0,
      serverParams2: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      totalRecords_adj: 0,
      serverParams_adj: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      temprow: null,

      columns1: [{
        label: "Product Name",
        field: "product_name",
        width: "20% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "10% !important"
      }, {
        label: "Qty",
        field: "sale_qty",
        width: "10% !important"
      }, {
        label: "Price",
        field: "product_unit_cost",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Sub Total",
        field: "sub_total",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Tax",
        field: "tax_inclusive",
        width: "10% !important"
      }, {
        label: "GST%",
        field: "gst_total",
        width: "15% !important"
      }, {
        label: "Amount",
        field: "amt_to_pay",
        width: "15% !important",
        formatFn: this.formatFn
      }],
      columns2: [{
        label: "Product Name",
        field: "product_name",
        width: "20% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "10% !important"
      }, {
        label: "Qty",
        field: "sale_qty",
        width: "10% !important"
      }, {
        label: "Price",
        field: "product_unit_cost",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Sub Total",
        field: "sub_total",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Tax",
        field: "tax_inclusive",
        width: "10% !important"
      }, {
        label: "GST%",
        field: "gst_total",
        width: "15% !important"
      }, {
        label: "Amount",
        field: "amt_to_pay",
        width: "15% !important",
        formatFn: this.formatFn
      }, {
        label: "Return Qty",
        field: "return_qty",
        width: "15% !important"
      }],
      columns_adj: [{
        label: "Product",
        field: "product_name",
        width: "5% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "20% !important"
      }, {
        label: "Sales Qty",
        field: "sale_qty",
        width: "20% !important"
      }, {
        label: "Adjust Qty",
        field: "adjusted_qty",
        width: "10% !important"
      }, {
        label: "Available Qty",
        field: "inv_qty",
        width: "10% !important"
      }, {
        label: "Action",
        field: "action",
        width: "15% !important"
      }]
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    columns: function columns() {
      return [{ label: "Sales Id", field: "sales_id", width: "7% !important", thClass: "text-center" }, { label: "Customer", field: "cust_cmp_name", width: "13% !important", thClass: "text-center" }, { label: "Shop", field: "est_shop_name", width: "13% !important", thClass: "text-center" }, { label: this.companyTaxType === 'US' ? "Tax Amount" : "GST Amount", field: "gst_total", width: "12% !important", thClass: "text-center" }, { label: "Total Amount", field: "total_amt_pay", width: "10% !important", formatFn: this.formatFn, thClass: "text-center" }, { label: "Sale Entry Date", field: "sale_entry_date", type: "date", dateInputFormat: "YYYY-MM-DDThh:mm:ss", dateOutputFormat: "Do MMM YYYY", tdClass: "text-left", width: "12% !important", thClass: "text-center" }, { label: "Action", field: "action", width: "10% !important", thClass: "text-center", tdClass: "text-center" }, { label: "Return", field: "return", width: "5% !important", tdClass: "text-center", thClass: "text-center" }, { label: "Sale Adjust", field: "adjust", width: "8% !important", tdClass: "text-center", thClass: "text-center" }, { label: "Generate", field: "generate", width: "10% !important", tdClass: "text-center", thClass: "text-center" }];
    },

    sale_view: function sale_view() {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_sale_view === true) {
          this.sales("comp");
          this.shopuser("comp");
          return true;
        } else {
          return false;
        }
      }
    },
    sale_rights: function sale_rights() {
      return this.$store.getters.get_sale_rights;
    },
    is_admin: function is_admin() {
      return this.$store.getters.get_is_admin;
    }
  },

  methods: {
    rowStyleClassFn: function rowStyleClassFn(row) {
      return row.salesadj == true ? "background-color:green" : "background-color:red";
    },
    addsales: function addsales() {
      var _this = this;
      this.loading = true;
      this.$router.push({ name: "Add Sales" });
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompnay: function onSelectCompnay(selected_company) {
      this.loadItems();
    },
    generate_invoice: function generate_invoice(row) {
      var route_query = { sid: row.sales_id, cid: row.customer_id };

      var routeData = this.$router.resolve({
        name: "Sale Invoice Pdf",
        query: route_query
      });
      window.open(routeData.href, "_blank");
    },
    editSales: function editSales(row) {
      var _this = this;
      this.loading = true;
      this.$http.post("/api/salesadjustments/getPurchaseAdj?saleId=" + row.sales_id + "&shp_id=" + row.est_shop_id).then(function (response) {
        if (response.data.data !== null) {
          setTimeout(function () {
            _this.loading = false;
          }, 2000);
          alert("Sales id - " + row.sales_id + " belongs to Sale Adjustment which is been adjusted, so cannot be edited");
        } else {
          setTimeout(function () {
            _this.loading = false;
          }, 2000);
          _this.$router.props = [row.sales_id];
          localStorage.setItem("sales_id", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(row.sales_id));
          _this.$router.push("/sales/editsales");
        }
      }).catch(function (error) {});
    },
    removeSales: function removeSales(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http.delete("api/sales/removeSale?id=" + row.sales_id).then(function (response) {
          if (response.status == 200) {
            if (response.data.res === "Successful") {
              _this.loading = false;
              _this.sales();
            } else {
              alert(response.data.res);
              _this.loading = false;
            }
          }
        }).catch(function (error) {});
      }
    },
    adjust: function adjust(row) {
      var r = confirm("Are you sure you want to Adjust Sale from inventory?");
      if (r == true) {
        var _this = this;
        this.loading = true;


        this.$http.get("/api/salesadjustments/adjustSale?filter[where][saleadj_id]=" + row.saleadjustment_id).then(function (response) {
          if (response.status == 200) {
            if (response.data.res == "success") {
              _this.saleadj(_this.temprow);
              _this.loading = false;
              _this.message = "Sales Adjusted Successfully";
              setTimeout(function () {
                _this.message = "";
              }, 2000);
            } else {
              _this.saleadj(_this.temprow);
              _this.loading = false;
              _this.message = response.data.res;
              setTimeout(function () {
                _this.message = "";
              }, 2000);
            }
          } else {
            _this.loading = false;
            _this.message = "Some error occurred while adjust. Kindly contact to admin";
            setTimeout(function () {
              _this.message = "";
            }, 2000);
          }
          setTimeout(function () {
            _this.saleadj(_this.temprow);
            _this.loading = false;
          }, 1000);
          _this.message = "Sales Adjusted Successfully";
          setTimeout(function () {
            _this.message = "";
          }, 2000);
        });
      }
    },
    saleadj: function saleadj(row) {
      this.rows_adj.length = 0;

      this.saleadjModal = true;
      this.sales_adj_salesid = row.sales_id;
      var _this = this;
      this.temprow = row;

      this.$http.get("/api/salesadjustments/getSaleAdj?filter[where][sales_id]=" + row.sales_id + "&filter[where][est_shop_id]=" + row.est_shop_id).then(function (response) {
        if (response.status == 200) {
          if (response.data.data !== undefined) {
            if (response.data.data.length > 0) {
              _this.totalRecords_adj = response.data.data["0"]["count"];
              _this.rows_adj = response.data.data;
            } else {
              _this.saleadjModal = false;
            }
          } else {
            console.log("data undefined");
          }
        } else {
          console.log("Didn't got response");
        }
      });
    },
    returnitems: function returnitems() {
      var sales_id = this.$refs["my-table2"].selectedRows[0]["sales_id"];
      var est_shop_id = this.$refs["my-table2"].selectedRows[0]["est_shop_id"];

      if (this.$refs["my-table2"].selectedRows.length > 0) {
        if ("sales_return_id" in this.$refs["my-table2"].selectedRows[0]) {
          var item_seqs = {};
          for (var i = 0; i < this.$refs["my-table2"].selectedRows.length; i++) {
            item_seqs[this.$refs["my-table2"].selectedRows[i].item_seq] = this.$refs["my-table2"].selectedRows[i].sale_qty;
          }

          this.$router.push({
            name: "Edit Sales Return",
            params: {
              saleId: sales_id,
              shopId: est_shop_id,
              itemSeqs: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item_seqs),
              saleReturnId: this.$refs["my-table2"].selectedRows[0]["sales_return_id"]
            }
          });
        } else {
          var item_seqs = [];
          for (var i = 0; i < this.$refs["my-table2"].selectedRows.length; i++) {
            item_seqs.push(this.$refs["my-table2"].selectedRows[i].item_seq);
          }
          this.$router.push({
            name: "Add Sales Return",
            params: {
              saleId: sales_id,
              shopId: est_shop_id,
              itemSeqs: item_seqs
            }
          });
        }
      } else {
        return;
      }
    },
    newDate: function newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      var dt2 = year + "-" + month + "-" + day;
      return dt2;
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1: function updateParams1(newProps, row) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params, row) {
      this.updateParams1({ page: params.currentPage });
      this.viewSale(this.temprow);
    },
    onPerPageChange1: function onPerPageChange1(params, row) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.viewSale(this.temprow);
    },
    onSortChange1: function onSortChange1(params, row) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        },
        page: 1
      });
      this.viewSale(this.temprow);
    },
    onColumnFilter1: function onColumnFilter1(params, row) {
      this.updateParams1(params);
      this.viewSale(this.temprow);
    },
    updateParams2: function updateParams2(newProps, row) {
      this.serverParams2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams2, newProps);
    },
    onPageChange2: function onPageChange2(params, row) {
      this.updateParams2({ page: params.currentPage });
      this.viewSale(this.temprow);
    },
    onPerPageChange2: function onPerPageChange2(params, row) {
      this.updateParams2({ perPage: params.currentPerPage, page: 1 });
      this.viewSale(this.temprow);
    },
    onSortChange2: function onSortChange2(params, row) {
      this.updateParams2({
        sort: {
          type: params.sortType,
          field: this.columns2[params.columnIndex].field
        },
        page: 1
      });
      this.viewSale(this.temprow);
    },
    onColumnFilter2: function onColumnFilter2(params, row) {
      this.updateParams2(params);
      this.viewSale(this.temprow);
    },
    updateParamsAdj: function updateParamsAdj(newProps) {
      this.serverParams_adj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams_adj, newProps);
    },
    onPageChange_adj: function onPageChange_adj(params) {
      this.updateParamsAdj({ page: params.currentPage });
      this.saleadj(this.temprow);
    },
    onPerPageChange_adj: function onPerPageChange_adj(params) {
      this.updateParamsAdj({ perPage: params.currentPerPage, page: 1 });
      this.saleadj(this.temprow);
    },
    onSortChange_adj: function onSortChange_adj(params) {
      this.updateParamsAdj({
        sort: {
          type: params.sortType,
          field: this.columns_adj[params.columnIndex].field
        },
        page: 1
      });
      this.saleadj(this.temprow);
    },
    onColumnFilter_adj: function onColumnFilter_adj(params) {
      this.updateParamsAdj(params);
      this.saleadj(this.temprow);
    },
    loadItems: function loadItems() {
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var _this = this;
      var data = [];
      this.rows = [];
      var unit = this.productunit;
      var qty = this.productqty;
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }
      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }
      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      if (this.todate != "" && this.fromdate != "") {
        data = data + " &filter[where][lastupdated_datetime][between][0]=" + todate1 + " &filter[where][lastupdated_datetime][between][1]=" + fromdate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit != "") {
        data = data + "&filter[where][sales_id]=" + unit;
      }

      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }

      this.$http.get("/api/saledetails/getSales?params=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (er) {
        console.log(er);
        _this.loading = false;
      });
    },
    sales: function sales(val) {
      if (val === "comp") {
        if (this.slfirst === false) {
          this.slfirst = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
    viewSale: function viewSale(row) {
      this.rows1.length = 0;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      this.temprow = row;

      var data = "&filter[where][sales_id]=" + row.sales_id;
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/saledetails/searchdb?params=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        if (response.data != undefined) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          _this.rows1 = response.data;
        }
      });
    },
    viewSale2: function viewSale2(row) {
      this.rows2.length = 0;
      var filteParam = {};
      filteParam.page = this.serverParams2.page;
      filteParam.perPage = this.serverParams2.perPage;
      filteParam.sort = this.serverParams2.sort;
      this.warningModal1 = true;
      var _this = this;
      this.temprow = row;
      var data = [];
      var data = data + "&filter[where][sales_id]=" + row.sales_id + "&filter[where][chk_return]=true";

      this.$http.get("/api/saledetails/searchdb?params=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        if (response.data != undefined) {
          if ("sale_rt_dt" in response.data) {
            _this.totalRecords2 = response.data.sale_dt.length;
            var sale_return_id = response.data.sale_rt_dt[0]["sales_return_id"];
            var obj_rtitemseq = {};

            var sale_data = response.data.sale_dt;
            var sale_rt_dt = response.data.sale_rt_dt;
            for (var i = 0; i < sale_rt_dt.length; i++) {
              obj_rtitemseq[parseInt(sale_rt_dt[i].item_seq)] = parseInt(sale_rt_dt[i].return_qty);
            }
            for (var j = 0; j < sale_data.length; j++) {
              if (parseInt(sale_data[j].item_seq) in obj_rtitemseq) {
                sale_data[j]["return_qty"] = obj_rtitemseq[sale_data[j].item_seq];
                sale_data[j]["sales_return_id"] = sale_return_id;
              } else {
                sale_data[j]["return_qty"] = 0;
                sale_data[j]["sales_return_id"] = sale_return_id;
              }
            }
            _this.rows2 = sale_data;
            for (var k = 0; k < _this.rows2.length; k++) {
              if (parseInt(_this.rows2[k].item_seq) in obj_rtitemseq) {
                _this.$set(_this.rows2[k], "vgtSelected", true);
              }
            }
          } else {
            _this.rows2 = response.data;
            _this.totalRecords2 = response.data.length;
          }
        }
      });
    },
    exportData: function exportData() {
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var _this = this;
      var unit = this.productunit;
      var qty = this.productqty;
      var num = /^[0-9]{1}$/;
      var data = [];
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      this.loading = true;

      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }
      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }
      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      if (this.todate != "" && this.fromdate != "") {
        data = data + " &filter[where][lastupdated_datetime][between][0]=" + todate1 + " &filter[where][lastupdated_datetime][between][1]=" + fromdate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit != "") {
        data = data + "&filter[where][sales_id]=" + unit;
      }

      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }


      this.loading = true;
      if (this.rows.length > 0) {

        this.$http.get("/api/saledetails/getSalesExport?params=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
          var access_token = localStorage.getItem("authUser");


          var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            _this.loading = false;
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
          }).catch(function (er) {
            console.log(er);
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Data Found');
      }
    },
    searchsales: function searchsales() {
      this.updateParams({
        sort: {
          type: "",
          field: ""
        },
        page: 1
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    }
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_1__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      shop_option: null,
      plan_modal: false,
      shopplan_modal: false,
      shopchange_modal: false,
      prodplan_modal: false,
      disabledBefore: null,
      disabledAfter: null,
      csgstdisable: true,
      igstdisable: true,
      addr: [],
      addressModel: false,
      saleentry_dt: new Date().toISOString().slice(0, 10),
      saleprice_nonedit: true,
      validate: 1,
      amt_rec: '',
      err_totamtpay: '',
      loading: false,
      variantindex: null,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      totalamtreceived: '',
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      tempArr: [],
      variantdata: null,
      oldshp: null,
      percentagemd: '',
      amtmd: '',
      barcode: '',
      inclusive: false,
      indexval: null,
      largeModal: false,
      customername: [],
      selected_pytype: 'full',
      lst_paymenttype: [{ value: 'full', text: 'Full' }, { value: 'partial', text: 'Partial' }, { value: 'no', text: 'No' }],
      selected_pymode: 'cash',
      selectedcustomer: null,
      shopname: [],
      selectshop: null,
      select_shop: null,
      saleprice_editable: false,
      processedRow: null,
      productname: [],

      selectproduct: {},
      is_cs_gst: true,
      is_i_gst: true,
      company_gst: null,
      customer_gst: null,
      rows: [],
      haserror: {
        amt: '',
        dis: '',
        cust: '',
        message: '',
        inclusive: '',
        shop: ''
      },
      customer1: {
        name: null,
        add: null,
        city: null,
        state: null,
        pincode: null,
        phone: null,
        gst: null,
        ship_id: null
      },
      detail: {
        totprddis: '',
        addition: '',
        tot: '',
        cgst: '',
        sgst: '',
        igst: '',
        taxamt: '',
        totalamtpay: '',
        totalamtpendingpay: ''
      }
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },

    cust_rights: function cust_rights() {
      return this.$store.getters.get_cust_rights;
    },
    shop_rights: function shop_rights() {
      return this.$store.getters.get_shop_rights;
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totaligst: function totaligst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.igst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.salestax = all;
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == '') {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return (all - parseFloat(this.detail.addition)).toFixed(4);
      }
    }
  },

  created: function created() {
    for (var i = 0; i < 3; i++) {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', avaqty: '', show: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '', show1: false, show2: false });
    }
    this.searchshops();
    this.searchcustomer();
    this.shopuser();

    var current_dt = new Date();
    var before_180 = new Date(current_dt.valueOf());
    var after_180 = new Date(current_dt.valueOf());
    before_180.setDate(before_180.getDate() - 180);
    after_180.setDate(before_180.getDate() + 180);
    this.disabledBefore = before_180;
    this.disabledAfter = after_180;
  },


  methods: {
    handleOk: function handleOk(event) {
      this.shopchange_modal = false;
      event.preventDefault();

      this.onSelectShp();
    },
    handleCancel: function handleCancel(event) {
      event.preventDefault();
      this.shopchange_modal = false;
      this.select_shop = this.selectshop;
    },
    addProduct: function addProduct(row, index) {
      var _thiss = this;
      this.loading = true;
      this.$http.get('/api/companyproducts/chk_plan_count').then(function (response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true;
          } else {
            _thiss.plan_modal = false;
            if (_thiss.selectedcustomer == null || _thiss.selectedcustomer.customer_id === undefined) {
              _thiss.haserror.cust = "Please Select Customer";
            } else {
              var _this = _thiss;
              row['productnamex'] = [];
              row['selectproductrow'] = null;
              _thiss.haserror.cust = "";
              _thiss.$http.get('/api/companyproducts/loadData').then(function (response) {
                if (response.data.data) {
                  _this.$addproductmodal.show(response.data.data);
                  var __this = _this;
                  var timer = setInterval(function () {
                    var modal_return = __this.$store.getters.get_productmodal;
                    if (modal_return !== null) {
                      clearInterval(timer);
                    }
                  }, 1000);
                }
              }).catch(function (error) {
                console.log(error);
                if (error.response.status === 401) {
                  localStorage.clear();
                  _this.$store.commit('SET_AUTH_USER', null);
                  _this.$router.push('/');
                }
                if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
                  localStorage.clear();
                  _this.$store.commit('SET_AUTH_USER', null);
                  _this.$router.push('/');
                }
              });
            }
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    addCustomer: function addCustomer() {
      var _thiss = this;
      this.loading = true;
      this.$http.get('/api/customers/chk_plan_count').then(function (response) {
        _thiss.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _thiss.plan_modal = true;
          } else {
            var params = {};
            var country_id = '101';
            var state_id = '22';
            var city_id = '2707';
            var _this = _thiss;
            _this.$http.get('/api/countries').then(function (countries) {
              params["conopt"] = countries.data;

              _this.$http.get('/api/companytypes').then(function (response) {
                params["contyp"] = response.data;

                _this.$http.get('/api/countries/' + country_id).then(function (sel_con) {
                  params["con"] = sel_con.data;
                  _this.$http.get('/api/states?&filter[where][country_id]=' + country_id).then(function (stateopt) {
                    params["stateopt"] = stateopt.data;
                    _this.$http.get('/api/states/' + state_id).then(function (sel_state) {
                      params["state"] = sel_state.data;
                      _this.$http.get('/api/cities?filter[where][state_id]=' + state_id).then(function (cityopt) {
                        params["cityopt"] = cityopt.data;
                        _this.$http.get('/api/cities/' + city_id).then(function (sel_city) {
                          params["city"] = sel_city.data;
                          _this.$addcustomermodal.showCustomer(params);

                          var timer = setInterval(function () {
                            var modal_return = _this.$store.getters.get_custmodal;
                            if (modal_return !== null) {
                              _this.customername.push(modal_return);
                              _this.selectedcustomer = modal_return;
                              _this.onSelectCust(modal_return);
                              clearInterval(timer);
                            }
                          }, 1000);
                        }).catch(function (error) {
                          console.log(error);
                        });
                      }).catch(function (error) {
                        console.log(error);
                      });
                    }).catch(function (error) {
                      console.log(error);
                    });
                  }).catch(function (error) {
                    console.log(error);
                  });
                }).catch(function (error) {
                  console.log(error);
                });
              }).catch(function (err) {
                console.log(err);
              });
            }).catch(function (error) {
              console.log(error);
            });
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    showAddress: function showAddress(adrs) {
      this.customer_gst = null;
      this.customer1.name = adrs.yname;
      this.customer1.add = adrs.yaddress;
      this.customer1.city = adrs.ycity;
      this.customer1.phone = adrs.yphn;
      this.customer1.state = adrs.ystate;
      this.customer1.pincode = adrs.ypincode;
      this.customer1.gst = adrs.ygst;
      this.customer1.ship_id = adrs.chkship_id;
      this.addressModel = false;
      this.is_cs_gst = true;
      this.is_i_gst = true;
      this.customer_gst = this.customer1.gst;

      if (this.company_gst && this.customer_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var customer_gst = this.customer_gst.substring(0, 2);
        if (company_gst === customer_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
          this.csgstdisable = true;
        } else {

          this.is_cs_gst = false;
          this.is_i_gst = true;
          this.igstdisable = true;
        }
      } else if (this.company_gst) {
        this.is_cs_gst = true;
        this.is_i_gst = true;
        this.csgstdisable = false;
        this.igstdisable = false;
      } else if (!this.company_gst) {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      }

      if (this.rows.length > 0) {
        this.set_taxforall();
      }
    },
    set_taxforall: function set_taxforall() {
      var lst_tax_id = [];
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].selectproductrow !== null) {
          var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.rows[i].selectproductrow) === 'object' ? this.rows[i].selectproductrow.tax_gst_id : this.rows[i].productdetails[0].tax_gst_id;
          lst_tax_id.push(tax_id);
        }
      }
      if (lst_tax_id.length > 0) {
        var _this = this;
        this.$http.get('/api/taxrates?filter={"where": {"tax_id": {"inq": ["' + lst_tax_id.join('","') + '"]}}}').then(function (response) {
          if (response.data.length > 0) {
            var obj = {};
            for (var j = 0; j < response.data.length; j++) {
              obj[response.data[j].tax_id] = response.data[j];
            }

            if (_this.company_gst && _this.customer_gst) {
              var company_gst = _this.company_gst.substring(0, 2);
              var customer_gst = _this.customer_gst.substring(0, 2);
              if (company_gst === customer_gst) {
                for (var k = 0; k < _this.rows.length; k++) {
                  if (_this.rows[k].selectproductrow !== null) {
                    var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.rows[k].selectproductrow) === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id;
                    _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst'];
                    _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst'];
                    _this.rows[k]['igst'] = 0.00;
                  }
                }
                _this.detail.igst = 0.000000;
              } else {
                for (var k = 0; k < _this.rows.length; k++) {
                  if (_this.rows[k].selectproductrow !== null) {
                    var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.rows[k].selectproductrow) === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id;
                    _this.rows[k]['cgst'] = 0.00;
                    _this.rows[k]['sgst'] = 0.00;
                    _this.rows[k]['igst'] = obj[tax_id]['tax_igst'];
                  }
                }
                _this.detail.sgst = 0.000000;
                _this.detail.cgst = 0.000000;
              }
            } else if (!_this.company_gst) {
              for (var k = 0; k < _this.rows.length; k++) {
                if (_this.rows[k].selectproductrow !== null) {
                  _this.rows[k]['inclusive1'] = true;
                  _this.rows[k]['cgst'] = 0.00;
                  _this.rows[k]['sgst'] = 0.00;
                  _this.rows[k]['igst'] = 0.00;
                }
              }
              _this.detail.cgst = 0.000000;
              _this.detail.sgst = 0.000000;
              _this.detail.igst = 0.000000;
            } else {
              for (var k = 0; k < _this.rows.length; k++) {
                if (_this.rows[k].selectproductrow !== null) {
                  var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.rows[k].selectproductrow) === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id;
                  _this.rows[k]['inclusive1'] = false;
                  _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst'];
                  _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst'];
                  _this.rows[k]['igst'] = 0.00;
                }
              }

              _this.detail.igst = 0.000000;
            }

            for (var k = 0; k < _this.rows.length; k++) {
              if (_this.rows[k].selectproductrow !== null) {
                _this.price(k);
              }
            }
          } else {
            alert('Something went wrong');
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    addShop: function addShop() {
      var _this = this;
      this.loading = true;
      this.$http.get('/api/shopestablishments/chk_plan_count').then(function (response) {
        _this.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _this.shopplan_modal = true;
          } else {
            _this.shopplan_modal = false;
            var params = {};
            _this.$http.get('/api/countries').then(function (countries) {
              params['countries'] = countries.data;
              _this.$addshopmodal.showShop(params);
              var __this = _this;
              var timer = setInterval(function () {
                var modal_return = __this.$store.getters.get_shopmodal;
                if (modal_return !== null) {
                  __this.searchshops(modal_return);
                  clearInterval(timer);
                }
              }, 1000);
            }).catch(function (error) {
              console.log(error);
            });
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== '') {
        if (regexp.test(this.totalamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalamtreceived = '';
          return;
        } else {
          this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(4);
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalparamtreceived = '';
          return;
        } else {
          this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === 'full') {
        this.fullpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    checkVariant: function checkVariant() {
      if (this.variantdata == null) {
        this.rows[this.variantindex].productnamex = [];
        this.rows[this.variantindex].selectedproductid = null;
        this.rows[this.variantindex].unit = '';
        this.rows[this.variantindex].selectproductrow = null;
        this.rows[this.variantindex].price = '';
        this.rows[this.variantindex].qty = '';
        this.rows[this.variantindex].amt = '';
        this.rows[this.variantindex].cgst = 0;
        this.rows[this.variantindex].sgst = 0;
        this.rows[this.variantindex].igst = '';
        this.rows[this.variantindex].amttotal = 0;
        this.rows[this.variantindex].percentagemd1 = '';
        this.rows[this.variantindex].amtmd1 = '';
        this.rows[this.variantindex].variantrow = 'n/a';
        this.rows[this.variantindex].avaqty = '';
        this.rows[this.variantindex].show = false;
        this.rows[this.variantindex].show1 = false;
        this.rows[this.variantindex].show2 = false;
        this.rows[this.variantindex].priceqty = '';
        this.rows[this.variantindex].inclusive1 = false;
        this.rows[this.variantindex].err_qty = '';
        this.rows[this.variantindex].err_price = '';
        this.rows[this.variantindex].err_sgst = '';
        this.rows[this.variantindex].err_cgst = '';
        this.rows[this.variantindex].err_igst = '';
        this.rows[this.variantindex].productExist = '';
      }
    },
    checkShop: function checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Customer";
        this.barcode = '';
      } else {
        this.haserror.cust = '';
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = '';
      } else {
        this.haserror.shop = '';
      }
    },
    searchBarcode: function searchBarcode() {
      var option = {};
      var index = 0;
      var addRow = 0;
      var _this = this;
      var barcode = this.barcode;
      this.barcode = '';
      if (barcode) {
        this.$http.get('/api/purchasereturns/joinproduct2?barcode=' + barcode).then(function (response) {

          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {

            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });
          if (response.data[0] != null) {

            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: 0, is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '', show: false, show1: false, show2: false });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];
            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.cust_cmp_name + ' - ' + item.cust_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    onSelectCust: function onSelectCust(option1) {
      this.haserror.cust = '';
      if (option1 === null) return;

      var _this = this;
      this.customer_gst = null;
      this.customer1.name = null;
      this.customer1.add = null;
      this.customer1.city = null;
      this.customer1.state = null;
      this.customer1.pincode = null;
      this.customer1.phone = null;
      this.customer1.gst = null;
      this.customer1.ship_id = null;
      this.addr.length = 0;
      this.$http.get('/api/customershippspecs?filter[where][customer_id]=' + option1.customer_id).then(function (response) {
        var addr_data = response.data['ship_dt'];
        var state_dt = response.data['state_dt'];
        var city_dt = response.data['city_dt'];
        for (var i = 0; i < addr_data.length; i++) {
          if (parseInt(addr_data[i].shipp_id) === 1) {
            _this.customer1.name = option1.cust_cmp_name;
            _this.customer1.add = addr_data[i].address;
            _this.customer1.city = city_dt[addr_data[i].city];
            _this.customer1.state = state_dt[addr_data[i].state_code];
            _this.customer1.pincode = addr_data[i].pincode;
            _this.customer1.phone = addr_data[i].contact_no;
            _this.customer1.gst = addr_data[i].gst_no;
            _this.customer1.ship_id = addr_data[i].shipp_id;
          }
          _this.addr.push({ yname: addr_data[i].customer_name, yaddress: addr_data[i].address, ypincode: addr_data[i].pincode, ystate: state_dt[addr_data[i].state_code], ystateid: addr_data[i].state_code, ycityid: addr_data[i].city, ycity: city_dt[addr_data[i].city], yphn: addr_data[i].contact_no, chkship_id: addr_data[i].shipp_id, ygst: addr_data[i].gst_no });
        }
      }).catch(function (error) {
        console.log(error);
      });
      this.is_cs_gst = true;
      this.is_i_gst = true;
      this.customer_gst = option1.cust_cmp_gst;
      if (this.company_gst && this.customer_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var customer_gst = this.customer_gst.substring(0, 2);
        if (company_gst === customer_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
          this.csgstdisable = true;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
          this.igstdisable = true;
        }
      } else if (this.company_gst) {
        this.is_cs_gst = true;
        this.is_i_gst = true;
        this.csgstdisable = false;
        this.igstdisable = false;
      } else if (!this.company_gst) {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      }
      if (this.rows.length > 0) {
        this.set_taxforall();
      }
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    show_tax: function show_tax(temprow, index) {
      var _this = this;
      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + temprow.selectproductrow.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.customer_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var customer_gst = _this.customer_gst.substring(0, 2);
          if (company_gst === customer_gst) {
            var salesTax = parseFloat(response.data.tax_igst) || 0;
            var splitTax = salesTax / 2;
            _this.rows[index]['sales_tax'] = salesTax;
            _this.rows[index]['cgst'] = splitTax;
            _this.rows[index]['sgst'] = splitTax;
            _this.rows[index]['igst'] = 0.00;
          } else {
            _this.rows[index]['sales_tax'] = response.data.tax_igst;
            _this.rows[index]['cgst'] = 0.00;
            _this.rows[index]['sgst'] = 0.00;
            _this.rows[index]['igst'] = response.data.tax_igst;
          }
        } else if (!_this.company_gst) {
          _this.rows[index]['inclusive1'] = true;
          _this.rows[index]['sales_tax'] = 0;
          _this.rows[index]['cgst'] = 0.00;
          _this.rows[index]['sgst'] = 0.00;
          _this.rows[index]['igst'] = 0.00;
        } else {
          _this.rows[index]['inclusive1'] = false;

          var salesTaxDefault = parseFloat(response.data.tax_igst) || 0;
          var splitTaxDefault = salesTaxDefault / 2;
          _this.rows[index]['sales_tax'] = salesTaxDefault;
          _this.rows[index]['cgst'] = splitTaxDefault;
          _this.rows[index]['sgst'] = splitTaxDefault;
          _this.rows[index]['igst'] = '';
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    onSelectProduct: function onSelectProduct(temprow, index) {
      var _this = this;
      this.$http.get('/api/estshopinventories?filter[where][product_id]=' + temprow.selectproductrow.product_id + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id + '&filter[where][variant_id]=' + temprow.variantrow).then(function (response) {
        if (response.data[0].variant_value === null) {
          if (response.data.length > 1) {
            _this.rows[index]['avaqty'] = response.data[1].quantity;

            _this.rows[index]['price'] = response.data[1].exp_sellprice_bft;
            _this.rows[index]['priceqty'] = response.data[1].exp_sellprice_bft;
            if (response.data[1].tax_inclusive == true) {
              _this.rows[index]['inclusive1'] = true;
            } else {
              _this.rows[index]['inclusive1'] = false;
            }
          } else {
            _this.rows[index]['price'] = '0.000';
            _this.rows[index]['avaqty'] = '0';
            _this.rows[index]['priceqty'] = '0.000';
            _this.saleprice_editable = true;
            _this.saleprice_nonedit = false;
            _this.rows[index]['inclusive1'] = false;
          }

          _this.rows[index]['variantrow'] = 'n/a';
          _this.rows[index]['selectedproductid'] = 'n/a';
          _this.rows[index]['show1'] = true;
          _this.rows[index]['show'] = false;
          _this.rows[index]['show2'] = false;
        } else {
          _this.rows[index]['show'] = true;
          _this.rows[index]['show1'] = false;
          _this.rows[index]['show2'] = false;
          if (response.data.length > 1) {
            if (response.data[1].tax_inclusive == true) {
              _this.rows[index]['inclusive1'] = true;
            } else {

              _this.rows[index]['inclusive1'] = false;
            }

            _this.rows[index]['selectedproductid'] = response.data[0].variant_value;
            _this.rows[index]['avaqty'] = response.data[1].quantity;

            if (parseFloat(response.data[1].exp_sellprice_bft) == 0) {
              _this.saleprice_editable = true;
              _this.saleprice_nonedit = false;
            }
            _this.rows[index]['price'] = response.data[1].exp_sellprice_bft;
            _this.rows[index]['priceqty'] = response.data[1].exp_sellprice_bft;

            if (response.data[1].variant_id == '') {
              _this.rows[index]['variantrow'] = 'n/a';
            } else {
              _this.rows[index]['variantrow'] = response.data[1].variant_id;
            }
          } else {
            _this.rows[index]['inclusive1'] = false;
            _this.rows[index]['avaqty'] = '0';
            _this.rows[index]['priceqty'] = '0.000';
            _this.rows[index]['price'] = '0.000';
            _this.rows[index]['inclusive1'] = false;
            _this.saleprice_editable = true;
            _this.saleprice_nonedit = false;
          }
        }
        _this.price(index);
      }).catch(function (err) {
        console.log(err);
      });
    },
    setRow: function setRow(temprow, index) {
      var _this = this;
      var product_id = temprow.selectproductrow.product_id;
      var variant_id = temprow.selectproductrow.variantrow;
      this.$http.get('/api/companyproducts/getProductDetail?filter[where][product_id]=' + product_id).then(function (response) {
        if (response.data.length > 0) {
          _this.rows[index].selectproductrow = response.data[0];
          _this.rows[index]['unit'] = response.data[0].unit_name;
          _this.rows[index]['unitvalue'] = response.data[0].unit_id;

          _this.onSelectProduct(_this.rows[index], index);
          if (response.data[0].tax_gst_id !== '' && response.data[0].tax_gst_id !== null) {
            _this.show_tax(_this.rows[index], index);
          } else {
            _this.rows[index]['amt'] = '';
            _this.rows[index]['cgst'] = 0;
            _this.rows[index]['sgst'] = 0;
            _this.rows[index]['igst'] = 0;
            _this.rows[index]['amttotal'] = 0;
            _this.rows[index]['inclusive1'] = false;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    onSelectvariant: function onSelectvariant(option) {
      var _this = this;
      var index = this.variantindex;

      if (option.variant_value === 'No Variant') {
        this.rows[this.variantindex]['variantrow'] = 'n/a';
      } else {
        this.rows[this.variantindex]['variantrow'] = option.variant_value;
      }
      this.smallmodal = false;


      var temprow = this.rows[this.variantindex];

      if (temprow.selectproductrow) {
        this.setRow(temprow, this.variantindex);
      } else {
        _this.rows[index]['selectedproductid'] = '';
        _this.rows[index]['unit'] = '';
        _this.rows[index]['unitvalue'] = '';
        _this.rows[index]['selectproductrow'] = null;
        _this.rows[index]['price'] = '';
        _this.rows[index]['qty'] = '';
        _this.rows[index]['amt'] = '';
        _this.rows[index]['cgst'] = 0;
        _this.rows[index]['sgst'] = 0;
        _this.rows[index]['igst'] = '';
        _this.rows[index]['amttotal'] = 0;
        _this.rows[index]['batchmd1'] = '';
        _this.rows[index]['serialmd1'] = '';
        _this.rows[index]['percentagemd1'] = '';
        _this.rows[index]['amtmd1'] = '';
        _this.rows[index]['variantrow'] = 'n/a';
        _this.rows[index]['inclusive1'] = false;
        _this.rows[index]['salepricemd1'] = 0;
      }
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(row, index) {
      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id;
      if (vrnt_id !== null) {
        this.smallmodal = true;
        this.$http.get('/api/variantvalues?filter[where][variant_id]=' + vrnt_id).then(function (response) {

          _this.variantvalue = response.data;
          _this.variantvalue.unshift({ company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant" });
        }).catch(function (error) {});
      } else {
        this.rows[this.variantindex].show = true;
        this.rows[this.variantindex].show1 = false;
        this.rows[this.variantindex].show2 = false;
        var option = { company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant" };
        this.onSelectvariant(option);
        this.smallmodal = false;
      }
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.percentagemd = '';
      this.amtmd = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
    },
    addRow1: function addRow1() {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', avaqty: '', variantrow: 'n/a', show: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '' });
    },

    removeElement: function removeElement(index) {
      this.rows.splice(index, 1);
      if (this.selected_pytype === 'partial') {
        this.bal = 0.0000;
        this.totalparamtreceived = '';
      }
    },

    searchshops: function searchshops(shop_id) {
      var _this = this;
      this.$http.get('/api/shopusers/getShop').then(function (response) {
        _this.shopname = response.data;
        if (shop_id === undefined) {
          for (var i = 0; i < response.data.length; i++) {
            if (response.data.length == i + 1) {
              _this.selectshop = response.data[i];
              if (_this.selectshop.saleprice === true) {
                _this.saleprice_editable = true;
                _this.saleprice_nonedit = false;
              } else {
                _this.saleprice_nonedit = true;
                _this.saleprice_editable = false;
              }
              _this.company_data();
            }
          }
        } else {
          var select_shp = _this.shopname.filter(function (each) {
            return each.est_shop_id === shop_id;
          });
          _this.selectshop = select_shp[0];
          if (_this.selectshop.saleprice === true) {
            _this.saleprice_editable = true;
            _this.saleprice_nonedit = false;
          } else {
            _this.saleprice_nonedit = true;
            _this.saleprice_editable = false;
          }
          _this.company_data();
        }
      }).catch(function (er) {
        console.log(er);
      });
    },
    searchprd3: function searchprd3(searchText, index, row) {
      this.haserror.cust = '';
      this.haserror.shop = '';
      var status = 1;

      if (this.selectshop == null) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }

      if (this.selectedcustomer == null || this.selectedcustomer.customer_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Customer";
      }

      if (status == 1) {
        var shopid = this.selectshop.est_shop_id;
        var _this = this;

        this.$http.get('/api/purchasereturns/joinproduct2?data=' + searchText).then(function (response) {
          row.productnamex = response.data;
        }).catch(function (error) {});
      }
    },
    onShpChange: function onShpChange(option) {
      this.shop_option = option;
      var item_exist = false;
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].selectproductrow !== null) {
          if (this.rows[i].selectproductrow.product_id !== null) {
            item_exist = true;
            break;
          }
        }
      }

      if (item_exist === true) {
        this.shopchange_modal = true;
      } else {
        this.onSelectShp();
      }
    },
    onSelectShp: function onSelectShp() {
      this.haserror.shop = '';
      var option = this.shop_option;
      if (option.id != undefined) {
        if (this.select_shop == null || this.select_shop.est_shop_id === undefined) {
          this.haserror.shop = "Please Select Shop";
        }
      } else {
        this.haserror.shop = "Please Select Shop";
      }
      this.selectshop = this.select_shop;

      if (this.selectshop.saleprice === true) {
        this.saleprice_editable = true;
        this.saleprice_nonedit = false;
      } else {
        this.saleprice_nonedit = true;
        this.saleprice_editable = false;
      }
      this.company_gst = option.shop_gst;

      this.is_cs_gst = true;
      this.is_i_gst = true;
      if (this.company_gst && this.customer_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var customer_gst = this.customer_gst.substring(0, 2);
        if (company_gst === customer_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
          this.csgstdisable = true;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
          this.igstdisable = true;
        }
      } else if (this.company_gst) {
        this.is_cs_gst = true;
        this.is_i_gst = true;
        this.csgstdisable = false;
        this.igstdisable = false;
      } else if (!this.company_gst) {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      }
      this.totalamtreceived = '';
      this.rows.length = 0;
      for (var i = 0; i < 3; i++) {
        this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', avaqty: '', show: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '', show1: false, show2: false });
      }
    },
    searchcustomer: function searchcustomer() {
      var _this = this;
      this.$http.get('/api/customers').then(function (response) {
        _this.customername = response.data;
      }).catch(function (error) {});
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;

      this.haserror.amt = '';
      this.haserror.dis = '';

      if (this.percentagemd != '' && this.amtmd != '') {
        this.haserror.amt = "Any one of required";
      } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Valid Amount";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]['batchmd1'] = this.batchmd;
        this.rows[val]['serialmd1'] = this.serialmd;
        this.rows[val]['percentagemd1'] = this.percentagemd;
        this.rows[val]['amtmd1'] = this.amtmd;
        this.rows[val]['inclusive1'] = this.inclusive;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition != '') {
        this.detail.addition = '';
        alert("Please Provide Valid Integer For Additional Discount");
      }
      this.err_totamtpay = '';
      if (parseFloat(this.detail.totalamtpay) < 0.00) {
        this.err_totamtpay = 'Invalid Entry for Total Amount';
      }

      if (this.selected_pytype === 'partial') {
        if (this.totalparamtreceived !== '') {
          this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
        }
      } else if (this.selected_pytype === 'full') {
        this.totalamtreceived = parseFloat(this.detail.totalamtpay).toFixed(4);
      }
    },
    price: function price(index) {
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var diff = 0;
      var temp_price = this.rows[index]['priceqty'];
      var temp_avaqty = this.rows[index]['avaqty'];

      if (igstexp.test(this.rows[index]['igst']) == false && this.rows[index]['igst'] !== '') {
        this.rows[index]['igst'] = 0;
        this.rows[index]['err_igst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['igst']) < 0) {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else {
        this.rows[index]['err_igst'] = '';
      }

      if (tax.test(this.rows[index]['sgst']) == false && this.rows[index]['sgst'] !== '') {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['sgst']) < 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else {
        this.rows[index]['err_sgst'] = '';
        this.rows[index]['cgst'] = this.rows[index]['sgst'];
      }

      if (tax.test(this.rows[index]['cgst']) == false && this.rows[index]['cgst'] !== '') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['cgst']) < 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else {
        this.rows[index]['err_cgst'] = '';
      }

      if (this.rows[index]['price'] == '') {
        this.rows[index]['err_price'] = 'Required';
      } else if (parseFloat(this.rows[index]['price']) < 0.00) {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else if (price.test(this.rows[index]['price']) == false && this.rows[index]['price'] !== '') {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else {
        this.rows[index]['err_price'] = '';
        this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4);
      }

      if (this.rows[index]['qty'] == '') {
        this.rows[index]['err_qty'] = 'Required';
      } else if (parseFloat(this.rows[index]['qty']) <= 0.00) {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (price.test(this.rows[index]['qty']) == false && this.rows[index]['qty'] != '') {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else {
        this.rows[index]['err_qty'] = '';
      }

      if (this.rows[index]['igst'] !== '' && parseFloat(this.rows[index]['igst']) > 0.00 && this.companyTaxType !== 'US') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['sgst'] = 0;
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else if (this.rows[index]['igst'] !== '' && parseFloat(this.rows[index]['igst']) > 0.00 && this.companyTaxType === 'US') {
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else {
        this.rows[index]['igst'] = 0.00;
        var igst_value = 0.00;
      }

      if (this.rows[index]['qty'] != '' && this.rows[index]['price'] != '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else if (this.rows[index]['qty'] != '' && this.rows[index]['price'] == '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] != '') {
        var qty = 0;
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      }

      if (this.rows[index]['percentagemd1'] != '') {
        total = total - total * this.rows[index]['percentagemd1'] / 100;
      }
      if (this.rows[index]['amtmd1'] != '') {
        total = total - parseFloat(this.rows[index]['amtmd1']);
      }

      if (total != undefined) {
        if (this.rows[index]['inclusive1'] == false) {
          this.rows[index]['amt'] = total.toFixed(4);

          var amttotal;
          if (this.companyTaxType === 'US') {
            amttotal = total + igst_value * total / 100;
          } else {
            amttotal = total + this.rows[index]['sgst'] * total / 100 + this.rows[index]['cgst'] * total / 100 + igst_value * total / 100;
          }
          amttotal = amttotal.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
        } else if (this.rows[index]['inclusive1'] == true) {
          amttotal = total.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
          var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]['amt'] = bfttotal.toFixed(4);
        }
      }

      if (this.selected_pytype === 'partial') {
        this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
      } else if (this.selected_pytype === 'full') {
        this.totalamtreceived = parseFloat(this.totalamtpay).toFixed(4);
      }
    },
    updateSalesTax: function updateSalesTax(index) {
      var salesTax = parseFloat(this.rows[index]['sales_tax']) || 0;

      var taxMode = this.companyTaxType || 'IN';

      if (taxMode === 'IN') {
        this.rows[index]['igst'] = salesTax;
        this.rows[index]['sgst'] = 0;
        this.rows[index]['cgst'] = 0;
        this.price(index);
        return;
      }

      var splitTax = salesTax / 2;

      this.rows[index]['sgst'] = splitTax;
      this.rows[index]['cgst'] = splitTax;
      this.rows[index]['igst'] = salesTax;

      this.price(index);
    },
    finalsubmit: function finalsubmit(val) {
      var _thiss = this;
      this.haserror.message = '';
      this.haserror.cust = '';
      this.haserror.shop = '';
      var submit = 0;
      this.loading = true;

      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      var submit = 0;
      var dtregex = /^[0-9]{1}$/;
      var saleentry_date = new Date(_thiss.saleentry_dt);
      var year1 = saleentry_date.getFullYear();
      var month1 = saleentry_date.getMonth() + 1;
      var daycon = saleentry_date.getDate();

      if (dtregex.test(month1) == true) {
        var month1 = '0' + month1;
      } else {
        var month1 = month1;
      }
      if (dtregex.test(daycon) == true) {
        var day1 = '0' + daycon;
      } else {
        var day1 = daycon;
      }

      saleentry_date = year1 + '-' + month1 + '-' + day1;

      for (var i = _thiss.rows.length - 1; i >= 0; i--) {
        if (_thiss.rows[i].selectproductrow != null) {

          if (_thiss.rows[i].price == '') {
            submit = 1;
            _thiss.rows[i].err_price = 'Required';
          } else if (parseFloat(_thiss.rows[i].price) < 0) {
            submit = 1;
            _thiss.rows[i].err_price = 'Invalid Price';
          } else if (price.test(_thiss.rows[i].price) == false && _thiss.rows[i].price != '') {
            submit = 1;
            _thiss.rows[i].err_price = 'Invalid Price';
          }

          if (_thiss.rows[i].qty == '') {
            submit = 1;
            _thiss.rows[i].err_qty = 'Required';
          } else if (parseFloat(_thiss.rows[i].qty) <= 0) {
            submit = 1;
            _thiss.rows[i].err_qty = 'Invalid Quantity';
          } else if (price.test(_thiss.rows[i].qty) == false && _thiss.rows[i].qty != '') {
            submit = 1;
            _thiss.rows[i].err_qty = 'Invalid Quantity';
          }

          if (igstexp.test(_thiss.rows[i]['igst']) == false && _thiss.rows[i]['igst'] != '') {
            _thiss.rows[i]['igst'] = '';
            _thiss.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(_thiss.rows[i]['igst']) < 0) {
            _thiss.rows[i]['igst'] = '';
            _thiss.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(_thiss.rows[i]['cgst']) == false && _thiss.rows[i]['cgst'] != 0) {
            _thiss.rows[i]['cgst'] = 0;
            _thiss.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(_thiss.rows[i]['cgst']) < 0) {
            _thiss.rows[i]['cgst'] = 0;
            _thiss.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(_thiss.rows[i]['sgst']) == false && _thiss.rows[i]['sgst'] != 0) {
            _thiss.rows[i]['sgst'] = 0;
            _thiss.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(_thiss.rows[i]['sgst']) < 0) {
            _thiss.rows[i]['sgst'] = 0;
            _thiss.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          }
        }
      }

      if (_thiss.selectedcustomer == null || _thiss.selectedcustomer.customer_id == null || _thiss.selectshop == null || _thiss.selectshop.est_shop_id == null) {
        if (_thiss.selectshop == null || _thiss.selectshop.est_shop_id == null) {
          _thiss.haserror.shop = "Please Select Shop";
        }
        if (_thiss.selectedcustomer == null || _thiss.selectedcustomer.customer_id == null) {
          _thiss.haserror.cust = "Please Select Customer";
        }
      } else {
        for (var i = _thiss.rows.length - 1; i >= 0; i--) {
          if (_thiss.rows[i].selectproductrow == null) {
            _thiss.rows.splice(i, 1);
          }
        }
        _thiss.err_totamtpay = '';
        if (_thiss.rows.length == 0) {
          alert("nothing to Save");
        } else {
          var _this = _thiss;
          if (parseFloat(_thiss.detail.totalamtpay) < 0) {
            _thiss.err_totamtpay = 'Invalid Entry for Total Amount';
          } else {
            if (submit == 0) {
              _thiss.amt_rec = '';
              if (_thiss.selected_pytype === 'full') {
                if (parseFloat(_thiss.chng) < 0.00) {
                  _thiss.amt_rec = 'Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)';
                  _thiss.totalamtreceived = '';
                  _thiss.chng = 0;
                  return;
                }
                _thiss.detail.totalamtpendingpay = 0;
              } else if (_thiss.selected_pytype === 'partial') {
                if (parseFloat(_thiss.totalparamtreceived) == 0 || _thiss.totalparamtreceived == '') {
                  _thiss.amt_rec = 'Required';
                  _thiss.totalparamtreceived = '';
                  _thiss.bal = 0.0000;
                  return;
                } else if (parseFloat(_thiss.bal) < 0) {
                  _thiss.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)';
                  _thiss.totalparamtreceived = '';
                  _thiss.bal = 0.0000;
                  return;
                }
                _thiss.detail.totalamtpendingpay = _thiss.bal;
              } else {
                _thiss.detail.totalamtpendingpay = _thiss.detail.totalamtpay;
              }

              if (_thiss.cheque_date != '') {
                var daynum = /^[0-9]{1}$/;
                var date = new Date(_thiss.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = '0' + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = '0' + day;
                } else {
                  var day = day;
                }
                var dateval = year + '-' + month + '-' + day;
              } else {
                var dateval = null;
              }

              _thiss.loading = true;
              var data = {};
              data.sale_entry_date = saleentry_date;
              data.suppliersid = _thiss.selectedcustomer.customer_id;
              data.shopid = _thiss.selectshop.est_shop_id;
              data.ship_id = _thiss.customer1.ship_id;
              data.pur_items = _thiss.rows;
              data.total_discount = _thiss.detail.totprddis;
              data.additional = _thiss.detail.addition;
              data.amt_before_tax = _thiss.detail.tot;
              data.cgst = _thiss.detail.cgst;
              data.sgst = _thiss.detail.sgst;
              data.igst = _thiss.detail.igst;
              data.taxamt = _thiss.detail.taxamt;
              data.totalamtpay = _thiss.detail.totalamtpay;
              data.totalamtpendingpay = _thiss.detail.totalamtpendingpay;
              data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
              data.pay.paytype = _thiss.selected_pytype;
              data.pay.paymode = _thiss.selected_pymode;
              data.pay.chqno = _thiss.cheque_no;
              data.pay.chqdt = dateval;
              data.pay.amt = parseFloat(_thiss.detail.totalamtpay) - parseFloat(_thiss.detail.totalamtpendingpay);

              _thiss.$http.post('/api/sales/saledata', data).then(function (response) {
                var saleid = response.data.data.saleid;
                _this.loading = false;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = 'Sales Added Successfully';
                setTimeout(function () {
                  _this.haserror.message = '';
                }, 2000);

                if (val == 'inv') {
                  var routeData = _this.$router.resolve({ name: 'Sale Invoice Pdf', query: { sid: saleid, cid: _this.selectedcustomer.customer_id } });
                  window.open(routeData.href, '_blank');
                }
                _this.reset();
              }).catch(function (error) {
                _this.loading = false;
              });
            }
          }
        }
      }
    },
    reset: function reset() {
      this.igstdisable = true;
      this.csgstdisable = true;
      this.selectedcustomer = null;
      this.selectshop = null;
      this.detail.totprddis = '';
      this.detail.addition = '';
      this.detail.tot = '';
      this.detail.cgst = '';
      this.detail.sgst = '';
      this.detail.igst = '';
      this.detail.taxamt = '';
      this.detail.totalamtpay = '';
      this.detail.totalamtpendingpay = '';
      this.chng = 0;
      this.bal = 0.0000;
      this.totalamtreceived = '';
      this.cheque_no = '';
      this.cheque_date = '';
      this.addr = [];
      this.company_gst = null;
      this.customer_gst = null;
      this.selected_pymode = 'cash';
      this.selected_pytype = 'full';
      this.customer1.name = null;
      this.customer1.add = null;
      this.customer1.city = null;
      this.customer1.state = null;
      this.customer1.pincode = null;
      this.customer1.phone = null;
      this.customer1.gst = null;
      this.customer1.ship_id = null;
      this.saleentry_dt = new Date().toISOString().slice(0, 10);
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }
      for (var i = 0; i <= 2; i++) {
        this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', avaqty: '', show: false, show1: false, show2: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '' });
      }
    }
  }
});

/***/ }),
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_4__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      disabledBefore: null,
      disabledAfter: null,
      saleentry_dt: '',
      totamtrecdis: false,
      ship_id: null,
      csgstdisable: true,
      igstdisable: true,
      addr: [],
      addressModel: false,
      all_unit: null,
      loading: false,
      amt_rec: '',
      err_totamtpay: '',
      fullamt_rec: '',
      chequeno_validate: '',
      chequedate_validate: '',
      variantindex: null,
      smallmodal1: false,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      total_amt_paid: 0.00,
      totalamtreceived: '',
      totalamtpreviouspaid: 0.00,
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      tempArr: [],
      variantdata: null,
      oldshp: null,
      old_shop_id: null,
      percentagemd: '',
      amtmd: '',
      barcode: '',
      inclusive: false,
      indexval: null,
      allproduct: [],
      largeModal: false,
      customername: [],
      selected_pytype: 'full',
      lst_paymenttype: [{ value: 'full', text: 'Full' }, { value: 'partial', text: 'Partial' }, { value: 'no', text: 'No' }],
      selected_pymode: 'cash',
      selectedcustomer: null,
      shopname: [],
      selectshop: null,
      selectshopname: null,
      selectcustname: null,
      productname: [],
      lst_prod_var: [],
      remove_rows: [],
      selectproduct: {},
      is_cs_gst: true,
      is_i_gst: true,
      sales_id: '',
      company_gst: null,
      customer_gst: null,
      rows: [],
      haserror: {
        amt: '',
        dis: '',

        message: '',
        inclusive: ''
      },
      customer1: {
        name: null,
        add: null,
        city: null,
        state: null,
        pincode: null,
        phone: null
      },
      detail: {
        totprddis: '',
        addition: '',
        tot: '',
        cgst: '',
        sgst: '',
        igst: '',
        taxamt: '',
        totalamtpay: '',
        totalamtpendingpay: ''
      }
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {

        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totaligst: function totaligst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.igst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.igst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.salestax = all;
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == '') {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    var _this2 = this;

    for (var i = 0; i < 2; i++) {
      var prodlst = [];
      prodlst = this.allproduct;
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', avaqty: '', variantrow: 'n/a', show: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', item_seq: '' });
    }
    var current_dt = new Date();
    var before_180 = new Date(current_dt.valueOf());
    var after_180 = new Date(current_dt.valueOf());
    before_180.setDate(before_180.getDate() - 180);
    after_180.setDate(before_180.getDate() + 180);
    this.disabledBefore = before_180;
    this.disabledAfter = after_180;
    this.shopuser();
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.searchcustomer(), this.searchshops(), this.listProduct(), this.getUnit()]).then(function (ret_val) {
      _this2.showSaleItems();
    });
  },


  methods: {
    getUnit: function getUnit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get('/api/Unittypes/getUnit').then(function (response) {
                  _this.all_unit = response.data.data;
                  if (_this.all_unit !== null) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    showAddress: function showAddress(adrs) {
      this.customer1.name = adrs.yname;
      this.customer1.add = adrs.yaddress;
      this.customer1.city = adrs.ycity;
      this.customer1.phone = adrs.yphn;
      this.customer1.state = adrs.ystate;
      this.customer1.pincode = adrs.ypincode;
      this.customer1.gst = adrs.ygst;
      this.customer1.ship_id = adrs.chkship_id;
      this.addressModel = false;
      this.is_cs_gst = true;
      this.is_i_gst = true;
      this.customer_gst = this.customer1.gst;
      if (this.company_gst && this.customer_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var customer_gst = this.customer_gst.substring(0, 2);
        if (company_gst === customer_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
          this.csgstdisable = true;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
          this.igstdisable = true;
        }
      } else if (this.company_gst) {
        this.is_cs_gst = true;
        this.is_i_gst = true;
        this.csgstdisable = false;
        this.igstdisable = false;
      } else if (!this.company_gst) {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      }

      this.set_taxforall();
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== '') {
        if (regexp.test(this.totalamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalamtreceived = '';
          return;
        } else {
          if (parseFloat(this.totalamtpay) == parseFloat(this.totalamtpreviouspaid)) {
            this.totalamtreceived = '';
            this.fullamt_rec = 'Already Paid';
          } else {
            var paid = parseFloat(this.totalamtreceived) + parseFloat(this.totalamtpreviouspaid);
            this.chng = paid.toFixed(4) - parseFloat(this.detail.totalamtpay);
          }
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalparamtreceived = '';
          return;
        } else {
          var paid = parseFloat(this.totalparamtreceived) + parseFloat(this.totalamtpreviouspaid);
          this.bal = (parseFloat(this.detail.totalamtpay) - paid).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === 'full') {
        this.fullpay = true;
        this.totalamtreceived = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
          this.cheque_no = '';
          this.cheque_date = '';
        }
      } else {
        this.chqpay = false;
        this.cheque_no = '';
        this.cheque_date = '';
      }
    },
    showSaleItems: function showSaleItems() {
      this.rows.length = 0;
      var _this = this;
      this.totalamtreceived = '';
      this.sales_id = JSON.parse(localStorage.getItem('sales_id'));
      _this.$http.get('/api/saledetails?filter[where][sales_id]=' + _this.sales_id).then(function (res) {
        _this.$http.get('/api/sales?filter[where][sales_id]=' + _this.sales_id).then(function (response) {
          if (response.data[0]) {
            var select_shop = _this.shopname.filter(function (each) {
              return each.est_shop_id === response.data[0].est_shop_id;
            });
            _this.selectshop = select_shop[0];
            _this.old_shop_id = response.data[0].est_shop_id;
            _this.selectshopname = _this.selectshop.est_shop_name;
            var select_cust = _this.customername.filter(function (each) {
              return each.customer_id === response.data[0].customer_id;
            });
            _this.selectedcustomer = select_cust[0];
            _this.selectcustname = _this.nameAndnumber(_this.selectedcustomer);
            if (res.status === 200) {
              _this.saleentry_dt = res.data[0].sale_entry_date;
              _this.ship_id = res.data[0].ship_id;
              _this.detail.totalamtpendingpay = res.data[0].total_amt_pendingpay;
              _this.detail.addition = parseFloat(res.data[0].additional_discount).toFixed(4);
              if (parseFloat(res.data[0].total_amt_pay) === parseFloat(res.data[0].total_amt_pendingpay)) {
                _this.selected_pytype = 'no';
                _this.parpay = false;
                _this.fullpay = false;
              } else {
                _this.$http.get('/api/salepayments?filter[where][sale_id]=' + _this.sales_id + '&filter[where][customer_id]=' + _this.selectedcustomer.customer_id + '&filter[where][est_shop_id]=' + _this.selectshop.est_shop_id).then(function (r) {
                  if (r.status == 200) {
                    var totamtprepaid = '';
                    totamtprepaid = r.data.reduce(function (last, d) {
                      return parseFloat(d.amount) + parseFloat(last);
                    }, 0.0);
                    _this.totalamtpreviouspaid = totamtprepaid.toFixed(4);


                    if (parseFloat(res.data[0].total_amt_pendingpay) === 0.00) {
                      _this.selected_pytype = 'full';
                      _this.parpay = false;
                      _this.fullpay = true;
                    } else {
                      _this.selected_pytype = 'partial';
                      _this.parpay = true;
                      _this.fullpay = false;

                      _this.bal = parseFloat(res.data[0].total_amt_pendingpay).toFixed(2);
                    }
                  }
                });
              }
            }
            var api_filter = '';
            var len = parseInt(response.data.length);
            if (len > 1) {
              for (var k = 0; k < len; k++) {
                api_filter = api_filter + '&filter[where][product_id][inq]=' + response.data[k].product_id + '&filter[where][variant_id][inq]=' + response.data[k].variant_id;
              }
            } else {
              for (var k = 0; k < len; k++) {
                api_filter = api_filter + '&filter[where][product_id]=' + response.data[k].product_id + '&filter[where][variant_id]=' + response.data[k].variant_id;
              }
            }

            _this.$http.get('/api/estshopinventories?filter[where][est_shop_id]=' + _this.selectshop.est_shop_id + api_filter).then(function (rr) {
              var inv_data = {};
              for (var j = 1; j < parseInt(rr.data.length); j++) {
                var temp = { 'avaqty': 0, 'price': 0 };
                temp['avaqty'] = rr.data[j].quantity;

                temp['price'] = rr.data[j].exp_sellprice_bft;
                inv_data[rr.data[j].product_id + '_' + rr.data[j].variant_id] = temp;
              }

              for (var i = 0; i < len; i++) {
                var each = response.data[i];

                var key = each.product_id + '_' + each.variant_id;
                var avqty = 0;
                var price = 0;
                if (key in inv_data) {
                  avqty = inv_data[each.product_id + '_' + each.variant_id]['avaqty'];
                  price = inv_data[each.product_id + '_' + each.variant_id]['price'];
                }
                var prdctdetails = _this.allproduct.filter(function (item) {
                  return item.product_id === response.data[i].product_id;
                });
                var disc_pct = '';
                if (parseFloat(each.disc_pct).toFixed(2) !== '0.00') {
                  disc_pct = parseFloat(each.disc_pct);
                }
                var disc_amt = '';
                if (parseFloat(each.disc_amt).toFixed(2) !== '0.00') {
                  disc_amt = parseFloat(each.disc_amt).toFixed(4);
                }
                _this.rows.push({ productnamex: prdctdetails, selectedproductid: each.product_id, unit: _this.all_unit[each.unit_id], selectproductrow: prdctdetails[0], price: parseFloat(each.product_unit_cost).toFixed(4), qty: each.sale_qty, amt: parseFloat(each.amt_before_tax).toFixed(4), cgst: parseFloat(each.cgst_amt).toFixed(4), sgst: parseFloat(each.sgst_amt).toFixed(4), igst: parseFloat(each.igst_amt).toFixed(4), amttotal: parseFloat(each.amt_to_pay).toFixed(4), percentagemd1: disc_pct, amtmd1: disc_amt, variantrow: each.variant_id, avaqty: avqty, priceqty: price, inclusive1: each.tax_inclusive, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', productdetails: prdctdetails[0], item_seq: each.item_seq, sales_id: each.sales_id, id: each.id });
              }
              _this.company_gst = _this.selectshop.shop_gst;
              _this.onSelectCust(_this.selectedcustomer, false);
            });
          } else {
            _this.$router.push('/sales/salesentry');
          }
        });
      }).catch(function (er) {
        console.log(er);
      });
    },
    listProduct: function listProduct() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this4;
                _context2.next = 3;
                return _this4.$http.get('/api/companyproducts');

              case 3:
                response = _context2.sent;

                _this.allproduct = response.data;

                if (!(_this.allproduct.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    searchBarcode: function searchBarcode() {
      var option = {};
      var index = 0;
      var addRow = 0;
      var _this = this;
      var barcode = this.barcode;
      this.barcode = '';
      if (barcode) {
        this.$http.get('/api/purchasereturns/joinproduct2?barcode=' + barcode).then(function (response) {
          if (response.data[0] != null) {
            if (_this.rows.length == 0) {
              _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: 0, is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', item_seq: '' });
              _this.rows[0].productnamex.push(response.data[0]);
              _this.rows[0].selectproductrow = response.data[0];
              option = response.data[0];
              index = 0;
              _this.openvariant(option, index);
            } else {
              for (var i = 0; i < _this.rows.length; i++) {
                if (_this.rows[i].selectproductrow == null) {
                  _this.rows[i].productnamex.push(response.data[0]);
                  _this.rows[i].selectproductrow = response.data[0];
                  option = response.data[0];
                  index = i;
                  _this.openvariant(option, index);
                  break;
                } else if (_this.rows[i].selectproductrow.product_id == response.data[0].product_id) {
                  _this.rows[i].qty = parseFloat(_this.rows[i].qty) + 1;
                  option = _this.rows[i];
                  _this.price(i);
                  break;
                } else {
                  if (i == parseInt(_this.rows.length) - 1) {
                    _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: 0, is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', item_seq: '' });
                    var j = parseInt(i) + 1;
                    _this.rows[j].productnamex.push(response.data[0]);
                    _this.rows[j].selectproductrow = response.data[0];
                    option = response.data[0];
                    index = j;
                    _this.openvariant(option, index);
                    break;
                  }
                }
              }
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.cust_cmp_name + ' - ' + item.cust_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    savevatiantmodal: function savevatiantmodal(index) {},
    onSelectCust: function onSelectCust(option1, set_default) {
      var _this = this;
      this.customer1.name = null;
      this.customer1.add = null;
      this.customer1.city = null;
      this.customer1.state = null;
      this.customer1.pincode = null;
      this.customer1.phone = null;
      this.customer1.gst = null;
      this.customer1.ship_id = null;
      this.addr.length = 0;
      this.$http.get('/api/customershippspecs?filter[where][customer_id]=' + option1.customer_id).then(function (response) {
        var addr_data = response.data['ship_dt'];
        var state_dt = response.data['state_dt'];
        var city_dt = response.data['city_dt'];
        for (var i = 0; i < addr_data.length; i++) {
          if (set_default === true) {
            if (parseInt(addr_data[i].shipp_id) === 1) {
              _this.customer1.name = addr_data[i].customer_name;
              _this.customer1.add = addr_data[i].address;
              _this.customer1.city = city_dt[addr_data[i].city];
              _this.customer1.state = state_dt[addr_data[i].state_code];
              _this.customer1.pincode = addr_data[i].pincode;
              _this.customer1.phone = addr_data[i].contact_no;
              _this.customer1.gst = addr_data[i].gst_no;
              _this.customer1.ship_id = addr_data[i].shipp_id;
              _this.customer_gst = addr_data[i].gst_no;
            }
          } else {
            if (parseInt(addr_data[i].shipp_id) === parseInt(_this.ship_id)) {
              _this.customer1.name = addr_data[i].customer_name;
              _this.customer1.add = addr_data[i].address;
              _this.customer1.city = city_dt[addr_data[i].city];
              _this.customer1.state = state_dt[addr_data[i].state_code];
              _this.customer1.pincode = addr_data[i].pincode;
              _this.customer1.phone = addr_data[i].contact_no;
              _this.customer1.gst = addr_data[i].gst_no;
              _this.customer1.ship_id = addr_data[i].shipp_id;
              _this.customer_gst = addr_data[i].gst_no;
            }
          }
          _this.addr.push({ yname: addr_data[i].customer_name, yaddress: addr_data[i].address, ypincode: addr_data[i].pincode, ystate: state_dt[addr_data[i].state_code], ystateid: addr_data[i].state_code, ycityid: addr_data[i].city, ycity: city_dt[addr_data[i].city], yphn: addr_data[i].contact_no, chkship_id: addr_data[i].shipp_id, ygst: addr_data[i].gst_no });
          if (i === addr_data.length - 1) {
            _this.set_taxforall();
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    set_tax: function set_tax(tax_id, index) {
      var _this = this;
      var cust_id = this.customername.filter(function (item) {
        return item.customer_id === _this.customer_gst;
      });
      _this.customer_gst = cust_id.length == 0 ? _this.customer_gst : cust_id[0].cust_cmp_gst;
      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + tax_id).then(function (response) {
        if (_this.company_gst && _this.customer_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var customer_gst = _this.customer_gst.substring(0, 2);
          if (company_gst === customer_gst) {
            _this.rows[index]['cgst'] = response.data.tax_cgst;
            _this.rows[index]['sgst'] = response.data.tax_sgst;
            _this.rows[index]['igst'] = 0.00;
          } else {
            _this.rows[index]['cgst'] = 0.00;
            _this.rows[index]['sgst'] = 0.00;
            _this.rows[index]['igst'] = response.data.tax_igst;
          }
        } else if (!_this.company_gst) {
          _this.rows[index]['cgst'] = 0.00;
          _this.rows[index]['sgst'] = 0.00;
          _this.rows[index]['igst'] = 0.00;
        } else {
          _this.rows[index]['cgst'] = response.data.tax_cgst;
          _this.rows[index]['sgst'] = response.data.tax_sgst;
          _this.rows[index]['igst'] = 0.00;
        }
        _this.price(index);
      }).catch(function (err) {
        console.log(err);
      });
    },
    set_taxforall: function set_taxforall() {
      var lst_tax_id = [];
      for (var i = 0; i < this.rows.length; i++) {
        var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.rows[i].selectproductrow) === 'object' ? this.rows[i].selectproductrow.tax_gst_id : this.rows[i].productdetails[0].tax_gst_id;
        lst_tax_id.push(tax_id);
      }

      var _this = this;
      var cust_id = this.customername.filter(function (item) {
        return item.customer_id === _this.customer_gst;
      });
      _this.customer_gst = cust_id.length == 0 ? _this.customer_gst : cust_id[0].cust_cmp_gst;

      this.$http.get('/api/taxrates?filter={"where": {"tax_id": {"inq": ["' + lst_tax_id.join('","') + '"]}}}').then(function (response) {
        if (response.data.length > 0) {
          var obj = {};
          for (var j = 0; j < response.data.length; j++) {
            obj[response.data[j].tax_id] = response.data[j];
          }

          if (_this.company_gst && _this.customer_gst) {
            var company_gst = _this.company_gst.substring(0, 2);
            var customer_gst = _this.customer_gst.substring(0, 2);
            if (company_gst === customer_gst) {
              _this.is_cs_gst = true;
              _this.is_i_gst = false;
              _this.csgstdisable = true;
              for (var k = 0; k < _this.rows.length; k++) {
                var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.rows[k].selectproductrow) === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id;
                _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst'];
                _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst'];
                _this.rows[k]['igst'] = 0.00;
              }
              _this.detail.igst = 0.000000;
            } else {
              _this.is_cs_gst = false;
              _this.is_i_gst = true;
              _this.igstdisable = true;
              for (var k = 0; k < _this.rows.length; k++) {
                var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.rows[k].selectproductrow) === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id;
                _this.rows[k]['cgst'] = 0.00;
                _this.rows[k]['sgst'] = 0.00;
                _this.rows[k]['igst'] = obj[tax_id]['tax_igst'];
              }
              _this.detail.sgst = 0.000000;
              _this.detail.cgst = 0.000000;
            }
          } else if (!_this.company_gst) {
            _this.is_cs_gst = false;
            _this.is_i_gst = false;
            for (var k = 0; k < _this.rows.length; k++) {
              _this.rows[k]['cgst'] = 0.00;
              _this.rows[k]['sgst'] = 0.00;
              _this.rows[k]['igst'] = 0.00;
            }
            _this.detail.cgst = 0.000000;
            _this.detail.sgst = 0.000000;
            _this.detail.igst = 0.000000;
          } else {
            _this.is_cs_gst = true;
            _this.is_i_gst = true;
            _this.csgstdisable = false;
            _this.igstdisable = false;
            for (var k = 0; k < _this.rows.length; k++) {
              var tax_id = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_this.rows[k].selectproductrow) === 'object' ? _this.rows[k].selectproductrow.tax_gst_id : _this.rows[k].productdetails[0].tax_gst_id;
              if (parseFloat(_this.rows[k]['cgst']) <= 0.00 && parseFloat(_this.rows[k]['sgst']) <= 0.00 && parseFloat(_this.rows[k]['igst']) <= 0.00) {
                _this.rows[k]['inclusive1'] = false;
                _this.rows[k]['cgst'] = obj[tax_id]['tax_cgst'];
                _this.rows[k]['sgst'] = obj[tax_id]['tax_sgst'];
                _this.rows[k]['igst'] = 0.00;
              }
            }
            if (parseFloat(_this.rows[0]['cgst']) <= 0.00 && parseFloat(_this.rows[0]['sgst']) <= 0.00) {
              _this.detail.cgst = 0.000000;
              _this.detail.sgst = 0.000000;
            } else {
              _this.detail.igst = 0.000000;
            }
          }

          for (var k = 0; k < _this.rows.length; k++) {
            _this.price(k);
          }
        } else {
          alert('Something went wrong');
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    onSelectvariant: function onSelectvariant(option) {
      var _this = this;
      var index = this.variantindex;

      if (option.variant_value === 'No Variant') {
        this.rows[this.variantindex]['variantrow'] = 'n/a';
      } else {
        this.rows[this.variantindex]['variantrow'] = option.variant_value;
      }
      this.smallmodal = false;

      var temprow = this.rows[this.variantindex];
      var prdctid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(temprow.selectproductrow) === 'object' ? temprow.selectproductrow.product_id : temprow.selectproductrow;
      var prdctdetails = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(temprow.selectproductrow) === 'object' ? temprow.selectproductrow : null;
      var customer_gst = _this.customername.filter(function (item) {
        return item.customer_id === _this.selectedcustomer.customer_id;
      });
      _this.customer_gst = customer_gst[0].customer_id;
      var row = this.rows[this.variantindex].selectproductrow;
      _this.onSelect(row, this.variantindex);
      if (prdctdetails) {
        if (prdctdetails.tax_gst_id) {
          _this.set_tax(prdctdetails.tax_gst_id, _this.variantindex);
        }
      }
      this.checkInventory(index, prdctid, option.variant_value);
      this.price(index);
    },
    onSelect: function onSelect(option, index) {
      var _this = this;
      _this.rows[index]['inclusive1'] = false;
      if (option != null) {
        if (option.alt_product_id != undefined) {
          _this.rows[index]['unit'] = option.unit_name;
          _this.rows[index]['unitvalue'] = option.unit_id;
          _this.rows[index]['selectedproductid'] = option.variant_id;
        } else {
          _this.rows[index]['selectedproductid'] = '';
          _this.rows[index]['unit'] = '';
          _this.rows[index]['unitvalue'] = '';
          _this.rows[index]['selectproductrow'] = null;
          _this.rows[index]['price'] = '';
          _this.rows[index]['qty'] = '';
          _this.rows[index]['amt'] = '';
          _this.rows[index]['cgst'] = 0;
          _this.rows[index]['sgst'] = 0;
          _this.rows[index]['igst'] = '';
          _this.rows[index]['amttotal'] = 0;
          _this.rows[index]['batchmd1'] = '';
          _this.rows[index]['serialmd1'] = '';
          _this.rows[index]['percentagemd1'] = '';
          _this.rows[index]['amtmd1'] = '';
          _this.rows[index]['variantrow'] = 'n/a';
          _this.rows[index]['inclusive1'] = false;
          _this.rows[index]['salepricemd1'] = 0;
          _this.rows[index]['item_seq'] = '';
          _this.rows[index].showvariant = false;
          _this.rows[index].novariant = false;
        }
      } else {
        _this.rows[index]['selectedproductid'] = '';
        _this.rows[index]['unit'] = '';
        _this.rows[index]['unitvalue'] = '';
        _this.rows[index]['selectproductrow'] = null;
        _this.rows[index]['price'] = '';
        _this.rows[index]['qty'] = '';
        _this.rows[index]['amt'] = '';
        _this.rows[index]['cgst'] = 0;
        _this.rows[index]['sgst'] = 0;
        _this.rows[index]['igst'] = '';
        _this.rows[index]['amttotal'] = 0;
        _this.rows[index]['batchmd1'] = '';
        _this.rows[index]['serialmd1'] = '';
        _this.rows[index]['percentagemd1'] = '';
        _this.rows[index]['amtmd1'] = '';
        _this.rows[index]['variantrow'] = 'n/a';
        _this.rows[index]['inclusive1'] = false;
        _this.rows[index]['salepricemd1'] = 0;
      }
    },
    updateshop: function updateshop() {
      this.loading = true;
      var _this = this;
      this.$http.post('/api/sales/updateShop?filter[where][sales_id]=' + this.sales_id + '&filter[where][old_shop_id]=' + this.old_shop_id + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id).then(function (response) {

        if (response.status == 200) {
          if (response.data.data == 'Successful') {
            _this.$route.params.shopId = _this.selectshop.est_shop_id;
            setTimeout(function () {
              _this.showSaleItems();_this.smallmodal1 = false;_this.loading = false;
            }, 1000);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.haserror.message = 'Sales Updated Successfully';
            setTimeout(function () {
              _this.haserror.message = '';
            }, 3000);
          }
        }
      }).catch(function (error) {});
    },
    checkInventory: function checkInventory(index, pid, vid) {
      var _this = this;
      this.$http.get('/api/estshopinventories?filter[where][product_id]=' + pid + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id + '&filter[where][variant_id]=' + vid).then(function (response) {
        if (response.data.length > 1) {
          var avqty = response.data.length == 1 ? '0' : response.data[1].quantity;

          var price = response.data.length == 1 ? '0' : response.data[1].exp_sellprice_bft;

          _this.rows[index]['avaqty'] = avqty;
          _this.rows[index]['priceqty'] = price;
        } else {
          _this.rows[index]['avaqty'] = 0;
          _this.rows[index]['priceqty'] = 0;
        }
      });
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(row, index) {
      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id = row.selectproductrow == null ? row.variant_id : row.selectproductrow.variant_id;
      if (vrnt_id != null && vrnt_id != undefined) {
        this.smallmodal = true;
        this.$http.get('/api/variantvalues?filter[where][variant_id]=' + vrnt_id).then(function (response) {
          _this.variantvalue = response.data;
          _this.variantvalue.unshift({ company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant" });
        }).catch(function (error) {});
      } else {
        this.rows[this.variantindex].show = true;
        this.rows[this.variantindex].show1 = false;
        var option = { company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "No Variant" };
        this.onSelectvariant(option);
        this.smallmodal = false;
      }
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.percentagemd = '';
      this.amtmd = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
    },
    addRow1: function addRow1() {
      this.rows.push({ productnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', sales_tax: '', sales_tax_amt: 0, cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', avaqty: '', variantrow: 'n/a', show: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', productExist: '', item_seq: '' });
      this.selected_pytype = 'partial';
      this.selected_pymode = 'cash';
      this.parpay = true;
    },
    removeElement: function removeElement(row, index) {

      if (this.rows[index].item_seq != '') {
        this.remove_rows.push(this.rows[index]);
        this.rows.splice(index, 1);
      } else {
        this.rows.splice(index, 1);
      }
      this.manage_pre_paid();
    },
    manage_pre_paid: function manage_pre_paid() {
      if (parseFloat(this.totalamtpreviouspaid) > parseFloat(this.totalamtpay)) {
        this.paychange('full');
        this.modechange('cash');

        this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(4);
        this.totalparamtreceived = '';

        this.totalamtreceived = '';
        this.totamtrecdis = true;
      } else if (parseFloat(this.totalamtpreviouspaid) == parseFloat(this.totalamtpay)) {
        this.paychange('full');
        this.modechange('cash');
        this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(4);
        this.totalparamtreceived = '';
        this.totalamtreceived = '';
        this.totamtrecdis = true;
      } else {
        this.paychange('partial');
        this.modechange('cash');
        this.totalparamtreceived = '';
        this.bal = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        this.totamtrecdis = false;
      }
    },
    searchshops: function searchshops() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this = _this5;
                _context3.next = 3;
                return _this5.$http.get('/api/shopusers/getShop');

              case 3:
                response = _context3.sent;

                _this.shopname = response.data;

                if (!(_this.shopname.length > 0)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    searchprd3: function searchprd3(searchText, index, row) {
      var shopid = this.selectshop.est_shop_id;
      var _this = this;

      this.$http.get('/api/purchasereturns/joinproduct2?data=' + searchText).then(function (response) {
        row.productnamex = response.data;
      }).catch(function (error) {});
    },
    onSelectShp: function onSelectShp(option) {
      this.haserror.shop = '';
      this.company_gst = this.selectshop.shop_gst;
      this.set_taxforall();
      if (option == undefined) {
        this.haserror.shop = "Please Select Shop";
      }
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          var pid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.rows[i].selectproductrow) === 'object' ? this.rows[i].selectproductrow.product_id : this.rows[i].selectproductrow;
          var vid = this.rows[i].variantrow == null ? 'n/a' : this.rows[i].variantrow;
          this.checkInventory(i, pid, vid);
        }
      }
    },
    searchcustomer: function searchcustomer() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this = _this6;
                _context4.next = 3;
                return _this6.$http.get('/api/customers');

              case 3:
                response = _context4.sent;

                _this.customername = response.data;

                if (!(_this.customername.length > 0)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;

      this.haserror.amt = '';
      this.haserror.dis = '';

      if (this.percentagemd != '' && this.amtmd != '') {
        this.haserror.amt = "Any one of required";
      } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Invalid Percentage";
      } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Invalid Amount";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]['batchmd1'] = this.batchmd;
        this.rows[val]['serialmd1'] = this.serialmd;
        this.rows[val]['percentagemd1'] = this.percentagemd;
        this.rows[val]['amtmd1'] = this.amtmd;
        this.rows[val]['inclusive1'] = this.inclusive;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {

      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition != '') {
        this.detail.addition = '';
        alert("Please Provide Valid Integer For Additional Discount");
      }

      this.err_totamtpay = '';
      if (parseFloat(this.detail.totalamtpay) < 0.00) {
        this.err_totamtpay = 'Invalid Entry for Total Amount';
      }

      if (this.selected_pytype === 'partial') {
        if (this.totalparamtreceived !== '') {
          this.bal = (parseFloat(this.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4);
        }
      } else if (this.selected_pytype === 'full') {
        this.totalamtreceived = parseFloat(this.detail.totalamtpay).toFixed(4);
      }
    },
    price: function price(index) {
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,6})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,6})?$|^(100)?$/;
      var diff = 0;
      var temp_price = this.rows[index]['priceqty'];
      var temp_avaqty = this.rows[index]['avaqty'];

      if (igstexp.test(this.rows[index]['igst']) == false && this.rows[index]['igst'] !== '') {
        this.rows[index]['igst'] = 0;
        this.rows[index]['err_igst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['igst']) < 0) {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else {
        this.rows[index]['err_igst'] = '';
      }

      if (tax.test(this.rows[index]['sgst']) == false && this.rows[index]['sgst'] !== '') {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['sgst']) < 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else {
        this.rows[index]['err_sgst'] = '';
        this.rows[index]['cgst'] = this.rows[index]['sgst'];
      }

      if (tax.test(this.rows[index]['cgst']) == false && this.rows[index]['cgst'] !== '') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['cgst']) < 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else {
        this.rows[index]['err_cgst'] = '';
      }

      if (this.rows[index]['price'] === '') {
        this.rows[index]['err_price'] = 'Required';
      } else if (parseFloat(this.rows[index]['price']) < 0) {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else if (price.test(this.rows[index]['price']) == false && this.rows[index]['price'] != '') {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else {
        this.rows[index]['err_price'] = '';
      }

      if (this.rows[index]['qty'] === '') {
        this.rows[index]['err_qty'] = 'Required';
      } else if (parseFloat(this.rows[index]['qty']) <= 0.00) {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (price.test(this.rows[index]['qty']) == false && this.rows[index]['qty'] != '') {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else {
        this.rows[index]['err_qty'] = '';
      }

      if (this.rows[index]['igst'] !== '' && parseFloat(this.rows[index]['igst']) > 0.00 && this.companyTaxType !== 'US') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['sgst'] = 0;
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else if (this.rows[index]['igst'] !== '' && parseFloat(this.rows[index]['igst']) > 0.00 && this.companyTaxType === 'US') {
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else {
        this.rows[index]['igst'] = 0.00;
        var igst_value = 0.00;
      }

      if (this.rows[index]['qty'] !== '' && this.rows[index]['price'] !== '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else if (this.rows[index]['qty'] !== '' && this.rows[index]['price'] === '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] === '' && this.rows[index]['price'] !== '') {
        var qty = 0;
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      }

      if (this.rows[index]['percentagemd1'] != '') {
        total = total - total * this.rows[index]['percentagemd1'] / 100;
      }
      if (this.rows[index]['amtmd1'] != '') {
        total = total - parseFloat(this.rows[index]['amtmd1']);
      }
      if (total != undefined) {
        if (this.rows[index]['inclusive1'] == false) {
          this.rows[index]['amt'] = total.toFixed(4);
          var amttotal = total + this.rows[index]['sgst'] * total / 100 + this.rows[index]['cgst'] * total / 100 + igst_value * total / 100;
          amttotal = amttotal.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
        } else if (this.rows[index]['inclusive1'] == true) {
          amttotal = total.toFixed(4);
          this.rows[index]['amttotal'] = amttotal;
          var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]['amt'] = bfttotal.toFixed(4);
        }
      }
      this.manage_pre_paid();
    },
    updateSalesTax: function updateSalesTax(index) {
      var salesTax = parseFloat(this.rows[index]['sales_tax']) || 0;

      var taxMode = this.companyTaxType || 'IN';

      if (taxMode === 'IN') {
        this.rows[index]['igst'] = salesTax;
        this.rows[index]['sgst'] = 0;
        this.rows[index]['cgst'] = 0;
        this.price(index);
        return;
      }

      var splitTax = salesTax / 2;

      this.rows[index]['sgst'] = splitTax;
      this.rows[index]['cgst'] = splitTax;
      this.rows[index]['igst'] = salesTax;

      this.price(index);
    },
    finalsubmit: function finalsubmit(val) {
      this.haserror.message = '';


      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var submit = 0;
      var dtregex = /^[0-9]{1}$/;
      var saleentry_date = new Date(this.saleentry_dt);
      var year1 = saleentry_date.getFullYear();
      var month1 = saleentry_date.getMonth() + 1;
      var daycon = saleentry_date.getDate();

      if (dtregex.test(month1) == true) {
        var month1 = '0' + month1;
      } else {
        var month1 = month1;
      }
      if (dtregex.test(daycon) == true) {
        var day1 = '0' + daycon;
      } else {
        var day1 = daycon;
      }

      saleentry_date = year1 + '-' + month1 + '-' + day1;

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow != null) {
          if (this.rows[i].price === '') {
            submit = 1;
            this.rows[i].err_price = 'Required';
          } else if (parseFloat(this.rows[i].price) <= 0) {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          } else if (price.test(this.rows[i].price) == false && this.rows[i].price != '') {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          }

          if (this.rows[i].qty === '') {
            submit = 1;
            this.rows[i].err_qty = 'Required';
          } else if (parseFloat(this.rows[i].qty) <= 0.00) {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          } else if (price.test(this.rows[i].qty) == false && this.rows[i].qty != '') {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          }

          if (igstexp.test(this.rows[i]['igst']) == false && this.rows[i]['igst'] !== '' && parseFloat(this.rows[i]['igst']).toFixed(2) !== '0.00') {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['igst']) < 0) {

            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['cgst']) === false && this.rows[i]['cgst'] !== '' && parseFloat(this.rows[i]['cgst']) < 0.00) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['cgst']) < 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['sgst']) == false && this.rows[i]['sgst'] !== '' && parseFloat(this.rows[i]['sgst']) < 0.00) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['sgst']) < 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          }
        }
      }

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (!this.rows[i].selectproductrow) {
          this.rows.splice(i, 1);
        }
      }
      this.err_totamtpay = '';
      if (this.rows.length == 0) {
        alert("Nothing to Save");
      } else {
        if (parseFloat(this.detail.totalamtpay) < 0) {
          this.err_totamtpay = 'Invalid Entry for Total Amount';
        } else {
          if (submit == 0) {
            this.amt_rec = '';
            this.fullamt_rec = '';
            this.chequeno_validate = '';
            this.chequedate_validate = '';

            var amount_pay = 0.0;
            if (this.selected_pytype === 'full') {
              var chk_full = false;
              if (this.totalamtreceived !== '' && parseFloat(this.totalamtreceived) <= 0.00) {
                var paying = parseFloat(this.totalamtpreviouspaid) + parseFloat(this.totalamtreceived);
                if (this.totalamtpay > paying) {
                  this.fullamt_rec = 'Invalid Amount Received, please select payment type - partial';

                  chk_full = true;
                } else {
                  this.fullamt_rec = '';
                }
              } else if (parseFloat(this.chng) < 0.00) {
                if (this.totamtrecdis !== true) {
                  alert('Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(i.e Partial)');
                  this.totalamtreceived = '';
                  this.chng = 0;
                  chk_full = true;
                }
              }

              if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                this.chequeno_validate = 'Required';
                chk_full = true;
              }
              if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                this.chequedate_validate = 'Required';
                chk_full = true;
              }
              if (chk_full == true) {
                return;
              } else {
                if (this.totamtrecdis === false) {
                  amount_pay = this.totalamtreceived;
                  this.detail.totalamtpendingpay = 0;
                } else {
                  amount_pay = 0 - parseFloat(this.chng);
                  this.detail.totalamtpendingpay = 0;
                }
              }
            } else if (this.selected_pytype === 'partial') {
              var chk_partial = false;
              if (parseFloat(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
                this.amt_rec = 'Required';
                this.totalparamtreceived = '';
                this.bal = 0;
                chk_partial = true;
              }
              if (parseFloat(this.bal) < 0.00) {
                alert('Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(i.e Full)');
                this.totalparamtreceived = '';
                this.bal = 0;
                chk_partial = true;
              }
              if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                this.chequeno_validate = 'Required';
                chk_partial = true;
              }
              if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                this.chequedate_validate = 'Required';
                chk_partial = true;
              }
              if (chk_partial == true) {
                return;
              } else {
                this.detail.totalamtpendingpay = this.bal;
                amount_pay = this.totalparamtreceived;
              }
              this.detail.totalamtpendingpay = this.bal;
            } else {
              this.detail.totalamtpendingpay = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
              amount_pay = 0.00;
            }

            if (this.cheque_date != '') {
              var daynum = /^[0-9]{1}$/;
              var date = new Date(this.cheque_date);
              var year = date.getFullYear();
              var month = date.getMonth() + 1;
              var day = date.getDate();

              if (daynum.test(month) == true) {
                var month = '0' + month;
              } else {
                var month = month;
              }

              if (daynum.test(day) == true) {
                var day = '0' + day;
              } else {
                var day = day;
              }
              var dateval = year + '-' + month + '-' + day;
            } else {
              var dateval = null;
            }
            this.loading = true;
            var data = {};
            data.sale_entry_date = saleentry_date;
            data.suppliersid = this.selectedcustomer.customer_id;
            data.shopid = this.selectshop.est_shop_id;
            data.ship_id = this.customer1.ship_id;
            data.pur_items = this.rows;
            data.remove_pur_items = this.remove_rows;
            data.total_discount = this.detail.totprddis;
            data.additional = this.detail.addition;
            data.amt_before_tax = this.detail.tot;
            data.cgst = this.detail.cgst;
            data.sgst = this.detail.sgst;
            data.igst = this.detail.igst;
            data.taxamt = this.detail.taxamt;
            data.totalamtpay = this.detail.totalamtpay;
            data.sales_id = this.sales_id;
            data.totalamtpendingpay = this.detail.totalamtpendingpay;

            data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
            data.pay.paytype = this.selected_pytype;
            data.pay.paymode = this.selected_pymode;
            data.pay.chqno = this.cheque_no;
            data.pay.chqdt = dateval;

            data.pay.amt = amount_pay;

            var _this = this;
            this.$http.post('/api/sales/editdata', data).then(function (rersponse) {
              _this.loading = false;
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              _this.haserror.message = 'Sales Updated Successfully';
              setTimeout(function () {
                _this.haserror.message = '';
              }, 2000);

              if (val === '') {
                _this.reset();
                _this.$router.push('/sales/salesentry');
              } else {
                var routeData = _this.$router.resolve({ name: 'Sale Invoice Pdf', query: { sid: _this.sales_id, cid: _this.selectedcustomer.customer_id } });
                window.open(routeData.href, '_blank');
                _this.reset();
                _this.$router.push('/sales/salesentry');
              }
            }).catch(function (error) {
              _this.loading = false;
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              _this.haserror.message = 'There is something wrong! Please try again later';
              setTimeout(function () {
                _this.haserror.message = '';
              }, 2000);
              _this.reset();
              console.log(error);
            });
          }
        }
      }
    },
    reset: function reset() {
      this.igstdisable = true;
      this.csgstdisable = true;
      this.selectedcustomer = null;
      this.selectshop = null;
      this.detail.totprddis = '';
      this.detail.addition = '';
      this.detail.tot = '';
      this.detail.cgst = '';
      this.detail.sgst = '';
      this.detail.igst = '';
      this.detail.taxamt = '';
      this.detail.totalamtpay = '';
      this.detail.totalamtpendingpay = '';
      this.totalamtreceived = '';
      this.chng = '';
      this.bal = '';
      this.cheque_no = '';
      this.cheque_date = '';
      this.selected_pymode = 'cash';
      this.selected_pytype = 'full';
      this.customer1.name = null;
      this.customer1.add = null;
      this.customer1.city = null;
      this.customer1.state = null;
      this.customer1.pincode = null;
      this.customer1.phone = null;
      this.customer1.gst = null;
      this.company_gst = null;
      this.customer_gst = null;
      this.totamtrecdis = false;
      this.saleentry_dt = new Date().toISOString().slice(0, 10);
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }
      for (var i = 0; i < 2; i++) {
        this.rows.push({ productqnamex: [], selectedproductid: null, unit: '', selectproductrow: null, price: '', qty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', avaqty: '', show: false, show1: false, priceqty: '', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', item_seq: '' });
      }
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      slfirst: false,
      shpfirst: false,
      todate: null,
      fromdate: null,
      productunit: "",
      productqty: "",
      rows1: [],
      rows: [],
      warningModal: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },

      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      temprow: null,
      columns1: [{
        label: "Product Name",
        field: "product_name",
        width: "25% !important"
      }, {
        label: "Variant",
        field: "variant_id",
        width: "15% !important"
      }, {
        label: "Return Qty",
        field: "return_qty",
        width: "10% !important"
      }, {
        label: "Price",
        field: "product_unit_cost",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Sub Total",
        field: "sub_total",
        width: "10% !important",
        formatFn: this.formatFn
      }, {
        label: "Tax",
        field: "tax_inclusive",
        width: "10% !important"
      }, {
        label: "GST%",
        field: "gst_total",
        width: "15% !important"
      }, {
        label: "Amount",
        field: "amt_to_pay",
        width: "15% !important",
        formatFn: this.formatFn
      }]

    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    columns: function columns() {
      return [{ label: "Sales Return Id", field: "sales_return_id", width: "5% !important" }, { label: "Sales Id", field: "sales_id", width: "5% !important" }, { label: "Customer", field: "cust_cmp_name", width: "18% !important" }, { label: "Shop", field: "est_shop_name", width: "17% !important" }, { label: this.companyTaxType === 'US' ? "Tax Amount" : "GST Amount", field: "gst_total", width: "10% !important" }, { label: "Total Amount", field: "total_amt_pay", width: "15% !important", formatFn: this.formatFn }, { label: "Date", field: "lastupdated_datetime", type: "date", dateInputFormat: "YYYY-MM-DDThh:mm:ss", dateOutputFormat: "Do MMM YYYY", width: "15% !important", tdClass: "text-left", thClass: "text-left" }, { label: "Action", field: "action", width: "15% !important" }];
    },

    salert_view: function salert_view() {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_salert_view === true) {
          this.salesreturn("comp");
          this.shopuser("comp");
          return true;
        } else {
          return false;
        }
      }
    },
    salert_rights: function salert_rights() {
      return this.$store.getters.get_salert_rights;
    },
    is_admin: function is_admin() {
      return this.$store.getters.get_is_admin;
    }
  },

  methods: {
    removeSalesReturn: function removeSalesReturn(row) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http.delete("api/salertdetails/removeSalesReturn?id=" + row.sales_return_id + "&shp_id=" + row.est_shop_id).then(function (response) {
          if (response.status == 200) {
            _this.salesreturn();
            _this.loading = false;
          }
        }).catch(function (error) {
          _this.loading = false;
        });
      }
    },
    newDate: function newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }

      var dt2 = day + "-" + month + "-" + year;

      return dt2;
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1: function updateParams1(newProps, row) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params, row) {
      this.updateParams1({ page: params.currentPage });
      this.returnitem(this.temprow);
    },
    onPerPageChange1: function onPerPageChange1(params, row) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.returnitem(this.temprow);
    },
    onSortChange1: function onSortChange1(params, row) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        },
        page: 1
      });
      this.returnitem(this.temprow);
    },
    onColumnFilter1: function onColumnFilter1(params, row) {
      this.updateParams1(params);
      this.returnitem(this.temprow);
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompnay: function onSelectCompnay(selected_company) {
      this.loadItems();
    },
    loadItems: function loadItems() {
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.loading = true;
      var _this = this;
      var data = [];
      this.rows = [];
      var unit = this.productunit;
      var qty = this.productqty;
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();

      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;

      if (this.todate != null && this.fromdate != null) {
        data = data + " &filter[where][lastupdated_datetime][between][0]=" + todate1 + "&filter[where][lastupdated_datetime][between][1]=" + fromdate1;
      } else {
        if (this.todate != null) {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != null) {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }

      if (this.productunit != "") {
        data = data + "&filter[where][sales_return_id]=" + unit;
      }
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/salesreturns/getSalesRtns?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    salesreturn: function salesreturn(val) {
      if (val === "comp") {
        if (this.slfirst === false) {
          this.slfirst = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
    returnitem: function returnitem(row) {
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      this.temprow = row;
      var data = [];
      var data = data + " &filter[where][sales_return_id]=" + row.sales_return_id;
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/salesreturns/searchdb?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords1 = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows1 = response.data;
      });
    },
    searchsalesitem: function searchsalesitem() {
      this.updateParams({
        sort: {
          type: "",
          field: ""
        },
        page: 1
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      all_unit: null,
      dd_show: true,
      sale_id: null,
      shop_id: null,
      item_seqnos: null,
      selectcustname: null,
      selectshopname: null,
      loading: false,
      variantindex: null,
      smallmodal: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      totalamtreceived: "",
      totalparamtreceived: "",
      cheque_no: "",
      cheque_date: "",
      variantvalue: [],
      is_cs_gst: true,
      is_i_gst: true,
      company_gst: "",
      customer_gst: "",
      variantdata: null,
      percentagemd: "",
      amtmd: "",
      barcode: "",
      inclusive: false,
      indexval: null,
      largeModal: false,
      customername: [],
      selected_pytype: "full",
      lst_paymenttype: [{ value: "full", text: "Full" }, { value: "partial", text: "Partial" }, { value: "no", text: "No" }],
      selected_pymode: "cash",
      selectedcustomer: null,
      shopname: [],
      prod_lst: [],
      selectshop: null,
      productname: [],

      selectproduct: {},
      rows: [],
      haserror: {
        amt: "",
        dis: "",
        cust: "",
        message: "",
        inclusive: "",
        shop: ""
      },
      detail: {
        totprddis: "",
        addition: "",
        tot: "",
        cgst: "",
        sgst: "",
        igst: "",
        taxamt: "",
        totalamtpay: "",
        totalamtpendingpay: ""
      }
    };
  },


  computed: {
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.sgst) + Number(row.cgst));
      }, 0);
      all = all.toFixed(4);
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == "") {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    var _this2 = this;

    for (var i = 0; i < 3; i++) {
      this.rows.push({
        productnamex: [],
        selectedproductid: "",
        unit: "",
        unitvalue: "",
        selectproductrow: null,
        price: "",
        qty: "",
        amt: "",
        sales_tax: "",
        cgst: 0,
        sgst: 0,
        igst: "",
        amttotal: 0,
        percentagemd1: "",
        amtmd1: "",
        variantrow: "n/a",
        inclusive1: false,
        err_qty: "",
        maxqty: "",
        err_price: "",
        err_salestax: "",
        err_sgst: "",
        err_cgst: "",
        err_igst: "",
        novariant: false,
        productExist: "",
        showvariant: false,
        item_seqno: ""
      });
    }

    this.shopuser();
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.searchcustomer(), this.searchshops(), this.listproduct(), this.getUnit()]).then(function (ret_val) {
      _this2.loadSaleData();
    });
  },


  methods: {
    getUnit: function getUnit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get("/api/Unittypes/getUnit").then(function (response) {
                  _this.all_unit = response.data.data;
                  if (_this.all_unit !== null) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== "") {
        if (regexp.test(this.totalamtreceived) === false) {
          alert("Please Enter Valid Amount");
          this.totalamtreceived = "";
          return;
        } else {
          this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(2);
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== "") {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert("Please Enter Valid Amount");
          this.totalparamtreceived = "";
          return;
        } else {
          this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(2);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === "full") {
        this.fullpay = true;
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === "partial") {
        this.parpay = true;
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== "no") {
        if (this.selected_pymode == "cheque") {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    loadSaleData: function loadSaleData() {
      if ("saleId" in this.$route.params) {
        this.dd_show = false;
        this.rows.length = 0;
        this.sale_id = this.$route.params.saleId;
        this.shop_id = this.$route.params.shopId;
        this.item_seqnos = this.$route.params.itemSeqs;
        var _this = this;
        _this.$http.get("/api/sales?filter[where][sales_id]=" + _this.sale_id).then(function (response) {
          if (response.status == 200) {
            var select_cust = _this.customername.filter(function (each) {
              return each.customer_id === response.data[0].customer_id;
            });
            _this.selectedcustomer = select_cust[0];
            _this.selectcustname = _this.selectedcustomer.cust_cmp_name;
            var select_shop = _this.shopname.filter(function (each) {
              return each.est_shop_id === _this.shop_id;
            });
            _this.selectshop = select_shop[0];
            _this.selectshopname = _this.selectshop.est_shop_name;
            for (var i = 0; i < response.data.length; i++) {
              if (_this.item_seqnos.indexOf(response.data[i].item_seq) !== -1) {
                var disc_amt = "";
                if (parseFloat(response.data[i].disc_amt).toFixed(3) != "0.000") {
                  disc_amt = parseFloat(response.data[i].disc_amt).toFixed(4);
                }

                var disc_pct = "";
                if (parseFloat(response.data[i].disc_pct).toFixed(3) != "0.000") {
                  disc_pct = parseInt(response.data[i].disc_pct);
                }

                var igst = "";
                if (parseFloat(response.data[i].igst_amt).toFixed(3) != "0.000") {
                  igst = parseFloat(response.data[i].igst_amt).toFixed(4);
                }

                var sgst = "";
                if (parseFloat(response.data[i].sgst_amt).toFixed(3) != "0.000") {
                  sgst = parseFloat(response.data[i].sgst_amt).toFixed(4);
                }

                var cgst = "";
                if (parseFloat(response.data[i].cgst_amt).toFixed(3) != "0.000") {
                  cgst = parseFloat(response.data[i].cgst_amt).toFixed(4);
                }

                var novariant_val = true;
                var showvariant_val = false;
                var variant_val = "";
                if (response.data[i].variant_id != null && response.data[i].variant_id != "") {
                  novariant_val = false;
                  showvariant_val = true;
                  variant_val = response.data[i].variant_id;
                }

                var prod_dt = _this.prod_lst.filter(function (each) {
                  return each.product_id === response.data[i].product_id;
                });

                var unit_value = "";
                if (response.data[i].unit_id in _this.all_unit) {
                  unit_value = _this.all_unit[response.data[i].unit_id];
                }
                _this.rows.push({
                  productnamex: prod_dt,
                  selectedproductid: prod_dt[0].product_id,
                  unit: unit_value,
                  unitvalue: response.data[i].unit_id,
                  selectproductrow: prod_dt[0],
                  price: response.data[i].product_unit_cost,
                  qty: response.data[i].sale_qty,
                  maxqty: response.data[i].sale_qty,
                  amt: response.data[i].sub_total,
                  cgst: cgst,
                  sgst: sgst,
                  igst: igst,
                  amttotal: response.data[i].amt_to_pay,
                  percentagemd1: disc_pct,
                  amtmd1: disc_amt,
                  variantrow: variant_val,
                  inclusive1: response.data[i].tax_inclusive,
                  err_qty: "",
                  err_price: "",
                  err_sgst: "",
                  err_cgst: "",
                  err_igst: "",
                  novariant: novariant_val,
                  productExist: "",
                  showvariant: showvariant_val,
                  item_seqno: response.data[i].item_seq
                });
              }
            }
            _this.onSelectSup(_this.selectedcustomer);
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        return;
      }
    },
    listproduct: function listproduct() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this4;
                _context2.next = 3;
                return _this4.$http.get("/api/companyproducts");

              case 3:
                response = _context2.sent;

                _this.prod_lst = response.data;

                if (!(_this.prod_lst.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    checkVariant: function checkVariant() {
      if (this.variantdata == null) {
        this.rows[this.variantindex].productnamex = [];
        this.rows[this.variantindex].selectedproductid = null;
        this.rows[this.variantindex].unit = "";
        this.rows[this.variantindex].selectproductrow = null;
        this.rows[this.variantindex].price = "";
        this.rows[this.variantindex].qty = "";
        this.rows[this.variantindex].maxqty = "";
        this.rows[this.variantindex].amt = "";
        this.rows[this.variantindex].cgst = 0;
        this.rows[this.variantindex].sgst = 0;
        this.rows[this.variantindex].igst = "";
        this.rows[this.variantindex].amttotal = 0;
        this.rows[this.variantindex].percentagemd1 = "";
        this.rows[this.variantindex].amtmd1 = "";
        this.rows[this.variantindex].variantrow = "n/a";
        this.rows[this.variantindex].unitvalue = "";
        this.rows[this.variantindex].novariant = false;
        this.rows[this.variantindex].showvariant = false;
        this.rows[this.variantindex].inclusive1 = false;
        this.rows[this.variantindex].err_qty = "";
        this.rows[this.variantindex].err_price = "";
        this.rows[this.variantindex].err_sgst = "";
        this.rows[this.variantindex].err_cgst = "";
        this.rows[this.variantindex].err_igst = "";
        this.rows[this.variantindex].productExist = "";
      }
    },
    checkShop: function checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Customer";
        this.barcode = "";
      } else {
        this.haserror.cust = "";
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = "";
      } else {
        this.haserror.shop = "";
      }
    },
    searchBarcode: function searchBarcode() {
      var option = {};
      var index = 0;
      var addRow = 0;
      var _this = this;
      var barcode = this.barcode;
      this.barcode = "";
      if (barcode) {
        this.$http.get("/api/purchasereturns/joinproduct2?barcode=" + barcode).then(function (response) {
          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {
            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });

          if (response.data[0] != null) {
            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({
                productnamex: [],
                selectedproductid: "",
                unit: "",
                unitvalue: "",
                selectproductrow: null,
                price: "",
                qty: "",
                maxqty: "",
                amt: "",
                cgst: 0,
                sgst: 0,
                igst: "",
                amttotal: 0,
                batchmd1: "",
                serialmd1: "",
                percentagemd1: "",
                amtmd1: "",
                variantrow: "n/a",
                inclusive1: false,
                salepricemd1: 0,
                is_adjustment: false,
                adjustment_list: [],
                adjusted: [],
                err_qty: "",
                err_price: "",
                err_sgst: "",
                err_cgst: "",
                err_igst: "",
                productExist: "",
                showvariant: false,
                item_seqno: ""
              });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];
            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {}
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.cust_cmp_name + " - " + item.cust_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    savevatiantmodal: function savevatiantmodal(index) {},
    onSelectvariant: function onSelectvariant(option) {
      var temprow = this.rows[this.variantindex];
      var _this = this;
      var rowindex = -1;
      var index = this.variantindex;

      if (option.variant_value === "No Variant") {
        this.rows[this.variantindex]["variantrow"] = "n/a";
      } else {
        this.rows[this.variantindex]["variantrow"] = option.variant_value;
      }

      this.smallmodal = false;

      this.rows[this.variantindex].showvariant = option.variant_value == (null || "n/a" || 'No Variant') ? false : true;
      this.rows[this.variantindex].novariant = option.variant_value == (null || "n/a" || 'No Variant') ? true : false;
      var option = temprow.selectproductrow;
      if (option != null) {
        if (option.product_id != undefined) {
          this.show_tax(option, index);
          _this.rows[index]["qty"] = 1;
          _this.rows[index]["unit"] = option.unit_name;
          _this.rows[index]["unitvalue"] = option.unit_id;
          _this.rows[index]["selectedproductid"] = option.variant_id;

          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["adjusted"] = [];
          _this.rows[index]["price"] = "";
        } else {
          _this.rows[index]["selectedproductid"] = "";
          _this.rows[index]["unit"] = "";
          _this.rows[index]["unitvalue"] = "";
          _this.rows[index]["selectproductrow"] = null;
          _this.rows[index]["price"] = "";
          _this.rows[index]["qty"] = "";
          _this.rows[index]["amt"] = "";
          _this.rows[index]["cgst"] = 0;
          _this.rows[index]["sgst"] = 0;
          _this.rows[index]["igst"] = "";
          _this.rows[index]["amttotal"] = 0;
          _this.rows[index]["batchmd1"] = "";
          _this.rows[index]["serialmd1"] = "";
          _this.rows[index]["percentagemd1"] = "";
          _this.rows[index]["amtmd1"] = "";
          _this.rows[index]["variantrow"] = "n/a";
          _this.rows[index]["inclusive1"] = false;
          _this.rows[index]["salepricemd1"] = 0;
          _this.rows[index]["adjustment_list"] = [];
          _this.rows[index]["adjusted"] = [];
          _this.rows[index]["item_seqno"] = "";
        }
      } else {
        _this.rows[index]["selectedproductid"] = "";
        _this.rows[index]["unit"] = "";
        _this.rows[index]["unitvalue"] = "";
        _this.rows[index]["selectproductrow"] = null;
        _this.rows[index]["price"] = "";
        _this.rows[index]["qty"] = "";
        _this.rows[index]["amt"] = "";
        _this.rows[index]["cgst"] = 0;
        _this.rows[index]["sgst"] = 0;
        _this.rows[index]["igst"] = "";
        _this.rows[index]["amttotal"] = 0;
        _this.rows[index]["batchmd1"] = "";
        _this.rows[index]["serialmd1"] = "";
        _this.rows[index]["percentagemd1"] = "";
        _this.rows[index]["amtmd1"] = "";
        _this.rows[index]["variantrow"] = "n/a";
        _this.rows[index]["inclusive1"] = false;
        _this.rows[index]["salepricemd1"] = 0;
        _this.rows[index]["adjustment_list"] = [];
        _this.rows[index]["adjusted"] = [];
        _this.rows[index]["item_seqno"] = "";
      }
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ("product_id" in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(row, index) {
      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id = row.selectproductrow == undefined ? row.variant_id : row.selectproductrow.variant_id;

      if (vrnt_id != null) {
        this.smallmodal = true;
        this.$http.get("/api/variantvalues?filter[where][variant_id]=" + vrnt_id).then(function (response) {
          _this.variantvalue = response.data;
          _this.variantvalue.unshift({
            company_id: "I2OCGLB",
            id: 0,
            regcity_code: "I2O",
            variant_id: "0",
            variant_value: "No Variant"
          });
        }).catch(function (error) {});
      } else {
        this.smallmodal = false;

        var option = {
          company_id: "I2OCGLB",
          id: 0,
          regcity_code: "I2O",
          variant_id: "0",
          variant_value: "No Variant"
        };
        this.onSelectvariant(option);
      }
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.percentagemd = "";
      this.amtmd = "";
      if (this.rows[test]["percentagemd1"] != "") {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != "") {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
    },
    addRow1: function addRow1() {
      this.rows.push({
        productnamex: [],
        selectedproductid: "",
        unit: "",
        unitvalue: "",
        selectproductrow: null,
        price: "",
        qty: "",
        maxqty: "",
        amt: "",
        cgst: 0,
        sgst: 0,
        igst: "",
        amttotal: 0,
        percentagemd1: "",
        amtmd1: "",
        variantrow: "n/a",
        inclusive1: false,
        err_qty: "",
        err_price: "",
        err_sgst: "",
        err_cgst: "",
        err_igst: "",
        productExist: "",
        novariant: false,
        showvariant: false,
        item_seqno: ""
      });
    },


    removeElement: function removeElement(index) {
      this.rows.splice(index, 1);
    },

    searchshops: function searchshops() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, len;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.$http.get("/api/shopusers/getShop");

              case 2:
                response = _context3.sent;

                _this5.shopname = response.data;
                len = response.data.length - 1;

                _this5.selectshop = response.data[len];

                if (!(_this5.shopname.length > 0)) {
                  _context3.next = 9;
                  break;
                }

                _this5.company_data();
                return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    onSelectSup: function onSelectSup(option) {
      this.is_cs_gst = true;
      this.is_i_gst = true;

      if (option.cust_cmp_gst != undefined) {
        this.haserror.cust = "";
        this.customer_gst = option.cust_cmp_gst;
      }

      if (this.company_gst && this.customer_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var customer_gst = this.customer_gst.substring(0, 2);
        if (company_gst === customer_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
        }
      } else if (this.company_gst) {
        this.is_cs_gst = true;
        this.is_i_gst = true;
      } else if (!this.company_gst) {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      }

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.variantindex = i;
            this.show_tax(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    show_tax: function show_tax(option) {
      var _this = this;
      var index = this.variantindex;
      this.$http.get("/api/taxrates/findOne?filter[where][tax_id]=" + option.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.customer_gst) {
          var company_gst = _this.company_gst.substring(0, 2);
          var customer_gst = _this.customer_gst.substring(0, 2);
          _this.rows[index]["inclusive1"] = false;
          if (company_gst === customer_gst) {
            _this.rows[index]["cgst"] = response.data.tax_cgst;
            _this.rows[index]["sgst"] = response.data.tax_sgst;
            _this.rows[index]["igst"] = 0.0;
          } else {
            _this.rows[index]["cgst"] = 0.0;
            _this.rows[index]["sgst"] = 0.0;
            _this.rows[index]["igst"] = response.data.tax_igst;
          }
          _this.price(index);
        } else if (!_this.company_gst) {
          _this.rows[index]["inclusive1"] = true;
          _this.rows[index]["cgst"] = 0.0;
          _this.rows[index]["sgst"] = 0.0;
          _this.rows[index]["igst"] = 0.0;
          _this.price(index);
        } else {
          _this.rows[index]["inclusive1"] = false;
          _this.rows[index]["cgst"] = response.data.tax_cgst;
          _this.rows[index]["sgst"] = response.data.tax_sgst;
          _this.rows[index]["igst"] = 0.0;
          _this.price(index);
        }
      });
    },
    searchprd3: function searchprd3(searchText, index, row) {
      var _this = this;
      this.haserror.cust = "";
      this.haserror.shop = "";
      var status = 1;
      if (this.selectedcustomer == null || this.selectedcustomer.customer_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Customer";
      }
      if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }
      if (status == 1) {
        this.$http.get("/api/purchasereturns/joinproduct2?data=" + searchText).then(function (response) {
          row.productnamex = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    onSelectShp: function onSelectShp(option) {
      this.company_data();
      this.onSelectSup(this.selectedcustomer);
    },
    searchcustomer: function searchcustomer() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this = _this6;
                _context4.next = 3;
                return _this6.$http.get("/api/customers");

              case 3:
                response = _context4.sent;

                _this.customername = response.data;

                if (!(_this.customername.length > 0)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
      this.haserror.amt = "";
      this.haserror.dis = "";

      if (this.percentagemd != "" && this.amtmd != "") {
        this.haserror.amt = "Select Any one of the following";
      } else if (this.percentagemd != "" && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != "" && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Integer";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]["amt"])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]["batchmd1"] = this.batchmd;
        this.rows[val]["serialmd1"] = this.serialmd;
        this.rows[val]["percentagemd1"] = this.percentagemd;
        this.rows[val]["amtmd1"] = this.amtmd;
        this.rows[val]["inclusive1"] = this.inclusive;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition != "") {
        this.detail.addition = "";
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if (parseFloat(this.detail.totalamtpay) <= 0) {
        this.detail.addition = "";
        alert("Addition Discount Cannot Be Greater Than Total Amount To Pay");
      }
    },
    price: function price(index) {
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var num1 = /^[0-9]{1,8}$/;

      if (this.rows[index]["price"] == "") {
        this.rows[index]["err_price"] = "Required";
      } else if (parseFloat(this.rows[index]["price"]) < 0) {
        this.rows[index]["err_price"] = "Invalid Price";
      } else if (price.test(this.rows[index]["price"]) == false && this.rows[index]["price"] != "") {
        this.rows[index]["err_price"] = "Invalid Price";
      } else {
        this.rows[index]["err_price"] = "";
        this.rows[index]["price"] = parseFloat(this.rows[index]["price"]).toFixed(4);
      }

      if (this.rows[index]["qty"] == "") {
        this.rows[index]["err_qty"] = "Required";
      } else if (parseFloat(this.rows[index]["qty"]) <= 0.0) {
        this.rows[index]["err_qty"] = "Invalid Quantity";
      } else if (price.test(this.rows[index]["qty"]) == false && this.rows[index]["qty"] != "") {
        this.rows[index]["err_qty"] = "Invalid Quantity";
      } else if (parseFloat(this.rows[index]["qty"]) > parseFloat(this.rows[index]["maxqty"])) {
        this.rows[index]["err_qty"] = "Qty should be less than or equal to max qty";
      } else {
        this.rows[index]["err_qty"] = "";
      }

      if (igstexp.test(this.rows[index]["igst"]) == false && this.rows[index]["igst"] != "") {
        this.rows[index]["igst"] = "";
        this.rows[index]["err_igst"] = "Invalid";
      } else if (parseFloat(this.rows[index]["igst"]) < 0) {
        this.rows[index]["igst"] = "";
        this.rows[index]["err_igst"] = "Invalid";
      } else {
        this.rows[index]["err_igst"] = "";
      }

      if (tax.test(this.rows[index]["cgst"]) == false && this.rows[index]["cgst"] != 0) {
        this.rows[index]["cgst"] = 0;
        this.rows[index]["err_cgst"] = "Invalid";
      } else if (parseFloat(this.rows[index]["cgst"]) < 0) {
        this.rows[index]["cgst"] = 0;
        this.rows[index]["err_cgst"] = "Invalid";
      } else {
        this.rows[index]["err_cgst"] = "";
      }

      if (tax.test(this.rows[index]["sgst"]) == false && this.rows[index]["sgst"] != 0) {
        this.rows[index]["sgst"] = 0;
        this.rows[index]["err_sgst"] = "Invalid";
      } else if (parseFloat(this.rows[index]["sgst"]) < 0) {
        this.rows[index]["sgst"] = 0;
        this.rows[index]["err_sgst"] = "Invalid";
      } else {
        this.rows[index]["err_sgst"] = "";
      }

      if (this.rows[index]["igst"] != "") {
        this.rows[index]["cgst"] = 0;
        this.rows[index]["sgst"] = 0;
        var igst_value = parseFloat(this.rows[index]["igst"]);
      } else {
        this.rows[index]["igst"] = "";
        var igst_value = 0;
      }

      if (this.rows[index]["qty"] != "" && this.rows[index]["price"] != "") {
        var qty = parseFloat(this.rows[index]["qty"]);
        var price = parseFloat(this.rows[index]["price"]);
        var total = qty * price;
      } else if (this.rows[index]["qty"] == "" && this.rows[index]["price"] == "") {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]["qty"] != "" && this.rows[index]["price"] == "") {
        var qty = parseFloat(this.rows[index]["qty"]);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]["qty"] == "" && this.rows[index]["price"] != "") {
        var qty = 0;
        var price = parseFloat(this.rows[index]["price"]);
        var total = qty * price;
      }

      if (this.rows[index]["percentagemd1"] != "") {
        total = total - total * this.rows[index]["percentagemd1"] / 100;
      }
      if (this.rows[index]["amtmd1"] != "") {
        total = total - parseFloat(this.rows[index]["amtmd1"]);
      }

      if (total != undefined) {
        if (this.rows[index]["inclusive1"] == false) {
          this.rows[index]["amt"] = total.toFixed(2);
          var amttotal = total + this.rows[index]["sgst"] * total / 100 + this.rows[index]["cgst"] * total / 100 + igst_value * total / 100;
          amttotal = amttotal.toFixed(2);
          this.rows[index]["amttotal"] = amttotal;
        } else if (this.rows[index]["inclusive1"] == true) {
          amttotal = total.toFixed(2);
          this.rows[index]["amttotal"] = amttotal;
          var total_percentage = parseFloat(this.rows[index]["sgst"]) + parseFloat(this.rows[index]["cgst"]) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]["amt"] = bfttotal.toFixed(2);
        }
      }
    },
    finalsubmit: function finalsubmit() {
      this.haserror.message = "";
      this.haserror.cust = "";
      this.haserror.shop = "";
      var submit = 0;
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow != null) {
          if (this.rows[i].price == "") {
            submit = 1;
            this.rows[i].err_price = "Required";
          } else if (parseFloat(this.rows[i].price) < 0) {
            submit = 1;
            this.rows[i].err_price = "Invalid Price";
          } else if (price.test(this.rows[i].price) == false && this.rows[i].price != "") {
            submit = 1;
            this.rows[i].err_price = "Invalid Price";
          }

          if (this.rows[i].qty == "") {
            submit = 1;
            this.rows[i].err_qty = "Required";
          } else if (parseFloat(this.rows[i].qty) <= 0.0) {
            submit = 1;
            this.rows[i].err_qty = "Invalid Quantity";
          } else if (price.test(this.rows[i].qty) == false && this.rows[i].qty != "") {
            submit = 1;
            this.rows[i].err_qty = "Invalid Quantity";
          } else if (this.rows[i].maxqty !== "") {
            if (parseFloat(this.rows[i].qty) > parseFloat(this.rows[i].maxqty)) {
              submit = 1;
              this.rows[i].err_qty = "Qty should be less than or equal to max qty";
            }
          }

          if (igstexp.test(this.rows[i]["igst"]) == false && this.rows[i]["igst"] != "") {
            this.rows[i]["igst"] = "";
            this.rows[i]["err_igst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["igst"]) < 0) {
            this.rows[i]["igst"] = "";
            this.rows[i]["err_igst"] = "Invalid";
            submit = 1;
          }

          if (tax.test(this.rows[i]["cgst"]) == false && this.rows[i]["cgst"] != 0) {
            this.rows[i]["cgst"] = 0;
            this.rows[i]["err_cgst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["cgst"]) < 0) {
            this.rows[i]["cgst"] = 0;
            this.rows[i]["err_cgst"] = "Invalid";
            submit = 1;
          }

          if (tax.test(this.rows[i]["sgst"]) == false && this.rows[i]["sgst"] != 0) {
            this.rows[i]["sgst"] = 0;
            this.rows[i]["err_sgst"] = "Invalid";
            submit = 1;
          } else if (parseFloat(this.rows[i]["sgst"]) < 0) {
            this.rows[i]["sgst"] = 0;
            this.rows[i]["err_sgst"] = "Invalid";
            submit = 1;
          }
        }
      }

      if (this.selectedcustomer == null || this.selectedcustomer.customer_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
        if (this.selectshop == null || this.selectshop.est_shop_id == null) {
          this.haserror.shop = "Please Select Shop";
        }
        if (this.selectedcustomer == null || this.selectedcustomer.customer_id == null) {
          this.haserror.cust = "Please Select Customer";
        }
      } else {
        for (var i = this.rows.length - 1; i >= 0; i--) {
          if (this.rows[i].selectproductrow == null) {
            this.rows.splice(i, 1);
          }
        }

        if (this.rows.length == 0) {
          alert("nothing to Save");
        } else {
          var _this = this;
          if (this.detail.totalamtpay == "") {
            alert("Nothing To Save");
          } else {
            if (submit == 0) {
              if (this.selected_pytype === "full") {
                if (parseFloat(this.chng) < 0.00) {
                  alert("Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)");
                  this.totalamtreceived = "";
                  this.chng = 0;
                  return;
                }
                this.detail.totalamtpendingpay = 0;
              } else if (this.selected_pytype === "partial") {
                if (parseFloat(this.bal) < 0.00) {
                  alert("Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)");
                  this.totalparamtreceived = "";
                  this.bal = 0;
                  return;
                }
                this.detail.totalamtpendingpay = this.bal;
              } else {
                this.detail.totalamtpendingpay = this.detail.totalamtpay;
              }

              if (this.cheque_date != '') {
                var daynum = /^[0-9]{1}$/;
                var date = new Date(this.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = '0' + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = '0' + day;
                } else {
                  var day = day;
                }
                var dateval = year + '-' + month + '-' + day;
              } else {
                var dateval = null;
              }

              this.loading = true;
              var data = {};
              data.suppliersid = this.selectedcustomer.customer_id;
              data.shopid = this.selectshop.est_shop_id;
              data.pur_items = this.rows;
              data.total_discount = this.detail.totprddis;
              data.additional = this.detail.addition;
              data.amt_before_tax = this.detail.tot;
              data.cgst = this.detail.cgst;
              data.sgst = this.detail.sgst;
              data.igst = this.detail.igst;
              data.taxamt = this.detail.taxamt;
              data.totalamtpay = this.detail.totalamtpay;
              data.sales_id = this.sale_id;
              data.totalamtpendingpay = this.detail.totalamtpendingpay;
              data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
              data.pay.paytype = this.selected_pytype;
              data.pay.paymode = this.selected_pymode;
              data.pay.chqno = this.cheque_no;
              data.pay.chqdt = dateval;
              data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay);
              this.$http.post("/api/salertdetails/saledata", data).then(function (response) {
                _this.loading = false;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = "Sales Returned Successfully";
                setTimeout(function () {
                  _this.haserror.message = "";
                }, 2000);
                if ("saleId" in _this.$route.params) {
                  _this.$router.push({ name: "Sales" });
                } else {
                  _this.reset();
                }
              }).catch(function (error) {
                _this.loading = false;
                console.log(error);
              });
            } else {
              return;
            }
          }
        }
      }
    },
    reset: function reset() {
      this.selectedcustomer = null;
      this.selectshop = null;
      this.detail.totprddis = "";
      this.detail.addition = "";
      this.detail.tot = "";
      this.detail.cgst = "";
      this.detail.sgst = "";
      this.detail.igst = "";
      this.detail.taxamt = "";
      this.detail.totalamtpay = "";
      this.detail.totalamtpendingpay = "";
      this.selectcustname = null;
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }
      for (var i = 0; i < 2; i++) {
        this.rows.push({
          productnamex: [],
          selectedproductid: "",
          unit: "",
          unitvalue: "",
          selectproductrow: null,
          price: "",
          qty: "",
          maxqty: "",
          amt: "",
          cgst: 0,
          sgst: 0,
          igst: "",
          amttotal: 0,
          percentagemd1: "",
          amtmd1: "",
          variantrow: "n/a",
          inclusive1: false,
          err_qty: "",
          err_price: "",
          err_sgst: "",
          err_cgst: "",
          err_igst: "",
          productExist: "",
          novariant: false,
          showvariant: false
        });
      }
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      all_unit: null,
      dd_show: true,
      sales_return_id: null,
      sale_entry_id: null,
      shop_id: null,
      old_shop_id: null,
      loading: false,
      variantindex: null,
      smallmodal: false,
      smallmodal1: false,
      fullpay: true,
      chqpay: false,
      parpay: false,
      chng: 0,
      bal: 0,
      amt_rec: '',
      chequeno_validate: '',
      chequedate_validate: '',
      fullamt_rec: '',
      totalamtpreviouspaid: 0.00,
      totalamtreceived: '',
      totalparamtreceived: '',
      cheque_no: '',
      cheque_date: '',
      variantvalue: [],
      is_cs_gst: true,
      is_i_gst: true,
      company_gst: '',
      customer_gst: '',
      variantdata: null,
      percentagemd: '',
      amtmd: '',
      barcode: '',
      inclusive: false,
      indexval: null,
      largeModal: false,
      customername: [],
      selected_pytype: 'full',
      lst_paymenttype: [{ value: 'full', text: 'Full' }, { value: 'partial', text: 'Partial' }, { value: 'no', text: 'No' }],
      selected_pymode: 'cash',
      selectedcustomer: null,
      selectcustname: null,
      shopname: [],
      prod_lst: [],
      selectshop: null,
      selectshopname: null,
      productname: [],

      selectproduct: {},
      rows: [],
      remove_rows: [],
      haserror: {
        amt: '',
        dis: '',
        cust: '',
        message: '',
        inclusive: '',
        shop: ''
      },
      detail: {
        totprddis: '',
        addition: '',
        tot: '',
        cgst: '',
        sgst: '',
        igst: '',
        taxamt: '',
        totalamtpay: '',
        totalamtpendingpay: ''
      }
    };
  },


  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    totaldis: function totaldis() {
      var all = this.rows.reduce(function (total, row) {
        if (Number(row.amtmd1) == 0) {
          return total + Number(row.qty) * Number(row.price) * Number(row.percentagemd1) / 100;
        } else {
          return total + Number(row.amtmd1);
        }
      }, 0);
      all = all.toFixed(4);
      this.detail.totprddis = all;
      return all;
    },
    totalamt: function totalamt() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amt);
      }, 0);
      all = all.toFixed(4);
      this.detail.tot = all;
      return all;
    },
    totalcgst: function totalcgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.cgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.cgst = all;
      return all;
    },
    totalsgst: function totalsgst() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.sgst) * Number(row.amt) / 100;
      }, 0);
      all = all.toFixed(4);
      this.detail.sgst = all;
      return all;
    },
    totalsalestax: function totalsalestax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.sgst) + Number(row.cgst));
      }, 0);
      all = all.toFixed(4);
      return all;
    },
    totaltax: function totaltax() {
      var all = this.rows.reduce(function (total, row) {
        return total + (Number(row.amttotal) - Number(row.amt));
      }, 0);
      all = all.toFixed(4);
      this.detail.taxamt = all;
      return all;
    },
    totalamtpay: function totalamtpay() {
      var all = this.rows.reduce(function (total, row) {
        return total + Number(row.amttotal);
      }, 0);
      all = all.toFixed(4);
      if (this.detail.addition == '') {
        this.detail.totalamtpay = all;
        return all;
      } else {
        this.detail.totalamtpay = all - parseFloat(this.detail.addition);
        return all - parseFloat(this.detail.addition);
      }
    }
  },

  created: function created() {
    var _this2 = this;

    for (var i = 0; i < 2; i++) {
      this.rows.push({ productnamex: this.prod_lst, selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', old_qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', novariant: false, productExist: '', showvariant: false, item_seqno: '' });
    }
    this.shopuser();
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.searchcustomer(), this.searchshops(), this.listproduct(), this.getUnit()]).then(function (ret_val) {
      _this2.loadSalesReturnData();
    });
  },


  methods: {
    getUnit: function getUnit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.$http.get('/api/Unittypes/getUnit').then(function (response) {
                  _this.all_unit = response.data.data;
                  if (_this.all_unit !== null) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    calchnge: function calchnge() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalamtreceived !== '') {
        if (regexp.test(this.totalamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalamtreceived = '';
          return;
        } else {
          if (parseFloat(this.totalamtpay) == parseFloat(this.totalamtpreviouspaid)) {
            this.totalamtreceived = '';
            this.fullamt_rec = 'Already Paid';
          } else {
            var paid = parseFloat(this.totalamtreceived) + parseFloat(this.totalamtpreviouspaid);
            this.chng = paid.toFixed(4) - parseFloat(this.detail.totalamtpay);
          }
        }
      }
    },
    calbalance: function calbalance() {
      var regexp = /^[1-9]\d*(\.\d+)?$/;
      if (this.totalparamtreceived !== '') {
        if (regexp.test(this.totalparamtreceived) === false) {
          alert('Please Enter Valid Amount');
          this.totalparamtreceived = '';
          return;
        } else {

          var paid = parseFloat(this.totalparamtreceived) + parseFloat(this.totalamtpreviouspaid);
          this.bal = (parseFloat(this.detail.totalamtpay) - paid).toFixed(4);
        }
      }
    },
    paychange: function paychange(select_paytype_val) {
      this.selected_pytype = select_paytype_val;
      this.fullpay = false;
      this.parpay = false;
      if (this.selected_pytype === 'full') {
        this.fullpay = true;

        this.totalamtreceived = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else if (this.selected_pytype === 'partial') {
        this.parpay = true;
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    modechange: function modechange(select_paymode_val) {
      this.selected_pymode = select_paymode_val;
      if (this.selected_pytype !== 'no') {
        if (this.selected_pymode == 'cheque') {
          this.chqpay = true;
        } else {
          this.chqpay = false;
        }
      } else {
        this.chqpay = false;
      }
    },
    loadSalesReturnData: function loadSalesReturnData() {
      this.rows.length = 0;
      this.sales_return_id = this.$route.params.saleReturnId;
      this.shop_id = this.$route.params.shopId;
      this.old_shop_id = this.$route.params.shopId;
      this.sale_entry_id = this.$route.params.saleId;
      var _this = this;
      var api = '';

      if (this.sale_entry_id !== null) {
        this.dd_show = false;
        if ('itemSeqs' in this.$route.params) {
          api = '/api/salertdetails/loadData?filter[where][sales_return_id]=' + this.sales_return_id + '&filter[where][est_shop_id]=' + this.shop_id + '&filter[where][sales_id]=' + this.sale_entry_id + '&filter[where][item_seqs]=' + this.$route.params.itemSeqs;
        } else {
          api = '/api/salertdetails/loadData?filter[where][sales_return_id]=' + this.sales_return_id + '&filter[where][est_shop_id]=' + this.shop_id + '&filter[where][sales_id]=' + this.sale_entry_id;
        }
      } else {
        api = '/api/salertdetails/loadData?filter[where][sales_return_id]=' + this.sales_return_id + '&filter[where][est_shop_id]=' + this.shop_id;
      }
      this.$http.get(api).then(function (res) {
        if (res.status == 200) {
          _this.detail.totalamtpendingpay = res.data.salert_dtl.total_amt_pendingpay;
          _this.detail.addition = parseFloat(res.data.salert_dtl.additional_discount).toFixed(2);
          if (res.data.salert_dtl.sales_id !== null) {
            _this.sale_entry_id = res.data.salert_dtl.sales_id;
            _this.dd_show = false;
          }

          var select_cust = _this.customername.filter(function (each) {
            return each.customer_id === res.data.salert_dtl.customer_id;
          });
          _this.selectedcustomer = select_cust[0];

          var select_shop = _this.shopname.filter(function (each) {
            return each.est_shop_id === res.data.salert_dtl.est_shop_id;
          });
          _this.selectshop = select_shop[0];
          _this.selectshopname = _this.selectshop.est_shop_name;

          if (_this.dd_show === false) {

            _this.selectcustname = _this.selectedcustomer.cust_cmp_name;
          }

          if (parseFloat(res.data.salert_dtl.total_amt_pendingpay) === 0.00) {

            _this.selected_pytype = 'full';
            _this.selected_pymode = 'cash';
            _this.parpay = false;
            _this.fullpay = true;
            _this.totalamtpreviouspaid = parseFloat(res.data.salert_dtl.total_amt_pay).toFixed(2);
          } else if (parseFloat(res.data.salert_dtl.total_amt_pay) === parseFloat(res.data.salert_dtl.total_amt_pendingpay)) {
            _this.selected_pytype = 'no';
            _this.parpay = false;
            _this.fullpay = false;
          } else {
            _this.selected_pytype = 'partial';
            _this.selected_pymode = 'cash';
            _this.parpay = true;
            _this.fullpay = false;
            _this.totalamtpreviouspaid = (parseFloat(res.data.salert_dtl.total_amt_pay) - parseFloat(res.data.salert_dtl.total_amt_pendingpay)).toFixed(2);
            _this.bal = parseFloat(res.data.salert_dtl.total_amt_pendingpay).toFixed(2);
          }

          for (var i = 0; i < res.data.item_data.length; i++) {

            var disc_amt = '';
            if (parseFloat(res.data.item_data[i].disc_amt).toFixed(3) != '0.000') {
              disc_amt = parseFloat(res.data.item_data[i].disc_amt).toFixed(4);
            }

            var disc_pct = '';
            if (parseFloat(res.data.item_data[i].disc_pct).toFixed(3) != '0.000') {
              disc_pct = parseFloat(res.data.item_data[i].disc_pct).toFixed(4);
            }

            var igst = '';
            if (parseFloat(res.data.item_data[i].igst_amt).toFixed(3) != '0.000') {
              igst = parseFloat(res.data.item_data[i].igst_amt).toFixed(4);
            }

            var sgst = '';
            if (parseFloat(res.data.item_data[i].sgst_amt).toFixed(3) != '0.000') {
              sgst = parseFloat(res.data.item_data[i].sgst_amt).toFixed(4);
            }

            var cgst = '';
            if (parseFloat(res.data.item_data[i].cgst_amt).toFixed(3) != '0.000') {
              cgst = parseFloat(res.data.item_data[i].cgst_amt).toFixed(4);
            }

            var novariant_val = true;
            var showvariant_val = false;
            var variant_val = '';
            if (res.data.item_data[i].variant_id != null && res.data.item_data[i].variant_id != '') {
              novariant_val = false;
              showvariant_val = true;
              variant_val = res.data.item_data[i].variant_id;
            }

            var prod_dt = _this.prod_lst.filter(function (each) {
              return each.product_id === res.data.item_data[i].product_id;
            });

            var rowqty = 0;
            var mxqty = '';

            if ('sale_qty' in res.data.item_data[i]) {
              rowqty = res.data.item_data[i].sale_qty;
            } else {
              rowqty = res.data.item_data[i].return_qty;
            }
            if (_this.sale_entry_id !== null) {
              mxqty = res.data.saleitem_qty[res.data.item_data[i].item_seq];
            }
            var unit_value = '';
            if (res.data.item_data[i].unit_id in _this.all_unit) {
              unit_value = _this.all_unit[res.data.item_data[i].unit_id];
            }

            _this.rows.push({ productnamex: prod_dt,
              selectedproductid: '',
              unit: unit_value,
              unitvalue: res.data.item_data[i].unit_id,
              selectproductrow: prod_dt[0],
              price: parseFloat(res.data.item_data[i].product_unit_cost).toFixed(4),
              qty: rowqty,
              old_qty: rowqty,
              maxqty: mxqty,
              amt: res.data.item_data[i].sub_total,
              cgst: cgst, sgst: sgst, igst: igst,
              amttotal: res.data.item_data[i].amt_to_pay,
              percentagemd1: disc_pct, amtmd1: disc_amt,
              variantrow: variant_val,
              inclusive1: res.data.item_data[i].tax_inclusive,
              err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '',
              novariant: novariant_val, productExist: '',
              showvariant: showvariant_val,
              item_seqno: res.data.item_data[i].item_seq });
          }
          _this.onSelectSup(_this.selectedcustomer);
        } else {
          console.log('Didnt got response');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkVariant: function checkVariant(index) {

      if (this.variantdata == null) {
        this.rows[index].selectedproductid = null;
        this.rows[index].unit = '';
        this.rows[index].selectproductrow = null;
        this.rows[index].price = '';
        this.rows[index].qty = '';
        this.rows[index].maxqty = '';
        this.rows[index].amt = '';
        this.rows[index].cgst = 0;
        this.rows[index].sgst = 0;
        this.rows[index].igst = '';
        this.rows[index].amttotal = 0;
        this.rows[index].percentagemd1 = '';
        this.rows[index].amtmd1 = '';
        this.rows[index].variantrow = 'n/a';
        this.rows[index].unitvalue = '';
        this.rows[index].novariant = false;
        this.rows[index].showvariant = false;
        this.rows[index].inclusive1 = false;
        this.rows[index].err_qty = '';
        this.rows[index].err_price = '';
        this.rows[index].err_sgst = '';
        this.rows[index].err_cgst = '';
        this.rows[index].err_igst = '';
        this.rows[index].productExist = '';
      }
    },
    checkShop: function checkShop() {
      if (!this.selectedcustomer) {
        this.haserror.cust = "Select Customer";
        this.barcode = '';
      } else {
        this.haserror.cust = '';
      }

      if (!this.selectshop) {
        this.haserror.shop = "Select Shop";
        this.barcode = '';
      } else {
        this.haserror.shop = '';
      }
    },
    searchBarcode: function searchBarcode() {
      var option = {};
      var index = 0;
      var addRow = 0;
      var _this = this;
      var barcode = this.barcode;
      this.barcode = '';
      if (barcode) {
        this.$http.get('/api/purchasereturns/joinproduct2?barcode=' + barcode).then(function (response) {

          var valueArr = _this.rows.map(function (item) {
            return item;
          });
          var rowindex = -1;
          var check = valueArr.some(function (value, indx) {

            if (value.selectproductrow == null) {
              rowindex = indx;

              return true;
            } else {
              return false;
            }
          });

          if (response.data[0] != null) {

            if (_this.rows.length == 0 || rowindex == -1) {
              rowindex = rowindex != -1 ? rowindex : _this.rows.length;
              _this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', old_qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, batchmd1: '', serialmd1: '', percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, salepricemd1: 0, is_adjustment: false, adjustment_list: [], adjusted: [], err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', item_seqno: '' });
            }
            _this.rows[rowindex].productnamex.push(response.data[0]);
            _this.rows[rowindex].selectproductrow = response.data[0];
            _this.openvariant(response.data[0], rowindex);
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {}
    },
    listproduct: function listproduct() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this = _this4;
                _context2.next = 3;
                return _this4.$http.get('/api/companyproducts');

              case 3:
                response = _context2.sent;

                _this.prod_lst = response.data;

                if (!(_this.prod_lst.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.cust_cmp_name + ' - ' + item.cust_cmp_phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    company_data: function company_data() {
      this.company_gst = this.selectshop.shop_gst;
    },
    savevatiantmodal: function savevatiantmodal(index) {},
    onSelectvariant: function onSelectvariant(option) {
      this.rows[this.variantindex]['variantrow'] = option.variant_value;
      var temprow = this.rows[this.variantindex];
      var _this = this;
      var rowindex = -1;
      var index = this.variantindex;
      this.rows[this.variantindex].variantrow = option.variant_value;
      this.smallmodal = false;

      var temprow = this.rows[this.variantindex];

      this.rows[this.variantindex].showvariant = option.variant_value == (null || 'n/a') ? false : true;
      this.rows[this.variantindex].novariant = option.variant_value == (null || 'n/a') ? true : false;
      var option = temprow.selectproductrow;
      if (option != null) {
        if (option.product_id != undefined) {
          this.show_tax(option, index);
          _this.rows[index]['qty'] = 1;
          _this.rows[index]['unit'] = option.unit_name;
          _this.rows[index]['unitvalue'] = option.unit_id;
          _this.rows[index]['selectedproductid'] = option.variant_id;

          _this.rows[index]['adjustment_list'] = [];
          _this.rows[index]['adjusted'] = [];
          _this.rows[index]['price'] = '';
        } else {

          _this.rows[index]['selectedproductid'] = '';
          _this.rows[index]['unit'] = '';
          _this.rows[index]['unitvalue'] = '';
          _this.rows[index]['selectproductrow'] = null;
          _this.rows[index]['price'] = '';
          _this.rows[index]['qty'] = '';
          _this.rows[index]['maxqty'] = '';
          _this.rows[index]['amt'] = '';
          _this.rows[index]['cgst'] = 0;
          _this.rows[index]['sgst'] = 0;
          _this.rows[index]['igst'] = '';
          _this.rows[index]['amttotal'] = 0;
          _this.rows[index]['batchmd1'] = '';
          _this.rows[index]['serialmd1'] = '';
          _this.rows[index]['percentagemd1'] = '';
          _this.rows[index]['amtmd1'] = '';
          _this.rows[index]['variantrow'] = 'n/a';
          _this.rows[index]['inclusive1'] = false;
          _this.rows[index]['salepricemd1'] = 0;
          _this.rows[index]['adjustment_list'] = [];
          _this.rows[index]['adjusted'] = [];
        }
      } else {
        _this.rows[index]['selectedproductid'] = '';
        _this.rows[index]['unit'] = '';
        _this.rows[index]['unitvalue'] = '';
        _this.rows[index]['selectproductrow'] = null;
        _this.rows[index]['price'] = '';
        _this.rows[index]['qty'] = '';
        _this.rows[index]['maxqty'] = '';
        _this.rows[index]['amt'] = '';
        _this.rows[index]['cgst'] = 0;
        _this.rows[index]['sgst'] = 0;
        _this.rows[index]['igst'] = '';
        _this.rows[index]['amttotal'] = 0;
        _this.rows[index]['batchmd1'] = '';
        _this.rows[index]['serialmd1'] = '';
        _this.rows[index]['percentagemd1'] = '';
        _this.rows[index]['amtmd1'] = '';
        _this.rows[index]['variantrow'] = 'n/a';
        _this.rows[index]['inclusive1'] = false;
        _this.rows[index]['salepricemd1'] = 0;
        _this.rows[index]['adjustment_list'] = [];
        _this.rows[index]['adjusted'] = [];
      }
    },
    updateshop: function updateshop() {
      this.loading = true;
      var _this = this;
      this.$http.post('/api/salertdetails/updateShop?filter[where][sales_return_id]=' + this.sales_return_id + '&filter[where][old_shop_id]=' + this.old_shop_id + '&filter[where][est_shop_id]=' + this.selectshop.est_shop_id).then(function (response) {
        if (response.status == 200) {
          if (response.data.data == 'Successful') {
            _this.$route.params.shopId = _this.selectshop.est_shop_id;
            setTimeout(function () {
              _this.loadSalesReturnData();_this.smallmodal1 = false;_this.loading = false;
            }, 1000);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.haserror.message = 'Sales Return Updated Successfully';
            setTimeout(function () {
              _this.haserror.message = '';
            }, 3000);
          }
        }
      }).catch(function (error) {});
    },
    openvariant_on_product: function openvariant_on_product(row, index) {
      if ('product_id' in row.selectproductrow) {
        this.openvariant(row, index);
      } else {
        return false;
      }
    },
    openvariant: function openvariant(row, index) {

      this.variantindex = index;
      this.variantdata = null;
      this.variantvalue = [];
      var _this = this;

      var vrnt_id = row.selectproductrow == undefined ? row.variant_id : row.selectproductrow.variant_id;

      if (vrnt_id != null) {
        this.smallmodal = true;
        this.$http.get('/api/variantvalues?filter[where][variant_id]=' + vrnt_id).then(function (response) {
          _this.variantvalue = response.data;
          _this.variantvalue.unshift({ company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "n/a" });
        }).catch(function (error) {});
      } else {
        this.smallmodal = false;

        var option = { company_id: "I2OCGLB", id: 0, regcity_code: "I2O", variant_id: "0", variant_value: "n/a" };
        this.onSelectvariant(option);
      }
    },
    openmodal: function openmodal(test) {
      this.largeModal = true;
      this.indexval = test;
      this.percentagemd = '';
      this.amtmd = '';
      if (this.rows[test]['percentagemd1'] != '') {
        this.percentagemd = this.rows[test].percentagemd1;
      }
      if (this.rows[test].amtmd1 != '') {
        this.amtmd = this.rows[test].amtmd1;
      }
      this.inclusive = this.rows[test].inclusive1;
    },
    addRow1: function addRow1() {
      this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', old_qty: '', amt: '', maxqty: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', err_salestax: '', sales_tax: '', productExist: '', novariant: false, showvariant: false, item_seqno: '' });
    },
    updateSalesTax: function updateSalesTax(index) {
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      if (this.rows[index]['sales_tax'] != '') {
        if (tax.test(this.rows[index]['sales_tax']) == false) {
          this.rows[index]['sales_tax'] = '';
          this.rows[index]['err_salestax'] = 'Invalid';
        } else if (parseFloat(this.rows[index]['sales_tax']) < 0) {
          this.rows[index]['sales_tax'] = '';
          this.rows[index]['err_salestax'] = 'Invalid';
        } else {
          this.rows[index]['err_salestax'] = '';

          var taxMode = this.companyTaxType || 'IN';
          var salesTax = parseFloat(this.rows[index]['sales_tax']);

          if (taxMode === 'IN') {
            this.rows[index]['igst'] = salesTax;
            this.rows[index]['sgst'] = 0;
            this.rows[index]['cgst'] = 0;
          } else {
            this.rows[index]['sgst'] = salesTax / 2;
            this.rows[index]['cgst'] = salesTax / 2;
            this.rows[index]['igst'] = salesTax;
          }
        }
      } else {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_salestax'] = '';
      }
      this.price(index);
    },
    removeElement: function removeElement(row, index) {
      if (this.rows[index].item_seqno != '') {
        this.remove_rows.push(this.rows[index]);
        this.rows.splice(index, 1);
      } else {
        this.rows.splice(index, 1);
        this.loading = false;
      }
      this.manage_pre_paid();
    },
    manage_pre_paid: function manage_pre_paid() {
      if (parseFloat(this.totalamtpreviouspaid) > parseFloat(this.totalamtpay)) {
        this.paychange('full');
        this.modechange('cash');

        this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(4);
        this.totalparamtreceived = '';

        this.totalamtreceived = '';
        this.totamtrecdis = true;
      } else if (parseFloat(this.totalamtpreviouspaid) == parseFloat(this.totalamtpay)) {
        this.paychange('full');
        this.modechange('cash');
        this.chng = (parseFloat(this.totalamtpreviouspaid) - parseFloat(this.totalamtpay)).toFixed(4);
        this.totalparamtreceived = '';
        this.totalamtreceived = '';
        this.totamtrecdis = true;
      } else {
        this.paychange('partial');
        this.modechange('cash');
        this.totalparamtreceived = '';
        this.bal = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
        this.totamtrecdis = false;
      }
    },
    searchshops: function searchshops() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this, response, len;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this = _this5;
                _context3.next = 3;
                return _this5.$http.get('/api/shopusers/getShop');

              case 3:
                response = _context3.sent;

                _this5.shopname = response.data;
                len = response.data.length - 1;

                _this5.selectshop = response.data[len];

                if (!(_this.shopname.length > 0)) {
                  _context3.next = 10;
                  break;
                }

                _this5.company_data();
                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    onSelectSup: function onSelectSup(option) {
      this.is_cs_gst = true;
      this.is_i_gst = true;

      if (option.cust_cmp_gst != undefined) {
        this.haserror.cust = '';
        this.customer_gst = option.cust_cmp_gst;
      }

      if (this.company_gst && this.customer_gst) {
        var company_gst = this.company_gst.substring(0, 2);
        var customer_gst = this.customer_gst.substring(0, 2);
        if (company_gst === customer_gst) {
          this.is_cs_gst = true;
          this.is_i_gst = false;
        } else {
          this.is_cs_gst = false;
          this.is_i_gst = true;
        }
      } else if (this.customer_gst === null || this.customer_gst === '') {
        this.is_cs_gst = false;
        this.is_i_gst = false;
      } else {
        this.is_cs_gst = true;
        this.is_i_gst = true;
      }

      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          if (this.rows[i].selectproductrow != null) {
            this.variantindex = i;
            this.show_tax(this.rows[i].selectproductrow, i);
          }
        }
      }
    },
    show_tax: function show_tax(option) {
      var _this = this;
      var index = this.variantindex;

      this.$http.get('/api/taxrates/findOne?filter[where][tax_id]=' + option.tax_gst_id).then(function (response) {
        if (_this.company_gst && _this.customer_gst) {

          var company_gst = _this.company_gst.substring(0, 2);
          var customer_gst = _this.customer_gst.substring(0, 2);
          _this.rows[index]['inclusive1'] = false;
          if (company_gst === customer_gst) {

            _this.rows[index]['cgst'] = response.data.tax_cgst;
            _this.rows[index]['sgst'] = response.data.tax_sgst;
            _this.rows[index]['igst'] = 0.00;
          } else {
            _this.rows[index]['cgst'] = 0.00;
            _this.rows[index]['sgst'] = 0.00;
            _this.rows[index]['igst'] = response.data.tax_igst;
          }
          _this.price(index);
        } else if (!_this.company_gst) {

          _this.rows[index]['inclusive1'] = true;
          _this.rows[index]['cgst'] = 0.00;
          _this.rows[index]['sgst'] = 0.00;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        } else {
          _this.rows[index]['inclusive1'] = false;
          _this.rows[index]['cgst'] = response.data.tax_cgst;
          _this.rows[index]['sgst'] = response.data.tax_sgst;
          _this.rows[index]['igst'] = 0.00;
          _this.price(index);
        }
      });
    },
    searchprd3: function searchprd3(searchText, index, row) {
      var _this = this;
      this.haserror.cust = '';
      this.haserror.shop = '';
      var status = 1;
      if (this.selectedcustomer == null || this.selectedcustomer.customer_id === undefined) {
        status = 0;
        this.haserror.cust = "Please Select Customer";
      }
      if (this.selectshop == null || this.selectshop.est_shop_id === undefined) {
        status = 0;
        this.haserror.shop = "Please Select Shop";
      }
      if (status == 1) {
        this.$http.get('/api/purchasereturns/joinproduct2?data=' + searchText).then(function (response) {
          row.productnamex = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    searchcustomer: function searchcustomer() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this, response;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this = _this6;
                _context4.next = 3;
                return _this6.$http.get('/api/customers');

              case 3:
                response = _context4.sent;

                _this.customername = response.data;

                if (!(_this.customername.length > 0)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    savemodal: function savemodal(val) {
      var num = /^([0-9]{1,2}|100)$/;
      var num1 = /^[0-9]{1,12}$/;
      var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/;
      this.haserror.amt = '';
      this.haserror.dis = '';

      if (this.percentagemd != '' && this.amtmd != '') {
        this.haserror.amt = "Select Any one of the following";
      } else if (this.percentagemd != '' && num.test(this.percentagemd) == false) {
        this.haserror.dis = "Please Provide Integer Between 1-100";
      } else if (this.amtmd != '' && amt_reg.test(this.amtmd) == false) {
        this.haserror.amt = "Please Provide Integer";
      } else if (parseFloat(this.amtmd) > parseFloat(this.rows[val]['amt'])) {
        this.haserror.amt = "Discount Amount Cannot Be Greater Than Provided Amount";
      } else {
        this.rows[val]['batchmd1'] = this.batchmd;
        this.rows[val]['serialmd1'] = this.serialmd;
        this.rows[val]['percentagemd1'] = this.percentagemd;
        this.rows[val]['amtmd1'] = this.amtmd;
        this.rows[val]['inclusive1'] = this.inclusive;
        this.largeModal = false;
        this.price(val);
      }
    },
    discountadd: function discountadd() {
      var num = /^\d{1,12}(\.\d{1,6})?$/;
      if (num.test(this.detail.addition) == false && this.detail.addition != '') {
        this.detail.addition = '';
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if (parseFloat(this.detail.totalamtpay) <= 0.00) {
        this.detail.addition = '';
        alert("Addition Discount Cannot be Greater Than Total Amount To Pay");
      }
    },
    price: function price(index) {

      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var num1 = /^[0-9]{1,8}$/;

      if (this.rows[index]['price'] == '') {
        this.rows[index]['err_price'] = 'Required';
      } else if (parseFloat(this.rows[index]['price']) <= 0.00) {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else if (price.test(this.rows[index]['price']) == false && this.rows[index]['price'] != '') {
        this.rows[index]['err_price'] = 'Invalid Price';
      } else {
        this.rows[index]['err_price'] = '';
        this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4);
      }

      if (this.rows[index]['qty'] == '') {
        this.rows[index]['err_qty'] = 'Required';
      } else if (parseFloat(this.rows[index]['qty']) <= 0.00) {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (price.test(this.rows[index]['qty']) == false && this.rows[index]['qty'] != '') {
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      } else if (this.rows[index].maxqty !== '') {
        if (parseFloat(this.rows[index].qty) > parseFloat(this.rows[index].maxqty)) {
          this.rows[index].err_qty = 'Qty should be less than or equal to max qty';
        }
      } else {
        this.rows[index]['err_qty'] = '';
      }

      if (igstexp.test(this.rows[index]['igst']) == false && this.rows[index]['igst'] != '') {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['igst']) < 0) {
        this.rows[index]['igst'] = '';
        this.rows[index]['err_igst'] = 'Invalid';
      } else {
        this.rows[index]['err_igst'] = '';
      }

      if (tax.test(this.rows[index]['cgst']) == false && this.rows[index]['cgst'] != 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['cgst']) < 0) {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['err_cgst'] = 'Invalid';
      } else {
        this.rows[index]['err_cgst'] = '';
      }

      if (tax.test(this.rows[index]['sgst']) == false && this.rows[index]['sgst'] != 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else if (parseFloat(this.rows[index]['sgst']) < 0) {
        this.rows[index]['sgst'] = 0;
        this.rows[index]['err_sgst'] = 'Invalid';
      } else {
        this.rows[index]['err_sgst'] = '';
      }

      if (this.rows[index]['igst'] != '' && this.companyTaxType != 'US') {
        this.rows[index]['cgst'] = 0;
        this.rows[index]['sgst'] = 0;
        var igst_value = parseFloat(this.rows[index]['igst']);
      } else {
        this.rows[index]['igst'] = '';
        var igst_value = 0;
      }

      if (this.rows[index]['qty'] != '' && this.rows[index]['price'] != '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] == '') {
        var qty = 0;
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] != '' && this.rows[index]['price'] == '') {
        var qty = parseFloat(this.rows[index]['qty']);
        var price = 0;
        var total = qty * price;
      } else if (this.rows[index]['qty'] == '' && this.rows[index]['price'] != '') {
        var qty = 0;
        var price = parseFloat(this.rows[index]['price']);
        var total = qty * price;
      }

      if (this.rows[index]['percentagemd1'] != '') {
        total = total - total * this.rows[index]['percentagemd1'] / 100;
      }
      if (this.rows[index]['amtmd1'] != '') {
        total = total - parseFloat(this.rows[index]['amtmd1']);
      }

      if (total != undefined) {
        if (this.rows[index]['inclusive1'] == false) {
          this.rows[index]['amt'] = total.toFixed(2);;
          var amttotal = total + this.rows[index]['sgst'] * total / 100 + this.rows[index]['cgst'] * total / 100 + igst_value * total / 100;
          amttotal = amttotal.toFixed(2);
          this.rows[index]['amttotal'] = amttotal;
        } else if (this.rows[index]['inclusive1'] == true) {
          amttotal = total.toFixed(2);
          this.rows[index]['amttotal'] = amttotal;
          var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value;
          var bfttotal = total * (100 / (100 + total_percentage));
          this.rows[index]['amt'] = bfttotal.toFixed(2);
        }
      }
      this.manage_pre_paid();
    },
    finalsubmit: function finalsubmit() {
      this.haserror.message = '';
      this.haserror.cust = '';
      this.haserror.shop = '';
      var submit = 0;
      var num = /^[0-9]{1,11}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;

      for (var i = this.rows.length - 1; i >= 0; i--) {
        if (this.rows[i].selectproductrow != null) {

          if (this.rows[i].price == '') {
            submit = 1;
            this.rows[i].err_price = 'Required';
          } else if (parseFloat(this.rows[i].price) < 0.00) {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          } else if (price.test(this.rows[i].price) == false && this.rows[i].price != '') {
            submit = 1;
            this.rows[i].err_price = 'Invalid Price';
          }

          if (this.rows[i].qty == '') {
            submit = 1;
            this.rows[i].err_qty = 'Required';
          } else if (parseFloat(this.rows[i].qty) <= 0.00) {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          } else if (price.test(this.rows[i].qty) == false && this.rows[i].qty != '') {
            submit = 1;
            this.rows[i].err_qty = 'Invalid Quantity';
          } else if (this.rows[i].maxqty !== '') {
            if (parseFloat(this.rows[i].qty) > parseFloat(this.rows[i].maxqty)) {
              submit = 1;
              this.rows[i].err_qty = 'Qty should be less than or equal to max qty';
            }
          }

          if (igstexp.test(this.rows[i]['igst']) == false && this.rows[i]['igst'] != '') {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['igst']) < 0) {
            this.rows[i]['igst'] = '';
            this.rows[i]['err_igst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['cgst']) == false && this.rows[i]['cgst'] != 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['cgst']) < 0) {
            this.rows[i]['cgst'] = 0;
            this.rows[i]['err_cgst'] = 'Invalid';
            submit = 1;
          }

          if (tax.test(this.rows[i]['sgst']) == false && this.rows[i]['sgst'] != 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          } else if (parseFloat(this.rows[i]['sgst']) < 0) {
            this.rows[i]['sgst'] = 0;
            this.rows[i]['err_sgst'] = 'Invalid';
            submit = 1;
          }
        }
      }

      if (this.selectedcustomer == null || this.selectedcustomer.customer_id == null || this.selectshop == null || this.selectshop.est_shop_id == null) {
        if (this.selectshop == null || this.selectshop.est_shop_id == null) {
          this.haserror.shop = "Please Select Shop";
        }
        if (this.selectedcustomer == null || this.selectedcustomer.customer_id == null) {
          this.haserror.cust = "Please Select Customer";
        }
      } else {
        for (var i = this.rows.length - 1; i >= 0; i--) {
          if (this.rows[i].selectproductrow == null) {
            this.rows.splice(i, 1);
          }
        }

        if (this.rows.length == 0) {
          alert("nothing to Save");
        } else {
          var _this = this;
          if (this.detail.totalamtpay == '') {
            alert("Nothing To Save");
          } else {
            if (submit == 0) {
              this.amt_rec = '';
              this.fullamt_rec = '';
              this.chequeno_validate = '';
              this.chequedate_validate = '';

              var amount_pay = 0.0;
              if (this.selected_pytype === 'full') {
                var chk_full = false;
                if (this.totalamtreceived !== '' && parseFloat(this.totalamtreceived) <= 0.00) {
                  var paying = parseFloat(this.totalamtpreviouspaid) + parseFloat(this.totalamtreceived);
                  if (this.totalamtpay > paying) {
                    this.fullamt_rec = 'Invalid Amount Received, please select payment type - partial';

                    chk_full = true;
                  } else {
                    this.fullamt_rec = '';
                  }
                } else if (parseFloat(this.chng) < 0.00) {
                  if (this.totamtrecdis !== true) {
                    alert('Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(i.e Partial)');
                    this.totalamtreceived = '';
                    this.chng = 0;
                    chk_full = true;
                  }
                }

                if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                  this.chequeno_validate = 'Required';
                  chk_full = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                  this.chequedate_validate = 'Required';
                  chk_full = true;
                }
                if (chk_full == true) {
                  return;
                } else {
                  if (this.totamtrecdis === false) {
                    amount_pay = this.totalamtreceived;
                    this.detail.totalamtpendingpay = 0;
                  } else {
                    amount_pay = 0 - parseFloat(this.chng);
                    this.detail.totalamtpendingpay = 0;
                  }
                }
              } else if (this.selected_pytype === 'partial') {
                var chk_partial = false;
                if (parseFloat(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
                  this.amt_rec = 'Required';
                  this.totalparamtreceived = '';
                  this.bal = 0;
                  chk_partial = true;
                }
                if (parseFloat(this.bal) < 0.00) {
                  alert('Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(i.e Full)');
                  this.totalparamtreceived = '';
                  this.bal = 0;
                  chk_partial = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                  this.chequeno_validate = 'Required';
                  chk_partial = true;
                }
                if (this.selected_pymode == 'cheque' && this.cheque_date == '') {
                  this.chequedate_validate = 'Required';
                  chk_partial = true;
                }
                if (chk_partial == true) {
                  return;
                } else {
                  this.detail.totalamtpendingpay = this.bal;
                  amount_pay = this.totalparamtreceived;
                }
                this.detail.totalamtpendingpay = this.bal;
              } else {
                this.detail.totalamtpendingpay = parseFloat(this.totalamtpay) - parseFloat(this.totalamtpreviouspaid);
                amount_pay = 0.00;
              }

              if (this.cheque_date != '') {
                var daynum = /^[0-9]{1}$/;
                var date = new Date(this.cheque_date);
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();

                if (daynum.test(month) == true) {
                  var month = '0' + month;
                } else {
                  var month = month;
                }

                if (daynum.test(day) == true) {
                  var day = '0' + day;
                } else {
                  var day = day;
                }
                var dateval = year + '-' + month + '-' + day;
              } else {
                var dateval = null;
              }

              this.loading = true;
              var data = {};
              data.sales_return_id = this.sales_return_id;
              data.customer_id = this.selectedcustomer.customer_id;
              data.shopid = this.selectshop.est_shop_id;
              data.pur_items = this.rows;
              data.remove_sale_items = this.remove_rows;
              data.total_discount = this.detail.totprddis;
              data.additional = this.detail.addition;
              data.amt_before_tax = this.detail.tot;
              data.cgst = this.detail.cgst;
              data.sgst = this.detail.sgst;
              data.igst = this.detail.igst;
              data.taxamt = this.detail.taxamt;
              data.totalamtpay = this.detail.totalamtpay;
              data.sales_id = this.sale_entry_id;
              data.totalamtpendingpay = this.detail.totalamtpendingpay;
              data.pay = { 'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0 };
              data.pay.paytype = this.selected_pytype;
              data.pay.paymode = this.selected_pymode;
              data.pay.chqno = this.cheque_no;
              data.pay.chqdt = dateval;
              data.pay.amt = amount_pay;
              this.$http.post('/api/salertdetails/editdata', data).then(function (response) {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                _this.haserror.message = 'Sales Return Updated Successfully';
                setTimeout(function () {
                  _this.haserror.message = '';
                }, 2000);
                if (_this.sale_entry_id !== null) {
                  _this.$router.push({ name: 'Sales Return' });
                } else {
                  setTimeout(function () {
                    _this.loadSalesReturnData();_this.loading = false;
                  }, 1000);
                }
              }).catch(function (error) {
                _this.loading = false;
              });
            } else {
              alert('Invalid data');
            }
          }
        }
      }
    },
    reset: function reset() {
      this.selectedcustomer = null;
      this.selectcustname = null;
      this.selectshopname = null;
      this.selectshop = null;
      this.detail.totprddis = '';
      this.detail.addition = '';
      this.detail.tot = '';
      this.detail.cgst = '';
      this.detail.sgst = '';
      this.detail.igst = '';
      this.detail.taxamt = '';
      this.detail.totalamtpay = '';
      this.detail.totalamtpendingpay = '';
      for (var i = this.rows.length - 1; i >= 0; i--) {
        this.rows.splice(i, 1);
      }
      for (var i = 0; i < 2; i++) {
        this.rows.push({ productnamex: [], selectedproductid: '', unit: '', unitvalue: '', selectproductrow: null, price: '', qty: '', old_qty: '', maxqty: '', amt: '', cgst: 0, sgst: 0, igst: '', amttotal: 0, percentagemd1: '', amtmd1: '', variantrow: 'n/a', inclusive1: false, err_qty: '', err_price: '', err_sgst: '', err_cgst: '', err_igst: '', productExist: '', novariant: false, showvariant: false, item_seqno: '' });
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_editor__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'customer',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_4_vue2_editor__["VueEditor"], Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      shipdisable: true,
      tit: '',
      access_token: null,
      plan_modal: false,
      customToolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }]],
      cfrst_time: false,
      conf_time: false,
      comf_time: false,
      customer_id: '',
      largeModal1: false,
      largeModal: false,
      saveBtn: false,
      editBtn: true,
      loading: false,
      suptype: null,
      state: null,
      city: null,
      shippingstate: null,
      shippingcity: null,

      con: null,
      cityopt: [],
      shippingcityopt: [],
      stateopt: [],
      conopt: [],
      maximumSize: 500000,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      contyp: [],
      srch_cmptyp: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      address: {
        sname: '',
        saddress: '',
        spincode: '',
        sstate: '',
        sstateid: '',
        scity: '',
        scityid: '',
        sphn: '',
        sgst: ''
      },
      addr: [],
      display: {
        name: null,
        cmptyp: null,
        email: null,
        add1: null
      },
      customer: {
        add: '',
        name: '',
        add2: '',
        pin: '',
        phone: '',
        email: '',
        gst: '',
        pan: '',
        cin: '',
        tan: '',
        contact: '',
        contactno: '',
        contactemail: '',
        profile: '',
        image: '',
        bankname: '',
        banknumber: '',
        bankholder: '',
        bankifsc: '',
        bankbranch: '',
        bankmicr: '',
        bankswift: ''
      },
      search: {
        custname: '',
        cmptyp: null,
        email: ''
      },
      columns: [{
        label: 'Customer Name',
        field: 'cust_cmp_name',
        width: '15% !important'
      }, {
        label: 'Company Type',
        field: 'companytypes.desc',
        width: '15% !important'
      }, {
        label: 'Contact No.',
        field: 'cust_cmp_phone',
        width: '10% !important'
      }, {
        label: 'Email',
        field: 'cust_cmp_email',
        width: '15% !important'
      }, {
        label: 'GST',
        field: 'cust_cmp_gst',
        width: '15% !important'
      }, {
        label: 'PAN',
        field: 'cust_cmp_pan',
        width: '15% !important'
      }, {
        label: 'Action',
        field: 'action',
        width: '15% !important'
      }],

      rows: [],

      ed: {
        image1: '',
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image1_href: '',
        image2_href: '',
        image3_href: '',
        image4_href: '',
        image5_href: ''
      },
      hasErrors1: {
        errsname: false,
        errsaddress: false,
        errsstate: false,
        errscity: false,
        errspincode: false,
        errsphn: false,
        errsgst: false
      },
      hasErrors: {
        message: false,
        custnm: false,
        custad1: false,
        custad2: false,
        custpin: false,
        custph: false,
        custeml: false,
        custgst: false,
        custpan: false,
        custcin: false,
        custtan: false,
        custcont: false,
        custcontno: false,
        custconteml: false,
        supplierprf: false,
        image1: false,
        image2: false,
        image3: false,
        image4: false,
        image5: false,
        bankname: false,
        banknumber: false,
        bankholder: false,
        bankifsc: false,
        bankbranch: false,
        bankmicr: false,
        bankswift: false
      },
      errorMessage: {
        message: '',
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      }
    };
  },

  computed: {
    cust_view: function cust_view() {
      if (this.$store.getters.get_cust_view === true) {
        this.getCustomer('comp');
        this.contr('comp');
        this.companytype('comp');
        this.contr1ed('101');
        this.state1ed('22');
        this.city1ed('2707');
        return true;
      } else {
        return false;
      }
    },

    cust_rights: function cust_rights() {
      return this.$store.getters.get_cust_rights;
    }
  },
  created: function created() {
    if (localStorage.authUser != null) {
      this.access_token = '?access_token=' + localStorage.authUser;
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getCustomer();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getCustomer();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getCustomer();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getCustomer();
    },
    deleteadd: function deleteadd(indx) {
      this.addr.splice(indx, 1);
    },
    shippingenable: function shippingenable() {
      if (this.customer.add.trim() !== "") {
        this.shipdisable = false;
      } else {
        this.shipdisable = true;
      }
    },
    addValues: function addValues() {
      if (this.shippingcity !== null) {
        this.address.scity = this.shippingcity.city_name;
        this.address.scityid = this.shippingcity.id;
      }
      var phnrex = /^[0-9]{10,15}$/;
      var pinrex = /^\d{0}$|^\d{6}$/;
      var nrex = /^[a-zA-Z\s]{0}$|^[a-zA-Z\s]{2,50}$/;
      var nmrex = /^[a-zA-Z\s]{2,50}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var _this = this;
      var nm = this.address.sname;
      var adrs = this.address.saddress;
      var pncd = this.address.spincode;
      var st = this.address.sstate;
      var ct = this.address.scity;
      var phn = this.address.sphn;
      var stid = this.address.sstateid;
      var ctid = this.address.scityid;
      var gst = this.address.sgst;
      var add_true = 1;
      _this.hasErrors1.errscity = '';
      _this.hasErrors1.errsstate = '';
      _this.hasErrors1.errsphn = '';
      _this.hasErrors1.errspincode = '';
      _this.hasErrors1.errsaddress = '';
      _this.hasErrors1.errsname = '';
      _this.hasErrors1.errsgst = '';
      if (nm == undefined) {
        nm = '';
      }

      if (adrs == undefined) {
        adrs = '';
      }

      if (phn == undefined) {
        phn = '';
      }

      if (pncd == undefined) {
        pncd = '';
      }

      if (ct == undefined) {
        ct = '';
      }

      if (st == undefined) {
        st = '';
      }
      if (gst === undefined) {
        gst = '';
      }

      if (nm === '') {
        add_true = 0;
        this.hasErrors1.errsname = 'Required';
      } else if ((nm.length < 2 || nm.length > 50) && nm != '') {
        add_true = 0;
        this.hasErrors1.errsname = 'Enter maximum 50 and minimum 2 letters';
      }

      if (gst !== "") {
        if (regex.test(gst) === false) {
          add_true = 0;
          this.hasErrors1.errsgst = true;
        } else if (gst.length > 15) {
          add_true = 0;
          this.hasErrors1.errsgst = true;
        }
      }

      if (adrs == '' && nm == '' && phn == '') {
        add_true = 0;
      }
      if (adrs == '' && nm == '' && phn == '' && st == '' && ct == '' && pncd == '') {
        add_true = 0;
      }
      if (adrs == '') {
        this.hasErrors1.errsaddress = 'Required';
        add_true = 0;
      } else if (adrs.length < 2 || adrs.length > 200) {
        this.hasErrors1.errsaddress = 'Enter maximum 200 and minimum 2 letters';
        add_true = 0;
      } else {}

      if (phnrex.test(phn) == false) {
        if (phn == '') {
          this.hasErrors1.errsphn = 'Required';
        } else if (phn.length < 10 || phn.length > 15) {
          this.hasErrors1.errsphn = 'Enter maximum 15 and minimum 10 numbers';
        } else {
          this.hasErrors1.errsphn = 'Enter valid phone number';
        }

        add_true = 0;
      }

      if (pinrex.test(pncd) == false) {
        if (pncd != '') {
          this.hasErrors1.errspincode = 'Enter valid pincode';
          add_true = 0;
        }
      }

      if (add_true == 1) {
        this.addr.push({ yname: nm, yaddress: adrs, ypincode: pncd, ystate: st, ycity: ct, yphn: phn, ystateid: stid, ycityid: ctid, ycountry: this.con.id, ygst: gst });
        this.address.sname = '';
        this.address.saddress = '';
        this.address.spincode = '';
        this.address.sstate = '';
        this.address.sstateid = '';
        this.address.scity = '';
        this.address.scityid = '';
        this.address.sphn = '';
        this.address.sgst = '';
        this.shippingstate = null;
        this.shippingcity = null;
      }
    },
    addcustomer: function addcustomer() {
      var _this = this;
      this.loading = true;
      this.$http.get('/api/customers/chk_plan_count').then(function (response) {
        _this.loading = false;
        if ('message' in response.data) {
          if (response.data.message === true) {
            _this.plan_modal = true;
          } else {
            _this.plan_modal = false;
            _this.tit = "Add Customer";
            _this.addr = [];
            _this.shipdisable = true;
            _this.saveBtn = true;
            _this.editBtn = false;
            _this.contr1ed('101');
            _this.state1ed('22');
            _this.city1ed('2707');
            _this.largeModal = true;
            _this.reset_error();
            _this.reset();
            _this.address.sname = '';
            _this.address.saddress = '';
            _this.address.spincode = '';
            _this.address.sstate = '';
            _this.address.sstateid = '';
            _this.address.scity = '';
            _this.address.scityid = '';
            _this.address.sphn = '';
            _this.hasErrors1.errscity = '';
            _this.hasErrors1.errsstate = '';
            _this.hasErrors1.errsphn = '';
            _this.hasErrors1.errspincode = '';
            _this.hasErrors1.errsaddress = '';
            _this.hasErrors1.errsname = '';
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    viewcustomer: function viewcustomer(customerid) {
      var _this = this;
      _this.display.name = null;
      _this.display.cmptyp = null;
      _this.display.email = null;
      _this.display.add1 = null;
      this.largeModal1 = true;
      _this.display.name = customerid.cust_cmp_name;

      _this.display.cmptyp = customerid.companytypes.desc;
      _this.display.email = customerid.cust_cmp_email;
      _this.display.add1 = customerid.address1;
    },
    contr1ed: function contr1ed(option) {
      var _this = this;
      this.$http.get('/api/countries/' + option).then(function (response) {
        _this.con = response.data;
      }).catch(function (error) {
        console.log(error);
      });

      this.$http.get('/api/states?&filter[where][country_id]=' + option).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    state1ed: function state1ed(conopt) {
      var _this = this;
      this.$http.get('/api/states/' + conopt).then(function (response) {
        _this.state = response.data;
      }).catch(function (error) {
        console.log(error);
      });

      this.$http.get('/api/cities?filter[where][state_id]=' + conopt).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1ed: function city1ed(stateopt) {
      var _this = this;
      this.$http.get('/api/cities/' + stateopt).then(function (response) {
        _this.city = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    suptyp1ed: function suptyp1ed(suptypopt) {
      var _this = this;
      this.$http.get('/api/companytypes/' + suptypopt).then(function (response) {
        _this.suptype = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getshippingDetails: function getshippingDetails(customer_id, company_id) {
      if (this.addr.length > 0) {
        for (var i = this.addr.length - 1; i >= 0; i--) {
          this.addr.splice(i, 1);
        }
      }
      var data = [];
      var _this = this;
      this.$http.get('/api/customershippspecs?filter[where][customer_id]=' + this.customer_id).then(function (response) {
        var addr_data = response.data['ship_dt'];
        var state_dt = response.data['state_dt'];
        var city_dt = response.data['city_dt'];
        for (var i = 0; i < addr_data.length; i++) {
          _this.addr.push({ yname: addr_data[i].customer_name, yaddress: addr_data[i].address, ypincode: addr_data[i].pincode, ystate: state_dt[addr_data[i].state_code], ystateid: addr_data[i].state_code, ycity: city_dt[addr_data[i].city], ycityid: addr_data[i].city, yphn: addr_data[i].contact_no, chkship_id: addr_data[i].shipp_id, ygst: addr_data[i].gst_no });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    editcustomer: function editcustomer(customerid) {
      this.reset_error();
      this.reset();
      this.tit = "Edit Customer";
      this.saveBtn = false;
      this.editBtn = true;
      this.largeModal = true;
      this.customer.name = customerid.cust_cmp_name;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      if (customerid.cust_cmp_type != null) {
        this.suptyp1ed(customerid.cust_cmp_type);
      }
      this.customer.add = customerid.address1;
      if (this.customer.add.trim() !== "") {
        this.shipdisable = false;
      } else {
        this.shipdisable = true;
      }
      this.customer.add2 = customerid.address2;
      if (customerid.country_code != null) {
        this.contr1ed(customerid.country_code);
      }
      if (customerid.state_code != null) {
        this.state1ed(customerid.state_code);
      }
      if (customerid.city != null) {
        this.city1ed(customerid.city);
      }
      this.customer.pin = customerid.pincode;
      this.customer.phone = customerid.cust_cmp_phone;
      this.customer.email = customerid.cust_cmp_email;
      this.customer.gst = customerid.cust_cmp_gst;
      this.customer.pan = customerid.cust_cmp_pan;
      this.customer.cin = customerid.cust_cmp_cin;
      this.customer.tan = customerid.cust_cmp_tan;
      this.customer.contact = customerid.contact_person_name;
      this.customer.contactno = customerid.contact_no;
      this.customer.contactemail = customerid.contact_email;
      this.customer.profile = customerid.customerdetailss.cust_cmp_profile;
      this.customer.bankname = customerid.customerbanks.bank_name;
      this.customer.banknumber = customerid.customerbanks.acc_number;
      this.customer.bankholder = customerid.customerbanks.bank_holder_name;
      this.customer.bankifsc = customerid.customerbanks.ifsc_code;
      this.customer.bankbranch = customerid.customerbanks.branch;
      this.customer.bankmicr = customerid.customerbanks.micr_code;
      this.customer.bankswift = customerid.customerbanks.swift_code;
      this.ed.image1 = customerid.customerdetailss.cust_cmp_cic_cert;
      this.ed.image2 = customerid.customerdetailss.cust_cmp_gst_cert;
      this.ed.image3 = customerid.customerdetailss.cust_cmp_pan_cert;
      this.ed.image4 = customerid.customerdetailss.cust_cmp_tan_cert;
      this.ed.image5 = customerid.customerdetailss.cust_cmp_logo;
      this.ed.image1_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + customerid.customerdetailss.cust_cmp_cic_cert + this.access_token;
      this.ed.image2_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + customerid.customerdetailss.cust_cmp_gst_cert + this.access_token;
      this.ed.image3_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + customerid.customerdetailss.cust_cmp_pan_cert + this.access_token;
      this.ed.image4_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + customerid.customerdetailss.cust_cmp_tan_cert + this.access_token;
      this.ed.image5_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + customerid.customerdetailss.cust_cmp_logo + this.access_token;
      this.customer_id = customerid.customer_id;
      this.company_id = customerid.company_id;
      this.getshippingDetails(this.customer_id, this.company_id);
    },
    getCustomer: function getCustomer(val) {
      if (val === 'comp') {
        if (this.cfrst_time === false) {
          this.cfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var data = [];
      this.rows = [];
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var custname = this.search.custname;
      var email = this.search.email;
      custname = custname.split(' ').join('_');
      email = email.split(' ').join('_');

      if (this.search.custname != '') {
        data = data + "&filter[where][cust_cmp_name][ilike]=%" + custname + "%";
      }
      if (this.search.cmptyp != null) {
        if (this.search.cmptyp.id != undefined) {
          var cmptyp = this.search.cmptyp.id;
          data = data + "&filter[where][cust_cmp_type]=" + cmptyp;
        }
      }
      if (this.search.email != '') {
        data = data + "&filter[where][cust_cmp_email][ilike]=%" + email + "%";
      }

      this.$http.get('/api/customers/customer_search?params=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    deletecustomer: function deletecustomer(customerid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        var id = customerid.id;
        this.loading = true;
        this.$http.delete('/api/customers/' + id).then(function (response) {

          _this.getCustomer();
          _this.loading = false;
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    companytype: function companytype(val) {
      if (val === 'comp') {
        if (this.comf_time === false) {
          this.comf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/companytypes').then(function (response) {
        _this.contyp = response.data;
        _this.srch_cmptyp = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    contr: function contr(val) {
      if (val === 'comp') {
        if (this.conf_time === false) {
          this.conf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.cityopt = [];
      this.city = null;
      this.stateopt = [];
      this.state = null;
      this.$http.get('/api/countries').then(function (response) {
        _this.conopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    state1: function state1(conopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      this.$http.get('/api/states?filter[where][country_id]=' + conopt.id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1: function city1(stateopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      this.$http.get('/api/cities?filter[where][state_id]=' + stateopt.id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    shipping_city: function shipping_city(stateopt) {
      this.address.sstate = stateopt.state_name;
      this.address.sstateid = stateopt.id;
      this.shippingcityopt = [];
      this.shippingcity = null;
      var _this = this;
      this.$http.get('/api/cities?filter[where][state_id]=' + stateopt.id).then(function (response) {
        _this.shippingcityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    image1: function image1(callback) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      if (this.ed.image1 !== '' && this.ed.image1 !== null) {
        if (image1.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image1);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image1;
        }
      } else {
        if (image1.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return '';
        }
      }
    },
    image2: function image2(callback) {
      var _this = this;
      var image2 = document.querySelector('#image2');
      if (this.ed.image2 !== '' && this.ed.image2 !== null) {
        if (image2.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image2);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image2;
        }
      } else {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    image3: function image3(callback) {
      var _this = this;
      var image3 = document.querySelector('#image3');
      if (this.ed.image3 !== '' && this.ed.image3 !== null) {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image3);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image3;
        }
      } else {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    image4: function image4(callback) {
      var _this = this;
      var image4 = document.querySelector('#image4');
      if (this.ed.image4 !== '' && this.ed.image4 !== null) {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image4);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image4;
        }
      } else {
        if (image4.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    },
    image5: function image5(callback) {
      var _this = this;
      var image5 = document.querySelector('#image5');
      if (this.ed.image5 !== '' && this.ed.image5 !== null) {
        if (image5.files[0] !== undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image5);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image5;
        }
      } else {
        var _image = document.querySelector('#image5');
        if (_image !== undefined) {
          if (_image.files[0] != undefined) {
            var formData = new FormData();
            formData.append('image', _image.files[0]);
            return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
              return response.data.result.files.image[0].name;
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            return '';
          }
        } else {
          return '';
        }
      }
    },
    reset_error: function reset_error() {
      var _this = this;
      _this.hasErrors.custnm = false;
      _this.hasErrors.custad1 = false;
      _this.hasErrors.custad2 = false;
      _this.hasErrors.custpin = false;
      _this.hasErrors.custph = false;
      _this.hasErrors.custeml = false;
      _this.hasErrors.custgst = false;
      _this.hasErrors.custpan = false;
      _this.hasErrors.custcin = false;
      _this.hasErrors.custtan = false;
      _this.hasErrors.custcont = false;
      _this.hasErrors.custcontno = false;
      _this.hasErrors.custconteml = false;
      _this.hasErrors.image1 = false;
      _this.hasErrors.image2 = false;
      _this.hasErrors.image3 = false;
      _this.hasErrors.image4 = false;
      _this.hasErrors.image5 = false;
      _this.hasErrors.bankname = false;
      _this.hasErrors.banknumber = false;
      _this.hasErrors.bankholder = false;
      _this.hasErrors.bankifsc = false;
      _this.hasErrors.bankbranch = false;
      _this.hasErrors.bankmicr = false;
      _this.hasErrors.bankswift = false;
      _this.hasErrors.supplierprf = false;
    },
    validation: function validation(boolean) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      var image2 = document.querySelector('#image2');
      var image3 = document.querySelector('#image3');
      var image4 = document.querySelector('#image4');
      var image5 = document.querySelector('#image5');

      this.reset_error();

      var submit_true = '0';
      var nrex = /^[a-zA-Z\s]{3,100}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var aregex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      var prex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var accregex = /^[0-9]{3,30}$/;
      var eregex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;

      if (aregex.test(this.customer.name) == false) {
        _this.hasErrors.custnm = true;
        submit_true = 1;
      } else if (this.customer.name.length > 100) {
        _this.hasErrors.custnm = true;
        submit_true = 1;
      }

      if (this.customer.add != "") {
        if (aregex.test(this.customer.add) == false) {
          _this.hasErrors.custad1 = true;
          submit_true = 1;
        } else if (this.customer.add.length > 100) {
          _this.hasErrors.custad1 = true;
          submit_true = 1;
        }
      }

      if (this.customer.add2 != "") {
        if (aregex.test(this.customer.add2) == false) {
          _this.hasErrors.custad2 = true;
          submit_true = 1;
        } else if (this.customer.add2.length > 100) {
          _this.hasErrors.custad2 = true;
          submit_true = 1;
        }
      }

      if (this.customer.profile.length > 255) {
        _this.hasErrors.supplierprf = true;
        submit_true = 1;
      }

      if (this.customer.pin != "") {
        if (pirex.test(this.customer.pin) == false) {
          _this.hasErrors.custpin = true;
          submit_true = 1;
        } else if (this.customer.pin.length > 10) {
          _this.hasErrors.custpin = true;
          submit_true = 1;
        }
      }

      if (prex.test(this.customer.phone) == false) {
        _this.hasErrors.custph = true;
        submit_true = 1;
      } else if (this.customer.phone.length > 15) {
        _this.hasErrors.custph = true;
        submit_true = 1;
      }

      if (this.customer.email != "") {
        if (eregex.test(this.customer.email) == false) {
          _this.hasErrors.custeml = true;
          submit_true = 1;
        } else if (this.customer.email.length > 70) {
          _this.hasErrors.custeml = true;
          submit_true = 1;
        }
      }

      if (this.customer.gst != "") {
        if (regex.test(this.customer.gst) == false) {
          _this.hasErrors.custgst = true;
          submit_true = 1;
        } else if (this.customer.gst.length > 15) {
          _this.hasErrors.custgst = true;
          submit_true = 1;
        }
      }

      if (this.customer.pan != "") {
        if (regex.test(this.customer.pan) == false) {
          _this.hasErrors.custpan = true;
          submit_true = 1;
        } else if (this.customer.pan.length > 10) {
          _this.hasErrors.custpan = true;
          submit_true = 1;
        }
      }

      if (this.customer.cin != "") {
        if (regex.test(this.customer.cin) == false) {
          _this.hasErrors.custcin = true;
          submit_true = 1;
        } else if (this.customer.cin.length > 25) {
          _this.hasErrors.custcin = true;
          submit_true = 1;
        }
      }

      if (this.customer.tan != "") {
        if (regex.test(this.customer.tan) == false) {
          _this.hasErrors.custtan = true;
          submit_true = 1;
        } else if (this.customer.tan.length > 12) {
          _this.hasErrors.custtan = true;
          submit_true = 1;
        }
      }

      if (this.customer.contact != "") {
        if (nrex.test(this.customer.contact) == false) {
          _this.hasErrors.custcont = true;
          submit_true = 1;
        } else if (this.customer.contact.length > 100) {
          _this.hasErrors.custcont = true;
          submit_true = 1;
        }
      }

      if (this.customer.contactno != "") {
        if (prex.test(this.customer.contactno) == false) {
          _this.hasErrors.custcontno = true;
          submit_true = 1;
        } else if (this.customer.contactno.length > 15) {
          _this.hasErrors.custcontno = true;
          submit_true = 1;
        }
      }

      if (this.customer.contactemail != "") {
        if (eregex.test(this.customer.contactemail) == false) {
          _this.hasErrors.custconteml = true;
          submit_true = 1;
        } else if (this.customer.contactemail.length > 70) {
          _this.hasErrors.custconteml = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankname != "") {
        if (regex.test(this.customer.bankname) == false) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        } else if (this.customer.bankname.length > 20) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        }
      }

      if (this.customer.banknumber != "") {
        if (accregex.test(this.customer.banknumber) == false) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        } else if (this.customer.banknumber.length > 20) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankholder != "") {
        if (regex.test(this.customer.bankholder) == false) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        } else if (this.customer.bankholder.length > 50) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankifsc != "") {
        if (regex.test(this.customer.bankifsc) == false) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        } else if (this.customer.bankifsc.length > 20) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankbranch != "") {
        if (regex.test(this.customer.bankbranch) == false) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        } else if (this.customer.bankbranch.length > 20) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankmicr != "") {
        if (regex.test(this.customer.bankmicr) == false) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        } else if (this.customer.bankmicr.length > 20) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankswift != "") {
        if (regex.test(this.customer.bankswift) == false) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        } else if (this.customer.bankswift.length > 20) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        }
      }

      if (image1.files[0] != undefined) {
        if (image1.files[0].size > this.maximumSize) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image1.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image2.files[0] != undefined) {
        if (image2.files[0].size > this.maximumSize) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image2.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image3.files[0] != undefined) {
        if (image3.files[0].size > this.maximumSize) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image3.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image4.files[0] != undefined) {
        if (image4.files[0].size > this.maximumSize) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image4.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image5.files[0] != undefined) {
        if (image5.files[0].size > this.maximumSize) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image5.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      return submit_true;
    },
    Update: function Update() {
      var _this2 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var submit_true = this.validation();
      var _this = this;
      if (submit_true == '0') {
        this.loading = true;
        var cust1 = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          cust1.cust_cmp_name = _this2.customer.name;

          if (_this2.suptype != null) {
            cust1.cust_cmp_type = _this2.suptype.id;
          } else {
            cust1.cust_cmp_type = null;
          }

          cust1.address1 = _this2.customer.add;
          cust1.address2 = _this2.customer.add2;
          cust1.pincode = _this2.customer.pin;
          if (_this2.city != null) {
            cust1.city = _this2.city.id;
          } else {
            cust1.city = null;
          }

          if (_this2.state != null) {
            cust1.state_code = _this2.state.id;
          } else {
            cust1.state_code = null;
          }

          if (_this2.con != null) {
            cust1.country_code = _this2.con.id;
          } else {
            cust1.country_code = null;
          }
          cust1.cust_cmp_phone = _this2.customer.phone;
          cust1.cust_cmp_email = _this2.customer.email;
          cust1.cust_cmp_gst = _this2.customer.gst;
          cust1.cust_cmp_pan = _this2.customer.pan;
          cust1.cust_cmp_cin = _this2.customer.cin;
          cust1.cust_cmp_tan = _this2.customer.tan;
          cust1.contact_person_name = _this2.customer.contact;
          cust1.contact_no = _this2.customer.contactno;
          cust1.contact_email = _this2.customer.contactemail;
          cust1.cust_cmp_cic_cert = user[0];
          cust1.cust_cmp_gst_cert = user[1];
          cust1.cust_cmp_pan_cert = user[2];
          cust1.cust_cmp_tan_cert = user[3];
          cust1.cust_cmp_logo = user[4];
          cust1.cust_cmp_profile = _this2.customer.profile;
          cust1.bank_name = _this2.customer.bankname;
          cust1.acc_number = _this2.customer.banknumber;
          cust1.bank_holder_name = _this2.customer.bankholder;
          cust1.ifsc_code = _this2.customer.bankifsc;
          cust1.branch = _this2.customer.bankbranch;
          cust1.micr_code = _this2.customer.bankmicr;
          cust1.swift_code = _this2.customer.bankswift;
          cust1.addr_data = _this2.addr;
          cust1.customer_id = _this2.customer_id;

          _this2.$http.post('/api/customers/update?where[customer_id]=' + _this2.customer_id, cust1).then(function (response) {
            _this.$http.post('/api/customerbanks/update?where[customer_id]=' + _this.customer_id, cust1).then(function (response) {
              _this.$http.post('/api/customerdetails/update?where[customer_id]=' + _this.customer_id, cust1).then(function (response) {
                _this.loading = false;
                _this.category = response.data;
                _this.hasErrors.message = true;
                _this.errorMessage.message = ' Customer Updated Successfully';
                setTimeout(function () {
                  _this.errorMessage.message = '';
                }, 2000);
                _this.reset();
                _this.getCustomer();
                _this.largeModal = false;
              }).catch(function (error) {
                _this.loading = false;
              });
            }).catch(function (error) {
              _this.loading = false;
            });
          }).catch(function (error) {
            _this.loading = false;
          });
        });
      }
    },
    Submit: function Submit() {
      var _this3 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var submit_true = this.validation();
      var _this = this;
      if (submit_true == '0') {
        this.loading = true;
        var cust = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          cust.cust_cmp_name = _this3.customer.name;

          if (_this3.suptype != null) {
            cust.cust_cmp_type = _this3.suptype.id;
          } else {
            cust.cust_cmp_type = null;
          }

          cust.address1 = _this3.customer.add;
          cust.address2 = _this3.customer.add2;
          cust.pincode = _this3.customer.pin;

          if (_this3.city != null) {
            cust.city = _this3.city.id;
          } else {
            cust.city = null;
          }

          if (_this3.state != null) {
            cust.state_code = _this3.state.id;
          } else {
            cust.state_code = null;
          }

          if (_this3.con != null) {
            cust.country_code = _this3.con.id;
          } else {
            cust.country_code = null;
          }
          cust.cust_cmp_phone = _this3.customer.phone;
          cust.cust_cmp_email = _this3.customer.email;
          cust.cust_cmp_gst = _this3.customer.gst;
          cust.cust_cmp_pan = _this3.customer.pan;
          cust.cust_cmp_cin = _this3.customer.cin;
          cust.cust_cmp_tan = _this3.customer.tan;
          cust.contact_person_name = _this3.customer.contact;
          cust.contact_no = _this3.customer.contactno;
          cust.contact_email = _this3.customer.contactemail;
          cust.cust_cmp_cic_cert = user[0];
          cust.cust_cmp_gst_cert = user[1];
          cust.cust_cmp_pan_cert = user[2];
          cust.cust_cmp_tan_cert = user[3];
          cust.cust_cmp_logo = user[4];
          cust.cust_cmp_profile = _this3.customer.profile;
          cust.bank_name = _this3.customer.bankname;
          cust.acc_number = _this3.customer.banknumber;
          cust.bank_holder_name = _this3.customer.bankholder;
          cust.ifsc_code = _this3.customer.bankifsc;
          cust.branch = _this3.customer.bankbranch;
          cust.micr_code = _this3.customer.bankmicr;
          cust.swift_code = _this3.customer.bankswift;
          cust.shippdetails = _this3.addr;
          _this3.$http.post('/api/customers', cust).then(function (response) {
            _this.loading = false;
            _this.category = response.data;
            _this.hasErrors.message = true;
            _this.errorMessage.message = ' Customer Added Successfully';
            setTimeout(function () {
              _this.errorMessage.message = '';
            }, 2000);
            _this.reset();
            _this.getCustomer();
            _this.largeModal = false;
          }).catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
        });
      }
    },
    reset: function reset() {
      var _this = this;
      _this.customer.name = '';
      _this.suptype = null;
      _this.customer.add = '';
      _this.customer.add2 = '';
      _this.customer.pin = '';

      _this.customer.phone = '';
      _this.customer.email = '';
      _this.customer.gst = '';
      _this.customer.pan = '';
      _this.customer.cin = '';
      _this.customer.tan = '';
      _this.customer.contact = '';
      _this.customer.contactno = '';
      _this.customer.contactemail = '';
      document.getElementById("image1").value = '';
      document.getElementById("image2").value = '';
      document.getElementById("image3").value = '';
      document.getElementById("image4").value = '';
      document.getElementById("image5").value = '';
      _this.customer.profile = '';
      _this.customer.bankname = '';
      _this.customer.banknumber = '';
      _this.customer.bankifsc = '';
      _this.customer.bankbranch = '';
      _this.customer.bankmicr = '';
      _this.customer.bankswift = '';
      _this.ed.image1 = '';
      _this.ed.image2 = '';
      _this.ed.image3 = '';
      _this.ed.image4 = '';
      _this.ed.image5 = '';
      _this.ed.image1_href = '';
      _this.ed.image2_href = '';
      _this.ed.image3_href = '';
      _this.ed.image4_href = '';
      _this.ed.image5_href = '';
      _this.address.sname = '';
      _this.address.sphn = '';
      _this.address.saddress = '';
      _this.address.sstate = '';
      _this.address.sstateid = '';
      _this.address.scity = '';
      _this.address.scityid = '';
      _this.address.spincode = '';
      _this.address.sgst = '';
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invoice',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a, Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      todate: null,
      fromdate: null,
      custname: '',
      salename: '',
      saleid: null,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns: [{
        label: 'Sale Id',
        field: 'sales_id',
        width: '5% !important'
      }, {
        label: 'Customer Company Name',
        field: 'cust_cmp_name',
        width: '20% !important'
      }, {
        label: 'Shop',
        field: 'est_shop_name',
        width: '20% !important'
      }, {
        label: 'Total Tax Amt',
        field: 'total_tax_amt',
        formatFn: this.formatFn,
        width: '10% !important'
      }, {
        label: 'Total Pay Amt',
        field: 'total_amt_pay',
        formatFn: this.formatFn,
        width: '15% !important'
      }, {
        label: 'Date',
        field: 'lastupdated_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        width: '20% !important',
        tdClass: 'text-left',
        thClass: 'text-left'
      }, {
        label: 'Generate',
        field: 'generate',
        width: '10% !important'
      }],
      rows: []
    };
  },
  created: function created() {
    this.tabledt();
    this.shopuser();
  },

  methods: {
    newDate: function newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var dt2 = day + '-' + month + '-' + year;

      return dt2;
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {

      this.updateParams({ page: params.currentPage });
      this.tabledt();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.tabledt();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.tabledt();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.tabledt();
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    generateclick: function generateclick(data) {
      var routeData = this.$router.resolve({ name: 'Sale Invoice Pdf', query: { sid: data.sales_id, cid: data.customer_id } });
      window.open(routeData.href, '_blank');
    },
    tabledt: function tabledt() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var _this = this;
      var data = [];
      this.rows = [];
      var num = /^[0-9]{1}$/;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();

      if (num.test(month) == true) {
        var month = '0' + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = '0' + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = '0' + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = '0' + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + '-' + month + '-' + day;
      var fromdate1 = year1 + '-' + month1 + '-' + day1;
      var custnameserach = this.custname;
      custnameserach = custnameserach.split(' ').join('_');

      if (this.todate != null && this.fromdate != null) {
        data = data + "&filter[where][lastupdated_datetime][between][0]=" + todate1 + "&filter[where][lastupdated_datetime][between][1]=" + fromdate1;
      } else {
        if (this.todate != null) {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != null) {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
      if (this.custname != '') {
        data = data + "&filter[where][cust_cmp_name]=" + custnameserach;
      }
      if (this.salename != '') {
        data = data + "&filter[where][sales_id]=" + this.salename;
      }

      this.$http.get('/api/saledetails/getSales?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    searchdt: function searchdt() {

      this.updateParams({
        sort: {
          type: '',
          field: ''
        }, page: 1
      });
      this.$refs['my-table'].reset();
      this.tabledt();
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      access_token: null,
      rows: [],
      company_logo: "",
      addressModel: false,
      cust_name: "",
      cust_email: "",
      cust_phone: "",
      cust_country: "",
      cust_state: "",
      cust_city: "",
      total_in_words: "",
      shop: {
        name: null,
        add1: null,
        add2: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        gst: null,
        phone: null
      },
      customer1: {
        ship_id: null,
        name: null,
        add: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone: null
      },
      customer: {
        name: null,
        add1: null,
        add2: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone: null,
        email: null,
        gst: null,
        pan: null,
        cin: null,
        tan: null,
        cust_name: null,
        cust_email: null,
        cust_phone: null,
        cust_country: null,
        cust_city: null,
        cust_state: null
      },
      sales: {
        id: null,
        total_amt_pay: null,
        total_items_disc: null,
        additional_discount: null,
        total_amt_before_disc: null,
        cgst: null,
        sgst: null,
        igst: null,
        date: null,
        total_discount: "0.00",
        total_amt_paid: null,
        balance: null
      },
      addr: [],
      cmp: {
        cmp_swift: null,
        cmp_bnk_holder: null
      },
      amt_word: null
    }, "total_in_words", "");
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    currencySymbol: function currencySymbol() {
      return this.companyTaxType === 'US' ? '$' : '{{ currencySymbol }}';
    }
  },
  created: function created() {
    var _this = this;
    var timer = setInterval(function () {
      if ("cid" in _this.$route.query && "sid" in _this.$route.query) {
        clearInterval(timer);
        var cid = _this.$route.query.cid;
        var sid = _this.$route.query.sid;
        _this.loadData(cid, sid);
      }
    }, 600);
  },

  methods: {
    loadData: function loadData(cid, sid) {
      this.customer_id = cid;
      this.shopuser();
      this.loadInvoiceData(cid, sid);
    },
    loadInvoiceData: function loadInvoiceData(cid, sid) {
      var _this = this;
      this.$http.get("/api/companydetails/findOne").then(function (response) {
        if (response.data.cmp_logo == null || response.data.cmp_logo == "") {
          _this.company_logo = "";
        } else {
          _this.company_logo = _this.$http.defaults.baseURL + "/api/containers/pics/download/" + response.data.cmp_logo + _this.access_token;
        }
      }).catch(function (error) {});
      this.$http.get("/api/customershippspecs?filter[where][customer_id]=" + this.customer_id).then(function (response) {
        var addr_data = response.data["ship_dt"];
        var state_dt = response.data["state_dt"];
        var city_dt = response.data["city_dt"];

        for (var i = 0; i < addr_data.length; i++) {
          _this.addr.push({
            yname: addr_data[i].customer_name,
            yaddress: addr_data[i].address,
            ypincode: addr_data[i].pincode,
            ystate: state_dt[addr_data[i].state_code],
            ystateid: addr_data[i].state_code,
            ycityid: addr_data[i].city,
            ycity: city_dt[addr_data[i].city],
            yphn: addr_data[i].contact_no,
            chkship_id: addr_data[i].shipp_id
          });
        }
      }).catch(function (error) {
        console.log(error);
      });

      var _this = this;
      var data = {};

      data.saleid = sid;
      data.customer_id = cid;
      this.$http.post("/api/saledetails/generate_invoice", data).then(function (response) {
        _this.rows = response.data;

        for (var i = 0; i < _this.rows.length; i++) {
          _this.rows[i]["item_discount"] = 0.0;
          if (_this.rows[i]["disc_pct"] !== "" && _this.rows[i]["disc_pct"] !== null && _this.rows[i]["disc_pct"] !== undefined && _this.rows[i]["disc_pct"] !== "0.000000") {
            _this.rows[i]["item_discount"] = parseInt(_this.rows[i]["disc_pct"]) / 100 * (parseFloat(_this.rows[i]["sale_qty"]) * parseFloat(_this.rows[i]["product_unit_cost"]));
          }

          if (_this.rows[i]["disc_amt"] !== "" && _this.rows[i]["disc_amt"] !== null && _this.rows[i]["disc_amt"] !== undefined && _this.rows[i]["disc_amt"] !== "0.000000") {
            _this.rows[i]["item_discount"] = parseFloat(_this.rows[i]["disc_amt"]);
          }
        }

        if (response.data[0] != undefined) {
          var total_item_disc = 0.0;
          var additional_discount = 0.0;
          var total_paid = 0.0;
          _this.cmp.cmp_swift = response.data[0].cmp_swift;
          _this.cmp.cmp_bnk_holder = response.data[0].cmp_bnk_holder;
          _this.cust_name = response.data[0].cust_cmp_name;
          _this.cust_email = response.data[0].cus_email;
          _this.cust_phone = response.data[0].cus_phone;
          _this.word(response.data[0].total_amt_pay);
          _this.customer.city = response.data[0].cus_city;
          _this.customer.state = response.data[0].cus_state;
          _this.customer.country = response.data[0].cus_cnty;
          _this.customer.pincode = response.data[0].cus_pincode;
          _this.customer.add1 = response.data[0].cus_add1;
          _this.customer.add2 = response.data[0].cus_add2;
          _this.customer.gst = response.data[0].cus_gst;
          _this.customer.pan = response.data[0].cus_pan;
          _this.customer.cin = response.data[0].cus_cin;
          _this.customer.tan = response.data[0].cus_tan;
          _this.customer1.ship_id = response.data[0].ship_id;
          _this.customer1.country = response.data[0].ship_country;
          _this.customer1.name = response.data[0].ship_customer_name;
          _this.customer1.add = response.data[0].ship_address;
          _this.customer1.city = response.data[0].ship_city;
          _this.customer1.state = response.data[0].ship_state;
          _this.customer1.pincode = response.data[0].ship_pincode;
          _this.customer1.phone = response.data[0].ship_contact_no;

          _this.sales.id = response.data[0].sales_id;
          _this.sales.total_amt_pay = parseFloat(response.data[0].total_amt_pay).toFixed(2);
          total_item_disc = parseFloat(response.data[0].total_items_disc);
          _this.sales.total_items_disc = parseFloat(response.data[0].total_items_disc).toFixed(2);
          _this.sales.cgst = parseFloat(response.data[0].cgst_amt).toFixed(2);
          _this.sales.sgst = parseFloat(response.data[0].sgst_amt).toFixed(2);
          _this.sales.igst = parseFloat(response.data[0].igst_amt).toFixed(2);
          _this.sales.total_amt_before_disc = parseFloat(response.data[0].total_amt_before_disc).toFixed(2);
          additional_discount = parseFloat(response.data[0].additional_discount);
          _this.sales.additional_discount = parseFloat(response.data[0].additional_discount).toFixed(2);
          _this.sales.total_discount = parseFloat(total_item_disc + additional_discount).toFixed(2);

          total_paid = parseFloat(response.data[0].total_amt_pay) - parseFloat(response.data[0].total_amt_pendingpay);
          _this.sales.total_amt_paid = parseFloat(total_paid).toFixed(2);
          _this.sales.balance = parseFloat(response.data[0].total_amt_pendingpay).toFixed(2);

          var today = new Date(response.data[0].sale_entry_date);
          var dd = today.getDate();
          var mm = today.getMonth() + 1;
          var yyyy = today.getFullYear();
          if (dd < 10) {
            dd = "0" + dd;
          }
          if (mm < 10) {
            mm = "0" + mm;
          }
          today = dd + "/" + mm + "/" + yyyy;
          _this.sales.date = today;

          _this.shop.name = response.data[0].shp_name;
          _this.shop.add1 = response.data[0].shp_add1;
          _this.shop.add2 = response.data[0].shp_add2;
          _this.shop.city = response.data[0].shp_city;
          _this.shop.state = response.data[0].shp_state;
          _this.shop.country = response.data[0].shp_cnty;
          _this.shop.pincode = response.data[0].shp_pin;
          _this.shop.gst = response.data[0]._this.shop.phone = response.data[0].shp_phone;

          _this.customer.name = response.data[0].cust_cmp_name;
          _this.customer.add1 = response.data[0].cus_add1;
          _this.customer.add2 = response.data[0].cus_add2;
          _this.customer.city = response.data[0].cus_city;
          _this.customer.state = response.data[0].cus_state;
          _this.customer.country = response.data[0].cus_cnty;
          _this.customer.pincode = response.data[0].cus_pincode;
          _this.customer.phone = response.data[0].cus_phone;
          _this.customer.email = response.data[0].cus_email;
          _this.customer.gst = response.data[0].cus_gst;
          _this.customer.pan = response.data[0].cus_pan;
          _this.customer.cin = response.data[0].cus_cin;
          _this.customer.tan = response.data[0].cus_tan;
          _this.word(response.data[0].total_amt_pay);
          _this.customer1.name = response.data[0].cust_cmp_name;
          _this.customer1.add = response.data[0].cus_add1;
          _this.customer1.city = response.data[0].cus_city;
          _this.customer1.state = response.data[0].cus_state;
          _this.customer1.pincode = response.data[0].cus_pincode;
          _this.customer1.phone = response.data[0].cus_phone;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatAmt: function formatAmt(value) {
      return parseFloat(value).toFixed(2);
    },
    showAddress: function showAddress(adrs) {
      this.customer1.name = adrs.yname;
      this.customer1.add = adrs.yaddress;
      this.customer1.city = adrs.ycity;
      this.customer1.phone = adrs.yphn;
      this.customer1.state = adrs.ystate;
      this.customer1.pincode = adrs.ypincode;
      this.addressModel = false;
    },
    word: function word(amt) {
      var _this = this;
      var string = _this.inWords(parseInt(amt));
      _this.amt_word = string;
    },
    inWords: function inWords(num) {
      var a = ["", "One ", "Two ", "Three ", "Four ", "Five ", "Six ", "Seven ", "Eight ", "Nine ", "Ten ", "Eleven ", "Twelve ", "Thirteen ", "Fourteen ", "Fifteen ", "Sixteen ", "Seventeen ", "Eighteen ", "Nineteen "];
      var b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

      if ((num = num.toString()).length > 9) return "overflow";
      var n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      var str = "";
      str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore " : "";
      str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh " : "";
      str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand " : "";
      str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred " : "";
      str += n[5] != 0 ? (str != "" ? "and " : "") + (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) + "Only " : "";
      return str;
    }
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListPayments',
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default.a, Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      is_cheque: false,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
      maximumSize: 1000000,
      largeModal1: false,
      largeModal: false,
      loading: false,
      customer_name: [],
      selectcustomer: null,
      sales_row: '',
      sales_id1: '',
      from_DT: '',
      to_DT: '',
      payment_mode: 'cash',
      cheque_no: '',
      cheque_date: '',
      note: '',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      payment: {
        sales_id: '',
        customer_id: '',
        amount_topay: 0,
        amount_balance: 0
      },
      haserror: {
        message: '',
        customer: '',
        attachment: '',
        cheque_no: '',
        cheque_date: '',
        note: '',
        payment_mode: ''
      },
      payment_mode_list: [{ pay_value: 'cash', pay_text: 'Cash' }, { pay_value: 'cheque', pay_text: 'Cheque' }, { pay_value: 'online', pay_text: 'Online' }],
      columns: [{
        label: 'Sales ID',
        field: 'sales_id',
        width: '10% !important'
      }, {
        label: 'Shop',
        field: 'est_shop_name',
        width: '15% !important'
      }, {
        label: 'Customer Name',
        field: 'cust_cmp_name',
        width: '25% !important'
      }, {
        label: 'Amount to Pay',
        field: 'total_amt_pay',
        width: '20% !important'
      }, {
        label: 'Amount Balance',
        field: 'total_amt_pendingpay',
        width: '20% !important'
      }, {
        label: 'Action',
        field: 'paymod',
        width: '10% !important'
      }],
      rows: [],
      rows1: []
    };
  },
  created: function created() {
    this.searchcustomer();
    this.shopuser();
    for (var i = 0; i < 1; i++) {
      this.rows1.push({ err_sales_id: '', sales_id: '', customer_id: '', amount_topay: 0, amount: 0, amount_balance: 0 });
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {

      this.updateParams({ page: params.currentPage });
      this.search_sales();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.search_sales();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.search_sales();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.search_sales();
    },
    onSelect: function onSelect() {
      if (this.payment_mode == 'cheque') {
        this.is_cheque = true;
      } else {
        this.is_cheque = false;
      }
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    attachment: function attachment(callback) {
      var _this = this;
      var attachment = document.querySelector('#attachment');
      if (attachment.files[0] != undefined) {
        var formData = new FormData();
        formData.append('image', attachment.files[0]);
        return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
          return response.data.result.files.image[0].name;
        }).catch(function (error) {
          return '';
        });
      } else {
        return '';
      }
    },
    searchcustomer: function searchcustomer() {
      this.haserror.customer = '';
      var _this = this;
      this.$http.get('/api/customers').then(function (response) {
        _this.customer_name = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRow1: function addRow1() {
      if (this.selectcustomer == null || this.selectcustomer.customer_id == undefined) {
        var cust_cmp_name = null;
      } else {
        var cust_cmp_name = this.selectcustomer.customer_id;
      }
      this.rows1.push({ err_sales_id: '', sales_id: '', customer_id: cust_cmp_name, amount_topay: 0, amount: 0, amount_balance: 0 });
    },


    removeElement: function removeElement(index) {
      this.rows1.splice(index, 1);
    },

    reset_error: function reset_error() {
      this.haserror.message = '';
      this.haserror.customer = '';
      this.haserror.attachment = '';
      this.haserror.cheque_no = '';
      this.haserror.cheque_date = '';
      this.haserror.note = '';
    },
    validation: function validation(boolean) {
      var _this = this;
      var attachment = document.querySelector('#attachment');
      this.reset_error();
      var submit_true = 0;
      var cheque_reg = /^\d+$/;

      if (this.selectcustomer == null || this.selectcustomer.customer_id == undefined) {
        this.haserror.customer = 'Required';
        submit_true = 1;
      }

      if (this.cheque_no != "") {
        if (cheque_reg.test(this.cheque_no) == false) {
          this.haserror.cheque_no = 'Invalid Cheque Number';
          submit_true = 1;
        } else if (this.cheque_no.length > 20) {
          this.haserror.cheque_no = 'Cheque number cannot be greater than 20';
          submit_true = 1;
        }
      }

      if (this.note != "") {
        if (this.cheque_no.length > 500) {
          this.haserror.cheque_no = 'Note cannot be greater than 500 characters';
          submit_true = 1;
        }
      }

      if (attachment.files[0] != undefined) {
        if (attachment.files[0].size > this.maximumSize) {
          this.haserror.attachment = "File Size Cannot Be Greater Than 1 mb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(attachment.files[0].type.toLowerCase()) === -1) {
          this.haserror.attachment = "File type should be jpeg, jpg, png, pdf";
          submit_true = 1;
        }
      }

      if (this.payment_mode == '') {
        this.haserror.payment_mode = 'Required';
        submit_true = 1;
      }

      for (var i = this.rows1.length - 1; i >= 0; i--) {
        if (this.rows1[i].sales_id == '') {
          submit_true = 1;
          this.rows1[i].err_sales_id = 'Required';
        } else {
          this.rows1[i].err_sales_id = '';
        }
      }

      return submit_true;
    },
    finalsubmit: function finalsubmit() {
      var _this2 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation();
      var _this = this;

      if (this.rows1.length == 0) {
        alert("nothing to Save");
      } else {
        if (submit_true == 0) {
          this.loading = true;

          var num = /^[0-9]{1}$/;

          if (this.cheque_date != '') {
            var date = new Date(this.cheque_date);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();

            if (num.test(month) == true) {
              var month = '0' + month;
            } else {
              var month = month;
            }

            if (num.test(day) == true) {
              var day = '0' + day;
            } else {
              var day = day;
            }

            var dateval = year + '-' + month + '-' + day;
          } else {
            var dateval = null;
          }

          var pay = {};
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.attachment()]).then(function (file) {
            pay.customer_id = _this2.selectcustomer.customer_id;
            pay.payment_row = _this2.rows1;
            pay.attachment = file[0];
            pay.cheque_no = _this2.cheque_no;
            pay.cheque_date = dateval;
            pay.note = _this2.note;
            pay.payment_mode = _this2.payment_mode;

            _this2.$http.post('/api/salepayments/addpayment', pay).then(function (response) {
              _this.loading = false;
              _this.reset_form();
              _this.haserror.message = 'Payment Added Successfully';
              setTimeout(function () {
                _this.haserror.message = '';
              }, 2000);
            }).catch(function (error) {
              _this.loading = false;
            });
          });
        }
      }
    },
    CusSelected: function CusSelected() {
      this.rows = [];
      this.haserror.customer = '';
      if (this.rows1.length > 0) {
        for (var i = 0; i < this.rows1.length; i++) {
          this.rows1[i]['sales_id'] = '';
          this.rows1[i]['customer_id'] = this.selectcustomer.customer_id;
          this.rows1[i]['amount_topay'] = 0;
          this.rows1[i]['amount_balance'] = 0;
        }
      }
    },
    search_sales: function search_sales() {
      var _this = this;
      var data = [];

      var sales_id = this.sales_id1;

      var customer_id = this.selectcustomer.customer_id;
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      var customerid = this.selectcustomer.customer_id;
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      if (this.to_DT) {
        var dateto = new Date(this.to_DT);
        var year = dateto.getFullYear();
        var month = dateto.getMonth() + 1;
        var day = dateto.getDate();

        if (num.test(month) == true) {
          var month = '0' + month;
        } else {
          var month = month;
        }

        if (num.test(day) == true) {
          var day = '0' + day;
        } else {
          var day = day;
        }
        var todate1 = year + '-' + month + '-' + day;
      } else {
        todate1 = '';
      }

      if (this.from_DT) {
        var datefrom = new Date(this.from_DT);
        var year1 = datefrom.getFullYear();
        var month1 = datefrom.getMonth() + 1;
        var daycon = datefrom.getDate();
        if (num.test(month1) == true) {
          var month1 = '0' + month1;
        } else {
          var month1 = month1;
        }

        if (num.test(daycon) == true) {
          var day1 = '0' + daycon;
        } else {
          var day1 = daycon;
        }
        var fromdate1 = year1 + '-' + month1 + '-' + day1;
      } else {
        fromdate1 = '';
      }

      data = data + "&filter[where][customer_id]=" + this.selectcustomer.customer_id;
      data = data + "&filter[where][sales_id]=" + sales_id;
      data = data + "&filter[where][from_DT]=" + fromdate1;
      data = data + "&filter[where][to_DT]=" + todate1;

      this.$http.get('/api/salepayments/sales_search?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    sales: function sales(index) {

      this.rows1[index].err_sales_id = '';
      if (this.selectcustomer == null || this.selectcustomer.customer_id == undefined) {
        this.haserror.customer = 'Select Customer First';
        this.rows1[index]['sales_id'] = '';
      } else {

        var match = 0;
        for (var i = 0; i < this.rows1.length; i++) {
          if (i != index) {
            if (this.rows1[i]['sales_id'] === this.rows1[index]['sales_id']) {
              match = 1;
            }
          }
        }

        if (match == 0) {
          this.haserror.customer = '';
          var _this = this;
          var data = {};
          data.sales_id = this.rows1[index]['sales_id'];
          data.customer_id = this.selectcustomer.customer_id;
          this.$http.post('/api/salepayments/customer_payment', data).then(function (response) {
            if (response.data.length > 0) {
              _this.rows1[index]['sales_id'] = response.data[0].sales_id;
              _this.rows1[index]['customer_id'] = _this.selectcustomer.customer_id;

              _this.rows1[index]['amount_topay'] = response.data[0].total_amt_pendingpay;
              _this.rows1[index]['amount'] = response.data[0].total_amt_pendingpay;
              _this.rows1[index]['amount_balance'] = 0;
            } else {
              _this.rows1[index]['sales_id'] = '';
              _this.rows1[index]['customer_id'] = '';
              _this.rows1[index]['amount_topay'] = 0;
              _this.rows1[index]['amount_balance'] = 0;
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          this.rows1[index].err_sales_id = 'This sales id already used';
          this.rows1[index]['sales_id'] = '';
        }
      }
    },
    calculate: function calculate(index) {
      this.rows1[index].err_sales_id = '';
      if (parseFloat(this.rows1[index]['amount_topay']) > parseFloat(this.rows1[index]['amount'])) {
        this.rows1[index]['amount_topay'] = this.rows1[index]['amount'];
        this.rows1[index].err_sales_id = 'Amount cannot be greater than ' + this.rows1[index]['amount'];
      } else if (parseFloat(this.rows1[index]['amount_topay']) < 0) {
        this.rows1[index]['amount_topay'] = this.rows1[index]['amount'];
        this.rows1[index].err_sales_id = 'Amount cannot be negative';
      } else {
        var amt_pay = /^[1-9]\d*(\.\d+)?$/;
        if (amt_pay.test(this.rows1[index]['amount_topay']) == false) {
          this.rows1[index].err_sales_id = 'Enter valid amount';
          this.rows1[index]['amount_topay'] = 0;
          this.rows1[index]['amount_balance'] = this.rows1[index]['amount'];
        } else {
          if (this.rows1[index]['amount_topay'] == '') {
            this.rows1[index]['amount_topay'] = 0;
            this.rows1[index]['amount_balance'] = this.rows1[index]['amount'];
          }
          var bal_amt = parseFloat(this.rows1[index]['amount']) - parseFloat(this.rows1[index]['amount_topay']);
          this.rows1[index]['amount_balance'] = bal_amt.toFixed(6);
        }
      }
    },
    search_sales_modal: function search_sales_modal(index) {
      this.from_DT = '';
      this.to_DT = '';
      this.sales_id1 = '';
      this.rows = [];
      if (this.selectcustomer == null || this.selectcustomer.customer_id == undefined) {
        this.haserror.customer = 'Select Customer First';
      } else {
        this.sales_row = index;
        this.largeModal = true;
      }
    },
    add_sales_payment: function add_sales_payment(row) {
      var sales_row = this.sales_row;
      this.rows1[sales_row]['sales_id'] = row.sales_id;
      this.sales(sales_row);
      this.largeModal = false;
    },
    reset_form: function reset_form() {
      var _this = this;
      if (_this.rows1.length > 0) {
        for (var i = 0; i < _this.rows1.length; i++) {
          _this.rows1[i]['err_sales_id'] = '', _this.rows1[i]['sales_id'] = '', _this.rows1[i]['customer_id'] = '', _this.rows1[i]['amount_topay'] = 0, _this.rows1[i]['amount'] = 0, _this.rows1[i]['amount_balance'] = 0;
        }
      }
      for (var j = this.rows1.length - 1; j >= 1; j--) {
        this.rows1.splice(j, 1);
      }
      _this.selectcustomer = null;
      _this.payment_mode = 'cash';
      _this.cheque_no = '';
      _this.cheque_date = '';
      _this.note = '';
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ListSalePayment",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      loading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns: [{
        label: "Payment Id",
        field: "payment_id",
        width: "15% !important"
      }, {
        label: "Sale Id",
        field: "sale_id",
        width: "10% !important"
      }, {
        label: "Customer",
        field: "cust_cmp_name",
        width: "20% !important"
      }, {
        label: "Shop",
        field: "est_shop_name",
        width: "15% !important"
      }, {
        label: "Payment Mode",
        field: "payment_mode",
        width: "10% !important"
      }, {
        label: "Amount",
        field: "amount",
        width: "15% !important"
      }, {
        label: "Cheque No",
        field: "cheque_no",
        width: "15% !important"
      }]
    };
  },

  computed: {
    is_admin: function is_admin() {
      if (this.$store.getters.get_is_admin) {
        return true;
      } else {
        this.SalePayment();
        this.shopuser();
        return this.$store.getters.get_is_admin;
      }
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.SalePayment();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.SalePayment();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.SalePayment();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.SalePayment();
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    onSelectCompnay: function onSelectCompnay(selectedcompany) {
      this.SalePayment();
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    SalePayment: function SalePayment() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = "";
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/salepayments/salepaymentHistory?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    exportData: function exportData() {

      var _this = this;
      if (this.rows.length > 0) {
        this.$http.get("/api/salepayments/getSalespaymentExport").then(function (response) {
          var access_token = localStorage.getItem("authUser");

          var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
          }).catch(function (er) {
            console.log(er);
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Data Found');
      }
    }
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ListSalePayment",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      companylist: [],
      selectcompany: null,
      loading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns: [{
        label: "Payment Id",
        field: "payment_id",
        width: "15% !important"
      }, {
        label: "Sale Return Id",
        field: "sales_return_id",
        width: "10% !important"
      }, {
        label: "Sale Id",
        field: "sale_id",
        width: "10% !important"
      }, {
        label: "Customer",
        field: "cust_cmp_name",
        width: "20% !important"
      }, {
        label: "Shop",
        field: "est_shop_name",
        width: "15% !important"
      }, {
        label: "Payment Mode",
        field: "payment_mode",
        width: "10% !important"
      }, {
        label: "Amount",
        field: "amount",
        width: "15% !important"
      }, {
        label: "Cheque No",
        field: "cheque_no",
        width: "15% !important"
      }]
    };
  },

  computed: {
    is_admin: function is_admin() {
      if (this.$store.getters.get_is_admin) {
        return true;
      } else {
        this.SalePayment();
        this.shopuser();
        return this.$store.getters.get_is_admin;
      }
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.SalePayment();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.SalePayment();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.SalePayment();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.SalePayment();
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    onSelectCompnay: function onSelectCompnay(selectedcompany) {
      this.SalePayment();
    },
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    SalePayment: function SalePayment() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = "";
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][user_id]=" + this.selectcompany.cmp_email + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      this.$http.get("/api/salereturnpayments/saleReturnpaymentHistory?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    exportData: function exportData() {

      var _this = this;
      if (this.rows.length > 0) {

        this.$http.get("/api/salereturnpayments/getSalesReturnpaymentExport").then(function (response) {
          var access_token = localStorage.getItem("authUser");

          var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
          }).catch(function (er) {
            console.log(er);
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Data Found');
      }
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_vue__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Shopinventory",
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_4__spinner_vue__["a" /* default */],
    "date-picker": __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a
  },
  data: function data() {
    return {
      shopname: [],
      productnamex: [],
      variantvalue: [],
      selectvariant: null,
      selectshop: null,
      selectproduct: null,
      shpfrst_time: false,
      ifrst_time: false,
      ssfrst_time: false,
      hide: false,
      largeModal1: false,
      largeModal: false,
      loading: false,
      inventory: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
        id: "",
        product_id: "",
        est_shop_id: "",
        price_bft: ""
      }, "price_bft", ""),
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      columns: [{
        label: "Product Name ",
        field: "product_name",
        width: "25%"
      }, {
        label: "Qty",
        field: "quantity",
        width: "5%"
      }, {
        label: "Variant",
        field: "variant_value",
        width: "15%"
      }, {
        label: "Shop",
        field: "est_shop_name",
        width: "20%"
      }, {
        label: "Tax",
        field: "tax_inclusive",
        formatFn: this.formatTax,
        width: "10%"
      }, {
        label: "Purchase Price",
        field: "last_purprice_bft",
        formatFn: this.formatFn,
        width: "10%"
      }, {
        label: "Sale Price",
        field: "exp_sellprice_bft_lbl",
        formatFn: this.formatFn,
        width: "10%"
      }, {
        label: "Edit",
        field: "action",
        width: "5%"
      }],
      rows: []
    };
  },

  computed: {
    invt_view: function invt_view() {
      if (this.$store.getters.get_invt_view === true) {
        this.getinventory("comp");
        this.searchshops("comp");
        this.shopuser("comp");
        return true;
      } else {
        return false;
      }
    },

    invt_rights: function invt_rights() {
      return this.$store.getters.get_invt_rights;
    }
  },

  methods: {
    search: function search() {
      this.getinventory();
    },
    openvariant: function openvariant() {
      this.variantvalue = [];
      var _this = this;
      this.selectvariant = null;
      var vrnt_id = this.selectproduct == null ? null : this.selectproduct.variant_id;
      if (vrnt_id !== null) {
        this.$http.get("/api/variantvalues?filter[where][variant_id]=" + vrnt_id).then(function (response) {
          _this.variantvalue = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    searchprd3: function searchprd3(searchText) {
      var _this = this;
      this.productnamex = [];
      this.selectproduct = null;
      this.$http.get("/api/purchasereturns/joinproduct2?data=" + searchText).then(function (response) {
        _this.productnamex = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    searchshops: function searchshops(val) {
      if (val === "comp") {
        if (this.ssfrst_time === false) {
          this.ssfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.shopname = [];
      this.selectshop = null;
      this.$http.get("/api/shopusers/getShop").then(function (response) {
        _this.shopname = response.data;
      }).catch(function (er) {
        console.log(er);
      });
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getinventory();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getinventory();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.getinventory();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getinventory();
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    formatTax: function formatTax(value) {
      if (value === true) {
        return "Inclusive";
      } else {
        return "Exclusive";
      }
    },
    getinventory: function getinventory(val) {
      if (val === "comp") {
        if (this.ifrst_time === false) {
          this.ifrst_time = true;
        } else {
          return;
        }
      }
      this.loading = true;
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var filter = "";
      if (this.selectshop !== null && this.selectshop.est_shop_id !== undefined) {
        filter += "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      if (this.selectproduct !== null && this.selectproduct.product_id !== undefined) {
        filter += "&filter[where][product_id]=" + this.selectproduct.product_id;
      }

      if (this.selectvariant !== null && this.selectvariant.variant_id !== undefined) {
        filter += "&filter[where][variant_id]=" + this.selectvariant.variant_value;
      }

      this.$http.get("/api/estshopinventories/getstock?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + filter).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      });
    },
    edit_inventory: function edit_inventory(inventory) {
      this.inventory.id = inventory.id, this.inventory.product_id = inventory.product_id, this.inventory.est_shop_id = inventory.est_shop_id;

      this.inventory.price_bft = parseFloat(inventory.exp_sellprice_bft).toFixed(2);
    },
    update_inventory: function update_inventory(inventory) {
      var num = /^\d{1,12}(\.\d{1,6})?$/;

      if (this.inventory.price_bft == "") {
        alert("Please Provide Sale Price");
      } else if (num.test(this.inventory.price_bft) == false && this.inventory.price_bft != "") {
        this.inventory.price_bft = "";
        alert("Please Provide Valid Sale Price");
      } else if (parseFloat(this.inventory.price_bft) <= 0) {
        this.inventory.price_bft = "";
        alert("Please Provide Valid Sale Price");
      } else {
        var _this = this;
        var data = {
          cmp_product_id: this.inventory.product_id,
          cmp_est_shop_id: this.inventory.est_shop_id,

          exp_sellprice_bft: this.inventory.price_bft,
          cmp_variant_id: inventory.variant_id
        };

        this.loading = true;
        this.$http.post("/api/estshopinventories/update?where[product_id]=" + inventory.product_id, data).then(function (response) {
          _this.loading = false;
          _this.getinventory();
          _this.inventory.id = "";
        }).catch(function (error) {});
      }
    },
    exportData: function exportData() {
      this.loading = true;
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var filter = "";
      if (this.selectshop !== null && this.selectshop.est_shop_id !== undefined) {
        filter += "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      if (this.selectproduct !== null && this.selectproduct.product_id !== undefined) {
        filter += "&filter[where][product_id]=" + this.selectproduct.product_id;
      }

      if (this.selectvariant !== null && this.selectvariant.variant_id !== undefined) {
        filter += "&filter[where][variant_id]=" + this.selectvariant.variant_value;
      }

      if (this.rows.length > 0) {

        this.$http.get("/api/estshopinventories/getshopinventoryExport?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + filter).then(function (response) {
          _this.loading = false;

          var access_token = localStorage.getItem("authUser");

          var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;

          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
            _this.loading = false;
          }).catch(function (er) {
            console.log(er);
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Data Found');
      }
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'date-picker': __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a, Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      shpfrst_time: false,
      tfrst_time: false,
      gfrst_time: false,
      loading: false,
      fromshp: [],
      toshp: [],
      transfer: {
        id_ed: '',
        productid_ed: '',
        qty_ed: '',
        toshp: '',
        fromshp: '',
        dispatched: '',
        received: ''
      },
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      search: {
        transfer_id: '',
        product_name: '',
        dispatch_DT: '',
        receive_DT: '',
        from_sh: '',
        to_sh: ''
      },
      columns: [{
        label: 'Transfer Id',
        field: 'stock_transfer_id',
        width: '5% !important'
      }, {
        label: 'Product Name',
        field: 'check',
        width: '30% !important'
      }, {
        label: 'From Shop',
        field: 'est_shop_id_from_lb',
        width: '15% !important'
      }, {
        label: 'To Shop',
        field: 'est_shop_id_to_lb',
        width: '15% !important'
      }, {
        label: 'Qty',
        field: 'product_qty_lb',
        width: '5% !important'
      }, {
        label: 'Dispatch Date',
        field: 'dispatch_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width: '15% !important'
      }, {
        label: 'Recived Date',
        field: 'receive_datetime',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDThh:mm:ss',
        dateOutputFormat: 'Do MMM YYYY',
        tdClass: 'text-left',
        thClass: 'text-left',
        width: '15% !important'
      }],
      rows: []
    };
  },

  computed: {
    stcktran_view: function stcktran_view() {
      if (this.$store.getters.get_stcktran_view === true) {
        this.shopuser('comp');
        this.getTotals('comp');
        this.getShop('comp');
        return true;
      } else {
        return false;
      }
    },
    stcktran_rights: function stcktran_rights() {
      return this.$store.getters.get_stcktran_rights;
    }
  },

  methods: {
    newDate: function newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      var dt2 = year + '-' + month + '-' + day;
      return dt2;
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getTotals();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getTotals();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getTotals();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getTotals();
    },
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    getShop: function getShop(val) {
      if (val === 'comp') {
        if (this.gfrst_time === false) {
          this.gfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopestablishments').then(function (response) {
        _this.fromshp = response.data;
        _this.toshp = response.data;
      }).catch(function (error) {
        console.log(erro);
      });
    },
    getTotals: function getTotals(val) {

      if (val === 'comp') {
        if (this.tfrst_time === false) {
          this.tfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var data = [];
      this.rows = [];
      this.loading = true;
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var transfer_id = this.search.transfer_id;
      var product_name = this.search.product_name;

      var from_sh = this.search.from_sh;
      var to_sh = this.search.to_sh;
      var myDate1 = new Date(this.search.dispatch_DT);
      var myDate2 = new Date(this.search.receive_DT);
      var num = /^[0-9]{1}$/;
      var year1 = myDate1.getFullYear();
      var month1 = myDate1.getMonth() + 1;
      var daycon = myDate1.getDate();
      if (num.test(month1) == true) {
        var month1 = '0' + month1;
      } else {
        var month1 = month1;
      }
      if (num.test(daycon) == true) {
        var day1 = '0' + daycon;
      } else {
        var day1 = daycon;
      }

      var year = myDate2.getFullYear();
      var month = myDate2.getMonth() + 1;
      var day = myDate2.getDate();
      if (num.test(month) == true) {
        var month = '0' + month;
      } else {
        var month = month;
      }
      if (num.test(day) == true) {
        var day = '0' + day;
      } else {
        var day = day;
      }

      var receive_DT = year + '-' + month + '-' + day;
      var dispatch_DT = year1 + '-' + month1 + '-' + day1;
      transfer_id = transfer_id.split(' ').join('_');
      product_name = product_name.split(' ').join('_');
      from_sh = from_sh.split(' ').join('_');
      to_sh = to_sh.split(' ').join('_');

      if (this.search.transfer_id != '') {
        data = data + "&filter[where][stock_transfer_id]=" + transfer_id;
      }
      if (this.search.product_name != '') {
        data = data + "&filter[where][product_name]=%" + product_name + "%";
      }
      if (this.search.dispatch_DT != '') {
        data = data + "&filter[where][dispatch_datetime]=" + dispatch_DT;
      }
      if (this.search.receive_DT != '') {
        data = data + "&filter[where][receive_datetime]=" + receive_DT;
      }
      if (this.search.from_sh != '') {
        data = data + "&filter[where][est_shop_id_from]=%" + from_sh + "%";
      }
      if (this.search.to_sh != '') {
        data = data + "&filter[where][est_shop_id_to]=%" + to_sh + "%";
      }

      this.$http.get('/api/stocktransfers/transfer_search?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.reset();
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    exportData: function exportData() {
      this.loading = true;
      var _this = this;

      if (this.rows.length > 0) {

        this.$http.get('/api/stocktransfers/getStocktransferExport').then(function (response) {
          var access_token = localStorage.getItem('authUser');

          var url1 = _this.baseURL2 + '/api/containers/csv/download/' + response.data + '?access_token=' + access_token;

          _this.loading = false;
          _this.$http({
            url: url1,
            method: 'GET',
            responseType: 'blob'
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement('a');
            link.setAttribute('download', response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
            _this.loading = false;
          }).catch(function (er) {
            console.log(er);
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
        alert('No Rows Found');
      }
    },
    editTransfer: function editTransfer(transferdetail) {
      this.transfer.id_ed = transferdetail.id, this.transfer.productid_ed = transferdetail.product_id, this.transfer.qty_ed = transferdetail.product_qty, this.transfer.fromshp = transferdetail.est_shop_id_from, this.transfer.toshp = transferdetail.est_shop_id_to, this.transfer.dispatched = transferdetail.dispatch_datetime, this.transfer.received = transferdetail.receive_datetime;
    },
    updateTransfer: function updateTransfer(transfer_det) {
      var _this = this;
      var data = {
        product_id: this.transfer.productid_ed,
        product_qty: this.transfer.qty_ed,
        est_shop_id_from: this.transfer.fromshp,
        est_shop_id_to: this.transfer.toshp,
        dispatch_datetime: this.transfer.dispatched,
        receive_datetime: this.transfer.received
      };
      this.$http.post('/api/stocktransfers/update?where[id]=' + transfer_det.id, data).then(function (response) {
        _this.getTotals();
        _this.transfer.id_ed = '';
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteTransfer: function deleteTransfer(transferid) {
      var _this = this;
      var id = transferid.id;
      this.$http.delete('/api/stocktransfers/' + id).then(function (response) {
        _this.getTotals();
      }).catch(function (error) {
        console.log(error);
      });
    },
    reset: function reset() {
      this.search.transfer_id = '';
      this.search.product_name = '';
      this.search.dispatch_DT = '';
      this.search.receive_DT = '';
      this.search.from_sh = '';
      this.search.to_sh = '';
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin_pages_company_mgmt_vue__ = __webpack_require__(404);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "shop",
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_1__spinner_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      largeModal: false,
      smallmodal: false,
      variantdata: null,
      variantindex: null,
      variantvalue: [],
      fromshp: [],
      toshp: [],
      loading: false,
      rows: [],
      dispatch_DT: "",
      receive_DT: "",
      note: "",
      from_sh: null,
      to_sh: null
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "rows", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "hasErrors", {
      message: "",
      fromshop: "",
      toshop: "",
      dispatch: "",
      received: "",
      note: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "errorMessage", {
      message: null
    }), _ref;
  },
  created: function created() {
    for (var i = 0; i < 1; i++) {
      this.rows.push({
        product_id: "",
        selectedproductid: "",
        productname: [],
        selectproductrow: null,
        unit_id: "",
        unit_name: "",
        variantrow: "n/a",
        show: false,
        show1: false,
        avai_quantity: 0,
        product_name: "",
        quantity: 0,
        est_shop_id_to: "",
        toshp_lbl: "",
        last_purprice_bft: 0,
        last_purprice_aft: 0,
        exp_sellprice_bft: 0,
        inclusive1: false
      });
    }
    this.getShop();
    this.shopuser();
  },

  methods: {
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    clear_all_rows: function clear_all_rows() {
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i]["product_id"] = "", this.rows[i]["productname"] = [], this.rows[i]["selectproductrow"] = null, this.rows[i]["unit_id"] = "", this.rows[i]["unit_name"] = "", this.rows[i]["avai_quantity"] = 0, this.rows[i]["product_name"] = "", this.rows[i]["quantity"] = 0, this.rows[i]["est_shop_id_to"] = "";
        }
      }
    },
    dispatchSelected: function dispatchSelected() {
      this.hasErrors.dispatch = "";
    },
    receivedSelected: function receivedSelected() {
      this.hasErrors.received = "";
    },
    fromShpSelected: function fromShpSelected() {
      this.hasErrors.fromshop = "";
      this.clear_all_rows();
    },
    toShpSelected: function toShpSelected() {
      this.hasErrors.toshop = "";
      if (this.rows.length > 0) {
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i]["toshp_lbl"] = this.to_sh.est_shop_name;
        }
      }
    },
    quantity: function quantity(row) {
      var num = /^[0-9]{1,10}$/;
      var price = /^\d{1,12}(\.\d{1,6})?$/;
      if (parseFloat(row.quantity) > parseFloat(row.avai_quantity)) {
        row.quantity = 0;
        alert("Transfer quantity should not be greater than " + row.avai_quantity);
      } else if (price.test(parseFloat(row.quantity)) == false) {
        row.quantity = 0;
        alert("Invalid Quantity Entered");
      }
    },
    openvariant: function openvariant(row, index) {
      this.variantindex = index;
      this.variantvalue = row.selectedproductid;
      this.smallmodal = true;
    },
    onSelectvariant: function onSelectvariant(option) {
      this.rows[this.variantindex]["product_id"] = option.product_id;
      this.rows[this.variantindex]["unit_id"] = option.unit_id;
      this.rows[this.variantindex]["unit_name"] = option.unit_name;
      this.rows[this.variantindex]["avai_quantity"] = option.quantity;
      this.rows[this.variantindex]["variantrow"] = option.variant_id;
      this.rows[this.variantindex]["last_purprice_bft"] = option.last_purprice_bft;
      this.rows[this.variantindex]["last_purprice_aft"] = option.last_purprice_aft;
      this.rows[this.variantindex]["exp_sellprice_bft"] = option.exp_sellprice_bft;
      this.smallmodal = false;
    },
    onSelect: function onSelect(option, row) {
      var _this = this;
      row.product_id = "";
      row.unit_id = "";
      row.unit_name = "";
      row.avai_quantity = 0;
      row.show = false;
      row.variantrow = "n/a";
      this.$http.get("/api/estshopinventories/getinventory?filter[where][product_id]=" + option.product_id + "&filter[where][est_shop_id]=" + option.est_shop_id).then(function (response) {
        if (response.data[0].tax_inclusive == true) {
          row.inclusive1 = true;
        }
        if (response.data.length > 1) {

          row.product_id = response.data[0].product_id;
          row.unit_id = response.data[0].unit_id;
          row.unit_name = response.data[0].unit_name;
          row.avai_quantity = response.data[0].quantity;
          row.variantrow = response.data[0].variant_id;
          row.selectedproductid = response.data;
          row.last_purprice_bft = response.data[0].last_purprice_bft;
          row.last_purprice_aft = response.data[0].last_purprice_aft;
          row.exp_sellprice_bft = response.data[0].exp_sellprice_bft;
          row.show = true;
          row.show1 = false;
        } else {
          if (response.data[0].variant_id == "n/a") {
            row.product_id = response.data[0].product_id;
            row.unit_id = response.data[0].unit_id;
            row.unit_name = response.data[0].unit_name;
            row.avai_quantity = response.data[0].quantity;
            row.show = false;
            row.show1 = true;
            row.variantrow = "n/a";
            row.last_purprice_bft = response.data[0].last_purprice_bft;
            row.last_purprice_aft = response.data[0].last_purprice_aft;
            row.exp_sellprice_bft = response.data[0].exp_sellprice_bft;
          } else {
            row.product_id = response.data[0].product_id;
            row.unit_id = response.data[0].unit_id;
            row.unit_name = response.data[0].unit_name;
            row.avai_quantity = response.data[0].quantity;
            row.show = false;
            row.show1 = true;
            row.variantrow = response.data[0].variant_id;
            row.last_purprice_bft = response.data[0].last_purprice_bft;
            row.last_purprice_aft = response.data[0].last_purprice_aft;
            row.exp_sellprice_bft = response.data[0].exp_sellprice_bft;
          }
        }
      }).catch(function (error) {});
    },
    row_reset: function row_reset(row) {
      row.product_id = "";
      row.unit_id = "";
      row.unit_name = "";
      row.avai_quantity = 0;
      row.selectproductrow = null, row.product_name = "", row.quantity = 0, row.est_shop_id_to = "", row.toshp_lbl = "";
    },
    searchprd: function searchprd(searchText, index, row) {
      if (this.from_sh == null || this.from_sh.est_shop_id == undefined) {
        this.hasErrors.fromshop = "Please Select Transfer From Shop";
      } else {
        this.hasErrors.fromshop = "";
        var data = [];
        data = data + "&filter[where][product_name]=%" + searchText + "%";
        data = data + "&filter[where][shopid]=" + this.from_sh.est_shop_id;
        var _this = this;
        this.$http.get("/api/stocktransfers/shop_products?" + data).then(function (response) {
          row.productname = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    getShop: function getShop() {
      var _this = this;
      this.$http.get("/api/shopestablishments").then(function (response) {
        _this.fromshp = response.data;
        _this.toshp = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRow1: function addRow1() {
      if (this.to_sh == null || this.to_sh == undefined) {
        var toshp_val = null;
      } else {
        var toshp_val = this.to_sh.est_shop_name;
      }
      this.rows.push({
        product_id: "",
        selectedproductid: "",
        productname: [],
        selectproductrow: null,
        unit_id: "",
        unit_name: "",
        variantrow: "n/a",
        show: false,
        show1: false,
        avai_quantity: 0,
        product_name: "",
        quantity: 0,
        est_shop_id_to: "",
        toshp_lbl: toshp_val,
        last_purprice_bft: 0,
        last_purprice_aft: 0,
        exp_sellprice_bft: 0,
        inclusive1: false
      });
    },
    validation: function validation() {
      var success = 0;
      this.hasErrors.message = "";
      this.hasErrors.dispatch = "";
      this.hasErrors.received = "";
      this.hasErrors.fromshop = "";
      this.hasErrors.toshop = "";
      this.hasErrors.note = "";
      if (this.dispatch_DT == "") {
        success = 1;
        this.hasErrors.dispatch = "Required";
      }
      if (this.receive_DT == "") {
        success = 1;
        this.hasErrors.received = "Required";
      }
      if (this.from_sh == null || this.from_sh.est_shop_id == undefined) {
        success = 1;
        this.hasErrors.fromshop = "Required";
      }
      if (this.from_sh === this.to_sh) {
        success = 1;
        this.hasErrors.toshop = "To Shop and From Shop are Same.";
      }
      if (this.to_sh == null || this.to_sh.est_shop_id == undefined) {
        success = 1;
        this.hasErrors.toshop = "Required";
      }
      if (this.note.length > 255) {
        success = 1;
        this.hasErrors.note = "Note cannot be greater than 255 characters";
      }
      if (this.dispatch_DT !== "" && this.receive_DT !== "") {
        if (Date.parse(this.receive_DT) < Date.parse(this.dispatch_DT)) {
          success = 1;
          this.hasErrors.received = "Must be greater than or equal to dispatch date";
        }
      }

      for (var j = this.rows.length - 1; j >= 0; j--) {
        if (this.rows[j].selectproductrow == null) {
          this.rows.splice(j, 1);
        }
      }

      if (this.rows.length == 0) {
        alert("Transfer Will Not Be Saved");
        success = 1;
      }

      return success;
    },
    saveTransfer: function saveTransfer() {
      var success = this.validation();
      if (success == 0) {
        this.loading = true;
        var data = {};

        var myDate1 = new Date(this.dispatch_DT);
        var myDate2 = new Date(this.receive_DT);
        var num = /^[0-9]{1}$/;
        var year1 = myDate1.getFullYear();
        var month1 = myDate1.getMonth() + 1;
        var daycon = myDate1.getDate();
        if (num.test(month1) == true) {
          var month1 = "0" + month1;
        } else {
          var month1 = month1;
        }
        if (num.test(daycon) == true) {
          var day1 = "0" + daycon;
        } else {
          var day1 = daycon;
        }

        var year = myDate2.getFullYear();
        var month = myDate2.getMonth() + 1;
        var day = myDate2.getDate();
        if (num.test(month) == true) {
          var month = "0" + month;
        } else {
          var month = month;
        }
        if (num.test(day) == true) {
          var day = "0" + day;
        } else {
          var day = day;
        }

        var receive_DT = year + "-" + month + "-" + day;
        var dispatch_DT = year1 + "-" + month1 + "-" + day1;


        data.est_shop_id_from = this.from_sh.est_shop_id;
        data.est_shop_id_to = this.to_sh.est_shop_id;
        data.dispatch_datetime = dispatch_DT;
        data.receive_datetime = receive_DT;
        data.product_items = this.rows;
        data.note = this.note;

        var _this = this;

        this.$http.post("/api/stocktransfers/save_transfer", data).then(function (response) {
          _this.loading = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          _this.hasErrors.message = " Transfer Added Successfully";
          setTimeout(function () {
            _this.hasErrors.message = "";
          }, 2000);
          _this.reset();
        }).catch(function (error) {
          _this.loading = false;
        });
      }
    },
    reset: function reset() {
      this.from_sh = null;
      this.to_sh = null;
      this.dispatch_DT = "";
      this.receive_DT = "";
      this.note = "";

      for (var j = this.rows.length - 1; j >= 0; j--) {
        this.rows.splice(j, 1);
      }

      for (var i = 0; i < 1; i++) {
        this.rows.push({
          product_id: "",
          selectedproductid: "",
          productname: [],
          selectproductrow: null,
          unit_id: "",
          unit_name: "",
          variantrow: "n/a",
          show: false,
          show1: false,
          avai_quantity: 0,
          product_name: "",
          quantity: 0,
          est_shop_id_to: "",
          toshp_lbl: "",
          last_purprice_bft: 0,
          last_purprice_aft: 0,
          exp_sellprice_bft: 0,
          inclusive1: false
        });
      }
    },

    removeElement: function removeElement(index) {
      this.rows.splice(index, 1);
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_mgmt_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a65732b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_mgmt_vue__ = __webpack_require__(810);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_mgmt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a65732b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_mgmt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CompanyManagement",
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      vfrst_time: false,
      loading: false,
      search_cname: "",
      totalRecords: 0,
      totalRecords1: 0,
      warningModal: false,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      columns: [{
        label: "Company Name",
        field: "company_name",
        width: "20% !important",
        thClass: "text-center"
      }, {
        label: "Company ID",
        field: "company_id",
        width: "15% !important",
        thClass: "text-center"
      }, {
        label: "Phone",
        field: "com_phone",
        width: "15% !important",
        thClass: "text-center"
      }, {
        label: "Email",
        field: "cmp_email",
        width: "25% !important",
        thClass: "text-center"
      }, {
        label: "Companies User",
        field: "userdtl",
        width: "15% !important",
        tdClass: "text-center",
        thClass: "text-center"
      }, {
        label: "Action",
        field: "action",
        width: "10% !important",
        tdClass: "text-center",
        thClass: "text-center"
      }],

      rows: [],

      columns1: [{
        label: "Username",
        field: "username",
        width: "20% !important"
      }, {
        label: "Role",
        field: "role",
        width: "10% !important"
      }, {
        label: "Email",
        field: "email",
        width: "30% !important"
      }, {
        label: "Phone",
        field: "phone",
        width: "20% !important"
      }, {
        label: "Status",
        field: "status",
        width: "20% !important"
      }],
      rows1: [],
      error: {
        errorname: false,
        errorided: "",
        errornameed: "",
        errorvalue: false
      },
      message: {
        sucess: "",
        sucess1: ""
      }
    };
  },
  created: function created() {
    this.getcompany();
  },


  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getcompany();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getcompany();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.getcompany();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getcompany();
    },
    editvalue: function editvalue(data1) {
      this.$store.commit("set_reg_view", true);
      this.$store.commit("set_reg_rights", true);
      this.$router.push({
        name: "Company Registration",
        params: { company_id: data1.company_id }
      });
    },
    viewvalue: function viewvalue(data) {
      this.$store.commit("set_reg_view", true);
      this.$store.commit("set_reg_rights", false);
      this.$router.push({
        name: "Company Registration",
        params: { company_id: data.company_id }
      });
    },
    userdetail: function userdetail(cmp) {
      var _this = this;
      this.warningModal = true;
      this.loading = true;
      this.$http.get("/api/users/getcompanyuserslist?filter[where][company_id]=" + cmp.company_id + "&filter[where][regcity]=" + cmp.regcity_code).then(function (response) {
        if (response.data.length > 0) {
          _this.rows1 = response.data;
        }
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    },
    getcompany: function getcompany(val) {
      if (val === "comp") {
        if (this.vfrst_time === false) {
          this.vfrst_time = true;
        } else {
          return;
        }
      }
      this.loading = true;
      var _this = this;
      var filteParam = {};
      var data = "";
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var api = "";
      if (this.search_cname !== "") {
        api = "/api/companies?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + "&filter[where][company_name][ilike]=%" + this.search_cname + "%";
      } else {
        api = "/api/companies?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam);
      }

      this.$http.get(api).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) {
          _this.rows = response.data;
        }
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__spinner_vue__ = __webpack_require__(3);










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_6_vue2_editor__["VueEditor"],
    Spinner: __WEBPACK_IMPORTED_MODULE_7__spinner_vue__["a" /* default */]
  },

  data: function data() {
    var _product;

    return {
      plan_modal: false,
      tnl_time: false,
      cf_time: false,
      scf_time: false,
      uf_time: false,
      bf_time: false,
      hf_time: false,
      vf_time: false,
      pf_time: false,
      rsf_time: false,
      access_token: null,
      disabled: 1,
      pluscheck: false,
      largeModal: false,
      productedit: 0,
      producteditvalue: null,
      loading: false,
      checkboxqty: false,
      checkboxtk: false,
      varientlist: [],
      pdid: '',
      pdname: '',
      show_save_btn: false,
      columns: [{
        label: 'Product Name',
        field: 'product_name',
        width: '30%'
      }, {
        label: 'Product Description',
        field: 'product_description',
        width: '45%'
      }, {
        label: 'Barcode',
        field: 'product_barcode_symbol',
        width: '20%'
      }, {
        label: 'Edit',
        field: 'action',
        width: '5%'
      }],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      category: [],
      unitopt: [],
      brndopt: [],
      hsnopt: [],
      taxopt: [],
      specs: [],
      subcategory: [],
      subcategory_all: [],
      selectedCategory: null,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      maximumSize: 500000,
      selectedSub: null,
      selectedBrand: null,
      selectedUnit: null,
      selectedHsn: '',
      selectedTax: '',
      product: (_product = {
        altproductid: '',
        productname: '',
        productdesc: '',
        productbarcodesymbol: '',
        productalertqty: '',
        productcf1: '',
        productcf2: '',
        productcf3: '',
        productcf_val1: '',
        productcf_val2: '',
        productcf_val3: '',
        specname: '',
        specdesc: '',
        additionalinfo: '',
        variantname: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_product, 'image5', null), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_product, 'imageArr', []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_product, 'imageUrl', []), _product),
      indx: 0,
      hasErrors: {
        message: false,
        altproductid: false,
        productname: false,
        productdesc: false,
        productcode: false,
        productalert: false,
        productcf1: false,
        productcf2: false,
        productcf3: false,
        productcf_val1: false,
        productcf_val2: false,
        productcf_val3: false,
        specname: false,
        specdesc: false,
        variantname: false,
        image: false,
        selectedHsn: false,
        selectedTax: false,
        productbarcodesymbol: false
      },
      errorMessage: {
        message: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null,
        image6: null,
        selectedHsn: '',
        selectedTax: '',
        productbarcodesymbol: ''
      }
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },

    prod_view: function prod_view() {
      if (this.$store.getters.get_prod_view === true) {
        this.getCategories('comp');
        this.unit_name('comp');
        this.tax_name_list('comp');
        this.brand_name('comp');
        this.hsnno('comp');
        this.getvariant('comp');
        this.getproducttl('comp');
        this.reset_specs('comp');
        return true;
      } else {
        return false;
      }
    },
    prod_rights: function prod_rights() {
      return this.$store.getters.get_prod_rights;
    }
  },
  watch: {
    'product.productname': function productProductname() {
      this.generateSku();
    },
    selectedCategory: function selectedCategory() {
      this.generateSku();
    }
  },
  created: function created() {
    if (localStorage.authUser != null) {
      this.access_token = '?access_token=' + localStorage.authUser;
    }
  },


  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getproducttl();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getproducttl();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getproducttl();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getproducttl();
    },
    hasBarcode: function hasBarcode() {
      this.disabled = (this.disabled + 1) % 2;
      this.hasErrors.productbarcodesymbol = false;
      this.errorMessage.productbarcodesymbol = '';
    },
    strip_html_tags: function strip_html_tags(str) {
      if (str === null || str === '') {
        return null;
      } else {
        str = str.toString();
        return str.replace(/<[^>]*>/g, ' ');
      }
    },
    reset_specs: function reset_specs(val) {
      if (val === 'comp') {
        if (this.rsf_time === false) {
          this.rsf_time = true;
        } else {
          return;
        }
      }
      if (this.specs.length > 0) {
        for (var i = this.specs.length - 1; i >= 0; i--) {
          this.specs.splice(i, 1);
        }
      }
      for (var i = 0; i < 1; i++) {
        this.specs.push({ specname: '', specdesc: '' });
      }
    },
    openproduct: function openproduct() {
      var _this = this;
      this.loading = true;
      this.$http.get('/api/companyproducts/chk_plan_count').then(function (response) {
        _this.loading = false;
        if ('message' in response.data) {
          if (response.data.message === false) {
            _this.plan_modal = false;
            _this.errorMessage.image1 = null;
            _this.errorMessage.image2 = null;
            _this.errorMessage.image3 = null;
            _this.errorMessage.image4 = null;
            _this.errorMessage.image5 = null;
            _this.errorMessage.image6 = null;
            _this.$refs.fileinput1.reset();
            _this.$refs.fileinput2.reset();
            _this.$refs.fileinput3.reset();
            _this.$refs.fileinput4.reset();
            _this.$refs.fileinput5.reset();
            _this.$refs.fileinput6.reset();
            _this.product.imageArr = [];
            _this.product.imageUrl = [];
            _this.show_save_btn = true;
            _this.largeModal = true;
            _this.reset();
          } else {
            _this.plan_modal = true;
          }
        } else {
          console.log('something went wrong');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    addRow: function addRow() {
      this.specs.push({ specname: '', specdesc: '' });
    },


    removeElement: function removeElement(index) {
      this.specs.splice(index, 1);
    },

    getvariant: function getvariant(val) {
      if (val === 'comp') {
        if (this.vf_time === false) {
          this.vf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/variants').then(function (response) {
        _this.varientlist = response.data;
      }).catch(function (error) {});
    },
    brand_name: function brand_name(val) {
      if (val === 'comp') {
        if (this.bf_time === false) {
          this.bf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/brands').then(function (response) {
        _this.brndopt = response.data;
      }).catch(function (error) {});
    },
    unit_name: function unit_name(val) {
      if (val === 'comp') {
        if (this.uf_time === false) {
          this.uf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/unittypes').then(function (response) {
        _this.unitopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    tax_name_list: function tax_name_list(val) {
      if (val === 'comp') {
        if (this.tnl_time === false) {
          this.tnl_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/taxrates').then(function (response) {
        _this.taxopt = response.data;
      }).catch(function (error) {});
    },
    tax_name: function tax_name(opt) {
      this.selectedTax = null;
      var tax_sel = this.taxopt.filter(function (each) {
        return each.tax_id === opt;
      });
      this.selectedTax = tax_sel[0];
    },
    hsnno: function hsnno(val) {
      if (val === 'comp') {
        if (this.hf_time === false) {
          this.hf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/hsns').then(function (response) {
        _this.hsnopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    subcategory1: function subcategory1(category) {
      if ('category_id' in category) {
        var _this = this;
        var id = category.category_id;
        this.$http.get('/api/subcategories?filter[where][category_id]=' + id).then(function (response) {
          _this.subcategory = response.data;
          this.selectedSub = _this.subcategory[0];
        }).catch(function (error) {});
      } else {
        this.selectedCategory = null;
        this.selectedSub = null;
      }
    },
    subcategory2: function subcategory2(category, subcategory) {
      this.subcategory = [];
      this.selectedSub = null;
      var _this = this;
      var id = category;
      this.$http.get('/api/subcategories?filter[where][category_id]=' + id).then(function (response) {
        _this.subcategory = response.data;
        if (subcategory !== null) {
          var sel_subcat = _this.subcategory.filter(function (each) {
            return each.sub_category_id === subcategory;
          });
          _this.selectedSub = sel_subcat[0];
        }
      }).catch(function (error) {});
    },
    getCategories: function getCategories(val) {
      if (val === 'comp') {
        if (this.cf_time === false) {
          this.cf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/categories').then(function (response) {
        _this.category = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getCategoriesed: function getCategoriesed(cat, sub_cat) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var cat_sel;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.category.filter(function (each) {
                  return each.category_id === cat;
                });

              case 2:
                cat_sel = _context.sent;

                _this2.selectedCategory = cat_sel[0];
                _this2.subcategory2(cat, sub_cat);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    subcategory1ed: function subcategory1ed(sub) {
      var subcat_sel = this.subcategory_all.filter(function (each) {
        return each.sub_category_id === sub;
      });
      this.selectedSub = subcat_sel[0];
    },
    brand_nameed: function brand_nameed(brd) {
      var brand_sel = this.brndopt.filter(function (each) {
        return each.brand_id === brd;
      });
      this.selectedBrand = brand_sel[0];
    },
    hsnnoed: function hsnnoed(hsn) {
      var hsn_sel = this.hsnopt.filter(function (each) {
        return each.hsn_id === hsn;
      });
      this.selectedHsn = hsn_sel[0];
      this.tax_name(this.selectedHsn.tax_id);
    },
    unit_nameed: function unit_nameed(unit) {
      var unit_sel = this.unitopt.filter(function (each) {
        return each.unit_id === unit;
      });
      this.selectedUnit = unit_sel[0];
    },
    variant_ed: function variant_ed(id) {
      var variant_sel = this.varientlist.filter(function (each) {
        return each.variant_id === id;
      });
      this.product.variantname = variant_sel[0];
    },
    tax_name_2: function tax_name_2() {
      this.taxopt = [];
      this.selectedTax = null;
      var _this = this;
      this.$http.get('/api/taxrates?filter[where][tax_id]=' + this.selectedHsn.tax_id).then(function (response) {
        _this.taxopt = response.data;
        _this.selectedTax = response.data[0];
      }).catch(function (error) {});
    },
    imagefun1: function imagefun1(callback) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      if (this.product.imageArr[0]) {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[0]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return _this.product.imageArr[0];
        }
      } else {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun2: function imagefun2(callback) {
      var _this = this;
      var image2 = document.querySelector('#image2');
      if (this.product.imageArr[1] != null) {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[1]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[1];
        }
      } else {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun3: function imagefun3(callback) {
      var _this = this;
      var image3 = document.querySelector('#image3');
      if (this.product.imageArr[2] != null) {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[2]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[2];
        }
      } else {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun4: function imagefun4(callback) {
      var _this = this;
      var image4 = document.querySelector('#image4');
      if (this.product.imageArr[3] != null) {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[3]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[3];
        }
      } else {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun5: function imagefun5(callback) {
      var _this = this;
      var image5 = document.querySelector('#image5');
      if (this.product.imageArr[4] != null) {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[4]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[4];
        }
      } else {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun6: function imagefun6(callback) {
      var _this = this;
      var image6 = document.querySelector('#image6');
      if (this.product.imageArr[5] != null) {
        if (image6.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[5]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[5];
        }
      } else {
        if (image6.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    allImage: function allImage(id) {
      var tempArr = [];
      return this.$http.get('/api/productimages?filter[where][product_id]=' + id).then(function (response) {
        if (response.data.length != 0) {
          return response.data;
        } else {
          return null;
        }
      }).catch(function (error) {
        return null;
      });
    },
    editpro: function editpro(row) {
      this.$refs.fileinput1.reset();
      this.$refs.fileinput2.reset();
      this.$refs.fileinput3.reset();
      this.$refs.fileinput4.reset();
      this.$refs.fileinput5.reset();
      this.$refs.fileinput6.reset();
      this.errorMessage.image1 = null;
      this.errorMessage.image2 = null;
      this.errorMessage.image3 = null;
      this.errorMessage.image4 = null;
      this.errorMessage.image5 = null;
      this.errorMessage.image6 = null;
      this.product.imageArr = [];
      this.product.imageUrl = [];
      this.show_save_btn = true;
      var _this = this;
      if (this.specs.length > 0) {
        for (var i = this.specs.length - 1; i >= 0; i--) {
          this.specs.splice(i, 1);
        }
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.allImage(row.product_id)]).then(function (user) {

        for (var i = 0; i < user[0].length; i++) {
          var imageUrl = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + user[0][i].product_image + _this.access_token;
          _this.product.imageArr.push(user[0][i].product_image);
          _this.product.imageUrl.push(imageUrl);
        }
      });

      _this.hasErrors.altproductid = false;
      _this.hasErrors.productname = false;
      _this.hasErrors.selectedHsn = false;
      _this.hasErrors.selectedTax = false;
      _this.hasErrors.productdesc = false;
      _this.hasErrors.productcode = false;
      _this.hasErrors.productalert = false;
      _this.hasErrors.productcf1 = false;
      _this.hasErrors.productcf2 = false;
      _this.hasErrors.productcf3 = false;
      _this.hasErrors.productcf_val1 = false;
      _this.hasErrors.productcf_val2 = false;
      _this.hasErrors.productcf_val3 = false;
      _this.hasErrors.specdesc = false;
      _this.hasErrors.variantname = false;
      _this.hasErrors.productbarcodesymbol = false;
      this.errorMessage.image1 = null;
      this.errorMessage.image2 = null;
      this.errorMessage.image3 = null;
      this.errorMessage.image4 = null;
      this.errorMessage.image5 = null;
      this.errorMessage.image6 = null;
      this.errorMessage.selectedHsn = null;
      this.errorMessage.selectedTax = null;
      this.errorMessage.productbarcodesymbol = '';
      this.largeModal = true;
      this.productedit = 1;
      this.producteditvalue = row.product_id;

      if (row.category_id != null) {
        this.getCategoriesed(row.category_id, row.sub_category_id);
      }

      if (row.brand_id != null) {
        this.brand_nameed(row.brand_id);
      }
      if (row.hsn_id != null) {
        this.hsnnoed(row.hsn_id);
      }
      if (row.tax_gst_id != null) {
        this.tax_name(row.tax_gst_id);
      }
      if (row.unit_id != null) {
        this.unit_nameed(row.unit_id);
      }
      if (row.variant_id != null) {
        this.variant_ed(row.variant_id);
      }

      var prd = row.product_id;

      this.$http.get('/api/productspecifications?filter[where][product_id]=' + prd).then(function (response) {
        var spec_data = response.data;
        for (var i = 0; i < spec_data.length; i++) {
          _this.specs.push({ specname: spec_data[i].spec_name, specdesc: spec_data[i].spec_desc });
        }
      }).catch(function (error) {});

      this.product.altproductid = row.alt_product_id;
      this.product.productname = row.product_name;
      this.product.productdesc = row.product_desc;
      this.product.productbarcodesymbol = row.product_barcode_symbol;
      this.product.productalertqty = row.product_alert_qty;
      this.product.productcf1 = row.product_cf1;
      this.product.productcf2 = row.product_cf2;
      this.product.productcf3 = row.product_cf3;
      this.product.productcf_val1 = row.product_cf1_value;
      this.product.productcf_val2 = row.product_cf2_value;
      this.product.productcf_val3 = row.product_cf3_value;
      this.product.additionalinfo = row.product_additional_info || '';

      if (row.product_alert_qty != '') {
        this.checkboxqty = true;
      }
      this.checkboxtk = row.product_tax_method;
      this.checkboxqty = row.product_track_req;
    },
    viewpro: function viewpro(row) {
      this.show_save_btn = false;
      this.largeModal = true;
      this.product.imageArr = [];
      this.product.imageUrl = [];
      var _this = this;
      if (this.specs.length > 0) {
        for (var i = this.specs.length - 1; i >= 0; i--) {
          this.specs.splice(i, 1);
        }
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.allImage(row.product_id)]).then(function (user) {
        for (var i = 0; i < user[0].length; i++) {
          var imageUrl = _this.$http.defaults.baseURL + '/api/containers/pics/download/' + user[0][i].product_image + _this.access_token;
          _this.product.imageArr.push(user[0][i].product_image);
          _this.product.imageUrl.push(imageUrl);
        }
      });

      if (row.category_id != null) {
        this.getCategoriesed(row.category_id, row.sub_category_id);
      }

      if (row.brand_id != null) {
        this.brand_nameed(row.brand_id);
      }
      if (row.hsn_id != null) {
        this.hsnnoed(row.hsn_id);
      }
      if (row.tax_gst_id != null) {
        this.tax_name(row.tax_gst_id);
      }
      if (row.unit_id != null) {
        this.unit_nameed(row.unit_id);
      }
      if (row.variant_id != null) {
        this.variant_ed(row.variant_id);
      }

      var prd = row.product_id;

      this.$http.get('/api/productspecifications?filter[where][product_id]=' + prd).then(function (response) {
        var spec_data = response.data;
        for (var i = 0; i < spec_data.length; i++) {
          _this.specs.push({ specname: spec_data[i].spec_name, specdesc: spec_data[i].spec_desc });
        }
      }).catch(function (error) {});

      this.product.altproductid = row.alt_product_id;
      this.product.productname = row.product_name;
      this.product.productdesc = row.product_desc;
      this.product.productbarcodesymbol = row.product_barcode_symbol;
      this.product.productalertqty = row.product_alert_qty;
      this.product.productcf1 = row.product_cf1;
      this.product.productcf2 = row.product_cf2;
      this.product.productcf3 = row.product_cf3;
      this.product.productcf_val1 = row.product_cf1_value;
      this.product.productcf_val2 = row.product_cf2_value;
      this.product.productcf_val3 = row.product_cf3_value;
      this.product.additionalinfo = row.product_additional_info || '';

      if (row.product_alert_qty != '') {
        this.checkboxqty = true;
      }
      this.checkboxtk = row.product_tax_method;
      this.checkboxqty = row.product_track_req;
    },
    Submit: function Submit() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var _this = this;
      _this.hasErrors.altproductid = false;
      _this.hasErrors.productname = false;
      _this.hasErrors.selectedHsn = false;
      _this.hasErrors.selectedTax = false;
      _this.hasErrors.productdesc = false;
      _this.hasErrors.productcode = false;
      _this.hasErrors.productalert = false;
      _this.hasErrors.productcf1 = false;
      _this.hasErrors.productcf2 = false;
      _this.hasErrors.productcf3 = false;
      _this.hasErrors.productcf_val1 = false;
      _this.hasErrors.productcf_val2 = false;
      _this.hasErrors.productcf_val3 = false;
      _this.hasErrors.specdesc = false;
      _this.hasErrors.variantname = false;
      _this.hasErrors.productbarcodesymbol = false;
      this.hasErrors.image = false;
      this.errorMessage.image1 = null;
      this.errorMessage.image2 = null;
      this.errorMessage.image3 = null;
      this.errorMessage.image4 = null;
      this.errorMessage.image5 = null;
      this.errorMessage.image6 = null;
      this.errorMessage.selectedHsn = null;
      this.errorMessage.selectedTax = null;
      this.errorMessage.productbarcodesymbol = '';
      var fileInput1 = document.querySelector('#image1');
      var fileInput2 = document.querySelector('#image2');
      var fileInput3 = document.querySelector('#image3');
      var fileInput4 = document.querySelector('#image4');
      var fileInput5 = document.querySelector('#image5');
      var fileInput6 = document.querySelector('#image6');
      var submit_true = '0';
      var nrex = /^[a-zA-Z0-9\s]{3,100}$/;
      var brex = /^[a-zA-Z0-9\s]{3,100}[!@#$%^.,%&<>'":;/_|]{0,3}$/;
      var urex = /^[0-9]{1,9}$/;
      if (fileInput1.files[0] != undefined) {
        if (fileInput1.files[0].size > this.maximumSize) {
          this.errorMessage.image1 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput1.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image1 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image1 = "";
        }
      }

      if (fileInput2.files[0] != undefined) {
        if (fileInput2.files[0].size > this.maximumSize) {
          this.errorMessage.image2 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput2.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image2 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image2 = "";
        }
      }

      if (fileInput3.files[0] != undefined) {
        if (fileInput3.files[0].size > this.maximumSize) {
          this.errorMessage.image3 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput3.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image3 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image3 = "";
        }
      }

      if (fileInput4.files[0] != undefined) {
        if (fileInput4.files[0].size > this.maximumSize) {
          this.errorMessage.image4 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput4.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image4 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image4 = "";
        }
      }

      if (fileInput5.files[0] != undefined) {
        if (fileInput5.files[0].size > this.maximumSize) {
          this.errorMessage.image5 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput5.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image5 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image5 = "";
        }
      }

      if (fileInput6.files[0] != undefined) {
        if (fileInput6.files[0].size > this.maximumSize) {
          this.errorMessage.image6 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput6.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image6 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image6 = "";
        }
      }

      if (this.disabled === 0) {

        if (this.product.productbarcodesymbol == '') {
          this.hasErrors.productbarcodesymbol = true;
          this.errorMessage.productbarcodesymbol = "Required";
          submit_true = '1';
        } else if (this.product.productbarcodesymbol.length > 20) {
          this.hasErrors.productbarcodesymbol = true;
          this.errorMessage.productbarcodesymbol = "Cannot be greater than 20 characters";
          submit_true = '1';
        } else if (this.product.productbarcodesymbol.length < 2) {
          this.hasErrors.productbarcodesymbol = true;
          this.errorMessage.productbarcodesymbol = "Cannot be less than 1 character";
          submit_true = '1';
        }
      }

      if (this.product.productname.length > 100) {
        this.hasErrors.productname = true;
        this.errorMessage.productname = " Enter maximum 100 characters";
        submit_true = '1';
      }

      if (this.product.productname == '') {
        this.hasErrors.productname = true;
        this.errorMessage.productname = "Required";
        submit_true = '1';
      } else {
        this.errorMessage.productname = '';
      }

      if (this.selectedHsn == undefined || this.selectedHsn == '') {
        this.errorMessage.selectedHsn = "Required";
        submit_true = '1';
      } else {
        this.errorMessage.selectedHsn = '';
      }

      if (this.selectedTax == undefined || this.selectedTax == '') {
        this.errorMessage.selectedTax = "Required";
        submit_true = '1';
      } else {
        this.errorMessage.selectedTax = '';
      }

      if (submit_true == '0') {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.imagefun1(), this.imagefun2(), this.imagefun3(), this.imagefun4(), this.imagefun5(), this.imagefun6()]).then(function (user) {
          _this.productval(_this, user);
        });
      }
    },
    productval: function productval(_this, user) {

      var product = {};
      var tempArr = [];
      for (var i = 0; i < user.length; i++) {
        if (user[i] != null) {
          tempArr.push(user[i]);
        }
      }
      if (tempArr.length == 0) {
        tempArr = null;
      }
      if (this.selectedCategory != undefined) {
        product.category_id = this.selectedCategory.category_id;
      } else {
        product.category_id = null;
      }

      if (this.selectedSub != undefined) {
        product.sub_category_id = this.selectedSub.sub_category_id;
      } else {
        product.sub_category_id = null;
      }
      if (this.selectedUnit != undefined) {
        product.unit_id = this.selectedUnit.unit_id;
      }
      if (this.selectedBrand != undefined) {
        product.brand_id = this.selectedBrand.brand_id;
      }
      if (this.selectedHsn != undefined) {
        product.hsn_id = this.selectedHsn.hsn_id;
      }
      if (this.selectedTax != undefined) {
        product.tax_gst_id = this.selectedTax.tax_id;
      }
      if (this.product.variantname != undefined) {
        product.variant_id = this.product.variantname.variant_id;
      }
      product.alt_product_id = this.product.altproductid, product.product_name = this.product.productname, product.product_desc = this.product.productdesc, product.product_barcode_symbol = this.product.productbarcodesymbol, product.product_alert_qty = this.product.productalertqty, product.product_track_req = this.checkboxqty, product.product_tax_method = this.checkboxtk, product.img = tempArr, product.specification = '', product.specRow = this.specs;
      product.product_cf1 = this.product.productcf1, product.product_cf2 = this.product.productcf2, product.product_cf3 = this.product.productcf3, product.product_cf1_value = this.product.productcf_val1, product.product_cf2_value = this.product.productcf_val2, product.product_cf3_value = this.product.productcf_val3, product.product_additional_info = this.product.additionalinfo, product.disabled = this.disabled;

      this.loading = true;
      if (this.productedit == 0) {
        this.$http.post('/api/companyproducts', product).then(function (response) {
          _this.reset();
          if (response.status === 200) {
            _this.loading = false;
            _this.largeModal = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = 'Product Added Successfully';
            _this.getproducttl();
            setTimeout(function () {
              _this.hasErrors.message = false;
            }, 4000);
          } else {
            _this.loading = false;
            if (user != null) {
              return _this.$http.delete('/api/containers/pics/files/' + user);
            }
          }
        }).catch(function (error) {
          _this.loading = false;
          if (user != null) {
            return _this.$http.delete('/api/containers/pics/files/' + user);
          }
        });
      } else {

        this.$http.post('/api/companyproducts/update?where[product_id]=' + this.producteditvalue, product).then(function (response) {
          _this.reset();
          if (response.status === 200) {
            _this.loading = false;
            _this.largeModal = false;
            _this.hasErrors.message = true;
            _this.errorMessage.message = 'Product Updated Successfully';
            _this.getproducttl();
            setTimeout(function () {
              _this.hasErrors.message = false;
            }, 4000);
          } else {
            _this.loading = false;
            if (user != null) {
              return _this.$http.delete('/api/containers/pics/files/' + user);
            }
          }
        }).catch(function (error) {
          _this.loading = false;
          if (user != null) {
            return _this.$http.delete('/api/containers/pics/files/' + user);
          }
        });
      }
    },
    generateSku: function generateSku() {
      if (this.productedit == 1) {
        return;
      }
      var name = (this.product.productname || '').toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      var catName = this.selectedCategory && this.selectedCategory.category_name ? this.selectedCategory.category_name.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : '';
      if (!name || !catName) {
        this.product.altproductid = '';
        return;
      }
      var d = new Date();
      var yy = String(d.getFullYear()).slice(-2);
      var mm = String(d.getMonth() + 1).padStart(2, '0');
      var dd = String(d.getDate()).padStart(2, '0');
      this.product.altproductid = catName.slice(0, 3) + '-' + name.slice(0, 3) + '-' + yy + mm + dd;
    },
    reset: function reset() {
      var _this = this;
      _this.reset_specs();
      _this.product.imageArr = [];
      _this.product.imageUrl = [];
      _this.product.variantname = null;
      _this.product.altproductid = '';
      _this.product.productname = '';
      _this.product.productdesc = '';
      _this.product.productbarcodesymbol = '';
      _this.product.productalertqty = '';
      _this.product.productcf1 = '';
      _this.product.productcf_val1 = '';
      _this.product.specname = '';
      _this.product.specdesc = '';
      _this.product.additionalinfo = '';
      _this.selectedCategory = null;
      _this.subcategory = [];
      _this.selectedSubc = null;
      _this.selectedBrand = null;
      _this.selectedHsn = null;
      _this.selectedTax = null;
      _this.selectedUnit = null;
      _this.hasErrors.message = false;
      _this.errorMessage.message = null;
      _this.hasErrors.selectedHsn = false;
      _this.hasErrors.productbarcodesymbol = false;
      _this.errorMessage.selectedHsn = null;
      _this.hasErrors.selectedTax = false;
      _this.errorMessage.selectedTax = null;
      _this.errorMessage.productbarcodesymbol = '';
      _this.hasErrors.productname = false;
      _this.errorMessage.productname = null;
      _this.productedit = 0;
      _this.producteditvalue = null;
      _this.pluscheck = false;
      _this.product.productcf2 = '';
      _this.product.productcf3 = '';
      _this.product.productcf_val2 = '';
      _this.product.productcf_val3 = '';
      _this.checkboxqty = false;
      _this.checkboxtk = false;
      _this.selectedSub = null;
      _this.image1 = null;
      _this.image2 = null;
      _this.image3 = null;
      _this.image4 = null;
      _this.image5 = null;
      _this.image6 = null;
      _this.productimagevalue1 = null;
      _this.productimagevalue2 = null;
      _this.productimagevalue3 = null;
      _this.productimagevalue4 = null;
      _this.productimagevalue5 = null;
      _this.productimagevalue6 = null;
    },
    getproducttl: function getproducttl(val) {
      if (val === 'comp') {
        if (this.pf_time === false) {
          this.pf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var data = [];
      this.rows = [];
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      if (this.pdid != '') {
        data = data + "&filter[where][product_desc]=" + this.pdid;
      }
      if (this.pdname != '') {
        data = data + "&filter[where][product_name]=" + this.pdname;
      }
      this.loading = true;
      this.$http.get('/api/companyproducts/searchprd?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.loading = false;
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-component',
  data: function data() {
    return {
      serverParams: {
        columnFilters: {},
        sort: {
          field: 'purchase_id',
          type: 'asc'
        },
        page: 1,
        perPage: 5
      },
      purchase_id: null,
      totalRecords: 0,
      PurchaseItemModal: false,
      productnamex: [],
      selectproductrow: null,
      objectItem: null,
      rows: [],
      currentIndex: 0,
      rows1: [],
      rows2: [],
      itemList: [],
      showCompany: false,
      showName: false,
      company_name: '',
      barcode_setting: 0,
      num: 0,
      qtyErr: [],
      options: {
        fontSize: 13,
        height: 40,
        width: 2
      },
      columns: [{
        label: 'Product Name',
        field: 'product_name',
        width: '25% !important'
      }, {
        label: 'Variant',
        field: 'variant_id',
        width: '15% !important'
      }, {
        label: 'Qty',
        field: 'purchase_qty',
        width: '10% !important'
      }, {
        label: 'Price',
        field: 'product_unit_cost',
        width: '10% !important',
        formatFn: this.formatFn
      }, {
        label: 'Tax',
        field: 'tax_inclusive',
        width: '10% !important'
      }, {
        label: 'GST%',
        field: 'gst_total',
        width: '15% !important'
      }, {
        label: 'Amount',
        field: 'amt_to_pay',
        width: '15% !important',
        formatFn: this.formatFn
      }]
    };
  },


  methods: {
    selectedItems: function selectedItems(items) {
      var len = items.selectedRows.length;
      var _this = this;
      this.itemList = [];
      for (var i = 0; i < len; i++) {
        var temp = items.selectedRows[i];
        _this.itemList.push({ product_name: temp.product_name, qty: 1, selectedproductid: temp.product_id, product_barcode_symbol: temp.item_barcode });
      }
    },
    submitPurchaseId: function submitPurchaseId() {
      if (this.purchase_id) {
        var _this = this;
        var data = [];
        var filteParam = {};
        filteParam.page = this.serverParams.page;
        filteParam.perPage = this.serverParams.perPage;
        filteParam.sort = this.serverParams.sort;
        data = data + " &filter[where][purchase_id]=" + this.purchase_id;
        this.$http.get('/api/purchasedetails/searchdb?params=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows2 = response.data;
        });
      }
    },
    searchPurchase: function searchPurchase() {
      this.PurchaseItemModal = true;
      this.purchase_id = null, this.totalRecords = 0, this.rows2 = [];
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },


    removeElement: function removeElement(index) {
      this.rows.splice(index, 1);
      this.generateBarcode();
    },

    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.submitPurchaseId();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.submitPurchaseId();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.submitPurchaseId();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.submitPurchaseId();
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    check: function check(val, indx) {
      var num1 = /^([1-9][0-9]{0,2}|1000)$/;
      if (val == "") {
        this.qtyErr[indx] = 'Required';
      } else if (val <= 0) {
        this.qtyErr[indx] = 'Quantity should be grater than zero';
      } else if (num1.test(val) == false) {
        this.qtyErr[indx] = 'Enter Valid Quantity';
      } else {
        this.qtyErr[indx] = '';
      }
    },
    printBarcode: function printBarcode() {
      window.print();
    },
    onSave: function onSave() {
      var temp = this.itemList;
      if (temp.length > 0) {
        for (var i = 0; i < temp.length; i++) {
          this.rows.push({ product_name: temp[i].product_name, qty: 1, selectedproductid: temp[i].product_id, barcode: temp[i].product_barcode_symbol });
          this.currentIndex = parseInt(this.currentIndex) + 1;
        }
      }
    },
    onSelect: function onSelect(option) {
      if (option.product_name) {
        this.rows.push({ product_name: option.product_name, qty: 1, selectedproductid: option.product_id, barcode: option.product_barcode_symbol });
        this.currentIndex = parseInt(this.currentIndex) + 1;
        this.selectproductrow = null;
      }
    },
    generateBarcode: function generateBarcode() {
      var _this = this;
      this.num = parseInt(this.barcode_setting) - 1;
      this.rows1 = [];
      for (var i = 0; i < this.rows.length; i++) {
        for (var j = 0; j < this.rows[i].qty; j++) {
          this.rows1.push({ barcode: _this.rows[i].barcode, product_name: _this.rows[i].product_name });
        }
      }
    },
    selectProductName: function selectProductName() {
      if (document.getElementById('pname').checked) {
        this.showName = true;
      } else {
        this.showName = false;
      }
    },
    selectCompanyName: function selectCompanyName() {
      var _this = this;
      this.$http.get('/api/companies/findOne').then(function (response) {
        _this.company_name = response.data.company_name;
      });
      if (document.getElementById('cname').checked) {
        this.showCompany = true;
      } else {
        this.showCompany = false;
      }
    },
    searchprd3: function searchprd3(searchText) {
      var _this = this;
      this.$http.get('/api/purchasereturns/joinproduct2?data=' + searchText).then(function (response) {
        _this.productnamex = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);




var idup = "";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "category",
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */]
  },

  data: function data() {
    return {
      plan_modal: false,
      shpfrst_time: false,
      is_admin: false,
      cfrst_time: false,
      sfrst_time: false,
      clf_time: false,
      hide: false,
      largeModal: false,
      largeModal1: false,
      warningModal: false,
      warningModal2: false,
      warningModal4: false,
      loading: false,
      columns: [{
        label: "Category",
        field: "category_name",
        width: "30% !important"
      }, {
        label: "Description",
        field: "category_desc",
        width: "60% !important"
      }, {
        label: "Action",
        field: "action",
        width: "10% !important"
      }],
      rows: [],
      columns1: [{
        label: "Sub Category",
        field: "sub_category_name",
        width: "30% !important"
      }, {
        label: "Description",
        field: "sub_category_desc",
        width: "60% !important"
      }, {
        label: "Action",
        field: "action1",
        width: "10% !important"
      }],
      rows1: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      totalRecords1: 0,
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      Productvalue: null,
      Productvalue1: null,
      categoryopt: [],
      category: {
        name: "",
        description: "",
        name2: "",
        description3: ""
      },
      subcate: {
        name: "",
        description: "",
        name3: "",
        description3: "",
        name4: "",
        description4: ""
      },
      hasErrors: {
        message: false,
        message1: false,
        category: false,
        category1: false,
        subcate1: false,
        subcate: false,
        subcate2: false,
        subcate3: false,
        category2: false,
        category3: false,
        categoryopt: false,
        categoryopt2: false
      },
      errorMessage: {
        message: null,
        message1: null,
        category: null
      }
    };
  },

  computed: {
    cat_view: function cat_view() {
      if (this.$store.getters.get_cat_view === true) {
        this.shopuser("comp");
        this.getCategories("comp");
        this.subcatval("comp");
        this.categorylist("comp");
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    cat_rights: function cat_rights() {
      return this.$store.getters.get_cat_rights;
    }
  },

  methods: {
    chkExist: function chkExist(type) {
      if (type == "cat") {
        this.category.name = this.category.name.trim().replace("'", "''");
        var _this = this;
        if (this.category.name != "") {
          this.$http.get("/api/categories/chk_exist?filter[where][category_name]=" + this.category.name).then(function (response) {
            if (response.data.length > 0) {
              _this.category.name = "";
              _this.hasErrors.category = "Category name already exist";
              _this.$refs["txtcategoryname"].focus();
            } else {
              _this.hasErrors.category = false;
            }
          }).catch(function (error) {
            _this.hasErrors.category = false;
          });
        } else {
          _this.hasErrors.category = false;
        }
      } else {
        var _this = this;
        if (this.Productvalue !== null) {
          this.subcate.name = this.subcate.name.trim();
          if (this.subcate.name != "") {
            this.$http.get("/api/subcategories/chk_exist?filter[where][sub_category_name]=" + this.subcate.name + "&filter[where][category_id]=" + this.Productvalue.category_id).then(function (response) {
              if (response.data.length > 0) {
                _this.subcate.name = "";
                _this.hasErrors.subcate = "Sub Category name already exist";
                _this.$refs["txtsubcategoryname"].focus();
              } else {
                _this.hasErrors.subcate = false;
              }
            }).catch(function (error) {
              _this.hasErrors.subcate = false;
            });
          } else {
            _this.hasErrors.subcate = false;
          }
        } else {
          this.hasErrors.categoryopt = "Please select category";
        }
      }
    },
    categorylist: function categorylist(val) {
      if (val === "comp") {
        if (this.clf_time === false) {
          this.clf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/categories").then(function (response) {
        _this.categoryopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getCategories();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getCategories();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.getCategories();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getCategories();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.subcatval();
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.subcatval();
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.subcatval();
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.subcatval();
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    selectCategory: function selectCategory(id) {
      var _this = this;
      this.$http.get("/api/categories/findOne?filter[where][category_id]=" + id).then(function (response) {
        _this.Productvalue1 = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    openmodel1: function openmodel1() {
      this.largeModal = true;
      var _this = this;
      this.hasErrors.subcate = "";
      this.hasErrors.subcate1 = "";
      this.hasErrors.categoryopt = "";
      this.hasErrors.categoryopt2 = "";
      this.Productvalue = null;
      this.subcate.name = "";
      this.subcate.description = "";
    },
    openmodel: function openmodel() {
      var _this = this;
      this.loading = true;
      this.$http.get("/api/categories/chk_plan_count").then(function (response) {
        _this.loading = false;
        if ("message" in response.data) {
          if (response.data.message === false) {
            _this.largeModal1 = true;
            _this.plan_modal = false;
            _this.hasErrors.category = "";
            _this.hasErrors.categoryopt2 = "";
            _this.hasErrors.category1 = "";
            _this.category.name = "";
            _this.category.description = "";
          } else {
            _this.plan_modal = true;
          }
        } else {
          console.log("something went wrong");
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    editpro: function editpro(categorylistid) {
      this.warningModal = true;
      var _this = this;
      var id = categorylistid.id;
      this.hasErrors.category2 = "";
      this.hasErrors.category3 = "";
      this.category.name2 = categorylistid.category_name;
      this.category.description3 = categorylistid.category_desc;
      idup = categorylistid.category_id;
    },
    viewpro1: function viewpro1(subcategorylistid) {
      this.warningModal4 = true;
      this.selectCategory(subcategorylistid.category_id);
      this.subcate.name4 = subcategorylistid.sub_category_name;
      this.subcate.description4 = subcategorylistid.sub_category_desc;
    },
    editpro1: function editpro1(subcategorylistid) {
      this.warningModal2 = true;
      this.hasErrors.subcate2 = "";
      this.hasErrors.subcate3 = "";
      this.hasErrors.categoryopt = "";
      this.hasErrors.categoryopt2 = "";
      var _this = this;
      this.selectCategory(subcategorylistid.category_id);
      this.subcate.name3 = subcategorylistid.sub_category_name;
      this.subcate.description3 = subcategorylistid.sub_category_desc;
      idup = subcategorylistid.sub_category_id;
    },
    deletecategory: function deletecategory(cateid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        _this.loading = true;

        var id = cateid.id;
        this.$http.delete("/api/categories/" + id).then(function (response) {
          _this.loading = false;
          _this.getCategories();
          _this.subcatval();
          _this.categorylist();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    deletesubcate: function deletesubcate(subcateid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        _this.loading = true;

        var id = subcateid.id;
        this.$http.delete("/api/subcategories/" + id).then(function (response) {
          _this.loading = false;
          _this.subcatval();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    subcatval: function subcatval(val) {
      if (val === "comp") {
        if (this.sfrst_time === false) {
          this.sfrst_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.$http.get("/api/subcategories/showSubCategories?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        _this.totalRecords1 = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows1 = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    submodel1: function submodel1() {
      var _this = this;
      var submit_true = 0;
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      this.hasErrors.subcate2 = "";
      this.hasErrors.subcate3 = "";
      this.hasErrors.categoryopt = "";
      this.hasErrors.categoryopt2 = "";
      if (this.Productvalue1 == null) {
        _this.hasErrors.categoryopt2 = "Required";
        submit_true = 1;
      }

      if (this.subcate.name3 == "") {
        submit_true = 1;
        _this.hasErrors.subcate2 = "Required";
      } else if (this.subcate.name3.length > 100 || this.subcate.name3.length < 2) {
        submit_true = 1;
        _this.hasErrors.subcate2 = "Enter Maximum 100 and Minimum 2 characters";
      }

      if (this.subcate.description3 == "") {
        submit_true = 1;
        _this.hasErrors.subcate3 = "Required";
      }

      if (this.subcate.description3 != null) {
        if (this.subcate.description3.length > 100) {
          _this.hasErrors.subcate3 = "Maximum 100 characters allowed";
          submit_true = 1;
        }
      }

      if (submit_true == 0) {
        _this.loading = true;
        var subcate = {
          category_id: this.Productvalue1.category_id,
          sub_category_name: this.subcate.name3,
          sub_category_desc: this.subcate.description3
        };
        this.$http.post("/api/subcategories/update?where[id]=" + idup, subcate).then(function (response) {
          _this.loading = false;
          _this.warningModal2 = false;
          _this.hasErrors.message = true;
          _this.errorMessage.message = "Subcategory Updated Successfully";
          setTimeout(function () {
            _this.errorMessage.message = "";
            _this.hasErrors.message = false;
          }, 4000);
          _this.subcatval();
        }).catch(function (error) {
          _this.loading = false;
        });
      }
    },
    submodel: function submodel() {
      var _this = this;
      var submit_true = 0;
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      var submit_true = 0;
      _this.hasErrors.category2 = "";
      if (this.category.name2 == "") {
        submit_true = 1;
        _this.hasErrors.category2 = "Required";
      }
      if (_this.category.name2.length > 100 || _this.category.name2.length < 2) {
        submit_true = 1;
        _this.hasErrors.category2 = "Enter Maximum 100 and Minimum 2 Chracters";
      }
      if (this.category.description3.length > 100) {
        _this.hasErrors.category3 = "Enter Maximum 100 characters";
        submit_true = 1;
      }
      if (this.category.description3 == "") {
        _this.hasErrors.category3 = "Required";
        submit_true = 1;
      }
      if (submit_true == 0) {
        this.loading = true;
        this.hasErrors.category2 = false;
        this.hasErrors.category3 = false;
        var category = {
          category_name: this.category.name2.trim(),
          category_desc: this.category.description3.trim()
        };
        this.$http.post("/api/categories/update?where[id]=" + idup, category).then(function (response) {
          _this.loading = false;
          _this.warningModal = false;
          _this.hasErrors.message1 = true;
          _this.getCategories();
          _this.categorylist();
          _this.errorMessage.message1 = "Category Updated Successfully";
          setTimeout(function () {
            _this.errorMessage.message1 = "";
            _this.hasErrors.message1 = false;
          }, 4000);
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    getCategories: function getCategories(val) {
      if (val === "comp") {
        if (this.cfrst_time === false) {
          this.cfrst_time = true;
        } else {
          return;
        }
      }

      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.$http.get("/api/categories/showCategories?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    Submit: function Submit() {
      var _this = this;
      this.hasErrors.category = "";
      this.hasErrors.category1 = "";
      var submit_true = 0;
      _this.category.name = _this.category.name.trim();
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      if (_this.category.name.length > 100 || _this.category.name.length < 2) {
        submit_true = 1;
        _this.hasErrors.category = "Enter Maximum 100 and Minimum 2 characters";
      }
      if (_this.category.name == "") {
        _this.hasErrors.category = "Required";
        submit_true = 1;
      }
      if (_this.category.description == "") {
        _this.hasErrors.category1 = "Required";
        submit_true = 1;
      }
      if (this.category.description.length > 100) {
        _this.hasErrors.category1 = "Enter Maximum 100 characters allowed";
        submit_true = 1;
      }
      if (submit_true == 0) {
        this.loading = true;
        this.hasErrors.category = false;
        this.hasErrors.category1 = false;
        var category = {
          category_name: this.category.name.trim(),
          category_desc: this.category.description
        };
        this.$http.post("/api/categories", category).then(function (response) {
          _this.loading = false;
          _this.hasErrors.message1 = true;
          _this.errorMessage.message1 = "Category Added Successfully";
          setTimeout(function () {
            _this.errorMessage.message1 = "";
            _this.hasErrors.message1 = false;
          }, 4000);
          _this.largeModal1 = false;
          _this.reset();
          _this.getCategories();
          _this.categorylist();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error.response);
        });
      }
    },
    Save: function Save() {
      var _this = this;
      var submit_true = 0;
      var nrex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      _this.hasErrors.subcate = "";
      _this.hasErrors.subcate1 = "";

      if (this.Productvalue == null) {
        _this.hasErrors.categoryopt = "Please Select Category";
        submit_true = 1;
      }

      if (_this.subcate.name == "") {
        submit_true = 1;
        _this.hasErrors.subcate = "Required";
      } else {
        if (_this.subcate.name.length > 100 || _this.subcate.name.length < 2) {
          submit_true = 1;
          _this.hasErrors.subcate = "Enter Maximum 100 characters and Minimum 2 Characters";
        }
      }

      if (_this.subcate.description == "") {
        submit_true = 1;
        _this.hasErrors.subcate1 = "Required";
      } else {
        if (this.subcate.description.length > 100) {
          _this.hasErrors.subcate1 = "Enter Maximum 100 characters";
          submit_true = 1;
        }
      }

      if (submit_true == 0) {
        this.loading = true;
        var subcate = {
          category_id: this.Productvalue.category_id,
          sub_category_name: this.subcate.name,
          sub_category_desc: this.subcate.description
        };
        this.$http.post("/api/subcategories", subcate).then(function (response) {
          _this.loading = false;
          _this.hasErrors.message = true;
          _this.errorMessage.message = "Subcategory Added Successfully";
          setTimeout(function () {
            _this.errorMessage.message = "";
            _this.hasErrors.message = false;
          }, 4000);
          _this.largeModal = false;
          _this.reset();
          _this.subcatval();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error.response);
        });
      }
    },
    reset: function reset() {
      var _this = this;
      _this.category.name = "";
      _this.Productvalue = null;
      _this.category.description = "";
      _this.subcate.name = "";
      _this.subcate.description = "";
    }
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);





var idup = '';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      is_admin: false,
      shpfrst_time: false,
      tfrst_time: false,
      access_token: null,
      submit_edi: 0,
      submit_true: 0,
      largeModal: false,
      warningModal: false,
      warningModal2: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      brandData: {
        brandname: '',
        desc: '',
        brandname1: '',
        brandname12: '',
        desc12: '',
        desc1: '',
        message: '',
        image1: null,
        image1_href: ''

      },
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      maximumSize: 500000,
      hasErrors: {
        brandname: false,
        message: false,
        branddsc1: false,
        brandnm: false,
        branddsc: false,
        brandlogo: false,
        brandnm1: false,
        brandnm12: false,
        branddsc12: false,
        brandlogo1: false

      },
      errorMessage: {
        brandname: null,
        message: '',
        brandlogo: null,
        brandlogo1: null
      },
      columns: [{
        label: 'Brand Name',
        field: 'brand_name',
        width: '40% !important'
      }, {
        label: 'Brand Description',
        field: 'brand_desc',
        width: '50% !important',
        html: false
      }, {
        label: 'Action',
        field: 'action',
        width: '10% !important'
      }],
      rows: []
    };
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getTotals();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getTotals();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getTotals();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getTotals();
    },
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    addbrand: function addbrand() {
      this.hasErrors.brandnm = false;
      this.hasErrors.branddsc = false;
      this.hasErrors.brandlogo = false;
      this.largeModal = true;
    },
    editpro: function editpro(brandlistid) {
      this.hasErrors.brandnm1 = false;
      this.hasErrors.branddsc1 = false;
      this.warningModal = true;
      var _this = this;
      this.brandData.desc1 = brandlistid.brand_desc;
      this.brandData.brandname1 = brandlistid.brand_name;
      idup = brandlistid.brand_id;
      this.brandData.image1 = brandlistid.brand_logo;
      this.brandData.image1_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + brandlistid.brand_logo + this.access_token;
    },
    viewbrand: function viewbrand(brandlistid) {
      this.warningModal2 = true;
      this.brandData.desc1 = brandlistid.brand_desc;
      this.brandData.brandname1 = brandlistid.brand_name;
      this.brandData.image1 = brandlistid.brand_logo;
      this.brandData.image1_href = this.$http.defaults.baseURL + '/api/containers/pics/download/' + brandlistid.brand_logo + this.access_token;
    },
    image1: function image1(callback) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      if (this.brandData.image1 != null) {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.brandData.image1);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.brandData.image1;
        }
      } else {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    deletebrand: function deletebrand(brandid) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        this.loading = true;
        var _this = this;
        var _vm = this.errorMessage;
        var id = brandid.id;
        this.$http.delete('/api/brands/' + id).then(function (response) {
          _this.loading = false;
          _vm.message = "Brand Deleted Successfully";
          setTimeout(function () {
            _vm.message = '';
          }, 2000);
          _this.getTotals();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    test: function test() {
      var fileInput = document.querySelector('#image');
      var formData = new FormData();
      formData.append('image', fileInput.files[0]);
      return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
        return response.data.result.files.image[0].name;
      }).catch(function (error) {
        console.log(error);
      });
    },
    chkBrandExist: function chkBrandExist() {
      var _this = this;
      this.brandData.brandname = this.brandData.brandname.trim();
      if (this.brandData.brandname != '') {
        this.$http.get('/api/brands/chk_brand_exist?filter[where][brand_name]=' + this.brandData.brandname).then(function (response) {
          if (response.data.length > 0) {
            _this.brandData.brandname = '';
            _this.hasErrors.brandnm = 'Brand name already exist';
            _this.$refs['txtbrandname'].focus();
          } else {
            _this.hasErrors.brandnm = false;
          }
        }).catch(function (error) {
          _this.hasErrors.brandnm = false;
        });
      } else {
        _this.hasErrors.brandnm = false;
      }
    },
    brandPost: function brandPost() {
      var _this = this;
      this.submit_true = 0;
      this.onComplete('check');

      var formData = new FormData();
      _this.hasErrors.brandlogo = false;
      var fileInput = document.querySelector('#image');

      if (fileInput.files[0] != undefined) {
        if (fileInput.files[0].size > this.maximumSize) {
          this.hasErrors.brandlogo = true;
          this.errorMessage.brandlogo = "Image Size Cannot Be Greater Than 500kb";
          this.submit_true = 1;
        }
        if (this.allowableTypes.indexOf(fileInput.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.brandlogo = true;
          this.errorMessage.brandlogo = "Invalid Image Type";
          this.submit_true = 1;
        }
      }

      if (this.submit_true == 0) {
        this.loading = true;
        this.largeModal = false;

        if (fileInput.files[0] != undefined) {
          this.test().then(function (user) {
            _this.submitbrandvalue(_this, user);
          });
        } else {
          var user = null;
          _this.submitbrandvalue(_this, user);
        }
      }
    },
    submitbrandvalue: function submitbrandvalue(_this, user) {
      if (user != null) {
        var has_logo = 1;
      } else {
        var has_logo = 0;
      }
      var res = {
        brand_name: this.brandData.brandname.trim(),
        brand_desc: this.brandData.desc,
        brand_logo: user,
        has_logo: has_logo
      };

      this.$http.post('/api/brands', res).then(function (response) {

        if (response.status == 200) {
          _this.message = true;
          _this.message = "Brand Added Successfully";
          setTimeout(function () {
            _this.message = '';
          }, 2000);
          _this.loading = false;
          _this.getTotals();
          _this.reset();
        } else {
          console.log('error');
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    },
    submodel: function submodel() {
      var _this2 = this;

      var _this = this;
      this.submit_edi = 0;
      this.onComplete('check');
      this.hasErrors.brandlogo1 = false;
      this.errorMessage.brandlogo1 = '';
      var fileInput1 = document.querySelector('#image1');

      if (fileInput1.files[0] != undefined) {
        if (fileInput1.files[0].size > this.maximumSize) {
          this.hasErrors.brandlogo1 = true;
          this.errorMessage.brandlogo1 = "Image Size Cannot Be Greater Than 500kb";
          this.submit_edi = 1;
        }
        if (this.allowableTypes.indexOf(fileInput1.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.brandlogo1 = true;
          this.errorMessage.brandlogo1 = "Invalid Image Type";
          this.submit_edi = 1;
        }
      }
      if (this.submit_edi == 0) {
        _this.loading = true;
        _this.warningModal = false;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.image1()]).then(function (user) {
          if (user != null) {
            var has_logo = 1;
          } else {
            var has_logo = 0;
          }

          var res = {
            brand_name: _this2.brandData.brandname1.trim(),
            brand_desc: _this2.brandData.desc1.trim(),
            brand_logo: user,
            has_logo: has_logo
          };
          _this2.$http.post('/api/brands/update?where[id]=' + idup, res).then(function (response) {

            if (response.status === 200) {
              _this.message = true;
              _this.message = "Brand Updated Successfully";
              setTimeout(function () {
                _this.message = '';
              }, 2000);
              _this.loading = false;
              _this.reset();
              _this.getTotals();
            } else {
              console.log('error');
            }
          }).catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
        });
      }
    },
    reset: function reset() {
      var _this = this;
      _this.brandData.brandname = '';
      _this.brandData.desc = '';
      var input = document.querySelector('#image');
      input.type = 'text';
      input.type = 'file';
    },
    getTotals: function getTotals(val) {
      if (val === 'comp') {
        if (this.tfrst_time === false) {
          this.tfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.brandData.brandname12 = this.brandData.brandname12.trim();
      this.brandData.desc12 = this.brandData.desc12.trim();
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = [];
      this.rows = [];
      if (this.brandData.brandname12 != '') {
        data = data + "&filter[where][brand_name][ilike]=%" + this.brandData.brandname12 + "%";
      }
      if (this.brandData.desc12 != '') {
        data = data + "&filter[where][brand_desc][ilike]=%" + this.brandData.desc12 + "%";
      }
      this.loading = true;
      this.$http.get('/api/brands/showBrands?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    onComplete: function onComplete(value) {
      this.hasErrors.brandnm = '';
      this.hasErrors.branddsc = '';
      this.hasErrors.brandnm1 = '';
      this.hasErrors.branddsc1 = '';
      this.brandData.brandname = this.brandData.brandname;
      this.brandData.desc = this.brandData.desc;
      if (value === 'bname' || value === 'check') {
        if (this.brandData.brandname == '' || this.brandData.brandname == '') {
          this.hasErrors.brandnm = 'Required';
          this.submit_true = 1;
        } else if (this.brandData.brandname.length > 100) {
          this.hasErrors.brandnm = 'Maximum 100 characters';
          this.submit_true = 1;
        } else if (this.brandData.brandname.length < 2) {
          this.hasErrors.brandnm = 'Minimum 2 characters';
          this.submit_true = 1;
        } else {
          this.hasErrors.brandnm = '';
        }
      }

      if (value === 'bdesc' || value === 'check') {
        if (this.brandData.desc.length > 500) {
          this.hasErrors.branddsc = 'Maximum 500 characters';
          this.submit_true = 1;
        } else if (this.brandData.desc.length < 2) {
          this.hasErrors.branddsc = 'Minimum 2 characters';
          this.submit_true = 1;
        } else {
          this.hasErrors.branddsc = '';
        }
      }

      this.brandData.brandname1 = this.brandData.brandname1;
      this.brandData.desc1 = this.brandData.desc1;
      if (value === 'editbname' || value === 'check') {
        if (this.brandData.brandname1 == '') {
          this.hasErrors.brandnm1 = 'Required';
          this.submit_edi = 1;
        } else if (this.brandData.brandname1.length > 100) {
          this.hasErrors.brandnm1 = 'Maximum 100 characters';
          this.submit_edi = 1;
        } else if (this.brandData.brandname1.length < 2) {
          this.hasErrors.brandnm1 = 'Minimum 2 characters';
          this.submit_edi = 1;
        } else {
          this.hasErrors.brandnm1 = '';
        }
      }

      if (value === 'editbdesc' || value === 'check') {
        if (this.brandData.desc1.length > 500) {
          this.hasErrors.branddsc1 = 'Maximum 500 characters';
          this.submit_edi = 1;
        } else if (this.brandData.desc1.length < 2) {
          this.hasErrors.branddsc1 = 'Minimum 2 characters';
          this.submit_edi = 1;
        } else {
          this.hasErrors.branddsc1 = '';
        }
      }
    }
  },
  computed: {
    brand_view: function brand_view() {
      if (this.$store.getters.get_brand_view === true) {
        this.shopuser('comp');
        this.getTotals('comp');
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    brand_rights: function brand_rights() {
      return this.$store.getters.get_brand_rights;
    }
  },
  created: function created() {
    if (localStorage.authUser != null) {
      this.access_token = '?access_token=' + localStorage.authUser;
    }
  }

});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HSN',
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      is_admin: false,
      shpfrst_time: false,
      hfrst_time: false,
      sfrst_time: false,
      hide: false,
      warningModal: false,
      warningModal1: false,
      loading: false,
      hsnid: '',
      hsncode: '',
      hsndsc: '',
      hsnided: '',
      selectedtax1: null,
      selectedtax2: null,
      taxlist1: [],
      taxlist2: [],
      hsncodeed: '',
      hsndsced: '',
      taxed: '',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      rows: [],
      error: {
        errorhsn: false,
        errortx: false,
        errorhsncd: false,
        errordes: false,
        errorhsned: false,
        errortxed: false,
        errorhsncded: false,
        errordesed: false
      },
      message: {
        sucess: ''
      }
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    hsnLabel: function hsnLabel() {
      return this.companyTaxType === 'US' ? 'US Code' : 'HSN';
    },
    hsnCodeLabel: function hsnCodeLabel() {
      return this.companyTaxType === 'US' ? 'US Code' : 'HSN Code';
    },
    columns: function columns() {
      return [{ label: this.hsnCodeLabel, field: 'hsn_code', width: '20% !important' }, { label: 'Chapter Code', field: 'chapter_code', width: '15% !important' }, { label: this.hsnLabel + ' Description', field: 'hsn_desc', width: '45% !important' }, { label: 'Action', field: 'action', width: '20% !important' }];
    },

    hsn_view: function hsn_view() {
      if (this.$store.getters.get_hsn_view === true) {
        this.shopuser('comp');
        this.getselect('comp');
        this.gethsn('comp');
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    hsn_rights: function hsn_rights() {
      return this.$store.getters.get_hsn_rights;
    }
  },


  methods: {
    chkExist: function chkExist() {
      var number = /^[0-9]{1,10}$/;
      this.hsnid = this.hsnid.trim();
      if (this.hsnid !== '') {
        if (number.test(this.hsnid) == false) {
          this.error.errorhsn = "Enter numeric value";
        } else {
          var _this = this;
          this.$http.get('/api/hsns/chk_exist?filter[where][hsncode]=' + this.hsnid).then(function (response) {
            if (response.data.length > 0) {
              _this.hsnid = '';
              _this.error.errorhsn = _this.hsnCodeLabel + ' already exist';
              _this.$refs["txthsnid"].focus();
            } else {
              _this.error.errorhsn = false;
            }
          }).catch(function (error) {
            _this.error.errorhsn = false;
          });
        }
      } else {
        this.error.errorhsn = false;
      }
    },
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.gethsn();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.gethsn();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.gethsn();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.gethsn();
    },
    getselect: function getselect(val) {
      if (val === 'comp') {
        if (this.sfrst_time === false) {
          this.sfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/taxrates').then(function (response) {
        _this.taxlist1 = response.data;
        _this.taxlist2 = response.data;
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    gethsn: function gethsn(val) {
      if (val === 'comp') {
        if (this.hfrst_time === false) {
          this.hfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.loading = true;
      this.$http.get('/api/hsns?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error.response);
        _this.message.sucess = "SomeThing Went Wrong";
      });
    },
    savehsn: function savehsn() {
      var _this = this;
      var submit = this.validation();
      if (submit == 0) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading = true;
        this.error.errorhsn = false;
        this.error.errortx = false;
        this.error.errorhsncd = false;
        this.error.errordes = false;
        _this.warningModal = false;
        var data = {
          hsn_code: this.hsnid,
          tax_id: this.selectedtax2.tax_id,
          chapter_code: this.hsncode,
          hsn_desc: this.hsndsc
        };
        this.$http.post('/api/hsns', data).then(function (response) {
          _this.loading = false;
          _this.message.sucess = _this.hsnLabel + " Added Successfully";
          setTimeout(function () {
            _this.message.sucess = false;
          }, 2000);
          _this.gethsn();
          _this.reset();
        }).catch(function (error) {
          console.log(error.response);
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    savehsned: function savehsned() {
      var _this = this;
      var submit = this.validationed();
      if (submit == 0) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading = true;

        _this.warningModal = false;
        var data = {
          hsn_code: this.hsnided,
          tax_id: this.selectedtax1,
          chapter_code: this.hsncodeed,
          hsn_desc: this.hsndsced
        };
        this.$http.post('/api/hsns/update?where[id]=' + this.taxed, data).then(function (response) {
          _this.loading = false;
          _this.message.sucess = _this.hsnLabel + " updated Successfully";
          setTimeout(function () {
            _this.message.sucess = false;
          }, 2000);
          _this.gethsn();
          _this.reset();
        }).catch(function (error) {
          console.log(error.response);
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    edithsn: function edithsn(val) {
      this.error.errorhsn = false;
      this.error.errortx = false;
      this.error.errorhsncd = false;
      this.error.errordes = false;
      this.warningModal = true;
      this.taxed = val.hsn_id;
      this.hsnided = val.hsn_code;
      this.selectedtax1 = val.tax_id;
      this.hsncodeed = val.chapter_code;
      this.hsndsced = val.hsn_desc;
    },
    viewhsn: function viewhsn(val) {
      this.warningModal1 = true;
      this.taxed = val.hsn_id;
      this.hsnided = val.hsn_code;
      this.selectedtax1 = val.tax_id;
      this.hsncodeed = val.chapter_code;
      this.hsndsced = val.hsn_desc;
    },
    deletehsn: function deletehsn(val) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        this.loading = true;
        var _this = this;
        var id = val.id;
        this.$http.delete('/api/hsns/' + id).then(function (response) {
          _this.loading = false;
          _this.gethsn();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    validation: function validation() {
      var number = /^[0-9]{1,10}$/;
      var submit = 0;
      this.error.errorhsn = false;
      this.error.errortx = false;
      this.error.errordes = false;
      this.error.errorhsncd = false;

      if (this.selectedtax2 == undefined && this.selectedtax2 == '') {
        this.error.errortx = true;
        submit = 1;
      }
      if (this.selectedtax2 == null) {
        this.error.errortx = true;
        submit = 1;
      }
      if (this.hsndsc == '') {
        this.error.errordes = true;
        submit = 1;
      }
      if (number.test(this.hsncode) == false) {
        this.error.errorhsncd = true;
        submit = 1;
      }
      return submit;
    },
    validationed: function validationed() {
      this.error.errorhsned = false;
      this.error.errortxed = false;
      this.error.errorhsncded = false;
      this.error.errordesed = false;
      var number = /^[0-9]{1,10}$/;
      var submit = 0;
      if (number.test(this.hsnided) == false) {
        this.error.errorhsned = true;
        submit = 1;
      }
      if (this.selectedtax1 == null) {
        this.error.errortxed = true;
        submit = 1;
      }
      if (this.selectedtax1 == undefined && this.selectedtax1 == null) {
        this.error.errortxed = true;
        submit = 1;
      }
      if (number.test(this.hsncodeed) == false) {
        this.error.errorhsncded = true;
        submit = 1;
      }
      if (this.hsndsced == '') {
        this.error.errordesed = true;
        submit = 1;
      }
      return submit;
    },
    reset: function reset() {
      this.hsnid = '';
      this.selectedtax2 = null;
      this.hsncode = '';
      this.hsndsc = '';
    }
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hsnrate',
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      is_admin: false,
      shpfrst_time: false,
      rfrst_time: false,
      hide: false,
      idtax: '',
      warningModal: false,
      loading: false,
      taxname: '',
      taxsgst: '',
      taxcgst: '',
      taxigst: '',
      taxnameed: '',
      taxsgsted: '',
      taxcgsted: '',
      taxigsted: '',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      rows: [],
      error: {
        errorname: false,
        errorsgst: false,
        errorcgst: false,
        errorigst: false,
        errornameed: false,
        errorsgsted: false,
        errorcgsted: false,
        errorigsted: false

      },
      message: {
        sucess: ''

      }
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    },
    columns: function columns() {
      if (this.companyTaxType === 'US') {
        return [{ label: 'Tax Name', field: 'tax_name', width: '35% !important' }, { label: 'Sales Tax', field: 'tax_igst', width: '20% !important' }, { label: 'Action', field: 'action', width: '10% !important' }];
      }
      return [{ label: 'Tax Name', field: 'tax_name', width: '35% !important' }, { label: 'SGST', field: 'tax_sgst', width: '15% !important' }, { label: 'CGST', field: 'tax_cgst', width: '15% !important' }, { label: 'IGST', field: 'tax_igst', width: '15% !important' }, { label: 'Action', field: 'action', width: '10% !important' }];
    },

    tax_view: function tax_view() {
      if (this.$store.getters.get_tax_view === true) {
        this.shopuser('comp');
        this.getrate('comp');
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    tax_rights: function tax_rights() {
      return this.$store.getters.get_tax_rights;
    }
  },

  methods: {
    chkExist: function chkExist() {
      this.taxname = this.taxname.trim();
      if (this.taxname !== '') {
        var _this = this;
        this.$http.get('/api/taxrates/chk_exist?filter[where][taxname]=' + this.taxname).then(function (response) {
          if (response.data.length > 0) {
            _this.taxname = '';
            _this.error.errorname = 'Tax name already exist';
            _this.$refs["txttaxname"].focus();
          } else {
            _this.error.errorname = false;
          }
        }).catch(function (error) {
          _this.error.errorname = false;
        });
      } else {
        this.error.errorname = false;
      }
    },
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    getrate: function getrate(val) {
      if (val === 'comp') {
        if (this.rfrst_time === false) {
          this.rfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.loading = true;
      this.$http.get('/api/taxrates?params=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) {
          _this.rows = response.data;
          _this.loading = false;
        }
      }).catch(function (error) {
        _this.loading = false;
      });
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getrate();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getrate();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getrate();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getrate();
    },
    edithsnrate: function edithsnrate(val) {
      this.warningModal = true;
      this.idtax = val.tax_id;
      this.taxnameed = val.tax_name;
      this.taxcgsted = val.tax_cgst;
      this.taxsgsted = val.tax_sgst;
      this.taxigsted = val.tax_igst;
    },
    deletehsnrate: function deletehsnrate(val) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        this.loading = true;
        var _this = this;
        var id = val.id;
        this.$http.delete('/api/taxrates/' + id).then(function (response) {
          _this.loading = false;
          _this.getrate();
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    savehsnrate: function savehsnrate() {
      var _this = this;
      var submit = this.validation();
      if (submit == 0) {

        this.loading = true;
        this.error.errorname = '';
        this.error.errorsgst = '';
        this.error.errorcgst = '';
        this.error.errorigst = '';

        var data;
        if (this.companyTaxType === 'US') {
          var salesTax = parseFloat(this.taxigst) || 0;
          var splitTax = salesTax / 2;
          data = {
            tax_name: this.taxname,
            tax_cgst: splitTax,
            tax_sgst: splitTax,
            tax_igst: this.taxigst
          };
        } else {
          data = {
            tax_name: this.taxname,
            tax_cgst: this.taxcgst,
            tax_sgst: this.taxsgst,
            tax_igst: this.taxigst
          };
        }
        this.$http.post('/api/taxrates', data).then(function (response) {
          _this.loading = false;
          _this.message.sucess = "Tax Added Successfully";
          setTimeout(function () {
            _this.message.sucess = false;
          }, 2000);
          _this.getrate();
          _this.reset();
        }).catch(function (error) {
          console.log(error.response);
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    savehsnrateed: function savehsnrateed() {

      var _this = this;
      var submit = this.validationed();
      if (submit == 0) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        this.loading = true;
        this.error.errorsgst = false;
        this.error.errorcgst = false;
        this.error.errorigst = false;
        _this.warningModal = false;

        var data;
        if (this.companyTaxType === 'US') {
          var salesTax = parseFloat(this.taxigsted) || 0;
          var splitTax = salesTax / 2;
          data = {
            tax_name: this.taxnameed,
            tax_cgst: splitTax,
            tax_sgst: splitTax,
            tax_igst: this.taxigsted
          };
        } else {
          data = {
            tax_name: this.taxnameed,
            tax_cgst: this.taxcgsted,
            tax_sgst: this.taxsgsted,
            tax_igst: this.taxigsted
          };
        }

        this.$http.post('/api/taxrates/update?where[id]=' + this.idtax, data).then(function (response) {
          _this.loading = false;
          _this.message.sucess = "Tax Updated Successfully";
          setTimeout(function () {
            _this.message.sucess = false;
          }, 2000);
          _this.getrate();
          _this.reset();
        }).catch(function (error) {
          console.log(error.response);
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    validation: function validation() {
      var exp = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var submit = 0;
      this.error.errorname = '';
      this.error.errorcgst = '';
      this.error.errorsgst = '';
      this.error.errorigst = '';

      if (this.taxname == '') {
        this.error.errorname = "Required ";
        submit = 1;
      } else if (this.taxname.length > 20) {
        this.error.errorname = "Enter maximum 20 characters";
        submit = 1;
      }

      if (this.companyTaxType === 'US') {
        if (this.taxigst == '') {
          this.error.errorigst = "Required";
          submit = 1;
        } else if (exp.test(this.taxigst) == false) {
          this.error.errorigst = "Enter Valid Tax";
          submit = 1;
        } else if (parseFloat(this.taxigst) > 50) {
          this.error.errorigst = "Maximum 50%";
          submit = 1;
        }
      } else {
        if (this.taxcgst == '') {
          this.error.errorcgst = "Required";
          submit = 1;
        } else if (exp.test(this.taxcgst) == false) {
          this.error.errorcgst = "Enter Valid Tax";
          submit = 1;
        } else if (this.taxcgst > 50) {
          submit = 1;
          this.error.errorcgst = "Maximum 50%";
        }

        if (this.taxsgst == '') {
          this.error.errorsgst = "Required";
          submit = 1;
        } else if (exp.test(this.taxsgst) == false) {
          this.error.errorsgst = "Enter Valid Tax";
          submit = 1;
        } else if (this.taxsgst > 50) {
          submit = 1;
          this.error.errorsgst = "Maximum 50%";
        }

        if (this.taxigst == '') {
          this.error.errorigst = "Required";
          submit = 1;
        } else if (igstexp.test(this.taxigst) == false) {
          this.error.errorigst = "Enter Valid Tax";
          submit = 1;
        }
        if (this.taxigst > 100) {
          this.error.errorigst = "Maximum 100%";
          submit = 1;
        }
      }
      return submit;
    },
    validationed: function validationed() {
      var exp = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/;
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/;
      var submit = 0;
      this.error.errornameed = '';
      this.error.errorcgsted = '';
      this.error.errorsgsted = '';
      this.error.errorigsted = '';

      if (this.taxnameed == '') {
        this.error.errornameed = "Required ";
        submit = 1;
      }
      if (this.taxnameed.length > 20) {
        this.error.errornameed = "Maximum 20 characters";
        submit = 1;
      }

      if (this.companyTaxType === 'US') {
        if (this.taxigsted == '') {
          this.error.errorigsted = "Required";
          submit = 1;
        } else if (exp.test(this.taxigsted) == false) {
          if (parseFloat(this.taxigsted) > 50) {
            this.error.errorigsted = "Maximum 50%";
          } else {
            this.error.errorigsted = "Enter Valid Tax";
          }
          submit = 1;
        }
      } else {
        if (exp.test(this.taxcgsted) == false) {
          if (this.taxcgsted > 50) {
            this.error.errorcgsted = "Maximum 50%";
          } else {
            this.error.errorcgsted = "Enter Valid Tax";
          }

          submit = 1;
        }
        if (this.taxcgsted == '') {
          this.error.errorcgsted = "Required";
          submit = 1;
        }

        if (exp.test(this.taxsgsted) == false) {
          if (this.taxsgsted > 50) {
            this.error.errorsgsted = "Maximum 50%";
          } else {
            this.error.errorsgsted = "Enter Valid Tax";
          }

          submit = 1;
        }
        if (this.taxsgsted == '') {
          this.error.errorsgsted = "Required";
          submit = 1;
        }

        if (igstexp.test(this.taxigsted) == false) {
          if (this.taxigsted > 100) {
            this.error.errorigsted = "Maximum 100%";
          } else {
            this.error.errorigsted = "Enter Valid Tax";
          }

          submit = 1;
        }
        if (this.taxigsted == '') {
          this.error.errorigsted = "Required";
          submit = 1;
        }
      }
      return submit;
    },
    reset: function reset() {
      this.taxname = '';
      this.taxsgst = '';
      this.taxcgst = '';
      this.taxigst = '';
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Variant',
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      is_admin: false,
      shpfrst_time: false,
      vfrst_time: false,
      hide: false,
      vnaddvalueed: '',
      editmodel: false,
      vnaddvalue: '',
      largeModal1: false,
      largeModal: false,
      loading: false,
      vnname: '',
      search_varname: '',
      vnvalue: '',
      vnidsearch: '',
      variantname: '',
      variantid: '',
      editvalue: '',
      vnnameed: '',
      varianteditid: '',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      totalRecords1: 0,
      columns: [{
        label: 'Variant Name',
        field: 'variant_name1',
        width: '60% !important'
      }, {
        label: 'Variant Value',
        field: 'viewdtl',
        width: '30% !important'
      }, {
        label: 'Action',
        field: 'action',
        width: '10% !important'
      }],
      columns1: [{
        label: 'Variant Value',
        field: 'viewdtl',
        width: '90% !important'
      }, {
        label: 'Action',
        field: 'action',
        width: '10% !important'
      }],
      rows: [],
      rows1: [],
      error: {
        errorname: false,
        errorided: '',
        errornameed: '',
        errorvalue: false
      },
      message: {
        sucess: '',
        sucess1: ''
      }
    };
  },

  computed: {
    var_view: function var_view() {
      if (this.$store.getters.get_var_view === true) {
        this.shopuser('comp');
        this.getvariant('comp');
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    var_rights: function var_rights() {
      return this.$store.getters.get_var_rights;
    }
  },

  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getvariant();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getvariant();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getvariant();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getvariant();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.getvariantvalue();
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.getvariantvalue();
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field
        }, page: 1
      });
      this.getvariantvalue();
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.getvariantvalue();
    },
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    viewvalue: function viewvalue(data) {
      this.message.sucess1 = '';
      this.largeModal1 = true;
      this.variantname = data.variant_name;
      this.variantid = data.variant_id;
      this.getvariantvalue();
    },
    editvnvalue: function editvnvalue(data) {
      this.editvalue = data.id;
      this.vnaddvalueed = data.variant_value;
    },
    deletevnvalue: function deletevnvalue(data) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        this.loading = true;
        this.$http.delete('/api/variantvalues/' + data.id).then(function (response) {
          _this.loading = false;
          _this.getvariantvalue();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    addVariant: function addVariant() {
      this.vnname = '';
      this.error.errorname = false;
      this.largeModal = true;
    },
    saveedvalue: function saveedvalue(data1) {
      var _this = this;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      if (this.vnaddvalueed == '') {} else {
        this.loading = true;
        var data = {
          variant_value: this.vnaddvalueed
        };
        this.$http.post('/api/variantvalues/update?where[id]=' + data1.id, data).then(function (response) {
          _this.loading = false;
          _this.message.sucess1 = "Variant Value Updated Successfully";
          setTimeout(function () {
            _this.message.sucess = false;
          }, 3000);
          _this.getvariantvalue();
          _this.editvalue = '';
        }).catch(function (error) {
          _this.loading = false;
          _this.message.sucess1 = "SomeThing Went Wrong";
        });
      }
    },
    editvn: function editvn(data) {
      this.editmodel = true;
      this.vnnameed = data.variant_name;
      this.varianteditid = data.variant_id;
    },
    editvariantvalue: function editvariantvalue(data1) {
      var _this = this;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var data = { variant_name: this.vnnameed };
      if (this.vnnameed == '') {} else {
        this.loading = true;
        this.$http.post('/api/variants/update?where[variant_id]=' + data1.variant_id, data).then(function (response) {
          _this.loading = false;
          _this.message.sucess = "Variant Updated Successfully";
          setTimeout(function () {
            _this.message.sucess = false;
          }, 3000);
          _this.getvariant();
          _this.varianteditid = '';
        }).catch(function (error) {
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    getvariantvalue: function getvariantvalue() {
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.$http.get('/api/variantvalues?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + '&filter[where][variant_id]=' + _this.variantid).then(function (response) {
        _this.totalRecords1 = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows1 = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getvariant: function getvariant(val) {
      if (val === 'comp') {
        if (this.vfrst_time === false) {
          this.vfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var filteParam = {};
      var data = '';
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var api = '';
      if (this.search_varname != '') {
        api = '/api/variants/showVariants?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + '&filter[where][variant_name][ilike]=%' + this.search_varname + '%';
      } else {
        api = '/api/variants?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam);
      }
      this.loading = true;
      this.$http.get(api).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    },
    deletevn: function deletevn(val) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        var id = val.id;
        this.loading = true;
        this.$http.delete('/api/variants/' + id).then(function (response) {
          _this.loading = false;
          _this.getvariant();
        }).catch(function (error) {});
      }
    },
    savevn: function savevn() {
      this.vnname = this.vnname.trim();
      if (this.vnname == '') {
        this.error.errorname = 'Required';
      } else {
        var _this = this;
        this.loading = true;
        this.$http.get('/api/variants/chk_exist?filter[where][variant_name]=' + this.vnname).then(function (response) {
          if (response.data.length > 0) {
            _this.loading = false;
            _this.vnname = '';
            _this.error.errorname = 'Variant name already exist';
            _this.$refs['txtvnname'].focus();
          } else {
            _this.error.errorname = false;
            _this.largeModal = false;
            var data = {
              variant_name: _this.vnname
            };
            var __this = _this;
            _this.$http.post('/api/variants', data).then(function (response) {
              __this.loading = false;
              __this.message.sucess = "Variant Added Successfully";
              setTimeout(function () {
                __this.message.sucess = false;
              }, 2000);
              __this.getvariant();
            }).catch(function (error) {
              __this.loading = false;
              __this.message.sucess = "SomeThing Went Wrong";
            });
          }
        }).catch(function (error) {
          _this.error.errorname = false;
        });
      }
    },
    addvalue: function addvalue() {
      this.error.errorvalue = false;
      if (this.vnaddvalue == '') {
        this.error.errorvalue = 'Required';
      } else {
        var _this = this;
        this.loading = true;
        this.$http.get('/api/variantvalues/chk_exist?filter[where][variant_value]=' + this.vnaddvalue + '&filter[where][variant_id]=' + this.variantid).then(function (response) {
          if (response.data.length > 0) {
            _this.loading = false;
            _this.vnaddvalue = '';
            _this.error.errorvalue = 'Variant value already exist';
            _this.$refs['txtvnvalue'].focus();
          } else {
            _this.error.errorvalue = false;

            var __this = _this;
            var data = { variant_id: _this.variantid, variant_value: _this.vnaddvalue };
            _this.$http.post('/api/variantvalues', data).then(function (response) {
              __this.loading = false;
              __this.message.sucess1 = "Variant Value Added Successfully";
              setTimeout(function () {
                _this.message.sucess1 = false;
              }, 2000);
              __this.getvariantvalue();
              __this.vnaddvalue = '';
            }).catch(function (error) {
              __this.loading = false;
              __this.message.sucess1 = "SomeThing Went Wrong";
            });
          }
        }).catch(function (error) {
          _this.error.errorvalue = false;
        });
      }
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'unit',
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */] },

  data: function data() {
    var _ref;

    return _ref = {
      is_admin: false,
      shpfrst_time: false,
      ufrst_time: false,
      hide: false,
      largeModal: false,
      largeModal1: false,
      editBtn: false,
      saveBtn: true,
      loading: false,
      unit_name1: '',
      unit_desc1: '',
      unit_name2: '',
      unit_desc2: '',
      unit_id: '',
      submit_true: true,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 5
      },
      columns: [{
        label: 'Unit Name',
        field: 'unit_name',
        width: '30% !important'
      }, {
        label: 'Unit Description',
        field: 'unit_desc',
        width: '60% !important'
      }, {
        label: 'Action',
        field: 'action',
        width: '10% !important'
      }],
      rows: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'submit_true', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'message', {
      success: '',
      unit_name1: '',
      unit_desc1: '',
      unit_name2: '',
      unit_desc2: ''
    }), _ref;
  },

  computed: {
    unit_view: function unit_view() {
      if (this.$store.getters.get_unit_view === true) {
        this.shopuser('comp');
        this.getunit('comp');
        this.is_admin = this.$store.getters.get_is_admin;
        return true;
      } else {
        return false;
      }
    },
    unit_rights: function unit_rights() {
      return this.$store.getters.get_unit_rights;
    }
  },


  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getunit();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getunit();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }, page: 1
      });
      this.getunit();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getunit();
    },
    shopuser: function shopuser(val) {
      if (val === 'comp') {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    chkExist: function chkExist() {
      var _this = this;
      this.unit_name1 = this.unit_name1.trim();
      if (this.unit_name1 != '') {
        this.$http.get('/api/unittypes/chk_exist?filter[where][unit_name]=' + this.unit_name1).then(function (response) {
          if (response.data.length > 0) {
            _this.unit_name1 = '';
            _this.message.unit_name1 = 'Unit name already exist';
            _this.$refs['txtunitname'].focus();
          } else {
            _this.message.unit_name1 = false;
          }
        }).catch(function (error) {
          _this.message.unit_name1 = false;
        });
      } else {
        _this.message.unit_name1 = false;
      }
    },
    getunit: function getunit(val) {
      this.loading = true;
      if (val === 'comp') {
        if (this.ufrst_time === false) {
          this.ufrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.$http.get('/api/unittypes?params=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam)).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data != undefined) _this.rows = response.data;
        _this.loading = false;
      }).catch(function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    deleteunit: function deleteunit(data) {
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this;
        _this.loading = true;
        this.$http.delete('/api/unittypes/' + data.id).then(function (response) {
          _this.loading = false;
          _this.message.success = "Unit Deleted Successfully";
          setTimeout(function () {
            _this.message.success = false;
          }, 4000);
          _this.getunit();
        }).catch(function (error) {
          _this.loading = false;
          _this.message.success = "Something Went Wrong";
          setTimeout(function () {
            _this.message.success = false;
          }, 4000);
          console.log(error.response);
        });
      }
    },
    editunit: function editunit(data) {
      this.largeModal = true;
      this.saveBtn = false;
      this.editBtn = true;
      this.message.unit_name1 = '';
      this.message.unit_desc1 = '';
      this.unit_name1 = data.unit_name;
      this.unit_desc1 = data.unit_desc;
      this.unit_id = data.unit_id;
    },
    edit: function edit() {
      var _this = this;
      this.submit_true = 0;
      this.onComplete('check');

      if (this.submit_true == 0) {
        _this.largeModal = false, _this.loading = true;
        var data1 = {
          unit_name: this.unit_name1,
          unit_desc: this.unit_desc1
        };
        this.$http.post('/api/unittypes/update?where[id]=' + _this.unit_id, data1).then(function (response) {
          _this.loading = false;
          _this.message.success = "Unit Updated SuccessFully";
          setTimeout(function () {
            _this.message.success = false;
          }, 4000);
          _this.getunit();
          _this.reset();
        }).catch(function (error) {
          console.log(error.response);
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    openmodel: function openmodel() {

      this.largeModal = true;
      this.saveBtn = true;
      this.editBtn = false;
      var _this = this;
      _this.unit_name1 = '';
      _this.unit_desc1 = '';
      _this.message.unit_desc1 = '';
      _this.message.unit_name1 = '';
    },
    onComplete: function onComplete(value) {
      var unameregex = /^[A-Za-z]+$/;
      var udescregex = /^[-_a-zA-Z0-9.]+$/;

      this.message.unit_desc1 = '';
      if (value === 'uname' || value === 'check') {
        if (this.unit_name1 == '') {
          this.message.unit_name1 = 'Required';
          this.submit_true = 1;
        } else if (this.unit_name1.length < 1) {
          this.message.unit_name1 = 'Minimum 1 characters';
          this.submit_true = 1;
        } else if (this.unit_name1.length > 30) {
          this.message.unit_name1 = 'Maximum 30 characters';
          this.submit_true = 1;
        } else if (unameregex.test(this.unit_name1) == false) {
          this.message.unit_name1 = 'Enter Valid Unit Name';
          this.submit_true = 1;
        } else {
          this.chkExist();
        }
      }

      if (value === ('udesc' || 'check') && this.unit_desc1 != '') {
        if (this.unit_desc1.length > 100) {
          this.message.unit_desc1 = 'Maximum 100 characters only';
          this.submit_true = 1;
        } else if (this.unit_desc1.length < 1) {
          this.message.unit_desc1 = 'Minimum 1 characters only';
          this.submit_true = 1;
        } else if (udescregex.test(this.unit_desc1) == false) {
          this.message.unit_desc1 = 'Enter Valid Unit Description';
          this.submit_true = 1;
        } else {
          this.message.unit_desc1 = '';
        }
      }
    },
    submit: function submit() {
      var _this = this;
      this.submit_true = 0;
      this.onComplete('check');

      if (this.submit_true == 0) {
        _this.largeModal = false, _this.loading = true;
        var data = {
          unit_name: this.unit_name1,
          unit_desc: this.unit_desc1
        };

        this.$http.post('/api/unittypes', data).then(function (response) {
          _this.loading = false;
          _this.message.success = "Unit Added Successfully";
          setTimeout(function () {
            _this.message.success = false;
          }, 4000);
          _this.getunit();
          _this.reset();
        }).catch(function (error) {
          console.log(error.response);
          _this.loading = false;
          _this.message.sucess = "SomeThing Went Wrong";
        });
      }
    },
    reset: function reset() {
      this.unit_name1 = '';
      this.unit_desc1 = '';
      this.unit_name2 = '';
      this.unit_desc2 = '';
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_vue__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Variant",
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_2__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      shpfrst_time: false,
      selected: "all",
      largeModal: false,
      loading: false,
      search_uname: "",
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      columns: [{
        label: "Company Name",
        field: "companyname",
        width: "20% !important"
      }, {
        label: "Username",
        field: "username",
        width: "17% !important"
      }, {
        label: "Email",
        field: "email",
        width: "20% !important"
      }, {
        label: "Phone No.",
        field: "phone",
        width: "13% !important"
      }, {
        label: "Registered Date",
        field: "created_datetime",
        width: "20% !important"
      }],

      rows: [],

      error: {
        errorname: false,
        errorided: "",
        errornameed: "",
        errorvalue: false
      },
      message: {
        sucess: "",
        sucess1: ""
      }
    };
  },
  created: function created() {
    this.getuser();
  },


  methods: {
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getuser();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getuser();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.getuser();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getuser();
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    typechange: function typechange(current_type) {
      if (current_type !== undefined) {
        this.selected = current_type;
      }
      this.getuser();
    },
    getuser: function getuser() {
      var data = "";
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var search_like = "";
      if (this.search_uname != "") {
        search_like = "&filter[where][search_uname]=" + this.search_uname;
      }
      var api = "/api/users/user_email_detail?params=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filteParam) + "&filter[where][emailVerified]=" + this.selected + search_like;

      this.loading = true;
      var _this = this;
      this.$http.get(api).then(function (response) {
        if (response.data != undefined) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          _this.rows = response.data;
        }
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_vue__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Variant",
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_5__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      shpfrst_time: false,
      planModal: false,
      plan_dt_save: null,
      plan_dt: null,
      selplan: "1",
      selected_status: "all",
      warningModal: false,
      loading: false,
      search_uname: "",
      totalRecords: 0,
      totalRecords1: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      columns: [{
        label: "Company Name",
        field: "companyname",
        width: "20% !important"
      }, {
        label: "Username",
        field: "username",
        width: "17% !important"
      }, {
        label: "Email",
        field: "email",
        width: "20% !important"
      }, {
        label: "Phone No.",
        field: "phone",
        width: "12% !important"
      }, {
        label: "Registered Date",
        field: "created_datetime",
        width: "14% !important"
      }, {
        label: "Active Days",
        field: "no_of_days",
        width: "14% !important"
      }, {
        label: "Status",
        field: "user_status",
        width: "20% !important"
      }, {
        label: "Plan",
        field: "plan",
        width: "13% !important"
      }],

      columns1: [{
        label: "Company Name",
        field: "companyname",
        width: "20% !important"
      }, {
        label: "Username",
        field: "username",
        width: "17% !important"
      }, {
        label: "Email",
        field: "email",
        width: "20% !important"
      }, {
        label: "Phone No.",
        field: "phone",
        width: "13% !important"
      }, {
        label: "Registered Date",
        field: "created_datetime",
        width: "20% !important"
      }, {
        label: "Status",
        field: "user_status",
        width: "20% !important"
      }],

      rows: [],
      rows1: [],
      error: {
        errorname: false,
        errorided: "",
        errornameed: "",
        errorvalue: false
      },
      message: {
        sucess: "",
        sucess1: ""
      },
      haserror: {
        message: ""
      }
    };
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.plan()]).then(function (ret_val) {
      _this2.plan_dt = _this2.plan_dt_save;
      _this2.getuser();
    });
  },


  methods: {
    plan_select: function plan_select() {
      this.planModal = false;
      if (this.$refs["my-table"].selectedRows.length > 0) {
        var selected_lock_user = this.$refs["my-table"].selectedRows.map(function (item) {
          return item.email;
        });
        var _this = this;
        var data = { sel_plan: this.selplan, sel_user: selected_lock_user };
        this.loading = true;
        this.$http.post("/api/users/changeplan", data).then(function (response) {
          _this.loading = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          _this.haserror.message = "Plan for selected user is changed Successfully";
          _this.getuser();
          setTimeout(function () {
            _this.haserror.message = "";
          }, 2000);
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      } else {
        alert("Please select user first");
      }
    },
    show_plan: function show_plan() {
      this.planModal = true;
    },
    plan: function plan() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this3;

                _this3.plan_dt_save = {};
                _this3.$http.get("/api/plans").then(function (response) {
                  for (var i = 0; i < response.data.length; i++) {
                    _this.plan_dt_save[response.data[i]["plan_type"]] = response.data[i];
                    if (i === response.data.length - 1) {
                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true);
                    }
                  }
                }).catch(function (error) {
                  console.log(error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    inactive_user_list: function inactive_user_list() {
      this.rows1.length = 0;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      var api = "/api/users/inactive_user_detail?params=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam);

      this.$http.get(api).then(function (response) {
        if (response.data !== undefined) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          _this.rows1 = response.data;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    lockuser: function lockuser(val) {
      if (this.$refs["my-table"].selectedRows.length > 0) {
        var selected_lock_user = this.$refs["my-table"].selectedRows.map(function (item) {
          return item.email;
        });
        var _this = this;
        var data = { lock_val: val, sel_user: selected_lock_user };
        this.$http.post("/api/users/lockuser", data).then(function (response) {
          _this.loading = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          _this.haserror.message = "Selected users locked Successfully";
          _this.getuser();
          setTimeout(function () {
            _this.haserror.message = "";
          }, 2000);
        }).catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
      }
    },
    statuschange: function statuschange(val) {
      this.selected_status = val;
      this.getuser();
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getuser();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getuser();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.getuser();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.getuser();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.serverParams1, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.inactive_user_list();
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.inactive_user_list();
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.inactive_user_list();
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.inactive_user_list();
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    datediff: function datediff(register_date, current_date) {
      return Math.round((current_date - register_date) / (1000 * 60 * 60 * 24));
    },
    getuser: function getuser() {
      var data = "";
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var search_like = "";
      if (this.search_uname != "") {
        search_like = "&filter[where][search_uname]=" + this.search_uname;
      }
      var api = "/api/users/all_user_detail?params=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filteParam) + search_like + "&filter[where][status]=" + this.selected_status;
      this.loading = true;
      var _this = this;
      this.$http.get(api).then(function (response) {
        if (response.data != undefined) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          _this.rows = response.data;

          var reg_date = null;
          var today = new Date();
          for (var i = 0; i < _this.rows.length; i++) {
            reg_date = new Date(_this.rows[i]["created_datetime"]);
            _this.rows[i]["no_of_days"] = _this.datediff(reg_date, today);
            _this.rows[i]["plan"] = _this.plan_dt[parseInt(_this.rows[i]["plan_type"])]["plan_label"];
          }
        }
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    }
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_vue__ = __webpack_require__(3);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "PlanConfig",
    components: { Spinner: __WEBPACK_IMPORTED_MODULE_1__spinner_vue__["a" /* default */] },
    data: function data() {
        return {
            edit_add: true,
            largeModal: false,
            plan_data: null,
            loading: false,
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {},
                page: 1,
                perPage: 50
            },
            columns: [{
                label: "",
                field: "type",
                width: "20% !important"
            }, {
                label: "Free Basic",
                field: "Free Basic",
                width: "20% !important",
                thClass: "text-center"
            }, {
                label: "Standard",
                field: "Standard",
                width: "20% !important",
                thClass: "text-center"
            }, {
                label: "Professional",
                field: "Professional",
                width: "20% !important",
                thClass: "text-center"
            }, {
                label: "Premium",
                field: "Premium",
                width: "20% !important",
                thClass: "text-center"
            }],
            rows: [],
            message: {
                success: "",
                fail: ""
            },
            hasErrors: {
                cost: '',
                barcode: false,
                purchase: false,
                sales: false,
                cust_count: false,
                supp_count: false,
                prod_count: false,
                cat_count: false,
                bal_payment: false,
                report: false,
                gst_report: false,
                invoice: false,
                ecom_int: false,
                user_count: false,
                shop_count: false,
                plan_label: false
            },
            plan: {
                cost: '',
                barcode: false,
                purchase: false,
                sales: false,
                cust_count: '0',
                supp_count: '0',
                prod_count: '0',
                cat_count: '0',

                report: '0',
                gst_report: false,
                invoice: false,
                desktop_app: false,
                ecom_int: false,
                user_count: '0',
                shop_count: '0',
                plan_label: '',
                plan_type: '0'
            }
        };
    },
    created: function created() {
        this.getplan();
    },


    methods: {
        update: function update() {
            this.plan.barcode = this.plan.barcode === "true" || this.plan.barcode === true ? true : false;
            this.plan.ecom_int = this.plan.ecom_int === "true" || this.plan.ecom_int === true ? true : false;
            this.plan.gst_report = this.plan.gst_report === "true" || this.plan.gst_report === true ? true : false;
            this.plan.report = this.plan.report === "true" || this.plan.report === true ? true : false;

            this.plan.desktop_app = this.plan.desktop_app === "true" || this.plan.desktop_app === true ? true : false;
            this.plan.sales = this.plan.sales === "true" || this.plan.sales === true ? true : false;
            this.plan.purchase = this.plan.purchase === "true" || this.plan.purchase === true ? true : false;
            this.loading = true;
            var _this = this;
            if (this.edit_add === true) {
                this.$http.post('/api/plans/update?where[plan_type]=' + this.plan.plan_type, this.plan).then(function (response) {
                    _this.loading = false;
                    _this.largeModal = false;
                    if (parseInt(response.data.count) === 1) {
                        _this.message.success = "Plan has been updated successfully";
                        setTimeout(function () {
                            _this.message.success = '';
                        }, 2000);
                        _this.getplan();
                    } else {
                        _this.message.fail = "Something went wrong, Please try again later";
                        setTimeout(function () {
                            _this.message.fail = '';
                        }, 2000);
                    }
                }).catch(function (error) {
                    _this.loading = false;
                    console.log(error);
                });
            } else {
                this.$http.post('/api/plans', this.plan).then(function (response) {
                    _this.loading = false;
                    _this.largeModal = false;
                    if (parseInt(response.data.count) === 1) {
                        _this.message.success = "Plan has been added successfully";
                        setTimeout(function () {
                            _this.message.success = '';
                        }, 2000);
                        _this.getplan();
                    } else {
                        _this.message.fail = "Something went wrong, Please try again later";
                        setTimeout(function () {
                            _this.message.fail = '';
                        }, 2000);
                    }
                }).catch(function (error) {
                    _this.loading = false;
                    console.log(error);
                });
            }
        },
        addplan: function addplan() {
            this.plan.cost = '';
            this.plan.cust_count = '';
            this.plan.supp_count = '';
            this.plan.prod_count = '';
            this.plan.cat_count = '';
            this.plan.invoice = '';
            this.plan.user_count = '';
            this.plan.shop_count = '';
            this.plan.barcode = false;
            this.plan.ecom_int = false;
            this.plan.gst_report = false;
            this.plan.report = false;
            this.plan.bal_payment = false;
            this.plan.sales = false;
            this.plan.purchase = false;
            this.plan.plan_label = '';
            this.plan.plan_type = '';
            this.largeModal = true;
            this.edit_add = false;
        },
        add: function add() {
            this.plan.barcode = this.plan.barcode === "true" ? true : false;
            this.plan.ecom_int = this.plan.ecom_int === "true" ? true : false;
            this.plan.gst_report = this.plan.gst_report === "true" ? true : false;
            this.plan.report = this.plan.report === "true" ? true : false;
            this.plan.bal_payment = this.plan.bal_payment === "true" ? true : false;
            this.plan.sales = this.plan.sales === "true" ? true : false;
            this.plan.purchase = this.plan.purchase === "true" ? true : false;
            this.loading = true;
            var _this = this;
            this.$http.post('/api/plans', this.plan).then(function (response) {
                _this.loading = false;
                _this.largeModal = false;
                if (parseInt(response.data.count) === 1) {
                    _this.message.success = "Plan has been updated successfully";
                    setTimeout(function () {
                        _this.message.success = '';
                    }, 2000);
                    _this.getplan();
                } else {
                    _this.message.fail = "Something went wrong, Please try again later";
                    setTimeout(function () {
                        _this.message.fail = '';
                    }, 2000);
                }
            }).catch(function (error) {
                _this.loading = false;
                console.log(error);
            });
        },
        edit_plan: function edit_plan(plan_type) {
            this.edit_add = true;
            for (var i = 0; i < this.plan_data.length; i++) {
                if (this.plan_data[i]['plan_type'] === plan_type) {
                    this.plan.plan_type = this.plan_data[i]['plan_type'];
                    this.plan.plan_label = this.plan_data[i]['plan_label'];
                    this.plan.shop_count = this.plan_data[i]['Shop Count'];
                    this.plan.user_count = this.plan_data[i]['User Count'];
                    this.plan.ecom_int = this.plan_data[i]['E-Commerce Integration'];
                    this.plan.invoice = this.plan_data[i]['Invoice'];
                    this.plan.gst_report = this.plan_data[i]['GST Report'];
                    this.plan.report = this.plan_data[i]['Report'];
                    this.plan.desktop_app = this.plan_data[i]['Desktop Application'];

                    this.plan.cat_count = this.plan_data[i]['Category Count'];
                    this.plan.prod_count = this.plan_data[i]['Product Count'];
                    this.plan.cust_count = this.plan_data[i]['Customer Count'];
                    this.plan.supp_count = this.plan_data[i]['Supplier Count'];
                    this.plan.sales = this.plan_data[i]['Sales'];
                    this.plan.purchase = this.plan_data[i]['Purchase'];
                    this.plan.barcode = this.plan_data[i]['Barcode'];
                    this.plan.cost = this.plan_data[i]['Cost'];

                    break;
                }
            }
            this.largeModal = true;
        },
        getplan: function getplan() {
            var _this = this;
            this.rows.length = 0;
            var create_row = [];
            var dict = {};
            this.$http.get("/api/plans/getPlan").then(function (response) {
                _this.plan_data = response.data;
                for (var i = 0; i < response.data.length; i++) {
                    dict = response.data[i];
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dict).forEach(function (key, index) {
                        var dict_key = {};
                        if (key !== 'plan_label') {
                            if (create_row.length > 0) {
                                var exist = false;
                                for (var k = 0; k < create_row.length; k++) {
                                    if (create_row[k]['type'] === key) {
                                        exist = true;
                                        create_row[k][response.data[i]['plan_label']] = dict[key];
                                    }
                                    if (k === create_row.length - 1) {
                                        if (exist === false) {
                                            dict_key[response.data[i]['plan_label']] = dict[key];
                                            dict_key['type'] = key;
                                            create_row.push(dict_key);
                                        }
                                    }
                                }
                            } else {
                                dict_key['type'] = key;
                                dict_key[response.data[i]['plan_label']] = dict[key];
                                create_row.push(dict_key);
                            }
                        }
                    });
                }
                _this.rows = create_row;
            }).catch(function (error) {
                console.log(error);
            });
        }
    }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__);











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_6__spinner_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      min_admin: false,
      show: false,
      companylist: [],
      selectcompany: null,
      customerlist: [],
      selectcustomer: null,
      selectshop: null,
      slfirst: false,
      shpfirst: false,
      srchfirst: false,
      rfrst_time: false,
      shopname: []
    }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "selectshop", null), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "rows", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "rows1", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "totalRecords", 0), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "totalRecords1", 0), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "warningModal", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "haserror", {
      message: ""
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "serverParams", {
      columnFilters: {},
      sort: {},
      page: 1,
      perPage: 10
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "serverParams1", {
      columnFilters: {},
      sort: {},
      page: 1,
      perPage: 10
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "columns", [{
      label: "Customer Name",
      field: "cust_cmp_name",
      width: "20% !important",
      thClass: "text-center"
    }, {
      label: "Shop",
      field: "est_shop_name",
      width: "20% !important",
      thClass: "text-center"
    }, {
      label: "Total Amount",
      field: "total_amt_pay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Balance Amount",
      field: "total_amt_pendingpay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Action",
      field: "action",
      width: "20% !important",
      thClass: "text-center",
      tdClass: "text-center"
    }]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "columns1", [{
      label: "Sales Id",
      field: "sales_id",
      width: "10% !important",
      thClass: "text-center"
    }, {
      label: "Shop Name",
      field: "est_shop_name",
      width: "20% !important",
      thClass: "text-center"
    }, {
      label: "Total Amount",
      field: "total_amt_pay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Balance Amount",
      field: "total_amt_pendingpay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Date",
      field: "lastupdated_dt",
      type: "date",
      dateInputFormat: "YYYY-MM-DDThh:mm:ss",
      dateOutputFormat: "Do MMM YYYY",
      tdClass: "text-left",
      thClass: "text-center",
      width: "30% !important"
    }]), _ref;
  },

  computed: {
    sale_view: function sale_view() {
      var _this2 = this;

      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_sale_view === true) {
          this.shopuser("comp");
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.searchshops("comp")]).then(function (ret_val) {
            _this2.sales("comp");
            return true;
          });
        } else {
          return false;
        }
      } else {
        this.min_admin = true;
      }
    },
    sale_rights: function sale_rights() {
      return this.$store.getters.get_sale_rights;
    },
    is_admin: function is_admin() {
      return this.$store.getters.get_is_admin;
    }
  },

  methods: {
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompany: function onSelectCompany(selectedcompany) {
      this.show = false;
      this.searchshops();
    },
    searchcustomer: function searchcustomer(searchText) {
      if (this.min_admin === true && this.selectcompany === null) {
        this.show = true;
        return;
      }
      var data = "?filter[where][cust_cmp_name][ilike]=%" + searchText + "%";
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      var _this = this;
      this.$http.get("/api/customers" + data).then(function (response) {
        _this.customerlist = response.data;
      }).catch(function (error) {});
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.view_detail(this.temprow);
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.view_detail(this.temprow);
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.view_detail(this.temprow);
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.view_detail(this.temprow);
    },
    loadItems: function loadItems() {
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.rows = [];
      var data = "";

      if (this.selectcustomer !== null && this.selectcustomer.customer_id !== undefined) {
        data = data + "&filter[where][customer_id]=" + this.selectcustomer.customer_id;
      }
      if (this.selectcompany !== null) {
        if (this.selectcompany.company_id !== undefined) data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (this.selectshop.est_shop_id !== "0") {
        data = data + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      var api = "/api/saledetails/getPendingPayment?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data;

      this.$http.get("/api/saledetails/getPendingPayment?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data !== undefined) _this.rows = response.data;
      }).catch(function (er) {
        console.log(er);
      });
    },
    sales: function sales(val) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(val === "comp")) {
                  _context.next = 6;
                  break;
                }

                if (!(_this3.slfirst === false)) {
                  _context.next = 5;
                  break;
                }

                _this3.slfirst = true;
                _context.next = 6;
                break;

              case 5:
                return _context.abrupt("return");

              case 6:
                _this3.loadItems();
                return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    view_detail: function view_detail(row) {
      this.rows1.length = 0;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;

      var data = "&filter[where][cust_id]=" + row.customer_id;
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (row.est_shop_id !== "0") {
        data = data + "&filter[where][shop_id]=" + row.est_shop_id;
      }

      this.$http.get("/api/saledetails/pendingBalance?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        if (response.data !== undefined) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          _this.rows1 = response.data;
        }
      });
    },
    searchshops: function searchshops(val) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response, all_shop;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(val === "comp")) {
                  _context2.next = 6;
                  break;
                }

                if (!(_this4.srchfirst === false)) {
                  _context2.next = 5;
                  break;
                }

                _this4.srchfirst = true;
                _context2.next = 6;
                break;

              case 5:
                return _context2.abrupt("return");

              case 6:
                _this = _this4;
                response = null;

                if (!(_this4.selectcompany !== null)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return _this4.$http.get("/api/shopusers/getShop?filter[where][company_id]=" + _this4.selectcompany.company_id + "&filter[where][user_id]=" + _this4.selectcompany.cmp_email);

              case 11:
                response = _context2.sent;
                _context2.next = 17;
                break;

              case 14:
                _context2.next = 16;
                return _this4.$http.get("/api/shopusers/getShop");

              case 16:
                response = _context2.sent;

              case 17:
                all_shop = {
                  est_shop_name: "All Shops",
                  est_shop_id: "0"
                };

                _this.shopname = response.data;
                _this.shopname.push(all_shop);

                _this.selectshop = all_shop;

                if (!(_this.shopname.length > 0)) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true));

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    searchlist: function searchlist() {
      this.loadItems();
    },
    exportData: function exportData() {
      var _this = this;
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var data = "";
      if (this.selectcustomer !== null && this.selectcustomer.customer_id !== undefined) {
        data = data + "&filter[where][customer_id]=" + this.selectcustomer.customer_id;
      }
      if (this.selectcompany !== null) {
        if (this.selectcompany.company_id !== undefined) data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (this.selectshop.est_shop_id !== "0") {
        data = data + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }
      this.$http.get("/api/saledetails/getsalesbalancereport?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.loading = false;
        var __this = _this;
        var access_token = localStorage.getItem("authUser");
        var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;
        if (response.data !== null || response.data !== "") {
          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", response.data);
            link.href = url1;
            document.body.appendChild(link);
            link.click();
          }).catch(function (error) {
            console.log(error);
            __this.haserror.message = "Something Went Wrong, Please try again later";
          });
        } else {
          __this.haserror.message = "Something Went Wrong, Please try again later";
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__);











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "date-picker": __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_6__spinner_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      min_admin: false,
      show: false,
      companylist: [],
      selectcompany: null,
      supplierlist: [],
      selectsupplier: null,
      selectshop: null,
      slfirst: false,
      shpfirst: false,
      srchfirst: false,
      rfrst_time: false,
      shopname: []
    }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "selectshop", null), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "rows", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "rows1", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "totalRecords", 0), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "totalRecords1", 0), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "srch_suppname", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "warningModal", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "serverParams", {
      columnFilters: {},
      sort: {},
      page: 1,
      perPage: 10
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "serverParams1", {
      columnFilters: {},
      sort: {},
      page: 1,
      perPage: 10
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "columns", [{
      label: "Supplier Name",
      field: "sup_cmp_name",
      width: "20% !important",
      thClass: "text-center"
    }, {
      label: "Shop",
      field: "est_shop_name",
      width: "20% !important",
      thClass: "text-center"
    }, {
      label: "Total Amount",
      field: "total_amt_pay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Balance Amount",
      field: "total_amt_pendingpay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Action",
      field: "action",
      width: "20% !important",
      thClass: "text-center",
      tdClass: "text-center"
    }]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "columns1", [{
      label: "Purchase Id",
      field: "purchase_id",
      width: "10% !important",
      thClass: "text-center"
    }, {
      label: "Shop Name",
      field: "est_shop_name",
      width: "20% !important",
      thClass: "text-center"
    }, {
      label: "Total Amount",
      field: "total_amt_pay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Balance Amount",
      field: "amt_pending_pay",
      width: "20% !important",
      formatFn: this.formatFn,
      thClass: "text-center"
    }, {
      label: "Date",
      field: "lastupdated_dt",
      width: "30% !important",
      type: "date",
      dateInputFormat: "YYYY-MM-DDThh:mm:ss",
      dateOutputFormat: "Do MMM YYYY",
      tdClass: "text-left",
      thClass: "text-center"
    }]), _ref;
  },

  computed: {
    pur_view: function pur_view() {
      var _this2 = this;

      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_pur_view === true) {
          this.shopuser("comp");
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all([this.searchshops("comp")]).then(function (ret_val) {
            _this2.sales("comp");
            return true;
          });
        } else {
          return false;
        }
      } else {
        this.min_admin = true;
      }
    },
    pur_rights: function pur_rights() {
      return this.$store.getters.get_pur_rights;
    },
    is_admin: function is_admin() {
      return this.$store.getters.get_is_admin;
    }
  },

  methods: {
    searchcompany: function searchcompany(searchText) {
      var _this = this;
      this.$http.get("/api/companies?filter[where][company_name][ilike]=%" + searchText + "%").then(function (response) {
        _this.companylist = response.data;
      }).catch(function (error) {});
    },
    onSelectCompany: function onSelectCompany(selectedcompany) {
      this.show = false;
      this.searchshops();
    },
    searchsupplier: function searchsupplier(searchText) {
      if (this.min_admin === true && this.selectcompany === null) {
        this.show = true;
        return;
      }
      var data = "?filter[where][sup_cmp_name][ilike]=%" + searchText + "%";
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      var _this = this;
      this.$http.get("/api/suppliers" + data).then(function (response) {
        _this.supplierlist = response.data;
      }).catch(function (error) {});
    },
    shopuser: function shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get("/api/shopusers").then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit("SET_AUTH_USER", null);
          _this.$router.push("/");
        }
      });
    },
    formatFn: function formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },
    onSortChange: function onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.loadItems();
    },
    onColumnFilter: function onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    updateParams1: function updateParams1(newProps) {
      this.serverParams1 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange1: function onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.view_detail(this.temprow);
    },
    onPerPageChange1: function onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.view_detail(this.temprow);
    },
    onSortChange1: function onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        },
        page: 1
      });
      this.view_detail(this.temprow);
    },
    onColumnFilter1: function onColumnFilter1(params) {
      this.updateParams1(params);
      this.view_detail(this.temprow);
    },
    loadItems: function loadItems() {
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.rows = [];
      var data = "";
      if (this.selectsupplier !== null && this.selectsupplier.supplier_id !== undefined) {
        data = data + "&filter[where][supplier_id]=" + this.selectsupplier.supplier_id;
      }
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (this.selectshop.est_shop_id !== "0") {
        data = data + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      this.$http.get("/api/purchasedetails/getPendingPayment?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.totalRecords = response.data[0].totalRecords;
        response.data.shift();
        if (response.data !== undefined) _this.rows = response.data;
      }).catch(function (er) {
        console.log(er);
      });
    },
    sales: function sales(val) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(val === "comp")) {
                  _context.next = 6;
                  break;
                }

                if (!(_this3.slfirst === false)) {
                  _context.next = 5;
                  break;
                }

                _this3.slfirst = true;
                _context.next = 6;
                break;

              case 5:
                return _context.abrupt("return");

              case 6:
                _this3.loadItems();
                return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    view_detail: function view_detail(row) {
      this.rows1.length = 0;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;

      var data = "&filter[where][sup_id]=" + row.supplier_id;
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (row.est_shop_id !== "0") {
        data = data + "&filter[where][shop_id]=" + row.est_shop_id;
      }

      this.$http.get("/api/purchasedetails/pendingBalance?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        if (response.data !== undefined) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          _this.rows1 = response.data;
        }
      });
    },
    searchshops: function searchshops(val) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this, response, all_shop;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(val === "comp")) {
                  _context2.next = 6;
                  break;
                }

                if (!(_this4.srchfirst === false)) {
                  _context2.next = 5;
                  break;
                }

                _this4.srchfirst = true;
                _context2.next = 6;
                break;

              case 5:
                return _context2.abrupt("return");

              case 6:
                _this = _this4;
                response = null;

                if (!(_this4.selectcompany !== null)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 11;
                return _this4.$http.get("/api/shopusers/getShop?filter[where][company_id]=" + _this4.selectcompany.company_id + "&filter[where][user_id]=" + _this4.selectcompany.cmp_email + "&filter[where][regcity]=" + _this4.selectcompany.regcity_code);

              case 11:
                response = _context2.sent;
                _context2.next = 17;
                break;

              case 14:
                _context2.next = 16;
                return _this4.$http.get("/api/shopusers/getShop");

              case 16:
                response = _context2.sent;

              case 17:
                all_shop = {
                  est_shop_name: "All Shops",
                  est_shop_id: "0"
                };

                _this.shopname = response.data;
                _this.shopname.push(all_shop);
                _this.selectshop = all_shop;

                if (!(_this.shopname.length > 0)) {
                  _context2.next = 23;
                  break;
                }

                return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve(true));

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    searchlist: function searchlist() {
      this.loadItems();
    },
    exportData: function exportData() {
      this.loading = true;
      var _this = this;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;


      var data = "";
      if (this.selectsupplier !== null && this.selectsupplier.supplier_id !== undefined) {
        data = data + "&filter[where][supplier_id]=" + this.selectsupplier.supplier_id;
      }
      if (this.selectcompany !== null) {
        data = data + "&filter[where][company_id]=" + this.selectcompany.company_id + "&filter[where][regcity]=" + this.selectcompany.regcity_code;
      }
      if (this.selectshop.est_shop_id !== "0") {
        data = data + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      this.$http.get("/api/purchasedetails/getPendingPaymentExport?params=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filteParam) + data).then(function (response) {
        _this.loading = false;
        var __this = _this;
        var access_token = localStorage.getItem("authUser");
        var url1 = _this.baseURL2 + "/api/containers/csv/download/" + response.data + "?access_token=" + access_token;
        if (response.data !== null || response.data !== "") {
          _this.$http({
            url: url1,
            method: "GET",
            responseType: "blob"
          }).then(function (res) {
            var url = window.URL.createObjectURL(new Blob([res.data]));
            var link = document.createElement("a");
            link.setAttribute("download", "Purchase_pending_list_" + Date.now() + ".csv");
            link.href = url1;
            document.body.appendChild(link);
            link.click();
          }).catch(function (error) {
            console.log(error);
            __this.haserror.message = "Something Went Wrong, Please try again later";
          });
        } else {
          __this.haserror.message = "Something Went Wrong, Please try again later";
        }
      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_userStore_js__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__(848);


var _getters;







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var debug = "production" !== 'production';

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */]({
  key: 'vuex',
  storage: window.localStorage });

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    userStore: __WEBPACK_IMPORTED_MODULE_3__user_userStore_js__["a" /* default */],
    plugins: [vuexLocalStorage.plugin]
  },

  state: {
    dashbd_view: null,
    dashbd_rights: null,
    reg_view: null,
    reg_rights: null,
    shop_view: null,
    shop_rights: null,
    u_view: null,
    u_rights: null,
    r_view: null,
    r_rights: null,
    cust_view: null,
    cust_rights: null,
    sup_view: null,
    sup_rights: null,
    invt_view: null,
    invt_rights: null,
    stcktran_view: null,
    stcktran_rights: null,
    prod_view: null,
    prod_rights: null,
    cat_view: null,
    cat_rights: null,
    brand_view: null,
    brand_rights: null,
    tax_view: null,
    tax_rights: null,
    hsn_view: null,
    hsn_rights: null,
    var_view: null,
    var_rights: null,
    unit_view: null,
    unit_rights: null,
    pur_view: null,
    pur_rights: null,
    purrt_view: null,
    purrt_rights: null,
    sale_view: null,
    sale_rights: null,
    salert_view: null,
    salert_rights: null,
    salerechis_view: null,
    salerechis_rights: null,
    salereturnpay_view: null,
    salereturnpay_rights: null,
    purchasereturnpay_view: null,
    purchasereturnpay_rights: null,
    saleinvoice_view: null,
    saleinvoice_rights: null,
    salerec_view: null,
    salerec_rights: null,
    purpay_view: null,
    purpay_rights: null,
    purpayhis_view: null,
    purpayhis_rights: null,

    is_super_user: null,
    is_shop_user: null,
    shopmodal: null,
    custmodal: null,
    productmodal: null,
    supmodal: null,

    is_admin: null
  },

  getters: (_getters = {
    get_is_admin: function get_is_admin(state) {
      return state.is_admin;
    },
    get_shop_user: function get_shop_user(state) {
      return state.is_shop_user;
    },
    get_super_user: function get_super_user(state) {
      return state.is_super_user;
    },
    get_dashbd_view: function get_dashbd_view(state) {
      return state.dashbd_view;
    },
    get_dashbd_rights: function get_dashbd_rights(state) {
      return state.dashbd_rights;
    },
    get_reg_view: function get_reg_view(state) {
      return state.reg_view;
    },
    get_reg_rights: function get_reg_rights(state) {
      return state.reg_rights;
    },
    get_shop_view: function get_shop_view(state) {
      return state.shop_view;
    },
    get_shop_rights: function get_shop_rights(state) {
      return state.shop_rights;
    },
    get_u_view: function get_u_view(state) {
      return state.u_view;
    },
    get_u_rights: function get_u_rights(state) {
      return state.u_rights;
    },
    get_r_view: function get_r_view(state) {
      return state.r_view;
    },
    get_r_rights: function get_r_rights(state) {
      return state.r_rights;
    },
    get_cust_view: function get_cust_view(state) {
      return state.cust_view;
    },
    get_cust_rights: function get_cust_rights(state) {
      return state.cust_rights;
    },
    get_sup_view: function get_sup_view(state) {
      return state.sup_view;
    },
    get_sup_rights: function get_sup_rights(state) {
      return state.sup_rights;
    },
    get_invt_view: function get_invt_view(state) {
      return state.invt_view;
    },
    get_invt_rights: function get_invt_rights(state) {
      return state.invt_rights;
    },
    get_stcktran_view: function get_stcktran_view(state) {
      return state.stcktran_view;
    },
    get_stcktran_rights: function get_stcktran_rights(state) {
      return state.stcktran_rights;
    },
    get_prod_view: function get_prod_view(state) {
      return state.prod_view;
    },
    get_prod_rights: function get_prod_rights(state) {
      return state.prod_rights;
    },
    get_cat_view: function get_cat_view(state) {
      return state.cat_view;
    },
    get_cat_rights: function get_cat_rights(state) {
      return state.cat_rights;
    },
    get_brand_view: function get_brand_view(state) {
      return state.brand_view;
    },
    get_brand_rights: function get_brand_rights(state) {
      return state.brand_rights;
    },
    get_tax_view: function get_tax_view(state) {
      return state.tax_view;
    },
    get_tax_rights: function get_tax_rights(state) {
      return state.tax_rights;
    },
    get_hsn_view: function get_hsn_view(state) {
      return state.hsn_view;
    },
    get_hsn_rights: function get_hsn_rights(state) {
      return state.hsn_rights;
    },
    get_var_view: function get_var_view(state) {
      return state.var_view;
    },
    get_var_rights: function get_var_rights(state) {
      return state.var_rights;
    },
    get_unit_view: function get_unit_view(state) {
      return state.unit_view;
    },
    get_unit_rights: function get_unit_rights(state) {
      return state.unit_rights;
    },
    get_pur_view: function get_pur_view(state) {
      return state.pur_view;
    },
    get_pur_rights: function get_pur_rights(state) {
      return state.pur_rights;
    },
    get_purrt_view: function get_purrt_view(state) {
      return state.purrt_view;
    },
    get_purrt_rights: function get_purrt_rights(state) {
      return state.purrt_rights;
    },
    get_sale_view: function get_sale_view(state) {
      return state.sale_view;
    },
    get_sale_rights: function get_sale_rights(state) {
      return state.sale_rights;
    },
    get_salert_view: function get_salert_view(state) {
      return state.salert_view;
    },
    get_salert_rights: function get_salert_rights(state) {
      return state.salert_rights;
    },
    get_salerechis_view: function get_salerechis_view(state) {
      return state.salerechis_view;
    },
    get_salerechis_rights: function get_salerechis_rights(state) {
      return state.salerechis_rights;
    },
    get_salereturnpay_view: function get_salereturnpay_view(state) {
      return state.salereturnpay_view;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_salerechis_rights', function get_salerechis_rights(state) {
    return state.salereturnpay_rights;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_saleinvoice_view', function get_saleinvoice_view(state) {
    return state.saleinvoice_view;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_saleinvoice_rights', function get_saleinvoice_rights(state) {
    return state.saleinvoice_rights;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_salerec_view', function get_salerec_view(state) {
    return state.salerec_view;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_salerec_rights', function get_salerec_rights(state) {
    return state.salerec_rights;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_purpay_view', function get_purpay_view(state) {
    return state.purpay_view;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_purpay_rights', function get_purpay_rights(state) {
    return state.purpay_rights;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_purpayhis_view', function get_purpayhis_view(state) {
    return state.purpayhis_view;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_purpayhis_rights', function get_purpayhis_rights(state) {
    return state.purpayhis_rights;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_shopmodal', function get_shopmodal(state) {
    return state.shopmodal;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_purchasereturnpay_view', function get_purchasereturnpay_view(state) {
    return state.purchasereturnpay_view;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_purchasereturnpay_rights', function get_purchasereturnpay_rights(state) {
    return state.purchasereturnpay_rights;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_custmodal', function get_custmodal(state) {
    return state.custmodal;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_productmodal', function get_productmodal(state) {
    return state.productmodal;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, 'get_supmodal', function get_supmodal(state) {
    return state.supmodal;
  }), _getters),
  mutations: {
    set_shop_user: function set_shop_user(state, shopuser) {
      state.is_shop_user = shopuser;
    },
    set_super_user: function set_super_user(state, superuser) {
      state.is_super_user = superuser;
    },
    set_dashbd_view: function set_dashbd_view(state, dashbdview) {
      state.dashbd_view = dashbdview;
    },
    set_dashbd_rights: function set_dashbd_rights(state, dashbdright) {
      state.dashbd_rights = dashbdright;
    },
    set_reg_view: function set_reg_view(state, regview) {
      state.reg_view = regview;
    },
    set_reg_rights: function set_reg_rights(state, regright) {
      state.reg_rights = regright;
    },
    set_shop_view: function set_shop_view(state, shopview) {
      state.shop_view = shopview;
    },
    set_shop_rights: function set_shop_rights(state, shopright) {
      state.shop_rights = shopright;
    },
    set_u_view: function set_u_view(state, userview) {
      state.u_view = userview;
    },
    set_u_rights: function set_u_rights(state, userright) {
      state.u_rights = userright;
    },
    set_r_view: function set_r_view(state, roleview) {
      state.r_view = roleview;
    },
    set_r_rights: function set_r_rights(state, roleright) {
      state.r_rights = roleright;
    },
    set_cust_view: function set_cust_view(state, custview) {
      state.cust_view = custview;
    },
    set_cust_rights: function set_cust_rights(state, custright) {
      state.cust_rights = custright;
    },
    set_sup_view: function set_sup_view(state, supview) {
      state.sup_view = supview;
    },
    set_sup_rights: function set_sup_rights(state, supright) {
      state.sup_rights = supright;
    },
    set_invt_view: function set_invt_view(state, invtview) {
      state.invt_view = invtview;
    },
    set_invt_rights: function set_invt_rights(state, invtright) {
      state.invt_rights = invtright;
    },
    set_stcktran_view: function set_stcktran_view(state, stcktranview) {
      state.stcktran_view = stcktranview;
    },
    set_stcktran_rights: function set_stcktran_rights(state, stcktranright) {
      state.stcktran_rights = stcktranright;
    },
    set_prod_view: function set_prod_view(state, prodview) {
      state.prod_view = prodview;
    },
    set_prod_rights: function set_prod_rights(state, prodright) {
      state.prod_rights = prodright;
    },
    set_cat_view: function set_cat_view(state, catview) {
      state.cat_view = catview;
    },
    set_cat_rights: function set_cat_rights(state, catright) {
      state.cat_rights = catright;
    },
    set_brand_view: function set_brand_view(state, brandview) {
      state.brand_view = brandview;
    },
    set_brand_rights: function set_brand_rights(state, brandright) {
      state.brand_rights = brandright;
    },
    set_tax_view: function set_tax_view(state, taxview) {
      state.tax_view = taxview;
    },
    set_tax_rights: function set_tax_rights(state, taxright) {
      state.tax_rights = taxright;
    },
    set_hsn_view: function set_hsn_view(state, hsnview) {
      state.hsn_view = hsnview;
    },
    set_hsn_rights: function set_hsn_rights(state, hsnright) {
      state.hsn_rights = hsnright;
    },
    set_var_view: function set_var_view(state, varview) {
      state.var_view = varview;
    },
    set_var_rights: function set_var_rights(state, varright) {
      state.var_rights = varright;
    },
    set_unit_view: function set_unit_view(state, unitview) {
      state.unit_view = unitview;
    },
    set_unit_rights: function set_unit_rights(state, unitright) {
      state.unit_rights = unitright;
    },
    set_pur_view: function set_pur_view(state, purview) {
      state.pur_view = purview;
    },
    set_pur_rights: function set_pur_rights(state, purright) {
      state.pur_rights = purright;
    },
    set_purrt_view: function set_purrt_view(state, purrtview) {
      state.purrt_view = purrtview;
    },
    set_purrt_rights: function set_purrt_rights(state, purrtright) {
      state.purrt_rights = purrtright;
    },
    set_sale_view: function set_sale_view(state, saleview) {
      state.sale_view = saleview;
    },
    set_sale_rights: function set_sale_rights(state, saleright) {
      state.sale_rights = saleright;
    },
    set_salert_view: function set_salert_view(state, salertview) {
      state.salert_view = salertview;
    },
    set_salert_rights: function set_salert_rights(state, salertright) {
      state.salert_rights = salertright;
    },
    set_salerechis_view: function set_salerechis_view(state, salerechisview) {
      state.salerechis_view = salerechisview;
    },
    set_salerechis_rights: function set_salerechis_rights(state, salerechisrights) {
      state.salerechis_rights = salerechisrights;
    },
    set_salereturnpay_view: function set_salereturnpay_view(state, salereturnview) {
      state.salereturnpay_view = salereturnview;
    },
    set_salereturnpay_rights: function set_salereturnpay_rights(state, salereturnright) {
      state.salereturnpay_rights = salereturnright;
    },
    set_salerec_view: function set_salerec_view(state, salerecview) {
      state.salerec_view = salerecview;
    },
    set_salerec_rights: function set_salerec_rights(state, salerecrights) {
      state.salerec_rights = salerecrights;
    },
    set_saleinvoice_view: function set_saleinvoice_view(state, saleinvoiceview) {
      state.saleinvoice_view = saleinvoiceview;
    },
    set_saleinvoice_rights: function set_saleinvoice_rights(state, saleinvoicerights) {
      state.saleinvoice_rights = saleinvoicerights;
    },
    set_purpay_view: function set_purpay_view(state, purpayview) {
      state.purpay_view = purpayview;
    },
    set_purpay_rights: function set_purpay_rights(state, purpayrights) {
      state.purpay_rights = purpayrights;
    },
    set_purpayhis_view: function set_purpayhis_view(state, purpayhisview) {
      state.purpayhis_view = purpayhisview;
    },
    set_purpayhis_rights: function set_purpayhis_rights(state, purpayhisrights) {
      state.purpayhis_rights = purpayhisrights;
    },
    set_purchasereturnpay_view: function set_purchasereturnpay_view(state, purchasereturnview) {
      state.purchasereturnpay_view = purchasereturnview;
    },
    set_puchasereturnpay_rights: function set_puchasereturnpay_rights(state, purchasereturnright) {
      state.purchasereturnpay_rights = purchasereturnright;
    },
    set_shopmodal: function set_shopmodal(state, shop) {
      state.shopmodal = shop;
    },
    set_custmodal: function set_custmodal(state, cust) {
      state.custmodal = cust;
    },
    set_productmodal: function set_productmodal(state, prod) {
      state.productmodal = prod;
    },
    set_supmodal: function set_supmodal(state, sup) {
      state.supmodal = sup;
    },
    set_is_admin: function set_is_admin(state, admin) {
      state.is_admin = admin;
    }
  },


  strict: debug
}));

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_setting_AddProductModal_vue__ = __webpack_require__(1121);



var Modal = {
  install: function install(Vue, options) {
    this.EventBus = new Vue();

    Vue.component('addproductmodal', __WEBPACK_IMPORTED_MODULE_0__views_setting_AddProductModal_vue__["a" /* default */]);

    Vue.prototype.$addproductmodal = {
      show: function show(params) {
        Modal.EventBus.$emit('show', params);
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_plugins_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_vue__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["VueEditor"],
    Spinner: __WEBPACK_IMPORTED_MODULE_4__spinner_vue__["a" /* default */]
  },
  data: function data() {
    var _product;

    return {
      access_token: null,
      disabled: 1,
      pluscheck: false,
      largeModal: false,
      loading: false,
      checkboxqty: false,
      checkboxtk: false,
      varientlist: [],
      pdid: '',
      pdname: '',
      rows: [],
      category: [],
      unitopt: [],
      brndopt: [],
      hsnopt: [],
      taxopt: [],
      specs: [],
      subcategory: [],
      selectedCategory: null,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      maximumSize: 500000,
      selectedSub: null,
      selectedBrand: null,
      selectedUnit: null,

      selectedHsn: null,
      selectedTax: null,
      product: (_product = {
        altproductid: '',
        productname: '',
        productdesc: '',
        productbarcodesymbol: '',
        productalertqty: '',
        productcf1: '',
        productcf2: '',
        productcf3: '',
        productcf_val1: '',
        productcf_val2: '',
        productcf_val3: '',
        specname: '',
        specdesc: '',
        variantname: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_product, 'image5', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_product, 'imageArr', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_product, 'imageUrl', []), _product),
      indx: 0,
      hasErrors: {
        message: false,
        altproductid: false,
        productname: false,
        productdesc: false,
        productcode: false,
        productalert: false,
        productcf1: false,
        productcf2: false,
        productcf3: false,
        productcf_val1: false,
        productcf_val2: false,
        productcf_val3: false,
        specname: false,
        specdesc: false,
        variantname: false,
        image: false,
        selectedHsn: false,
        selectedTax: false,
        productbarcodesymbol: false
      },
      errorMessage: {
        message: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null,
        image6: null,
        selectedHsn: '',
        selectedTax: '',
        productbarcodesymbol: ''
      }
    };
  },

  computed: {
    companyTaxType: function companyTaxType() {
      var companyId = localStorage.getItem('companyId') || '';
      return this.$config && this.$config.companyTaxLogic && this.$config.companyTaxLogic[companyId] || 'IN';
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    hide: function hide() {
      this.largeModal = false;
    },
    addRow: function addRow() {
      this.specs.push({ specname: '', specdesc: '' });
    },
    getvariant: function getvariant(val) {
      if (val === 'comp') {
        if (this.vf_time === false) {
          this.vf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/variants').then(function (response) {
        _this.varientlist = response.data;
      }).catch(function (error) {});
    },
    tax_name: function tax_name(opt) {
      var _this = this;
      this.$http.get('/api/taxrates?filter[where][tax_id]=' + opt.tax_id).then(function (response) {
        _this.taxopt = response.data;
        _this.selectedTax = response.data[0];
      }).catch(function (error) {});
    },
    brand_name: function brand_name(val) {
      if (val === 'comp') {
        if (this.bf_time === false) {
          this.bf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/brands').then(function (response) {
        _this.brndopt = response.data;
      }).catch(function (error) {});
    },
    unit_name: function unit_name(val) {
      if (val === 'comp') {
        if (this.uf_time === false) {
          this.uf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/unittypes').then(function (response) {
        _this.unitopt = response.data;
      }).catch(function (error) {});
    },
    tax_name2: function tax_name2(opt) {
      var _this = this;
      this.$http.get('/api/taxrates?filter[where][tax_id]=' + opt).then(function (response) {
        _this.taxopt = response.data;
        _this.selectedTax = response.data[0];
      }).catch(function (error) {});
    },
    hsnno: function hsnno(val) {
      if (val === 'comp') {
        if (this.hf_time === false) {
          this.hf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/hsns').then(function (response) {
        _this.hsnopt = response.data;
      }).catch(function (error) {});
    },
    subcategory1: function subcategory1(category) {
      this.subcategory = [];
      this.selectedSub = null;
      this.selectedSub = null;
      var _this = this;
      var id = category.category_id;

      this.$http.get('/api/subcategories?filter[where][category_id]=' + id).then(function (response) {
        _this.subcategory = response.data;
      }).catch(function (error) {});
    },
    subcategory2: function subcategory2(category) {
      this.subcategory = [];
      this.selectedSub = null;
      this.selectedSub = null;
      var _this = this;
      var id = category;
      this.$http.get('/api/subcategories?filter[where][category_id]=' + id).then(function (response) {
        _this.subcategory = response.data;
      }).catch(function (error) {});
    },
    getCategories: function getCategories(val) {
      if (val === 'comp') {
        if (this.cf_time === false) {
          this.cf_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http.get('/api/categories').then(function (response) {
        _this.category = response.data;
      }).catch(function (error) {});
    },
    reset: function reset() {
      var _this = this;
      _this.reset_specs();
      _this.product.imageArr = [];
      _this.product.imageUrl = [];
      _this.product.variantname = null;
      _this.product.altproductid = '';
      _this.product.productname = '';
      _this.product.productdesc = '';
      _this.product.productbarcodesymbol = '';
      _this.product.productalertqty = '';
      _this.product.productcf1 = '';
      _this.product.productcf_val1 = '';
      _this.product.specname = '';
      _this.product.specdesc = '';
      _this.selectedCategory = null;
      _this.subcategory = [];
      _this.selectedSubc = null;
      _this.selectedBrand = null;
      _this.selectedHsn = null;
      _this.selectedTax = null;
      _this.taxopt = [];
      _this.selectedUnit = null;
      _this.hasErrors.message = false;
      _this.errorMessage.message = null;
      _this.hasErrors.selectedHsn = false;
      _this.hasErrors.productbarcodesymbol = false;
      _this.errorMessage.selectedHsn = null;
      _this.hasErrors.selectedTax = false;
      _this.errorMessage.selectedTax = null;
      _this.errorMessage.productbarcodesymbol = '';
      _this.hasErrors.productname = false;
      _this.errorMessage.productname = null;
      _this.productedit = 0;
      _this.producteditvalue = null;
      _this.pluscheck = false;
      _this.product.productcf2 = '';
      _this.product.productcf3 = '';
      _this.product.productcf_val2 = '';
      _this.product.productcf_val3 = '';
      _this.checkboxqty = false;
      _this.checkboxtk = false;
      _this.selectedSub = null;
      _this.image1 = null;
      _this.image2 = null;
      _this.image3 = null;
      _this.image4 = null;
      _this.image5 = null;
      _this.image6 = null;
      _this.productimagevalue1 = null;
      _this.productimagevalue2 = null;
      _this.productimagevalue3 = null;
      _this.productimagevalue4 = null;
      _this.productimagevalue5 = null;
      _this.productimagevalue6 = null;
    },
    show: function show(params) {
      this.reset();


      this.category = params.category;
      this.unitopt = params.unitopt;
      this.brndopt = params.brndopt;
      this.hsnopt = params.hsnopt;
      this.varientlist = params.varientlist;

      this.largeModal = true;
    },
    reset_specs: function reset_specs() {
      if (this.specs.length > 0) {
        for (var i = this.specs.length - 1; i >= 0; i--) {
          this.specs.splice(i, 1);
        }
      }
      for (var i = 0; i < 1; i++) {
        this.specs.push({ specname: '', specdesc: '' });
      }
    },
    imagefun1: function imagefun1(callback) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      if (this.product.imageArr[0]) {

        if (image1.files[0] != undefined) {

          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[0]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return _this.product.imageArr[0];
        }
      } else {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun2: function imagefun2(callback) {
      var _this = this;
      var image2 = document.querySelector('#image2');
      if (this.product.imageArr[1] != null) {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[1]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[1];
        }
      } else {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun3: function imagefun3(callback) {
      var _this = this;
      var image3 = document.querySelector('#image3');
      if (this.product.imageArr[2] != null) {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[2]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[2];
        }
      } else {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun4: function imagefun4(callback) {
      var _this = this;
      var image4 = document.querySelector('#image4');
      if (this.product.imageArr[3] != null) {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[3]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[3];
        }
      } else {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun5: function imagefun5(callback) {
      var _this = this;
      var image5 = document.querySelector('#image5');
      if (this.product.imageArr[4] != null) {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[4]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[4];
        }
      } else {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    imagefun6: function imagefun6(callback) {
      var _this = this;
      var image6 = document.querySelector('#image6');
      if (this.product.imageArr[5] != null) {
        if (image6.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.product.imageArr[5]);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return this.product.imageArr[5];
        }
      } else {
        if (image6.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return null;
          });
        } else {
          return null;
        }
      }
    },
    Submit: function Submit() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var _this = this;

      _this.hasErrors.altproductid = false;
      _this.hasErrors.productname = false;
      _this.hasErrors.selectedHsn = false;
      _this.hasErrors.selectedTax = false;
      _this.hasErrors.productdesc = false;
      _this.hasErrors.productcode = false;
      _this.hasErrors.productalert = false;
      _this.hasErrors.productcf1 = false;
      _this.hasErrors.productcf2 = false;
      _this.hasErrors.productcf3 = false;
      _this.hasErrors.productcf_val1 = false;
      _this.hasErrors.productcf_val2 = false;
      _this.hasErrors.productcf_val3 = false;
      _this.hasErrors.specdesc = false;
      _this.hasErrors.variantname = false;
      _this.hasErrors.productbarcodesymbol = false;
      this.hasErrors.image = false;
      this.errorMessage.image1 = null;
      this.errorMessage.image2 = null;
      this.errorMessage.image3 = null;
      this.errorMessage.image4 = null;
      this.errorMessage.image5 = null;
      this.errorMessage.image6 = null;
      this.errorMessage.selectedHsn = null;
      this.errorMessage.selectedTax = null;
      this.errorMessage.productbarcodesymbol = '';
      var fileInput1 = document.querySelector('#image1');
      var fileInput2 = document.querySelector('#image2');
      var fileInput3 = document.querySelector('#image3');
      var fileInput4 = document.querySelector('#image4');
      var fileInput5 = document.querySelector('#image5');
      var fileInput6 = document.querySelector('#image6');
      var submit_true = '0';
      var nrex = /^[a-zA-Z0-9\s]{3,100}$/;
      var brex = /^[a-zA-Z0-9\s]{3,100}[!@#$%^.,%&<>'":;/_|]{0,3}$/;
      var urex = /^[0-9]{1,9}$/;
      if (fileInput1.files[0] != undefined) {
        if (fileInput1.files[0].size > this.maximumSize) {
          this.errorMessage.image1 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput1.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image1 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image1 = "";
        }
      }

      if (fileInput2.files[0] != undefined) {
        if (fileInput2.files[0].size > this.maximumSize) {
          this.errorMessage.image2 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput2.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image2 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image2 = "";
        }
      }

      if (fileInput3.files[0] != undefined) {
        if (fileInput3.files[0].size > this.maximumSize) {
          this.errorMessage.image3 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput3.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image3 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image3 = "";
        }
      }

      if (fileInput4.files[0] != undefined) {
        if (fileInput4.files[0].size > this.maximumSize) {
          this.errorMessage.image4 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput4.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image4 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image4 = "";
        }
      }

      if (fileInput5.files[0] != undefined) {
        if (fileInput5.files[0].size > this.maximumSize) {
          this.errorMessage.image5 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput5.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image5 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image5 = "";
        }
      }

      if (fileInput6.files[0] != undefined) {
        if (fileInput6.files[0].size > this.maximumSize) {
          this.errorMessage.image6 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = '1';
        } else if (this.allowableTypes.indexOf(fileInput6.files[0].type.toLowerCase()) === -1) {
          this.errorMessage.image6 = "Invalid Image Type";
          submit_true = '1';
        } else {
          this.errorMessage.image6 = "";
        }
      }

      if (this.disabled === 0) {

        if (this.product.productbarcodesymbol == '') {
          this.hasErrors.productbarcodesymbol = true;
          this.errorMessage.productbarcodesymbol = "Required";
          submit_true = '1';
        } else if (this.product.productbarcodesymbol.length > 20) {
          this.hasErrors.productbarcodesymbol = true;
          this.errorMessage.productbarcodesymbol = "Cannot be greater than 20 characters";
          submit_true = '1';
        } else if (this.product.productbarcodesymbol.length < 2) {
          this.hasErrors.productbarcodesymbol = true;
          this.errorMessage.productbarcodesymbol = "Cannot be less than 1 character";
          submit_true = '1';
        }
      }

      if (this.product.productname.length > 100) {
        this.hasErrors.productname = true;
        this.errorMessage.productname = " Enter maximum 100 characters";
        submit_true = '1';
      }

      if (this.product.productname == '') {
        this.hasErrors.productname = true;
        this.errorMessage.productname = "Required";
        submit_true = '1';
      } else {
        this.errorMessage.productname = '';
      }

      if (submit_true == '0') {

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.imagefun1(), this.imagefun2(), this.imagefun3(), this.imagefun4(), this.imagefun5(), this.imagefun6()]).then(function (user) {
          _this.productval(_this, user);
        });
      } else {
        _this.loading = false;
      }
    },
    productval: function productval(_this, user) {
      this.loading = true;
      var product = {};
      var tempArr = [];
      for (var i = 0; i < user.length; i++) {
        if (user[i] != null) {
          tempArr.push(user[i]);
        }
      }
      if (tempArr.length == 0) {
        tempArr = null;
      }
      if (this.selectedCategory != undefined) {
        product.category_id = this.selectedCategory.category_id;
      }
      if (this.selectedSub != undefined) {
        product.sub_category_id = this.selectedSub.sub_category_id;
      }
      if (this.selectedUnit != undefined) {
        product.unit_id = this.selectedUnit.unit_id;
      }
      if (this.selectedBrand != undefined) {
        product.brand_id = this.selectedBrand.brand_id;
      }
      if (this.selectedHsn != undefined) {
        product.hsn_id = this.selectedHsn.hsn_id;
      }
      if (this.selectedTax != undefined) {
        product.tax_gst_id = this.selectedTax.tax_id;
      }
      if (this.product.variantname != undefined) {
        product.variant_id = this.product.variantname.variant_id;
      }
      product.alt_product_id = this.product.altproductid, product.product_name = this.product.productname, product.product_desc = this.product.productdesc, product.product_barcode_symbol = this.product.productbarcodesymbol, product.product_alert_qty = this.product.productalertqty, product.product_track_req = this.checkboxqty, product.product_tax_method = this.checkboxtk, product.img = tempArr, product.specification = '', product.specRow = this.specs;
      product.product_cf1 = this.product.productcf1, product.product_cf2 = this.product.productcf2, product.product_cf3 = this.product.productcf3, product.product_cf1_value = this.product.productcf_val1, product.product_cf2_value = this.product.productcf_val2, product.product_cf3_value = this.product.productcf_val3, product.disabled = this.disabled;

      if (this.productedit == 0) {
        this.$http.post('/api/companyproducts', product).then(function (response) {
          _this.reset();
          if (response.status === 200) {
            _this.loading = false;
            _this.largeModal = false;

            alert('Product Added Successfully');
            _this.$store.commit('set_productmodal', response.data);
          } else {
            if (user != null) {
              return _this.$http.delete('/api/containers/pics/files/' + user);
            }
          }
        }).catch(function (error) {
          _this.loading = false;
          if (user != null) {
            return _this.$http.delete('/api/containers/pics/files/' + user);
          }
        });
      }
    }
  }, 'reset', function reset() {
    var _this = this;
    _this.reset_specs();

    _this.product.imageArr = [];
    _this.product.imageUrl = [];
    _this.product.variantname = null;
    _this.product.altproductid = '';
    _this.product.productname = '';
    _this.product.productdesc = '';
    _this.product.productbarcodesymbol = '';
    _this.product.productalertqty = '';
    _this.product.productcf1 = '';
    _this.product.productcf_val1 = '';
    _this.product.specname = '';
    _this.product.specdesc = '';
    _this.selectedCategory = null;
    _this.subcategory = [];
    _this.selectedSubc = null;
    _this.selectedBrand = null;
    _this.selectedHsn = null;
    _this.selectedTax = null;
    _this.taxopt = [];
    _this.selectedUnit = null;
    _this.hasErrors.message = false;
    _this.errorMessage.message = null;
    _this.hasErrors.selectedHsn = false;
    _this.hasErrors.productbarcodesymbol = false;
    _this.errorMessage.selectedHsn = null;
    _this.hasErrors.selectedTax = false;
    _this.errorMessage.selectedTax = null;
    _this.errorMessage.productbarcodesymbol = '';
    _this.hasErrors.productname = false;
    _this.errorMessage.productname = null;
    _this.productedit = 0;
    _this.producteditvalue = null;
    _this.pluscheck = false;
    _this.product.productcf2 = '';
    _this.product.productcf3 = '';
    _this.product.productcf_val2 = '';
    _this.product.productcf_val3 = '';
    _this.checkboxqty = false;
    _this.checkboxtk = false;
    _this.selectedSub = null;
    _this.image1 = null;
    _this.image2 = null;
    _this.image3 = null;
    _this.image4 = null;
    _this.image5 = null;
    _this.image6 = null;
    _this.productimagevalue1 = null;
    _this.productimagevalue2 = null;
    _this.productimagevalue3 = null;
    _this.productimagevalue4 = null;
    _this.productimagevalue5 = null;
    _this.productimagevalue6 = null;
  }),

  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__modal_plugins_js__["a" /* default */].EventBus.$on('show', function (params) {
      _this2.show(params);
    });
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_setting_AddShopModal_vue__ = __webpack_require__(1124);



var shopModal = {
  install: function install(Vue, options) {
    this.EventBus = new Vue();

    Vue.component('addshopmodal', __WEBPACK_IMPORTED_MODULE_0__views_setting_AddShopModal_vue__["a" /* default */]);

    Vue.prototype.$addshopmodal = {
      showShop: function showShop(params) {
        shopModal.EventBus.$emit('showShop', params);
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (shopModal);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shop_plugins_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(36);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shop',
  components: { Spinner: __WEBPACK_IMPORTED_MODULE_1__spinner_vue__["a" /* default */] },
  data: function data() {
    return {
      center: { lat: 19.283442, lng: 72.870092 },
      largeModal1: false,
      largeModal: false,
      loading: false,
      cityopt: [],
      stateopt: [],
      conopt: [],

      citysrchopt: [],

      con: null,
      state: null,
      city: null,
      shoptype: [],
      editid: null,
      shopid: null,
      shpusername: null,
      buttosstat: 0,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10
      },
      shop: {
        name: '',
        phone: '',
        address1: '',
        address2: '',
        pincode: '',
        gst: '',
        sale_price_editable: false
      },
      search: {
        name: '',
        city: null,
        address2: '',
        pincode: ''
      },
      columns: [{
        label: 'Shop Name',
        field: 'est_shop_name',
        width: '40%'
      }, {
        label: 'Shop Type',
        field: 'est_type',
        width: '20%'
      }, {
        label: 'Shop Phone',
        field: 'est_shop_phone',
        width: '10%'
      }, {
        label: 'Pincode',
        field: 'pincode',
        width: '10%'
      }, {
        label: 'City',
        field: 'cities.city_name',
        width: '10%'
      }, {
        label: 'Action',
        field: 'action',
        width: '10%'
      }],
      rows: [],
      hasErrors: {
        message: false,
        shopnm: false,
        shopad1: false,
        shopad2: false,
        shoppin: false,
        shop_gst: false,
        shopph: false,
        shopcntry: false,
        shopstate: false,
        shopcity: false,
        cmptype: false,
        shopadmin: false,
        shopnmexist: false
      },
      errorMessage: {
        message: ''
      },
      warningModal: false,
      markers: [{ position: null }],
      place: null
    };
  },


  mounted: function mounted() {
    if (navigator.geolocation) {
      var self = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        self.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        self.markers.push({
          position: {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        });
      });
    }
  },

  methods: {
    chkShopExist: function chkShopExist() {
      var _this = this;

      if (this.shop.name != '') {
        this.$http.get('/api/shopestablishments/chk_shop_exist?filter[where][est_shop_name]=' + this.shop.name).then(function (response) {
          if (response.data.length > 0) {
            _this.shop.name = '';
            _this.hasErrors.shopnmexist = true;
            _this.$refs['txtshopname'].focus();
          }
        }).catch(function (error) {
          _this.hasErrors.shopnmexist = false;
        });
      } else {
        _this.hasErrors.shopnmexist = false;
      }
    },
    hide: function hide() {
      this.largeModal = false;
    },
    nameAndnumber: function nameAndnumber(item) {
      return item.username + ' - ' + item.phone;
    },
    shopuser: function shopuser() {
      var _this = this;
      this.$http.get('/api/shopusers').then(function (response) {}).catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
        if (error.response.data.error.message === "Cannot read property 'cmpname' of null") {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null);
          _this.$router.push('/');
        }
      });
    },
    fillshopgst: function fillshopgst() {
      var _this = this;
      this.$http.get('/api/companies/findOne').then(function (response) {
        _this.shop.gst = response.data.cmp_gst;
      });
    },
    openwarning: function openwarning() {
      this.largeModal = false;
      this.warningModal = true;
      this.buttosstat = 0;
    },
    showShop: function showShop(params) {

      this.shoptype = 'shop';
      this.hasErrors.cmptype = '';
      this.hasErrors.shopnm = '';
      this.hasErrors.shopad1 = '';
      this.hasErrors.shopad2 = '';
      this.hasErrors.shoppin = '';
      this.hasErrors.shop_gst = '';
      this.hasErrors.shopph = '';
      this.hasErrors.shopcntry = '';
      this.hasErrors.shopadmin = '';
      this.hasErrors.shopstate = '';
      this.hasErrors.shopcity = '';
      this.hasErrors.message = '';
      this.hasErrors.shopnmexist = '';
      this.errorMessage.message = '';
      this.shop.name = '';
      this.shop.address1 = '';
      this.shop.address2 = '';
      this.shop.pincode = '';
      this.shop.gst = '';
      this.shop.phone = '';
      this.editid = null;
      this.shopid = null;
      this.shpusername = null;
      this.conopt = params['countries'];

      this.fillshopgst();
      this.largeModal = true;
    },
    getMarkerPosition: function getMarkerPosition(marker) {
      this.center = { lat: marker.lat(), lng: marker.lng() };
    },
    state1: function state1(conopt) {
      this.stateopt = [];
      this.cityopt = [];
      this.state = null;
      this.city = null;
      var _this = this;
      var id = conopt.id;
      this.$http.get('/api/states?filter[where][country_id]=' + id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1: function city1(stateopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      var id = stateopt.id;
      this.$http.get('/api/cities?filter[where][state_id]=' + id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    searchcity: function searchcity(name) {
      var _this = this;
      if (name.length > 2) {
        this.$http.get('/api/cities?filter[where][city_name][ilike]=%' + name + '%').then(function (response) {
          _this.citysrchopt = response.data;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    Successsub: function Successsub() {
      this.loading = true;
      var _this = this;
      _this.hasErrors.cmptype = false;
      _this.hasErrors.shopnm = false;
      _this.hasErrors.shopad1 = false;
      _this.hasErrors.shopad2 = false;
      _this.hasErrors.shoppin = false;
      _this.hasErrors.shop_gst = false;
      _this.hasErrors.shopph = false;
      _this.hasErrors.shopadmin = false;
      _this.hasErrors.shopcntry = false;
      _this.hasErrors.shopstate = false;
      _this.hasErrors.shopcity = false;
      _this.hasErrors.shopnmexist = false;
      var submit_true = 0;
      var regex = /^[a-zA-Z0-9\s,.'-/]{3,}$/;
      var prex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var eregex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
      if (this.shoptype.length == 0) {
        _this.hasErrors.cmptype = true;
        submit_true = 1;
      }
      if (regex.test(this.shop.name) == false) {
        _this.hasErrors.shopnm = true;
        submit_true = 1;
      }
      if (regex.test(this.shop.address1) == false) {
        _this.hasErrors.shopad1 = true;
        submit_true = 1;
      }

      if (this.con == null) {
        _this.hasErrors.shopcntry = true;
        submit_true = 1;
      }
      if (this.state == null) {
        _this.hasErrors.shopstate = true;
        submit_true = 1;
      }
      if (this.city == null) {
        _this.hasErrors.shopcity = true;
        submit_true = 1;
      }
      if (pirex.test(this.shop.pincode) == false) {
        _this.hasErrors.shoppin = true;
        submit_true = 1;
      }
      if (regex.test(this.shop.gst) == false && this.shop.gst != '') {
        _this.hasErrors.shop_gst = true;
        submit_true = 1;
      }
      if (prex.test(this.shop.phone) == false) {
        _this.hasErrors.shopph = true;
        submit_true = 1;
      }

      if (submit_true == 0) {

        var useradmin = null;
        var shp_username = null;
        var shp_userphone = null;


        var shop = {
          est_type: this.shoptype,
          est_shop_name: this.shop.name,
          est_shop_phone: this.shop.phone,
          address1: this.shop.address1,
          address2: this.shop.address2,
          pincode: this.shop.pincode,
          country_code: this.con.id,
          state_code: this.state.id,
          city: this.city.id,
          shop_gst: this.shop.gst,
          saleprice: this.shop.sale_price_editable,
          est_latitude: this.center.lat,
          est_longititude: this.center.lng,
          shopid: this.shopid,
          user_admin: useradmin,
          shpusername: shp_username,
          shpuserphone: shp_userphone
        };

        this.$http.post('/api/shopestablishments', shop).then(function (response) {
          _this.loading = false;
          _this.reset();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          _this.$store.commit('set_shopmodal', response.data.est_shop_id);
          _this.largeModal = false;
        }).catch(function (error) {
          _this.$store.commit('set_shopmodal', '');
          _this.loading = false;
        });
      } else {
        _this.loading = false;
      }
    },
    setPlace: function setPlace(place) {
      this.position = [];
      this.buttosstat = 0;
      this.place = place;
      this.center = { lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng() };
    },
    usePlace: function usePlace(place) {
      this.buttosstat = 1;
      this.markers = [];
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          }
        });
        this.place = null;
      } else {
        this.markers = [{ position: { lat: this.center.lat, lng: this.center.lng } }];
      }
    },
    revertbck: function revertbck() {
      this.largeModal = true;
      this.warningModal = false;
    },
    reset: function reset() {
      var _this = this;
      _this.shop.name = '';
      _this.con = null, _this.state = null;
      _this.city = null;
      _this.shoptype = null;
      _this.shop.address1 = '';
      _this.shop.address2 = '';
      _this.shop.pincode = '';
      _this.shop.gst = '';
      _this.shop.phone = '';
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__shop_plugins_js__["a" /* default */].EventBus.$on('showShop', function (params) {
      _this2.showShop(params);
    });
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_setting_AddSupplierModal_vue__ = __webpack_require__(1126);



var supplierModal = {
  install: function install(Vue, options) {
    this.EventBus = new Vue();

    Vue.component('addsuppliermodal', __WEBPACK_IMPORTED_MODULE_0__views_setting_AddSupplierModal_vue__["a" /* default */]);

    Vue.prototype.$addsuppliermodal = {
      showSupplier: function showSupplier(params) {
        supplierModal.EventBus.$emit('showSupplier', params);
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (supplierModal);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__supplier_modal_plugins_js__ = __webpack_require__(490);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add_supplier',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_2_vue2_editor__["VueEditor"], Spinner: __WEBPACK_IMPORTED_MODULE_1__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      access_token: null,
      customToolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }]],

      largeModal: false,

      loading: false,
      suptype: null,
      city: null,
      state: null,
      con: null,
      cityopt: [],
      stateopt: [],
      maximumSize: 500000,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      conopt: [],
      contyp: [],
      srch_cmptyp: [],
      display: {
        name: null,
        cmptyp: null,
        email: null,
        add1: null
      },

      supplier: {
        add: '',
        name: '',
        add2: '',
        pin: '',
        phone: '',
        email: '',
        gst: '',
        pan: '',
        cin: '',
        tan: '',
        contact: '',
        contactno: '',
        contactemail: '',
        profile: '',
        image: '',
        bankname: '',
        banknumber: '',
        bankholder: '',
        bankifsc: '',
        bankbranch: '',
        bankmicr: '',
        bankswift: ''
      },
      ed: {
        image1: '',
        image2: '',
        image3: '',
        image4: '',
        image5: '',
        image1_href: '',
        image2_href: '',
        image3_href: '',
        image4_href: '',
        image5_href: ''
      },
      hasErrors: {
        message: false,
        supnm: false,
        supad1: false,
        supad2: false,
        suppin: false,
        supph: false,
        supeml: false,
        supgst: false,
        suppan: false,
        supcin: false,
        suptan: false,
        supcont: false,
        supcontno: false,
        supconteml: false,
        supplierprf: false,
        image1: false,
        image2: false,
        image3: false,
        image4: false,
        image5: false,
        bankname: false,
        banknumber: false,
        bankholder: false,
        bankifsc: false,
        bankbranch: false,
        bankmicr: false,
        bankswift: false
      },
      errorMessage: {
        message: '',
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      }
    };
  },

  methods: {
    hide: function hide() {
      this.largeModal = false;
    },
    showSupplier: function showSupplier(params) {
      this.conopt = params["conopt"];
      this.contyp = params["contyp"];
      this.largeModal = true;
      this.reset_error();
      this.reset();
    },
    state1: function state1(conopt) {
      this.stateopt = [];
      this.cityopt = [];
      this.state = null;
      this.city = null;
      var _this = this;
      var id = conopt.id;
      this.$http.get('/api/states?filter[where][country_id]=' + id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1: function city1(stateopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      var id = stateopt.id;
      this.$http.get('/api/cities?filter[where][state_id]=' + id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    reset_error: function reset_error() {
      var _this = this;
      _this.hasErrors.supnm = false;
      _this.hasErrors.supad1 = false;
      _this.hasErrors.supad2 = false;
      _this.hasErrors.suppin = false;
      _this.hasErrors.supph = false;
      _this.hasErrors.supeml = false;
      _this.hasErrors.supgst = false;
      _this.hasErrors.suppan = false;
      _this.hasErrors.supcin = false;
      _this.hasErrors.suptan = false;
      _this.hasErrors.supcont = false;
      _this.hasErrors.supcontno = false;
      _this.hasErrors.supconteml = false;
      _this.hasErrors.supplierprf = false;
      _this.hasErrors.image1 = false;
      _this.hasErrors.image2 = false;
      _this.hasErrors.image3 = false;
      _this.hasErrors.image4 = false;
      _this.hasErrors.image5 = false;
      _this.hasErrors.bankname = false;
      _this.hasErrors.banknumber = false;
      _this.hasErrors.bankholder = false;
      _this.hasErrors.bankifsc = false;
      _this.hasErrors.bankbranch = false;
      _this.hasErrors.bankmicr = false;
      _this.hasErrors.bankswift = false;
    },
    Submit: function Submit() {
      var _this2 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.loading = true;
      var submit_true = this.validation();
      var _this = this;
      if (submit_true == '0') {

        var sup = {};

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          sup.sup_cmp_name = _this2.supplier.name;

          if (_this2.suptype != null) {
            sup.sup_cmp_type = _this2.suptype.id;
          } else {
            sup.sup_cmp_type = null;
          }

          sup.address1 = _this2.supplier.add;
          sup.address2 = _this2.supplier.add2;
          sup.pincode = _this2.supplier.pin;

          if (_this2.city != null) {
            sup.city = _this2.city.id;
          } else {
            sup.city = null;
          }

          if (_this2.state != null) {
            sup.state_code = _this2.state.id;
          } else {
            sup.state_code = null;
          }

          if (_this2.con != null) {
            sup.country_code = _this2.con.id;
          } else {
            sup.country_code = null;
          }

          sup.sup_cmp_phone = _this2.supplier.phone;
          sup.sup_cmp_email = _this2.supplier.email;
          sup.sup_cmp_gst = _this2.supplier.gst;
          sup.sup_cmp_pan = _this2.supplier.pan;
          sup.sup_cmp_cin = _this2.supplier.cin;
          sup.sup_cmp_tan = _this2.supplier.tan;
          sup.contact_person_name = _this2.supplier.contact;
          sup.contact_no = _this2.supplier.contactno;
          sup.contact_email = _this2.supplier.contactemail;
          sup.sup_cmp_cic_cert = user[0];
          sup.sup_cmp_gst_cert = user[1];
          sup.sup_cmp_pan_cert = user[2];
          sup.sup_cmp_tan_cert = user[3];
          sup.sup_cmp_logo = user[4];
          sup.sup_cmp_profile = _this2.supplier.profile;
          sup.bank_name = _this2.supplier.bankname;
          sup.acc_number = _this2.supplier.banknumber;
          sup.bank_holder_name = _this2.supplier.bankholder;
          sup.ifsc_code = _this2.supplier.bankifsc;
          sup.branch = _this2.supplier.bankbranch;
          sup.micr_code = _this2.supplier.bankmicr;
          sup.swift_code = _this2.supplier.bankswift;

          _this2.$http.post('/api/suppliers', sup).then(function (response) {
            _this.reset();
            _this.loading = false;
            alert('Supplier Added Successfully');
            _this.$store.commit('set_supmodal', response.data);
            _this.largeModal = false;
          }).catch(function (error) {
            _this.loading = false;
          });
        });
      } else {
        _this.loading = false;
      }
    },
    reset: function reset() {
      var _this = this;
      _this.supplier.name = '';
      _this.suptype = null;
      _this.supplier.add = '';
      _this.supplier.add2 = '';
      _this.supplier.pin = '';
      _this.con = null;
      _this.state = null;
      _this.city = null;
      _this.supplier.phone = '';
      _this.supplier.email = '';
      _this.supplier.gst = '';
      _this.supplier.pan = '';
      _this.supplier.cin = '';
      _this.supplier.tan = '';
      _this.supplier.contact = '';
      _this.supplier.contactno = '';
      _this.supplier.contactemail = '';
      document.getElementById("image1").value = '';
      document.getElementById("image2").value = '';
      document.getElementById("image3").value = '';
      document.getElementById("image4").value = '';
      document.getElementById("image5").value = '';
      _this.supplier.profile = '';
      _this.supplier.bankname = '';
      _this.supplier.banknumber = '';
      _this.supplier.bankifsc = '';
      _this.supplier.bankbranch = '';
      _this.supplier.bankmicr = '';
      _this.supplier.bankswift = '';
      _this.ed.image1 = '';
      _this.ed.image2 = '';
      _this.ed.image3 = '';
      _this.ed.image4 = '';
      _this.ed.image5 = '';
      _this.ed.image1_href = '';
      _this.ed.image2_href = '';
      _this.ed.image3_href = '';
      _this.ed.image4_href = '';
      _this.ed.image5_href = '';
    },
    image1: function (_image) {
      function image1(_x) {
        return _image.apply(this, arguments);
      }

      image1.toString = function () {
        return _image.toString();
      };

      return image1;
    }(function (callback) {
      var _this = this;
      if (this.ed.image1 != '') {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image1);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image1;
        }
      } else {
        var _image2 = document.querySelector('#image1');
        if (_image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return '';
        }
      }
    }),
    image2: function (_image3) {
      function image2(_x2) {
        return _image3.apply(this, arguments);
      }

      image2.toString = function () {
        return _image3.toString();
      };

      return image2;
    }(function (callback) {
      var _this = this;
      if (this.ed.image2 != '') {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image2);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image2;
        }
      } else {
        var _image4 = document.querySelector('#image2');
        if (_image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    image3: function (_image5) {
      function image3(_x3) {
        return _image5.apply(this, arguments);
      }

      image3.toString = function () {
        return _image5.toString();
      };

      return image3;
    }(function (callback) {
      var _this = this;
      if (this.ed.image3 != '') {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image3);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image3;
        }
      } else {
        var _image6 = document.querySelector('#image3');
        if (_image6.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    image4: function (_image7) {
      function image4(_x4) {
        return _image7.apply(this, arguments);
      }

      image4.toString = function () {
        return _image7.toString();
      };

      return image4;
    }(function (callback) {
      var _this = this;
      if (this.ed.image4 != '') {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image4);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image4;
        }
      } else {
        var _image8 = document.querySelector('#image4');
        if (_image8.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image8.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    image5: function (_image9) {
      function image5(_x5) {
        return _image9.apply(this, arguments);
      }

      image5.toString = function () {
        return _image9.toString();
      };

      return image5;
    }(function (callback) {
      var _this = this;
      if (this.ed.image5 != '') {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image5);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image5;
        }
      } else {
        var _image10 = document.querySelector('#image5');
        if (_image10.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image10.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    validation: function validation(boolean) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      var image2 = document.querySelector('#image2');
      var image3 = document.querySelector('#image3');
      var image4 = document.querySelector('#image4');
      var image5 = document.querySelector('#image5');

      this.reset_error();

      var submit_true = '0';
      var nrex = /^[a-zA-Z\s]{3,100}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var aregex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      var prex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var accregex = /^[0-9]{3,30}$/;
      var eregex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;

      if (aregex.test(this.supplier.name) == false) {
        _this.hasErrors.supnm = true;
        submit_true = '1';
      } else if (this.supplier.name.length > 100) {
        _this.hasErrors.supnm = true;
        submit_true = 1;
      }

      if (this.supplier.add != "") {
        if (aregex.test(this.supplier.add) == false) {
          _this.hasErrors.supad1 = true;
          submit_true = 1;
        } else if (this.supplier.add.length > 100) {
          _this.hasErrors.supad1 = true;
          submit_true = 1;
        }
      }

      if (this.supplier.add2 != "") {
        if (aregex.test(this.supplier.add2) == false) {
          _this.hasErrors.supad2 = true;
          submit_true = 1;
        } else if (this.supplier.add2.length > 100) {
          _this.hasErrors.supad2 = true;
          submit_true = 1;
        }
      }

      if (this.supplier.pin != "") {
        if (pirex.test(this.supplier.pin) == false) {
          _this.hasErrors.suppin = true;
          submit_true = 1;
        } else if (this.supplier.pin.length > 10) {
          _this.hasErrors.suppin = true;
          submit_true = 1;
        }
      }

      if (prex.test(this.supplier.phone) == false) {
        _this.hasErrors.supph = true;
        submit_true = 1;
      } else if (this.supplier.phone.length > 15) {
        _this.hasErrors.supph = true;
        submit_true = 1;
      }

      if (this.supplier.email != "") {
        if (eregex.test(this.supplier.email) == false) {
          _this.hasErrors.supeml = true;
          submit_true = 1;
        } else if (this.supplier.email.length > 70) {
          _this.hasErrors.supeml = true;
          submit_true = 1;
        }
      }

      if (this.supplier.gst != "") {
        if (regex.test(this.supplier.gst) == false) {
          _this.hasErrors.supgst = true;
          submit_true = 1;
        } else if (this.supplier.gst.length > 15) {
          _this.hasErrors.supgst = true;
          submit_true = 1;
        }
      }

      if (this.supplier.pan != "") {
        if (regex.test(this.supplier.pan) == false) {
          _this.hasErrors.suppan = true;
          submit_true = 1;
        } else if (this.supplier.pan.length > 10) {
          _this.hasErrors.suppan = true;
          submit_true = 1;
        }
      }

      if (this.supplier.cin != "") {
        if (regex.test(this.supplier.cin) == false) {
          _this.hasErrors.supcin = true;
          submit_true = 1;
        } else if (this.supplier.cin.length > 25) {
          _this.hasErrors.supcin = true;
          submit_true = 1;
        }
      }

      if (this.supplier.tan != "") {
        if (regex.test(this.supplier.tan) == false) {
          _this.hasErrors.suptan = true;
          submit_true = 1;
        } else if (this.supplier.tan.length > 12) {
          _this.hasErrors.suptan = true;
          submit_true = 1;
        }
      }

      if (this.supplier.profile != "") {
        if (this.supplier.profile.length > 255) {
          _this.hasErrors.supplierprf = true;
          submit_true = 1;
        }
      }

      if (this.supplier.contact != "") {
        if (nrex.test(this.supplier.contact) == false) {
          _this.hasErrors.supcont = true;
          submit_true = 1;
        } else if (this.supplier.contact.length > 100) {
          _this.hasErrors.supcont = true;
          submit_true = 1;
        }
      }

      if (this.supplier.contactno != "") {
        if (prex.test(this.supplier.contactno) == false) {
          _this.hasErrors.supcontno = true;
          submit_true = 1;
        } else if (this.supplier.contactno.length > 15) {
          _this.hasErrors.supcontno = true;
          submit_true = 1;
        }
      }

      if (this.supplier.contactemail != "") {
        if (eregex.test(this.supplier.contactemail) == false) {
          _this.hasErrors.supconteml = true;
          submit_true = 1;
        } else if (this.supplier.contactemail.length > 70) {
          _this.hasErrors.supconteml = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankname != "") {
        if (regex.test(this.supplier.bankname) == false) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        } else if (this.supplier.bankname.length > 20) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        }
      }

      if (this.supplier.banknumber != "") {
        if (accregex.test(this.supplier.banknumber) == false) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        } else if (this.supplier.banknumber.length > 20) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankholder != "") {
        if (regex.test(this.supplier.bankholder) == false) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        } else if (this.supplier.bankholder.length > 50) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankifsc != "") {
        if (regex.test(this.supplier.bankifsc) == false) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        } else if (this.supplier.bankifsc.length > 20) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankbranch != "") {
        if (regex.test(this.supplier.bankbranch) == false) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        } else if (this.supplier.bankbranch.length > 20) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankmicr != "") {
        if (regex.test(this.supplier.bankmicr) == false) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        } else if (this.supplier.bankmicr.length > 20) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        }
      }

      if (this.supplier.bankswift != "") {
        if (regex.test(this.supplier.bankswift) == false) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        } else if (this.supplier.bankswift.length > 20) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        }
      }

      if (image1.files[0] != undefined) {
        if (image1.files[0].size > this.maximumSize) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image1.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image2.files[0] != undefined) {
        if (image2.files[0].size > this.maximumSize) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image2.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image3.files[0] != undefined) {
        if (image3.files[0].size > this.maximumSize) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image3.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image4.files[0] != undefined) {
        if (image4.files[0].size > this.maximumSize) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image4.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image5.files[0] != undefined) {
        if (image5.files[0].size > this.maximumSize) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image5.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Invalid Image Type";
          submit_true = 1;
        }
      }
      return submit_true;
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_3__supplier_modal_plugins_js__["a" /* default */].EventBus.$on('showSupplier', function (params) {
      _this3.showSupplier(params);
    });
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_setting_AddCustomerModal_vue__ = __webpack_require__(1128);



var customerModal = {
  install: function install(Vue, options) {
    this.EventBus = new Vue();

    Vue.component('addcustomermodal', __WEBPACK_IMPORTED_MODULE_0__views_setting_AddCustomerModal_vue__["a" /* default */]);

    Vue.prototype.$addcustomermodal = {
      showCustomer: function showCustomer(params) {
        customerModal.EventBus.$emit('showCustomer', params);
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (customerModal);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customer_modal_plugins_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_editor__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add_customer',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_4_vue2_editor__["VueEditor"], Spinner: __WEBPACK_IMPORTED_MODULE_3__spinner_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      shipdisable: true,
      access_token: null,
      customToolbar: [['bold', 'italic', 'underline'], [{ 'list': 'ordered' }, { 'list': 'bullet' }]],

      largeModal: false,
      shippingstate: null,
      shippingcity: null,
      shippingcityopt: [],
      loading: false,
      suptype: null,
      city: null,
      state: null,
      con: null,
      cityopt: [],
      stateopt: [],
      conopt: [],
      maximumSize: 500000,
      allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
      contyp: [],
      srch_cmptyp: [],
      address: {
        sname: '',
        saddress: '',
        spincode: '',
        sstate: '',
        sstateid: '',
        scity: '',
        scityid: '',
        sphn: '',
        sgst: ''
      },
      addr: [],
      display: {
        name: null,
        cmptyp: null,
        email: null,
        add1: null
      },

      customer: {
        add: '',
        name: '',
        add2: '',
        pin: '',
        phone: '',
        email: '',
        gst: '',
        pan: '',
        cin: '',
        tan: '',
        contact: '',
        contactno: '',
        contactemail: '',
        profile: '',
        image: '',
        bankname: '',
        banknumber: '',
        bankholder: '',
        bankifsc: '',
        bankbranch: '',
        bankmicr: '',
        bankswift: ''
      }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'address', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'ed', {
      image1: '',
      image2: '',
      image3: '',
      image4: '',
      image5: '',
      image1_href: '',
      image2_href: '',
      image3_href: '',
      image4_href: '',
      image5_href: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hasErrors1', {
      errsname: false,
      errsaddress: false,
      errsstate: false,
      errscity: false,
      errspincode: false,
      errsphn: false,
      errsgst: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'hasErrors', {
      message: false,
      custnm: false,
      custad1: false,
      custad2: false,
      custpin: false,
      custph: false,
      custeml: false,
      custgst: false,
      custpan: false,
      custcin: false,
      custtan: false,
      custcont: false,
      custcontno: false,
      custconteml: false,
      supplierprf: false,
      image1: false,
      image2: false,
      image3: false,
      image4: false,
      image5: false,
      bankname: false,
      banknumber: false,
      bankholder: false,
      bankifsc: false,
      bankbranch: false,
      bankmicr: false,
      bankswift: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'errorMessage', {
      message: '',
      image1: null,
      image2: null,
      image3: null,
      image4: null,
      image5: null
    }), _ref;
  },

  methods: {
    hide: function hide() {
      this.largeModal = false;
    },
    deleteadd: function deleteadd(indx) {
      this.addr.splice(indx, 1);
    },
    shippingenable: function shippingenable() {
      if (this.customer.add.trim() !== "") {
        this.shipdisable = false;
      } else {
        this.shipdisable = true;
      }
    },
    addValues: function addValues() {
      this.address.scity = this.shippingcity.city_name;
      this.address.scityid = this.shippingcity.id;
      var phnrex = /^[0-9]{10,15}$/;
      var pinrex = /^\d{0}$|^\d{6}$/;
      var nrex = /^[a-zA-Z\s]{0}$|^[a-zA-Z\s]{2,50}$/;
      var nmrex = /^[a-zA-Z\s]{2,50}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var _this = this;
      var nm = this.address.sname;
      var adrs = this.address.saddress;
      var pncd = this.address.spincode;
      var st = this.address.sstate;
      var ct = this.address.scity;
      var phn = this.address.sphn;
      var stid = this.address.sstateid;
      var ctid = this.address.scityid;
      var gst = this.address.sgst;
      var add_true = 1;
      _this.hasErrors1.errscity = '';
      _this.hasErrors1.errsstate = '';
      _this.hasErrors1.errsphn = '';
      _this.hasErrors1.errspincode = '';
      _this.hasErrors1.errsaddress = '';
      _this.hasErrors1.errsname = '';
      _this.hasErrors1.errsgst = '';
      if (nm == undefined) {
        nm = '';
      }

      if (adrs == undefined) {
        adrs = '';
      }

      if (phn == undefined) {
        phn = '';
      }

      if (pncd == undefined) {
        pncd = '';
      }

      if (ct == undefined) {
        ct = '';
      }

      if (st == undefined) {
        st = '';
      }
      if (gst === undefined) {
        gst = '';
      }

      if (nm == '') {
        add_true = 0;
        this.hasErrors1.errsname = 'Required';
      } else if ((nm.length < 2 || nm.length > 50) && nm != '') {
        add_true = 0;
        this.hasErrors1.errsname = 'Enter maximum 50 and minimum 2 letters';
      }

      if (adrs == '' && nm == '' && phn == '') {
        add_true = 0;
      }
      if (adrs == '' && nm == '' && phn == '' && st == '' && ct == '' && pncd == '') {
        add_true = 0;
      }
      if (adrs == '') {
        this.hasErrors1.errsaddress = 'Required';
        add_true = 0;
      } else if (adrs.length < 2 || adrs.length > 200) {
        this.hasErrors1.errsaddress = 'Enter maximum 200 and minimum 2 letters';
        add_true = 0;
      } else {}

      if (gst !== "") {
        if (regex.test(gst) === false) {
          add_true = 0;
          this.hasErrors1.errsgst = true;
        } else if (gst.length > 15) {
          add_true = 0;
          this.hasErrors1.errsgst = true;
        }
      }

      if (phnrex.test(phn) == false) {
        if (phn == '') {
          this.hasErrors1.errsphn = 'Required';
        } else if (phn.length < 10 || phn.length > 15) {
          this.hasErrors1.errsphn = 'Enter maximum 15 and minimum 10 numbers';
        } else {
          this.hasErrors1.errsphn = 'Enter valid phone number';
        }

        add_true = 0;
      }

      if (pinrex.test(pncd) == false) {
        if (pncd != '') {
          this.hasErrors1.errspincode = 'Enter valid pincode';
          add_true = 0;
        }
      }

      if (add_true == 1) {
        this.addr.push({ yname: nm, yaddress: adrs, ypincode: pncd, ystate: st, ycity: ct, yphn: phn, ystateid: stid, ycityid: ctid, ycountry: this.con.id, ygst: gst });
        this.address.sname = '';
        this.address.saddress = '';
        this.address.spincode = '';
        this.address.sstate = '';
        this.address.sstateid = '';
        this.address.scity = '';
        this.address.scityid = '';
        this.address.sphn = '';
        this.address.sgst = '';
        this.shippingstate = null;
        this.shippingcity = null;
      }
    },
    state1: function state1(conopt) {
      this.cityopt = [];
      this.city = null;
      var _this = this;
      this.$http.get('/api/states?filter[where][country_id]=' + conopt.id).then(function (response) {
        _this.stateopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    city1: function city1(stateopt) {

      this.cityopt = [];
      this.city = null;

      var _this = this;

      this.$http.get('/api/cities?filter[where][state_id]=' + stateopt.id).then(function (response) {
        _this.cityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    shipping_city: function shipping_city(stateopt) {
      this.address.sstate = stateopt.state_name;
      this.address.sstateid = stateopt.id;
      this.shippingcityopt = [];
      this.shippingcity = null;
      var _this = this;
      this.$http.get('/api/cities?filter[where][state_id]=' + stateopt.id).then(function (response) {
        _this.shippingcityopt = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    reset_error: function reset_error() {
      var _this = this;
      _this.hasErrors.custnm = false;
      _this.hasErrors.custad1 = false;
      _this.hasErrors.custad2 = false;
      _this.hasErrors.custpin = false;
      _this.hasErrors.custph = false;
      _this.hasErrors.custeml = false;
      _this.hasErrors.custgst = false;
      _this.hasErrors.custpan = false;
      _this.hasErrors.custcin = false;
      _this.hasErrors.custtan = false;
      _this.hasErrors.custcont = false;
      _this.hasErrors.custcontno = false;
      _this.hasErrors.custconteml = false;
      _this.hasErrors.image1 = false;
      _this.hasErrors.image2 = false;
      _this.hasErrors.image3 = false;
      _this.hasErrors.image4 = false;
      _this.hasErrors.image5 = false;
      _this.hasErrors.bankname = false;
      _this.hasErrors.banknumber = false;
      _this.hasErrors.bankholder = false;
      _this.hasErrors.bankifsc = false;
      _this.hasErrors.bankbranch = false;
      _this.hasErrors.bankmicr = false;
      _this.hasErrors.bankswift = false;
      _this.hasErrors.supplierprf = false;
    },
    validation: function validation(boolean) {
      var _this = this;
      var image1 = document.querySelector('#image1');
      var image2 = document.querySelector('#image2');
      var image3 = document.querySelector('#image3');
      var image4 = document.querySelector('#image4');
      var image5 = document.querySelector('#image5');

      this.reset_error();

      var submit_true = '0';
      var nrex = /^[a-zA-Z\s]{3,100}$/;
      var regex = /^[a-zA-Z0-9\s]{3,100}$/;
      var aregex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/;
      var prex = /^[0-9]{10,15}$/;
      var pirex = /^[0-9]{6}$/;
      var accregex = /^[0-9]{3,30}$/;
      var eregex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;

      if (aregex.test(this.customer.name) == false) {
        _this.hasErrors.custnm = true;
        submit_true = 1;
      } else if (this.customer.name.length > 100) {
        _this.hasErrors.custnm = true;
        submit_true = 1;
      }

      if (this.customer.add != "") {
        if (aregex.test(this.customer.add) == false) {
          _this.hasErrors.custad1 = true;
          submit_true = 1;
        } else if (this.customer.add.length > 100) {
          _this.hasErrors.custad1 = true;
          submit_true = 1;
        }
      }

      if (this.customer.add2 != "") {
        if (aregex.test(this.customer.add2) == false) {
          _this.hasErrors.custad2 = true;
          submit_true = 1;
        } else if (this.customer.add2.length > 100) {
          _this.hasErrors.custad2 = true;
          submit_true = 1;
        }
      }

      if (this.customer.profile.length > 255) {
        _this.hasErrors.supplierprf = true;
        submit_true = 1;
      }

      if (this.customer.pin != "") {
        if (pirex.test(this.customer.pin) == false) {
          _this.hasErrors.custpin = true;
          submit_true = 1;
        } else if (this.customer.pin.length > 10) {
          _this.hasErrors.custpin = true;
          submit_true = 1;
        }
      }

      if (prex.test(this.customer.phone) == false) {
        _this.hasErrors.custph = true;
        submit_true = 1;
      } else if (this.customer.phone.length > 15) {
        _this.hasErrors.custph = true;
        submit_true = 1;
      }

      if (this.customer.email != "") {
        if (eregex.test(this.customer.email) == false) {
          _this.hasErrors.custeml = true;
          submit_true = 1;
        } else if (this.customer.email.length > 70) {
          _this.hasErrors.custeml = true;
          submit_true = 1;
        }
      }

      if (this.customer.gst != "") {
        if (regex.test(this.customer.gst) == false) {
          _this.hasErrors.custgst = true;
          submit_true = 1;
        } else if (this.customer.gst.length > 15) {
          _this.hasErrors.custgst = true;
          submit_true = 1;
        }
      }

      if (this.customer.pan != "") {
        if (regex.test(this.customer.pan) == false) {
          _this.hasErrors.custpan = true;
          submit_true = 1;
        } else if (this.customer.pan.length > 10) {
          _this.hasErrors.custpan = true;
          submit_true = 1;
        }
      }

      if (this.customer.cin != "") {
        if (regex.test(this.customer.cin) == false) {
          _this.hasErrors.custcin = true;
          submit_true = 1;
        } else if (this.customer.cin.length > 25) {
          _this.hasErrors.custcin = true;
          submit_true = 1;
        }
      }

      if (this.customer.tan != "") {
        if (regex.test(this.customer.tan) == false) {
          _this.hasErrors.custtan = true;
          submit_true = 1;
        } else if (this.customer.tan.length > 12) {
          _this.hasErrors.custtan = true;
          submit_true = 1;
        }
      }

      if (this.customer.contact != "") {
        if (nrex.test(this.customer.contact) == false) {
          _this.hasErrors.custcont = true;
          submit_true = 1;
        } else if (this.customer.contact.length > 100) {
          _this.hasErrors.custcont = true;
          submit_true = 1;
        }
      }

      if (this.customer.contactno != "") {
        if (prex.test(this.customer.contactno) == false) {
          _this.hasErrors.custcontno = true;
          submit_true = 1;
        } else if (this.customer.contactno.length > 15) {
          _this.hasErrors.custcontno = true;
          submit_true = 1;
        }
      }

      if (this.customer.contactemail != "") {
        if (eregex.test(this.customer.contactemail) == false) {
          _this.hasErrors.custconteml = true;
          submit_true = 1;
        } else if (this.customer.contactemail.length > 70) {
          _this.hasErrors.custconteml = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankname != "") {
        if (regex.test(this.customer.bankname) == false) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        } else if (this.customer.bankname.length > 20) {
          _this.hasErrors.bankname = true;
          submit_true = 1;
        }
      }

      if (this.customer.banknumber != "") {
        if (accregex.test(this.customer.banknumber) == false) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        } else if (this.customer.banknumber.length > 20) {
          _this.hasErrors.banknumber = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankholder != "") {
        if (regex.test(this.customer.bankholder) == false) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        } else if (this.customer.bankholder.length > 50) {
          _this.hasErrors.bankholder = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankifsc != "") {
        if (regex.test(this.customer.bankifsc) == false) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        } else if (this.customer.bankifsc.length > 20) {
          _this.hasErrors.bankifsc = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankbranch != "") {
        if (regex.test(this.customer.bankbranch) == false) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        } else if (this.customer.bankbranch.length > 20) {
          _this.hasErrors.bankbranch = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankmicr != "") {
        if (regex.test(this.customer.bankmicr) == false) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        } else if (this.customer.bankmicr.length > 20) {
          _this.hasErrors.bankmicr = true;
          submit_true = 1;
        }
      }

      if (this.customer.bankswift != "") {
        if (regex.test(this.customer.bankswift) == false) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        } else if (this.customer.bankswift.length > 20) {
          _this.hasErrors.bankswift = true;
          submit_true = 1;
        }
      }

      if (image1.files[0] != undefined) {
        if (image1.files[0].size > this.maximumSize) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image1.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image1 = true;
          this.errorMessage.image1 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image2.files[0] != undefined) {
        if (image2.files[0].size > this.maximumSize) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image2.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image2 = true;
          this.errorMessage.image2 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image3.files[0] != undefined) {
        if (image3.files[0].size > this.maximumSize) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image3.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image3 = true;
          this.errorMessage.image3 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image4.files[0] != undefined) {
        if (image4.files[0].size > this.maximumSize) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image4.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image4 = true;
          this.errorMessage.image4 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      if (image5.files[0] != undefined) {
        if (image5.files[0].size > this.maximumSize) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Image Size Cannot Be Greater Than 500kb";
          submit_true = 1;
        }
        if (this.allowableTypes.indexOf(image5.files[0].type.toLowerCase()) === -1) {
          this.hasErrors.image5 = true;
          this.errorMessage.image5 = "Invalid Image Type";
          submit_true = 1;
        }
      }

      return submit_true;
    },
    Submit: function Submit() {
      var _this2 = this;

      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation();
      var _this = this;

      if (submit_true == '0') {
        this.loading = true;

        var cust = {};
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.image1(), this.image2(), this.image3(), this.image4(), this.image5()]).then(function (user) {
          cust.cust_cmp_name = _this2.customer.name;

          if (_this2.suptype != null) {
            cust.cust_cmp_type = _this2.suptype.id;
          } else {
            cust.cust_cmp_type = null;
          }

          cust.address1 = _this2.customer.add;
          cust.address2 = _this2.customer.add2;
          cust.pincode = _this2.customer.pin;

          if (_this2.city != null) {
            cust.city = _this2.city.id;
          } else {
            cust.city = null;
          }

          if (_this2.state != null) {
            cust.state_code = _this2.state.id;
          } else {
            cust.state_code = null;
          }

          if (_this2.con != null) {
            cust.country_code = _this2.con.id;
          } else {
            cust.country_code = null;
          }
          cust.cust_cmp_phone = _this2.customer.phone;
          cust.cust_cmp_email = _this2.customer.email;
          cust.cust_cmp_gst = _this2.customer.gst;
          cust.cust_cmp_pan = _this2.customer.pan;
          cust.cust_cmp_cin = _this2.customer.cin;
          cust.cust_cmp_tan = _this2.customer.tan;
          cust.contact_person_name = _this2.customer.contact;
          cust.contact_no = _this2.customer.contactno;
          cust.contact_email = _this2.customer.contactemail;
          cust.cust_cmp_cic_cert = user[0];
          cust.cust_cmp_gst_cert = user[1];
          cust.cust_cmp_pan_cert = user[2];
          cust.cust_cmp_tan_cert = user[3];
          cust.cust_cmp_logo = user[4];
          cust.cust_cmp_profile = _this2.customer.profile;
          cust.bank_name = _this2.customer.bankname;
          cust.acc_number = _this2.customer.banknumber;
          cust.bank_holder_name = _this2.customer.bankholder;
          cust.ifsc_code = _this2.customer.bankifsc;
          cust.branch = _this2.customer.bankbranch;
          cust.micr_code = _this2.customer.bankmicr;
          cust.swift_code = _this2.customer.bankswift;
          cust.shippdetails = _this2.addr;
          _this2.$http.post('/api/customers', cust).then(function (response) {
            _this.reset();
            _this.loading = false;
            alert('Customer Added Successfully');
            _this.$store.commit('set_custmodal', response.data);
            _this.largeModal = false;
          }).catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
        });
      } else {
        _this.loading = false;
      }
    },
    reset: function reset() {
      var _this = this;
      _this.customer.name = '';
      _this.suptype = null;
      _this.customer.add = '';
      _this.customer.add2 = '';
      _this.customer.pin = '';

      _this.customer.phone = '';
      _this.customer.email = '';
      _this.customer.gst = '';
      _this.customer.pan = '';
      _this.customer.cin = '';
      _this.customer.tan = '';
      _this.customer.contact = '';
      _this.customer.contactno = '';
      _this.customer.contactemail = '';
      document.getElementById("image1").value = '';
      document.getElementById("image2").value = '';
      document.getElementById("image3").value = '';
      document.getElementById("image4").value = '';
      document.getElementById("image5").value = '';
      _this.customer.profile = '';
      _this.customer.bankname = '';
      _this.customer.banknumber = '';
      _this.customer.bankifsc = '';
      _this.customer.bankbranch = '';
      _this.customer.bankmicr = '';
      _this.customer.bankswift = '';
      _this.ed.image1 = '';
      _this.ed.image2 = '';
      _this.ed.image3 = '';
      _this.ed.image4 = '';
      _this.ed.image5 = '';
      _this.ed.image1_href = '';
      _this.ed.image2_href = '';
      _this.ed.image3_href = '';
      _this.ed.image4_href = '';
      _this.ed.image5_href = '';
      _this.address.sname = '';
      _this.address.sphn = '';
      _this.address.saddress = '';
      _this.address.sstate = '';
      _this.address.scity = '';
      _this.address.spincode = '';
      _this.address.sgst = '';
    },
    image1: function (_image) {
      function image1(_x) {
        return _image.apply(this, arguments);
      }

      image1.toString = function () {
        return _image.toString();
      };

      return image1;
    }(function (callback) {
      var _this = this;
      if (this.ed.image1 != '') {
        if (image1.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image1);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image1;
        }
      } else {
        var _image2 = document.querySelector('#image1');
        if (_image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return '';
        }
      }
    }),
    image2: function (_image3) {
      function image2(_x2) {
        return _image3.apply(this, arguments);
      }

      image2.toString = function () {
        return _image3.toString();
      };

      return image2;
    }(function (callback) {
      var _this = this;
      if (this.ed.image2 != '') {
        if (image2.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image2);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image2;
        }
      } else {
        var _image4 = document.querySelector('#image2');
        if (_image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    image3: function (_image5) {
      function image3(_x3) {
        return _image5.apply(this, arguments);
      }

      image3.toString = function () {
        return _image5.toString();
      };

      return image3;
    }(function (callback) {
      var _this = this;
      if (this.ed.image3 != '') {
        if (image3.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image3);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image3;
        }
      } else {
        var _image6 = document.querySelector('#image3');
        if (_image6.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image6.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    image4: function (_image7) {
      function image4(_x4) {
        return _image7.apply(this, arguments);
      }

      image4.toString = function () {
        return _image7.toString();
      };

      return image4;
    }(function (callback) {
      var _this = this;
      if (this.ed.image4 != '') {
        if (image4.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image4);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image4;
        }
      } else {
        var _image8 = document.querySelector('#image4');
        if (_image8.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image8.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    image5: function (_image9) {
      function image5(_x5) {
        return _image9.apply(this, arguments);
      }

      image5.toString = function () {
        return _image9.toString();
      };

      return image5;
    }(function (callback) {
      var _this = this;
      if (this.ed.image5 != '') {
        if (image5.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            _this.$http.delete('/api/containers/pics/files/' + _this.ed.image5);
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            return '';
          });
        } else {
          return this.ed.image5;
        }
      } else {
        var _image10 = document.querySelector('#image5');
        if (_image10.files[0] != undefined) {
          var formData = new FormData();
          formData.append('image', _image10.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          return '';
        }
      }
    }),
    showCustomer: function showCustomer(params) {
      this.addr = [];
      this.address.sname = '';
      this.address.saddress = '';
      this.address.spincode = '';
      this.address.sstate = '';
      this.address.scity = '';
      this.address.sphn = '';
      this.hasErrors1.errscity = '';
      this.hasErrors1.errsstate = '';
      this.hasErrors1.errsphn = '';
      this.hasErrors1.errspincode = '';
      this.hasErrors1.errsaddress = '';
      this.hasErrors1.errsname = '';
      this.conopt = params["conopt"];
      this.contyp = params["contyp"];
      this.con = params["con"];
      this.stateopt = params["stateopt"];
      this.state = params["state"];
      this.cityopt = params["cityopt"];
      this.city = params["city"];
      this.largeModal = true;
      this.reset_error();
      this.reset();
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_2__customer_modal_plugins_js__["a" /* default */].EventBus.$on('showCustomer', function (params) {
      _this3.showCustomer(params);
    });
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_good_table__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_snotify__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_search_select__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_tui_vue_barcode__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_plugins_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shop_plugins_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__supplier_modal_plugins_js__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__customer_modal_plugins_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__spinner_vue__ = __webpack_require__(3);
var _this2 = this;



















var config = __webpack_require__(201);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$config = config;

var options = {
  toast: {
    position: __WEBPACK_IMPORTED_MODULE_10_vue_snotify__["a" /* SnotifyPosition */].rightTop
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Spinner', __WEBPACK_IMPORTED_MODULE_17__spinner_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_snotify__["b" /* default */], options);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13__modal_plugins_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__shop_plugins_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__supplier_modal_plugins_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_16__customer_modal_plugins_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.baseURL = config.baseUrl;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.baseURL2 = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.baseURL;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('barcode', __WEBPACK_IMPORTED_MODULE_12_tui_vue_barcode__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_good_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('model-list-select', __WEBPACK_IMPORTED_MODULE_11_vue_search_select__["ModelListSelect"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDnvL5EInN-OPUgNbrArsNI3XYys8xYoOI',
    libraries: 'places'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_4_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
var VueResource = __webpack_require__(1130);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueResource);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  var _this = _this2;
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.userStore.authUser || __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.userStore.authUser === 'null')) {
    next({ path: '/' });
  } else {
    __WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers.common['authorization'] = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.userStore.authUser;
    next();
  }
});

if (window.localStorage) {
  var localUserString = localStorage.getItem('authUser') || 'null';
  if (localUserString && __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.userStore.authUser !== localUserString) {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('SET_AUTH_USER', localUserString);
  }
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f45b4c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(607);
function injectStyle (ssrContext) {
  __webpack_require__(605)
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f45b4c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('addproductmodal'),_vm._v(" "),_c('addshopmodal'),_vm._v(" "),_c('addsuppliermodal'),_vm._v(" "),_c('addcustomermodal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Full__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_verification__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_pages_Page404__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pages_ResetPassword__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_pages_Login__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_pages_Register__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_pages_AfterRegister__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Dashboard__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_AdminDashboard__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Registration__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_setting_Shop__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_setting_Role__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_setting_User__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_help__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_purches_addpurches__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_purches_editpurchase__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_purches_listpurches__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_purches_Listpurchesreturn__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_purches_Addpurchesreturn__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_purches_editpurchasereturn__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_purches_Supplier__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_purches_Purchasepayment__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_purches_purchasepaymenthistory__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_purches_PurchaseReturnpayment__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_sales_sales__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_sales_addsales__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_sales_editsales__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_sales_list__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_sales_salesreturn__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_sales_editsalesreturn__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_setting_Customer__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_sales_saleinvoice__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_sales_salepdf__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_sales_salepayment__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_sales_salepaymenthistory__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_sales_salereturnpayment__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_ShopInventory__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_transfer_listtransfer__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_transfer_addtransfer__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_product_addproduct__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_product_barcode__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_setting_Category__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_setting_Brand__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_setting_HSN__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_setting_Hsnrate__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_setting_variant__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_setting_unit__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_admin_pages_company_mgmt__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_admin_pages_user_mgmt__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_admin_pages_user_status_info__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_admin_pages_plan_config__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_reports_sales_pending_pay_list__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_reports_purchase_pending_pay_list_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__store__ = __webpack_require__(419);

































































__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

function doSomethingBeforeAllChildren(ax) {}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  hashbang: false,
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{ path: '*', component: __WEBPACK_IMPORTED_MODULE_5__views_pages_Page404__["a" /* default */] }, {
    path: '/verifyemail/:uid',
    beforeEnter: function beforeEnter(to, from, next) {
      var uid = to.params.uid;
      localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].commit('SET_AUTH_USER', null);
      next({ path: '/', query: { id: uid } });
    }
  }, {
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_7__views_pages_Login__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser || __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser === 'null' || localStorage.getItem('authUser') == null) {
        next();
      } else {
        next('/dashboard');
      }
    }
  }, {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_6__views_pages_ResetPassword__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser || __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser === 'null' || localStorage.getItem('authUser') == null) {
        next();
      } else {
        next('/dashboard');
      }
    }
  }, {
    name: 'Sale Invoice Pdf',
    path: '/saleinvoice/saleinvoicepdf',
    component: __WEBPACK_IMPORTED_MODULE_35__views_sales_salepdf__["a" /* default */],
    meta: { requiresAuth: true },
    beforeEnter: function beforeEnter(to, from, next) {
      next();
    }
  }, {
    path: '/afterregister',
    name: 'AfterRegister',
    component: __WEBPACK_IMPORTED_MODULE_9__views_pages_AfterRegister__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser || __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser === 'null') {
        next();
      } else {
        next('/dashboard');
      }
    }
  }, {
    path: '/register',
    name: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_8__views_pages_Register__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (!__WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser || __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.userStore.authUser === 'null') {
        next();
      } else {
        next('/dashboard');
      }
    }
  }, {
    path: '/authuser',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__containers_Full__["a" /* default */],
    meta: { requiresAuth: true },
    children: [{
      path: '/dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Dashboard__["a" /* default */],
      meta: { requiresAuth: true },
      beforeEnter: function beforeEnter(to, from, next) {
        var is_admin = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.is_admin;
        if (is_admin === true) {
          next('/admindashboard');
        } else {
          next();
        }
      }
    }, {
      path: '/admindashboard',
      name: 'Admin Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_11__views_AdminDashboard__["a" /* default */],
      meta: { requiresAuth: true }
    }, {
      path: '/companyinfo',
      redirect: '/companyinfo/registration',
      name: 'Company Info',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'registration',
        name: 'Company Registration',
        component: __WEBPACK_IMPORTED_MODULE_12__views_Registration__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var reg_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.reg_view;
          var reg_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.reg_rights;
          if (reg_view === true || reg_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/Companyinfo/Shop',
        name: 'Shop Details',
        component: __WEBPACK_IMPORTED_MODULE_13__views_setting_Shop__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var shop_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.shop_view;
          var shop_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.shop_rights;
          if (shop_view === true || shop_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }, {
      path: '/definesecurity',
      redirect: '/definesecurity/user',
      name: 'Define Security',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'user',
        name: 'Add & Update User',
        component: __WEBPACK_IMPORTED_MODULE_15__views_setting_User__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var u_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.u_view;
          var u_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.u_rights;
          if (u_view === true || u_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/Definesecurity/Role',
        name: 'Add & Update Role',
        component: __WEBPACK_IMPORTED_MODULE_14__views_setting_Role__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var r_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.r_view;
          var r_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.r_rights;

          if (r_view === true || r_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }, {
      path: '/help',
      name: 'Help',
      component: __WEBPACK_IMPORTED_MODULE_16__views_help__["a" /* default */],
      meta: { requiresAuth: true }
    }, {
      path: '/purchase',
      redirect: '/purchase/purchaseentry',
      name: 'Purchase',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'Addpurches',
        name: 'Add Purchase',
        component: __WEBPACK_IMPORTED_MODULE_17__views_purches_addpurches__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var pur_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.pur_rights;

          if (pur_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'editpurchase',
        name: 'Edit Purchase',
        component: __WEBPACK_IMPORTED_MODULE_18__views_purches_editpurchase__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var pur_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.pur_rights;

          if (pur_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'purchaseentry',
        name: 'Purchase Entry',
        component: __WEBPACK_IMPORTED_MODULE_19__views_purches_listpurches__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var pur_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.pur_view;
          var pur_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.pur_rights;
          if (pur_view === true || pur_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'Listpurchesreturn',
        name: 'List Purchase Return',
        component: __WEBPACK_IMPORTED_MODULE_20__views_purches_Listpurchesreturn__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var purrt_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purrt_view;
          var purrt_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purrt_rights;
          if (purrt_view === true || purrt_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'Addpurchesreturn',
        name: 'Add Purchase return',
        component: __WEBPACK_IMPORTED_MODULE_21__views_purches_Addpurchesreturn__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var purrt_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purrt_rights;

          if (purrt_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'editpurchasereturn',
        name: 'Edit Purchase Return',
        component: __WEBPACK_IMPORTED_MODULE_22__views_purches_editpurchasereturn__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var purrt_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purrt_rights;

          if (purrt_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'supplier/add',
        name: 'Add & Update Supplier',
        component: __WEBPACK_IMPORTED_MODULE_23__views_purches_Supplier__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var sup_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sup_view;
          var sup_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sup_rights;
          if (sup_view === true || sup_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'addpayment',
        name: 'Purchase Payment',
        component: __WEBPACK_IMPORTED_MODULE_24__views_purches_Purchasepayment__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var purpay_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purpay_rights;

          if (purpay_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/purchase/listpayment',
        name: 'List Payment',
        component: __WEBPACK_IMPORTED_MODULE_25__views_purches_purchasepaymenthistory__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var purpayhis_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purpayhis_view;
          var purpayhis_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purpayhis_rights;
          if (purpayhis_view === true || purpayhis_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/purchase/PurchaseReturnpayment',
        name: 'List Purchase Return Payment',
        component: __WEBPACK_IMPORTED_MODULE_26__views_purches_PurchaseReturnpayment__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var purchasert_v = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purchasereturnpay_view;
          var purchasert_r = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.purchasereturnpay_rights;
          if (purchasert_v === true || purchasert_r === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }, {
      path: '/sales',
      redirect: '/sales/salesentry',
      name: 'Sales',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/sales/salesentry',
        name: 'Sales Entry',
        component: __WEBPACK_IMPORTED_MODULE_27__views_sales_sales__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var sale_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sale_view;
          var sale_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sale_rights;
          if (sale_view === true || sale_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/sales/addsales',
        name: 'Add Sales',
        component: __WEBPACK_IMPORTED_MODULE_28__views_sales_addsales__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var sale_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sale_rights;

          if (sale_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/sales/editsales',
        name: 'Edit Sales',
        component: __WEBPACK_IMPORTED_MODULE_29__views_sales_editsales__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var sale_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sale_rights;

          if (sale_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Sales Return',
        path: '/Salesreturn/list',
        component: __WEBPACK_IMPORTED_MODULE_30__views_sales_list__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var salert_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salert_view;
          var salert_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salert_rights;
          if (salert_view === true || salert_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Edit Sales Return',
        path: 'editsalesreturn',
        component: __WEBPACK_IMPORTED_MODULE_32__views_sales_editsalesreturn__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {

          var salert_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salert_rights;

          if (salert_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Add Sales Return',
        path: '/Sales/Salesreturn',
        component: __WEBPACK_IMPORTED_MODULE_31__views_sales_salesreturn__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var salert_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salert_rights;

          if (salert_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/Sales/customeradd',
        name: 'Add & Update Customer',
        component: __WEBPACK_IMPORTED_MODULE_33__views_setting_Customer__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var cust_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.cust_view;
          var cust_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.cust_rights;
          if (cust_view === true || cust_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Sale Invoice',
        path: '/sales/saleinvoice/list',
        component: __WEBPACK_IMPORTED_MODULE_34__views_sales_saleinvoice__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var saleinvoice_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.saleinvoice_view;
          var saleinvoice_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.saleinvoice_rights;
          if (saleinvoice_view === true || saleinvoice_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Sale Receipt',
        path: '/sales/salereceipt',
        component: __WEBPACK_IMPORTED_MODULE_36__views_sales_salepayment__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var salerec_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salerec_rights;

          if (salerec_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Sales Receipt History',
        path: '/sales/Salesreceipthistory',
        component: __WEBPACK_IMPORTED_MODULE_37__views_sales_salepaymenthistory__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var salerechis_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salerechis_view;
          var salerechis_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salerechis_rights;
          if (salerechis_view === true || salerechis_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        name: 'Sales Return Receipt History',
        path: '/sales/SalesReturnreceipthistory',
        component: __WEBPACK_IMPORTED_MODULE_38__views_sales_salereturnpayment__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var salereturnpayment_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salereturnpay_view;
          var salereturnpayment_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.salereturnpay_rights;

          if (salereturnpayment_view === true || salereturnpayment_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }, {
      path: '/shopinventory',
      name: 'Shop Inventory',
      component: __WEBPACK_IMPORTED_MODULE_39__views_ShopInventory__["a" /* default */],
      meta: { requiresAuth: true },
      beforeEnter: function beforeEnter(to, from, next) {
        var invt_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.invt_view;
        var invt_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.invt_rights;
        if (invt_view === true || invt_rights === true) {
          next();
        } else {
          next('/dashboard');
        }
      }
    }, {
      path: '/CompaniesInfo',
      name: 'Companies Info',
      component: __WEBPACK_IMPORTED_MODULE_50__views_admin_pages_company_mgmt__["a" /* default */],
      meta: { requiresAuth: true },
      beforeEnter: function beforeEnter(to, from, next) {
        var is_admin = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.is_admin;

        if (is_admin === true) {
          next();
        } else {
          next('/dashboard');
        }
      }
    }, {
      path: '/PlanConfig',
      name: 'Plan Config',
      component: __WEBPACK_IMPORTED_MODULE_53__views_admin_pages_plan_config__["a" /* default */],
      meta: { requiresAuth: true },
      beforeEnter: function beforeEnter(to, from, next) {
        var is_admin = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.is_admin;

        if (is_admin === true) {
          next();
        } else {
          next('/dashboard');
        }
      }
    }, {
      path: '/user_management',
      redirect: '/user_management/user_info',
      name: 'User Management',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'user_info',
        name: 'User Info',
        component: __WEBPACK_IMPORTED_MODULE_51__views_admin_pages_user_mgmt__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var is_admin = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.is_admin;
          if (is_admin === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'user_status',
        name: 'User Status',
        component: __WEBPACK_IMPORTED_MODULE_52__views_admin_pages_user_status_info__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var is_admin = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.is_admin;
          if (is_admin === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }, {
      path: '/stocktransfer',
      name: 'Stock Transfer',
      component: __WEBPACK_IMPORTED_MODULE_40__views_transfer_listtransfer__["a" /* default */],
      meta: { requiresAuth: true },
      beforeEnter: function beforeEnter(to, from, next) {
        var stcktran_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.stcktran_view;
        var stcktran_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.stcktran_rights;
        if (stcktran_view === true || stcktran_rights === true) {
          next();
        } else {
          next('/dashboard');
        }
      }
    }, {
      path: '/addtransfer',
      name: 'Add Transfer',
      component: __WEBPACK_IMPORTED_MODULE_41__views_transfer_addtransfer__["a" /* default */],
      meta: { requiresAuth: true },
      beforeEnter: function beforeEnter(to, from, next) {
        var stcktran_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.stcktran_rights;

        if (stcktran_rights === true) {
          next();
        } else {
          next('/dashboard');
        }
      }
    }, {
      path: '/reports',
      redirect: '/reports/balance_receipt_list',
      name: 'Reports',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: '/reports/balance_receipt_list',
        name: 'Balance Receipy List',
        component: __WEBPACK_IMPORTED_MODULE_54__views_reports_sales_pending_pay_list__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var sale_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.sale_view;
          if (sale_view === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/reports/pending_payment_list',
        name: 'Pending Payment List',
        component: __WEBPACK_IMPORTED_MODULE_55__views_reports_purchase_pending_pay_list_vue__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var pur_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.pur_view;
          if (pur_view === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }, {
      path: '/setup',
      redirect: '/setup/addupdateproduct',
      name: 'Setup',
      meta: { requiresAuth: true },
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      children: [{
        path: 'addupdateproduct',
        name: 'Add & Update Product',
        component: __WEBPACK_IMPORTED_MODULE_42__views_product_addproduct__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var prod_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.prod_view;
          var prod_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.prod_rights;

          if (prod_view === true || prod_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'barcode',
        name: 'Print Barcode',
        component: __WEBPACK_IMPORTED_MODULE_43__views_product_barcode__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var prod_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.prod_view;
          var prod_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.prod_rights;

          if (prod_view === true || prod_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'addupdatecategory',
        name: 'Add & Update Category',
        component: __WEBPACK_IMPORTED_MODULE_44__views_setting_Category__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var cat_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.cat_view;
          var cat_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.cat_rights;

          if (cat_view === true || cat_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: 'addupdatebrand',
        name: 'Add & Update Brand',
        component: __WEBPACK_IMPORTED_MODULE_45__views_setting_Brand__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var brand_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.brand_view;
          var brand_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.brand_rights;

          if (brand_view === true || brand_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/taxdetails',
        name: 'Tax Details',
        redirect: '/setup/taxdetails/hsn',
        meta: { requiresAuth: true },
        component: {
          render: function render(d) {
            return d('router-view');
          }
        },
        children: [{
          path: '/setup/taxdetails/hsn',
          name: 'Hsn',
          component: __WEBPACK_IMPORTED_MODULE_46__views_setting_HSN__["a" /* default */],
          meta: { requiresAuth: true },
          beforeEnter: function beforeEnter(to, from, next) {
            var hsn_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.hsn_view;
            var hsn_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.hsn_rights;
            if (hsn_view === true || hsn_rights === true) {
              next();
            } else {
              next('/dashboard');
            }
          }
        }, {
          path: '/setup/taxdetails/hsnrate',
          name: 'Hsn Rate',
          component: __WEBPACK_IMPORTED_MODULE_47__views_setting_Hsnrate__["a" /* default */],
          meta: { requiresAuth: true },
          beforeEnter: function beforeEnter(to, from, next) {
            var tax_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.tax_view;
            var tax_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.tax_rights;

            if (tax_view === true || tax_rights === true) {
              next();
            } else {
              next('/dashboard');
            }
          }
        }]
      }, {
        path: '/setup/addupdatevariant',
        name: 'Add & Update Variant',
        component: __WEBPACK_IMPORTED_MODULE_48__views_setting_variant__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var var_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.var_view;
          var var_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.var_rights;

          if (var_view === true || var_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }, {
        path: '/setup/addupdateunit',
        name: 'Add & Update Unit',
        component: __WEBPACK_IMPORTED_MODULE_49__views_setting_unit__["a" /* default */],
        meta: { requiresAuth: true },
        beforeEnter: function beforeEnter(to, from, next) {
          var unit_view = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.unit_view;
          var unit_rights = __WEBPACK_IMPORTED_MODULE_56__store__["a" /* default */].state.unit_rights;

          if (unit_view === true || unit_rights === true) {
            next();
          } else {
            next('/dashboard');
          }
        }
      }]
    }]
  }]
}));

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c6fcd9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(657);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c6fcd9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'primary',
      text: 'NEW'
    }
  }, {
    title: true,
    name: 'Main-Navigation',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  }, {
    name: 'Product',
    url: '/product',
    icon: 'fa fa-cart-arrow-down',
    children: [{
      name: 'Addproduct',
      url: '/product/Addproduct',
      icon: 'fa fa-circle-thin'
    }, {
      name: 'Listproduct',
      url: '/product/Listproduct',
      icon: 'fa fa-circle-thin'
    }]
  }, {
    name: 'Purchase',
    url: '/purches',
    icon: 'fa fa-shopping-bag',
    children: [{
      name: 'AddPurchase',
      url: '/purches/Addpurches',
      icon: 'fa fa-circle-thin'
    }, {
      name: 'ListPurchase',
      url: '/purches/Listpurches',
      icon: 'fa fa-circle-thin'
    }, {
      name: 'AddPurchaseReturn',
      url: '/purches/Addpurchesreturn',
      icon: 'fa fa-circle-thin'
    }, {
      name: 'ListPurchaseReturn',
      url: '/purches/Listpurchesreturn',
      icon: 'fa fa-circle-thin'
    }]
  }, {
    name: 'Transfer',
    url: '/transfer',
    icon: 'icon-calculator',
    children: [{
      name: 'AddTransfer',
      url: '/transfer/Addtransfer',
      icon: 'fa fa-circle-thin'
    }, {
      name: 'ListTransfer',
      url: '/transfer/Listtransfer',
      icon: 'fa fa-circle-thin'
    }]
  }, {
    name: 'Sales',
    url: '/sales',
    icon: 'icon-pie-chart',
    children: [{
      name: 'Saleslist',
      url: '/sales/Sale',
      icon: 'fa fa-shopping-cart',
      children: [{
        name: 'SalesAdd',
        url: '/sales/Sale/add',
        icon: 'fa fa-circle-thin'
      }, {
        name: 'SalesList',
        url: '/sales/Sale/list',
        icon: 'fa fa-circle-thin'
      }]
    }, {
      name: 'SalesReturn',
      url: '/sales/Salesreturn',
      icon: 'fa fa-cart-arrow-down',
      children: [{
        name: 'SalesReturnAdd',
        url: '/sales/Salesreturn/add',
        icon: 'fa fa-circle-thin'
      }, {
        name: 'SalesReturnList',
        url: '/sales/Salesreturn/list',
        icon: 'fa fa-circle-thin'
      }]
    }, {
      name: 'Quotation',
      url: '/sales',
      icon: 'fa fa-list-alt',
      children: [{
        name: 'Add',
        url: '/sales/Quotation/addquotation',
        icon: 'fa fa-circle-thin'
      }, {
        name: 'List',
        url: '/sales/Quotation/listQuotation',
        icon: 'fa fa-circle-thin'
      }]
    }]
  }, {
    name: 'Setting',
    url: '/Setting',
    icon: 'icon-star',
    children: [{
      name: 'Supplier',
      url: '/Setting/supplier',
      icon: 'icon-star',
      children: [{
        url: '/Setting/supplier/add',
        name: 'SupplierAdd',
        icon: 'icon-star'
      }, {
        url: '/Setting/supplier/list',
        name: 'SupplierList',
        icon: 'icon-star'
      }]
    }, {
      name: 'Customer',
      url: '/Setting/customer',
      icon: 'icon-star',
      children: [{
        url: '/Setting/customer/add',
        name: 'CustomerAdd',
        icon: 'icon-star'
      }, {
        url: '/Setting/customer/list',
        name: 'CustomerList',
        icon: 'icon-star'
      }]
    }, {
      name: 'User',
      url: '/Setting/user',
      icon: 'icon-star',
      children: [{
        url: '/Setting/user/add',
        name: 'UserAdd',
        icon: 'icon-star'
      }, {
        url: '/Setting/user/list',
        name: 'UserList',
        icon: 'icon-star'
      }]
    }, {
      name: 'Shop',
      url: '/Setting/shop',
      icon: 'icon-star',
      children: [{
        url: '/Setting/shop/add',
        name: 'ShopAdd',
        icon: 'icon-star'
      }, {
        url: '/Setting/shop/list',
        name: 'ShopList',
        icon: 'icon-star'
      }]
    }, {
      name: 'Tax',
      url: '/Setting/tax',
      icon: 'icon-star'
    }, {
      name: 'Category',
      url: '/Setting/category',
      icon: 'icon-star'
    }, {
      name: 'Brand',
      url: '/Setting/brand',
      icon: 'icon-star',
      children: [{
        url: '/Setting/brand/add',
        name: 'BrandAdd',
        icon: 'icon-star'
      }]
    }, {
      name: 'Role',
      url: '/Setting/Role',
      icon: 'icon-star',
      children: [{
        url: '/Setting/Role/add',
        name: 'RoleAdd',
        icon: 'icon-star'
      }]
    }]
  }]
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(192);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523945b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(617);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523945b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"<i class='icon-list'></i>"}},[_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Today")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"warning"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Meeting with "),_c('strong',[_vm._v("Lucas")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"info"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Skype with "),_c('strong',[_vm._v("Megan")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 5pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-social-skype"}),_vm._v("  On-line ")])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Tomorrow")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"danger"}},[_c('div',[_vm._v("New UI Project - "),_c('strong',[_vm._v("deadline")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  10 - 11pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"success"}},[_c('div',[_c('strong',[_vm._v("#10 Startups.Garden")]),_vm._v(" Meetup")]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"primary"}},[_c('div',[_c('strong',[_vm._v("Team meeting")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 6pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/8.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-speech'></i>"}},[_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-settings'></i>"}},[_c('div',{staticClass:"p-3"},[_c('h6',[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-4"},[_c('small',[_c('b',[_vm._v("Option 1")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 2")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 3")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1)]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 4")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("System Utilization")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-4"},[_c('small',[_c('b',[_vm._v("CPU Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"info","value":25}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("348 Processes. 1/4 Cores.")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("Memory Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"warning","value":70}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("11444GB/16384MB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 1 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"danger","value":95}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("243GB/256GB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 2 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"success","value":10}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("25GB/256GB")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(619);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2aab07e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(621);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2aab07e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('a',{attrs:{"href":"http://minsyst.com"}},[_vm._v("MInSysT © Consulting Pvt Ltd. All rights reserved 2019.")]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://minsyst.com"}},[_vm._v("MInSysT")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c329f516_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(627);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c329f516_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffda4b2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffda4b2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading1"}},[_c('div',{attrs:{"id":"spinner1"}},[_c('i',{staticClass:"fa fa-repeat fa-lg mt-4 fa-spin",staticStyle:{"font-size":"58px","color":"rgb(206, 172, 12)"}}),_vm._v(" "),_c('label',{staticStyle:{"font-size":"25px","font-weight":"800","margin-left":"-20px","margin-top":"15px","color":"ghostwhite"}},[_vm._v("Loading")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-user-circle-o fa-lg",staticStyle:{"font-size":"30px"}})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();_vm.reset_password($event)}}},[_c('i',{staticClass:"fa fa-key"}),_vm._v(" Reset Password")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2),_vm._v(" "),_c('b-modal',{staticStyle:{"margin":"auto"},attrs:{"title":"Reset Password","size":"md","hide-footer":""},model:{value:(_vm.resetModal),callback:function ($$v) {_vm.resetModal=$$v},expression:"resetModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[(_vm.errorMessage.message != '')?_c('div',{staticClass:"alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v("\n              "+_vm._s(_vm.errorMessage.message)+"\n            ")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" New Password :")]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.new },attrs:{"type":"password","placeholder":"New Password"},model:{value:(_vm.password.new),callback:function ($$v) {_vm.$set(_vm.password, "new", $$v)},expression:"password.new"}}),_vm._v(" "),(_vm.hasErrors.new)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.new))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Confirm Password :")]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.confirm },attrs:{"type":"password","placeholder":"Confirm Password"},model:{value:(_vm.password.confirm),callback:function ($$v) {_vm.$set(_vm.password, "confirm", $$v)},expression:"password.confirm"}}),_vm._v(" "),(_vm.hasErrors.confirm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.confirm))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n            ")])])],1)],1)])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":_vm.i2oc}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"d-md-down-none"},[_c('b-nav-item',{staticClass:"px-3",attrs:{"href":"/system/#/help"}},[_vm._v("Help")])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[(_vm.isDownloading)?_c('b-button',{attrs:{"disabled":"","squared":"","variant":"warning"}},[_vm._v("Downloading\n          "),_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})]):_vm._e(),_vm._v(" "),(_vm.enableDownloadButton)?_c('div',[(!_vm.isDownloading)?_c('b-button',{attrs:{"squared":"","variant":"success"},on:{"click":_vm.downloadData}},[_vm._v("Download")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('HeaderDropdown')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446d6811_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(656);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446d6811_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419727a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(631);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419727a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bed3424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(633);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bed3424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0777a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(635);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0777a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5682a54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(637);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5682a54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(649);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(652);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52cff4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(655);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52cff4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar",attrs:{"id":"mobile"}},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[(_vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.is_admin === true)?_c('li',{staticClass:"nav-item nav-dropdown active",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-users"}),_vm._v("Manage User\n           ")]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.dashboard === true)?_c('li',{staticClass:"nav-item"},[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.company_tab === true)?_c('li',{staticClass:"nav-item nav-dropdown active",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-building-o"}),_vm._v(" Company Info\n            ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[((_vm.company_reg === true && _vm.super_user == 1) || _vm.shop_user == 2)?_c('li',{staticClass:"nav-item"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.shop_details === true && _vm.super_user == 1)?_c('li',{staticClass:"nav-item"},[_vm._m(5)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.security_tab === true)?_c('li',{staticClass:"nav-item nav-dropdown",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" Define Security\n            ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[((_vm.users === true && _vm.super_user == 1) || _vm.shop_user == 2)?_c('li',{staticClass:"nav-item"},[_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.super_user == 1)?_c('li',{staticClass:"nav-item"},[_vm._m(7)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.sales_tab === true)?_c('li',{staticClass:"nav-item nav-dropdown",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-pie-chart"}),_vm._v("Sales\n            ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[(_vm.sales === true)?_c('li',{staticClass:"nav-item"},[_vm._m(8)]):_vm._e(),_vm._v(" "),(_vm.sale_return === true)?_c('li',{staticClass:"nav-item"},[_vm._m(9)]):_vm._e(),_vm._v(" "),(_vm.customer === true)?_c('li',{staticClass:"nav-item"},[_vm._m(10)]):_vm._e(),_vm._v(" "),(_vm.sale_invoice === true)?_c('li',{staticClass:"nav-item"},[_vm._m(11)]):_vm._e(),_vm._v(" "),(_vm.sale_receipt === true)?_c('li',{staticClass:"nav-item"},[_vm._m(12)]):_vm._e(),_vm._v(" "),(_vm.sale_receipt_history === true)?_c('li',{staticClass:"nav-item"},[_vm._m(13)]):_vm._e(),_vm._v(" "),(_vm.salereturn_receipt_history === true)?_c('li',{staticClass:"nav-item"},[_vm._m(14)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.purchase_tab === true)?_c('li',{staticClass:"nav-item nav-dropdown",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v("Purchase\n            ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[(_vm.purchase === true)?_c('li',{staticClass:"nav-item"},[_vm._m(15)]):_vm._e(),_vm._v(" "),(_vm.purchase_return === true)?_c('li',{staticClass:"nav-item"},[_vm._m(16)]):_vm._e(),_vm._v(" "),(_vm.supplier === true)?_c('li',{staticClass:"nav-item"},[_vm._m(17)]):_vm._e(),_vm._v(" "),(_vm.purchase_payment === true)?_c('li',{staticClass:"nav-item"},[_vm._m(18)]):_vm._e(),_vm._v(" "),(_vm.purchase_payment_history === true)?_c('li',{staticClass:"nav-item"},[_vm._m(19)]):_vm._e(),_vm._v(" "),(_vm.purchasereturn_pending_list === true)?_c('li',{staticClass:"nav-item"},[_vm._m(20)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.shop_inventory === true)?_c('li',{staticClass:"nav-item"},[_vm._m(21)]):_vm._e(),_vm._v(" "),(_vm.stock_transfer === true)?_c('li',{staticClass:"nav-item"},[_vm._m(22)]):_vm._e(),_vm._v(" "),(_vm.sales_tab === true || _vm.purchase_tab === true)?_c('li',{staticClass:"nav-item nav-dropdown",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-dropdown-toggle nav-link",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" Reports\n            ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[(_vm.sales_tab === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/reports/balance_receipt_list"}},[_vm._v("Balance Receipt List")])]):_vm._e(),_vm._v(" "),(_vm.purchase_tab === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/reports/pending_payment_list"}},[_vm._v("Pending Payment List")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.setup_tab === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item nav-dropdown",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v("Setup\n            ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[(_vm.category_sub_category === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_vm._m(23)]):_vm._e(),_vm._v(" "),(_vm.brand === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_vm._m(24)]):_vm._e(),_vm._v(" "),(_vm.tax_tab === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item nav-dropdown",attrs:{"disabled":"disabled"}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick1}},[_vm._v("\n                  Tax Details\n                ")]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items dropdown-content",attrs:{"id":"destopview"}},[(_vm.hsn === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/taxdetails/hsn"}},[_vm._v(_vm._s(_vm.hsnLabel))])])]):_vm._e(),_vm._v(" "),(_vm.tax === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/taxdetails/hsnrate"}},[_vm._v(_vm._s(_vm.hsnRateLabel))])])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.variant === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_vm._m(25)]):_vm._e(),_vm._v(" "),(_vm.unit === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_vm._m(26)]):_vm._e(),_vm._v(" "),(_vm.product === true)?_c('li',{staticClass:"nav-item"},[_vm._m(27)]):_vm._e(),_vm._v(" "),(_vm.product === true)?_c('li',{staticClass:"nav-item"},[_vm._m(28)]):_vm._e()])]):_vm._e()]),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1),_vm._v(" "),_c('div',{staticClass:"sidebar",attrs:{"id":"destop"}},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav",attrs:{"id":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item"},[(_vm.is_admin === true)?_c('div',[_vm._m(29)]):_vm._e()]),_vm._v(" "),(_vm.is_admin === true)?_c('li',{staticClass:"test2"},[_vm._m(30),_vm._v(" "),_c('ul',{staticClass:"test top-level-menu"},[_c('li',{staticClass:"nav-item"},[(_vm.is_admin === true)?_c('div',[_c('a',{attrs:{"href":"#/user_management/user_info"}},[_vm._v("User Info")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.brand === true || _vm.is_admin === true)?_c('div',[_c('a',{attrs:{"href":"#/user_management/user_status"}},[_vm._v("User Status")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.is_admin === true)?_c('div',[_vm._m(31)]):_vm._e()]),_vm._v(" "),(_vm.dashboard === true)?_c('li',{staticClass:"nav-item"},[_vm._m(32)]):_vm._e(),_vm._v(" "),(_vm.company_tab === true)?_c('li',{staticClass:"test2"},[_vm._m(33),_vm._v(" "),_c('ul',{staticClass:"test top-level-menu"},[((_vm.company_reg === true && _vm.super_user == 1) || _vm.shop_user == 2)?_c('li',[_c('a',{attrs:{"href":"#/companyinfo/Registration"}},[_vm._v("Company Registration")])]):_vm._e(),_vm._v(" "),(_vm.shop_details === true && _vm.super_user == 1)?_c('li',[_c('a',{attrs:{"href":"#/companyinfo/Shop"}},[_vm._v("Shop Details")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.security_tab === true)?_c('li',{staticClass:"test2 dropdown-content"},[_vm._m(34),_vm._v(" "),_c('ul',{staticClass:"test dropdown-content",attrs:{"id":""}},[_c('li',{staticClass:"nav-item"},[((_vm.users === true && _vm.super_user == 1) || _vm.shop_user == 2)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/Definesecurity/User"}},[_vm._v("Add / Update Users")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.super_user == 1)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/Definesecurity/Role"}},[_vm._v("Add / Update Roles")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.sales_tab === true)?_c('li',{staticClass:"test2 dropdown-content"},[_vm._m(35),_vm._v(" "),_c('ul',{staticClass:"test dropdown-content",attrs:{"id":""}},[(_vm.sales === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales"}},[_vm._v("Sale Entry")])]):_vm._e(),_vm._v(" "),(_vm.sale_return === true)?_c('li',{staticClass:"nav-item"},[_vm._m(36)]):_vm._e(),_vm._v(" "),(_vm.customer === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/Customeradd"}},[_vm._v("Add / Update Customer")])]):_vm._e(),_vm._v(" "),(_vm.sale_invoice === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/saleinvoice/list"}},[_vm._v("Sale Invoice")])]):_vm._e(),_vm._v(" "),(_vm.sale_receipt === true)?_c('li',{staticClass:"nav-item"},[_vm._m(37)]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.sale_receipt_history === true)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/Salesreceipthistory"}},[_vm._v("Sales Receipt History")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.salereturn_receipt_history === true)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/SalesReturnreceipthistory"}},[_vm._v("Sales Return Receipt History")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.purchase_tab === true)?_c('li',{staticClass:"test2 dropdown-content"},[_vm._m(38),_vm._v(" "),_c('ul',{staticClass:"test dropdown-content",attrs:{"id":""}},[(_vm.purchase === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/purchaseentry"}},[_vm._v("Purchase Entry")])]):_vm._e(),_vm._v(" "),(_vm.purchase_return === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/Listpurchesreturn"}},[_vm._v("Purchase Return")])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.supplier === true)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/supplier/add"}},[_vm._v("Add / Update Supplier")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.purchase_payment === true)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/addpayment"}},[_vm._v("Add Payment")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.purchase_payment_history === true)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/listpayment"}},[_vm._v("List Payment")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.purchasereturn_pending_list === true)?_c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/PurchaseReturnpayment"}},[_vm._v("List Purchase Return Payment")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.shop_inventory === true)?_c('li',{staticClass:"nav-item"},[_vm._m(39)]):_vm._e(),_vm._v(" "),(_vm.stock_transfer === true)?_c('li',{staticClass:"nav-item"},[_vm._m(40)]):_vm._e(),_vm._v(" "),(_vm.sales_tab === true || _vm.purchase_tab === true)?_c('li',{staticClass:"test2 dropdown-content"},[_vm._m(41),_vm._v(" "),_c('ul',{staticClass:"test dropdown-content"},[(_vm.sales_tab === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/reports/balance_receipt_list"}},[_vm._v("Balance Receipt List")])]):_vm._e(),_vm._v(" "),(_vm.purchase_tab === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/reports/pending_payment_list"}},[_vm._v("Pending Payment List")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.setup_tab === true || _vm.is_admin === true)?_c('li',{staticClass:"test2"},[_vm._m(42),_vm._v(" "),_c('ul',{staticClass:"test top-level-menu"},[_c('li',{staticClass:"nav-item"},[(_vm.category_sub_category === true || _vm.is_admin === true)?_c('div',[_c('a',{attrs:{"href":"#/setup/addupdatecategory"}},[_vm._v("Add / Update Category")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.brand === true || _vm.is_admin === true)?_c('div',[_c('a',{attrs:{"href":"#/setup/addupdatebrand"}},[_vm._v("Add / Update Brand")])]):_vm._e()]),_vm._v(" "),(_vm.tax_tab === true || _vm.is_admin === true)?_c('li',{},[_vm._m(43),_vm._v(" "),_c('ul',{staticClass:"second-level-menu"},[(_vm.hsn === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/taxdetails/hsn"}},[_vm._v(_vm._s(_vm.hsnLabel))])]):_vm._e(),_vm._v(" "),(_vm.tax === true || _vm.is_admin === true)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/taxdetails/hsnrate"}},[_vm._v(_vm._s(_vm.hsnRateLabel))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.variant === true || _vm.is_admin === true)?_c('div',[_c('a',{attrs:{"href":"#/setup/addupdatevariant"}},[_vm._v("Add / Update Variant")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.unit === true || _vm.is_admin === true)?_c('div',[_c('a',{attrs:{"href":"#/setup/addupdateunit"}},[_vm._v("Add / Update Unit")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.product === true)?_c('div',[_c('a',{attrs:{"href":"#/setup/addupdateproduct"}},[_vm._v("Add / Update Product")])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[(_vm.product === true)?_c('div',[_c('a',{attrs:{"href":"#/setup/barcode"}},[_vm._v("Print Barcode")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"#/CompaniesInfo"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Companies Info")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items dropdown-content"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/user_management/user_info"}},[_vm._v("User Info")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#/user_management/user_status"}},[_vm._v("User Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"#/PlanConfig"}},[_c('i',{staticClass:"fa fa-tasks"}),_vm._v(" Plan Configuration\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/dashboard"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Dashboard")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/companyinfo/Registration"}},[_vm._v("Company Registration")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/companyinfo/Shop"}},[_vm._v("Shop Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/Definesecurity/User"}},[_vm._v("Add / Update Users\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/Definesecurity/Role"}},[_vm._v("Add / Update Roles")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales"}},[_vm._v("Sale Entry")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/Salesreturn/list"}},[_vm._v("Sale Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/Customeradd"}},[_vm._v("Add / Update Customer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/saleinvoice/list"}},[_vm._v("Sale Invoice")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/salereceipt"}},[_vm._v("Sales Receipt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/Salesreceipthistory"}},[_vm._v("Sales Receipt History")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/SalesReturnreceipthistory"}},[_vm._v("Sales Return Receipt History")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/purchaseentry"}},[_vm._v("Purchase Entry")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/Listpurchesreturn"}},[_vm._v("Purchase Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/supplier/add"}},[_vm._v("Add / Update Supplier")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/addpayment"}},[_vm._v("Add Payment")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/listpayment"}},[_vm._v("List Payment")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/purchase/PurchaseReturnpayment"}},[_vm._v("List Purchase Return Payment")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/shopinventory"}},[_c('i',{staticClass:"icon-social-dropbox"}),_vm._v(" Shop Inventory")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/stocktransfer"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Stock Transfer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/addupdatecategory"}},[_vm._v("Add / Update Category")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/addupdatebrand"}},[_vm._v("Add / Update Brand")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/addupdatevariant"}},[_vm._v("Add / Update Variant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/addupdateunit"}},[_vm._v("Add / Update Unit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/addupdateproduct"}},[_vm._v("Add / Update Product")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/setup/barcode"}},[_vm._v("Print Barcode")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"#/CompaniesInfo"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Companies Info")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link"},[_c('i',{staticClass:"fa fa-users"}),_vm._v("Manage User"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":"#/PlanConfig"}},[_c('i',{staticClass:"fa fa-tasks"}),_vm._v(" Plan Configuration\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/dashboard"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Dashboard")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link"},[_c('i',{staticClass:"fa fa-building-o"}),_vm._v("Company Info"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"fa fa-shield"}),_vm._v("Define Security"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"fa fa-pie-chart"}),_vm._v("Sales"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/Salesreturn/list"}},[_vm._v("Sale Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/sales/salereceipt"}},[_vm._v("Sales Receipt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v("Purchase"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/shopinventory"}},[_c('i',{staticClass:"icon-social-dropbox"}),_vm._v(" Shop Inventory")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"nav-link",attrs:{"href":"#/stocktransfer"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Stock Transfer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" Reports"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropbtn nav-link"},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" Setup"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_vm._v("Tax Details"),_c('i',{staticClass:"fa fa-angle-double-right",staticStyle:{"float":"right","color":"#fff"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verification_vue__ = __webpack_require__(226);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbc49d80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verification_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbc49d80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e064e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(661);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e064e2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"fa fa-search"})])],1),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8780b840_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(663);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8780b840_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-center",staticStyle:{"width":"100%","height":"100","overflow":"hidden"}},[_c('div',{staticClass:"col-md-12"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"width":"135px","float":"left","padding":"8px"},attrs:{"src":_vm.logo}})])])]),_vm._v(" "),_c('div',{staticClass:"app flex-row align-items-center",style:({ 'background-image': 'url(' + _vm.bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'})},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6","sm":"8"}},[_c('b-card',{staticClass:"mx-4",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-4"},[_c('div',{staticClass:"row"},[(_vm.hasErrors.message)?_c('div',{class:_vm.status_color,attrs:{"role":"alert","data-dismiss":"alert"}},[_c('strong',[_c('small',[_vm._v(_vm._s(_vm.errorMessage.message))])])]):_vm._e()]),_vm._v(" "),_c('h1',[_vm._v("Reset Password")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Please check the email for OTP:")]),_vm._v(" "),(_vm.hasErrors.username)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.username))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"otp"}},[_vm._v(" Token Id:")]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.otp },attrs:{"type":"text","placeholder":"Otp"},model:{value:(_vm.resetotp),callback:function ($$v) {_vm.resetotp=$$v},expression:"resetotp"}}),_vm._v(" "),(_vm.hasErrors.otp === true)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.otp))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" New Password :")]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.new },attrs:{"type":"password","placeholder":"New Password"},model:{value:(_vm.resetpassword),callback:function ($$v) {_vm.resetpassword=$$v},expression:"resetpassword"}}),_vm._v(" "),(_vm.hasErrors.new)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.new))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Confirm Password :")]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.confirm },attrs:{"type":"password","placeholder":"Confirm Password"},model:{value:(_vm.resetpasswordconf),callback:function ($$v) {_vm.resetpasswordconf=$$v},expression:"resetpasswordconf"}}),_vm._v(" "),(_vm.hasErrors.confirm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.confirm))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-button',{attrs:{"variant":"primary","block":""},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_vm._v("Verify")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{staticClass:"form-text text-muted",staticStyle:{"font-size":"15px"}},[_vm._v("Click\n                    "),_c('a',{staticStyle:{"color":"#63c2de","font-size":"15px","cursor":"pointer"},on:{"click":function($event){$event.preventDefault();_vm.Login()}}},[_vm._v("here")]),_vm._v("\n                    to Login")])])],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036eb435_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(669);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036eb435_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-center",staticStyle:{"width":"100%","height":"100","overflow":"hidden"}},[_c('div',{staticClass:"col-md-12"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"width":"135px","float":"left","padding":"8px"},attrs:{"src":_vm.logo}})])])]),_vm._v(" "),_c('div',{staticClass:"app flex-row align-items-center",style:({ 'background-image': 'url(' + _vm.bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'})},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('div',{staticClass:"row"},[(_vm.errorMessage.verifyemail)?_c('div',{staticClass:"col-md-12"},[_c('div',{class:_vm.verfiy_color,staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage.verifyemail))])]):_vm._e()]),_vm._v(" "),_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Sign In to your account")]),_vm._v(" "),(_vm.hasErrors.message)?_c('div',{staticClass:"help-block",staticStyle:{"color":"red","margin-left":"47px","font-size":"11px","font-weight":"bold"},domProps:{"innerHTML":_vm._s(_vm.errorMessage.message)}}):_vm._e(),_vm._v(" "),(_vm.hasErrors.both)?_c('div',{staticClass:"help-block",staticStyle:{"color":"red","margin-left":"47px","font-size":"11px"}},[_c('strong',[_vm._v(_vm._s(_vm.errorMessage.both))])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_vm._v("@")])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginData.both),expression:"loginData.both"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email/Phone","name":"both","id":"both","required":""},domProps:{"value":(_vm.loginData.both)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginData, "both", $event.target.value)}}})],1),_vm._v(" "),(_vm.hasErrors.password)?_c('div',{staticClass:"help-block",staticStyle:{"color":"red","margin-left":"47px","font-size":"12px"}},[_c('strong',[_vm._v(_vm._s(_vm.errorMessage.password))])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-lock"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginData.password),expression:"loginData.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","id":"password","name":"password","required":""},domProps:{"value":(_vm.loginData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginData, "password", $event.target.value)}}})],1),_vm._v(" "),(_vm.hasErrors.companyname)?_c('div',{staticClass:"help-block",staticStyle:{"color":"red","margin-left":"47px","font-size":"11px"}},[_c('strong',[_vm._v(_vm._s(_vm.errorMessage.companyname))])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-user"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginData.companyname),expression:"loginData.companyname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Company ID","id":"companyname","name":"companyname","required":""},domProps:{"value":(_vm.loginData.companyname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginData, "companyname", $event.target.value)}}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"form-check form-check-inline mr-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remember),expression:"remember"}],staticClass:"form-check-input",attrs:{"id":"check1","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.remember)?_vm._i(_vm.remember,null)>-1:(_vm.remember)},on:{"change":function($event){var $$a=_vm.remember,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.remember=$$a.concat([$$v]))}else{$$i>-1&&(_vm.remember=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.remember=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"check1"}},[_vm._v("Remember")])])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4",attrs:{"type":"button","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.loginPost()}}},[_vm._v("Login")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-0",attrs:{"type":"button","variant":"link"},on:{"click":_vm.resetmodel}},[_vm._v("Forgot password?")])],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"text-white bg-primary p-4 d-md-down-none",staticStyle:{"background-color":"#08051cb0 !important","width":"44%"},attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"text-center"},[_c('div',[_c('h1',[_vm._v("Sign up")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"20px","margin-top":"58px"}},[_vm._v("For New User Please Click On Register Button.")]),_vm._v(" "),_c('b-button',{staticClass:"active mt-3",staticStyle:{"font-size":"18px"},attrs:{"to":'/register',"variant":"primary"}},[_vm._v("Register")])],1)])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Forgot Password","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('div',{staticClass:"row"},[(_vm.errorMessage.statusemail)?_c('div',{staticClass:"col-md-12"},[_c('div',{class:_vm.status_color,staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage.statusemail))])]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"name1","placeholder":"Email"},model:{value:(_vm.resetemail),callback:function ($$v) {_vm.resetemail=$$v},expression:"resetemail"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{attrs:{"type":"button","variant":"primary","block":""},on:{"click":function($event){$event.preventDefault();_vm.reseturl($event)}}},[_vm._v("Verify")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Forgot Password","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal1 = true}},model:{value:(_vm.warningModal1),callback:function ($$v) {_vm.warningModal1=$$v},expression:"warningModal1"}},[_c('div',{staticClass:"row"},[(_vm.errorMessage.statusemail)?_c('div',{staticClass:"col-md-12"},[_c('div',{class:_vm.status_color,staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.errorMessage.statusemail))])]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Token Id")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Otp"},model:{value:(_vm.resettoken),callback:function ($$v) {_vm.resettoken=$$v},expression:"resettoken"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Password"},model:{value:(_vm.resetpassword),callback:function ($$v) {_vm.resetpassword=$$v},expression:"resetpassword"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Confirm Password"},model:{value:(_vm.resetpasswordconf),callback:function ($$v) {_vm.resetpasswordconf=$$v},expression:"resetpasswordconf"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-button',{attrs:{"variant":"primary","block":""},on:{"click":function($event){$event.preventDefault();_vm.loginPost1($event)}}},[_vm._v("Verify")])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_023fe76d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(686);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_023fe76d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-center",staticStyle:{"width":"100%","height":"100","overflow":"hidden"}},[_c('div',{staticClass:"col-md-12"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"width":"135px","float":"left","padding":"8px"},attrs:{"src":_vm.logo}})])])]),_vm._v(" "),_c('div',{staticClass:"app flex-row align-items-center",style:({ 'background-image': 'url(' + _vm.bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'})},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6","sm":"8"}},[_c('b-card',{staticClass:"mx-4",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-4"},[_c('div',{staticClass:"row"},[(_vm.hasErrors.message)?_c('div',{staticClass:"col-md-12 alert alert-success",attrs:{"role":"alert","data-dismiss":"alert"}},[_c('strong',[_c('small',[_vm._v(_vm._s(_vm.errorMessage.message))])])]):_vm._e()]),_vm._v(" "),_c('h1',[_vm._v("Register")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n                Please Enter your company details below:\n              ")]),_vm._v(" "),(_vm.hasErrors.username)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.username))])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3",class:{ 'has-error': _vm.hasErrors.username }},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-user"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.username),expression:"registerData.username"}],staticClass:"form-control",attrs:{"type":"text","id":"username","name":"username","placeholder":"Name","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "username", $event.target.value)}}})],1),_vm._v(" "),(_vm.hasErrors.companyname)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.companyname))])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3",class:{ 'has-error': _vm.hasErrors.companyname }},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"fa fa-building"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.companyname),expression:"registerData.companyname"}],staticClass:"form-control",attrs:{"type":"text","id":"companyname","placeholder":"Company Name","name":"companyname","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.companyname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "companyname", $event.target.value)}}})],1),_vm._v(" "),(_vm.hasErrors.email)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.email)+"\n                ")])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3",class:{ 'has-error': _vm.hasErrors.email }},[_c('b-input-group-prepend',[_c('b-input-group-text',[_vm._v("@")])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.email),expression:"registerData.email"}],staticClass:"form-control",attrs:{"type":"text","id":"email","placeholder":"Email","name":"email","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "email", $event.target.value)}}})],1),_vm._v(" "),(_vm.hasErrors.phone)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.phone)+"\n                ")])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3",class:{ 'has-error': _vm.hasErrors.phone }},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"fa fa-phone"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.phone),expression:"registerData.phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","placeholder":"Phone","name":"phone","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "phone", $event.target.value)}}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3",class:{ 'has-error': _vm.hasErrors.plan }},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"fa fa-tasks"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.plan),expression:"registerData.plan"}],staticClass:"form-control",attrs:{"type":"text","id":"select_plan","name":"plan","disabled":"","placeholder":"Select Plan","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.plan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "plan", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-pill btn-primary",staticStyle:{"border-radius":"unset"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.showplan()}}},[_vm._v("\n                  Change Plan\n                ")])],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"fa fa-map-marker",staticStyle:{"padding":"2px"}})])],1),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"width":"20% !important","-webkit-text-fill-color":"rgba(","height":"20px !important","border":"1px solid #c2cfd6","border-radius":"0px"},attrs:{"list":_vm.cityopt,"option-value":"shortname","option-text":"dbname","placeholder":"Select Registration  City"},on:{"searchchange":_vm.city1},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),_c('span',{staticStyle:{"margin-right":"-17px","color":"#20a8d8"}},[_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-info-circle",staticStyle:{"font-size":"15px","margin-top":"10px"},attrs:{"title":"This is your data centre location where your details will be saved.\n            If you do not found your current city kindly choose the nearest city\n            to your business location."}})])],1),_vm._v(" "),(_vm.hasErrors.password)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.messagepassword))])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3",class:{ 'has-error': _vm.hasErrors.password }},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-lock"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.password),expression:"registerData.password"}],staticClass:"form-control",attrs:{"type":"password","id":"password","placeholder":"Password","name":"password","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "password", $event.target.value)}}})],1),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('i',{staticClass:"icon-lock"})])],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.confirmpassword),expression:"registerData.confirmpassword"}],staticClass:"form-control",attrs:{"type":"password","id":"confirmpassword","placeholder":"Confirm password","name":"confirmpassword","required":"","autocomplete":"off"},domProps:{"value":(_vm.registerData.confirmpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registerData, "confirmpassword", $event.target.value)}}})],1),_vm._v(" "),(_vm.hasErrors.agree)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.agree)+"\n                ")])]):_vm._e(),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registerData.agree),expression:"registerData.agree"}],staticStyle:{"margin-top":"6px"},attrs:{"type":"checkbox","name":"agree","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.registerData.agree)?_vm._i(_vm.registerData.agree,null)>-1:(_vm.registerData.agree)},on:{"change":function($event){var $$a=_vm.registerData.agree,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.registerData.agree=$$a.concat([$$v]))}else{$$i>-1&&(_vm.registerData.agree=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.registerData, "agree", $$c)}}}}),_vm._v("   I agree to the "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.termModal = true}}},[_vm._v("\n                  Terms of Service ")]),_vm._v(" and \n                "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.privacyModal = true}}},[_vm._v(" Privacy Policy ")]),_vm._v(".\n              ")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.registerPost()}}},[_vm._v("Create Account")])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Privacy Policy","size":"lg"},on:{"ok":function($event){_vm.privacyModal = false}},model:{value:(_vm.privacyModal),callback:function ($$v) {_vm.privacyModal=$$v},expression:"privacyModal"}},[_c('span',{attrs:{"id":"docs-internal-guid-f01e961b-0b21-5c32-3be4-2452cbe5bc18"}},[_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You should carefully read the following Terms and Conditions\n              (also referred to as the \"Terms of Use\", \"Terms of Service\" or\n              \"TOS\"). Your use of our service(s) implies that you have read\n              and accepted these Terms and Conditions. The Website (all I2OC\n              websites may hereafter be referred to, both individually and\n              collectively, as \"The Website\") from which you accessed this\n              agreement is provided to you subject to the conditions listed\n              below. These terms are in addition to any other terms that\n              individual Website owners within the I2OC may include for\n              governing access to their Websites.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Any Non-Human Visitors to these Websites shall be considered\n              agents of the individual(s) who controls, authors or otherwise\n              makes use of them. Such individual(s) shall be deemed\n              responsible for the actions of their Non-Human Visitor devices\n              in the same manner as if they personally visited the\n              Website.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The access rights granted to you under the Terms Of Use are\n              non-transferable without the express written permission of the\n              owner of I2OC. You are responsible for the actions of any other\n              person who may utilize your access rights on the I2OC\n              Website.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Introduction")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The following terms and conditions govern all use of the I2OC\n              Website(s) and all content, services and products available at\n              or through the Website. The Website is offered subject to your\n              acceptance without modification of all of the terms and\n              conditions contained herein and all other associated operating\n              rules and policies (including, without limitation, I2OC Privacy\n              Policy).")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Please read this Agreement carefully before accessing or using\n              the I2OC Website. By accessing or using any part of the Website,\n              you agree to become bound by the terms and conditions of this\n              agreement. If you do not agree to all the terms and conditions\n              of this agreement, then you may not access the Website or use\n              any services. If these terms and conditions are considered an\n              offer by the I2OC, acceptance is expressly limited to these\n              terms.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The Website is available only to individuals who are at least\n              16 years old. If you are not yet 16 years old, you must stop\n              using the Website immediately or else provide I2OC with written\n              parental approval.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Our basic products and services are free to both Website owners\n              & individual users. However we may offer some paid upgrades\n              for advanced features such as monthly subscription charges or\n              yearly subscription charges.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Our products and services are designed to give users as much\n              control and ownership over their content as possible. However,\n              employer must be responsible for the content they posted during\n              job post and also recruiters when applying to the job on behalf\n              of applicant as well.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("SPECIAL LICENSE RESTRICTIONS FOR NON-HUMAN VISITORS")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("A special restriction on a visitor's license to access the\n              Website applies to all Non-Human Visitors. Non-Human Visitors\n              include, but are not limited to, web spiders, bots, indexers,\n              robots, crawlers, harvesters, or any other computer programs\n              designed to access, read, compile or gather content from the\n              Website automatically.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Email addresses on the I2OC are considered proprietary\n              intellectual property. It is recognized that these email\n              addresses are provided for human visitors alone. You acknowledge\n              and agree that each email address the Website contains has a\n              value not less than US $50. You further agree that the\n              compilation, storage, and/or distribution of these addresses\n              substantially diminishes the value of these addresses.\n              Intentional collection, harvesting, gathering, and/or storing\n              the Website's email addresses is recognized as a violation of\n              this agreement and expressly prohibited.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Ownership")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You do not claim intellectual property right or exclusive\n              ownership to any of our products or services, whether modified\n              or unmodified. All products and services are the property of\n              I2OC. Our products and services are provided 'as is' without\n              warranty of any kind, either expressed or implied. In no event\n              shall our organization (or any business or individual associated\n              with I2OC) be liable for any damages including, but not limited\n              to, direct, indirect, special, punitive, incidental or\n              consequential, or other losses arising out of the use of or\n              inability to use our products or services.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Your I2OC Account.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("If you create an account with I2OC, you are responsible for\n              maintaining the security of your account, and you are fully\n              responsible for all activities that occur under the account and\n              any other actions taken in connection with the account. You must\n              not describe or assign keywords to your content while posting\n              the job or while applying to the job post  in a misleading\n              or unlawful manner, including in a manner intended to trade on\n              the name or reputation of others, and I2OC may change or remove\n              any description or keyword that it considers inappropriate or\n              unlawful, or otherwise likely to cause I2OC to be positioned for\n              possible liability. You must immediately notify I2OC of any\n              unauthorized uses of your account, your account or any other\n              breaches of security. I2OC will not be liable for any acts or\n              omissions by you, including any damages of any kind incurred as\n              a result of such acts or omissions.")])]),_vm._v(" "),_c('ul',{staticStyle:{"margin-top":"0pt","margin-bottom":"0pt"}},[_c('li',{staticStyle:{"list-style-type":"disc","font-size":"10pt","font-family":"\"Noto Sans Symbols\"color:#162532","background-color":"transparent","vertical-align":"baseline"},attrs:{"dir":"ltr"}},[_c('p',{staticStyle:{"line-height":"1.2","margin-top":"6.1pt","margin-bottom":"6.1pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Arial","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("no obligation to provide a refund of any amounts previously\n                  paid.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Fees and Payment.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Optional premium paid services (such as monthly or yearly fees,\n              etc.) by selecting a premium service you agree to pay I2OC the\n              monthly or annual subscription fees indicated for that service.\n              Payments will be charged on the day you sign up for a premium\n              service and will cover the use of that service for a monthly or\n              annual period as indicated. Premium service fees are not\n              refundable.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Responsibility of Application Users.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC has not reviewed, and cannot review, all of the material\n              posted to the Website, and cannot therefore be responsible for\n              that material's content, use or effects. By operating the\n              Website, I2OC does not represent or imply that it endorses the\n              material there posted, or that it believes such material to be\n              accurate, useful or non-harmful. You are responsible for taking\n              precautions as necessary to protect yourself and your computer\n              systems from viruses, worms, Trojan horses, and other harmful or\n              destructive content. Any user or site owner who finds content\n              that is offensive, indecent, or otherwise objectionable, or\n              content containing technical inaccuracies, typographical\n              mistakes, or other errors has a responsibility to report such\n              Content to I2OC. In the same way, anyone who discovers Content\n              on the Website that contains material that violates the privacy\n              or publicity rights, or infringes the intellectual property and\n              other proprietary rights, of third parties, or the downloading,\n              copying or use of which is subject to additional terms and\n              conditions, stated or unstated, must report the same to I2OC.\n              I2OC disclaims any responsibility for any harm resulting from\n              the use by visitors of the Website, or from any downloading by\n              those visitors of content there posted.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Content Posted on Other Websites.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("We have not reviewed, and cannot review, all of the material,\n              including computer software, made available through the Websites\n              and WebPages to which I2OC links, and that link to I2OC. I2OC\n              does not have any control over those non-I2OC Websites and\n              WebPages, and is not responsible for their contents or their\n              use. By linking to a non-I2OC Website or webpage, I2OC does not\n              represent or imply that it endorses such Website or webpage. You\n              are responsible for taking precautions as necessary to protect\n              yourself and your computer systems from viruses, worms, Trojan\n              horses, and other harmful or destructive content. I2OC disclaims\n              any responsibility for any harm resulting from your use of\n              non-I2OC Websites and WebPages.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_vm._v("\n             \n          ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Copyright Infringement and DMCA Policy.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("As I2OC asks others to respect its intellectual property\n              rights, it respects the intellectual property rights of others.\n              If you believe that material located on or linked to by I2OC\n              violates your copyright, you are encouraged to notify I2OC. I2OC\n              will respond to all such notices, including as required or\n              appropriate by removing the infringing material or disabling all\n              links to the infringing material. In the case of a visitor who\n              may infringe or repeatedly infringes the copyrights or other\n              intellectual property rights of I2OC or others, I2OC may, in its\n              discretion, terminate or deny access to and use of the Website.\n              In the case of such termination, I2OC will have no obligation to\n              provide a refund of any amounts previously paid to I2OC.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Intellectual Property.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("This Agreement does not transfer from I2OC to you any I2OC or\n              third party intellectual property, and all right, title and\n              interest in and to such property will remain (as between the\n              parties) solely with I2OC. I2OC, the I2OC domain, the I2OC logo,\n              and all other trademarks, service marks, graphics and logos used\n              in connection with I2OC, or the Website are trademarks or\n              registered trademarks of I2OC or I2OC's licensors. Other\n              trademarks, service marks, graphics and logos used in connection\n              with the Website may be the trademarks of other third parties.\n              Your use of the Website grants you no right or license to\n              reproduce or otherwise use any I2OC or third-party\n              trademarks.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Changes.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC reserves the right, at its sole discretion, to modify or\n              replace any part of this Agreement. It is your responsibility to\n              check this Agreement periodically for changes. Your continued\n              use of or access to the Website following the posting of any\n              changes to this Agreement constitutes acceptance of those\n              changes. I2OC may also, in the future, offer new services and/or\n              features through the Website (including, the release of new\n              tools, services and resources). Such new features and/or\n              services shall be subject to the terms and conditions of this\n              Agreement.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Termination.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC may terminate your access to all or any part of the\n              Website at any time, with or without cause, with or without\n              notice, effective immediately. If you wish to terminate this\n              Agreement or your I2OC account (if you have one), you may simply\n              discontinue using the Website. Notwithstanding the foregoing, if\n              you have a VIP, Premium or other Paid Services account, such\n              account can only be terminated by I2OC if you materially breach\n              this Agreement and fail to cure such breach within thirty (30)\n              days from I2OC's notice to you thereof; provided that, I2OC can\n              terminate the Website immediately as part of a general shut down\n              of our service or other lawful reason. Additionally, a paid\n              account may be temporarily terminated pending a determination of\n              the facts relating to a possible breach of this Agreement. Upon\n              termination, all provisions of this Agreement which by their\n              nature should survive termination shall survive termination,\n              including, without limitation, ownership provisions, warranty\n              disclaimers, indemnity and limitations of liability.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Disclaimer of Warranties.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The materials on I2OC's Website are provided 'as is'. I2OC\n              makes no warranties, expressed or implied, and hereby disclaims\n              and negates all other warranties, including without limitation,\n              implied warranties or conditions of merchantability, fitness for\n              a particular purpose, or non-infringement of intellectual\n              property or other violation of rights. Further, I2OC does not\n              warrant or make any representations concerning the accuracy,\n              likely results, or reliability of the use of the materials on\n              its Internet Website or otherwise relating to such materials or\n              on any sites linked to this site.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Limitation of Liability.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("In no event will I2OC, or its suppliers or licensors, or any\n              individuals associated with those entities, be liable with\n              respect to any subject matter of this agreement under any\n              contract, negligence, strict liability or other legal or\n              equitable theory for: (i) any special, incidental or\n              consequential damages; (ii) the cost of procurement or\n              substitute products or services; (iii) for interruption of use\n              or loss or corruption of data; or (iv) for any amounts that\n              exceed the fees paid by you to I2OC under this agreement during\n              the twelve (12) month period prior to the cause of action. I2OC\n              shall have no liability for any failure or delay due to matters\n              beyond their reasonable control. The foregoing shall not apply\n              to the extent prohibited by applicable law.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("General Representation and Warranty.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You represent and warrant that (i) your use of the Website will\n              be in strict accordance with the I2OC Privacy Policy, with this\n              Agreement and with all applicable laws and regulations\n              (including without limitation any local laws or regulations in\n              your country, state, city, or other governmental area, regarding\n              online conduct and acceptable content, and including all\n              applicable laws regarding the transmission of technical data\n              exported from the country in which you reside) and (ii) your use\n              of the Website will not infringe or misappropriate the\n              intellectual property rights of any third party.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("APPLICABLE LAW AND JURISDICTION")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Each party agrees that any suit, action or proceeding brought\n              by such party against the other in connection with or arising\n              from the Terms of Service (\"Judicial Action\") shall be governed\n              by the law of the state of residence of the registered\n              Administrative Contact (the \"Admin State\") for the Website as\n              such laws are applied to agreements between Admin State\n              residents entered into and performed entirely within the Admin\n              State. You consent to the jurisdiction of federal and state\n              courts within the Admin State. You consent to the venue in any\n              action brought against him in connection with breaches of these\n              Terms of Service. You consent to electronic service of process\n              regarding actions under the above agreement.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("RECORDS OF VISITOR USE AND ABUSE")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You consent to having your Internet Protocol address recorded.\n              An email address may appear immediately below (the \"Identifier\")\n              if we suspect potential abuse. The Identifier is uniquely\n              matched to your Internet Protocol address. Visitors agree not to\n              use this address for any reason.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("VISITORS AGREE THAT HARVESTING, GATHERING, STORING,\n              TRANSFERRING TO A THIRD PARTY OR SENDING ANY MESSAGE(S) TO THE\n              IDENTIFIER CONSTITUTES AN ACCEPTANCE AND SUBSEQUENT BREACH OF\n              THESE TERMS OF SERVICE.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Site Terms of Use Modifications")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC may revise these Terms of Use for its Website at any time\n              without notice. By using this Website you are agreeing to be\n              bound by the then current version of these Terms and Conditions\n              of Use.")])]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Terms & Condition","size":"lg"},on:{"ok":function($event){_vm.termModal = false}},model:{value:(_vm.termModal),callback:function ($$v) {_vm.termModal=$$v},expression:"termModal"}},[_c('p',{staticClass:"MsoNormal",staticStyle:{"margin":"0cm 0cm 8pt","line-height":"15.6933px"}}),_vm._v(" "),_c('h3',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Calibri, sans-serif","font-size":"11pt","text-align":"justify"}},[_c('span',{staticStyle:{"font-family":"Tahoma","color":"black","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('b',[_vm._v("I2OC’s Privacy Commitment")])]),_c('span',{staticStyle:{"font-family":"Tahoma"}})]),_vm._v(" "),_c('div',{staticStyle:{"color":"black","font-family":"Roboto","font-size":"11pt","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("I2OC has troubled regarding client ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("and user privacy for nearly twenty years, long\n            before it became trendy, correctness,\n            or wrongfully binding to require such a\n            foothold. we tend to raise solely the smallest\n            {amount} amount of knowledge necessary,\n            gathering solely what we tend\n            to believe is crucial for doing business, or\n            for the precise dealing at hand. we tend\n            to let customers apprehend the\n            data we've on them and permit them\n            to prefer of specific engagements. But, by far, our\n            biggest commitment is that we tend\n            to don't create one dollar ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("from advertising revenue—never have, ne'er will—even\n            from the free editions of our product. this\n            implies we tend to avoid the basic conflict of\n            interest between\n            gathering client info and ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("refueling advertising revenue, and therefore\n            the inevitable compromises in client privacy\n            that it brings.")])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_c('font',{attrs:{"color":"#000000","face":"Roboto"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_c('br')])])],1),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("The goal of this policy is to form specific the\n              data we tend to gather on our customers and\n              users, however we are going to use it, and\n              the way we are going to not. This policy\n              is sadly longer than we\n              might like, however we tend\n              to should unambiguously address all the relevant\n              cases. we are going to attempt to keep the\n              language easy and direct the maximum\n              amount as attainable.")])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_c('br')]),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("Purposes for mistreatment info")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("In addition to the needs mentioned higher\n              than, we tend to might use\n              your info for the subsequent purposes:")])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"justify"}},[_c('br')]),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To communicate with you (such as through\n              email) regarding product that you\n              simply have downloaded and services that you\n              simply have signed up for, changes to the\n              current Privacy Policy, changes to the Terms of Service,\n              or necessary notices;")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To keep you denote on new product and\n              services, future events, offers, promotions\n              and alternative info that we\n              expect are of interest to you;")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To raise you to participate in surveys, or to solicit\n              feedback on our product and services;")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Roboto","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("To set up and maintain your account, and to try and\n              do all alternative things ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("needed for providing our services, reminiscent\n              of sanctionative ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("collaboration, providing web  mail hosting, and\n              backing up and restoring your data")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To understand however users use\n              our product and services, to watch and\n              forestall issues, and to\n              boost our product and services;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To provide client support, and to\n              investigate and improve our interactions with\n              customers;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Calibri, sans-serif","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("To sight and forestall deceitful ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("transactions and alternative ill-gotten ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("activities, to report spam, and to shield the rights\n              and interests of I2OC, I2OC’s users, third parties and\n              therefore the public;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To update, expand and analyze our\n              records, establish new customers, and\n              supply product and services that will be of\n              interest to you;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To analyze trends, administer our websites, and\n              track traveller navigations on our websites to\n              know what guests square measure searching\n              for and to higher facilitate them;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To monitor and improve promoting campaigns\n              and create suggestions relevant to the user.")])])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"justify","margin":"0cm 0cm 8pt","color":"rgb(34, 34, 34)","line-height":"15.6933px","font-size":"11pt","font-family":"Calibri, sans-serif"}},[_c('span',{staticStyle:{"font-family":"Roboto","color":"black","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('span',{staticStyle:{"font-family":"Tahoma"}},[_vm._v("For any query related to our privacy and policy kindly mail us\n              at")]),_c('span',{staticStyle:{"font-family":"Tahoma"}},[_vm._v(" ")]),_c('a',{staticStyle:{"color":"rgb(17, 85, 204)"},attrs:{"href":"mailto:info@i2oc.com","target":"_blank"}},[_c('span',{staticStyle:{"font-family":"Tahoma"}},[_vm._v("info@i2oc.com")])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Select Plan","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.planModal = true}},model:{value:(_vm.planModal),callback:function ($$v) {_vm.planModal=$$v},expression:"planModal"}},[_c('b-collapse',{attrs:{"id":"collapse3","visible":""}},[(_vm.plan_dt !== null)?_c('table',{staticStyle:{"width":"100%"}},[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"free","name":"selplan","checked":""},domProps:{"value":_vm.plan_dt[0].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[0].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[0].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[0].plan_label)+"\n              ")]),_vm._v(" "),_c('th',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"basic","name":"selplan"},domProps:{"value":_vm.plan_dt[1].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[1].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[1].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[1].plan_label)+"\n              ")]),_vm._v(" "),_c('th',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"standard","name":"selplan"},domProps:{"value":_vm.plan_dt[2].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[2].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[2].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[2].plan_label)+"\n              ")]),_vm._v(" "),_c('th',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"professional","name":"selplan"},domProps:{"value":_vm.plan_dt[3].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[3].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[3].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[3].plan_label)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-inr",staticStyle:{"color":"rgb(221, 120, 89)","font-size":"30px"},attrs:{"aria-hidden":"true"}}),_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"32px"}},[_vm._v(_vm._s(_vm.plan_dt[0].cost))])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-inr",staticStyle:{"color":"rgb(221, 120, 89)","font-size":"30px"},attrs:{"aria-hidden":"true"}}),_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"32px"}},[_vm._v(_vm._s(_vm.plan_dt[1].cost))])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-inr",staticStyle:{"color":"rgb(221, 120, 89)","font-size":"30px"},attrs:{"aria-hidden":"true"}}),_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"32px"}},[_vm._v(_vm._s(_vm.plan_dt[2].cost))])]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-inr",staticStyle:{"color":"rgb(221, 120, 89)","font-size":"30px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"32px"}},[_vm._v(_vm._s(_vm.plan_dt[3].cost))])])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"12px"}},[_vm._v("      plus gst (per annum)")])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"12px"}},[_vm._v("      plus gst (per annum)")])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"12px"}},[_vm._v("      plus gst (per annum)")])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"color":"rgb(221, 120, 89)","font-size":"12px"}},[_vm._v("      plus gst (per annum)")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Warehouse / Shop")]),_vm._v(" "),(_vm.plan_dt[0].shop_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[0].shop_count))]),_vm._v(" "),(_vm.plan_dt[1].shop_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[1].shop_count))]),_vm._v(" "),(_vm.plan_dt[2].shop_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[2].shop_count))]),_vm._v(" "),(_vm.plan_dt[3].shop_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[3].shop_count))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Max Users Allowed")]),_vm._v(" "),(_vm.plan_dt[0].user_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[0].user_count))]),_vm._v(" "),(_vm.plan_dt[1].user_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[1].user_count))]),_vm._v(" "),(_vm.plan_dt[2].user_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[2].user_count))]),_vm._v(" "),(_vm.plan_dt[3].user_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[3].user_count))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Third Party Ecommerce Integration")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].ecom_int === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].ecom_int === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].ecom_int === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].ecom_int === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].ecom_int === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].ecom_int === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].ecom_int === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].ecom_int === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Invoices")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].invoice === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].invoice === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].invoice === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].invoice === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].invoice === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].invoice === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].invoice === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].invoice === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Reports")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("GST Reports")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].gst_report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].gst_report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].gst_report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].gst_report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].gst_report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].gst_report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].gst_report === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].gst_report === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Max no. of Categories Allowed")]),_vm._v(" "),(_vm.plan_dt[0].cat_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[0].cat_count))]),_vm._v(" "),(_vm.plan_dt[1].cat_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[1].cat_count))]),_vm._v(" "),(_vm.plan_dt[2].cat_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[2].cat_count))]),_vm._v(" "),(_vm.plan_dt[3].cat_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[3].cat_count))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Max no. of Products Allowed")]),_vm._v(" "),(_vm.plan_dt[0].prod_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[0].prod_count))]),_vm._v(" "),(_vm.plan_dt[1].prod_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[1].prod_count))]),_vm._v(" "),(_vm.plan_dt[2].prod_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[2].prod_count))]),_vm._v(" "),(_vm.plan_dt[3].prod_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[3].prod_count))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Sales")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].sales === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].sales === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].sales === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].sales === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].sales === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].sales === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].sales === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].sales === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Purchase")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].purchase === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].purchase === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].purchase === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].purchase === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].purchase === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].purchase === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].purchase === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].purchase === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Max Customers")]),_vm._v(" "),(_vm.plan_dt[0].cust_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[0].cust_count))]),_vm._v(" "),(_vm.plan_dt[1].cust_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[1].cust_count))]),_vm._v(" "),(_vm.plan_dt[2].cust_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[2].cust_count))]),_vm._v(" "),(_vm.plan_dt[3].cust_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[3].cust_count))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Max Suppliers")]),_vm._v(" "),(_vm.plan_dt[0].supp_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[0].supp_count))]),_vm._v(" "),(_vm.plan_dt[1].supp_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[1].supp_count))]),_vm._v(" "),(_vm.plan_dt[2].supp_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[2].supp_count))]),_vm._v(" "),(_vm.plan_dt[3].supp_count === '0')?_c('td',[_vm._v("Unlimited")]):_c('td',[_vm._v(_vm._s(_vm.plan_dt[3].supp_count))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Barcodes")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].barcode === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].barcode === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].barcode === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].barcode === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].barcode === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].barcode === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].barcode === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].barcode === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Desktop Application")]),_vm._v(" "),_c('td',[(_vm.plan_dt[0].desktop_app === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[0].desktop_app === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[1].desktop_app === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[1].desktop_app === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[2].desktop_app === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[2].desktop_app === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.plan_dt[3].desktop_app === false)?_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e(),(_vm.plan_dt[3].desktop_app === true)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"center"},attrs:{"colspan":"5"}},[_c('button',{staticClass:"btn btn-lg btn-primary btn-pill",attrs:{"type":"button"},on:{"click":_vm.plan_select}},[_vm._v("\n                  Submit\n                ")])])])]):_vm._e()])],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfterRegister_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd542bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfterRegister_vue__ = __webpack_require__(688);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AfterRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdd542bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AfterRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-center",staticStyle:{"width":"100%","height":"100","overflow":"hidden"}},[_c('div',{staticClass:"col-md-12"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticStyle:{"width":"135px","float":"left","padding":"8px"},attrs:{"src":_vm.logo}})])])]),_vm._v(" "),_c('div',{staticClass:"app flex-row align-items-center",style:({ 'background-image': 'url(' + _vm.bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'})},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"12","sm":"10"}},[_c('b-card',{staticClass:"text-black bg-primary p-4 d-md-down-none",staticStyle:{"background-color":"#FFFFFF !important","width":"44%","margin-left":"300px"},attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"text-center"},[_c('div',{style:(_vm.myStyle),attrs:{"id":"wrapper"}},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_vm._v(" "),_c('h4',{staticStyle:{"color":"#3498DB","margin-top":"20px"}},[_vm._v("Registration Successfull")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.img2,"alt":""}}),_vm._v(" "),_c('p',{staticStyle:{"font-size":"15px","color":"black","margin-top":"35px"}},[_vm._v("Please Check your registered email to verify your account")]),_vm._v(" "),_c('b-button',{staticClass:"active mt-3",staticStyle:{"font-size":"18px","width":"300px"},attrs:{"to":'/',"variant":"primary"}},[_vm._v("Continue")])],1)])],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Privacy Policy","size":"lg"},on:{"ok":function($event){_vm.privacyModal = false}},model:{value:(_vm.privacyModal),callback:function ($$v) {_vm.privacyModal=$$v},expression:"privacyModal"}},[_c('span',{attrs:{"id":"docs-internal-guid-f01e961b-0b21-5c32-3be4-2452cbe5bc18"}},[_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You should carefully read the following Terms and Conditions (also referred to as the \"Terms of Use\", \"Terms of Service\" or \"TOS\"). Your use of our service(s) implies that you have read and accepted these Terms and Conditions. The Website (all I2OC websites may hereafter be referred to, both individually and collectively, as \"The Website\") from which you accessed this agreement is provided to you subject to the conditions listed below. These terms are in addition to any other terms that individual Website owners within the I2OC may include for governing access to their Websites.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Any Non-Human Visitors to these Websites shall be considered agents of the individual(s) who controls, authors or otherwise makes use of them. Such individual(s) shall be deemed responsible for the actions of their Non-Human Visitor devices in the same manner as if they personally visited the Website.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The access rights granted to you under the Terms Of Use are non-transferable without the express written permission of the owner of I2OC. You are responsible for the actions of any other person who may utilize your access rights on the I2OC Website.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Introduction")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The following terms and conditions govern all use of the I2OC Website(s) and all content, services and products available at or through the Website. The Website is offered subject to your acceptance without modification of all of the terms and conditions contained herein and all other associated operating rules and policies (including, without limitation, I2OC Privacy Policy).")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Please read this Agreement carefully before accessing or using the I2OC Website. By accessing or using any part of the Website, you agree to become bound by the terms and conditions of this agreement. If you do not agree to all the terms and conditions of this agreement, then you may not access the Website or use any services. If these terms and conditions are considered an offer by the I2OC, acceptance is expressly limited to these terms.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The Website is available only to individuals who are at least 16 years old. If you are not yet 16 years old, you must stop using the Website immediately or else provide I2OC with written parental approval.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Our basic products and services are free to both Website owners & individual users. However we may offer some paid upgrades for advanced features such as monthly subscription charges or yearly subscription charges.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Our products and services are designed to give users as much control and ownership over their content as possible. However, employer must be responsible for the content they posted during job post and also recruiters when applying to the job on behalf of applicant as well.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("SPECIAL LICENSE RESTRICTIONS FOR NON-HUMAN VISITORS")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("A special restriction on a visitor's license to access the Website applies to all Non-Human Visitors. Non-Human Visitors include, but are not limited to, web spiders, bots, indexers, robots, crawlers, harvesters, or any other computer programs designed to access, read, compile or gather content from the Website automatically.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Email addresses on the I2OC are considered proprietary intellectual property. It is recognized that these email addresses are provided for human visitors alone. You acknowledge and agree that each email address the Website contains has a value not less than US $50. You further agree that the compilation, storage, and/or distribution of these addresses substantially diminishes the value of these addresses. Intentional collection, harvesting, gathering, and/or storing the Website's email addresses is recognized as a violation of this agreement and expressly prohibited.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Ownership")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You do not claim intellectual property right or exclusive ownership to any of our products or services, whether modified or unmodified. All products and services are the property of I2OC. Our products and services are provided 'as is' without warranty of any kind, either expressed or implied. In no event shall our organization (or any business or individual associated with I2OC) be liable for any damages including, but not limited to, direct, indirect, special, punitive, incidental or consequential, or other losses arising out of the use of or inability to use our products or services.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"Arial","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Your I2OC Account.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("If you create an account with I2OC, you are responsible for maintaining the security of your account, and you are fully responsible for all activities that occur under the account and any other actions taken in connection with the account. You must not describe or assign keywords to your content while posting the job or while applying to the job post  in a misleading or unlawful manner, including in a manner intended to trade on the name or reputation of others, and I2OC may change or remove any description or keyword that it considers inappropriate or unlawful, or otherwise likely to cause I2OC to be positioned for possible liability. You must immediately notify I2OC of any unauthorized uses of your account, your account or any other breaches of security. I2OC will not be liable for any acts or omissions by you, including any damages of any kind incurred as a result of such acts or omissions.")])]),_vm._v(" "),_c('ul',{staticStyle:{"margin-top":"0pt","margin-bottom":"0pt"}},[_c('li',{staticStyle:{"list-style-type":"disc","font-size":"10pt","font-family":"\"Noto Sans Symbols\"color:#162532","background-color":"transparent","vertical-align":"baseline"},attrs:{"dir":"ltr"}},[_c('p',{staticStyle:{"line-height":"1.2","margin-top":"6.1pt","margin-bottom":"6.1pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Arial","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("no obligation to provide a refund of any amounts previously paid.")])])])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Fees and Payment.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Optional premium paid services (such as monthly or yearly fees, etc.) by selecting a premium service you agree to pay I2OC the monthly or annual subscription fees indicated for that service. Payments will be charged on the day you sign up for a premium service and will cover the use of that service for a monthly or annual period as indicated. Premium service fees are not refundable.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Responsibility of Application Users.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC has not reviewed, and cannot review, all of the material posted to the Website, and cannot therefore be responsible for that material's content, use or effects. By operating the Website, I2OC does not represent or imply that it endorses the material there posted, or that it believes such material to be accurate, useful or non-harmful. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. Any user or site owner who finds content that is offensive, indecent, or otherwise objectionable, or content containing technical inaccuracies, typographical mistakes, or other errors has a responsibility to report such Content to I2OC. In the same way, anyone who discovers Content on the Website that contains material that violates the privacy or publicity rights, or infringes the intellectual property and other proprietary rights, of third parties, or the downloading, copying or use of which is subject to additional terms and conditions, stated or unstated, must report the same to I2OC. I2OC disclaims any responsibility for any harm resulting from the use by visitors of the Website, or from any downloading by those visitors of content there posted.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Content Posted on Other Websites.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("We have not reviewed, and cannot review, all of the material, including computer software, made available through the Websites and WebPages to which I2OC links, and that link to I2OC. I2OC does not have any control over those non-I2OC Websites and WebPages, and is not responsible for their contents or their use. By linking to a non-I2OC Website or webpage, I2OC does not represent or imply that it endorses such Website or webpage. You are responsible for taking precautions as necessary to protect yourself and your computer systems from viruses, worms, Trojan horses, and other harmful or destructive content. I2OC disclaims any responsibility for any harm resulting from your use of non-I2OC Websites and WebPages.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Copyright Infringement and DMCA Policy.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("As I2OC asks others to respect its intellectual property rights, it respects the intellectual property rights of others. If you believe that material located on or linked to by I2OC violates your copyright, you are encouraged to notify I2OC. I2OC will respond to all such notices, including as required or appropriate by removing the infringing material or disabling all links to the infringing material. In the case of a visitor who may infringe or repeatedly infringes the copyrights or other intellectual property rights of I2OC or others, I2OC may, in its discretion, terminate or deny access to and use of the Website. In the case of such termination, I2OC will have no obligation to provide a refund of any amounts previously paid to I2OC.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Intellectual Property.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("This Agreement does not transfer from I2OC to you any I2OC or third party intellectual property, and all right, title and interest in and to such property will remain (as between the parties) solely with I2OC. I2OC, the I2OC domain, the I2OC logo, and all other trademarks, service marks, graphics and logos used in connection with I2OC, or the Website are trademarks or registered trademarks of I2OC or I2OC's licensors. Other trademarks, service marks, graphics and logos used in connection with the Website may be the trademarks of other third parties. Your use of the Website grants you no right or license to reproduce or otherwise use any I2OC or third-party trademarks.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Changes.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC reserves the right, at its sole discretion, to modify or replace any part of this Agreement. It is your responsibility to check this Agreement periodically for changes. Your continued use of or access to the Website following the posting of any changes to this Agreement constitutes acceptance of those changes. I2OC may also, in the future, offer new services and/or features through the Website (including, the release of new tools, services and resources). Such new features and/or services shall be subject to the terms and conditions of this Agreement.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Termination.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC may terminate your access to all or any part of the Website at any time, with or without cause, with or without notice, effective immediately. If you wish to terminate this Agreement or your I2OC account (if you have one), you may simply discontinue using the Website. Notwithstanding the foregoing, if you have a VIP, Premium or other Paid Services account, such account can only be terminated by I2OC if you materially breach this Agreement and fail to cure such breach within thirty (30) days from I2OC's notice to you thereof; provided that, I2OC can terminate the Website immediately as part of a general shut down of our service or other lawful reason. Additionally, a paid account may be temporarily terminated pending a determination of the facts relating to a possible breach of this Agreement. Upon termination, all provisions of this Agreement which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Disclaimer of Warranties.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("The materials on I2OC's Website are provided 'as is'. I2OC makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights. Further, I2OC does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its Internet Website or otherwise relating to such materials or on any sites linked to this site.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Limitation of Liability.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("In no event will I2OC, or its suppliers or licensors, or any individuals associated with those entities, be liable with respect to any subject matter of this agreement under any contract, negligence, strict liability or other legal or equitable theory for: (i) any special, incidental or consequential damages; (ii) the cost of procurement or substitute products or services; (iii) for interruption of use or loss or corruption of data; or (iv) for any amounts that exceed the fees paid by you to I2OC under this agreement during the twelve (12) month period prior to the cause of action. I2OC shall have no liability for any failure or delay due to matters beyond their reasonable control. The foregoing shall not apply to the extent prohibited by applicable law.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("General Representation and Warranty.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You represent and warrant that (i) your use of the Website will be in strict accordance with the I2OC Privacy Policy, with this Agreement and with all applicable laws and regulations (including without limitation any local laws or regulations in your country, state, city, or other governmental area, regarding online conduct and acceptable content, and including all applicable laws regarding the transmission of technical data exported from the country in which you reside) and (ii) your use of the Website will not infringe or misappropriate the intellectual property rights of any third party.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("APPLICABLE LAW AND JURISDICTION")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Each party agrees that any suit, action or proceeding brought by such party against the other in connection with or arising from the Terms of Service (\"Judicial Action\") shall be governed by the law of the state of residence of the registered Administrative Contact (the \"Admin State\") for the Website as such laws are applied to agreements between Admin State residents entered into and performed entirely within the Admin State. You consent to the jurisdiction of federal and state courts within the Admin State. You consent to the venue in any action brought against him in connection with breaches of these Terms of Service. You consent to electronic service of process regarding actions under the above agreement.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("RECORDS OF VISITOR USE AND ABUSE")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("You consent to having your Internet Protocol address recorded. An email address may appear immediately below (the \"Identifier\") if we suspect potential abuse. The Identifier is uniquely matched to your Internet Protocol address. Visitors agree not to use this address for any reason.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("VISITORS AGREE THAT HARVESTING, GATHERING, STORING, TRANSFERRING TO A THIRD PARTY OR SENDING ANY MESSAGE(S) TO THE IDENTIFIER CONSTITUTES AN ACCEPTANCE AND SUBSEQUENT BREACH OF THESE TERMS OF SERVICE.")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.2","margin-top":"7.9pt","margin-bottom":"2.35pt","margin-left":"36pt"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"14.5pt","font-family":"inherit","color":"#162532","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("Site Terms of Use Modifications")])]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1.295","margin-top":"0","margin-bottom":"7.9pt","margin-left":"36pt","text-align":"justify"},attrs:{"dir":"ltr"}},[_c('span',{staticStyle:{"font-size":"10.5pt","font-family":"Arial","color":"#333","background-color":"transparent","vertical-align":"baseline","white-space":"pre-wrap"}},[_vm._v("I2OC may revise these Terms of Use for its Website at any time without notice. By using this Website you are agreeing to be bound by the then current version of these Terms and Conditions of Use.")])]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Terms & Condition","size":"lg"},on:{"ok":function($event){_vm.termModal = false}},model:{value:(_vm.termModal),callback:function ($$v) {_vm.termModal=$$v},expression:"termModal"}},[_c('p',{staticClass:"MsoNormal",staticStyle:{"margin":"0cm 0cm 8pt","line-height":"15.6933px"}}),_c('h3',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Calibri, sans-serif","font-size":"11pt","text-align":"justify"}},[_c('span',{staticStyle:{"font-family":"Tahoma","color":"black","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('b',[_vm._v("I2OC’s Privacy Commitment")])]),_c('span',{staticStyle:{"font-family":"Tahoma"}})]),_c('div',{staticStyle:{"color":"black","font-family":"Roboto","font-size":"11pt","text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("I2OC has troubled regarding client ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("and user privacy for nearly twenty years, long before it became trendy, correctness, or wrongfully binding to require such a foothold. we tend to raise solely the smallest {amount} amount of knowledge necessary, gathering solely what we tend to believe is crucial for doing business, or for the precise dealing at hand. we tend to let customers apprehend the data we've on them and permit them to prefer of specific engagements. But, by far, our biggest commitment is that we tend to don't create one dollar ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("from advertising revenue—never have, ne'er will—even from the free editions of our product. this implies we tend to avoid the basic conflict of interest between gathering client info and ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("refueling advertising revenue, and therefore the inevitable compromises in client privacy that it brings.")])]),_c('div',{staticStyle:{"text-align":"justify"}},[_c('font',{attrs:{"color":"#000000","face":"Roboto"}},[_c('span',{staticStyle:{"font-size":"14.6667px"}},[_c('br')])])],1),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("The goal of this policy is to form specific the data we tend to gather on our customers and users, however we are going to use it, and the way we are going to not. This policy is sadly longer than we might like, however we tend to should unambiguously address all the relevant cases. we are going to attempt to keep the language easy and direct the maximum amount as attainable.")])])]),_c('div',{staticStyle:{"text-align":"justify"}},[_c('br')]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("Purposes for mistreatment info")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("In addition to the needs mentioned higher than, we tend to might use your info for the subsequent purposes:")])])]),_c('div',{staticStyle:{"text-align":"justify"}},[_c('br')]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To communicate with you (such as through email) regarding product that you simply have downloaded and services that you simply have signed up for, changes to the current Privacy Policy, changes to the Terms of Service, or necessary notices;")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To keep you denote on new product and services, future events, offers, promotions and alternative info that we expect are of interest to you;")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To raise you to participate in surveys, or to solicit feedback on our product and services;")])])]),_c('span',{staticStyle:{"color":"black","font-family":"Roboto","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("To set up and maintain your account, and to try and do all alternative things ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("needed for providing our services, reminiscent of sanctionative ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("collaboration, providing web  mail hosting, and backing up and restoring your data")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To understand however users use our product and services, to watch and forestall issues, and to boost our product and services;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To provide client support, and to investigate and improve our interactions with customers;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Calibri, sans-serif","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("To sight and forestall deceitful ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("transactions and alternative ill-gotten ")]),_c('wbr',{staticStyle:{"font-size":"11pt"}}),_c('span',{staticStyle:{"font-size":"11pt","font-family":"Tahoma"}},[_vm._v("activities, to report spam, and to shield the rights and interests of I2OC, I2OC’s users, third parties and therefore the public;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To update, expand and analyze our records, establish new customers, and supply product and services that will be of interest to you;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To analyze trends, administer our websites, and track traveller navigations on our websites to know what guests square measure searching for and to higher facilitate them;")])])]),_c('span',{staticStyle:{"color":"rgb(34, 34, 34)","font-family":"Tahoma","font-size":"11pt","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('div',{staticStyle:{"text-align":"justify"}},[_c('span',{staticStyle:{"font-size":"11pt"}},[_vm._v("To monitor and improve promoting campaigns and create suggestions relevant to the user.")])])]),_c('p'),_c('p',{staticClass:"MsoNormal",staticStyle:{"text-align":"justify","margin":"0cm 0cm 8pt","color":"rgb(34, 34, 34)","line-height":"15.6933px","font-size":"11pt","font-family":"Calibri, sans-serif"}},[_c('span',{staticStyle:{"font-family":"Roboto","color":"black","background-image":"initial","background-position":"initial","background-size":"initial","background-repeat":"initial","background-origin":"initial","background-clip":"initial"}},[_c('span',{staticStyle:{"font-family":"Tahoma"}},[_vm._v("For any query related to our privacy and policy kindly mail us at")]),_c('span',{staticStyle:{"font-family":"Tahoma"}},[_vm._v(" ")]),_c('a',{staticStyle:{"color":"rgb(17, 85, 204)"},attrs:{"href":"mailto:info@i2oc.com","target":"_blank"}},[_c('span',{staticStyle:{"font-family":"Tahoma"}},[_vm._v("info@i2oc.com")])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bec50c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(715);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bec50c9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine1ChartExample_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine1ChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 691 */,
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 240,
	"./af.js": 240,
	"./ar": 241,
	"./ar-dz": 242,
	"./ar-dz.js": 242,
	"./ar-kw": 243,
	"./ar-kw.js": 243,
	"./ar-ly": 244,
	"./ar-ly.js": 244,
	"./ar-ma": 245,
	"./ar-ma.js": 245,
	"./ar-sa": 246,
	"./ar-sa.js": 246,
	"./ar-tn": 247,
	"./ar-tn.js": 247,
	"./ar.js": 241,
	"./az": 248,
	"./az.js": 248,
	"./be": 249,
	"./be.js": 249,
	"./bg": 250,
	"./bg.js": 250,
	"./bm": 251,
	"./bm.js": 251,
	"./bn": 252,
	"./bn.js": 252,
	"./bo": 253,
	"./bo.js": 253,
	"./br": 254,
	"./br.js": 254,
	"./bs": 255,
	"./bs.js": 255,
	"./ca": 256,
	"./ca.js": 256,
	"./cs": 257,
	"./cs.js": 257,
	"./cv": 258,
	"./cv.js": 258,
	"./cy": 259,
	"./cy.js": 259,
	"./da": 260,
	"./da.js": 260,
	"./de": 261,
	"./de-at": 262,
	"./de-at.js": 262,
	"./de-ch": 263,
	"./de-ch.js": 263,
	"./de.js": 261,
	"./dv": 264,
	"./dv.js": 264,
	"./el": 265,
	"./el.js": 265,
	"./en-au": 266,
	"./en-au.js": 266,
	"./en-ca": 267,
	"./en-ca.js": 267,
	"./en-gb": 268,
	"./en-gb.js": 268,
	"./en-ie": 269,
	"./en-ie.js": 269,
	"./en-il": 270,
	"./en-il.js": 270,
	"./en-nz": 271,
	"./en-nz.js": 271,
	"./eo": 272,
	"./eo.js": 272,
	"./es": 273,
	"./es-do": 274,
	"./es-do.js": 274,
	"./es-us": 275,
	"./es-us.js": 275,
	"./es.js": 273,
	"./et": 276,
	"./et.js": 276,
	"./eu": 277,
	"./eu.js": 277,
	"./fa": 278,
	"./fa.js": 278,
	"./fi": 279,
	"./fi.js": 279,
	"./fo": 280,
	"./fo.js": 280,
	"./fr": 281,
	"./fr-ca": 282,
	"./fr-ca.js": 282,
	"./fr-ch": 283,
	"./fr-ch.js": 283,
	"./fr.js": 281,
	"./fy": 284,
	"./fy.js": 284,
	"./gd": 285,
	"./gd.js": 285,
	"./gl": 286,
	"./gl.js": 286,
	"./gom-latn": 287,
	"./gom-latn.js": 287,
	"./gu": 288,
	"./gu.js": 288,
	"./he": 289,
	"./he.js": 289,
	"./hi": 290,
	"./hi.js": 290,
	"./hr": 291,
	"./hr.js": 291,
	"./hu": 292,
	"./hu.js": 292,
	"./hy-am": 293,
	"./hy-am.js": 293,
	"./id": 294,
	"./id.js": 294,
	"./is": 295,
	"./is.js": 295,
	"./it": 296,
	"./it.js": 296,
	"./ja": 297,
	"./ja.js": 297,
	"./jv": 298,
	"./jv.js": 298,
	"./ka": 299,
	"./ka.js": 299,
	"./kk": 300,
	"./kk.js": 300,
	"./km": 301,
	"./km.js": 301,
	"./kn": 302,
	"./kn.js": 302,
	"./ko": 303,
	"./ko.js": 303,
	"./ky": 304,
	"./ky.js": 304,
	"./lb": 305,
	"./lb.js": 305,
	"./lo": 306,
	"./lo.js": 306,
	"./lt": 307,
	"./lt.js": 307,
	"./lv": 308,
	"./lv.js": 308,
	"./me": 309,
	"./me.js": 309,
	"./mi": 310,
	"./mi.js": 310,
	"./mk": 311,
	"./mk.js": 311,
	"./ml": 312,
	"./ml.js": 312,
	"./mn": 313,
	"./mn.js": 313,
	"./mr": 314,
	"./mr.js": 314,
	"./ms": 315,
	"./ms-my": 316,
	"./ms-my.js": 316,
	"./ms.js": 315,
	"./mt": 317,
	"./mt.js": 317,
	"./my": 318,
	"./my.js": 318,
	"./nb": 319,
	"./nb.js": 319,
	"./ne": 320,
	"./ne.js": 320,
	"./nl": 321,
	"./nl-be": 322,
	"./nl-be.js": 322,
	"./nl.js": 321,
	"./nn": 323,
	"./nn.js": 323,
	"./pa-in": 324,
	"./pa-in.js": 324,
	"./pl": 325,
	"./pl.js": 325,
	"./pt": 326,
	"./pt-br": 327,
	"./pt-br.js": 327,
	"./pt.js": 326,
	"./ro": 328,
	"./ro.js": 328,
	"./ru": 329,
	"./ru.js": 329,
	"./sd": 330,
	"./sd.js": 330,
	"./se": 331,
	"./se.js": 331,
	"./si": 332,
	"./si.js": 332,
	"./sk": 333,
	"./sk.js": 333,
	"./sl": 334,
	"./sl.js": 334,
	"./sq": 335,
	"./sq.js": 335,
	"./sr": 336,
	"./sr-cyrl": 337,
	"./sr-cyrl.js": 337,
	"./sr.js": 336,
	"./ss": 338,
	"./ss.js": 338,
	"./sv": 339,
	"./sv.js": 339,
	"./sw": 340,
	"./sw.js": 340,
	"./ta": 341,
	"./ta.js": 341,
	"./te": 342,
	"./te.js": 342,
	"./tet": 343,
	"./tet.js": 343,
	"./tg": 344,
	"./tg.js": 344,
	"./th": 345,
	"./th.js": 345,
	"./tl-ph": 346,
	"./tl-ph.js": 346,
	"./tlh": 347,
	"./tlh.js": 347,
	"./tr": 348,
	"./tr.js": 348,
	"./tzl": 349,
	"./tzl.js": 349,
	"./tzm": 350,
	"./tzm-latn": 351,
	"./tzm-latn.js": 351,
	"./tzm.js": 350,
	"./ug-cn": 352,
	"./ug-cn.js": 352,
	"./uk": 353,
	"./uk.js": 353,
	"./ur": 354,
	"./ur.js": 354,
	"./uz": 355,
	"./uz-latn": 356,
	"./uz-latn.js": 356,
	"./uz.js": 355,
	"./vi": 357,
	"./vi.js": 357,
	"./x-pseudo": 358,
	"./x-pseudo.js": 358,
	"./yo": 359,
	"./yo.js": 359,
	"./zh-cn": 360,
	"./zh-cn.js": 360,
	"./zh-hk": 361,
	"./zh-hk.js": 361,
	"./zh-tw": 362,
	"./zh-tw.js": 362
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 692;

/***/ }),
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.1.0","E:\\i2ocgold"]],"_from":"vue-chartjs@3.1.0","_id":"vue-chartjs@3.1.0","_inBundle":false,"_integrity":"sha512-cp70zluNJdN57J907hSzjp4jayF6O0ayBJ/alZprHx+BvbVe+nL+QF3TOPSSao3UoenCopYJybmDi/RWYb7afw==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.1.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.1.0","saveSpec":null,"fetchSpec":"3.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.1.0.tgz","_spec":"3.1.0","_where":"E:\\i2ocgold","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.1.0"}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine2ChartExample_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine2ChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine3ChartExample_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine3ChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartExample_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__ = __webpack_require__(366);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChart2Example_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChart2Example_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialBoxChartExample_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialBoxChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalloutChartExample_vue__ = __webpack_require__(370);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalloutChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass}),_vm._v(" "+_vm._s(_vm.total_sale_revenue))]),_vm._v(" "),_c('p',[_vm._v("Total Sale Revenue")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-info",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass}),_vm._v(" "+_vm._s(_vm.profit))]),_vm._v(" "),_c('p',[_vm._v("Balance to Collect")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-warning",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass}),_vm._v(" "+_vm._s(_vm.purchase_expenses))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.dashbd_view))]),_vm._v(" "),_c('p',[_vm._v("Total Purchase Expenses")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-success",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass}),_vm._v(" "+_vm._s(_vm.purchasepayment))]),_vm._v(" "),_c('p',[_vm._v("Value of Stock")])])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('h4',{staticClass:"card-title mb-0",attrs:{"id":"traffic"}},[_vm._v("SALES REPORT")]),_vm._v(" "),(_vm.selected == 'Month')?_c('span',[_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.mnth)+" "+_vm._s(_vm.year))])]):_c('span',[_c('div',{staticClass:"small text-muted"},[_vm._v(_vm._s(_vm.year))])])]),_vm._v(" "),_c('b-col',{staticClass:"d-none d-md-block",attrs:{"sm":"7"}},[_c('b-button',{staticClass:"float-right",attrs:{"type":"button","variant":"primary"}},[_c('i',{staticClass:"icon-cloud-download"})]),_vm._v(" "),_c('b-button-toolbar',{staticClass:"float-right",attrs:{"aria-label":"Toolbar with buttons group"}},[_c('b-form-radio-group',{staticClass:"mr-3",attrs:{"id":"radiosBtn","buttons":"","button-variant":"outline-secondary","name":"radiosBtn"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"Month"}},[_vm._v("Month")]),_vm._v(" "),_c('b-form-radio',{staticClass:"mx-0",attrs:{"value":"Year"}},[_vm._v("Year")])],1)],1)],1)],1),_vm._v(" "),(_vm.selected == 'Month')?_c('span',[_c('main-chart-example',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"height":"300"}})],1):_c('span',[_c('main-chart2-example',{staticClass:"chart-wrapper",staticStyle:{"height":"300px","margin-top":"40px"},attrs:{"height":"300"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('i',{staticClass:"fa fa-align-justify"}),_vm._v(" TOP 5 SELLING PRODUCT "+_vm._s(_vm.year)+"\n")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"pagination-options":{
        enabled: false,
        perPage: 5,
      },"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span'):_c('span',[_vm._v("\n      "+_vm._s(props.formattedRow[props.column.field])+"\n    ")])]}}])})],1)])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',{attrs:{"header":"RECENT ORDERS"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns3,"rows":_vm.rows3,"pagination-options":{
        enabled: false,
        perPage: 5
      },"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span'):_c('span',[_vm._v("\n      "+_vm._s(props.formattedRow[props.column.field])+"\n    ")])]}}])})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('i',{staticClass:"fa fa-align-justify"}),_vm._v(" TOP 5 SELLING PRODUCT "+_vm._s(_vm.mnth)+"\n")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{attrs:{"columns":_vm.columns2,"rows":_vm.rows2,"pagination-options":{
        enabled: false,
        perPage: 5,
      },"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span'):_c('span',[_vm._v("\n      "+_vm._s(props.formattedRow[props.column.field])+"\n    ")])]}}])})],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ea04bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__ = __webpack_require__(717);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ea04bf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-primary",attrs:{"no-body":""},on:{"click":function($event){_vm.bcardclick()}}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(_vm._s(_vm.total_user))]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Active User: "+_vm._s(_vm.active_user)+" "),_c('br'),_vm._v("Inactive/Locked User: "+_vm._s(_vm.inactive_user))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-info",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass})]),_vm._v(" "),_c('p',[_vm._v("Balance to Collect")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-warning",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass})]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.dashbd_view))]),_vm._v(" "),_c('p',[_vm._v("Total Purchase Expenses")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6","lg":"3"}},[_c('b-card',{staticClass:"bg-success",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"pb-0"},[_c('h4',{staticClass:"mb-0"},[_c('i',{class:_vm.currencyIconClass})]),_vm._v(" "),_c('p',[_vm._v("Value of Stock")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad31515_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(720);
function injectStyle (ssrContext) {
  __webpack_require__(719)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad31515_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('Spinner'):_vm._e(),_vm._v(" "),(_vm.super_user == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Company Details"),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.super_user))])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.messagesucc != '')?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert","data-dismiss":"alert"}},[_c('strong',[_vm._v(_vm._s(_vm.messagesucc)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reg_view),expression:"reg_view"}],attrs:{"type":"hidden","name":"aaa"},domProps:{"value":(_vm.reg_view)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reg_view=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.name),expression:"company.name"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companyname},attrs:{"type":"text","id":"company_name","name":"company_name","placeholder":"Enter Company Name","autocomplete":"off"},domProps:{"value":(_vm.company.name)},on:{"keyup":function($event){_vm.onComplete('false','cmpname')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "name", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.companyname)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companyname))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.comptype1,"option-value":"companycode","option-text":"desc","placeholder":"Select Company Type","autocomplete":"off"},on:{"input":function($event){_vm.onComplete('false','cmptype')}},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}}),_vm._v(" "),(_vm.hasErrors.cmptype)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.cmptype))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Address ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.add),expression:"company.add"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companyadd1},attrs:{"type":"text","id":"address1","name":"address1","placeholder":"Enter Address","autocomplete":"off"},domProps:{"value":(_vm.company.add)},on:{"keyup":function($event){_vm.onComplete('false','address')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "add", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.companyadd1)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companyadd1))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country","autocomplete":"off"},on:{"input":[_vm.state1,function($event){_vm.onComplete('false','con')}]},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}}),_vm._v(" "),(_vm.hasErrors.conty)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.conty))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State","autocomplete":"off"},on:{"input":[_vm.city1,function($event){_vm.onComplete('false','state')}]},model:{value:(_vm.stateo1),callback:function ($$v) {_vm.stateo1=$$v},expression:"stateo1"}}),_vm._v(" "),(_vm.hasErrors.stateopt1)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.stateopt1))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select City","autocomplete":"off"},on:{"input":function($event){_vm.onComplete('false','city')}},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),(_vm.hasErrors.ctyopt)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.ctyopt))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.pincode),expression:"company.pincode"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companypin},attrs:{"type":"text","id":"alt_product_id","name":"alt_product_id","placeholder":"Enter Pincode","autocomplete":"off"},domProps:{"value":(_vm.company.pincode)},on:{"keyup":function($event){_vm.onComplete('false','pncd')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "pincode", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.companypin)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companypin)+"  ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.companyphone),expression:"company.companyphone"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.compphone},attrs:{"type":"text","id":"cmp_phone","name":"cmp_phone","placeholder":"Enter Company Phone No","autocomplete":"off"},domProps:{"value":(_vm.company.companyphone)},on:{"keyup":function($event){_vm.onComplete('false','companyphone')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "companyphone", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.compphone)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.compphone))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.email),expression:"company.email"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companymail},attrs:{"type":"text","id":"cmp_email","name":"cmp_email","placeholder":"Enter Company Email","autocomplete":"off"},domProps:{"value":(_vm.company.email)},on:{"keyup":function($event){_vm.onComplete('false','email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "email", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.companymail)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companymail))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Logo ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",attrs:{"type":"file","name":"image1","id":"image1","accept":"image/*","autocomplete":"off"},on:{"change":function($event){_vm.onComplete('false','logo')}}}),_vm._v(" "),(_vm.hasErrors.image1!=null)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.image1))])]):_vm._e(),_vm._v(" "),(_vm.view.image1!==null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.view.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Registration Year ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.yearopt,"option-value":"year","option-text":"year","placeholder":"Select Year","autocomplete":"off"},model:{value:(_vm.sel_year),callback:function ($$v) {_vm.sel_year=$$v},expression:"sel_year"}})],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Company Document Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Corporate Identity Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.cin),expression:"company.cin"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companycin},attrs:{"type":"text","id":"product_alert_qty","aria-label":"Enter Corporate Identity Number","aria-describedby":"btnGroupAddon","name":"product_alert_qty","placeholder":"Enter Company  CIN Number","autocomplete":"off"},domProps:{"value":(_vm.company.cin)},on:{"keyup":function($event){_vm.onComplete('false','cin')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "cin", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.companycin)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companycin))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CIN Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",attrs:{"type":"file","name":"image2","id":"image2","placeholder":"Enter Company CIN Numberr","autocomplete":"off"},on:{"change":function($event){_vm.onComplete('false','cincert')}}}),_vm._v(" "),(_vm.hasErrors.image2!=null)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.image2))])]):_vm._e(),_vm._v(" "),(_vm.view.image2!=null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.view.image2_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST/VAT Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.gst),expression:"company.gst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companygst},attrs:{"type":"text","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon","autocomplete":"off"},domProps:{"value":(_vm.company.gst)},on:{"keyup":function($event){_vm.onComplete('false','gst')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "gst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.companygst)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companygst))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",attrs:{"type":"file","name":"image3","id":"image3","accept":"image/*","autocomplete":"off"},on:{"change":function($event){_vm.onComplete('false','gstcert')}}}),_vm._v(" "),(_vm.hasErrors.image3!=null)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.image3))])]):_vm._e(),_vm._v(" "),(_vm.view.image3!=null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.view.image3_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.pan),expression:"company.pan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companypan},attrs:{"type":"text","placeholder":"Enter Company PAN Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon","autocomplete":"off"},domProps:{"value":(_vm.company.pan)},on:{"keyup":function($event){_vm.onComplete('false','pan')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "pan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.companypan)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companypan))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",attrs:{"type":"file","id":"image4","name":"image4","placeholder":"Enter Company Pan Numberr","autocomplete":"off"},on:{"change":function($event){_vm.onComplete('false','pancert')}}}),_vm._v(" "),(_vm.hasErrors.image4!=null)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.image4))])]):_vm._e(),_vm._v(" "),(_vm.view.image4!=null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.view.image4_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.tan),expression:"company.tan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.companytan},attrs:{"type":"text","id":"cmp_tan","name":"cmp_tan","placeholder":"Enter Company Tan Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon","autocomplete":"off"},domProps:{"value":(_vm.company.tan)},on:{"keyup":function($event){_vm.onComplete('false','tan')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "tan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.companytan)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companytan))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",attrs:{"type":"file","id":"image5","name":"image5","placeholder":"Enter Company Pan Numberr","autocomplete":"off"},on:{"change":function($event){_vm.onComplete('false','tancert')}}}),_vm._v(" "),(_vm.hasErrors.image5!=null)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.image5))])]):_vm._e(),_vm._v(" "),(_vm.view.image5!=null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.view.image5_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Profile ")]),_vm._v(" "),_c('vue-editor',{on:{"input":function($event){_vm.onComplete('false','profile')}},model:{value:(_vm.company.profile),callback:function ($$v) {_vm.$set(_vm.company, "profile", $$v)},expression:"company.profile"}}),_vm._v(" "),(_vm.hasErrors.companyprofile)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.companyprofile))])]):_vm._e()],1)])])]),_vm._v(" "),(_vm.reg_rights === true)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.finalSave()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.bankname),expression:"company.bankname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.banknm},attrs:{"type":"text","id":"bankname","name":"bankname","placeholder":"Enter your Bank Name","autocomplete":"off"},domProps:{"value":(_vm.company.bankname)},on:{"keyup":function($event){_vm.onComplete('false','bankname')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "bankname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.banknm)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.banknm))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Holder Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.bankholdername),expression:"company.bankholdername"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankac},attrs:{"type":"text","id":"bankholder","name":"bankholder","placeholder":"Enter your Bank Holder Name","autocomplete":"off"},domProps:{"value":(_vm.company.bankholdername)},on:{"keyup":function($event){_vm.onComplete('false','bankhldname')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "bankholdername", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankholdername)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.bankholdername))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.bankaccount),expression:"company.bankaccount"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankac},attrs:{"type":"text","id":"bankacc","name":"bankacc","placeholder":"Enter your Bank Account Number","autocomplete":"off"},domProps:{"value":(_vm.company.bankaccount)},on:{"keyup":function($event){_vm.onComplete('false','bankacc')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "bankaccount", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankac)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.bankac))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IFSC Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.ifsc),expression:"company.ifsc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankifsc},attrs:{"type":"text","id":"ifsc","name":"ifsc","placeholder":"Enter Bank IFSC Code","autocomplete":"off"},domProps:{"value":(_vm.company.ifsc)},on:{"keyup":function($event){_vm.onComplete('false','ifsc')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "ifsc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankifsc)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.bankifsc))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Branch ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.branch),expression:"company.branch"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankbrnch},attrs:{"type":"text","id":"bankbranch","name":"bankbranch","placeholder":"Enter Branch Name","autocomplete":"off"},domProps:{"value":(_vm.company.branch)},on:{"keyup":function($event){_vm.onComplete('false','branch')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "branch", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankbrnch)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.bankbrnch)+" ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("MICR Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.micr),expression:"company.micr"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankmicr},attrs:{"type":"text","id":"micrcode","name":"micrcode","placeholder":"Enter MICR code","autocomplete":"off"},domProps:{"value":(_vm.company.micr)},on:{"keyup":function($event){_vm.onComplete('false','micr')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "micr", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankmicr)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.bankmicr))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Swift Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.code),expression:"company.code"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankswft},attrs:{"type":"text","id":"Swiftcode","name":"Swiftcode","placeholder":"Enter Bank Swift Code","autocomplete":"off"},domProps:{"value":(_vm.company.code)},on:{"keyup":function($event){_vm.onComplete('false','swiftcode')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "code", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankswft)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.bankswft)+" ")])]):_vm._e()])])])])])])]):(_vm.shop_user == 2)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Company Details"),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.reg_view))])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Name")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.name))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[(_vm.selectedCategory.desc!='')?_c('h5',[_vm._v(_vm._s(_vm.selectedCategory.desc))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Address")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.add)+", "),(_vm.city.city_name!='')?_c('span',[_vm._v(_vm._s(_vm.city.city_name))]):_vm._e(),_vm._v(", "),(_vm.stateo1.state_name!='')?_c('span',[_vm._v(_vm._s(_vm.stateo1.state_name))]):_vm._e(),_vm._v(" "),(_vm.company.pincode!='')?_c('span',[_vm._v("- ("+_vm._s(_vm.company.pincode)+")")]):_vm._e(),_vm._v(", "+_vm._s(_vm.con.country_name))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Phone")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.companyphone))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Email")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.email))])])])])]),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Company Document Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Corporate Identity Number ")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.cin))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST/VAT Number")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.gst))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Number")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.pan))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Number")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.tan))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Profile ")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.company.profile)}})])])]),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Company Bank Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Name")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.bankname))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Holder Name")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.bankholdername))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Number")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.bankaccount))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IFSC Number")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.ifsc))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Branch")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.branch))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("MICR Code")]),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_c('h5',[_vm._v(_vm._s(_vm.company.micr))])])])])])])])])]):_c('div',{staticClass:"row"},[_vm._m(10)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Company Name"),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Company Type "),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Country "),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("State "),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("City "),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Pincode "),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Company Phone No."),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Company Email "),_c('span',{staticClass:"star"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("PAN Number "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Company Bank Details")]),_vm._v(" "),_c('small')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("RESTRICTED")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('h3',[_vm._v("You cannot access this page")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shop_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abe3a1a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shop_vue__ = __webpack_require__(724);
function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abe3a1a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */,
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.errorMessage.message != '')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_c('strong'),_vm._v(_vm._s(_vm.errorMessage.message))])],1):_vm._e()])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","autocomplete":"off","id":"name1","placeholder":"Enter Shop Name"},model:{value:(_vm.search.name),callback:function ($$v) {_vm.$set(_vm.search, "name", $$v)},expression:"search.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.citysrchopt,"option-value":"id","option-text":"city_name","placeholder":"Select Shop City"},on:{"searchchange":_vm.searchcity},model:{value:(_vm.search.city),callback:function ($$v) {_vm.$set(_vm.search, "city", $$v)},expression:"search.city"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopad2},attrs:{"type":"text","autocomplete":"off","id":"name3","placeholder":"Enter Pincode"},model:{value:(_vm.search.pincode),callback:function ($$v) {_vm.$set(_vm.search, "pincode", $$v)},expression:"search.pincode"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"name"}}),_vm._v(" "),(_vm.shop_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.serachprev($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")]):_vm._e()])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Shop List")]),_vm._v("  \n          "),_c('span',[(_vm.shop_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.addshopnew}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Shop")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[[_c('div',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{enabled: true, perPage: 10},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"rgb(99, 194, 222)"},on:{"click":function($event){$event.preventDefault();_vm.viewshop(props.row)}}}),_vm._v(" "),(_vm.shop_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                    "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")])]}}])}),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Shop Establishment","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Type"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.shoptype),expression:"shoptype"}],ref:"shptype",staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.shoptype=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","readonly":"","value":""}},[_vm._v("Select Your Shop Type")]),_vm._v(" "),_c('option',{attrs:{"value":"shop"}},[_vm._v("Shop")]),_vm._v(" "),_c('option',{attrs:{"value":"warehouse"}},[_vm._v("Warehouse")])]),_vm._v(" "),(_vm.hasErrors.cmptype)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Company  Type")])]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Shop Name "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtshopname",class:{'is-invalid':_vm.hasErrors.shopnm},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Shop Name"},nativeOn:{"blur":function($event){_vm.chkShopExist()}},model:{value:(_vm.shop.name),callback:function ($$v) {_vm.$set(_vm.shop, "name", $$v)},expression:"shop.name"}}),_vm._v(" "),(_vm.hasErrors.shopnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Shop Name")])]):_vm._e(),_vm._v(" "),(_vm.hasErrors.shopnmexist === true)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Shop Name Already Exist")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 1 "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopad1},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Address Line 1"},model:{value:(_vm.shop.address1),callback:function ($$v) {_vm.$set(_vm.shop, "address1", $$v)},expression:"shop.address1"}}),_vm._v(" "),(_vm.hasErrors.shopad1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Shop Address")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 2 ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopad2},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Address Line 2"},model:{value:(_vm.shop.address2),callback:function ($$v) {_vm.$set(_vm.shop, "address2", $$v)},expression:"shop.address2"}}),_vm._v(" "),(_vm.hasErrors.shopad2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Shop Address")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Country "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country"},on:{"input":_vm.state1},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}}),_vm._v(" "),(_vm.hasErrors.shopcntry)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select Country")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("State "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.city1},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}}),_vm._v(" "),(_vm.hasErrors.shopstate)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select State")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select City"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),(_vm.hasErrors.shopcity)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select City")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shoppin},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter your Pincode"},model:{value:(_vm.shop.pincode),callback:function ($$v) {_vm.$set(_vm.shop, "pincode", $$v)},expression:"shop.pincode"}}),_vm._v(" "),(_vm.hasErrors.shoppin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Pincode")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("GST No. ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shop_gst},attrs:{"type":"text","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Your GST No"},model:{value:(_vm.shop.gst),callback:function ($$v) {_vm.$set(_vm.shop, "gst", $$v)},expression:"shop.gst"}}),_vm._v(" "),(_vm.hasErrors.shop_gst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST No")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact No. "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopph},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Shop Phone Number"},model:{value:(_vm.shop.phone),callback:function ($$v) {_vm.$set(_vm.shop, "phone", $$v)},expression:"shop.phone"}}),_vm._v(" "),(_vm.hasErrors.shopph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Phone Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Shop Admin "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.useropt,"option-value":"email","custom-text":_vm.nameAndnumber,"placeholder":"Select Shop Admin"},model:{value:(_vm.adminuser),callback:function ($$v) {_vm.adminuser=$$v},expression:"adminuser"}}),_vm._v(" "),(_vm.hasErrors.shopadmin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select Shop Admin")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Locate Address In Map ")]),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"warning"},on:{"click":_vm.openwarning}},[_vm._v("Select Address In Map")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}}),_vm._v("\n                      Sale Price Editable : "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shop.sale_price_editable),expression:"shop.sale_price_editable"}],attrs:{"type":"checkbox","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.shop.sale_price_editable)?_vm._i(_vm.shop.sale_price_editable,null)>-1:(_vm.shop.sale_price_editable)},on:{"change":function($event){var $$a=_vm.shop.sale_price_editable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.shop.sale_price_editable=$$a.concat([$$v]))}else{$$i>-1&&(_vm.shop.sale_price_editable=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.shop, "sale_price_editable", $$c)}}}})])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_save_btn),expression:"show_save_btn"}],staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Successsub()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v("  Save")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                  You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.\n                ")])],1)],1)],1)],1)]],2)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Select Address","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = false}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('div',[_c('label',[_vm._v("Search Address"),_c('GmapAutocomplete',{on:{"place_changed":_vm.setPlace}}),_vm._v(" "),(_vm.buttosstat==0)?_c('span',[_c('button',{on:{"click":_vm.usePlace}},[_vm._v("Add")])]):_c('span',[_c('label',[_vm._v("Now you can drag Marker to your loacation")])])],1),_vm._v(" "),_c('label',[( _vm.buttosstat==1)?_c('div',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.revertbck}},[_vm._v("save")])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"300px"},attrs:{"zoom":16,"center":_vm.center}},[_vm._l((_vm.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=marker.position},"dragend":function($event){_vm.getMarkerPosition($event.latLng)}}})}),(this.place)?_c('gmap-marker',{attrs:{"label":"★","position":{lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()}}}):_vm._e()],2)],1)]),_vm._v(" "),(_vm.loading === true)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Shop & Establishment Search")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b394c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__ = __webpack_require__(726);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b394c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v("\n            Roles List "),(_vm.r_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){_vm.addRoles()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Create Custom Role")]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.r_view))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message!='')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message))])],1):_vm._e()])]),_vm._v(" "),_c('div',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{enabled: true, perPage: 5},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){_vm.viewpermission(props.row)}}}),_vm._v(" "),(props.row.company_id !== "I2OCGLB")?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){_vm.editpermission(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.deletepermission(props.row)}}})]):_vm._e()]):_c('span',[_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")])]}}])})],1)])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Add Role Type","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.roletype),callback:function ($$v) {_vm.roletype=$$v},expression:"roletype"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Role Type Name:")]),_vm._v(" "),_c('b-form-input',{ref:"txtrolename",class:{'is-invalid':_vm.haserror.role_name},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter New Role Type"},nativeOn:{"blur":function($event){_vm.chkExist()}},model:{value:(_vm.role_name),callback:function ($$v) {_vm.role_name=$$v},expression:"role_name"}}),_vm._v(" "),(_vm.haserror.role_name)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.role_name))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectallview_add),expression:"selectallview_add"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectallview_add)?_vm._i(_vm.selectallview_add,null)>-1:(_vm.selectallview_add)},on:{"change":[function($event){var $$a=_vm.selectallview_add,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectallview_add=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectallview_add=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectallview_add=$$c}},function($event){_vm.selectallview('add')}]}}),_c('strong',[_vm._v("Select All")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectallrights_add),expression:"selectallrights_add"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectallrights_add)?_vm._i(_vm.selectallrights_add,null)>-1:(_vm.selectallrights_add)},on:{"change":[function($event){var $$a=_vm.selectallrights_add,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectallrights_add=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectallrights_add=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectallrights_add=$$c}},function($event){_vm.selectallrights('add')}]}}),_c('strong',[_vm._v("Select All")])])],1)],1),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletebrand(props.row)}}})]):(props.column.field == 'view')?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkview[props.row.originalIndex]),expression:"checkview[props.row.originalIndex]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkview[props.row.originalIndex])?_vm._i(_vm.checkview[props.row.originalIndex],null)>-1:(_vm.checkview[props.row.originalIndex])},on:{"change":[function($event){var $$a=_vm.checkview[props.row.originalIndex],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkview[props.row.originalIndex]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkview[props.row.originalIndex]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.checkview, props.row.originalIndex, $$c)}},function($event){_vm.checkedview(props.row.originalIndex)}]}})]):(props.column.field == 'rights')?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkrights[props.row.originalIndex]),expression:"checkrights[props.row.originalIndex]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkrights[props.row.originalIndex])?_vm._i(_vm.checkrights[props.row.originalIndex],null)>-1:(_vm.checkrights[props.row.originalIndex])},on:{"change":[function($event){var $$a=_vm.checkrights[props.row.originalIndex],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkrights[props.row.originalIndex]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkrights[props.row.originalIndex]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.checkrights, props.row.originalIndex, $$c)}},function($event){_vm.checkedrights(props.row.originalIndex)}]}})]):_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")])]}}])}),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.close_addroles()}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.create_roles()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"View Role Type","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.viewroles),callback:function ($$v) {_vm.viewroles=$$v},expression:"viewroles"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Role Type: "),_c('strong',[_vm._v(_vm._s(_vm.role_name_view))])])])],1)],1),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletebrand(props.row)}}})]):(props.column.field == 'view')?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkview_view[props.row.originalIndex]),expression:"checkview_view[props.row.originalIndex]"}],attrs:{"type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.checkview_view[props.row.originalIndex])?_vm._i(_vm.checkview_view[props.row.originalIndex],null)>-1:(_vm.checkview_view[props.row.originalIndex])},on:{"change":function($event){var $$a=_vm.checkview_view[props.row.originalIndex],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkview_view[props.row.originalIndex]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkview_view[props.row.originalIndex]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.checkview_view, props.row.originalIndex, $$c)}}}})]):(props.column.field == 'rights')?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkrights_view[props.row.originalIndex]),expression:"checkrights_view[props.row.originalIndex]"}],attrs:{"type":"checkbox","disabled":"disabled"},domProps:{"checked":Array.isArray(_vm.checkrights_view[props.row.originalIndex])?_vm._i(_vm.checkrights_view[props.row.originalIndex],null)>-1:(_vm.checkrights_view[props.row.originalIndex])},on:{"change":function($event){var $$a=_vm.checkrights_view[props.row.originalIndex],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkrights_view[props.row.originalIndex]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkrights_view[props.row.originalIndex]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.checkrights_view, props.row.originalIndex, $$c)}}}})]):_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")])]}}])})],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-primary",attrs:{"title":"Edit Role Type","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.editmodal),callback:function ($$v) {_vm.editmodal=$$v},expression:"editmodal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Role Type :")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","autocomplete":"off","placeholder":"Enter New Role Type"},model:{value:(_vm.role_name1),callback:function ($$v) {_vm.role_name1=$$v},expression:"role_name1"}}),_vm._v(" "),(_vm.haserror.role_name1!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.role_name1))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectallview_edit),expression:"selectallview_edit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectallview_edit)?_vm._i(_vm.selectallview_edit,null)>-1:(_vm.selectallview_edit)},on:{"change":[function($event){var $$a=_vm.selectallview_edit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectallview_edit=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectallview_edit=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectallview_edit=$$c}},function($event){_vm.selectallview('edit')}]}}),_c('strong',[_vm._v("Select All")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectallrights_edit),expression:"selectallrights_edit"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectallrights_edit)?_vm._i(_vm.selectallrights_edit,null)>-1:(_vm.selectallrights_edit)},on:{"change":[function($event){var $$a=_vm.selectallrights_edit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectallrights_edit=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectallrights_edit=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectallrights_edit=$$c}},function($event){_vm.selectallrights('edit')}]}}),_c('strong',[_vm._v("Select All")])])],1)],1),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletebrand(props.row)}}})]):(props.column.field == 'view')?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkview_edit[props.row.originalIndex]),expression:"checkview_edit[props.row.originalIndex]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkview_edit[props.row.originalIndex])?_vm._i(_vm.checkview_edit[props.row.originalIndex],null)>-1:(_vm.checkview_edit[props.row.originalIndex])},on:{"change":[function($event){var $$a=_vm.checkview_edit[props.row.originalIndex],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkview_edit[props.row.originalIndex]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkview_edit[props.row.originalIndex]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.checkview_edit, props.row.originalIndex, $$c)}},function($event){_vm.checkedview_edit(props.row.originalIndex)}]}})]):(props.column.field == 'rights')?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkrights_edit[props.row.originalIndex]),expression:"checkrights_edit[props.row.originalIndex]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkrights_edit[props.row.originalIndex])?_vm._i(_vm.checkrights_edit[props.row.originalIndex],null)>-1:(_vm.checkrights_edit[props.row.originalIndex])},on:{"change":[function($event){var $$a=_vm.checkrights_edit[props.row.originalIndex],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkrights_edit[props.row.originalIndex]=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkrights_edit[props.row.originalIndex]=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.checkrights_edit, props.row.originalIndex, $$c)}},function($event){_vm.checkedrights_edit(props.row.originalIndex)}]}})]):_c('span',[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")])]}}])}),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.update_roles()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])],1),_vm._v(" "),_c('Spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4251a170_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(732);
function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4251a170_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("Search Shop User")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasErrors.message)?_c('div',{staticClass:"alert alert-success"},[_c('center',[_c('strong'),_vm._v(_vm._s(_vm.errorMessage.message))])],1):_vm._e()])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" User Name ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter your name","autocomplete":"off"},model:{value:(_vm.user.names),callback:function ($$v) {_vm.$set(_vm.user, "names", $$v)},expression:"user.names"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter your Email Address","autocomplete":"off"},model:{value:(_vm.user.email1),callback:function ($$v) {_vm.$set(_vm.user, "email1", $$v)},expression:"user.email1"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Establishment ID ")]),_vm._v(" "),_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.shopidopt1,"option-value":"est_shop_name","option-text":"est_shop_name","placeholder":"Select Shop Establishment ID"},model:{value:(_vm.shopids),callback:function ($$v) {_vm.shopids=$$v},expression:"shopids"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[(_vm.u_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.shopuser($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n            ")]):_vm._e()])],1)],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("List User's")]),_vm._v("  \n      "),(_vm.u_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.addusers}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add User\n        ")])]):_vm._e()]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}})]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',[(props.row.status == '1')?_c('div',[_c('b-badge',{attrs:{"variant":"success"}},[_vm._v("Active")])],1):_c('div',[_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("In Active")])],1)]):_c('span',[_vm._v("\n              "+_vm._s(props.formattedRow[props.column.field])+"\n            ")])]}}])}),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"User Detail","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.hasErrors.err_message)?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.errorMessage.err_message))])],1):_vm._e()])],1),_vm._v(" "),(_vm.isSuperAdmin === false)?_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Status ")]),_vm._v("\n               "),_c('label',{staticClass:"switch switch-text switch-pill switch-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkbox),expression:"checkbox"}],staticClass:"switch-input",attrs:{"type":"checkbox","data-toggle":"tooltip","data-placement":"top","title":"","data-original-title":"Tooltip on top","true-value":true,"false-value":false},domProps:{"checked":Array.isArray(_vm.checkbox)?_vm._i(_vm.checkbox,null)>-1:(_vm.checkbox)},on:{"change":function($event){var $$a=_vm.checkbox,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkbox=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkbox=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkbox=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"Active","data-off":"Inactive"}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin === true)?_c('b-form-group',{staticStyle:{"text-align":"right"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Activate/Deactivate Account ")]),_vm._v("\n               "),_c('label',{staticClass:"switch switch-text switch-pill switch-primary"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.active_deactive),expression:"active_deactive"}],staticClass:"switch-input",attrs:{"type":"checkbox","data-toggle":"tooltip","data-placement":"top","title":"","data-original-title":"Tooltip on top","true-value":true,"false-value":false},domProps:{"checked":Array.isArray(_vm.active_deactive)?_vm._i(_vm.active_deactive,null)>-1:(_vm.active_deactive)},on:{"change":[function($event){var $$a=_vm.active_deactive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.active_deactive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.active_deactive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.active_deactive=$$c}},_vm.account_status]}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"Active","data-off":"Deactive"}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("User Name"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.usernm },attrs:{"type":"text","placeholder":"Enter your name","autocomplete":"off"},nativeOn:{"keyup":function($event){_vm.onComplete('false', 'uname')}},model:{value:(_vm.user.name),callback:function ($$v) {_vm.$set(_vm.user, "name", $$v)},expression:"user.name"}}),_vm._v(" "),(_vm.hasErrors.usernm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.usernm))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),(_vm.updateedit === 0)?_c('div',[_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.usereml },attrs:{"type":"text","autocomplete":"off","placeholder":"Enter your email"},nativeOn:{"keyup":function($event){_vm.onComplete('false', 'eml')}},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1):_c('div',[_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.usereml },attrs:{"type":"text","autocomplete":"off","value":_vm.user.email,"readonly":"","placeholder":"Enter your email"}})],1),_vm._v(" "),(_vm.hasErrors.usereml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.usereml))])]):_vm._e()])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.userph },attrs:{"type":"text","name":"phone","placeholder":"Enter your contact number","autocomplete":"off"},nativeOn:{"keyup":function($event){_vm.onComplete('false', 'phn')}},model:{value:(_vm.user.phone),callback:function ($$v) {_vm.$set(_vm.user, "phone", $$v)},expression:"user.phone"}}),_vm._v(" "),(_vm.hasErrors.userph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.userph))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Password "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('div',[_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.password },attrs:{"type":"password","placeholder":"Enter your name","autocomplete":"off"},nativeOn:{"keyup":function($event){_vm.onComplete('false', 'psw')}},model:{value:(_vm.user.pass),callback:function ($$v) {_vm.$set(_vm.user, "pass", $$v)},expression:"user.pass"}})],1),_vm._v(" "),(_vm.hasErrors.password)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.password))])]):_vm._e()])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Confirm Password "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.confpassword },attrs:{"type":"password","name":"conf","placeholder":"Enter your ConfirmPassword","autocomplete":"off"},on:{"input":function($event){_vm.onComplete('false', 'cnfpsw')}},model:{value:(_vm.user.conf),callback:function ($$v) {_vm.$set(_vm.user, "conf", $$v)},expression:"user.conf"}}),_vm._v(" "),(_vm.hasErrors.confpassword)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.confpassword))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}})],1),_vm._v(" "),(_vm.isSuperAdmin === false)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Select Shops")]),_vm._v(" "),_c('vue-good-table',{ref:"myShopTable",attrs:{"id":"shoplist","totalRows":_vm.totalRecordsShop,"columns":_vm.columnsadj,"rows":_vm.rowsadj,"select-options":{
                  enabled: true,
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
                },"styleClass":"vgt-table striped bordered table-sm condensed","pagination-options":{ enabled: true, perPage: 5 }},on:{"on-page-change":_vm.onPageChangeShop,"on-sort-change":_vm.onSortChangeShop,"on-column-filter":_vm.onColumnFilterShop,"on-per-page-change":_vm.onPerPageChangeShop,"on-selected-rows-change":function($event){_vm.selectedShops($event)}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")]}}])},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_vm._v("\n                  No Data\n                ")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.errorMessage.usershop)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.usershop))])]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin === false)?_c('b-row',{staticStyle:{"padding-top":"20px"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Select Roles")]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.column1,"rows":_vm.rows1,"totalRows":_vm.totalRecordsRoles,"search-options":{ enabled: true },"select-options":{ enabled: true },"styleClass":"vgt-table striped bordered table-sm condensed","pagination-options":{ enabled: true, perPage: 10 }},on:{"on-row-click":_vm.selectedRoles,"on-page-change":_vm.onPageChangeRole,"on-sort-change":_vm.onSortChangeRole,"on-column-filter":_vm.onColumnFilterRole,"on-per-page-change":_vm.onPerPageChangeRole},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")]}}])})],1)],1):_vm._e(),_vm._v(" "),(_vm.errorMessage.userrole)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.userrole))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-button-group',[(_vm.u_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n                  ")]):_vm._e()])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Please Confirm","size":"sm","ok-variant":"danger","ok-title":"Yes, Deactivate it"},on:{"ok":_vm.handleOk},model:{value:(_vm.deact_modal),callback:function ($$v) {_vm.deact_modal=$$v},expression:"deact_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("Are you Sure, you want to deactivate your account?")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                Deactivating your account will disable your account and you\n                will not be able to login again.\n              ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                You have reached the limit of adding User. Please upgrade your\n                plan to add more Users.\n              ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_decd7c9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(734)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_decd7c9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */,
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"color":"#20a8d8"}}),_vm._v(" I2OC\n              Process Flow Chart\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-pill btn-primary",staticStyle:{"height":"35px","margin-top":"1px"},attrs:{"id":"btn_manual","type":"button"},on:{"click":function($event){$event.preventDefault();_vm.download_manual($event)}}},[_vm._v("\n                Download Manual\n              ")])])])]),_vm._v(" "),_c('form-wizard',{attrs:{"color":"#20a8d8"}},[_c('h5',{staticStyle:{"display":"none"},attrs:{"slot":"title"},slot:"title"}),_vm._v(" "),_c('tab-content',{attrs:{"title":"Basic Setup","icon":"fa fa-info-circle"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"container"}},[_c('ol',{staticClass:"organizational-chart"},[_c('li',[_c('div',{staticClass:"opp"},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Basic Setup\n                      ")])]),_vm._v(" "),_c('ol',{staticStyle:{"padding-right":"10%","padding-left":"10%"}},[_c('li',{staticStyle:{"width":"27%"}},[_c('div',{staticClass:"opp"},[_c('a',{staticClass:"opp",attrs:{"href":"#"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" Company Profile\n                            ")])])]),_vm._v(" "),_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/companyinfo/Registration"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Shop / Company\n                                  Registration\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/companyinfo/Shop"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"color":"rgba(41, 54, 61, 0.76)"}}),_vm._v("\n                                  Add Multiple Shops\n                                ")])])])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" Roles\n                            ")])])]),_vm._v(" "),_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/Definesecurity/User"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" Add User\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/Definesecurity/Role"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Add Update\n                                  Role\n                                ")])])])])])])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Setup","icon":"fa fa-cogs"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"container"}},[_c('ol',{staticClass:"organizational-chart"},[_c('li',[_c('div',{staticClass:"opp"},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" Setup\n                      ")])]),_vm._v(" "),_c('ol',{staticStyle:{"width":"42%","margin-left":"29%"}},[_c('li',[_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/addupdatecategory"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-list-alt"}),_vm._v(" Product\n                                  Category\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/addupdatebrand"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-bold"}),_vm._v(" Add Brand\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/addupdateunit"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" Add Unit\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/addupdatevariant"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-list-ol"}),_vm._v(" Add Variant\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/taxdetails/hsn"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-percent"}),_vm._v(" Add HSN\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/taxdetails/hsnrate"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-percent"}),_vm._v(" Add Tax\n                                  Details\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/setup/addupdateproduct"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" Add\n                                  Product\n                                ")])])])])])])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Purchase","icon":"fa fa-shopping-cart"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"container"}},[_c('ol',{staticClass:"organizational-chart"},[_c('li',[_c('div',{staticClass:"opp"},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v(" Purchase\n                      ")])]),_vm._v(" "),_c('ol',{staticStyle:{"width":"42%","margin-left":"29%"}},[_c('li',[_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/purchase/supplier/add"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" Add Supplier\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/purchase/purchaseentry"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"color":"rgba(41, 54, 61, 0.76)"}}),_vm._v("\n                                  Purchase Entry\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/purchase/Listpurchesreturn"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-retweet"}),_vm._v(" Purchase\n                                  Return\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/purchase/addpayment"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-money"}),_vm._v(" Add Payments\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/purchase/listpayment"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-retweet"}),_vm._v(" List Payments\n                                ")])])])])])])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Sale","icon":"fa fa-pie-chart"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"container"}},[_c('ol',{staticClass:"organizational-chart"},[_c('li',[_c('div',{staticClass:"opp"},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-pie-chart"}),_vm._v(" Sale\n                      ")])]),_vm._v(" "),_c('ol',{staticStyle:{"width":"42%","margin-left":"29%"}},[_c('li',[_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/sales/Customeradd"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v(" Add Customer\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/sales/salesentry"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-cart-plus"}),_vm._v(" Sale Entry\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/Salesreturn/list"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-retweet"}),_vm._v(" Sale Return\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/sales/saleinvoice/list"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" Sale\n                                  Invoice\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/sales/salereceipt"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" Sale Receipt\n                                ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/sales/Salesreceipthistory"}},[_c('h5',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" Sale Receipt\n                                  History\n                                ")])])])])])])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Stock Transfer","icon":"fa fa-exchange"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"container"}},[_c('ol',{staticClass:"organizational-chart"},[_c('li',[_c('div',{staticClass:"opp"},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-exchange"}),_vm._v(" Stock Transfer\n                      ")])]),_vm._v(" "),_c('ol',{staticStyle:{"width":"42%","margin-left":"29%"}},[_c('li',[_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/stocktransfer"}},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-retweet"}),_vm._v(" From Shop To\n                                  Shop\n                                ")])])])])])])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Shop Inventory","icon":"fa fa-th-list"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('div',{attrs:{"id":"container"}},[_c('ol',{staticClass:"organizational-chart"},[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/shop_inventory"}},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_vm._v("Shop Inventory")])])]),_vm._v(" "),_c('ol',{staticStyle:{"width":"42%","margin-left":"29%"}},[_c('li',[_c('ol',[_c('li',[_c('div',{staticClass:"opp"},[_c('a',{attrs:{"href":"#/shopinventory"}},[_c('h4',{staticStyle:{"color":"#29363dc2"}},[_c('i',{staticClass:"fa fa-retweet"}),_vm._v(" Shop Inventory\n                                ")])])])])])])])])])])])])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addpurches_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4095218c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addpurches_vue__ = __webpack_require__(740);
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addpurches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4095218c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addpurches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{attrs:{"list":_vm.suppliername,"option-value":"sup_cmp_name","custom-text":_vm.nameAndnumber,"placeholder":"Search Supplier Name"},on:{"input":function($event){_vm.onSelectSup($event)},"searchchange":_vm.searchsupplier},model:{value:(_vm.selectedcustomer),callback:function ($$v) {_vm.selectedcustomer=$$v},expression:"selectedcustomer"}}),_vm._v("  \n                  "),_vm._v(" "),(_vm.sup_rights === true)?_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill btn-primary",attrs:{"type":"button","route":"","title":"Add New Supplier"},on:{"click":function($event){_vm.addSupplier()}}},[_c('i',{staticClass:"fa fa-user"})]):_vm._e()],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},on:{"input":function($event){_vm.onSelectShp($event)},"searchchange":_vm.searchshops},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}}),_vm._v("  \n                  "),_vm._v(" "),_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill btn-primary",attrs:{"type":"button","title":"Add New Shop"},on:{"click":function($event){_vm.addShop()}}},[_c('i',{staticClass:"fa fa-plus"})])],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Scan Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","name":"barcode","autocomplete":"off","placeholder":"Enter Product Barcode Number"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n                "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',{},[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"1%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Purchase Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Sales Price")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"13%"}},[_vm._v("Total ")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[_c('a',{staticStyle:{"font-size":"14px","color":"#20a8d8","cursor":"pointer"},on:{"click":function($event){_vm.addProduct(row,index)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-plus",attrs:{"title":"Add New Product"}})])]),_vm._v(" "),_c('td',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"white-space":"nowrap","-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name","id":"productlist"},on:{"input":function($event){_vm.openvariant($event,index)},"searchchange":function($event){_vm.searchprd3($event,index,row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.showvariant==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.variantrow))])]):_vm._e(),_vm._v(" "),(row.novariant==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant   "),_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.variantrow))])]):_vm._e()],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_vm._v(" "),(row.err_qty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_vm._v(" "),(row.err_price!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.salepricemd1),expression:"row.salepricemd1"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.salepricemd1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "salepricemd1", $event.target.value)}}}),_vm._v(" "),(row.err_saleprice!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_saleprice))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"Sales Tax %"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax!='' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst!='' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled","autocomplete":"off"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[(row.is_adjustment)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-bell bell",staticStyle:{"color":"red"},attrs:{"title":"Sale Adjustment"},on:{"click":function($event){_vm.onSelectAdjustment(index,row)}}}):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(index);}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("Add New Row\n                       "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Total Items Discount:\n                       "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Additional Discount :\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":"","autocomplete":"off"},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Total Amount Before Tax:\n                        "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),(_vm.is_cs_gst && _vm.companyTaxType !== 'US')?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]):_vm._e(),_vm._v(" "),(_vm.is_i_gst && _vm.companyTaxType !== 'US')?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Sales Tax:\n                       "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"2"}},[_vm._v("Payment Type:")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"2"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("Total Tax Amount :\n                     "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"4"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                      Payment Mode:\n                      "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("Total Amount To Pay: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}})])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Amount Paid: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}}),_c('br')])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Amount Paid: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance();},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Balance: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Cheque No.: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.chequeno_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequeno_validate))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("Cheque Date.: "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_c('br'),_vm._v(" "),(_vm.chequedate_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequedate_validate))]):_vm._e()],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Batch")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchmd),expression:"batchmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"cmp_phone","placeholder":"Enter Batch"},domProps:{"value":(_vm.batchmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.batchmd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Serial Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serialmd),expression:"serialmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Serial Number"},domProps:{"value":(_vm.serialmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serialmd=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","name":"cmp_phone","autocomplete":"off","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","no-close-on-esc":"","no-close-on-backdrop":"","size":"sm","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false},"hide":function($event){}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"size":"lg","title":"Sale Adjustment","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":_vm.Adjustment},model:{value:(_vm.Adjustment),callback:function ($$v) {_vm.Adjustment=$$v},expression:"Adjustment"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message1!='')?_c('div',{staticClass:"col-sm-12 alert alert-danger",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message1))]):_vm._e()])]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columnsadj,"rows":_vm.rowsadj,"select-options":{ enabled: true },"search-options":{ enabled: true },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-select-all":_vm.selectAll,"on-row-click":_vm.toggleSelectRow}}),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":_vm.disabled == 1 ? true : false,"type":"submit"},on:{"click":function($event){_vm.save_adjustment()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n            You have reached the limit of adding Supplier. Please upgrade your plan to add more Suppliers.\n          ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.shopplan_modal),callback:function ($$v) {_vm.shopplan_modal=$$v},expression:"shopplan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n            You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.\n          ")])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Add Purchase")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("ITEM DETAILS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editpurchase_vue__ = __webpack_require__(378);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68598cfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editpurchase_vue__ = __webpack_require__(743);
function injectStyle (ssrContext) {
  __webpack_require__(742)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editpurchase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68598cfa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editpurchase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message != '')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v("\n              "+_vm._s(_vm.haserror.message)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectsupname),expression:"selectsupname"}],staticClass:"form-control",attrs:{"type":"text","id":"sup_name","name":"txtSupName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectsupname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectsupname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectshopname),expression:"selectshopname"}],staticClass:"form-control",attrs:{"type":"text","id":"shop_name","name":"txtShopName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectshopname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectshopname=$event.target.value}}}),_vm._v(" "),_vm._v("\n\n                    \n                  ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Scan Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","name":"barcode","autocomplete":"off","placeholder":"Enter Product Barcode Number"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n                "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',{},[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Purchase Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"7%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"white-space":"nowrap","-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name","id":"productlist"},on:{"input":function($event){_vm.openvariant($event, index)},"searchchange":function($event){_vm.searchprd3($event, index, row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.productExist != '')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v("\n                      "+_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.showvariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row, index)}}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v("\n                        "+_vm._s(row.variantrow))])]):_vm._e(),_vm._v(" "),(row.novariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row, index)}}},[_vm._v("Variant  \n                      "),_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v("\n                        "+_vm._s(row.variantrow))])]):_vm._e()],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_vm._v(" "),(row.err_qty != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_vm._v(" "),(row.err_price != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax != '' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst != '' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled","autocomplete":"off"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[(row.is_adjustment)?_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-bell bell",staticStyle:{"color":"red"},attrs:{"title":"Sale Adjustment"},on:{"click":function($event){_vm.onSelectAdjustment(index, row)}}}):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#f44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(index)}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("\n                      Add New Row\n                      "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Total Items Discount:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Additional Discount :\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":"","autocomplete":"off"},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Total Amount Before Tax:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Sales Tax:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v("Payment:")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("\n                    Total Tax Amount:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                      Payment Mode:\n                      "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("\n                    Total Amount To Pay:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}})])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"10"}},[_vm._v("\n                    Amount Paid:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.total_amt_to_pay}}),_c('br')])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Amount Paid:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance()},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Previously Paid Amount:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtpreviouspaid),expression:"totalamtpreviouspaid"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.totalamtpreviouspaid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalamtpreviouspaid=$event.target.value}}}),_c('br')])]),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Balance:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Cheque No.:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.chequeno_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequeno_validate))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Cheque Date.:\n                    "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_c('br'),_vm._v(" "),(_vm.chequedate_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequedate_validate))]):_vm._e()],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Batch")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchmd),expression:"batchmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"cmp_phone","placeholder":"Enter Batch"},domProps:{"value":(_vm.batchmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.batchmd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Serial Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serialmd),expression:"serialmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Serial Number"},domProps:{"value":(_vm.serialmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serialmd=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","name":"cmp_phone","autocomplete":"off","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salepricemd),expression:"salepricemd"}],staticClass:"form-control",attrs:{"type":"text","name":"sale_price","autocomplete":"off","placeholder":"Enter Sales Price"},domProps:{"value":(_vm.salepricemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.salepricemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.saleprice))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n                ")])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Shop","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.smallmodal1 = false}},model:{value:(_vm.smallmodal1),callback:function ($$v) {_vm.smallmodal1=$$v},expression:"smallmodal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Search Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-warning pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.updateshop()}}},[_vm._v("\n                      Update Shop\n                    ")])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","no-close-on-esc":"","no-close-on-backdrop":"","size":"sm","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false},"hide":function($event){}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n          ")])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"size":"lg","title":"Edit Purchase","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":_vm.Adjustment},model:{value:(_vm.Adjustment),callback:function ($$v) {_vm.Adjustment=$$v},expression:"Adjustment"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message1 != '')?_c('div',{staticClass:"col-sm-12 alert alert-danger",staticStyle:{"text-align":"center"}},[_vm._v("\n          "+_vm._s(_vm.haserror.message1)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columnsadj,"rows":_vm.rowsadj,"select-options":{ enabled: true },"search-options":{ enabled: true },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-select-all":_vm.selectAll,"on-row-click":_vm.toggleSelectRow}}),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":_vm.disabled == 1 ? true : false,"type":"submit"},on:{"click":function($event){_vm.save_adjustment()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n      ")])])],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Edit Purchase")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("ITEM DETAILS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listpurches_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6207cbf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listpurches_vue__ = __webpack_require__(745);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listpurches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6207cbf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listpurches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[(_vm.is_admin === true)?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("From Date")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.fromdate),callback:function ($$v) {_vm.fromdate=$$v},expression:"fromdate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("To Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.todate),callback:function ($$v) {_vm.todate=$$v},expression:"todate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase Id")]),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Purchase  Id"},model:{value:(_vm.productunit),callback:function ($$v) {_vm.productunit=$$v},expression:"productunit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[(_vm.pur_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.searchpurchase}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                ")]):_vm._e()])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" List Purchase\n                "),(_vm.pur_rights === true)?_c('a',{attrs:{"href":"#/Purchase/AddPurches"}},[_vm._m(1)]):_vm._e()]),_vm._v(" "),_vm._v("\n                          \n                \n              "),_c('div',{staticClass:"col-sm-1"},[(_vm.pur_view === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"id":"MyDownload","type":"button"},on:{"click":_vm.exportData}},[_c('i',{}),_vm._v(" Export Data\n                ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"mode":"remote","totalRows":_vm.totalRecords,"columns":_vm.columns,"rows":_vm.rows,"pagination-options":{
              enabled: true,
              perPage: 5,
            },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.editpro(props.row)}}}),_vm._v(" "),(_vm.pur_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"#f44336","font-size":"20px","cursor":"pointer"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removePurchase(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},attrs:{"title":"Edit Purchase"},on:{"click":function($event){_vm.editPurchase(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important","font-size":"20px"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"grey !important","font-size":"20px"}})])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n                "+_vm._s((
                    parseFloat(props.row.cgst_amt) +
                    parseFloat(props.row.sgst_amt) +
                    parseFloat(props.row.igst_amt)
                  ).toFixed(2))+"\n              ")]):(props.column.field == 'lastupdated_datetime')?_c('span',[_vm._v("\n                "+_vm._s(_vm.newDate(props.row.lastupdated_datetime))+"\n              ")]):(props.column.field == 'return')?_c('span',[(_vm.pur_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-reply",staticStyle:{"color":"#63c2de","font-size":"18px","cursor":"pointer"},on:{"click":function($event){_vm.editpro2(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-reply",staticStyle:{"color":"grey !important","font-size":"18px"}})])]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Purchase Item detail ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'tax_inclusive')?_c('span',[(props.row.tax_inclusive == true)?_c('div',[_vm._v("Inclusive")]):_c('div',[_vm._v("Exclusive")])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n            "+_vm._s((
                parseFloat(props.row.cgst_amt) +
                parseFloat(props.row.sgst_amt) +
                parseFloat(props.row.igst_amt)
              ).toFixed(2))+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Select Purchase Items To Return ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal1 = true}},model:{value:(_vm.warningModal1),callback:function ($$v) {_vm.warningModal1=$$v},expression:"warningModal1"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table2",attrs:{"columns":_vm.columns2,"rows":_vm.rows2,"select-options":{
          enabled: true,
        },"mode":"remote","totalRows":_vm.totalRecords2,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange2,"on-sort-change":_vm.onSortChange2,"on-column-filter":_vm.onColumnFilter2,"on-per-page-change":_vm.onPerPageChange2},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'tax_inclusive')?_c('span',[(props.row.tax_inclusive == true)?_c('div',[_vm._v("Inclusive")]):_c('div',[_vm._v("Exclusive")])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n            "+_vm._s((
                parseFloat(props.row.cgst_amt) +
                parseFloat(props.row.sgst_amt) +
                parseFloat(props.row.igst_amt)
              ).toFixed(2))+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1),_vm._v(" "),(_vm.pur_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":_vm.returnitems}},[_vm._v("\n      Proceed\n    ")]):_vm._e()],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Purchase")]),_vm._v(" "),_c('small')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Purchase\n                  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Listpurchesreturn_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d90facb2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Listpurchesreturn_vue__ = __webpack_require__(747);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Listpurchesreturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d90facb2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Listpurchesreturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[(_vm.is_admin === true)?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("To Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.todate),callback:function ($$v) {_vm.todate=$$v},expression:"todate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("From Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.fromdate),callback:function ($$v) {_vm.fromdate=$$v},expression:"fromdate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase Return Id")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Purchase Return Id"},model:{value:(_vm.productunit),callback:function ($$v) {_vm.productunit=$$v},expression:"productunit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[(_vm.purrt_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.searchpurchase}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                ")]):_vm._e()])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("List Purchase Return\n            "),_c('span',[_vm._v("  \n              "),(_vm.purrt_rights === true)?_c('a',{attrs:{"href":"#/Purchase/Addpurchesreturn"}},[_vm._m(1)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{
              enabled: true,
              perPage: 5,
            },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.editpro(props.row)}}}),_vm._v(" "),(_vm.purrt_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"#f44336","font-size":"20px","cursor":"pointer"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removePurchaseReturn(props.row)}}}),_vm._v(" "),_c('router-link',{attrs:{"to":{
                      name: 'Edit Purchase Return',
                      params: {
                        purchaseReturnId: props.row.purchase_return_id,
                        shopId: props.row.est_shop_id,
                      },
                    }}},[_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},attrs:{"title":"Edit Purchase Return"}})])],1):_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"grey !important","font-size":"20px"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"grey !important","font-size":"20px"}})])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n                "+_vm._s((
                    parseFloat(props.row.cgst_amt) +
                    parseFloat(props.row.sgst_amt) +
                    parseFloat(props.row.igst_amt)
                  ).toFixed(2))+"\n              ")]):(props.column.field == 'lastupdated_datetime')?_c('span',[_vm._v("\n                "+_vm._s(_vm.newDate(props.row.lastupdated_datetime))+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Purchase Return Item detail ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{
          enabled: true,
          perPage: 5,
        },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'tax_inclusive')?_c('span',[(props.row.tax_inclusive == true)?_c('div',[_vm._v("Inclusive")]):_c('div',[_vm._v("Exclusive")])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n            "+_vm._s((
                parseFloat(props.row.cgst_amt) +
                parseFloat(props.row.sgst_amt) +
                parseFloat(props.row.igst_amt)
              ).toFixed(2))+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Purchase Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-primary label_bttn",staticStyle:{"width":"15%"},attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Purchase Return\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Addpurchesreturn_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f952f972_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Addpurchesreturn_vue__ = __webpack_require__(750);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Addpurchesreturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f952f972_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Addpurchesreturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name :")]),_vm._v(" "),(_vm.dd_show === true)?_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px","white-space":"nowrap"},attrs:{"list":_vm.customername,"option-value":"sup_cmp_name","custom-text":_vm.nameAndnumber,"placeholder":"Search Supplier Name"},on:{"input":function($event){_vm.onSelectSup($event)},"searchchange":_vm.searchcustomer},model:{value:(_vm.selectedcustomer),callback:function ($$v) {_vm.selectedcustomer=$$v},expression:"selectedcustomer"}}),_vm._v("  \n                  ")],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectsupname),expression:"selectsupname"}],staticClass:"form-control",attrs:{"type":"text","id":"sup_name","name":"txtSupName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectsupname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectsupname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name")]),_vm._v(" "),(_vm.dd_show === true)?_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},on:{"input":function($event){_vm.onSelectShp()}},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}}),_vm._v("  \n                  ")],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectshopname),expression:"selectshopname"}],staticClass:"form-control",attrs:{"type":"text","id":"shop_name","name":"txtShopName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectshopname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectshopname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[(_vm.dd_show === true)?_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Scan Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","name":"barcode","autocomplete":"off","placeholder":"Enter Product Barcode Number"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n                  "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])]):_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase Id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.purchase_id),expression:"purchase_id"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"txtpurchase_id","placeholder":"Purchase ID","disabled":true},domProps:{"value":(_vm.purchase_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.purchase_id=$event.target.value}}})])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',{},[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Purchase Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"qty1","id":"qty1","value":""}}),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[(_vm.dd_show === true)?_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant($event,index)},"searchchange":function($event){_vm.searchprd3($event,index,row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.show==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.show1==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v("Variant : "+_vm._s(row.variantrow))]):_vm._e()],1):_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.show==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.show1==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(" Variant : "+_vm._s(row.variantrow))]):_vm._e()],1)]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_qty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty)),_c('br')]):_vm._e(),_vm._v(" "),(row.avaqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"Available Qty in Stock"}},[_vm._v("Qty : "+_vm._s(row.avaqty))]):_vm._e(),_vm._v(" "),(row.maxqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"max quantity"}},[_vm._v("Max Qty : "+_vm._s(row.maxqty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_price!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price)),_c('br')]):_vm._e(),_vm._v(" "),(row.priceqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"Price"}},[_vm._v("Price : "+_vm._s(row.priceqty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax!='' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst!='' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled","autocomplete":"off"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(index);}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',[(_vm.dd_show === true)?_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("Add New Row: "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Items Discount:\n                "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Additional Discount:\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":""},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Amount Before Tax:\n                  "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v("Payment: ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("Total Tax Amount: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                      Payment Mode:\n                      "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("Total Amount To Pay: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}})])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtreceived),expression:"totalamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalamtreceived)},on:{"change":function($event){_vm.calchnge();},"input":function($event){if($event.target.composing){ return; }_vm.totalamtreceived=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.fullpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Change: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chng),expression:"chng"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.chng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chng=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance();},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_vm._v(" "),_c('br'),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Balance: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque No.: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.chequeno_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequeno_validate))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque Date.: "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.chequedate_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequedate_validate))]):_vm._e()],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Batch")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchmd),expression:"batchmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"cmp_phone","placeholder":"Enter Batch"},domProps:{"value":(_vm.batchmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.batchmd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Serial Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serialmd),expression:"serialmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_email","name":"cmp_email","autocomplete":"off","placeholder":"Enter Serial Number"},domProps:{"value":(_vm.serialmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serialmd=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","name":"cmp_phone","autocomplete":"off","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_disc","name":"cmp_disc","autocomplete":"off","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.variantvalue,"option-value":"variant_id","option-text":"variant_id","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n          ")])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Purchase Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("ITEM DETAILS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editpurchasereturn_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6428d2fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editpurchasereturn_vue__ = __webpack_require__(753);
function injectStyle (ssrContext) {
  __webpack_require__(752)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editpurchasereturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6428d2fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editpurchasereturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name :")]),_vm._v(" "),(_vm.dd_show === true)?_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px","white-space":"nowrap"},attrs:{"list":_vm.suppliername,"option-value":"sup_cmp_name","custom-text":_vm.nameAndnumber,"placeholder":"Search Supplier Name"},on:{"input":function($event){_vm.onSelectSup($event)},"searchchange":_vm.searchsupplier},model:{value:(_vm.selectedsupplier),callback:function ($$v) {_vm.selectedsupplier=$$v},expression:"selectedsupplier"}}),_vm._v("\n                    \n                  ")],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectsupname),expression:"selectsupname"}],staticClass:"form-control",attrs:{"type":"text","id":"cust_name","name":"txtSupName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectsupname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectsupname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectshopname),expression:"selectshopname"}],staticClass:"form-control",attrs:{"type":"text","id":"shop_name","name":"txtShopName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectshopname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectshopname=$event.target.value}}}),_vm._v(" "),_vm._v("\n                    \n                  ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[(_vm.dd_show === true)?_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Scan Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","name":"barcode","autocomplete":"off","placeholder":"Enter Product Barcode Number"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n                  "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])]):_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase Id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.purchase_entry_id),expression:"purchase_entry_id"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"txtpurchase_id","placeholder":"Purchase ID","disabled":true},domProps:{"value":(_vm.purchase_entry_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.purchase_entry_id=$event.target.value}}})])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',{},[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Return Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Purchase Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"qty1","id":"qty1","value":""}}),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[(_vm.dd_show === true)?_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant($event,index)},"searchchange":function($event){_vm.searchprd3($event,index,row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.show==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.show1==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(" Variant : "+_vm._s(row.variantrow))]):_vm._e()],1):_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(" "+_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.show==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.show1==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(" Variant : "+_vm._s(row.variantrow))]):_vm._e()],1)]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_qty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty)),_c('br')]):_vm._e(),_vm._v(" "),(row.avaqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"Available Qty in Stock"}},[_vm._v("Qty : "+_vm._s(row.avaqty))]):_vm._e(),_vm._v(" "),(row.maxqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"max quantity"}},[_vm._v("Max Qty : "+_vm._s(row.maxqty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_price!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price)),_c('br')]):_vm._e(),_vm._v(" "),(row.priceqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"Price"}},[_vm._v("Price : "+_vm._s(row.priceqty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax!='' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst!='' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled","autocomplete":"off"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(index);}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',[(_vm.dd_show === true)?_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("Add New Row: "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Items Discount:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Additional Discount:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":""},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Amount Before Tax:\n                      "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v("Payment: ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("Total Tax Amount: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                          Payment Mode:\n                          "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("Total Amount To Pay: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}})])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtreceived),expression:"totalamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalamtreceived)},on:{"change":function($event){_vm.calchnge();},"input":function($event){if($event.target.composing){ return; }_vm.totalamtreceived=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Change: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chng),expression:"chng"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.chng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chng=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance();},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Previously Paid Amount:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtpreviouspaid),expression:"totalamtpreviouspaid"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.totalamtpreviouspaid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalamtpreviouspaid=$event.target.value}}}),_c('br')])]),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Balance: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque No.: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),(_vm.chequeno_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequeno_validate))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque Date.: "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.chequedate_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequedate_validate))]):_vm._e()],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Batch")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchmd),expression:"batchmd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"cmp_phone","placeholder":"Enter Batch"},domProps:{"value":(_vm.batchmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.batchmd=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Serial Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.serialmd),expression:"serialmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_email","name":"cmp_email","autocomplete":"off","placeholder":"Enter Serial Number"},domProps:{"value":(_vm.serialmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.serialmd=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","name":"cmp_phone","autocomplete":"off","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_disc","name":"cmp_disc","autocomplete":"off","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Shop","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.smallmodal1 = false}},model:{value:(_vm.smallmodal1),callback:function ($$v) {_vm.smallmodal1=$$v},expression:"smallmodal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Search Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-warning pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.updateshop()}}},[_vm._v(" Update Shop")])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.variantvalue,"option-value":"variant_id","option-text":"variant_id","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n              ")])])])])]),_vm._v(" "),_c('Spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Purchase Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("ITEM DETAILS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Supplier_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e738b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Supplier_vue__ = __webpack_require__(756);
function injectStyle (ssrContext) {
  __webpack_require__(755)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Supplier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e738b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Supplier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.errorMessage.message != '')?_c('div',{staticClass:"alert alert-success alert-dismissible"},[_c('a',{staticClass:"close",attrs:{"data-dismiss":"alert","aria-label":"close"}},[_vm._v("×")]),_vm._v(" "),_c('strong',[_vm._v("Success!")]),_vm._v(_vm._s(_vm.errorMessage.message)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Search Supplier List\n      ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.supname),expression:"search.supname"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Supplier Name"},domProps:{"value":(_vm.search.supname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "supname", $event.target.value)}}})])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.srch_cmptyp,"option-value":"id","option-text":"desc","placeholder":"Company Type"},model:{value:(_vm.search.cmptyp),callback:function ($$v) {_vm.$set(_vm.search, "cmptyp", $$v)},expression:"search.cmptyp"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.email),expression:"search.email"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Your Email Address"},domProps:{"value":(_vm.search.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "email", $event.target.value)}}})])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}}),_vm._v(" "),(_vm.sup_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getSupplier()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")]):_vm._e()])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Supplier List"),_c('span',[_vm._v("  \n          "),(_vm.sup_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.addsupplier()}}},[_vm._v("Add Supplier")]):_vm._e()])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{enabled: true ,perPage:5},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){$event.preventDefault();_vm.viewsupplier(props.row)}}}),_vm._v(" "),(_vm.sup_rights === true)?_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editsupplier(props.row)}}}):_vm._e(),_vm._v(" "),(_vm.sup_rights === true)?_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletesupplier(props.row)}}}):_vm._e()]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])}),_vm._v(" "),_c('b-modal',{attrs:{"title":"View supplier","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal1 = false}},model:{value:(_vm.largeModal1),callback:function ($$v) {_vm.largeModal1=$$v},expression:"largeModal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p'),_c('h6',[_vm._v("Supplier Name:")]),_vm._v(_vm._s(_vm.display.name)),_c('p'),_vm._v(" "),_c('p'),_c('h6',[_vm._v("Company Type:")]),_vm._v(_vm._s(_vm.display.cmptyp)),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p'),_c('h6',[_vm._v("Company email:")]),_vm._v(_vm._s(_vm.display.email)),_c('p'),_vm._v(" "),_c('p'),_c('h6',[_vm._v("Address:")]),_vm._v(_vm._s(_vm.display.add1)),_c('p')])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",staticStyle:{"width":"140%","margin":"auto"},attrs:{"title":"Add Supplier","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Supplier Detail")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supnm},attrs:{"type":"text","id":"name","autocomplete":"off","placeholder":"Enter Supplier Name"},model:{value:(_vm.supplier.name),callback:function ($$v) {_vm.$set(_vm.supplier, "name", $$v)},expression:"supplier.name"}}),_vm._v(" "),(_vm.hasErrors.supnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Supplier Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.contyp,"option-value":"desc","option-text":"desc","placeholder":"Select Company Type"},model:{value:(_vm.suptype),callback:function ($$v) {_vm.suptype=$$v},expression:"suptype"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 1 ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supad1},attrs:{"type":"text","id":"add1","autocomplete":"off","placeholder":"Enter supplier Address 1"},model:{value:(_vm.supplier.add),callback:function ($$v) {_vm.$set(_vm.supplier, "add", $$v)},expression:"supplier.add"}}),_vm._v(" "),(_vm.hasErrors.supad1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 2 ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supad2},attrs:{"type":"text","id":"add2","autocomplete":"off","placeholder":"Enter supplier Address 2"},model:{value:(_vm.supplier.add2),callback:function ($$v) {_vm.$set(_vm.supplier, "add2", $$v)},expression:"supplier.add2"}}),_vm._v(" "),(_vm.hasErrors.supad2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address ")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.suppin},attrs:{"type":"text","id":"pin","autocomplete":"off","placeholder":"Pincode"},model:{value:(_vm.supplier.pin),callback:function ($$v) {_vm.$set(_vm.supplier, "pin", $$v)},expression:"supplier.pin"}}),_vm._v(" "),(_vm.hasErrors.suppin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Pincode ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Country ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country"},on:{"input":_vm.state1},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("State ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.city1},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select City"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Corporate Identity Number")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.cin),expression:"supplier.cin"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.supcin},attrs:{"type":"text","id":"cin","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Company Identity Number","aria-label":"Enter Corporate Identity Number","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.cin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "cin", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.supcin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid CIN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CIN Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image1},attrs:{"type":"file","name":"image1","id":"image1","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image1))])]):_vm._e(),_vm._v(" "),(_vm.ed.image1!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST/VAT Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.gst),expression:"supplier.gst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.supgst},attrs:{"type":"text","id":"gst","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.gst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "gst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.supgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image2},attrs:{"type":"file","name":"image2","id":"image2","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image2))])]):_vm._e(),_vm._v(" "),(_vm.ed.image2!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image2_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Number")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.pan),expression:"supplier.pan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.suppan},attrs:{"type":"text","id":"pan","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company PAN Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.pan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "pan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.suppan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid PAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Certificate")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image3},attrs:{"type":"file","name":"image3","id":"image3","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image3))])]):_vm._e(),_vm._v(" "),(_vm.ed.image3!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image3_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.tan),expression:"supplier.tan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.suptan},attrs:{"type":"text","id":"tan","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Company Tan Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.tan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "tan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.suptan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid TAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Certificate")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image4},attrs:{"type":"file","name":"image4","id":"image4","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image4)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image4))])]):_vm._e(),_vm._v(" "),(_vm.ed.image4!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image4_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact No. "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supph},attrs:{"type":"text","id":"phone","autocomplete":"off","placeholder":"Enter Your Contact Number"},model:{value:(_vm.supplier.phone),callback:function ($$v) {_vm.$set(_vm.supplier, "phone", $$v)},expression:"supplier.phone"}}),_vm._v(" "),(_vm.hasErrors.supph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supeml},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Your E-Mail Id"},model:{value:(_vm.supplier.email),callback:function ($$v) {_vm.$set(_vm.supplier, "email", $$v)},expression:"supplier.email"}}),_vm._v(" "),(_vm.hasErrors.supeml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil  Id")])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Logo ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image5},attrs:{"type":"file","name":"image5","id":"image5","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image5)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image5))])]):_vm._e(),_vm._v(" "),(_vm.ed.image5!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image5_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Contact Person Detail")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Person Name ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supcont},attrs:{"type":"text","id":"contact","autocomplete":"off","placeholder":"Enter Contact Person Name"},model:{value:(_vm.supplier.contact),callback:function ($$v) {_vm.$set(_vm.supplier, "contact", $$v)},expression:"supplier.contact"}}),_vm._v(" "),(_vm.hasErrors.supcont)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid  Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supcontno},attrs:{"type":"text","id":"contactno","autocomplete":"off","placeholder":" Enter Contact Phone Number"},model:{value:(_vm.supplier.contactno),callback:function ($$v) {_vm.$set(_vm.supplier, "contactno", $$v)},expression:"supplier.contactno"}}),_vm._v(" "),(_vm.hasErrors.supcontno)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Email ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supconteml},attrs:{"type":"text","id":"contactemail","autocomplete":"off","placeholder":"Enter Contact Person E-mail Id"},model:{value:(_vm.supplier.contactemail),callback:function ($$v) {_vm.$set(_vm.supplier, "contactemail", $$v)},expression:"supplier.contactemail"}}),_vm._v(" "),(_vm.hasErrors.supconteml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil Id ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Company Profile ")]),_vm._v(" "),(_vm.hasErrors.supplierprf)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Profile cannot be greater than 255 Character")])]):_vm._e(),_vm._v(" "),_c('vue-editor',{attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.supplier.profile),callback:function ($$v) {_vm.$set(_vm.supplier, "profile", $$v)},expression:"supplier.profile"}})],1)],1)],1),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Bank Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankname),expression:"supplier.bankname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankname},attrs:{"type":"text","id":"bankname","autocomplete":"off","placeholder":"Enter your Bank Name"},domProps:{"value":(_vm.supplier.bankname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.banknumber),expression:"supplier.banknumber"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.banknumber},attrs:{"type":"text","id":"banknumber","name":"banknumber","autocomplete":"off","placeholder":"Enter your Bank Account Number"},domProps:{"value":(_vm.supplier.banknumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "banknumber", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.banknumber)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Account Number")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Holder Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankholder),expression:"supplier.bankholder"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankholder},attrs:{"type":"text","id":"bankholder","name":"bankholder","autocomplete":"off","placeholder":"Enter Account Holder Name"},domProps:{"value":(_vm.supplier.bankholder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankholder", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankholder)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Account Holder Name")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IFSC Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankifsc),expression:"supplier.bankifsc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankifsc},attrs:{"type":"text","id":"bankifsc","name":"bankifsc","autocomplete":"off","placeholder":"Enter Bank IFSC Code"},domProps:{"value":(_vm.supplier.bankifsc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankifsc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankifsc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid IFSC Code")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Branch ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankbranch),expression:"supplier.bankbranch"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankbranch},attrs:{"type":"text","id":"bankbranch","name":"bankbranch","placeholder":"Enter Branch Name"},domProps:{"value":(_vm.supplier.bankbranch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankbranch", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankbranch)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Branch")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("MICR Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankmicr),expression:"supplier.bankmicr"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankmicr},attrs:{"type":"text","id":"bankmicr","name":"bankmicr","autocomplete":"off","placeholder":"Enter MICR code"},domProps:{"value":(_vm.supplier.bankmicr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankmicr", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankmicr)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid MICR Code")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Swift Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankswift),expression:"supplier.bankswift"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankswift},attrs:{"type":"text","id":"bankswift","name":"bankswift","autocomplete":"off","placeholder":"Enter Bank Swift Code"},domProps:{"value":(_vm.supplier.bankswift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankswift", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankswift)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Swift Code")])]):_vm._e()])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.saveBtn)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]):_vm._e(),_vm._v(" "),(_vm.editBtn)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Update()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]):_vm._e()])],1)],1)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                You have reached the limit of adding Supplier. Please upgrade your plan to add more Suppliers.\n              ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Purchasepayment_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45568b83_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Purchasepayment_vue__ = __webpack_require__(759);
function injectStyle (ssrContext) {
  __webpack_require__(758)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Purchasepayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45568b83_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Purchasepayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ui-view"}},[_c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Supplier "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.supplier_name,"option-value":"supplier_id","option-text":"sup_cmp_name","placeholder":"Search Supplier"},on:{"input":function($event){_vm.SupSelected()},"searchchange":_vm.searchsupplier},model:{value:(_vm.selectsupplier),callback:function ($$v) {_vm.selectsupplier=$$v},expression:"selectsupplier"}}),_vm._v(" "),(_vm.haserror.supplier!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.supplier))])]):_vm._e()],1)])])],1)]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"rgb(232, 235, 238)","padding-left":"18px","padding-top":"10px","padding-bottom":"25px"}},[_vm._m(1),_vm._v(" "),_vm._l((_vm.rows1),function(row,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('label',{attrs:{"for":"Purches"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.purchase_id),expression:"row.purchase_id"}],staticClass:"form-control",attrs:{"type":"text","name":"purchase_id","autocomplete":"off","placeholder":"Enter Purchase Id"},domProps:{"value":(row.purchase_id)},on:{"change":function($event){_vm.purchase(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "purchase_id", $event.target.value)}}}),_vm._v(" "),(row.err_purchase_id!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(row.err_purchase_id))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"padding-left":"0px","padding-top":"20px"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill",attrs:{"type":"button","title":"Search Purches Id"},on:{"click":function($event){_vm.search_purchase_modal(index)}}},[_c('i',{staticClass:"fa fa-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"supplier_id"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.supplier_id),expression:"row.supplier_id"}],staticClass:"form-control",attrs:{"type":"text","name":"supplier_id","autocomplete":"off","readonly":""},domProps:{"value":(row.supplier_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "supplier_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amount_topay),expression:"row.amount_topay"}],staticClass:"form-control",attrs:{"type":"text","name":"amount_topay","autocomplete":"off"},domProps:{"value":(row.amount_topay)},on:{"change":function($event){_vm.calculate(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amount_topay", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('label'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amount_balance),expression:"row.amount_balance"}],staticClass:"form-control",attrs:{"type":"text","name":"amount_balance","autocomplete":"off","readonly":""},domProps:{"value":(row.amount_balance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amount_balance", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"padding-top":"20px"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill",attrs:{"type":"button","variant":"addcust","title":"Add New Row"},on:{"click":_vm.addRow1}},[_c('i',{staticClass:"fa fa-plus"})])]),_vm._v(" "),((index != 0))?_c('div',{staticClass:"col-md-2",staticStyle:{"padding-top":"20px","padding-left":"0px"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill",attrs:{"type":"button","variant":"addcust","title":"Delete Row"},on:{"click":function($event){_vm.removeElement(index);}}},[_c('i',{staticClass:"fa fa-trash"})])]):_vm._e()])])])})],2),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Payment Mode")]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.payment_mode_list,"option-value":"pay_value","option-text":"pay_text","placeholder":"Select Payment Mode"},on:{"input":function($event){_vm.onSelect()}},model:{value:(_vm.payment_mode),callback:function ($$v) {_vm.payment_mode=$$v},expression:"payment_mode"}}),_vm._v(" "),(_vm.haserror.payment_mode!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.payment_mode))])]):_vm._e()],1)]),_vm._v(" "),(_vm.is_cheque)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cheque No")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No."},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_vm._v(" "),(_vm.haserror.cheque_no!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cheque_no))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.is_cheque)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cheque Date")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_vm._v(" "),(_vm.haserror.cheque_date!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cheque_date))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Attachment ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.haserror.attachment},attrs:{"type":"file","name":"attachment","autocomplete":"off","id":"attachment"}}),_vm._v(" "),(_vm.haserror.attachment!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.attachment))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Note ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],staticClass:"form-control",attrs:{"type":"textarea"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}}),_vm._v(" "),(_vm.haserror.note!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.note))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Search","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" From Dateee ")]),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"120px"},attrs:{"editable":"","lang":"en"},model:{value:(_vm.from_DT),callback:function ($$v) {_vm.from_DT=$$v},expression:"from_DT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("To Date ")]),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"120px"},attrs:{"editable":"","lang":"en"},model:{value:(_vm.to_DT),callback:function ($$v) {_vm.to_DT=$$v},expression:"to_DT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase Id ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Purchase Id","autocomplete":"off"},model:{value:(_vm.purchase_id1),callback:function ($$v) {_vm.purchase_id1=$$v},expression:"purchase_id1"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('button',{staticClass:"btn btn-pill",staticStyle:{"width":"110px","border-radius":"15px"},attrs:{"type":"button"},on:{"click":_vm.search_purchase}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")])])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("List Purchase")])]),_vm._v(" "),_c('div',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5, },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'paymod')?_c('span',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.add_purchase_payment(props.row)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add")])]):_c('span',[_vm._v("\n              "+_vm._s(props.formattedRow[props.column.field])+"\n            ")])]}}])})],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Purchase Payments")]),_vm._v(" "),_c('a',{staticClass:"float-right",attrs:{"href":"#"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":"Purches"}},[_vm._v("Purchase Id "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"Supplier"}},[_vm._v("Supplier Id")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',[_vm._v("Amount To Pay")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v("Balance")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchasepaymenthistory_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7b74e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchasepaymenthistory_vue__ = __webpack_require__(761);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchasepaymenthistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7b74e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchasepaymenthistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[(_vm.is_admin === true)?_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1)],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v("\n                          \n                            \n                \n              "),_c('div',{staticClass:"col-sm-1"},[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.exportData()}}},[_c('i',{}),_vm._v(" Export Data\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Choose Company")]),_vm._v(" "),_c('small')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-9"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v("List Purchase Payment\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseReturnpayment_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3936d9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseReturnpayment_vue__ = __webpack_require__(763);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseReturnpayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3936d9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseReturnpayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[(_vm.is_admin === true)?_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1)],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Choose Company")]),_vm._v(" "),_c('small')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v("List Purchase Return Payment\n              ")]),_vm._v("\n                          \n                            \n                \n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sales_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145b4b06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sales_vue__ = __webpack_require__(766);
function injectStyle (ssrContext) {
  __webpack_require__(765)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145b4b06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[(_vm.is_admin === true)?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" From Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.todate),callback:function ($$v) {_vm.todate=$$v},expression:"todate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" To Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.fromdate),callback:function ($$v) {_vm.fromdate=$$v},expression:"fromdate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale Id ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Sale Id"},model:{value:(_vm.productunit),callback:function ($$v) {_vm.productunit=$$v},expression:"productunit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[(_vm.sale_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.searchsales}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                ")]):_vm._e()])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" List Sales\n                 "),(_vm.sale_rights === true)?_c('a',{attrs:{"href":"#/sales/addsales"}},[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addsales()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Sales\n                  ")])]):_vm._e()]),_vm._v(" "),_vm._v("\n                          \n                \n              "),_c('div',{staticClass:"col-sm-1"},[(_vm.sale_view === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"id":"MyDownload","type":"button"},on:{"click":_vm.exportData}},[_c('i'),_vm._v(" Export Data\n                ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","row-style-class":_vm.rowStyleClassFn,"totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.viewSale(props.row)}}}),_vm._v(" "),(_vm.sale_rights === true)?_c('span',[(props.row.sale_editable === true)?_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"#f44336","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.removeSales(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.editSales(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"grey !important","font-size":"20px"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"grey !important","font-size":"20px"}})])]):_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"grey !important","font-size":"20px"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"grey !important","font-size":"20px"}})])]):_vm._e(),_vm._v(" "),(props.column.field == 'adjust')?_c('span',[(_vm.sale_rights === true)?_c('span',[(props.row.salesadj === true)?_c('i',{staticClass:"fa fa-random fa-flip-horizontal",staticStyle:{"color":"#63c2de","font-size":"18px","cursor":"pointer"},on:{"click":function($event){_vm.saleadj(props.row)}}}):_vm._e()]):_c('span',[(props.row.salesadj === true)?_c('i',{staticClass:"fa fa-random fa-flip-horizontal",staticStyle:{"color":"grey !important","font-size":"18px"}}):_vm._e()])]):_vm._e(),_vm._v(" "),(props.column.field == 'generate')?_c('span',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_admin !== true),expression:"is_admin !== true"}],staticClass:"btn btn-primary",staticStyle:{"width":"80px","border-radius":"20px"},attrs:{"type":"submit"},on:{"click":function($event){_vm.generate_invoice(props.row)}}},[_vm._v("\n                  Invoice\n                ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'gst_total')?_c('span',[_vm._v("\n                "+_vm._s((
                    parseFloat(props.row.cgst_amt) +
                    parseFloat(props.row.sgst_amt) +
                    parseFloat(props.row.igst_amt)
                  ).toFixed(2))+"\n              ")]):(props.column.field == 'return')?_c('span',[(_vm.sale_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-reply",staticStyle:{"color":"#63c2de","font-size":"18px","cursor":"pointer"},on:{"click":function($event){_vm.viewSale2(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-reply",staticStyle:{"color":"grey !important","font-size":"18px"}})])]):(props.column.field == 'lastupdated_datetime')?_c('span',[_vm._v("\n                "+_vm._s(_vm.newDate(props.row.lastupdated_datetime))+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Sale Item Details ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'tax_inclusive')?_c('span',[(props.row.tax_inclusive == true)?_c('div',[_vm._v("Inclusive")]):_c('div',[_vm._v("Exclusive")])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n            "+_vm._s((
                parseFloat(props.row.cgst_amt) +
                parseFloat(props.row.sgst_amt) +
                parseFloat(props.row.igst_amt)
              ).toFixed(2))+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Select Sale Items To Return","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal1 = true}},model:{value:(_vm.warningModal1),callback:function ($$v) {_vm.warningModal1=$$v},expression:"warningModal1"}},[_c('b-collapse',{attrs:{"id":"collapse2","visible":""}},[_c('vue-good-table',{ref:"my-table2",attrs:{"columns":_vm.columns2,"rows":_vm.rows2,"select-options":{
          enabled: true,
        },"mode":"remote","totalRows":_vm.totalRecords2,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange2,"on-sort-change":_vm.onSortChange2,"on-column-filter":_vm.onColumnFilter2,"on-per-page-change":_vm.onPerPageChange2},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'tax_inclusive')?_c('span',[(props.row.tax_inclusive == true)?_c('div',[_vm._v("Inclusive")]):_c('div',[_vm._v("Exclusive")])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n            "+_vm._s((
                parseFloat(props.row.cgst_amt) +
                parseFloat(props.row.sgst_amt) +
                parseFloat(props.row.igst_amt)
              ).toFixed(2))+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1),_vm._v(" "),(_vm.sale_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":_vm.returnitems}},[_vm._v("\n      Proceed\n    ")]):_vm._e()],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Sale Adjustment","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"saleadj"},on:{"ok":function($event){_vm.saleadjModal = true}},model:{value:(_vm.saleadjModal),callback:function ($$v) {_vm.saleadjModal=$$v},expression:"saleadjModal"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale ID : "+_vm._s(_vm.sales_adj_salesid))]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse2","visible":""}},[_c('vue-good-table',{ref:"my-table_adj",attrs:{"columns":_vm.columns_adj,"rows":_vm.rows_adj,"mode":"remote","totalRows":_vm.totalRecords_adj,"pagination-options":{ enabled: false, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange_adj,"on-sort-change":_vm.onSortChange_adj,"on-column-filter":_vm.onColumnFilter_adj,"on-per-page-change":_vm.onPerPageChange_adj},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[(_vm.sale_rights === true)?_c('span',[(props.row.inv_qty > 0)?_c('i',{staticClass:"fa fa-random fa-flip-horizontal",staticStyle:{"color":"#63c2de","font-size":"18px","cursor":"pointer"},on:{"click":function($event){_vm.adjust(props.row)}}}):_vm._e()]):_c('span',[_c('i',{staticClass:"fa fa-random fa-flip-horizontal",staticStyle:{"color":"grey !important","font-size":"18px"}})])]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n          You have reached the limit of adding Sales. Please upgrade your plan to add more Sales.\n        ")])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Sales")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addsales_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf90024c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addsales_vue__ = __webpack_require__(781);
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addsales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf90024c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addsales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.haserror.message!='')?_c('div',{staticClass:"alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.customername,"option-value":"customer_id","custom-text":_vm.nameAndnumber,"placeholder":"Search Customer Name"},on:{"input":function($event){_vm.onSelectCust($event)},"searchchange":_vm.searchcustomer},model:{value:(_vm.selectedcustomer),callback:function ($$v) {_vm.selectedcustomer=$$v},expression:"selectedcustomer"}}),_vm._v("\n                      \n                    "),_vm._v(" "),(_vm.cust_rights === true)?_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill btn-primary",attrs:{"type":"button","route":"","title":"Add New Customer"},on:{"click":function($event){_vm.addCustomer()}}},[_c('i',{staticClass:"fa fa-user"})]):_vm._e()],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},on:{"input":function($event){_vm.onShpChange($event)}},model:{value:(_vm.select_shop),callback:function ($$v) {_vm.select_shop=$$v},expression:"select_shop"}}),_vm._v("\n                    \n                  "),_vm._v(" "),(_vm.shop_rights === true)?_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill btn-primary",attrs:{"type":"button","title":"Add New Shop"},on:{"click":function($event){_vm.addShop()}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e()],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","name":"barcode","placeholder":"Enter Barcode"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n\n                "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale Entry Date")]),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"0px","min-width":"155px"},attrs:{"input-name":"date","format":"YYYY-MM-DD","editable":"","not-before":_vm.disabledBefore,"not-after":_vm.disabledAfter,"lang":"en"},model:{value:(_vm.saleentry_dt),callback:function ($$v) {_vm.saleentry_dt=$$v},expression:"saleentry_dt"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('h6',{staticClass:"my-3"},[_vm._v("\n                  Ship To:"),_c('small',{staticClass:"printpage"},[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.addressModel =true}}})])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.customer1.name)+"   "+_vm._s(_vm.customer1.phone))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.customer1.gst))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.customer1.add))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.customer1.city)+" "+_vm._s(_vm.customer1.state)+"\n                "+_vm._s(_vm.customer1.pincode)+"\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header title_head"},[_vm._v("\n          ITEM DETAILS\n        ")]),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"1%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Sale Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"qty1","id":"qty1","value":""}}),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[_c('a',{staticStyle:{"font-size":"14px","color":"#20a8d8","cursor":"pointer"},on:{"click":function($event){_vm.addProduct(row,index)}}},[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-plus",attrs:{"title":"Add New Product"}})])]),_vm._v(" "),_c('td',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant_on_product(row,index)},"searchchange":function($event){_vm.searchprd3($event,index,row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.show==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant :"),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("  "+_vm._s(row.variantrow)+" ")]):_vm._e(),_vm._v(" "),(row.show1==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"}},[_vm._v("Variant : "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(_vm._s(row.productExist))]):_vm._e(),_vm._v(" "),(row.show2==true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Select Variant")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"disabled":"disabled","type":"text"},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_qty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty)),_c('br')]):_vm._e(),_vm._v(" "),(row.avaqty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"}},[_vm._v("Available Qty:"+_vm._s(row.avaqty))]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.saleprice_editable === true)?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.saleprice_nonedit === true)?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":""},domProps:{"value":(row.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(row.err_price!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price)),_c('br')]):_vm._e(),_vm._v(" "),(row.priceqty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"}},[_vm._v("Price:"+_vm._s(row.priceqty))]):_vm._e(),_vm._v(" "),_c('br')]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"Sales Tax %"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax!='' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst!='' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(index);}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("Add New Row:\n                   "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Items Discount:\n                  "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Additional Discount: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":""},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Amount Before Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),(_vm.is_cs_gst && _vm.companyTaxType !== 'US')?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]):_vm._e(),_vm._v(" "),(_vm.is_i_gst && _vm.companyTaxType !== 'US')?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"1"}},[_vm._v("Payment: ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"1"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Tax Amount: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"4"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                  Payment Mode:\n                  "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("Total Amount To Pay: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}}),_c('br'),_vm._v(" "),(_vm.err_totamtpay != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.err_totamtpay))]):_vm._e()])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtreceived),expression:"totalamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalamtreceived)},on:{"change":function($event){_vm.calchnge();},"input":function($event){if($event.target.composing){ return; }_vm.totalamtreceived=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Change: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chng),expression:"chng"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.chng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chng=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance();},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Balance: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque No.: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque Date.: "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}})],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","name":"cmp_phone","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_email","name":"cmp_email","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.finalsubmit('')}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]),_vm._v("    \n          "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.finalsubmit('inv')}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save And Generate Invoice")])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Shipping Details","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.addressModel = false}},model:{value:(_vm.addressModel),callback:function ($$v) {_vm.addressModel=$$v},expression:"addressModel"}},_vm._l((_vm.addr),function(address1,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"form-group"},[_c('b',[_vm._v(_vm._s(address1.yname)+" ("+_vm._s(address1.yphn)+")")]),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(address1.ygst))]),_c('br'),_vm._v(" "),(address1.yaddress!='')?_c('span',[_vm._v("\n             "+_vm._s(address1.yaddress)),_c('br')]):_vm._e(),_vm._v(" "),(address1.ystate != '' && address1.ycity != '' && address1.ypincode != '')?_c('span',[_vm._v("\n               "+_vm._s(address1.ystate)+"   "+_vm._s(address1.ycity)+" - "+_vm._s(address1.ypincode)+"\n             ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2",staticStyle:{"color":"#f86c6b","font-size":"20px","cursor":"pointer"}},[_c('span',[_c('small',[_c('i',{staticClass:"fa fa-plus",staticStyle:{"color":"#34a8d8","cursor":"pointer"},on:{"click":function($event){_vm.showAddress(address1)}}},[_vm._v("Add")])])])]),_c('hr',{attrs:{"width":"97%"}})])})),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n              You have reached the limit of adding Customers. Please upgrade your plan to add more Customers.\n            ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.shopplan_modal),callback:function ($$v) {_vm.shopplan_modal=$$v},expression:"shopplan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n              You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.\n            ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.prodplan_modal),callback:function ($$v) {_vm.prodplan_modal=$$v},expression:"prodplan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n              You have reached the limit of adding Product. Please upgrade your plan to add more Products.\n            ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Are You Sure?","size":"sm","ok-variant":"danger","ok-title":"Yes","no-close-on-esc":"","no-close-on-backdrop":""},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel},model:{value:(_vm.shopchange_modal),callback:function ($$v) {_vm.shopchange_modal=$$v},expression:"shopchange_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("Are you Sure, You want to Change the Shop ?")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                  Once you change the shop, all the Items entered by you will be cleared. Do you still want to continue?\n                ")])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Sales")]),_vm._v(" "),_c('small')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editsales_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21255740_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editsales_vue__ = __webpack_require__(783);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editsales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21255740_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editsales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.haserror.message!='')?_c('div',{staticClass:"alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectcustname),expression:"selectcustname"}],staticClass:"form-control",attrs:{"type":"text","id":"cust_name","name":"txtCustName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectcustname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectcustname=$event.target.value}}})])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectshopname),expression:"selectshopname"}],staticClass:"form-control",attrs:{"type":"text","id":"shop_name","name":"txtShopName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectshopname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectshopname=$event.target.value}}})])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","name":"barcode","placeholder":"Enter Barcode"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n                    "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale Entry Date")]),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"0px","min-width":"155px"},attrs:{"input-name":"date","format":"YYYY-MM-DD","editable":"","lang":"en","not-before":_vm.disabledBefore,"not-after":_vm.disabledAfter},model:{value:(_vm.saleentry_dt),callback:function ($$v) {_vm.saleentry_dt=$$v},expression:"saleentry_dt"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('h6',{staticClass:"my-3"},[_vm._v("\n                    Ship To:"),_c('small',{staticClass:"printpage"},[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.addressModel =true}}})])]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.customer1.name)+"   "+_vm._s(_vm.customer1.phone))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.customer1.gst))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.customer1.add))]),_vm._v(" "),_c('div',[_vm._v("\n                    "+_vm._s(_vm.customer1.city)+" "+_vm._s(_vm.customer1.state)+"\n                    "+_vm._s(_vm.customer1.pincode)+"\n                  ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header title_head"},[_vm._v("\n              ITEM DETAILS\n            ")]),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Sale Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"qty1","id":"qty1","value":""}}),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant($event,index)},"searchchange":function($event){_vm.searchprd3($event,index,row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant :"),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(row.variantrow)+" ")])],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"disabled":"disabled","type":"text"},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_qty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty)),_c('br')]):_vm._e(),_vm._v(" "),_c('small',{staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"}},[_vm._v("Available Qty:"+_vm._s(row.avaqty))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_c('br'),_vm._v(" "),(row.err_price!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price)),_c('br')]):_vm._e(),_vm._v(" "),_c('small',{staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"}},[_vm._v("Price:"+_vm._s(row.priceqty))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"Sales Tax %"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax!='' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst!='' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(row,index);}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("Add New Row:\n                     "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Items Discount: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Additional Discount: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":""},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Amount Before Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),(_vm.is_cs_gst)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]):_vm._e(),_vm._v(" "),(_vm.is_i_gst)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v("Payment: ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("Total Tax Amount: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                      Payment Mode:\n                      "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("Total Amount To Pay: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}}),_c('br'),_vm._v(" "),(_vm.err_totamtpay != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.err_totamtpay))]):_vm._e()])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtreceived),expression:"totalamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":_vm.totamtrecdis},domProps:{"value":(_vm.totalamtreceived)},on:{"change":function($event){_vm.calchnge();},"input":function($event){if($event.target.composing){ return; }_vm.totalamtreceived=$event.target.value}}}),_c('br'),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullamt_rec != ''),expression:"fullamt_rec != ''"}],staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.fullamt_rec))])])]):_vm._e(),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Change: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chng),expression:"chng"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.chng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chng=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance();},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Previously Paid Amount: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtpreviouspaid),expression:"totalamtpreviouspaid"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.totalamtpreviouspaid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalamtpreviouspaid=$event.target.value}}}),_c('br')])]),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Balance: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque No.: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.chequeno_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequeno_validate))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque Date.: "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_c('br'),_vm._v(" "),(_vm.chequedate_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequedate_validate))]):_vm._e()],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","name":"cmp_phone","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_email","name":"cmp_email","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("f\n              "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Shop","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.smallmodal1 = false}},model:{value:(_vm.smallmodal1),callback:function ($$v) {_vm.smallmodal1=$$v},expression:"smallmodal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Search Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-warning pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.updateshop()}}},[_vm._v(" Update Shop")])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.finalsubmit('')}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]),_vm._v("    \n            "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.finalsubmit('inv')}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save And Generate Invoice")])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Shipping Details","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.addressModel = false}},model:{value:(_vm.addressModel),callback:function ($$v) {_vm.addressModel=$$v},expression:"addressModel"}},_vm._l((_vm.addr),function(address1,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"form-group"},[_c('b',[_vm._v(_vm._s(address1.yname)+" ("+_vm._s(address1.yphn)+")")]),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(address1.ygst))]),_c('br'),_vm._v(" "),(address1.yaddress!='')?_c('span',[_vm._v("\n              "+_vm._s(address1.yaddress)),_c('br')]):_vm._e(),_vm._v(" "),(address1.ystate != '' && address1.ycity != '' && address1.ypincode != '')?_c('span',[_vm._v("\n              "+_vm._s(address1.ystate)+"   "+_vm._s(address1.ycity)+" - "+_vm._s(address1.ypincode)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2",staticStyle:{"color":"#f86c6b","font-size":"20px","cursor":"pointer"}},[_c('span',[_c('small',[_c('i',{staticClass:"fa fa-plus",staticStyle:{"color":"#34a8d8","cursor":"pointer"},on:{"click":function($event){_vm.showAddress(address1)}}},[_vm._v("Add")])])])]),_vm._v(" "),_c('hr',{attrs:{"width":"97%"}})])})),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Sales")]),_vm._v(" "),_c('small')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc0c0e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__(785);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc0c0e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[(_vm.is_admin === true)?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" To Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.todate),callback:function ($$v) {_vm.todate=$$v},expression:"todate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" From Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.fromdate),callback:function ($$v) {_vm.fromdate=$$v},expression:"fromdate"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale Return Id ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Sale Return Id"},model:{value:(_vm.productunit),callback:function ($$v) {_vm.productunit=$$v},expression:"productunit"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[(_vm.salert_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.searchsalesitem}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                ")]):_vm._e()])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("List Sale Return\n            "),_c('span',[_vm._v("  \n              "),(_vm.salert_rights === true)?_c('a',{attrs:{"href":"#/sales/Salesreturn"}},[_vm._m(1)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{
              enabled: true,
              perPage: 5
            },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){_vm.returnitem(props.row)}}}),_vm._v(" "),(_vm.salert_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336","font-size":"20px","cursor":"pointer"},attrs:{"title":"Remove Sales Return"},on:{"click":function($event){_vm.removeSalesReturn(props.row)}}}),_vm._v(" "),_c('router-link',{attrs:{"to":{
                      name: 'Edit Sales Return',
                      params: {
                        saleReturnId: props.row.sales_return_id,
                        shopId: props.row.est_shop_id,
                        saleId: props.row.sales_id
                      }
                    }}},[_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},attrs:{"title":"Edit Sale Return"}})])],1):_c('span',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"grey !important","font-size":"20px"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-pencil",staticStyle:{"color":"grey !important","font-size":"20px"}})])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n                "+_vm._s((
                    parseFloat(props.row.cgst_amt) +
                    parseFloat(props.row.sgst_amt) +
                    parseFloat(props.row.igst_amt)
                  ).toFixed(2))+"\n              ")]):(props.column.field == 'lastupdated_datetime')?_c('span',[_vm._v("\n                "+_vm._s(_vm.newDate(props.row.lastupdated_datetime))+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Sales Item Return Details ","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{
          enabled: true,
          perPage: 5
        },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'tax_inclusive')?_c('span',[(props.row.tax_inclusive == true)?_c('div',[_vm._v("Inclusive")]):_c('div',[_vm._v("Exclusive")])]):(props.column.field == 'gst_total')?_c('span',[_vm._v("\n            "+_vm._s((
                parseFloat(props.row.cgst_amt) +
                parseFloat(props.row.sgst_amt) +
                parseFloat(props.row.igst_amt)
              ).toFixed(2))+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Sales Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Sales Return\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salesreturn_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_485c359d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salesreturn_vue__ = __webpack_require__(787);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salesreturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_485c359d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salesreturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message != '')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v("\n              "+_vm._s(_vm.haserror.message)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name ")]),_vm._v(" "),(_vm.dd_show === true)?_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px","white-space":"nowrap"},attrs:{"list":_vm.customername,"option-value":"customer_id","custom-text":_vm.nameAndnumber,"placeholder":"Search Customer Name"},on:{"input":function($event){_vm.onSelectSup($event)},"searchchange":_vm.searchcustomer},model:{value:(_vm.selectedcustomer),callback:function ($$v) {_vm.selectedcustomer=$$v},expression:"selectedcustomer"}}),_vm._v("  \n                  ")],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectcustname),expression:"selectcustname"}],staticClass:"form-control",attrs:{"type":"text","id":"cust_name","name":"txtCustName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectcustname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectcustname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name")]),_vm._v(" "),(_vm.dd_show === true)?_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px","white-space":"nowrap"},attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},on:{"input":function($event){_vm.onSelectShp($event)}},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}}),_vm._v("\n                    \n                  ")],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectshopname),expression:"selectshopname"}],staticClass:"form-control",attrs:{"type":"text","id":"shop_name","name":"txtShopName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectshopname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectshopname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[(_vm.dd_show === true)?_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"barcode","placeholder":"Enter Barcode"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n\n                  "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])]):_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales Id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sale_id),expression:"sale_id"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"txtsales_id","placeholder":"Sale ID","disabled":true},domProps:{"value":(_vm.sale_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sale_id=$event.target.value}}})])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',[_c('table',{staticClass:"table table-striped table-responsive"},[_vm._m(2),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"qty1","id":"qty1","value":""}}),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[(_vm.dd_show === true)?_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px","white-space":"nowrap"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant($event, index)},"searchchange":function($event){_vm.searchprd3($event, index, row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.showvariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row, index)}}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.novariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"}},[_vm._v("variant : "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.productExist != '')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(_vm._s(row.productExist))]):_vm._e()],1):_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px","white-space":"nowrap"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.showvariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.novariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v("\n                        No variant : "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.productExist != '')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue"}},[_vm._v(_vm._s(row.productExist))]):_vm._e()],1)]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"disabled":"","type":"text"},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_vm._v(" "),(row.err_qty != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty)),_c('br')]):_vm._e(),_vm._v(" "),(row.maxqty != '')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"max quantity"}},[_vm._v("Max Qty : "+_vm._s(row.maxqty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_vm._v(" "),(row.err_price != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price)),_c('br')]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"","autocomplete":"off"},domProps:{"value":(row.sales_tax)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}),_vm._v(" "),(row.err_salestax != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#f44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(index)}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',[(_vm.dd_show === true)?_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("\n                      Add New Row :\n                      "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Total Items Discount :\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Additional Discount :\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":""},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Total Amount Before Tax :\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Sales Tax:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v("Payment:")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("\n                    Total Tax Amount:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                      Payment Mode:\n                      "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("\n                    Total Amount To Pay:\n                    "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}})])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Amount Received:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtreceived),expression:"totalamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalamtreceived)},on:{"change":function($event){_vm.calchnge()},"input":function($event){if($event.target.composing){ return; }_vm.totalamtreceived=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Change:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chng),expression:"chng"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.chng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chng=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Amount Received:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance()},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Balance:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Cheque No.:\n                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',{},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("\n                    Cheque Date.:\n                    "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}})],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"cmp_phone","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_email","name":"cmp_email","autocomplete":"off","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n                ")])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false},"hide":function($event){}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n          ")])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Add Sales Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("ITEM DETAILS ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Return Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Sale Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editsalesreturn_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d296ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editsalesreturn_vue__ = __webpack_require__(789);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editsalesreturn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d296ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editsalesreturn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name ")]),_vm._v(" "),(_vm.dd_show === true)?_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px","white-space":"nowrap"},attrs:{"list":_vm.customername,"option-value":"customer_id","custom-text":_vm.nameAndnumber,"placeholder":"Search Customer Name"},on:{"input":function($event){_vm.onSelectSup($event)},"searchchange":_vm.searchcustomer},model:{value:(_vm.selectedcustomer),callback:function ($$v) {_vm.selectedcustomer=$$v},expression:"selectedcustomer"}}),_vm._v("  \n                      ")],1):_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectcustname),expression:"selectcustname"}],staticClass:"form-control",attrs:{"type":"text","id":"cust_name","name":"txtCustName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectcustname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectcustname=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cust))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectshopname),expression:"selectshopname"}],staticClass:"form-control",attrs:{"type":"text","id":"shop_name","name":"txtShopName","autocomplete":"off","disabled":true},domProps:{"value":(_vm.selectshopname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectshopname=$event.target.value}}}),_vm._v(" "),_vm._v("\n                     \n                   ")]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.shop))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[(_vm.dd_show === true)?_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Barcode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.barcode),expression:"barcode"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"barcode","placeholder":"Enter Barcode"},domProps:{"value":(_vm.barcode)},on:{"blur":_vm.searchBarcode,"keyup":_vm.checkShop,"input":function($event){if($event.target.composing){ return; }_vm.barcode=$event.target.value}}}),_vm._v("  \n\n                  "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.barcode))])])]):_c('span',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales Id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sale_entry_id),expression:"sale_entry_id"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"txtsales_id","placeholder":"Sale ID","disabled":true},domProps:{"value":(_vm.sale_entry_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sale_entry_id=$event.target.value}}})])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',[_c('table',{staticClass:"table table-striped table-responsive"},[_c('thead',[_c('tr',{staticStyle:{"font-size":"12px","text-align":"center"}},[_c('th',{attrs:{"width":"20%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("Return Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Sale Price/Unit")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("Amt Before Tax")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{attrs:{"width":"6%"}},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"6%"}},[_vm._v("Other")])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"qty1","id":"qty1","value":""}}),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},[_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[(_vm.dd_show === true)?_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px","white-space":"nowrap"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant($event,index)},"searchchange":function($event){_vm.searchprd3($event,index,row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.showvariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"},on:{"click":function($event){_vm.openvariant(row,index)}}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.novariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red","cursor":"pointer"}},[_vm._v("Variant : "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue","cursor":"pointer"}},[_vm._v(_vm._s(row.productExist))]):_vm._e()],1):_c('span',[_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px","white-space":"nowrap"},attrs:{"list":row.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}}),_vm._v(" "),(row.showvariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v("Variant "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.novariant == true)?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(" No variant : "+_vm._s(row.variantrow))]):_vm._e(),_vm._v(" "),(row.productExist !='')?_c('small',{staticStyle:{"font-size":"10px","color":"darkblue"}},[_vm._v(_vm._s(row.productExist))]):_vm._e()],1)]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit),expression:"row.unit"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"disabled":"","type":"text"},domProps:{"value":(row.unit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}}),_vm._v(" "),(row.err_qty!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_qty)),_c('br')]):_vm._e(),_vm._v(" "),(row.maxqty!='')?_c('small',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"font-size":"10px","color":"green","margin-top":"41px"},attrs:{"title":"max quantity"}},[_vm._v("Max Qty : "+_vm._s(row.maxqty))]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.price),expression:"row.price"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.price)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "price", $event.target.value)}}}),_vm._v(" "),(row.err_price!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_price)),_c('br')]):_vm._e()]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amt),expression:"row.amt"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.amt)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amt", $event.target.value)}}})]),_vm._v(" "),_c('td',[(_vm.companyTaxType === 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_tax),expression:"row.sales_tax"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.sales_tax)},on:{"change":function($event){_vm.updateSalesTax(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_tax", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_salestax!='' && _vm.companyTaxType === 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_salestax)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.cgst),expression:"row.cgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"CGST %"},domProps:{"value":(row.cgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "cgst", $event.target.value)}}}):_vm._e(),_vm._v(" "),(row.err_cgst!='' && _vm.companyTaxType !== 'US')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_cgst)),_c('br')]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sgst),expression:"row.sgst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"SGST %"},domProps:{"value":(row.sgst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sgst", $event.target.value)}}}),_vm._v(" "),(row.err_sgst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_sgst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.igst),expression:"row.igst"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","placeholder":"IGST %"},domProps:{"value":(row.igst)},on:{"change":function($event){_vm.price(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "igst", $event.target.value)}}}),_vm._v(" "),(row.err_igst!='')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(row.err_igst)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amttotal),expression:"row.amttotal"}],staticClass:"form-control-sm",staticStyle:{"width":"100%"},attrs:{"type":"text","disabled":"disabled"},domProps:{"value":(row.amttotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amttotal", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('center',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-reorder",staticStyle:{"color":"#20a8d8"},attrs:{"title":"Add More option","variant":"secondary"},on:{"click":function($event){_vm.openmodal(index)}}}),_vm._v(" "),_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},attrs:{"title":"Delete"},on:{"click":function($event){_vm.removeElement(row,index);}}})])],1)])}),_vm._v(" "),_c('tr',[_c('td',[(_vm.dd_show === true)?_c('div',{staticStyle:{"font-size":"13px","color":"green"}},[_vm._v("Add New Row :\n                      "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Items Discount :\n                      "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaldis}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Additional Discount : "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detail.addition),expression:"detail.addition"}],staticClass:"form-control-sm",attrs:{"type":""},domProps:{"value":(_vm.detail.addition)},on:{"change":_vm.discountadd,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.detail, "addition", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Total Amount Before Tax : "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"","disabled":""},domProps:{"value":_vm.totalamt}})])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Sales Tax: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalsalestax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v("Payment: ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-select',{attrs:{"options":_vm.lst_paymenttype},on:{"change":_vm.paychange},model:{value:(_vm.selected_pytype),callback:function ($$v) {_vm.selected_pytype=$$v},expression:"selected_pytype"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"8"}},[_vm._v("Total Tax Amount: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totaltax}})])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_c('b-form-group',{attrs:{"label":""}},[_vm._v("\n                        Payment Mode:\n                        "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cash"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cash")]),_vm._v(" "),_c('b-form-radio',{attrs:{"name":"payment_mode","value":"cheque"},on:{"change":_vm.modechange},model:{value:(_vm.selected_pymode),callback:function ($$v) {_vm.selected_pymode=$$v},expression:"selected_pymode"}},[_vm._v("Cheque")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"7"}},[_vm._v("Total Amount To Pay: "),_c('input',{staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.totalamtpay}})])]),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtreceived),expression:"totalamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalamtreceived)},on:{"change":function($event){_vm.calchnge();},"input":function($event){if($event.target.composing){ return; }_vm.totalamtreceived=$event.target.value}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullamt_rec != ''),expression:"fullamt_rec != ''"}],staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.fullamt_rec))])])]):_vm._e(),_vm._v(" "),(_vm.fullpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Change: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.chng),expression:"chng"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.chng)},on:{"input":function($event){if($event.target.composing){ return; }_vm.chng=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Amount Received: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalparamtreceived),expression:"totalparamtreceived"}],staticClass:"form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.totalparamtreceived)},on:{"change":function($event){_vm.calbalance();},"input":function($event){if($event.target.composing){ return; }_vm.totalparamtreceived=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.amt_rec != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.amt_rec))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Previously Paid Amount: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.totalamtpreviouspaid),expression:"totalamtpreviouspaid"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.totalamtpreviouspaid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.totalamtpreviouspaid=$event.target.value}}}),_c('br')])]),_vm._v(" "),(_vm.parpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Balance: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bal),expression:"bal"}],staticClass:"form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.bal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bal=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque No.: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control-sm",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_c('br'),_vm._v(" "),(_vm.chequeno_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequeno_validate))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.chqpay === true)?_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"},attrs:{"colspan":"9"}},[_vm._v("Cheque Date.: "),_c('date-picker',{staticClass:"form-control-sm",attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.chequedate_validate != '')?_c('small',{staticStyle:{"font-size":"10px","color":"red"}},[_vm._v(_vm._s(_vm.chequedate_validate))]):_vm._e()],1)]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add More Option","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Percentage:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.percentagemd),expression:"percentagemd"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","name":"cmp_phone","placeholder":"Enter Discount Percentage"},domProps:{"value":(_vm.percentagemd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.percentagemd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.dis))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Discount Amount :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.amtmd),expression:"amtmd"}],staticClass:"form-control",attrs:{"type":"text","id":"cmp_email","name":"cmp_email","autocomplete":"off","placeholder":"Enter Discount Amount"},domProps:{"value":(_vm.amtmd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.amtmd=$event.target.value}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.amt))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Inclusive:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inclusive),expression:"inclusive"}],attrs:{"type":"checkbox","name":"cmp_inclusive"},domProps:{"checked":Array.isArray(_vm.inclusive)?_vm._i(_vm.inclusive,null)>-1:(_vm.inclusive)},on:{"change":function($event){var $$a=_vm.inclusive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inclusive=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inclusive=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inclusive=$$c}}}}),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.inclusive))])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){_vm.savemodal(_vm.indexval)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Shop","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.smallmodal1 = false}},model:{value:(_vm.smallmodal1),callback:function ($$v) {_vm.smallmodal1=$$v},expression:"smallmodal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-warning pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.updateshop()}}},[_vm._v(" Update Shop")])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false},"hide":function($event){}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n          ")])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Edit Sales Return")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("ITEM DETAILS\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca3552d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__(792);
function injectStyle (ssrContext) {
  __webpack_require__(791)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca3552d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.errorMessage.message != '')?_c('div',{staticClass:"alert alert-success alert-dismissible"},[_c('a',{staticClass:"close",attrs:{"data-dismiss":"alert","aria-label":"close"}},[_vm._v("×")]),_vm._v(" "),_c('strong',[_vm._v("Success!")]),_vm._v(_vm._s(_vm.errorMessage.message)+"\n        ")]):_vm._e()])]),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Search Customer List\n      ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.custname),expression:"search.custname"}],staticClass:"form-control",attrs:{"type":"text","id":"custname","name":"custname","autocomplete":"off","placeholder":"Enter Customer Name"},domProps:{"value":(_vm.search.custname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "custname", $event.target.value)}}})])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.srch_cmptyp,"option-value":"id","option-text":"desc","placeholder":"Company Type"},model:{value:(_vm.search.cmptyp),callback:function ($$v) {_vm.$set(_vm.search, "cmptyp", $$v)},expression:"search.cmptyp"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.email),expression:"search.email"}],staticClass:"form-control",attrs:{"type":"text","id":"custemail","name":"custemail","autocomplete":"off","placeholder":"Enter Your Email Address"},domProps:{"value":(_vm.search.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "email", $event.target.value)}}})])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}}),_vm._v(" "),(_vm.cust_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getCustomer()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")]):_vm._e()])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n        Customer List"),_c('span',[_vm._v("  \n          "),(_vm.cust_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.addcustomer()}}},[_vm._v("Add Customer")]):_vm._e()])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{enabled: true, perPage: 5,},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){$event.preventDefault();_vm.viewcustomer(props.row)}}}),_vm._v(" "),(_vm.cust_rights === true)?_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editcustomer(props.row)}}}):_vm._e(),_vm._v(" "),(_vm.cust_rights === true)?_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletecustomer(props.row)}}}):_vm._e()]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n            ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"title":"View Customer","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal1 = false}},model:{value:(_vm.largeModal1),callback:function ($$v) {_vm.largeModal1=$$v},expression:"largeModal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p'),_c('h6',[_vm._v("Customer Name:")]),_vm._v(_vm._s(_vm.display.name)),_c('p'),_vm._v(" "),_c('p'),_c('h6',[_vm._v("Company Type:")]),_vm._v(_vm._s(_vm.display.cmptyp)),_c('p')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p'),_c('h6',[_vm._v("Company email:")]),_vm._v(_vm._s(_vm.display.email)),_c('p'),_vm._v(" "),_c('p'),_c('h6',[_vm._v("Address:")]),_vm._v(_vm._s(_vm.display.add1)),_c('p')])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",staticStyle:{"width":"140%","margin":"auto"},attrs:{"title":_vm.tit,"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Customer Detail")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Customer Name :"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custnm},attrs:{"type":"text","id":"name","autocomplete":"off","placeholder":"Enter Customer Name"},model:{value:(_vm.customer.name),callback:function ($$v) {_vm.$set(_vm.customer, "name", $$v)},expression:"customer.name"}}),_vm._v(" "),(_vm.hasErrors.custnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid comapny Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgba(12, 11, 11, 0.87) !important","height":"20px !important"},attrs:{"list":_vm.contyp,"option-value":"desc","option-text":"desc","placeholder":"Select Company Type"},model:{value:(_vm.suptype),callback:function ($$v) {_vm.suptype=$$v},expression:"suptype"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 1:")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custad1},attrs:{"type":"text","id":"add1","autocomplete":"off","placeholder":"Enter Customer Address 1"},on:{"input":function($event){_vm.shippingenable()}},model:{value:(_vm.customer.add),callback:function ($$v) {_vm.$set(_vm.customer, "add", $$v)},expression:"customer.add"}}),_vm._v(" "),(_vm.hasErrors.custad1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address 1")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 2(optional):")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custad2},attrs:{"type":"text","id":"add2","autocomplete":"off","placeholder":"Enter  Address Line 2"},model:{value:(_vm.customer.add2),callback:function ($$v) {_vm.$set(_vm.customer, "add2", $$v)},expression:"customer.add2"}}),_vm._v(" "),(_vm.hasErrors.custad2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address 2 ")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custpin},attrs:{"type":"text","id":"pin","autocomplete":"off","placeholder":"Pincode"},model:{value:(_vm.customer.pin),callback:function ($$v) {_vm.$set(_vm.customer, "pin", $$v)},expression:"customer.pin"}}),_vm._v(" "),(_vm.hasErrors.custpin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Pincode ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Country :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country"},on:{"input":_vm.state1},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("State :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.city1},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select city"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Corporate Identity Number:")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.cin),expression:"customer.cin"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custcin},attrs:{"type":"text","id":"cin","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company Identity Number","aria-label":"Enter Corporate Identity Number","aria-describedby":"btnGroupAddon","autocomplete":"off"},domProps:{"value":(_vm.customer.cin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "cin", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custcin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid CIN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CIN Certificate : ")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image1},attrs:{"type":"file","name":"image1","id":"image1","accept":"image/*","autocomplete":"off"}}),_vm._v(" "),(_vm.hasErrors.image1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image1))])]):_vm._e(),_vm._v(" "),(_vm.ed.image1!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST/VAT Number :")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.gst),expression:"customer.gst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custgst},attrs:{"type":"text","id":"cust_gst","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.customer.gst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "gst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Certificate:")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image2},attrs:{"type":"file","name":"image2","id":"image2","accept":"image/*","autocomplete":"off"}}),_vm._v(" "),(_vm.hasErrors.image2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image2))])]):_vm._e(),_vm._v(" "),(_vm.ed.image2!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image2_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Number:")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.pan),expression:"customer.pan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custpan},attrs:{"type":"text","id":"cust_pan","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company PAN Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.customer.pan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "pan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custpan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid PAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Certificate:")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image3},attrs:{"type":"file","name":"image3","id":"image3","accept":"image/*","autocomplete":"off"}}),_vm._v(" "),(_vm.hasErrors.image3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image3))])]):_vm._e(),_vm._v(" "),(_vm.ed.image3!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image3_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Number :")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.tan),expression:"customer.tan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custtan},attrs:{"type":"text","id":"tan","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company Tan Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.customer.tan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "tan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custtan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid TAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Certificate:")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image4},attrs:{"type":"file","name":"image4","id":"image4","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image4)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image4))])]):_vm._e(),_vm._v(" "),(_vm.ed.image4!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image4_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact No. : "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custph},attrs:{"type":"text","id":"phone","autocomplete":"off","placeholder":"Enter Your Contact Number"},model:{value:(_vm.customer.phone),callback:function ($$v) {_vm.$set(_vm.customer, "phone", $$v)},expression:"customer.phone"}}),_vm._v(" "),(_vm.hasErrors.custph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custeml},attrs:{"type":"text","id":"email","autocomplete":"off","placeholder":"Enter Your E-Mail Id"},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}}),_vm._v(" "),(_vm.hasErrors.custeml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil  Id")])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Logo :")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image5},attrs:{"type":"file","name":"image5","id":"image5","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image5)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image5))])]):_vm._e(),_vm._v(" "),(_vm.ed.image5!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image5_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Contact Person Detail")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Person Name :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custcont},attrs:{"type":"text","id":"contact","autocomplete":"off","placeholder":"Enter Contact Person Name"},model:{value:(_vm.customer.contact),callback:function ($$v) {_vm.$set(_vm.customer, "contact", $$v)},expression:"customer.contact"}}),_vm._v(" "),(_vm.hasErrors.custcont)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid  Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custcontno},attrs:{"type":"text","id":"contactno","autocomplete":"off","placeholder":" Enter Contact Contact Number"},model:{value:(_vm.customer.contactno),callback:function ($$v) {_vm.$set(_vm.customer, "contactno", $$v)},expression:"customer.contactno"}}),_vm._v(" "),(_vm.hasErrors.custcontno)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Email :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custconteml},attrs:{"type":"text","id":"contactemail","autocomplete":"off","placeholder":"Enter Contact Person E-mail Id"},model:{value:(_vm.customer.contactemail),callback:function ($$v) {_vm.$set(_vm.customer, "contactemail", $$v)},expression:"customer.contactemail"}}),_vm._v(" "),(_vm.hasErrors.custconteml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil Id ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Company Profile :")]),_vm._v(" "),(_vm.hasErrors.supplierprf)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Profile cannot be greater than 255 Character")])]):_vm._e(),_vm._v(" "),_c('vue-editor',{attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.customer.profile),callback:function ($$v) {_vm.$set(_vm.customer, "profile", $$v)},expression:"customer.profile"}})],1)],1)],1),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Bank Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Name :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankname),expression:"customer.bankname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankname},attrs:{"type":"text","id":"bankname","autocomplete":"off","placeholder":"Enter your Bank Name"},domProps:{"value":(_vm.customer.bankname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Number :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.banknumber),expression:"customer.banknumber"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.banknumber},attrs:{"type":"text","id":"banknumber","name":"banknumber","autocomplete":"off","placeholder":"Enter your Bank Account Number"},domProps:{"value":(_vm.customer.banknumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "banknumber", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.banknumber)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Account Number")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Holder Name :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankholder),expression:"customer.bankholder"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankholder},attrs:{"type":"text","id":"bankholder","name":"bankholder","autocomplete":"off","placeholder":"Enter Account Holder Name"},domProps:{"value":(_vm.customer.bankholder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankholder", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankholder)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Account Holder Name")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IFSC Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankifsc),expression:"customer.bankifsc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankifsc},attrs:{"type":"text","id":"bankifsc","name":"bankifsc","autocomplete":"off","placeholder":"Enter Bank IFSC Code"},domProps:{"value":(_vm.customer.bankifsc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankifsc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankifsc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid IFSC Code")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Branch :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankbranch),expression:"customer.bankbranch"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankbranch},attrs:{"type":"text","id":"bankbranch","name":"bankbranch","autocomplete":"off","placeholder":"Enter Branch Name"},domProps:{"value":(_vm.customer.bankbranch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankbranch", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankbranch)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Branch")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("MICR Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankmicr),expression:"customer.bankmicr"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankmicr},attrs:{"type":"text","id":"bankmicr","name":"bankmicr","autocomplete":"off","placeholder":"Enter MICR code"},domProps:{"value":(_vm.customer.bankmicr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankmicr", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankmicr)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid MICR Code")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Swift Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankswift),expression:"customer.bankswift"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankswift},attrs:{"type":"text","id":"bankswift","name":"bankswift","autocomplete":"off","placeholder":"Enter Bank Swift Code"},domProps:{"value":(_vm.customer.bankswift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankswift", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankswift)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Swift Code")])]):_vm._e()])])]),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Shipping Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.sname),expression:"address.sname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsname},attrs:{"type":"text","id":"sname","placeholder":"Enter Name","autocomplete":"off","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.sname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "sname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errsname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsname))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.saddress),expression:"address.saddress"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsaddress},attrs:{"type":"text","id":"saddress","name":"saddress","autocomplete":"off","placeholder":"Enter Address","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.saddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "saddress", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errsaddress)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsaddress))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.sphn),expression:"address.sphn"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsphn},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Phone Number","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.sphn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "sphn", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errsphn)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsphn))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("State ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.shipping_city},model:{value:(_vm.shippingstate),callback:function ($$v) {_vm.shippingstate=$$v},expression:"shippingstate"}}),_vm._v(" "),(_vm.hasErrors1.errsstate)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsstate))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("City")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.shippingcityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select city"},model:{value:(_vm.shippingcity),callback:function ($$v) {_vm.shippingcity=$$v},expression:"shippingcity"}}),_vm._v(" "),(_vm.hasErrors1.errscity)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errscity))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.spincode),expression:"address.spincode"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errspincode},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Pincode","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.spincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "spincode", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errspincode)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errspincode))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Number :")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.sgst),expression:"address.sgst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsgst},attrs:{"type":"text","id":"gst","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.sgst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "sgst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors1.errsgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_c('br')]),_c('br'),_vm._v(" "),_c('small',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"name":"add","disabled":_vm.shipdisable},on:{"click":function($event){_vm.addValues()}}},[_vm._v("Add")])])])])]),_c('br'),_c('br'),_vm._v(" "),_vm._l((_vm.addr),function(address1,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"form-group"},[_c('b',[_vm._v(_vm._s(address1.yname)+" ("+_vm._s(address1.yphn)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(address1.ygst))]),_c('br'),_vm._v(" "),(address1.yaddress!='')?_c('span',[_vm._v("\n                   "+_vm._s(address1.yaddress)),_c('br')]):_vm._e(),_vm._v(" "),(address1.ystate != '' && address1.ycity != '' && address1.ypincode != '')?_c('span',[_vm._v("\n                   "+_vm._s(address1.ystate)+"   "+_vm._s(address1.ycity)+" - "+_vm._s(address1.ypincode)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2",staticStyle:{"color":"#f86c6b","font-size":"20px","cursor":"pointer"}},[(address1.chkship_id!=1)?_c('span',[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deleteadd(index)}}})]):_vm._e()]),_c('hr',{attrs:{"width":"97%"}})])})],2)]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.saveBtn)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]):_vm._e(),_vm._v(" "),(_vm.editBtn)?_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Update()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Update")]):_vm._e()])],1)],1)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                You have reached the limit of adding Customers. Please upgrade your plan to add more Customers.\n              ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleinvoice_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1c76f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saleinvoice_vue__ = __webpack_require__(794);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saleinvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b1c76f2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saleinvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ui-view"}},[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("To Date")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.todate),callback:function ($$v) {_vm.todate=$$v},expression:"todate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("From Date")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.fromdate),callback:function ($$v) {_vm.fromdate=$$v},expression:"fromdate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.custname),expression:"custname"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Your Customer Name"},domProps:{"value":(_vm.custname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.custname=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale Id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salename),expression:"salename"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Your SaleId"},domProps:{"value":(_vm.salename)},on:{"input":function($event){if($event.target.composing){ return; }_vm.salename=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary serach_bttn",attrs:{"type":"submit"},on:{"click":_vm.searchdt}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                  ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"pagination-options":{enabled: true, perPage: 5, },"mode":"remote","totalRows":_vm.totalRecords,"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'generate')?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary",staticStyle:{"width":"80px","border-radius":"20px"},on:{"click":function($event){_vm.generateclick(props.row)}}},[_vm._v("Invoice")])]):(props.column.field == 'lastupdated_datetime')?_c('span',[_vm._v("\n                    "+_vm._s(_vm.newDate(props.row.lastupdated_datetime))+"\n              ")]):_c('span',[_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")])]}}])})],1)])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Invoices")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Invoice List")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salepdf_vue__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c08079ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salepdf_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salepdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c08079ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salepdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ui-view"}},[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('strong',[_c('img',{staticStyle:{"height":"35px"},attrs:{"src":_vm.company_logo}})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 card-header"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.shop.name))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_vm._v("\n                    "+_vm._s(_vm.shop.add1)+" "+_vm._s(_vm.shop.add2)+" "+_vm._s(_vm.shop.city)+"\n                    "),(_vm.shop.pincode != null)?_c('span',[_vm._v("- "+_vm._s(_vm.shop.pincode))]):_vm._e(),_vm._v("\n                    "+_vm._s(_vm.shop.state)+" - "+_vm._s(_vm.shop.country)+"\n                    "),(_vm.shop.gst != null)?_c('span',[_vm._v("GSTIN : "+_vm._s(_vm.shop.gst))]):_vm._e(),(_vm.shop.phone != null)?_c('span',[_vm._v("\n                      Contact : "+_vm._s(_vm.shop.phone))]):_vm._e()])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row mbt-4"},[_c('div',{staticClass:"col-sm-4"},[_c('h6',{staticClass:"my-3"},[_vm._v("Bill To:")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.cust_name))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.customer.add1)+" "+_vm._s(_vm.customer.add2))]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(_vm.customer.city)+" "+_vm._s(_vm.customer.state)+"\n                  "),(_vm.customer.pincode != '')?_c('span'):_vm._e(),_vm._v("\n                  "+_vm._s(_vm.customer.pincode)),(_vm.customer.country != '')?_c('span'):_vm._e(),_vm._v("\n                  "+_vm._s(_vm.customer.country)+"\n                ")]),_vm._v(" "),(_vm.customer.email != '')?_c('div',[_vm._v("Email: "+_vm._s(_vm.cust_email))]):_vm._e(),_vm._v(" "),(_vm.customer.phone != '')?_c('div',[_vm._v("Phone: "+_vm._s(_vm.cust_phone))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h6',{staticClass:"my-3"},[_vm._v("\n                  Ship To:\n                  ")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.customer1.name)+"   "+_vm._s(_vm.customer1.phone))])]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.customer1.add))]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(_vm.customer1.city)+" "+_vm._s(_vm.customer1.state)+"\n                  "+_vm._s(_vm.customer1.pincode)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h6',{staticClass:"my-3"},[_vm._v("Details:")]),_vm._v(" "),_c('div',[_vm._v("\n                  Invoice\n                  "),_c('strong',[_vm._v("#"+_vm._s(_vm.sales.id))])]),_vm._v(" "),_c('div',[_vm._v("Invoice Date : "+_vm._s(_vm.sales.date))]),_vm._v(" "),(_vm.cmp.cmp_bnk_holder != null)?_c('div',[_vm._v("\n                  Account Name: "+_vm._s(_vm.cmp.cmp_bnk_holder)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.cmp.cmp_swift != null)?_c('div',[_c('strong',[_vm._v("SWIFT Code: "+_vm._s(_vm.cmp.cmp_swift))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-header",staticStyle:{"padding-top":"0px","padding-bottom":"0px"}},[_c('h4',[_vm._v("\n                Attn: "),_c('span',[_vm._v(_vm._s(_vm.cust_name))])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',{staticClass:"center"},[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Item & Description")]),_vm._v(" "),_c('th',{staticClass:"center"},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{staticClass:"right"},[_vm._v("Sale Price")]),_vm._v(" "),_c('th',{staticClass:"right"},[_vm._v("Amount Before Tax")]),_vm._v(" "),_c('th',{staticClass:"right"},[_vm._v("Discount")]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('th',{staticClass:"right"},[_vm._v("Sales Tax %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{staticClass:"right"},[_vm._v("SGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{staticClass:"right"},[_vm._v("CGST %")]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('th',{staticClass:"right"},[_vm._v("IGST %")]):_vm._e(),_vm._v(" "),_c('th',{staticClass:"right"},[_vm._v("Total")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',{staticClass:"center"},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('td',{staticClass:"left"},[_vm._v("\n                      "+_vm._s(row.product_name)+" ("+_vm._s(row.variant_id)+")\n                    ")]),_vm._v(" "),_c('td',{staticClass:"left"},[_vm._v(_vm._s(row.sale_qty))]),_vm._v(" "),_c('td',{staticClass:"center"},[_vm._v("\n                      "+_vm._s(_vm.currencySymbol)+_vm._s(_vm.formatAmt(row.product_unit_cost))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.currencySymbol)+_vm._s(_vm.formatAmt(row.sub_total)))]),_vm._v(" "),_c('td',{staticClass:"right"},[(row.sale_igst != '')?_c('span',[_vm._v(_vm._s(_vm.currencySymbol)+_vm._s(_vm.formatAmt(row.item_discount)))]):_vm._e()]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('td',{staticClass:"right"},[(row.sale_igst != '')?_c('span',[_vm._v(_vm._s(_vm.formatAmt(row.sale_igst))+"%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',{staticClass:"right"},[(row.sale_cgst != '')?_c('span',[_vm._v(_vm._s(_vm.formatAmt(row.sale_cgst))+"%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',{staticClass:"right"},[(row.sale_sgst != '')?_c('span',[_vm._v(_vm._s(_vm.formatAmt(row.sale_sgst))+"%")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('td',{staticClass:"right"},[(row.sale_igst != '')?_c('span',[_vm._v(_vm._s(_vm.formatAmt(row.sale_igst))+"%")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.formatAmt(row.amt_to_pay)))])])}))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-sm-5",staticStyle:{"margin-top":"10px"}},[_vm._v("\n                Total in words:"),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.amt_word))]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"text-align":"rigth","padding-left":"0px","padding-top":"122px"}},[_vm._v("\n                  Authorized Signature\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-5 ml-auto"},[_c('table',{staticClass:"table table-clear"},[_c('tbody',[_c('tr',[_vm._m(2),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v("\n                        "+_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.sales.total_amt_before_disc)+"\n                      ")])]),_vm._v(" "),_c('tr',[_vm._m(3),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.sales.total_discount))])]),_vm._v(" "),(_vm.companyTaxType === 'US')?_c('tr',[_vm._m(4),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.sales.igst))])]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('tr',[_vm._m(5),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.sales.cgst))])]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('tr',[_vm._m(6),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.sales.sgst))])]):_vm._e(),_vm._v(" "),(_vm.companyTaxType !== 'US')?_c('tr',[_vm._m(7),_vm._v(" "),_c('td',{staticClass:"right"},[_vm._v(_vm._s(_vm.currencySymbol)+" "+_vm._s(_vm.sales.igst))])]):_vm._e(),_vm._v(" "),_c('tr',[_vm._m(8),_vm._v(" "),_c('td',{staticClass:"right"},[_c('strong',[_vm._v(_vm._s(_vm.sales.total_amt_pay))])])]),_vm._v(" "),_c('tr',[_vm._m(9),_vm._v(" "),_c('td',{staticClass:"right"},[_c('strong',[_vm._v(_vm._s(_vm.sales.total_amt_paid))])])]),_vm._v(" "),_c('tr',[_vm._m(10),_vm._v(" "),_c('td',{staticClass:"right"},[_c('strong',[_vm._v(_vm._s(_vm.sales.balance))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 card-header"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-sm btn-info float-right printpage",staticStyle:{"margin-top":"10px"},attrs:{"href":"#","onclick":"javascript:window.print();"}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" Print")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"invoice",staticStyle:{"font-size":"40px"}},[_vm._v("\n                  Tax Invoice\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("Discount")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("Sales Tax")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("CGST")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("SGST")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("IGST")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("Amount Paid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"left"},[_c('strong',[_vm._v("Balance")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salepayment_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a23c93_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salepayment_vue__ = __webpack_require__(799);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salepayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a23c93_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salepayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ui-view"}},[_c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.haserror.message))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Customer "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.customer_name,"option-value":"customer_id","option-text":"cust_cmp_name","placeholder":"Search Customer"},on:{"input":function($event){_vm.CusSelected()},"searchchange":_vm.searchcustomer},model:{value:(_vm.selectcustomer),callback:function ($$v) {_vm.selectcustomer=$$v},expression:"selectcustomer"}}),_vm._v(" "),(_vm.haserror.customer!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.customer))])]):_vm._e()],1)])])],1)]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"rgb(232, 235, 238)","padding-left":"18px","padding-top":"10px","padding-bottom":"25px"}},[_vm._m(1),_vm._v(" "),_vm._l((_vm.rows1),function(row,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('label',{attrs:{"for":"Purches"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.sales_id),expression:"row.sales_id"}],staticClass:"form-control",attrs:{"type":"text","name":"sales_id","autocomplete":"off","placeholder":"Enter Sale Id"},domProps:{"value":(row.sales_id)},on:{"change":function($event){_vm.sales(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "sales_id", $event.target.value)}}}),_vm._v(" "),(row.err_sales_id!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(row.err_sales_id))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"padding-left":"0px","padding-top":"20px"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill",attrs:{"type":"button","title":"Search Sales Id"},on:{"click":function($event){_vm.search_sales_modal(index)}}},[_c('i',{staticClass:"fa fa-search"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"customer_id"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.customer_id),expression:"row.customer_id"}],staticClass:"form-control",attrs:{"type":"text","name":"customer_id","autocomplete":"off","readonly":""},domProps:{"value":(row.customer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "customer_id", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amount_topay),expression:"row.amount_topay"}],staticClass:"form-control",attrs:{"type":"text","name":"amount_topay","autocomplete":"off"},domProps:{"value":(row.amount_topay)},on:{"change":function($event){_vm.calculate(index);},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amount_topay", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('label'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amount_balance),expression:"row.amount_balance"}],staticClass:"form-control",attrs:{"type":"text","name":"amount_balance","autocomplete":"off","readonly":""},domProps:{"value":(row.amount_balance)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amount_balance", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"padding-top":"20px"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill",attrs:{"type":"button","title":"Add New Row"},on:{"click":_vm.addRow1}},[_c('i',{staticClass:"fa fa-plus"})])]),_vm._v(" "),((index != 0))?_c('div',{staticClass:"col-md-2",staticStyle:{"padding-top":"20px","padding-left":"0px"}},[_c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"btn btn-pill",attrs:{"type":"button","title":"Delete Row"},on:{"click":function($event){_vm.removeElement(index);}}},[_c('i',{staticClass:"fa fa-trash"})])]):_vm._e()])])])})],2),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Payment Mode")]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.payment_mode_list,"option-value":"pay_value","option-text":"pay_text","placeholder":"Select Payment Mode"},on:{"input":function($event){_vm.onSelect()}},model:{value:(_vm.payment_mode),callback:function ($$v) {_vm.payment_mode=$$v},expression:"payment_mode"}}),_vm._v(" "),(_vm.haserror.payment_mode!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.payment_mode))])]):_vm._e()],1)]),_vm._v(" "),(_vm.is_cheque)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cheque No")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cheque_no),expression:"cheque_no"}],staticClass:"form-control",attrs:{"type":"text","name":"cheque_no","autocomplete":"off","placeholder":"Enter Cheque No"},domProps:{"value":(_vm.cheque_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cheque_no=$event.target.value}}}),_vm._v(" "),(_vm.haserror.cheque_no!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cheque_no))])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.is_cheque)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cheque Date")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},model:{value:(_vm.cheque_date),callback:function ($$v) {_vm.cheque_date=$$v},expression:"cheque_date"}}),_vm._v(" "),(_vm.haserror.cheque_date!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.cheque_date))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Attachment ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.haserror.attachment},attrs:{"autocomplete":"off","type":"file","name":"attachment","id":"attachment"}}),_vm._v(" "),(_vm.haserror.attachment!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.attachment))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Note ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],staticClass:"form-control",attrs:{"type":"textarea"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}}),_vm._v(" "),(_vm.haserror.note!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.haserror.note))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":_vm.finalsubmit}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Search","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" From Date ")]),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"120px"},attrs:{"editable":"","lang":"en"},model:{value:(_vm.from_DT),callback:function ($$v) {_vm.from_DT=$$v},expression:"from_DT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("To Date ")]),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"120px"},attrs:{"editable":"","lang":"en"},model:{value:(_vm.to_DT),callback:function ($$v) {_vm.to_DT=$$v},expression:"to_DT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales Id ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Sales Id","autocomplete":"off"},model:{value:(_vm.sales_id1),callback:function ($$v) {_vm.sales_id1=$$v},expression:"sales_id1"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('button',{staticClass:"btn btn-pill",staticStyle:{"width":"110px","border-radius":"15px"},attrs:{"type":"button"},on:{"click":_vm.search_sales}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")])])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('strong',[_vm._v("List Sales")])]),_vm._v(" "),_c('div',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'paymod')?_c('span',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.add_sales_payment(props.row)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add")])]):_c('span',[_vm._v("\n              "+_vm._s(props.formattedRow[props.column.field])+"\n            ")])]}}])})],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Sales Receipt")]),_vm._v(" "),_c('a',{staticClass:"float-right",attrs:{"href":"#"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":"Purches"}},[_vm._v("Sales Id "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"Customer"}},[_vm._v("Customer Id")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',[_vm._v("Amount To Pay")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',[_vm._v("Balance")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salepaymenthistory_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08389d21_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salepaymenthistory_vue__ = __webpack_require__(801);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salepaymenthistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08389d21_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salepaymenthistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[(_vm.is_admin === true)?_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1)],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v("\n                          \n                            \n              "),_c('div',{staticClass:"col-sm-1"},[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.exportData()}}},[_c('i',{}),_vm._v(" Export Data\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),(_vm.loading === true)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Choose Company")]),_vm._v(" "),_c('small')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-9"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" List Sales Receipt\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salereturnpayment_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9656da8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salereturnpayment_vue__ = __webpack_require__(803);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salereturnpayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9656da8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salereturnpayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[(_vm.is_admin === true)?_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompnay($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}})],1)],1)],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 5 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),(_vm.loading === true)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Choose Company")]),_vm._v(" "),_c('small')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" List Sales Return Receipt\n              ")]),_vm._v("\n                          \n                            \n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopInventory_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a598c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopInventory_vue__ = __webpack_require__(805);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopInventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4a598c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopInventory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Name ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Product")]),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.openvariant()},"searchchange":function($event){_vm.searchprd3($event)}},model:{value:(_vm.selectproduct),callback:function ($$v) {_vm.selectproduct=$$v},expression:"selectproduct"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Variant")]),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.variantvalue,"option-value":"variant_value","option-text":"variant_value","placeholder":"Search Variant"},model:{value:(_vm.selectvariant),callback:function ($$v) {_vm.selectvariant=$$v},expression:"selectvariant"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.search}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                ")])])],1)],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('span',{staticClass:"title_head"},[_vm._v("Stock Inventory")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.invt_view))])]),_vm._v(" "),_vm._v("\n                          \n                          \n                      \n              "),_c('div',{staticClass:"col-sm-1"},[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.exportData()}}},[_c('i',{}),_vm._v(" Export Data\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'exp_sellprice_bft_lbl')?_c('span',[(props.row.id == _vm.inventory.id)?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventory.price_bft),expression:"inventory.price_bft"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Sale Price"},domProps:{"value":(_vm.inventory.price_bft)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventory, "price_bft", $event.target.value)}}})]):_c('span',[_vm._v("\n                  "+_vm._s(_vm.formatFn(props.row.exp_sellprice_bft))+"\n                ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'variant_value')?_c('span',[(props.row.variant_id == 'n/a')?_c('span',[_vm._v("\n                  No Variant\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(props.row.variant_id)+"\n                ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'action')?_c('span',[(_vm.invt_rights === true)?_c('span',[(props.row.id == _vm.inventory.id)?_c('span',[_c('i',{staticClass:"fa fa-save",on:{"click":function($event){$event.preventDefault();_vm.update_inventory(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.edit_inventory(props.row)}}})])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Inventory")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listtransfer_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08dfb450_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listtransfer_vue__ = __webpack_require__(807);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listtransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08dfb450_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listtransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Transfer Id ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.transfer_id),expression:"search.transfer_id"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Transfer Id","name":""},domProps:{"value":(_vm.search.transfer_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "transfer_id", $event.target.value)}}})])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Name ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.product_name),expression:"search.product_name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Product Name ","name":""},domProps:{"value":(_vm.search.product_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.search, "product_name", $event.target.value)}}})])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Dispatch Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"0px","min-width":"155px"},attrs:{"input-name":"date","format":"YYYY-MM-DD","editable":"","lang":"en"},model:{value:(_vm.search.dispatch_DT),callback:function ($$v) {_vm.$set(_vm.search, "dispatch_DT", $$v)},expression:"search.dispatch_DT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Recived Date")]),_c('br'),_vm._v(" "),_c('date-picker',{staticStyle:{"width":"0px","min-width":"155px"},attrs:{"editable":"","lang":"en"},model:{value:(_vm.search.receive_DT),callback:function ($$v) {_vm.$set(_vm.search, "receive_DT", $$v)},expression:"search.receive_DT"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("From Shop")]),_vm._v(" "),_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.fromshp,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"From Shop"},model:{value:(_vm.search.from_sh),callback:function ($$v) {_vm.$set(_vm.search, "from_sh", $$v)},expression:"search.from_sh"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("To Shop")]),_vm._v(" "),_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.toshp,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"To Shop"},model:{value:(_vm.search.to_sh),callback:function ($$v) {_vm.$set(_vm.search, "to_sh", $$v)},expression:"search.to_sh"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[(_vm.stcktran_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary",staticStyle:{"width":"140px","border-radius":"15px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getTotals()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")]):_vm._e()])],1)],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._v("\n                               \n                   \n                  "),_c('div',{staticClass:"col-sm-1"},[(_vm.stcktran_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"id":"MyDownload","type":"button"},on:{"click":_vm.exportData}},[_c('i',{}),_vm._v(" Export Data\n                    \n                  ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[[_c('div',[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{enabled: true, perPage: 5,},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'check')?_c('span',[(props.row.companyproducts!=undefined)?_c('span',[_vm._v("   \n                        "+_vm._s(props.row.companyproducts.product_name)+"\n                      ")]):_c('span',[_vm._v("         \n                        "+_vm._s(props.row.product_name)+"\n                      ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'product_qty_lb')?_c('span',[_vm._v("\n                        "+_vm._s(props.row.product_qty)+"\n                    ")]):_vm._e(),_vm._v(" "),(props.column.field == 'est_shop_id_from_lb')?_c('span',[(props.row.shopestablishments_from!=undefined)?_c('span',[_vm._v("   \n                        "+_vm._s(props.row.shopestablishments_from.est_shop_name)+"\n                      ")]):_c('span',[_vm._v("         \n                        "+_vm._s(props.row.shp_from)+"\n                      ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'est_shop_id_to_lb')?_c('span',[(props.row.shopestablishments_to!=undefined)?_c('span',[_vm._v("   \n                        "+_vm._s(props.row.shopestablishments_to.est_shop_name)+"\n                      ")]):_c('span',[_vm._v("         \n                        "+_vm._s(props.row.shp_to)+"\n                      ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'action')?_c('span',[(_vm.stcktran_rights === true)?_c('span',[(props.row.id==_vm.transfer.id_ed)?_c('span',[_c('i',{staticClass:"fa fa-save",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){$event.preventDefault();_vm.updateTransfer(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"#63c2de","font-size":"20px","cursor":"pointer"},on:{"click":function($event){$event.preventDefault();_vm.editTransfer(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"#f86c6b","font-size":"20px","cursor":"pointer"},on:{"click":function($event){$event.preventDefault();_vm.deleteTransfer(props.row)}}})])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):(props.column.field == 'dispatch_datetime')?_c('span',[_vm._v("\n                      "+_vm._s(_vm.newDate(props.row.dispatch_datetime))+"\n                    ")]):(props.column.field == 'receive_datetime')?_c('span',[_vm._v("\n                      "+_vm._s(_vm.newDate(props.row.receive_datetime))+"\n                    ")]):_c('span',[_vm._v("\n                      "+_vm._s(props.formattedRow[props.column.field])+"\n                    ")])]}}])})],1)]],2)])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Transfer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-10"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" Transfer List\n                       "),_c('a',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"href":"#/Addtransfer"}},[_c('i',{staticClass:"fa  fa-plus"}),_vm._v(" Add Transfer\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addtransfer_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08da1d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addtransfer_vue__ = __webpack_require__(811);
function injectStyle (ssrContext) {
  __webpack_require__(809)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addtransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08da1d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addtransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Company Name","name":"company_name"},model:{value:(_vm.search_cname),callback:function ($$v) {_vm.search_cname=$$v},expression:"search_cname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"2px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getcompany($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                  ")])])],1)],1)],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.sucess != '')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.sucess))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{
                  enabled: true,
                  perPage: 10,
                },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){$event.preventDefault();_vm.viewvalue(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editvalue(props.row)}}})]):(props.column.field == 'userdtl')?_c('span',[_c('i',{staticClass:"fa fa-user-circle",staticStyle:{"color":"#63c2de","font-size":"18px","cursor":"pointer"},on:{"click":function($event){$event.preventDefault();_vm.userdetail(props.row)}}})]):_c('span',[_vm._v("\n                    "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")])]}}])})],1)])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Company User Details ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"styleClass":"vgt-table striped bordered table-sm condensed"}})],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Company")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v("\n              Registered Company List\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Add Transfer")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasErrors.message != '')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_c('strong',[_vm._v("Success!")]),_vm._v(_vm._s(_vm.hasErrors.message)+"\n                ")])],1):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("From Shop ")]),_vm._v(" "),_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.fromshp,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"From Shop"},on:{"input":function($event){_vm.fromShpSelected()}},model:{value:(_vm.from_sh),callback:function ($$v) {_vm.from_sh=$$v},expression:"from_sh"}})],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.fromshop))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("To Shop ")]),_vm._v(" "),_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.toshp,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"To Shop"},on:{"input":function($event){_vm.toShpSelected()}},model:{value:(_vm.to_sh),callback:function ($$v) {_vm.to_sh=$$v},expression:"to_sh"}})],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.toshop))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(" Dispatch Date ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},on:{"input":function($event){_vm.dispatchSelected()}},model:{value:(_vm.dispatch_DT),callback:function ($$v) {_vm.dispatch_DT=$$v},expression:"dispatch_DT"}})],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.dispatch))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(" Expected to arrive ")]),_c('br'),_vm._v(" "),_c('date-picker',{attrs:{"editable":"","lang":"en"},on:{"input":function($event){_vm.receivedSelected()}},model:{value:(_vm.receive_DT),callback:function ($$v) {_vm.receive_DT=$$v},expression:"receive_DT"}})],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.received))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"0px !important"}},[_c('div',{staticClass:"table-responsive-sm"},[_c('table',{staticClass:"table table-striped",attrs:{"width":"100%"}},[_vm._m(1),_vm._v(" "),_c('tbody',{attrs:{"id":"product_table_body"}},_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":row.productname,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product Name"},on:{"input":function($event){_vm.onSelect($event, row)},"searchchange":function($event){_vm.searchprd($event, index, row)}},model:{value:(row.selectproductrow),callback:function ($$v) {_vm.$set(row, "selectproductrow", $$v)},expression:"row.selectproductrow"}})],1),_vm._v(" "),_vm._m(2,true)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('small',{staticStyle:{"font-size":"14px","color":"green","margin-top":"41px"}},[_vm._v("Product Unit\n                          "),_c('span',{staticStyle:{"color":"#000"}},[_vm._v(_vm._s(row.unit_name))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('small',{staticStyle:{"font-size":"14px","color":"green","margin-top":"41px"},on:{"click":function($event){_vm.openvariant(row, index)}}},[(row.show == true)?_c('a',{staticStyle:{"cursor":"pointer"}},[_vm._v("Change Variant: "+_vm._s(row.variantrow))]):_vm._e()]),_vm._v(" "),_c('small',{staticStyle:{"font-size":"14px","color":"green","margin-top":"41px"}},[(row.show1 == true)?_c('a',[_vm._v("Variant :"+_vm._s(row.variantrow))]):_vm._e()])])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.quantity),expression:"row.quantity"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(row.quantity)},on:{"change":function($event){_vm.quantity(row)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "quantity", $event.target.value)}}}),_vm._v(" "),_c('small',{staticStyle:{"font-size":"14px","color":"green","margin-top":"41px"}},[_vm._v("Available Qty\n                      "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(row.avai_quantity))])])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.toshp_lbl),expression:"row.toshp_lbl"}],staticClass:"form-control",staticStyle:{"width":"90%"},attrs:{"type":"text","autocomplete":"off","disabled":""},domProps:{"value":(row.toshp_lbl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "toshp_lbl", $event.target.value)}}}),_vm._v(" "),_c('div',{staticStyle:{"float":"right","font-size":"23px","padding-right":"10px","margin-top":"-37px"}},[_c('span',[_c('a',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"cursor":"pointer"},attrs:{"title":"Delete"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red"},on:{"click":function($event){_vm.removeElement(index)}}})])])])])])}))])]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"15px","color":"green","margin-top":"-8px","margin-left":"7px","margin-bottom":"8px"}},[_vm._v("\n            Add New Row :\n            "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge badge-pill badge-info",staticStyle:{"cursor":"pointer"},attrs:{"title":"Add New Row"},on:{"click":_vm.addRow1}},[_vm._v("Add")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"15px !important"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Note (optional) :")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.note),expression:"note"}],staticClass:"form-control",attrs:{"rows":"2"},domProps:{"value":(_vm.note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.note=$event.target.value}}})]),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.note))])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer card-footer"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.saveTransfer}},[_c('i',{staticClass:"fa fa-dot-circle-o"},[_vm._v(" Save")])])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Select Variant","size":"sm","hide-footer":""},on:{"ok":function($event){_vm.smallmodal = false}},model:{value:(_vm.smallmodal),callback:function ($$v) {_vm.smallmodal=$$v},expression:"smallmodal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('model-list-select',{staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.variantvalue,"option-value":"variant_id","option-text":"variant_id","placeholder":"Search Variant Value"},on:{"input":function($event){_vm.onSelectvariant($event)}},model:{value:(_vm.variantdata),callback:function ($$v) {_vm.variantdata=$$v},expression:"variantdata"}})],1)])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Item Details")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticStyle:{"padding":"5px"}},[_c('tr',[_c('th',{staticClass:"span2",staticStyle:{"width":"10%","padding-left":"10px"}},[_vm._v("\n                    Product ID\n                  ")]),_vm._v(" "),_c('th',{staticClass:"span2",staticStyle:{"width":"45%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticClass:"span2",staticStyle:{"width":"15%"}},[_vm._v("Product Qty")]),_vm._v(" "),_c('th',{staticClass:"span2",staticStyle:{"width":"30%"}},[_vm._v("Transfer Shop")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2",staticStyle:{"padding-left":"0px"}},[_c('a',{attrs:{"target":"_blank","href":"#/setup/addupdateproduct"}},[_c('button',{staticClass:"btn btn-pill btn-primary",attrs:{"type":"button","title":"","data-original-title":"Add New Product"}},[_c('i',{staticClass:"fa fa-plus",staticStyle:{"color":"rgb(255, 255, 255)"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addproduct_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb3b3ec2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addproduct_vue__ = __webpack_require__(814);
function injectStyle (ssrContext) {
  __webpack_require__(813)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addproduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb3b3ec2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addproduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Product")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasErrors.message)?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.errorMessage.message))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdname),expression:"pdname"}],staticClass:"form-control",attrs:{"type":"text","name":"","autocomplete":"off","placeholder":"Enter Product Name"},domProps:{"value":(_vm.pdname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pdname=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pdid),expression:"pdid"}],staticClass:"form-control",attrs:{"type":"text","name":"","autocomplete":"off","placeholder":"Product Description"},domProps:{"value":(_vm.pdid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pdid=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.prod_view === true),expression:"prod_view === true"}],staticClass:"btn  btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getproducttl($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")])])])])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{attrs:{"header-tag":"header","footer-tag":"footer"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"title_head"},[_vm._v("List Product")]),_vm._v("  \n            "),(_vm.prod_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.openproduct}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Product")])]):_vm._e()]),_vm._v(" "),_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"paginationOptions":{enabled: true, perPage: 5},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[(_vm.prod_rights === true)?_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"rgb(99, 194, 222) !important"},on:{"click":function($event){$event.preventDefault();_vm.viewpro(props.row)}}}),_vm._v(" "),(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"rgb(99, 194, 222) !important"},on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}})])]):_c('span',[_c('i',{staticClass:"fa fa-eye",staticStyle:{"color":"grey !important"},on:{"click":function($event){$event.preventDefault();_vm.viewpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}})])]):(props.column.field == 'product_description')?_c('span',[_vm._v("\n                "+_vm._s(_vm.strip_html_tags(props.row.product_desc))+"\n              ")]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n            ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Product Detail","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Name"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productname),expression:"product.productname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productname},attrs:{"type":"text","autocomplete":"off","id":"productname","name":"productname","placeholder":"Enter Product Name"},domProps:{"value":(_vm.product.productname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.errorMessage.productname))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Category")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.category,"option-value":"category_name","option-text":"category_name","placeholder":"Select Category"},on:{"input":_vm.subcategory1},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.subcategory,"option-value":"sub_category_name","option-text":"sub_category_name","placeholder":"Select Sub Category"},model:{value:(_vm.selectedSub),callback:function ($$v) {_vm.selectedSub=$$v},expression:"selectedSub"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.brndopt,"option-value":"brand_name","option-text":"brand_name","placeholder":"Select Brand"},model:{value:(_vm.selectedBrand),callback:function ($$v) {_vm.selectedBrand=$$v},expression:"selectedBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.companyTaxType === 'US' ? 'US Code' : 'HSN Code')+" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.hsnopt,"option-value":"hsn_id","option-text":"hsn_code","placeholder":_vm.companyTaxType === 'US' ? 'Select US Code' : 'Select HSN Code'},on:{"input":_vm.tax_name_2},model:{value:(_vm.selectedHsn),callback:function ($$v) {_vm.selectedHsn=$$v},expression:"selectedHsn"}}),_vm._v(" "),(_vm.errorMessage.selectedHsn)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.errorMessage.selectedHsn))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"readonly":"","list":_vm.taxopt,"option-value":"tax_name","option-text":"tax_name","placeholder":"Select Tax"},model:{value:(_vm.selectedTax),callback:function ($$v) {_vm.selectedTax=$$v},expression:"selectedTax"}}),_vm._v(" "),(_vm.errorMessage.selectedTax)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.errorMessage.selectedTax))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Unit")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.unitopt,"option-value":"unit_name","option-text":"unit_name","placeholder":"Select Unit"},model:{value:(_vm.selectedUnit),callback:function ($$v) {_vm.selectedUnit=$$v},expression:"selectedUnit"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("SKU")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.altproductid),expression:"product.altproductid"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.altproductid},attrs:{"type":"text","autocomplete":"off","disabled":"","readonly":"","placeholder":"Auto-generated from Category & Product Name"},domProps:{"value":(_vm.product.altproductid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "altproductid", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.altproductid)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Id")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Variant")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.varientlist,"option-value":"variant_id","option-text":"variant_name","placeholder":"Select Variant"},model:{value:(_vm.product.variantname),callback:function ($$v) {_vm.$set(_vm.product, "variantname", $$v)},expression:"product.variantname"}}),_vm._v(" "),(_vm.hasErrors.variantname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Variant Name")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Description")]),_vm._v(" "),_c('vue-editor',{class:{'is-invalid':_vm.hasErrors.productdesc},attrs:{"id":"productdesc","name":"productdesc"},model:{value:(_vm.product.productdesc),callback:function ($$v) {_vm.$set(_vm.product, "productdesc", $$v)},expression:"product.productdesc"}}),_vm._v(" "),(_vm.hasErrors.productdesc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Description")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Additional Information "),_c('small',{staticClass:"text-muted"},[_vm._v("(optional)")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.additionalinfo),expression:"product.additionalinfo"}],staticClass:"form-control",attrs:{"rows":"3","autocomplete":"off","placeholder":"Enter Additional Information"},domProps:{"value":(_vm.product.additionalinfo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "additionalinfo", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 1 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput1",attrs:{"name":"product.image1","state":Boolean(_vm.errorMessage.image1==null),"accept":"image/*","id":"image1","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[0])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[0],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image1))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 2 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput2",attrs:{"name":"product.image2","state":Boolean(_vm.errorMessage.image2==null),"accept":"image/*","id":"image2","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[1])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[1],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image2))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 3 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput3",attrs:{"name":"product.image3","state":Boolean(_vm.errorMessage.image3==null),"accept":"image/*","id":"image3","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[2])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[2],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image3))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 4 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput4",attrs:{"name":"product.image4","state":Boolean(_vm.errorMessage.image4==null),"accept":"image/*","id":"image4","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[3])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[3],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image4)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image4))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 5 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput5",attrs:{"name":"product.image5","state":Boolean(_vm.errorMessage.image5==null),"accept":"image/*","id":"image5","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[4])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[4],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image5)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image5))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 6 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput6",attrs:{"name":"product.image6","state":Boolean(_vm.errorMessage.image6==null),"accept":"image/*","id":"image6","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[5])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[5],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image6)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image6))])]):_vm._e()],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Specification :")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Specification Description")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_vm._l((_vm.specs),function(spec,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(spec.specname),expression:"spec.specname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.specname},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Product Specification"},domProps:{"value":(spec.specname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(spec, "specname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.specname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Specification  Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(spec.specdesc),expression:"spec.specdesc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.specdesc},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Product Specification Description"},domProps:{"value":(spec.specdesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(spec, "specdesc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.specdesc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Specification Description")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"3px"}},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.addRow}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),((index != 0))?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){_vm.removeElement(index);}}},[_c('i',{staticClass:"fa fa-trash-o"})]):_vm._e()])])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Custom Field 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf1),expression:"product.productcf1"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productcf1},attrs:{"type":"text","id":"productcf1","autocomplete":"off","name":"productcf1","placeholder":"Custom Field Label 1"},domProps:{"value":(_vm.product.productcf1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf1", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productcf1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Classification")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Custom Field 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf2),expression:"product.productcf2"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Custom Field Label 2"},domProps:{"value":(_vm.product.productcf2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Custom Field 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf3),expression:"product.productcf3"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Custom Field Label 3"},domProps:{"value":(_vm.product.productcf3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf3", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{attrs:{"id":"checkbox1","value":"true","unchecked-value":"false"},model:{value:(_vm.checkboxqty),callback:function ($$v) {_vm.checkboxqty=$$v},expression:"checkboxqty"}},[_vm._v("Alert Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productalertqty),expression:"product.productalertqty"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productalert},attrs:{"type":"text","placeholder":"Enter Alert Quantity"},domProps:{"value":(_vm.product.productalertqty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productalertqty", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productalert)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Alert Quantity")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf_val1),expression:"product.productcf_val1"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productcf_val1},attrs:{"type":"text","id":"productcf_val1","autocomplete":"off","name":"productcf_val1","placeholder":"Custom Field value 1"},domProps:{"value":(_vm.product.productcf_val1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf_val1", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productcf_val1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Classification")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf_val2),expression:"product.productcf_val2"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Custom Field value 2"},domProps:{"value":(_vm.product.productcf_val2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf_val2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf_val3),expression:"product.productcf_val3"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Custom Field value 3"},domProps:{"value":(_vm.product.productcf_val3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf_val3", $event.target.value)}}})])])]),_vm._v(" "),( false)?_c('br'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[( false)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},on:{"input":function($event){_vm.hasBarcode()}}},[_vm._v("I have product barcode number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productbarcodesymbol),expression:"product.productbarcodesymbol"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productbarcodesymbol},attrs:{"type":"text","placeholder":"Enter Barcode Number","disabled":_vm.disabled == 0 ? false : true},domProps:{"value":(_vm.product.productbarcodesymbol)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productbarcodesymbol", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productbarcodesymbol)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.productbarcodesymbol))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-top":"28px"}},[_c('b-form-checkbox',{attrs:{"value":"true","unchecked-value":"false"},model:{value:(_vm.checkboxtk),callback:function ($$v) {_vm.checkboxtk=$$v},expression:"checkboxtk"}},[_vm._v(" Product Track Quantity ")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_save_btn),expression:"show_save_btn"}],staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])],2),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                You have reached the limit of adding Product. Please upgrade your plan to add more Products.\n              ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_barcode_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49620423_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_barcode_vue__ = __webpack_require__(817);
function injectStyle (ssrContext) {
  __webpack_require__(816)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_barcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49620423_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_barcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row no"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Add Product to generate barcode")]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.productnamex,"option-value":"product_id","option-text":"product_name","placeholder":"Search Product"},on:{"searchchange":function($event){_vm.searchprd3($event)},"input":function($event){_vm.onSelect($event)}},model:{value:(_vm.selectproductrow),callback:function ($$v) {_vm.selectproductrow=$$v},expression:"selectproductrow"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-pill",attrs:{"type":"button"},on:{"click":_vm.searchPurchase}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search Purchase")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-striped table-responsive"},[_vm._m(1),_vm._v(" "),(_vm.rows.length != 0)?_c('tbody',_vm._l((_vm.rows),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_c('label',[_vm._v(_vm._s(row.product_name))])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control-sm",class:{'is-invalid':_vm.qtyErr[index]},attrs:{"type":"text"},domProps:{"value":(row.qty)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)},function($event){_vm.check(row.qty,index)}]}}),_c('br'),_vm._v(" "),(_vm.qtyErr[index])?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red","font-weight":"normal"}},[_vm._v(_vm._s(_vm.qtyErr[index]))])]):_vm._e()]),_vm._v(" "),_c('td',[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"color":"#F44336"},on:{"click":function($event){_vm.removeElement(index);}}})])])})):_c('tbody',[_vm._m(2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-form-checkbox',{attrs:{"name":"pname","id":"pname","value":"true","unchecked-value":"false"},on:{"input":function($event){_vm.selectProductName()}}},[_vm._v("Product Name")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"name":"cname","id":"cname","value":"true","unchecked-value":"false"},on:{"input":function($event){_vm.selectCompanyName()}}},[_vm._v("Company Name")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":_vm.generateBarcode}},[_c('i',{staticClass:"fa fa-cog"}),_vm._v(" Generate")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":function($event){_vm.printBarcode()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" Print")])])])])])])]),_vm._v(" "),(_vm.rows1.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"background-color":"white"}},_vm._l((_vm.rows1),function(row,index){return _c('div',{staticClass:"d-inline-flex p-3",attrs:{"id":"id1"}},[_c('div',{staticClass:"p-2 my-flex-item",class:{'page-break':_vm.num == index},staticStyle:{"text-align":"center"}},[_c('barcode',{staticClass:"barcode",attrs:{"options":_vm.options},model:{value:(row.barcode),callback:function ($$v) {_vm.$set(row, "barcode", $$v)},expression:"row.barcode"}}),_vm._v(" "),(_vm.showName==true)?_c('small',{staticStyle:{"position":"relative","top":"-15%","font-size":"12px","font-family":"monospace","font-weight":"normal"}},[_c('br'),_vm._v(_vm._s(row.product_name))]):_vm._e(),_vm._v(" "),(_vm.showCompany==true && _vm.showName==true)?_c('small',{staticStyle:{"position":"relative","top":"-21%","font-size":"12px","font-family":"monospace","font-weight":"normal"}},[_c('br'),_vm._v(_vm._s(_vm.company_name))]):_vm._e(),_vm._v(" "),(_vm.showCompany==true && _vm.showName==false)?_c('small',{staticStyle:{"position":"relative","top":"-15%","font-size":"12px","font-family":"monospace","font-weight":"normal"}},[_c('br'),_vm._v(_vm._s(_vm.company_name))]):_vm._e()],1)])}))]):_vm._e(),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Purchase Items","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.PurchaseItemModal = true}},model:{value:(_vm.PurchaseItemModal),callback:function ($$v) {_vm.PurchaseItemModal=$$v},expression:"PurchaseItemModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase Id")]),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Purchase Id"},model:{value:(_vm.purchase_id),callback:function ($$v) {_vm.purchase_id=$$v},expression:"purchase_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-pill",attrs:{"type":"button"},on:{"click":_vm.submitPurchaseId}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")])])],1)],1),_vm._v(" "),_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows2,"mode":"remote","search-options":{ enabled: false },"select-options":{ enabled: true },"styleClass":"vgt-table striped bordered table-sm condensed","totalRows":_vm.totalRecords,"pagination-options":{enabled: true, perPage: 5}},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-per-page-change":_vm.onPerPageChange,"on-selected-rows-change":function($event){_vm.selectedItems($event)},"on-column-filter":_vm.onColumnFilter},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")]}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary btn-pill pull-right",attrs:{"type":"button"},on:{"click":function($event){_vm.onSave()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add")])])],1)],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v("\n            Product Barcode\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"1%"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"width":"5%"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"3%"}},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{attrs:{"width":"1%"}},[_vm._v("Delete")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"text-align":"center"},attrs:{"colspan":"4"}},[_vm._v("No Records Found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2315fbf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__ = __webpack_require__(820);
function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2315fbf6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Category List\n      "),(_vm.cat_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",staticStyle:{"width":"115px"},attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.openmodel}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Category\n        ")])]):_vm._e()]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasErrors.message1)?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.errorMessage.message1))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"mode":"remote","totalRows":_vm.totalRecords,"styleClass":"vgt-table striped bordered table-sm condensed","rows":_vm.rows,"paginationOptions":{ enabled: true, perPage: 5 }},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'action')?_c('span',[(_vm.cat_rights === true)?_c('span',[(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletecategory(props.row)}}})]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletecategory(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n            ")]):_vm._e()])],1)])],1)],1),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"title_head",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Sub Category\n      "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.cat_view))]),_vm._v(" "),(_vm.cat_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.openmodel1}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Sub Category\n        ")])]):_vm._e()]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasErrors.message)?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.errorMessage.message))])],1):_vm._e()])]),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"styleClass":"vgt-table striped bordered table-sm condensed","rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"paginationOptions":{ enabled: true, perPage: 5 }},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action1')?_c('span',[(_vm.cat_rights === true)?_c('span',[(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro1(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletesubcate(props.row)}}})]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro1(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletesubcate(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"lightblue !important"},on:{"click":function($event){$event.preventDefault();_vm.viewpro1(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n            ")]):_vm._e()])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add Sub Category","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Category "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{class:{ 'is-invalid': _vm.hasErrors.categoryopt },attrs:{"list":_vm.categoryopt,"option-value":"category_name","option-text":"category_name","placeholder":"Select Category"},model:{value:(_vm.Productvalue),callback:function ($$v) {_vm.Productvalue=$$v},expression:"Productvalue"}}),_vm._v(" "),(_vm.hasErrors.categoryopt)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.categoryopt))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category Name "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtsubcategoryname",class:{ 'is-invalid': _vm.hasErrors.subcate },attrs:{"type":"text","placeholder":"Enter Sub Category"},nativeOn:{"blur":function($event){_vm.chkExist('subcat')}},model:{value:(_vm.subcate.name),callback:function ($$v) {_vm.$set(_vm.subcate, "name", $$v)},expression:"subcate.name"}}),_vm._v(" "),(_vm.hasErrors.subcate)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.subcate))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category Description "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.subcate1 },attrs:{"type":"text","placeholder":"Description"},model:{value:(_vm.subcate.description),callback:function ($$v) {_vm.$set(_vm.subcate, "description", $$v)},expression:"subcate.description"}}),_vm._v(" "),(_vm.hasErrors.subcate1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.subcate1))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-button-group',[_c('b-button',{staticClass:"btn btn-sm btn-primary",staticStyle:{"background-color":"#1a94cb","color":"#fff"},attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Save()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Plan Limit Reached","size":"sm","ok-only":""},model:{value:(_vm.plan_modal),callback:function ($$v) {_vm.plan_modal=$$v},expression:"plan_modal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('i',{staticClass:"fa fa-exclamation",staticStyle:{"font-size":"40px","color":"red"}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"10"}},[_c('b-row',[_c('b',[_vm._v("You have hit the plan limit.")])]),_vm._v(" "),_c('b-row',[_vm._v("\n                You have reached the limit of adding Category. Please upgrade your plan to add more Categories.\n              ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add Category","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal1),callback:function ($$v) {_vm.largeModal1=$$v},expression:"largeModal1"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Category Name "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{ref:"txtcategoryname",staticClass:"form-control",class:{ 'is-invalid': _vm.hasErrors.category },attrs:{"type":"text","placeholder":"Enter  Category Name"},nativeOn:{"blur":function($event){_vm.chkExist('cat')}},model:{value:(_vm.category.name),callback:function ($$v) {_vm.$set(_vm.category, "name", $$v)},expression:"category.name"}}),_vm._v(" "),(_vm.hasErrors.category)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.category))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n          Category Description "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.category1 },attrs:{"type":"text","placeholder":"Enter Description"},model:{value:(_vm.category.description),callback:function ($$v) {_vm.$set(_vm.category, "description", $$v)},expression:"category.description"}}),_vm._v(" "),(_vm.hasErrors.category1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.category1))])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-button-group',[_c('b-button',{staticClass:"btn btn-sm btn-primary",staticStyle:{"background":"#1a94cb","color":"#fff"},attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Edit Sub Category ","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal2 = true}},model:{value:(_vm.warningModal2),callback:function ($$v) {_vm.warningModal2=$$v},expression:"warningModal2"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Related Category "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('model-list-select',{class:{ 'is-invalid': _vm.hasErrors.categoryopt2 },attrs:{"list":_vm.categoryopt,"option-value":"category_name","option-text":"category_name","placeholder":"Select Category"},model:{value:(_vm.Productvalue1),callback:function ($$v) {_vm.Productvalue1=$$v},expression:"Productvalue1"}}),_vm._v(" "),(_vm.hasErrors.categoryopt2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.categoryopt2))])]):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category Name "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.subcate2 },attrs:{"type":"text","placeholder":"Enter  SubCategory "},model:{value:(_vm.subcate.name3),callback:function ($$v) {_vm.$set(_vm.subcate, "name3", $$v)},expression:"subcate.name3"}}),_vm._v(" "),(_vm.hasErrors.subcate2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.subcate2))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category Description\n                "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.subcate3 },attrs:{"type":"text","placeholder":" Sub Category Description"},model:{value:(_vm.subcate.description3),callback:function ($$v) {_vm.$set(_vm.subcate, "description3", $$v)},expression:"subcate.description3"}}),_vm._v(" "),(_vm.hasErrors.subcate3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.subcate3))])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.submodel1($event)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n            ")])])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"View Sub Category ","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal4 = true}},model:{value:(_vm.warningModal4),callback:function ($$v) {_vm.warningModal4=$$v},expression:"warningModal4"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Category")]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.categoryopt,"option-value":"category_name","option-text":"category_name","placeholder":"Select Category"},model:{value:(_vm.Productvalue1),callback:function ($$v) {_vm.Productvalue1=$$v},expression:"Productvalue1"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":"","placeholder":"Enter Sub Category"},model:{value:(_vm.subcate.name4),callback:function ($$v) {_vm.$set(_vm.subcate, "name4", $$v)},expression:"subcate.name4"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category Description")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":"","placeholder":" Sub Category Description"},model:{value:(_vm.subcate.description4),callback:function ($$v) {_vm.$set(_vm.subcate, "description4", $$v)},expression:"subcate.description4"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Edit Category","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal1 = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Category Name "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.category2 },attrs:{"type":"text","placeholder":"Enter Category"},model:{value:(_vm.category.name2),callback:function ($$v) {_vm.$set(_vm.category, "name2", $$v)},expression:"category.name2"}}),_vm._v(" "),(_vm.hasErrors.category2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.category2))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Category Description "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{ 'is-invalid': _vm.hasErrors.category3 },attrs:{"type":"text","placeholder":" Category Description"},model:{value:(_vm.category.description3),callback:function ($$v) {_vm.$set(_vm.category, "description3", $$v)},expression:"category.description3"}}),_vm._v(" "),(_vm.hasErrors.category3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.category3)+"\n              ")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.submodel($event)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save\n            ")])])],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brand_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c0d5e5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brand_vue__ = __webpack_require__(822);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brand_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c0d5e5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brand_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[(_vm.errorMessage.message != '')?_c('div',{staticClass:"alert alert-success col-sm-12",attrs:{"data-auto-dismiss":"2000"}},[_vm._v("\n                "+_vm._s(_vm.errorMessage.message)+"\n              ")]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Brand Name:")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Brand Name","name":"brand_name"},model:{value:(_vm.brandData.brandname12),callback:function ($$v) {_vm.$set(_vm.brandData, "brandname12", $$v)},expression:"brandData.brandname12"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Description")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Brand Description"},model:{value:(_vm.brandData.desc12),callback:function ($$v) {_vm.$set(_vm.brandData, "desc12", $$v)},expression:"brandData.desc12"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[(_vm.brand_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getTotals($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")]):_vm._e()])],1)],1)],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Brand List Table "),_c('span',[(_vm.brand_rights === true)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.addbrand()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Brand")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-snotify'),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"styleClass":"vgt-table striped bordered table-sm condensed","paginationOptions":{enabled: true,perPage:5 }},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[(_vm.brand_rights === true)?_c('span',[(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletebrand(props.row)}}})]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editpro(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletebrand(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"lightblue !important"},on:{"click":function($event){$event.preventDefault();_vm.viewbrand(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                    "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n                ")]):_vm._e()])],1)],1)])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add Brand","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Add Brand:"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{ref:"txtbrandname",class:{'is-invalid':_vm.hasErrors.brandnm},attrs:{"type":"text","id":"","placeholder":"Enter Brand Name","name":""},nativeOn:{"keyup":function($event){_vm.onComplete('bname')},"blur":function($event){_vm.chkBrandExist()}},model:{value:(_vm.brandData.brandname),callback:function ($$v) {_vm.$set(_vm.brandData, "brandname", $$v)},expression:"brandData.brandname"}}),_vm._v(" "),(_vm.hasErrors.brandnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.brandnm))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Description")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.branddsc},attrs:{"type":"text","placeholder":"Enter Brand Description"},nativeOn:{"keyup":function($event){_vm.onComplete('bdesc')}},model:{value:(_vm.brandData.desc),callback:function ($$v) {_vm.$set(_vm.brandData, "desc", $$v)},expression:"brandData.desc"}}),_vm._v(" "),(_vm.hasErrors.branddsc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.branddsc))])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Logo :")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.brandlogo},attrs:{"type":"file","id":"image","name":"image","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.brandlogo)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.brandlogo))])]):_vm._e()])],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-button-group',[_c('b-button',{staticClass:"d-sm-down-none btn-sm",attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.brandPost()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Edit Brand","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal1 = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Name "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.brandnm1},attrs:{"type":"text","placeholder":"Enter Brand Name","name":"brand_name"},nativeOn:{"keyup":function($event){_vm.onComplete('editbname')}},model:{value:(_vm.brandData.brandname1),callback:function ($$v) {_vm.$set(_vm.brandData, "brandname1", $$v)},expression:"brandData.brandname1"}}),_vm._v(" "),(_vm.hasErrors.brandnm1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.brandnm1))])]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Description "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.branddsc1},attrs:{"type":"text","placeholder":"Enter Brand Description"},nativeOn:{"keyup":function($event){_vm.onComplete('editbdesc')}},model:{value:(_vm.brandData.desc1),callback:function ($$v) {_vm.$set(_vm.brandData, "desc1", $$v)},expression:"brandData.desc1"}}),_vm._v(" "),(_vm.hasErrors.branddsc1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors.branddsc1))])]):_vm._e()],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Logo :")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.brandlogo1},attrs:{"type":"file","id":"image1","name":"image1","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.brandlogo1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.brandlogo1))])]):_vm._e(),_vm._v(" "),(_vm.brandData.image1!=null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.brandData.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[(_vm.brandData.image1!=null)?_c('span',[_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.brandData.image1_href,"width":"250px","height":"250px"}})]):_vm._e()])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"modal_footer card-footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.submodel($event)}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"View Brand","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal2 = true}},model:{value:(_vm.warningModal2),callback:function ($$v) {_vm.warningModal2=$$v},expression:"warningModal2"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Name")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.brandnm1},attrs:{"type":"text","placeholder":"Enter Brand Name","disabled":"","name":"brand_name"},nativeOn:{"keyup":function($event){_vm.onComplete('editbname')}},model:{value:(_vm.brandData.brandname1),callback:function ($$v) {_vm.$set(_vm.brandData, "brandname1", $$v)},expression:"brandData.brandname1"}})],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Description")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.branddsc1},attrs:{"type":"text","disabled":"","placeholder":"Enter Brand Description"},nativeOn:{"keyup":function($event){_vm.onComplete('editbdesc')}},model:{value:(_vm.brandData.desc1),callback:function ($$v) {_vm.$set(_vm.brandData, "desc1", $$v)},expression:"brandData.desc1"}})],1),_vm._v(" "),_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand Logo :")]),_vm._v(" "),(_vm.brandData.image1!=null)?_c('p',[_vm._v("Click to view uploaded Image/File "),_c('a',{attrs:{"href":_vm.brandData.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[(_vm.brandData.image1!=null)?_c('span',[_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.brandData.image1_href,"width":"250px","height":"250px"}})]):_vm._e()])],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Brand")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HSN_vue__ = __webpack_require__(410);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc102d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HSN_vue__ = __webpack_require__(825);
function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HSN_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc102d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HSN_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hsn_rights === true)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.hsn_view))]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v("Add "+_vm._s(_vm.hsnLabel))])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('div',{staticClass:"row error_msg"},[(_vm.message.sucess!='')?_c('div',{staticClass:"col-sm-12 alert alert-success ",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.message.sucess))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.hsnCodeLabel)+" : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txthsnid",staticClass:"form-control",class:{'is-invalid':_vm.error.errorhsn},attrs:{"type":"text","placeholder":'Enter ' + _vm.hsnLabel + ' Id'},nativeOn:{"blur":function($event){_vm.chkExist()}},model:{value:(_vm.hsnid),callback:function ($$v) {_vm.hsnid=$$v},expression:"hsnid"}}),_vm._v(" "),(_vm.error.errorhsn)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorhsn))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax: "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.taxlist2,"option-value":"tax_id","option-text":"tax_name","placeholder":"Select Tax"},model:{value:(_vm.selectedtax2),callback:function ($$v) {_vm.selectedtax2=$$v},expression:"selectedtax2"}}),_vm._v(" "),(_vm.error.errortx)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Please Select Tax Id")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Chapter Code : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsncode),expression:"hsncode"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Chapter Code Name"},domProps:{"value":(_vm.hsncode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsncode=$event.target.value}}}),_vm._v(" "),(_vm.error.errorhsncd)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Numeric Value")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.hsnLabel)+" Description : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsndsc),expression:"hsndsc"}],staticClass:"form-control",attrs:{"type":"text","placeholder":'Enter ' + _vm.hsnLabel + ' Description'},domProps:{"value":(_vm.hsndsc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsndsc=$event.target.value}}}),_vm._v(" "),(_vm.error.errordes)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter "+_vm._s(_vm.hsnLabel)+" Description")])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.savehsn()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])])])],1)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v(_vm._s(_vm.hsnLabel)+" List Table")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","pagination-options":{
                  enabled: true,
                  perPage: 5,
                              },"totalRows":_vm.totalRecords,"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[(_vm.hsn_rights === true)?_c('span',[(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.edithsn(props.row)}}}),_vm._v(" "),(props.row.isAssociated)?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:('Cannot delete — this tax rate is linked to one or more products.'),expression:"'Cannot delete — this tax rate is linked to one or more products.'",modifiers:{"hover":true}}],staticClass:"fa fa-trash",staticStyle:{"color":"lightgrey","pointer-events":"none"}})]):_c('span',[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletehsn(props.row)}}})])]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.edithsn(props.row)}}}),_vm._v(" "),(props.row.isAssociated)?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:('Cannot delete — this tax rate is linked to one or more products.'),expression:"'Cannot delete — this tax rate is linked to one or more products.'",modifiers:{"hover":true}}],staticClass:"fa fa-trash",staticStyle:{"color":"lightgrey","pointer-events":"none"}})]):_c('span',[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletehsn(props.row)}}})])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"lightblue !important"},on:{"click":function($event){$event.preventDefault();_vm.viewhsn(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")])]}}])})],1)])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":'Edit ' + _vm.hsnLabel,"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = false}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.hsnLabel)+" ID : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsnided),expression:"hsnided"}],staticClass:"form-control",attrs:{"type":"text","placeholder":'Enter ' + _vm.hsnLabel + ' Id'},domProps:{"value":(_vm.hsnided)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsnided=$event.target.value}}}),_vm._v(" "),(_vm.error.errorhsned)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Numeric Value")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax ID : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.taxlist1,"option-value":"tax_id","option-text":"tax_name","placeholder":"Select Tax"},model:{value:(_vm.selectedtax1),callback:function ($$v) {_vm.selectedtax1=$$v},expression:"selectedtax1"}}),_vm._v(" "),(_vm.error.errortxed)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Please Select Tax")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Chapter Code : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsncodeed),expression:"hsncodeed"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Chapter Code Name"},domProps:{"value":(_vm.hsncodeed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsncodeed=$event.target.value}}}),_vm._v(" "),(_vm.error.errorhsncded)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Numeric Value")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.hsnLabel)+" Description : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsndsced),expression:"hsndsced"}],staticClass:"form-control",attrs:{"type":"text","placeholder":'Enter ' + _vm.hsnLabel + ' Description'},domProps:{"value":(_vm.hsndsced)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsndsced=$event.target.value}}}),_vm._v(" "),(_vm.error.errordesed)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter "+_vm._s(_vm.hsnLabel)+" Description")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.savehsned()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":'View ' + _vm.hsnLabel,"no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal1 = false}},model:{value:(_vm.warningModal1),callback:function ($$v) {_vm.warningModal1=$$v},expression:"warningModal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.hsnLabel)+" ID :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsnided),expression:"hsnided"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":'Enter ' + _vm.hsnLabel + ' Id'},domProps:{"value":(_vm.hsnided)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsnided=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax ID :")]),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.taxlist1,"isDisabled":true,"option-value":"tax_id","option-text":"tax_name","placeholder":"Select Tax"},model:{value:(_vm.selectedtax1),callback:function ($$v) {_vm.selectedtax1=$$v},expression:"selectedtax1"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Chapter Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsncodeed),expression:"hsncodeed"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":"Enter Chapter Code Name"},domProps:{"value":(_vm.hsncodeed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsncodeed=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.hsnLabel)+" Description :")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.hsndsced),expression:"hsndsced"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":'Enter ' + _vm.hsnLabel + ' Description'},domProps:{"value":(_vm.hsndsced)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hsndsced=$event.target.value}}})])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hsnrate_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_281ea0b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hsnrate_vue__ = __webpack_require__(828);
function injectStyle (ssrContext) {
  __webpack_require__(827)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hsnrate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_281ea0b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hsnrate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tax_rights === true)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.sucess!='')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.sucess))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Name "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txttaxname",staticClass:"form-control",class:{'is-invalid':_vm.error.errorname},attrs:{"type":"text","placeholder":"Enter Tax Name"},nativeOn:{"blur":function($event){_vm.chkExist()}},model:{value:(_vm.taxname),callback:function ($$v) {_vm.taxname=$$v},expression:"taxname"}}),_vm._v(" "),(_vm.error.errorname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorname))])]):_vm._e()],1)]),_vm._v(" "),(_vm.companyTaxType === 'US')?[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales Tax In %  "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxigst),expression:"taxigst"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Sales Tax In %"},domProps:{"value":(_vm.taxigst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxigst=$event.target.value}}}),_vm._v(" "),(_vm.error.errorigst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorigst))])]):_vm._e()])])]:[_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("SGST In %  "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxsgst),expression:"taxsgst"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter SGST In %"},domProps:{"value":(_vm.taxsgst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxsgst=$event.target.value}}}),_vm._v(" "),(_vm.error.errorsgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorsgst))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CGST In %  "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxcgst),expression:"taxcgst"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter CGST In %"},domProps:{"value":(_vm.taxcgst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxcgst=$event.target.value}}}),_vm._v(" "),(_vm.error.errorcgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorcgst))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IGST In %  "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxigst),expression:"taxigst"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter IGST In %"},domProps:{"value":(_vm.taxigst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxigst=$event.target.value}}}),_vm._v(" "),(_vm.error.errorigst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorigst))])]):_vm._e()])])]],2)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.savehsnrate()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])])])],1)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v(_vm._s(_vm.companyTaxType === 'US' ? 'US Code Rate List Table' : 'HSN Rate List Table')),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.tax_view))])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","pagination-options":{
                  enabled: true,
                  perPage: 5,
                              },"totalRows":_vm.totalRecords,"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[(_vm.tax_rights === true)?_c('span',[(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.edithsnrate(props.row)}}}),_vm._v(" "),(props.row.isAssociated)?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:('Cannot delete — this tax rate is linked to one or more products.'),expression:"'Cannot delete — this tax rate is linked to one or more products.'",modifiers:{"hover":true}}],staticClass:"fa fa-trash",staticStyle:{"color":"lightgrey","pointer-events":"none"}})]):_c('span',[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletehsnrate(props.row)}}})])]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.edithsnrate(props.row)}}}),_vm._v(" "),(props.row.isAssociated)?_c('span',[_c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:('Cannot delete — this tax rate is linked to one or more products.'),expression:"'Cannot delete — this tax rate is linked to one or more products.'",modifiers:{"hover":true}}],staticClass:"fa fa-trash",staticStyle:{"color":"lightgrey","pointer-events":"none"}})]):_c('span',[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletehsnrate(props.row)}}})])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")])]}}])})],1)])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Edit Tax","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = false}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('div',{staticClass:"row"},[(_vm.message.sucess!='')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.message.sucess))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax Name : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxnameed),expression:"taxnameed"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Tax Name"},domProps:{"value":(_vm.taxnameed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxnameed=$event.target.value}}}),_vm._v(" "),(_vm.error.errornameed)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errornameed))])]):_vm._e()])]),_vm._v(" "),(_vm.companyTaxType === 'US')?[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales Tax : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxigsted),expression:"taxigsted"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter Sales Tax"},domProps:{"value":(_vm.taxigsted)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxigsted=$event.target.value}}}),_vm._v(" "),(_vm.error.errorigsted)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorigsted))])]):_vm._e()])])]:[_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("SGST : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxsgsted),expression:"taxsgsted"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter SGST"},domProps:{"value":(_vm.taxsgsted)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxsgsted=$event.target.value}}}),_vm._v(" "),(_vm.error.errorsgsted)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorsgsted))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CGST : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxcgsted),expression:"taxcgsted"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter CGST"},domProps:{"value":(_vm.taxcgsted)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxcgsted=$event.target.value}}}),_vm._v(" "),(_vm.error.errorcgsted)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorcgsted))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IGST : "),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taxigsted),expression:"taxigsted"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter IGST"},domProps:{"value":(_vm.taxigsted)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taxigsted=$event.target.value}}}),_vm._v(" "),(_vm.error.errorigsted)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorigsted))])]):_vm._e()])])]],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.savehsnrateed()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v("Add Tax")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_variant_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5279d1b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_variant_vue__ = __webpack_require__(830);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_variant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5279d1b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_variant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Variant Name","name":"variant_name"},model:{value:(_vm.search_varname),callback:function ($$v) {_vm.search_varname=$$v},expression:"search_varname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[(_vm.var_view === true)?_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"2px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getvariant($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search")]):_vm._e()])],1)],1)],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_vm._v("\nVariant List Table"),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.var_view))]),_vm._v(" "),(_vm.var_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.addVariant()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Variant")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.sucess!='')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.sucess))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{
  enabled: true,
  perPage: 5,
},"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'variant_name1')?_c('span',[(props.row.variant_id==_vm.varianteditid)?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vnnameed),expression:"vnnameed"}],staticClass:"form-control",attrs:{"type":"text","name":"variant_id","placeholder":"Enter Variant Value"},domProps:{"value":(_vm.vnnameed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.vnnameed=$event.target.value}}})]):_c('span',[_vm._v(" \n"+_vm._s(props.row.variant_name)+"\n")])]):_vm._e(),_vm._v(" "),(props.column.field == 'viewdtl')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){$event.preventDefault();_vm.viewvalue(props.row)}}})]):_vm._e(),_vm._v(" "),(props.column.field == 'action')?_c('span',[(_vm.var_rights === true)?_c('span',[(_vm.varianteditid==props.row.variant_id)?_c('span',[_c('i',{staticClass:"fa fa-save",on:{"click":function($event){$event.preventDefault();_vm.editvariantvalue(props.row)}}})]):_c('span',[(props.row.company_id !== 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editvn(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletevn(props.row)}}})]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editvn(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletevn(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n"+_vm._s(props.formattedRow[props.column.field])+"\n")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n")]):_vm._e()]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add Variant","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Variant Name :"),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtvnname",staticClass:"form-control",class:{'is-invalid':_vm.error.errorname},attrs:{"type":"text","name":"variant_id","placeholder":"Enter Variant Name"},model:{value:(_vm.vnname),callback:function ($$v) {_vm.vnname=$$v},expression:"vnname"}}),_vm._v(" "),(_vm.error.errorname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorname))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.savevn()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Variant Value","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal1 = false}},model:{value:(_vm.largeModal1),callback:function ($$v) {_vm.largeModal1=$$v},expression:"largeModal1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.sucess1!='')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.sucess1))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-sm-2 col-form-label"},[_vm._v("Variant Name:-")]),_vm._v(" "),_c('label',{staticClass:"col-sm-10 col-form-label"},[_vm._v(_vm._s(_vm.variantname))])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"22px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"name"}},[_vm._v("Variant Value :"),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('b-form-input',{ref:"txtvnvalue",staticClass:"form-control",class:{'is-invalid':_vm.error.errorvalue},attrs:{"type":"text","name":"variant_id","placeholder":"Enter Variant Value (eg. Red)"},model:{value:(_vm.vnaddvalue),callback:function ($$v) {_vm.vnaddvalue=$$v},expression:"vnaddvalue"}}),_vm._v(" "),(_vm.error.errorvalue)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.error.errorvalue))])]):_vm._e()],1),_vm._v(" "),(_vm.var_rights === true)?_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-pill btn-primary",staticStyle:{"border-radius":"15px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addvalue($event)}}},[_vm._v("Add Value")])]):_vm._e()])])]),_vm._v(" "),_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{enabled: true,
  perPage: 10},"styleClass":"vgt-table striped bordered table-sm condensed","lineNumbers":true},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'viewdtl')?_c('span',[(_vm.editvalue==props.row.id)?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vnaddvalueed),expression:"vnaddvalueed"}],staticClass:"form-control",staticStyle:{"width":"170px"},attrs:{"type":"text","name":"variant_id","placeholder":"Enter Variant Id"},domProps:{"value":(_vm.vnaddvalueed)},on:{"input":function($event){if($event.target.composing){ return; }_vm.vnaddvalueed=$event.target.value}}})]):_c('span',[_vm._v("\n  "+_vm._s(props.row.variant_value)+"\n  ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'action')?_c('span',[(_vm.var_rights === true)?_c('span',[(_vm.editvalue==props.row.id)?_c('span',[_c('i',{staticClass:"fa fa-save",on:{"click":function($event){$event.preventDefault();_vm.saveedvalue(props.row)}}})]):_c('span',[(props.row.company_id != 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editvnvalue(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletevnvalue(props.row)}}})]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editvnvalue(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deletevnvalue(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n  "+_vm._s(props.formattedRow[props.column.field])+"\n  ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("Loading\n  ")]):_vm._e()])],1)],1)])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search Variant")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unit_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399ab559_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unit_vue__ = __webpack_require__(832);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399ab559_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.success!='')?_c('div',{staticClass:"alert alert-success"},[_c('i',{staticClass:"fa fa-check fa-icons"}),_vm._v(" "+_vm._s(_vm.message.success)+"\n      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',[_c('span',{staticClass:"title_head"},[_vm._v("Unit List Table"),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}]},[_vm._v(_vm._s(_vm.unit_view))])]),_vm._v(" "),(_vm.unit_rights === true)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button","unit":"secondary"},on:{"click":function($event){_vm.openmodel()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Unit")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{
                  enabled: true,
                  perPage: 5,
                              },"styleClass":"vgt-table striped bordered table-sm condensed","lineNumbers":true},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'action')?_c('span',[(_vm.unit_rights === true)?_c('span',[(props.row.company_id != 'I2OCGLB')?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editunit(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deleteunit(props.row)}}})]):_c('span',[(_vm.is_admin === true)?_c('span',[_c('i',{staticClass:"fa fa-edit",on:{"click":function($event){$event.preventDefault();_vm.editunit(props.row)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deleteunit(props.row)}}})]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])])]):_c('span',[_c('i',{staticClass:"fa fa-edit",staticStyle:{"color":"grey !important"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"grey !important"}})])]):_c('span',[_vm._v("\n                    "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")])]}}])},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading\n                ")]):_vm._e()]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add Unit","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Unit Name :"),_c('span',{staticClass:"star"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtunitname",staticClass:"form-control",class:{'is-invalid' :_vm.message.unit_name1},attrs:{"type":"text","placeholder":"Enter Unit Name"},nativeOn:{"blur":function($event){_vm.onComplete('uname')}},model:{value:(_vm.unit_name1),callback:function ($$v) {_vm.unit_name1=$$v},expression:"unit_name1"}}),_vm._v(" "),(_vm.message.unit_name1!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.message.unit_name1))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Unit Description :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.unit_desc1),expression:"unit_desc1"}],staticClass:"form-control",class:{'is-invalid' :_vm.message.unit_desc1},attrs:{"type":"text","placeholder":"Enter Unit Description"},domProps:{"value":(_vm.unit_desc1)},on:{"keyup":function($event){_vm.onComplete('udesc')},"input":function($event){if($event.target.composing){ return; }_vm.unit_desc1=$event.target.value}}}),_vm._v(" "),(_vm.message.unit_desc1!='')?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.message.unit_desc1))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[(_vm.saveBtn)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]):_vm._e(),_vm._v(" "),(_vm.editBtn)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.edit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]):_vm._e()])])],1)])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_mgmt_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee75f2c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_mgmt_vue__ = __webpack_require__(834);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_mgmt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee75f2c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_mgmt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('b-card-body',[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Username","name":"username"},model:{value:(_vm.search_uname),callback:function ($$v) {_vm.search_uname=$$v},expression:"search_uname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"2px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getuser($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                  ")])])],1)],1)],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_vm._v("User's List")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-select',{on:{"change":_vm.typechange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"verified"}},[_vm._v("Verified")]),_vm._v(" "),_c('option',{attrs:{"value":"not_verified"}},[_vm._v("Not Verified")])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.sucess != '')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.sucess))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-column-filter":_vm.onColumnFilter,"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_vm._v("\n                  "+_vm._s(props.formattedRow[props.column.field])+"\n                ")]}}])})],1)])])])])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search User")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_status_info_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254f03bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_status_info_vue__ = __webpack_require__(836);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_status_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_254f03bd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_status_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message != '')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v("\n                "+_vm._s(_vm.haserror.message)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"srch_uname"}},[_vm._v(" Username ")]),_c('br'),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter Username","name":"srch_uname","id":"srch_uname"},model:{value:(_vm.search_uname),callback:function ($$v) {_vm.search_uname=$$v},expression:"search_uname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"user_status"}},[_vm._v("Status ")]),_c('br'),_vm._v(" "),_c('b-form-select',{attrs:{"name":"user_status","id":"user_status"},on:{"change":_vm.statuschange},model:{value:(_vm.selected_status),callback:function ($$v) {_vm.selected_status=$$v},expression:"selected_status"}},[_c('option',{attrs:{"value":"all"}},[_vm._v("All")]),_vm._v(" "),_c('option',{attrs:{"value":"active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"locked"}},[_vm._v("Locked")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"22px","position":"absolute"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.getuser($event)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n                ")])])],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_vm._v("User's List")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('a',{staticStyle:{"color":"#1b8eb7","font-size":"14px","cursor":"pointer"},on:{"click":_vm.inactive_user_list}},[_vm._v("View Inactive User")]),_vm._v("  \n                  "),_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){_vm.lockuser('lock')}}},[_vm._v("\n                    Lock")]),_vm._v("  "),_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){_vm.lockuser('unlock')}}},[_vm._v("\n                    Unlock")]),_vm._v("  "),_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){_vm.show_plan()}}},[_vm._v("\n                    Change Plan\n                  ")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.sucess != '')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.sucess))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"select-options":{
                  enabled: true,
                },"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-column-filter":_vm.onColumnFilter,"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'user_status')?_c('span',[(props.row.status === true)?_c('span',[_c('span',{staticClass:"badge badge-success"},[_vm._v("Active")])]):_c('span',[(props.row.locked === true)?_c('span',[_c('span',{staticClass:"badge badge-danger"},[_vm._v("Locked")])]):_c('span',[_c('span',{staticClass:"badge badge-secondary"},[_vm._v("Inactive")])])])]):_c('span',[_vm._v("\n                    "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")])]}}])})],1)])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Inactive User Accounts","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'user_status')?_c('span',[_c('span',{staticClass:"badge badge-secondary"},[_vm._v("Inactive")])]):(props.column.field == 'plan_type')?_c('span',[_vm._v("\n            "+_vm._s(_vm.plan_dt[parseInt(props.row.plan_type)].plan_label)+"\n          ")]):_c('span',[_vm._v("\n            "+_vm._s(props.formattedRow[props.column.field])+"\n          ")])]}}])})],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Select Plan","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.planModal = true}},model:{value:(_vm.planModal),callback:function ($$v) {_vm.planModal=$$v},expression:"planModal"}},[_c('b-collapse',{attrs:{"id":"collapse3","visible":""}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Choose Plan")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"free","name":"selplan"},domProps:{"value":_vm.plan_dt[0].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[0].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[0].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[0].plan_label)+"\n                  \n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"basic","name":"selplan"},domProps:{"value":_vm.plan_dt[1].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[1].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[1].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[1].plan_label)+"\n                  \n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"standard","name":"selplan"},domProps:{"value":_vm.plan_dt[2].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[2].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[2].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[2].plan_label)+"\n                  \n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selplan),expression:"selplan"}],attrs:{"type":"radio","id":"professional","name":"selplan"},domProps:{"value":_vm.plan_dt[3].plan_type,"checked":_vm._q(_vm.selplan,_vm.plan_dt[3].plan_type)},on:{"change":function($event){_vm.selplan=_vm.plan_dt[3].plan_type}}}),_vm._v(" "+_vm._s(_vm.plan_dt[3].plan_label)+"\n            ")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":_vm.plan_select}},[_vm._v("\n              Submit\n            ")])])],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search User")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_plan_config_vue__ = __webpack_require__(416);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2146e0e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plan_config_vue__ = __webpack_require__(842);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_plan_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2146e0e9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plan_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"title_head"},[_c('div',{staticClass:"col-sm-10"},[_vm._v("\n               I2OC Plan  \n                "),( false)?_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.addplan()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add Plan")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.message.success !== '')?_c('div',{staticClass:"alert alert-success"},[_c('center',[_vm._v(_vm._s(_vm.message.success))])],1):_vm._e(),_vm._v(" "),(_vm.message.fail !== '')?_c('div',{staticClass:"alert alert-danger",staticStyle:{"color":"#242020"}},[_c('center',[_vm._v(_vm._s(_vm.message.fail))])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"sort-options":{enabled: true},"pagination-options":{ enabled: false},"styleClass":"vgt-table striped bordered table-sm condensed"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'type')?_c('span',[(props.row['type'] === 'plan_type')?_c('span',[_c('span',[_vm._v("Action")])]):_c('span',[_vm._v("\n                          "+_vm._s(props.formattedRow[props.column.field])+"\n                      ")])]):(props.column.field === 'Free Basic')?_c('span',[(props.row.type === 'Shop Count')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'User Count')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'E-Commerce Integration')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'GST Report')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Report')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Sales')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Purchase')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Barcode')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Invoice')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Category Count')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Product Count')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Customer Count')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Supplier Count')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Desktop Application')?_c('span',[(props.row['Free Basic'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'plan_type')?_c('span',[(props.row['Free Basic'] === '0')?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":function($event){_vm.edit_plan(props.row['Free Basic'])}}},[_vm._v("Edit")])]):_vm._e()]):_c('span',[_vm._v("\n                          "+_vm._s(props.formattedRow[props.column.field])+"\n                      ")])]):(props.column.field === 'Standard')?_c('span',[(props.row.type === 'Shop Count')?_c('span',[(props.row['Standard'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'User Count')?_c('span',[(props.row['Standard'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'E-Commerce Integration')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'GST Report')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Report')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Sales')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Purchase')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Barcode')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Invoice')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Category Count')?_c('span',[(props.row['Standard'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Product Count')?_c('span',[(props.row['Standard'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Customer Count')?_c('span',[(props.row['Standard'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Supplier Count')?_c('span',[(props.row['Standard'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Desktop Application')?_c('span',[(props.row['Standard'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'plan_type')?_c('span',[(props.row['Standard'] === '1')?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":function($event){_vm.edit_plan(props.row['Standard'])}}},[_vm._v("Edit")])]):_vm._e()]):_c('span',[_vm._v("\n                          "+_vm._s(props.formattedRow[props.column.field])+"\n                      ")])]):(props.column.field === 'Professional')?_c('span',[(props.row.type === 'Shop Count')?_c('span',[(props.row['Professional'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'User Count')?_c('span',[(props.row['Professional'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'E-Commerce Integration')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'GST Report')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Report')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Sales')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Purchase')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Barcode')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Invoice')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Category Count')?_c('span',[(props.row['Professional'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Product Count')?_c('span',[(props.row['Professional'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Customer Count')?_c('span',[(props.row['Professional'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Supplier Count')?_c('span',[(props.row['Professional'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Desktop Application')?_c('span',[(props.row['Professional'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'plan_type')?_c('span',[(props.row['Professional'] === '2')?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":function($event){_vm.edit_plan(props.row['Professional'])}}},[_vm._v("Edit")])]):_vm._e()]):_c('span',[_vm._v("\n                          "+_vm._s(props.formattedRow[props.column.field])+"\n                      ")])]):(props.column.field === 'Premium')?_c('span',[(props.row.type === 'Shop Count')?_c('span',[(props.row['Premium'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'User Count')?_c('span',[(props.row['Premium'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'E-Commerce Integration')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'GST Report')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Report')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Sales')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Purchase')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Barcode')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Invoice')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'Category Count')?_c('span',[(props.row['Premium'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Product Count')?_c('span',[(props.row['Premium'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Customer Count')?_c('span',[(props.row['Premium'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Supplier Count')?_c('span',[(props.row['Premium'] === '0')?_c('span',[_c('span',[_vm._v("Unlimited")])]):_c('span',[_vm._v("\n                              "+_vm._s(props.formattedRow[props.column.field])+"        \n                          ")])]):(props.row.type === 'Desktop Application')?_c('span',[(props.row['Premium'] === true)?_c('span',[_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green","font-size":"17px"},attrs:{"aria-hidden":"true"}})]):_c('span',[_c('i',{staticClass:"fa fa-times",staticStyle:{"color":"red","font-size":"17px"},attrs:{"aria-hidden":"true"}})])]):(props.row.type === 'plan_type')?_c('span',[(props.row['Premium'] === '3')?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary btn-pill",attrs:{"type":"button"},on:{"click":function($event){_vm.edit_plan(props.row['Premium'])}}},[_vm._v("Edit")])]):_vm._e()]):_c('span',[_vm._v("\n                          "+_vm._s(props.formattedRow[props.column.field])+"\n                      ")])]):_c('span',[_vm._v("\n                      "+_vm._s(props.formattedRow[props.column.field])+"\n                  ")])]}}])})],1)])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Edit Plan","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Plan Label"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtplanlabel",class:{'is-invalid':_vm.hasErrors.plan_label},attrs:{"type":"text","disabled":"","autocomplete":"off","placeholder":"Enter Plan Label"},model:{value:(_vm.plan.plan_label),callback:function ($$v) {_vm.$set(_vm.plan, "plan_label", $$v)},expression:"plan.plan_label"}}),_vm._v(" "),(_vm.hasErrors.plan_label)?_c('small',{staticClass:"form-text text-muted"},[_vm._v("Required")]):_vm._e()],1)]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Count"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtshopcount",class:{'is-invalid':_vm.hasErrors.shop_count},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Shop Count"},model:{value:(_vm.plan.shop_count),callback:function ($$v) {_vm.$set(_vm.plan, "shop_count", $$v)},expression:"plan.shop_count"}}),_vm._v(" "),(_vm.hasErrors.shop_count)?_c('small',{staticClass:"form-text text-muted"}):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("User Count"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.user_count},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter User Count"},model:{value:(_vm.plan.user_count),callback:function ($$v) {_vm.$set(_vm.plan, "user_count", $$v)},expression:"plan.user_count"}}),_vm._v(" "),(_vm.hasErrors.user_count)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Invalid")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("E-Commerce Integration")]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.ecom_int),callback:function ($$v) {_vm.$set(_vm.plan, "ecom_int", $$v)},expression:"plan.ecom_int"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Invoice")]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.invoice),callback:function ($$v) {_vm.$set(_vm.plan, "invoice", $$v)},expression:"plan.invoice"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Report "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.gst_report),callback:function ($$v) {_vm.$set(_vm.plan, "gst_report", $$v)},expression:"plan.gst_report"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Report "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.report),callback:function ($$v) {_vm.$set(_vm.plan, "report", $$v)},expression:"plan.report"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Desktop Application"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.desktop_app),callback:function ($$v) {_vm.$set(_vm.plan, "desktop_app", $$v)},expression:"plan.desktop_app"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Category Count"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.cat_count},attrs:{"type":"text","autocomplete":"off","placeholder":"Category Count"},model:{value:(_vm.plan.cat_count),callback:function ($$v) {_vm.$set(_vm.plan, "cat_count", $$v)},expression:"plan.cat_count"}}),_vm._v(" "),(_vm.hasErrors.cat_count)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Invalid")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Count"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.prod_count},attrs:{"type":"text","autocomplete":"off","placeholder":"Product Count"},model:{value:(_vm.plan.prod_count),callback:function ($$v) {_vm.$set(_vm.plan, "prod_count", $$v)},expression:"plan.prod_count"}}),_vm._v(" "),(_vm.hasErrors.prod_count)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Invalid")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Count"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.cust_count},attrs:{"type":"text","autocomplete":"off","placeholder":"Customer Count"},model:{value:(_vm.plan.cust_count),callback:function ($$v) {_vm.$set(_vm.plan, "cust_count", $$v)},expression:"plan.cust_count"}}),_vm._v(" "),(_vm.hasErrors.cust_count)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Invalid")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Count"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supp_count},attrs:{"type":"text","autocomplete":"off","placeholder":"Supplier Count"},model:{value:(_vm.plan.supp_count),callback:function ($$v) {_vm.$set(_vm.plan, "supp_count", $$v)},expression:"plan.supp_count"}}),_vm._v(" "),(_vm.hasErrors.supp_count)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Invalid")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sales"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.sales),callback:function ($$v) {_vm.$set(_vm.plan, "sales", $$v)},expression:"plan.sales"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Purchase"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.purchase),callback:function ($$v) {_vm.$set(_vm.plan, "purchase", $$v)},expression:"plan.purchase"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"name"}},[_vm._v("Barcode"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.plan.barcode),callback:function ($$v) {_vm.$set(_vm.plan, "barcode", $$v)},expression:"plan.barcode"}},[_c('option',{attrs:{"value":"true"}},[_vm._v("Allowed")]),_vm._v(" "),_c('option',{attrs:{"value":"false"}},[_vm._v("Not Allowed")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Cost"),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.cost},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Plan Cost"},model:{value:(_vm.plan.cost),callback:function ($$v) {_vm.$set(_vm.plan, "cost", $$v)},expression:"plan.cost"}}),_vm._v(" "),(_vm.hasErrors.cost)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Invalid")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}})],1),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.update()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v("  Update")])])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pending_pay_list_vue__ = __webpack_require__(417);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da2e9bc2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_pay_list_vue__ = __webpack_require__(844);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pending_pay_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da2e9bc2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_pay_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search")]),_vm._v(" "),(_vm.sale_view === true)?_c('span'):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.haserror.message != '')?_c('div',{staticClass:"col-sm-12 alert alert-success",staticStyle:{"text-align":"center"}},[_vm._v("\n              "+_vm._s(_vm.haserror.message)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('b-row',[(_vm.is_admin === true)?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompany($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Please select company")])])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Name : ")]),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.customerlist,"option-value":"customer_id","option-text":"cust_cmp_name","placeholder":"Search Customer"},on:{"searchchange":function($event){_vm.searchcustomer($event)}},model:{value:(_vm.selectcustomer),callback:function ($$v) {_vm.selectcustomer=$$v},expression:"selectcustomer"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Shop ")]),_c('br'),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.searchlist}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v("\n                          \n                \n              "),_c('div',{staticClass:"col-sm-1"},[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.exportData()}}},[_c('i',{}),_vm._v(" Export Data\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){$event.preventDefault();_vm.view_detail(props.row)}}})]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Summary of Supplier Balance Amount ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1}})],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-10"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" List of Customers Whose\n                Payment is Pending\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pending_pay_list_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc6f262_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_pay_list_vue__ = __webpack_require__(846);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pending_pay_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc6f262_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pending_pay_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"title_head"},[_vm._v("Search")]),_vm._v(" "),(_vm.pur_view === true)?_c('span'):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-row',[(_vm.is_admin === true)?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"Company List"}},[_vm._v(" Company List ")]),_c('br'),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.companylist,"option-value":"company_id","option-text":"company_name","placeholder":"Search Company Name"},on:{"searchchange":function($event){_vm.searchcompany($event)},"input":function($event){_vm.onSelectCompany($event)}},model:{value:(_vm.selectcompany),callback:function ($$v) {_vm.selectcompany=$$v},expression:"selectcompany"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Please select company")])])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name : ")]),_vm._v(" "),_c('model-list-select',{staticClass:"product-drop",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"30px !important","border":"1px solid rgb(194, 207, 214)","min-height":"30px","border-radius":"1px","padding-top":"6px"},attrs:{"list":_vm.supplierlist,"option-value":"supplier_id","option-text":"sup_cmp_name","placeholder":"Search Supplier"},on:{"searchchange":function($event){_vm.searchsupplier($event)}},model:{value:(_vm.selectsupplier),callback:function ($$v) {_vm.selectsupplier=$$v},expression:"selectsupplier"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Select Shop ")]),_c('br'),_vm._v(" "),_c('model-list-select',{attrs:{"list":_vm.shopname,"option-value":"est_shop_id","option-text":"est_shop_name","placeholder":"Select Shop"},model:{value:(_vm.selectshop),callback:function ($$v) {_vm.selectshop=$$v},expression:"selectshop"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('button',{staticClass:"btn btn-pill btn-primary serach_bttn",staticStyle:{"margin-top":"24px","margin-left":"16%"},attrs:{"type":"button"},on:{"click":_vm.searchlist}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Search\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v("\n                          \n                \n              "),_c('div',{staticClass:"col-sm-1"},[_c('button',{staticClass:"btn btn-sm btn-primary label_bttn",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.exportData()}}},[_c('i',{}),_vm._v(" Export Data\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('vue-good-table',{ref:"my-table",attrs:{"columns":_vm.columns,"rows":_vm.rows,"mode":"remote","totalRows":_vm.totalRecords,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange,"on-sort-change":_vm.onSortChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'action')?_c('span',[_c('i',{staticClass:"fa fa-eye",on:{"click":function($event){$event.preventDefault();_vm.view_detail(props.row)}}})]):_c('span',[_vm._v("\n                "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)])])]),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Summary of Balance Amount ","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = true}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('b-collapse',{attrs:{"id":"collapse1","visible":""}},[_c('vue-good-table',{ref:"my-table1",attrs:{"columns":_vm.columns1,"rows":_vm.rows1,"mode":"remote","totalRows":_vm.totalRecords1,"pagination-options":{ enabled: true, perPage: 10 },"styleClass":"vgt-table striped bordered table-sm condensed"},on:{"on-page-change":_vm.onPageChange1,"on-sort-change":_vm.onSortChange1,"on-column-filter":_vm.onColumnFilter1,"on-per-page-change":_vm.onPerPageChange1}})],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-10"},[_c('i',{staticStyle:{"color":"#20a8d8"}}),_vm._v(" List of Suppliers Whose\n                Payment is Pending\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
	roles: null,
	authUser: null
};
var mutations = {
	SET_AUTH_USER: function SET_AUTH_USER(state, userObj) {
		state.authUser = userObj;
	},
	SET_USER_ROLE: function SET_USER_ROLE(state, userRole) {
		state.roles = userRole;
	}
};
var actions = {
	setUserObject: function setUserObject(_ref, userObj) {
		var commit = _ref.commit;

		commit('SET_AUTH_USER', userObj);
	},
	setUserRoles: function setUserRoles(_ref2, userRole) {
		var commit = _ref2.commit;

		commit('SET_USER_ROLE', userRole);
	}
};
/* harmony default export */ __webpack_exports__["a"] = ({
	state: state, mutations: mutations, actions: actions
});

/***/ }),
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(967);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(970);
function injectStyle (ssrContext) {
  __webpack_require__(969)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(973);
function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(975);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(980);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProductModal_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b32fbfa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProductModal_vue__ = __webpack_require__(1123);
function injectStyle (ssrContext) {
  __webpack_require__(1122)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b32fbfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProductModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b32fbfa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProductModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-info",attrs:{"title":"Add Product","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Name"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productname),expression:"product.productname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productname},attrs:{"type":"text","autocomplete":"off","id":"productname","name":"productname","placeholder":"Enter Product Name"},domProps:{"value":(_vm.product.productname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.errorMessage.productname))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Category")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.category,"option-value":"category_name","option-text":"category_name","placeholder":"Select Category"},on:{"input":_vm.subcategory1},model:{value:(_vm.selectedCategory),callback:function ($$v) {_vm.selectedCategory=$$v},expression:"selectedCategory"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Sub Category")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.subcategory,"option-value":"sub_category_name","option-text":"sub_category_name","placeholder":"Select Sub Category"},model:{value:(_vm.selectedSub),callback:function ($$v) {_vm.selectedSub=$$v},expression:"selectedSub"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Brand")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.brndopt,"option-value":"brand_name","option-text":"brand_name","placeholder":"Select Brand"},model:{value:(_vm.selectedBrand),callback:function ($$v) {_vm.selectedBrand=$$v},expression:"selectedBrand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.companyTaxType === 'US' ? 'US Code' : 'HSN Code')+" ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.hsnopt,"option-value":"hsn_id","option-text":"hsn_code","placeholder":"Select Hsn"},on:{"input":_vm.tax_name},model:{value:(_vm.selectedHsn),callback:function ($$v) {_vm.selectedHsn=$$v},expression:"selectedHsn"}}),_vm._v(" "),(_vm.errorMessage.selectedHsn)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.errorMessage.selectedHsn))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Tax ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"readonly":"","list":_vm.taxopt,"option-value":"tax_name","option-text":"tax_name","placeholder":"Select Tax"},model:{value:(_vm.selectedTax),callback:function ($$v) {_vm.selectedTax=$$v},expression:"selectedTax"}}),_vm._v(" "),(_vm.errorMessage.selectedTax)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" "+_vm._s(_vm.errorMessage.selectedTax))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Unit")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.unitopt,"option-value":"unit_name","option-text":"unit_name","placeholder":"Select Unit"},model:{value:(_vm.selectedUnit),callback:function ($$v) {_vm.selectedUnit=$$v},expression:"selectedUnit"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("SKU")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.altproductid),expression:"product.altproductid"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.altproductid},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter SKU"},domProps:{"value":(_vm.product.altproductid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "altproductid", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.altproductid)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Id")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Variant")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.varientlist,"option-value":"variant_id","option-text":"variant_name","placeholder":"Select Variant"},model:{value:(_vm.product.variantname),callback:function ($$v) {_vm.$set(_vm.product, "variantname", $$v)},expression:"product.variantname"}}),_vm._v(" "),(_vm.hasErrors.variantname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Variant Name")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Description")]),_vm._v(" "),_c('vue-editor',{class:{'is-invalid':_vm.hasErrors.productdesc},attrs:{"id":"productdesc","name":"productdesc"},model:{value:(_vm.product.productdesc),callback:function ($$v) {_vm.$set(_vm.product, "productdesc", $$v)},expression:"product.productdesc"}}),_vm._v(" "),(_vm.hasErrors.productdesc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Description")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 1 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput1",attrs:{"name":"product.image1","state":Boolean(_vm.errorMessage.image1==null),"accept":"image/*","id":"image1","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[0])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[0],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image1))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 2 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput2",attrs:{"name":"product.image2","state":Boolean(_vm.errorMessage.image2==null),"accept":"image/*","id":"image2","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[1])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[1],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image2))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 3 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput3",attrs:{"name":"product.image3","state":Boolean(_vm.errorMessage.image3==null),"accept":"image/*","id":"image3","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[2])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[2],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image3))])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 4 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput4",attrs:{"name":"product.image4","state":Boolean(_vm.errorMessage.image4==null),"accept":"image/*","id":"image4","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[3])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[3],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image4)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image4))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 5 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput5",attrs:{"name":"product.image5","state":Boolean(_vm.errorMessage.image5==null),"accept":"image/*","id":"image5","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[4])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[4],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image5)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image5))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Image 6 :")]),_vm._v(" "),_c('b-form-file',{ref:"fileinput6",attrs:{"name":"product.image6","state":Boolean(_vm.errorMessage.image6==null),"accept":"image/*","id":"image6","placeholder":"Choose a file..."}}),_vm._v(" "),(_vm.product.imageArr[5])?_c('p',[_vm._v("View Image "),_c('a',{attrs:{"href":_vm.product.imageUrl[5],"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e(),_vm._v(" "),(_vm.errorMessage.image6)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image6))])]):_vm._e()],1)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Specification :")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Product Specification Description")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"})]),_vm._v(" "),_vm._l((_vm.specs),function(spec,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(spec.specname),expression:"spec.specname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.specname},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Product Specification"},domProps:{"value":(spec.specname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(spec, "specname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.specname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Specification  Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(spec.specdesc),expression:"spec.specdesc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.specdesc},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Product Specification Description"},domProps:{"value":(spec.specdesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(spec, "specdesc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.specdesc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Specification Description")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2",staticStyle:{"margin-top":"3px"}},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.addRow}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),((index != 0))?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){_vm.removeElement(index);}}},[_c('i',{staticClass:"fa fa-trash-o"})]):_vm._e()])])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Custom Field 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf1),expression:"product.productcf1"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productcf1},attrs:{"type":"text","id":"productcf1","autocomplete":"off","name":"productcf1","placeholder":"Custom Field Label 1"},domProps:{"value":(_vm.product.productcf1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf1", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productcf1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Classification")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Custom Field 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf2),expression:"product.productcf2"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off","placeholder":"Custom Field Label 2"},domProps:{"value":(_vm.product.productcf2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Custom Field 3")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf3),expression:"product.productcf3"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Custom Field Label 3"},domProps:{"value":(_vm.product.productcf3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf3", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{attrs:{"id":"checkbox1","value":"true","unchecked-value":"false"},model:{value:(_vm.checkboxqty),callback:function ($$v) {_vm.checkboxqty=$$v},expression:"checkboxqty"}},[_vm._v("Alert Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productalertqty),expression:"product.productalertqty"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productalert},attrs:{"type":"text","placeholder":"Enter Alert Quantity"},domProps:{"value":(_vm.product.productalertqty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productalertqty", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productalert)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Alert Quantity")])]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf_val1),expression:"product.productcf_val1"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productcf_val1},attrs:{"type":"text","id":"productcf_val1","autocomplete":"off","name":"productcf_val1","placeholder":"Custom Field value 1"},domProps:{"value":(_vm.product.productcf_val1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf_val1", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productcf_val1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Classification")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf_val2),expression:"product.productcf_val2"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productcf_val2},attrs:{"type":"text","id":"productcf_val2","autocomplete":"off","placeholder":"Custom Field value 2"},domProps:{"value":(_vm.product.productcf_val2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf_val2", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productcf_val2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Classification")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productcf_val3),expression:"product.productcf_val3"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productcf_val3},attrs:{"type":"text","id":"productcf_val3","placeholder":"Custom Field value 3"},domProps:{"value":(_vm.product.productcf_val3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productcf_val3", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productcf_val3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Product Classification")])]):_vm._e()])])]),_vm._v(" "),( false)?_c('br'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[( false)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},on:{"input":function($event){_vm.hasBarcode()}}},[_vm._v("I have product barcode number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.product.productbarcodesymbol),expression:"product.productbarcodesymbol"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.productbarcodesymbol},attrs:{"type":"text","placeholder":"Enter Barcode Number","disabled":_vm.disabled == 0 ? false : true},domProps:{"value":(_vm.product.productbarcodesymbol)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.product, "productbarcodesymbol", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.productbarcodesymbol)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.productbarcodesymbol))])]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-top":"28px"}},[_c('b-form-checkbox',{attrs:{"value":"true","unchecked-value":"false"},model:{value:(_vm.checkboxtk),callback:function ($$v) {_vm.checkboxtk=$$v},expression:"checkboxtk"}},[_vm._v(" Product Track Quantity ")])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]),_vm._v("    "),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.hide}},[_vm._v("Close")])]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddShopModal_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3a512de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddShopModal_vue__ = __webpack_require__(1125);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddShopModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3a512de_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddShopModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{staticClass:"modal-info",attrs:{"title":"Shop Establishment","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":""},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Shop Type"),_c('span',{staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.shoptype),expression:"shoptype"}],ref:"shptype",staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.shoptype=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":"","readonly":"","value":""}},[_vm._v("Select Your Shop Type")]),_vm._v(" "),_c('option',{attrs:{"value":"shop"}},[_vm._v("Shop")]),_vm._v(" "),_c('option',{attrs:{"value":"warehouse"}},[_vm._v("Warehouse")])]),_vm._v(" "),(_vm.hasErrors.cmptype)?_c('small',{staticClass:"help-block"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Company  Type")])]):_vm._e()])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Shop Name "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{ref:"txtshopname",class:{'is-invalid':_vm.hasErrors.shopnm},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Shop Name"},nativeOn:{"blur":function($event){_vm.chkShopExist()}},model:{value:(_vm.shop.name),callback:function ($$v) {_vm.$set(_vm.shop, "name", $$v)},expression:"shop.name"}}),_vm._v(" "),(_vm.hasErrors.shopnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Shop Name")])]):_vm._e(),_vm._v(" "),(_vm.hasErrors.shopnmexist === true)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Shop Name Already Exist")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 1 "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopad1},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Address Line 1"},model:{value:(_vm.shop.address1),callback:function ($$v) {_vm.$set(_vm.shop, "address1", $$v)},expression:"shop.address1"}}),_vm._v(" "),(_vm.hasErrors.shopad1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Shop Address")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 2 ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopad2},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Address Line 2"},model:{value:(_vm.shop.address2),callback:function ($$v) {_vm.$set(_vm.shop, "address2", $$v)},expression:"shop.address2"}}),_vm._v(" "),(_vm.hasErrors.shopad2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Shop Address")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Country "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country"},on:{"input":_vm.state1},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}}),_vm._v(" "),(_vm.hasErrors.shopcntry)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select Country")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("State "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.city1},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}}),_vm._v(" "),(_vm.hasErrors.shopstate)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select State")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select City"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),(_vm.hasErrors.shopcity)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Select City")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shoppin},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter your Pincode"},model:{value:(_vm.shop.pincode),callback:function ($$v) {_vm.$set(_vm.shop, "pincode", $$v)},expression:"shop.pincode"}}),_vm._v(" "),(_vm.hasErrors.shoppin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Pincode")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("GST No. ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shop_gst},attrs:{"type":"text","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Your GST No"},model:{value:(_vm.shop.gst),callback:function ($$v) {_vm.$set(_vm.shop, "gst", $$v)},expression:"shop.gst"}}),_vm._v(" "),(_vm.hasErrors.shop_gst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST No")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact No. "),_c('span',{staticClass:"star",staticStyle:{"color":"red"}},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.shopph},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Shop Phone Number"},model:{value:(_vm.shop.phone),callback:function ($$v) {_vm.$set(_vm.shop, "phone", $$v)},expression:"shop.phone"}}),_vm._v(" "),(_vm.hasErrors.shopph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Phone Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Locate your Address In Map ")]),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"warning"},on:{"click":_vm.openwarning}},[_vm._v("Select Address In Map")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Sale Price Editable ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.shop.sale_price_editable),expression:"shop.sale_price_editable"}],attrs:{"type":"checkbox","autocomplete":"off"},domProps:{"checked":Array.isArray(_vm.shop.sale_price_editable)?_vm._i(_vm.shop.sale_price_editable,null)>-1:(_vm.shop.sale_price_editable)},on:{"change":function($event){var $$a=_vm.shop.sale_price_editable,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.shop.sale_price_editable=$$a.concat([$$v]))}else{$$i>-1&&(_vm.shop.sale_price_editable=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.shop, "sale_price_editable", $$c)}}}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.Successsub()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v("  Save")])])],1)],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-warning",attrs:{"title":"Select Address","no-close-on-esc":"","no-close-on-backdrop":"","size":"lg","hide-footer":"","ok-variant":"warning"},on:{"ok":function($event){_vm.warningModal = false}},model:{value:(_vm.warningModal),callback:function ($$v) {_vm.warningModal=$$v},expression:"warningModal"}},[_c('div',[_c('label',[_vm._v("Search Address"),_c('GmapAutocomplete',{on:{"place_changed":_vm.setPlace}}),_vm._v(" "),(_vm.buttosstat==0)?_c('span',[_c('button',{on:{"click":_vm.usePlace}},[_vm._v("Add")])]):_c('span',[_c('label',[_vm._v("Now you can drag Marker to your loacation")])])],1),_vm._v(" "),_c('label',[( _vm.buttosstat==1)?_c('div',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.revertbck}},[_vm._v("save")])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"300px"},attrs:{"zoom":16,"center":_vm.center}},[_vm._l((_vm.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=marker.position},"dragend":function($event){_vm.getMarkerPosition($event.latLng)}}})}),(this.place)?_c('gmap-marker',{attrs:{"label":"★","position":{lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()}}}):_vm._e()],2)],1)]),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSupplierModal_vue__ = __webpack_require__(491);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c07da06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSupplierModal_vue__ = __webpack_require__(1127);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSupplierModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c07da06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSupplierModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-info",staticStyle:{"width":"140%","margin":"auto"},attrs:{"title":"Add Supplier","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Supplier Detail")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Name "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supnm},attrs:{"type":"text","id":"name","autocomplete":"off","placeholder":"Enter Supplier Name"},model:{value:(_vm.supplier.name),callback:function ($$v) {_vm.$set(_vm.supplier, "name", $$v)},expression:"supplier.name"}}),_vm._v(" "),(_vm.hasErrors.supnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Supplier Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.contyp,"option-value":"desc","option-text":"desc","placeholder":"Select Company Type"},model:{value:(_vm.suptype),callback:function ($$v) {_vm.suptype=$$v},expression:"suptype"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 1 ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supad1},attrs:{"type":"text","id":"add1","autocomplete":"off","placeholder":"Enter supplier Address 1"},model:{value:(_vm.supplier.add),callback:function ($$v) {_vm.$set(_vm.supplier, "add", $$v)},expression:"supplier.add"}}),_vm._v(" "),(_vm.hasErrors.supad1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 2 ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supad2},attrs:{"type":"text","id":"add2","autocomplete":"off","placeholder":"Enter supplier Address 2"},model:{value:(_vm.supplier.add2),callback:function ($$v) {_vm.$set(_vm.supplier, "add2", $$v)},expression:"supplier.add2"}}),_vm._v(" "),(_vm.hasErrors.supad2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address ")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.suppin},attrs:{"type":"text","id":"pin","autocomplete":"off","placeholder":"Pincode"},model:{value:(_vm.supplier.pin),callback:function ($$v) {_vm.$set(_vm.supplier, "pin", $$v)},expression:"supplier.pin"}}),_vm._v(" "),(_vm.hasErrors.suppin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Pincode ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Country ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country"},on:{"input":_vm.state1},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("State ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.city1},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select City"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Corporate Identity Number")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.cin),expression:"supplier.cin"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.supcin},attrs:{"type":"text","id":"cin","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Company Identity Number","aria-label":"Enter Corporate Identity Number","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.cin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "cin", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.supcin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid CIN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CIN Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image1},attrs:{"type":"file","name":"image1","id":"image1","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image1))])]):_vm._e(),_vm._v(" "),(_vm.ed.image1!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST/VAT Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.gst),expression:"supplier.gst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.supgst},attrs:{"type":"text","id":"gst","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.gst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "gst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.supgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Certificate ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image2},attrs:{"type":"file","name":"image2","id":"image2","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image2))])]):_vm._e(),_vm._v(" "),(_vm.ed.image2!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image2_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Number")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.pan),expression:"supplier.pan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.suppan},attrs:{"type":"text","id":"pan","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company PAN Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.pan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "pan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.suppan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid PAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Certificate")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image3},attrs:{"type":"file","name":"image3","id":"image3","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image3))])]):_vm._e(),_vm._v(" "),(_vm.ed.image3!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image3_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Number ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.tan),expression:"supplier.tan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.suptan},attrs:{"type":"text","id":"tan","onkeyup":"this.value = this.value.toUpperCase();","autocomplete":"off","placeholder":"Enter Company Tan Number","aria-label":"Input group example","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.supplier.tan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "tan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.suptan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid TAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Certificate")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image4},attrs:{"type":"file","name":"image4","id":"image4","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image4)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image4))])]):_vm._e(),_vm._v(" "),(_vm.ed.image4!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image4_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact No. "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supph},attrs:{"type":"text","id":"phone","autocomplete":"off","placeholder":"Enter Your Contact Number"},model:{value:(_vm.supplier.phone),callback:function ($$v) {_vm.$set(_vm.supplier, "phone", $$v)},expression:"supplier.phone"}}),_vm._v(" "),(_vm.hasErrors.supph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supeml},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Your E-Mail Id"},model:{value:(_vm.supplier.email),callback:function ($$v) {_vm.$set(_vm.supplier, "email", $$v)},expression:"supplier.email"}}),_vm._v(" "),(_vm.hasErrors.supeml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil  Id")])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Logo ")]),_vm._v(" "),_c('input',{staticClass:"form-control filesize",class:{'is-invalid':_vm.hasErrors.image5},attrs:{"type":"file","name":"image5","id":"image5","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image5)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image5))])]):_vm._e(),_vm._v(" "),(_vm.ed.image5!='')?_c('p',[_vm._v("View Uploaded File "),_c('a',{attrs:{"href":_vm.ed.image5_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Contact Person Detail")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Person Name ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supcont},attrs:{"type":"text","id":"contact","autocomplete":"off","placeholder":"Enter Contact Person Name"},model:{value:(_vm.supplier.contact),callback:function ($$v) {_vm.$set(_vm.supplier, "contact", $$v)},expression:"supplier.contact"}}),_vm._v(" "),(_vm.hasErrors.supcont)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid  Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supcontno},attrs:{"type":"text","id":"contactno","autocomplete":"off","placeholder":" Enter Contact Phone Number"},model:{value:(_vm.supplier.contactno),callback:function ($$v) {_vm.$set(_vm.supplier, "contactno", $$v)},expression:"supplier.contactno"}}),_vm._v(" "),(_vm.hasErrors.supcontno)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Email ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.supconteml},attrs:{"type":"text","id":"contactemail","autocomplete":"off","placeholder":"Enter Contact Person E-mail Id"},model:{value:(_vm.supplier.contactemail),callback:function ($$v) {_vm.$set(_vm.supplier, "contactemail", $$v)},expression:"supplier.contactemail"}}),_vm._v(" "),(_vm.hasErrors.supconteml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil Id ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Supplier Company Profile ")]),_vm._v(" "),(_vm.hasErrors.supplierprf)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Profile cannot be greater than 255 Character")])]):_vm._e(),_vm._v(" "),_c('vue-editor',{attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.supplier.profile),callback:function ($$v) {_vm.$set(_vm.supplier, "profile", $$v)},expression:"supplier.profile"}})],1)],1)],1),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Bank Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankname),expression:"supplier.bankname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankname},attrs:{"type":"text","id":"bankname","autocomplete":"off","placeholder":"Enter your Bank Name"},domProps:{"value":(_vm.supplier.bankname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.banknumber),expression:"supplier.banknumber"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.banknumber},attrs:{"type":"text","id":"banknumber","name":"banknumber","autocomplete":"off","placeholder":"Enter your Bank Account Number"},domProps:{"value":(_vm.supplier.banknumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "banknumber", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.banknumber)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Account Number")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Holder Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankholder),expression:"supplier.bankholder"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankholder},attrs:{"type":"text","id":"bankholder","name":"bankholder","autocomplete":"off","placeholder":"Enter Account Holder Name"},domProps:{"value":(_vm.supplier.bankholder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankholder", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankholder)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Account Holder Name")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IFSC Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankifsc),expression:"supplier.bankifsc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankifsc},attrs:{"type":"text","id":"bankifsc","name":"bankifsc","autocomplete":"off","placeholder":"Enter Bank IFSC Code"},domProps:{"value":(_vm.supplier.bankifsc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankifsc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankifsc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid IFSC Code")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Branch ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankbranch),expression:"supplier.bankbranch"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankbranch},attrs:{"type":"text","id":"bankbranch","name":"bankbranch","placeholder":"Enter Branch Name"},domProps:{"value":(_vm.supplier.bankbranch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankbranch", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankbranch)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Branch")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("MICR Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankmicr),expression:"supplier.bankmicr"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankmicr},attrs:{"type":"text","id":"bankmicr","name":"bankmicr","autocomplete":"off","placeholder":"Enter MICR code"},domProps:{"value":(_vm.supplier.bankmicr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankmicr", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankmicr)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid MICR Code")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Swift Code ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.supplier.bankswift),expression:"supplier.bankswift"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankswift},attrs:{"type":"text","id":"bankswift","name":"bankswift","autocomplete":"off","placeholder":"Enter Bank Swift Code"},domProps:{"value":(_vm.supplier.bankswift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.supplier, "bankswift", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankswift)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Swift Code")])]):_vm._e()])])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]),_vm._v("   \n                 "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hide()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Close")])])],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCustomerModal_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283ae496_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCustomerModal_vue__ = __webpack_require__(1129);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCustomerModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283ae496_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCustomerModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal-info",staticStyle:{"width":"140%","margin":"auto"},attrs:{"title":"Add Customer","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":"","size":"lg"},on:{"ok":function($event){_vm.largeModal = false}},model:{value:(_vm.largeModal),callback:function ($$v) {_vm.largeModal=$$v},expression:"largeModal"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Customer Detail")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v(" Customer Name :"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custnm},attrs:{"type":"text","id":"name","autocomplete":"off","placeholder":"Enter Customer Name"},model:{value:(_vm.customer.name),callback:function ($$v) {_vm.$set(_vm.customer, "name", $$v)},expression:"customer.name"}}),_vm._v(" "),(_vm.hasErrors.custnm)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid comapny Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Type :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgba(12, 11, 11, 0.87) !important","height":"20px !important"},attrs:{"list":_vm.contyp,"option-value":"desc","option-text":"desc","placeholder":"Select Company Type"},model:{value:(_vm.suptype),callback:function ($$v) {_vm.suptype=$$v},expression:"suptype"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 1:")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custad1},attrs:{"type":"text","id":"add1","autocomplete":"off","placeholder":"Enter Customer Address 1"},on:{"input":function($event){_vm.shippingenable()}},model:{value:(_vm.customer.add),callback:function ($$v) {_vm.$set(_vm.customer, "add", $$v)},expression:"customer.add"}}),_vm._v(" "),(_vm.hasErrors.custad1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address 1")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Address Line 2(optional):")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custad2},attrs:{"type":"text","id":"add2","autocomplete":"off","placeholder":"Enter  Address Line 2"},model:{value:(_vm.customer.add2),callback:function ($$v) {_vm.$set(_vm.customer, "add2", $$v)},expression:"customer.add2"}}),_vm._v(" "),(_vm.hasErrors.custad2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Address 2 ")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custpin},attrs:{"type":"text","id":"pin","autocomplete":"off","placeholder":"Pincode"},model:{value:(_vm.customer.pin),callback:function ($$v) {_vm.$set(_vm.customer, "pin", $$v)},expression:"customer.pin"}}),_vm._v(" "),(_vm.hasErrors.custpin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Pincode ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Country :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.conopt,"option-value":"country_name","option-text":"country_name","placeholder":"Select Country"},on:{"input":_vm.state1},model:{value:(_vm.con),callback:function ($$v) {_vm.con=$$v},expression:"con"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("State :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.city1},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("City :")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.cityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select city"},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Corporate Identity Number:")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.cin),expression:"customer.cin"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custcin},attrs:{"type":"text","id":"cin","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company Identity Number","aria-label":"Enter Corporate Identity Number","aria-describedby":"btnGroupAddon","autocomplete":"off"},domProps:{"value":(_vm.customer.cin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "cin", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custcin)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid CIN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("CIN Certificate : ")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image1},attrs:{"type":"file","name":"image1","id":"image1","accept":"image/*","autocomplete":"off"}}),_vm._v(" "),(_vm.hasErrors.image1)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image1))])]):_vm._e(),_vm._v(" "),(_vm.ed.image1!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image1_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST/VAT Number :")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.gst),expression:"customer.gst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custgst},attrs:{"type":"text","id":"cust_gst","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.customer.gst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "gst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Certificate:")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image2},attrs:{"type":"file","name":"image2","id":"image2","accept":"image/*","autocomplete":"off"}}),_vm._v(" "),(_vm.hasErrors.image2)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image2))])]):_vm._e(),_vm._v(" "),(_vm.ed.image2!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image2_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Number:")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.pan),expression:"customer.pan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custpan},attrs:{"type":"text","id":"pan","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company PAN Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.customer.pan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "pan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custpan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid PAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("PAN Certificate:")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image3},attrs:{"type":"file","name":"image3","id":"image3","accept":"image/*","autocomplete":"off"}}),_vm._v(" "),(_vm.hasErrors.image3)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image3))])]):_vm._e(),_vm._v(" "),(_vm.ed.image3!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image3_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Number :")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.tan),expression:"customer.tan"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.custtan},attrs:{"type":"text","id":"tan","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company Tan Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon"},domProps:{"value":(_vm.customer.tan)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "tan", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors.custtan)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid TAN ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("TAN Certificate:")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image4},attrs:{"type":"file","name":"image4","id":"image4","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image4)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image4))])]):_vm._e(),_vm._v(" "),(_vm.ed.image4!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image4_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact No. : "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(" *")])]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custph},attrs:{"type":"text","id":"phone","autocomplete":"off","placeholder":"Enter Your Contact Number"},model:{value:(_vm.customer.phone),callback:function ($$v) {_vm.$set(_vm.customer, "phone", $$v)},expression:"customer.phone"}}),_vm._v(" "),(_vm.hasErrors.custph)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Email :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custeml},attrs:{"type":"text","id":"email","autocomplete":"off","placeholder":"Enter Your E-Mail Id"},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}}),_vm._v(" "),(_vm.hasErrors.custeml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil  Id")])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Company Logo :")]),_vm._v(" "),_c('input',{staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.image5},attrs:{"type":"file","name":"image5","id":"image5","autocomplete":"off","accept":"image/*"}}),_vm._v(" "),(_vm.hasErrors.image5)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage.image5))])]):_vm._e(),_vm._v(" "),(_vm.ed.image5!='')?_c('p',[_vm._v("View Uploaded File : "),_c('a',{attrs:{"href":_vm.ed.image5_href,"target":"blank"}},[_c('i',{staticClass:"fa fa-file-image-o",staticStyle:{"color":"skyblue","cursor":"pointer"}})])]):_vm._e()])])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h6',{staticClass:"page_head"},[_vm._v("Contact Person Detail")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Person Name :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custcont},attrs:{"type":"text","id":"contact","autocomplete":"off","placeholder":"Enter Contact Person Name"},model:{value:(_vm.customer.contact),callback:function ($$v) {_vm.$set(_vm.customer, "contact", $$v)},expression:"customer.contact"}}),_vm._v(" "),(_vm.hasErrors.custcont)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid  Name")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custcontno},attrs:{"type":"text","id":"contactno","autocomplete":"off","placeholder":" Enter Contact Contact Number"},model:{value:(_vm.customer.contactno),callback:function ($$v) {_vm.$set(_vm.customer, "contactno", $$v)},expression:"customer.contactno"}}),_vm._v(" "),(_vm.hasErrors.custcontno)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Contact Number")])]):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Email :")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid':_vm.hasErrors.custconteml},attrs:{"type":"text","id":"contactemail","autocomplete":"off","placeholder":"Enter Contact Person E-mail Id"},model:{value:(_vm.customer.contactemail),callback:function ($$v) {_vm.$set(_vm.customer, "contactemail", $$v)},expression:"customer.contactemail"}}),_vm._v(" "),(_vm.hasErrors.custconteml)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Eamil Id ")])]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("Customer Company Profile :")]),_vm._v(" "),(_vm.hasErrors.supplierprf)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Profile cannot be greater than 255 Character")])]):_vm._e(),_vm._v(" "),_c('vue-editor',{attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.customer.profile),callback:function ($$v) {_vm.$set(_vm.customer, "profile", $$v)},expression:"customer.profile"}})],1)],1)],1),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Bank Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Bank Name :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankname),expression:"customer.bankname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankname},attrs:{"type":"text","id":"bankname","autocomplete":"off","placeholder":"Enter your Bank Name"},domProps:{"value":(_vm.customer.bankname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Name")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Number :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.banknumber),expression:"customer.banknumber"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.banknumber},attrs:{"type":"text","id":"banknumber","name":"banknumber","autocomplete":"off","placeholder":"Enter your Bank Account Number"},domProps:{"value":(_vm.customer.banknumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "banknumber", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.banknumber)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Account Number")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Account Holder Name :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankholder),expression:"customer.bankholder"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankholder},attrs:{"type":"text","id":"bankholder","name":"bankholder","autocomplete":"off","placeholder":"Enter Account Holder Name"},domProps:{"value":(_vm.customer.bankholder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankholder", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankholder)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Account Holder Name")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("IFSC Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankifsc),expression:"customer.bankifsc"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankifsc},attrs:{"type":"text","id":"bankifsc","name":"bankifsc","autocomplete":"off","placeholder":"Enter Bank IFSC Code"},domProps:{"value":(_vm.customer.bankifsc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankifsc", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankifsc)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid IFSC Code")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Branch :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankbranch),expression:"customer.bankbranch"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankbranch},attrs:{"type":"text","id":"bankbranch","name":"bankbranch","autocomplete":"off","placeholder":"Enter Branch Name"},domProps:{"value":(_vm.customer.bankbranch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankbranch", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankbranch)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Bank Branch")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("MICR Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankmicr),expression:"customer.bankmicr"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankmicr},attrs:{"type":"text","id":"bankmicr","name":"bankmicr","autocomplete":"off","placeholder":"Enter MICR code"},domProps:{"value":(_vm.customer.bankmicr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankmicr", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankmicr)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid MICR Code")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Swift Code :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customer.bankswift),expression:"customer.bankswift"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors.bankswift},attrs:{"type":"text","id":"bankswift","name":"bankswift","autocomplete":"off","placeholder":"Enter Bank Swift Code"},domProps:{"value":(_vm.customer.bankswift)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.customer, "bankswift", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors.bankswift)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid Swift Code")])]):_vm._e()])])]),_vm._v(" "),_c('h6',{staticClass:"page_head"},[_vm._v("Shipping Details")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.sname),expression:"address.sname"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsname},attrs:{"type":"text","id":"sname","placeholder":"Enter Name","autocomplete":"off","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.sname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "sname", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errsname)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsname))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.saddress),expression:"address.saddress"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsaddress},attrs:{"type":"text","id":"saddress","name":"saddress","autocomplete":"off","placeholder":"Enter Address","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.saddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "saddress", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errsaddress)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsaddress))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Contact Number ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.sphn),expression:"address.sphn"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsphn},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Phone Number","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.sphn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "sphn", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errsphn)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsphn))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("State ")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.stateopt,"option-value":"state_name","option-text":"state_name","placeholder":"Select State"},on:{"input":_vm.shipping_city},model:{value:(_vm.shippingstate),callback:function ($$v) {_vm.shippingstate=$$v},expression:"shippingstate"}}),_vm._v(" "),(_vm.hasErrors1.errsstate)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errsstate))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("City")]),_vm._v(" "),_c('model-list-select',{staticClass:"form-control",staticStyle:{"-webkit-text-fill-color":"rgb(83, 108, 121) !important","height":"20px !important","border":"1px solid rgb(194, 207, 214)","min-height":"35px"},attrs:{"list":_vm.shippingcityopt,"option-value":"city_name","option-text":"city_name","placeholder":"Select city"},model:{value:(_vm.shippingcity),callback:function ($$v) {_vm.shippingcity=$$v},expression:"shippingcity"}}),_vm._v(" "),(_vm.hasErrors1.errscity)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errscity))])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Pincode")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.spincode),expression:"address.spincode"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errspincode},attrs:{"type":"text","autocomplete":"off","placeholder":"Enter Pincode","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.spincode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "spincode", $event.target.value)}}}),_vm._v(" "),(_vm.hasErrors1.errspincode)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.hasErrors1.errspincode))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("GST Number :")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.sgst),expression:"address.sgst"}],staticClass:"form-control",class:{'is-invalid':_vm.hasErrors1.errsgst},attrs:{"type":"text","id":"gst","onkeyup":"this.value = this.value.toUpperCase();","placeholder":"Enter Company GST/VAT Number","aria-label":"Input group example","autocomplete":"off","aria-describedby":"btnGroupAddon","disabled":_vm.shipdisable},domProps:{"value":(_vm.address.sgst)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "sgst", $event.target.value)}}})]),_vm._v(" "),(_vm.hasErrors1.errsgst)?_c('small',{staticClass:"form-text text-muted"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Enter Valid GST")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_c('br')]),_c('br'),_vm._v(" "),_c('small',[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"name":"add","disabled":_vm.shipdisable},on:{"click":function($event){_vm.addValues()}}},[_vm._v("Add")])])])])]),_c('br'),_c('br'),_vm._v(" "),_vm._l((_vm.addr),function(address1,index){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"form-group"},[_c('b',[_vm._v(_vm._s(address1.yname)+" ("+_vm._s(address1.yphn)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(address1.ygst))]),_c('br'),_vm._v(" "),(address1.yaddress!='')?_c('span',[_vm._v("\n                     "+_vm._s(address1.yaddress)),_c('br')]):_vm._e(),_vm._v(" "),(address1.ystate != '' && address1.ycity != '' && address1.ypincode != '')?_c('span',[_vm._v("\n                     "+_vm._s(address1.ystate)+"   "+_vm._s(address1.ycity)+" - "+_vm._s(address1.ypincode)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2",staticStyle:{"color":"#f86c6b","font-size":"20px","cursor":"pointer"}},[(address1.chkship_id!=1)?_c('span',[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){$event.preventDefault();_vm.deleteadd(index)}}})]):_vm._e()]),_c('hr',{attrs:{"width":"97%"}})])})],2)]),_vm._v(" "),_c('div',{staticClass:"card-footer modal_footer"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"save"},on:{"click":function($event){$event.preventDefault();_vm.Submit()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Save")]),_vm._v("\n                  \n                 "),_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.hide()}}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Close")])])],1)],1),_vm._v(" "),(_vm.loading)?_c('Spinner'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1130 */,
/* 1131 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[494]);


// WEBPACK FOOTER //
// static/js/app.a435e6f73ebc73cc7c82.js